(function() {
  'use strict';

   /* Module CnafComponentsTeleprocApp */
   angular.module('cnafComponentsTeleprocApp', [
    'cnafCommonsApp','cnafComponentsTeleprocApp.templates', 'ngResource','ui.bootstrap','ui.mask', 'ui.validate'
  ]);


  /* Module de configuration CnafComponentsTeleprocApp */
  var cnafComponentsTeleprocAppConfig = angular.module('cnafComponentsTeleprocApp.config', ['ui.router']);

  var msie = document.documentMode;
  // if is IE (documentMode contains IE version)
  if (!msie) {
    cnafComponentsTeleprocAppConfig.run(RunState);
  }

  RunState.$inject = [ '$transitions'];

  // Configuration qui permet de bloquer le retour arrière ( flèche navigateur ou backspace )
  function RunState ($transitions) {
      $transitions.onSuccess({}, function(trans) {
        setTimeout( function(){
          history.pushState(null, null, document.URL);
          window.addEventListener('popstate', function () {
              history.pushState(null, null, document.URL);
          });
        },0);
      });
    }
})();

(function() {
    'use strict';
    //Définition d'une constante pour les demandes de preasta via redirect
    angular.module('cnafComponentsTeleprocApp').constant("CnafCctConstants",
      {
        'DEM_PRIME_ADOPTION': 'DPA',
        'DEM_ALL_FAMILIALE': 'DPF',
        'DEM_ALL_RENTREE_SCO': 'DARS',
        'ACTUALISATION_POUR_PRESTATION' : 'actualisationSituationPourPrestation',
        'ACTUALISATION_POUR_PRESTATION_AVEC_FORMULAIRE' : 'actualisationSituationPourPrestationAvecFormulaire',
        'ACTUALISATION_POUR_PRESTATION_SANS_FORMULAIRE' : 'actualisationSituationPourPrestationSansFormulaire'
      }
    );
})();

(function() {
    'use strict';
    //Définition d'une constante pour les states du module angular
    angular.module('cnafComponentsTeleprocApp').constant("CctPaysCotisation",
      {
        'PAYSCOTIS': [
            {libelle: 'ALLEMAGNE', zoneActi : 'DE', pays : 'CEE'},
            {libelle: 'AUTRICHE', zoneActi : 'AT', pays : 'CEE'},
            {libelle: 'BELGIQUE', zoneActi : 'BE', pays : 'CEE'},
            {libelle: 'BULGARIE', zoneActi : 'BG', pays : 'CEE'},
            {libelle: 'CHYPRE', zoneActi : 'CY', pays : 'CEE'},
            {libelle: 'CROATIE', zoneActi : 'HR', pays : 'CEE'},
            {libelle: 'DANEMARK', zoneActi : 'DK', pays : 'CEE'},
            {libelle: 'ESPAGNE', zoneActi : 'ES', pays : 'CEE'},
            {libelle: 'ESTONIE', zoneActi : 'EE', pays : 'CEE'},
            {libelle: 'FINLANDE', zoneActi : 'FI', pays : 'CEE'},
            {libelle: 'GRECE', zoneActi : 'GR', pays : 'CEE'},
            {libelle: 'HONGRIE', zoneActi : 'HU', pays : 'CEE'},
            {libelle: 'IRLANDE', zoneActi : 'IE', pays : 'CEE'},
            {libelle: 'ISLANDE', zoneActi : 'IS', pays : 'CEE'},
            {libelle: 'ITALIE', zoneActi : 'IT', pays : 'CEE'},
            {libelle: 'LETTONIE', zoneActi : 'LV', pays : 'CEE'},
            {libelle: 'LIECHTENSTEIN', zoneActi : 'LI', pays : 'CEE'},
            {libelle: 'LITUANIE', zoneActi : 'LT', pays : 'CEE'},
            {libelle: 'LUXEMBOURG', zoneActi : 'LU', pays : 'CEE'},
            {libelle: 'MALTE', zoneActi : 'MT', pays : 'CEE'},
            {libelle: 'PRINCIPAUTE DE MONACO', zoneActi : 'MC', pays : 'CNV'},
            {libelle: 'NORVEGE', zoneActi : 'NO', pays : 'CEE'},
            {libelle: 'PAYS-BAS', zoneActi : 'NL', pays : 'CEE'},
            {libelle: 'POLOGNE', zoneActi : 'PL', pays : 'CEE'},
            {libelle: 'PORTUGAL', zoneActi : 'PT', pays : 'CEE'},
            {libelle: 'REPUBLIQUE TCHEQUE', zoneActi : 'CZ', pays : 'CEE'},
            {libelle: 'ROUMANIE', zoneActi : 'RO', pays : 'CEE'},
            {libelle: 'ROYAUME-UNI', zoneActi : 'GG', pays : 'CEE'},
            {libelle: 'SLOVAQUIE', zoneActi : 'SK', pays : 'CEE'},
            {libelle: 'SLOVENIE', zoneActi : 'SI', pays : 'CEE'},
            {libelle: 'SUEDE', zoneActi : 'SE', pays : 'CEE'},
            {libelle: 'SUISSE', zoneActi : 'CH', pays : 'ACE'}
          ]

      }
    );
})();

(function () {
    'use strict';
    // Ne pas éditer ce fichier - utiliser la tâche ngConstant dans le gulpfile
    angular.module('cnafComponentsTeleprocApp')
        .constant('VERSION', "2.24.4")
;
})();

//HEAD 
(function(app) {
try { app = angular.module("cnafComponentsTeleprocApp.templates"); }
catch(err) { app = angular.module("cnafComponentsTeleprocApp.templates", []); }
app.run(["$templateCache", function($templateCache) {
"use strict";

$templateCache.put("components/cnaf-cct-adresse-socle/cnaf-cct-adresse-socle.html","<div class=\"row col-sm-12\"><div class=row ng-init=vm.init()><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=pays>Pays</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                    (vm.adresseform.pays.$invalid && !vm.adresseform.pays.$pristine)\n" +
    "                }\"><input id=pays title={{vm.titlePays}} ng-model=vm.data.pays name=pays class=form-control typeahead-min-length=2 uib-typeahead=\"pays as pays.libelleCaffr for pays in vm.listepays | filter:$viewValue | limitTo:8\" typeahead-editable=false ng-required=vm.isObligatoire aria-describedby=\"format_attendu_Pays adresseSocleErreurInputPaysRequired\"><p id=format_attendu_Pays class=sr-only>title={{vm.titlePays}}</p><cnaf-cct-erreur-input iderreur=adresseSocleErreurInputPaysRequired condition=\"{{((vm.adresseform.pays.$invalid && !vm.adresseform.pays.$pristine)\n" +
    "                                    || vm.erroradresse)\n" +
    "                                    && vm.adresseform.pays.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input></div></div><div class=col-sm-6 ng-if=\"vm.data.pays.code == 'FR' || vm.data.pays.code == 'MC'\"><label class=\"label-form-cnaf control-label\" for=codePostalVille>Code postal ou commune</label><div ng-switch on=vm.autocompletion><div ng-switch-when=on class=form-group ng-class=\"{ 'has-error' :\n" +
    "                        (vm.adresseform.codePostalVille.$invalid && !vm.adresseform.codePostalVille.$pristine)\n" +
    "                        || vm.erroradresse}\"><input role=combobox id=codePostalVille ng-model=vm.data.codePostalVille title={{vm.titleCPVille}} name=codePostalVille class=form-control typeahead-min-length=2 uib-typeahead=\"result as result.lib for result in vm.codePostalVilles($viewValue, vm.data)\" typeahead-editable=false ng-change=vm.reinitErreurAdresse() ng-disabled=vm.verrouillerCP ng-required=vm.isObligatoire aria-describedby=\"format_attendu_CPCommune adresseSocleErreurInputCPvilleRequired\" aria-haspopup=true><p id=format_attendu_CPCommune class=sr-only>{{vm.titleCPVille}}</p><cnaf-cct-erreur-input iderreur=adresseSocleErreurInputCPvilleRequired condition=\"{{((vm.adresseform.codePostalVille.$invalid && !vm.adresseform.codePostalVille.$pristine)\n" +
    "                                        || vm.erroradresse)\n" +
    "                                        && vm.adresseform.codePostalVille.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input></div><div ng-switch-when=off class=form-group ng-class=\"{ 'has-error' :\n" +
    "                        (vm.adresseform.codePostalVille.$invalid && !vm.adresseform.codePostalVille.$pristine)\n" +
    "                        || vm.erroradresse}\n" +
    "                        || vm.adresseform.codePostalVille.$error.type12\n" +
    "                        \"><input id=codePostalVille ng-model=vm.data.codePostalVille title={{vm.titleCPVille}} name=codePostalVille class=form-control ui-validate=\"{controleCodePostalFormat  : 'vm.controleCodePostalFormat($value)'}\" ng-trim=false ng-disabled=vm.verrouillerCP ng-required=vm.isObligatoire aria-describedby=\"format_attendu_CPCommuneOff \n" +
    "                                                adresseSocleErreurInputCPvilleRequiredOff \n" +
    "                                                adresseSocleErreurInputCPvilleFormatOff\"><p id=format_attendu_CPCommuneOff class=sr-only>{{vm.titleCPVille}}</p><cnaf-cct-erreur-input iderreur=adresseSocleErreurInputCPvilleRequiredOff condition=\"{{((vm.adresseform.codePostalVille.$invalid && !vm.adresseform.codePostalVille.$pristine)\n" +
    "                                        || vm.erroradresse)\n" +
    "                                        && vm.adresseform.codePostalVille.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=adresseSocleErreurInputCPvilleFormatOff condition=\"{{((vm.adresseform.codePostalVille.$invalid && !vm.adresseform.codePostalVille.$pristine)\n" +
    "                                        || vm.erroradresse)\n" +
    "                                        && vm.adresseform.codePostalVille.$error.controleCodePostalFormat}}\" message=\"Code postal incorrect. Il doit contenir 5 chiffres, dont les 2 premiers sont compris entre 01 et 98. Exemple : 77230.\"></cnaf-cct-erreur-input></div></div></div><div class=col-sm-6 ng-if=\"vm.data.pays.code != 'FR' && vm.data.pays.code != 'MC'\"><label class=\"label-form-cnaf control-label\" for=etrangerVille>Ville</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                (vm.adresseform.etrangerVille.$invalid && !vm.adresseform.etrangerVille.$pristine)\n" +
    "                || vm.adresseform.etrangerVille.$error.type5\n" +
    "                }\"><input id=etrangerVille title={{vm.titleVilleEtranger}} ng-model=vm.data.etrangerVille ng-blur=vm.testType5(vm.data.etrangerVille,vm.adresseform.etrangerVille) ng-trim=false name=etrangerVille maxlength=38 class=form-control ng-required=vm.isObligatoire ng-pattern=\"/^[a-zA-Z0-9à-ÿÀ-Ÿ '-]*$/\" aria-describedby=\"format_attendu_EtrangerVille \n" +
    "                                            adresseSocleErreurInputEtrangerVilleRequired \n" +
    "                                            adresseSocleErreurInputEtrangerVillePattern\n" +
    "                                            adresseSocleErreurInputEtrangerVilleType5\"><p id=format_attendu_EtrangerVille class=sr-only>{{vm.titleVilleEtranger}}</p><cnaf-cct-erreur-input iderreur=adresseSocleErreurInputEtrangerVilleRequired condition=\"{{(vm.adresseform.etrangerVille.$invalid \n" +
    "                                        && !vm.adresseform.etrangerVille.$pristine)\n" +
    "                                    && vm.adresseform.etrangerVille.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=adresseSocleErreurInputEtrangerVillePattern condition=\"{{(vm.adresseform.etrangerVille.$invalid \n" +
    "                                        && !vm.adresseform.etrangerVille.$pristine)\n" +
    "                                    && vm.adresseform.etrangerVille.$error.pattern\n" +
    "                                    && !vm.adresseform.etrangerVille.$error.required}}\" message=\"La saisie comporte des caractères non autorisés.\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=adresseSocleErreurInputEtrangerVilleType5 condition=\"{{(vm.adresseform.etrangerVille.$invalid \n" +
    "                                        && !vm.adresseform.etrangerVille.$pristine)\n" +
    "                                    && vm.adresseform.etrangerVille.$error.type5\n" +
    "                                    && !vm.adresseform.etrangerVille.$error.required}}\" message={{vm.adresseform.etrangerVille.invalidmsg}}></cnaf-cct-erreur-input></div></div></div><div class=row ng-if=\"vm.data.pays.code == 'FR' || vm.data.pays.code == 'MC'\"><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=numEtAdresse>N° et voie / Lieu-dit<cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-numvoieAdresse alt=\"Informations complémentaires pour voie et lieu-dit\" data-container=body data-trigger=manual tabindex=0></label><div ng-switch on=vm.autocompletion><div ng-switch-when=on class=form-group ng-class=\"{ 'has-error' :\n" +
    "                    (vm.adresseform.numEtAdresse.$invalid && !vm.adresseform.numEtAdresse.$pristine)\n" +
    "                    || vm.erroradresse\n" +
    "                    }\"><div class=hidden id=content-popover-numvoieAdresse><div class=popover-btn-close-cnaf></div><p>Exemples :</p><li>1 la pie morais</li><li>1 hameau Betty Williams</li><li>3 boulevard Beaumont</li><p></p></div><input role=combobox id=numEtAdresse title={{vm.titleNumEtAdresse}} ng-model=vm.data.numEtAdresse name=numEtAdresse class=form-control typeahead-min-length=2 uib-typeahead=\"result as result.lib for result in vm.numEtAdresse($viewValue)\" maxlength=38 ng-change=vm.reinitErreurAdresse() aria-describedby=\"format_attendu_numEtAdresse adresseSocleFormErreurInputNumEtAdresseRequired\" ng-required=vm.isObligatoire placeholder=\"Exemple : 15 rue des allouettes\" aria-haspopup=true><p id=format_attendu_NumEtAdresse class=sr-only>{{vm.titleNumEtAdresse}}</p><cnaf-cct-erreur-input iderreur=adresseSocleFormErreurInputNumEtAdresseRequired condition=\"{{((vm.adresseform.numEtAdresse.$invalid \n" +
    "                                            && !vm.adresseform.numEtAdresse.$pristine)\n" +
    "                                        || vm.erroradresse)\n" +
    "                                        && vm.adresseform.numEtAdresse.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input></div><div ng-switch-when=off class=form-group ng-class=\"{ 'has-error' :\n" +
    "                        (vm.adresseform.numEtAdresse.$invalid && !vm.adresseform.numEtAdresse.$pristine)\n" +
    "                        || vm.erroradresse\n" +
    "                        || vm.adresseform.numEtAdresse.$error.type7\n" +
    "                        }\"><input id=numEtAdresse title={{vm.titleNumEtAdresse}} ng-model=vm.data.numEtAdresse placeholder=\"Exemple : 15 rue des allouettes\" ng-blur=\"vm.testType7(vm.data.numEtAdresse,vm.adresseform.numEtAdresse,'numEtAdresse')\" ng-trim=false name=numEtAdresse class=form-control maxlength=38 aria-describedby=\"format_attendu_numEtAdresseOff \n" +
    "                                            adresseSocleFormErreurInputNumEtAdresseRequiredOff \n" +
    "                                            adresseSocleErreurInputNumEtAdressetype7\" ng-required=vm.isObligatoire><p id=format_attendu_NumEtAdresseOff class=sr-only>{{vm.titleNumEtAdresse}}</p><cnaf-cct-erreur-input iderreur=adresseSocleFormErreurInputNumEtAdresseRequiredOff condition=\"{{((vm.adresseform.numEtAdresse.$invalid \n" +
    "                                            && !vm.adresseform.numEtAdresse.$pristine)\n" +
    "                                        || vm.erroradresse)\n" +
    "                                        && vm.adresseform.numEtAdresse.$error.required}}\" message=\"Champ obligatoire.\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=adresseSocleErreurInputNumEtAdressetype7 condition=\"{{(vm.adresseform.numEtAdresse.$invalid \n" +
    "                                            && !vm.adresseform.numEtAdresse.$pristine)\n" +
    "                                        && vm.adresseform.numEtAdresse.$error.type7\n" +
    "                                        && !vm.adresseform.numEtAdresse.$error.required}}\" message={{vm.adresseform.numEtAdresse.invalidmsg}}></cnaf-cct-erreur-input></div></div></div><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=cplAdr1>Complément d'adresse<cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-complementAdresse alt=\"Informations complémentaires pour le complément d'adresse\" data-container=body data-trigger=manual tabindex=0></label><div class=hidden id=content-popover-complementAdresse><div class=popover-btn-close-cnaf></div><p>Bat C appt 330 chez Monsieur X</p></div><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                        (vm.adresseform.cplAdr1.$invalid && !vm.adresseform.cplAdr1.$pristine)\n" +
    "                        || vm.adresseform.cplAdr1.$error.type7\n" +
    "                    }\"><input id=cplAdr1 ng-model=vm.data.cplAdr1 title=\"Saisie des informations complémentaires de la résidence. Exemple : Bâtiment C, Appartement 330, Chez Monsieur Personne,...\" ng-blur=\"vm.testType7(vm.data.cplAdr1,vm.adresseform.cplAdr1,'cplAdr1')\" ng-trim=false name=cplAdr1 maxlength=38 class=form-control placeholder=\"Exemple : Bâtiment C, Appartement 330\" ng-pattern=\"/^[a-zA-Z0-9à-ÿÀ-Ÿ ']*$/\" aria-describedby=\"format_attendu_cplAdr1\n" +
    "                                        adresseSocleFormErreurInputCplAdr1Pattern\n" +
    "                                        adresseSocleFormErreurInputCplAdr1Type7\"><p id=format_attendu_cplAdr1 class=sr-only>Saisie des informations complémentaires de la résidence. Exemple : Bâtiment C, Appartement 330, Chez Monsieur Personne,...</p><cnaf-cct-erreur-input iderreur=adresseSocleFormErreurInputCplAdr1Pattern condition=\"{{(vm.adresseform.cplAdr1.$invalid && !vm.adresseform.cplAdr1.$pristine)\n" +
    "                                && vm.adresseform.cplAdr1.$error.pattern}}\" message=\"La saisie comporte des caractères non autorisés.\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=adresseSocleFormErreurInputCplAdr1Type7 condition=\"{{(vm.adresseform.cplAdr1.$invalid && !vm.adresseform.cplAdr1.$pristine) \n" +
    "                                && vm.adresseform.cplAdr1.$error.type7}}\" message={{vm.adresseform.cplAdr1.invalidmsg}}></cnaf-cct-erreur-input></div></div></div><div class=row ng-if=\"vm.data.pays.code != 'FR' && vm.data.pays.code != 'MC'\"><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=etrangerAdresse>Adresse</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                    (vm.adresseform.etrangerAdresse.$invalid && !vm.adresseform.etrangerAdresse.$pristine)\n" +
    "                    || vm.adresseform.etrangerAdresse.$error.type7\n" +
    "                }\"><input id=etrangerAdresse title={{vm.titleAdresseEtranger}} ng-model=vm.data.etrangerAdresse ng-blur=\"vm.testType7(vm.data.etrangerAdresse,vm.adresseform.etrangerAdresse,'etrangerAdresse')\" ng-trim=false name=etrangerAdresse maxlength=38 class=form-control ng-required=vm.isObligatoire aria-describedby=\"format_attendu_EtrangerAdresse\n" +
    "                                        adresseSocleFormErreurInputEtrangerAdresseRequired\n" +
    "                                        adresseSocleErreurInputEtrangerAdressetype7\n" +
    "                                        adresseSocleErreurInputEtrangerAdressePattern\" ng-pattern=\"/^[a-zA-Z0-9à-ÿÀ-Ÿ ']*$/\"><p id=format_attendu_EtrangerAdresse class=sr-only>{{vm.titleAdresseEtranger}}</p><cnaf-cct-erreur-input iderreur=adresseSocleFormErreurInputEtrangerAdresseRequired condition=\"{{(vm.adresseform.etrangerAdresse.$invalid \n" +
    "                                        && !vm.adresseform.etrangerAdresse.$pristine)\n" +
    "                                    && vm.adresseform.etrangerAdresse.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=adresseSocleErreurInputEtrangerAdressetype7 condition=\"{{(vm.adresseform.etrangerAdresse.$invalid \n" +
    "                                        && !vm.adresseform.etrangerAdresse.$pristine)\n" +
    "                                    && vm.adresseform.etrangerAdresse.$error.type7\n" +
    "                                    && !vm.adresseform.etrangerAdresse.$error.required}}\" message={{vm.adresseform.etrangerAdresse.invalidmsg}}></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=adresseSocleErreurInputEtrangerAdressePattern condition=\"{{(vm.adresseform.etrangerAdresse.$invalid \n" +
    "                                        && !vm.adresseform.etrangerAdresse.$pristine)\n" +
    "                                    && vm.adresseform.etrangerAdresse.$error.pattern\n" +
    "                                    && !vm.adresseform.etrangerAdresse.$error.required}}\" message=\"La saisie comporte des caractères non autorisés.\"></cnaf-cct-erreur-input></div></div><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=etrangerAdresseSuite>Adresse (suite)</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                (vm.adresseform.etrangerAdresseSuite.$invalid && !vm.adresseform.etrangerAdresseSuite.$pristine)\n" +
    "                || vm.adresseform.etrangerAdresseSuite.$error.type7\n" +
    "                }\"><input id=etrangerAdresseSuite title=\"Saisie de la suite de l'adresse à l'étranger. Exemple : Level 7, Flat 32,...\" ng-model=vm.data.etrangerAdresseSuite ng-blur=\"vm.testType7(vm.data.etrangerAdresseSuite,vm.adresseform.etrangerAdresseSuite,'etrangerAdresseSuite')\" ng-trim=false name=etrangerAdresseSuite maxlength=38 class=form-control aria-describedby=\"format_attendu_EtrangerAdresseSuite\n" +
    "                                        adresseSocleErreurInputEtrangerAdresseSuitetype7\n" +
    "                                        adresseSocleErreurInputEtrangerAdresseSuitePattern\" ng-pattern=\"/^[a-zA-Z0-9à-ÿÀ-Ÿ ']*$/\"><p id=format_attendu_EtrangerAdresseSuite class=sr-only>Saisie de la suite de l'adresse à l'étranger. Exemple : Level 7, Flat 32,...</p><cnaf-cct-erreur-input iderreur=adresseSocleErreurInputEtrangerAdresseSuitetype7 condition=\"{{(vm.adresseform.etrangerAdresseSuite.$invalid \n" +
    "                                        && !vm.adresseform.etrangerAdresseSuite.$pristine)\n" +
    "                                    && vm.adresseform.etrangerAdresseSuite.$error.type7}}\" message={{vm.adresseform.etrangerAdresseSuite.invalidmsg}}></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=adresseSocleErreurInputEtrangerAdresseSuitePattern condition=\"{{(vm.adresseform.etrangerAdresseSuite.$invalid \n" +
    "                                        && !vm.adresseform.etrangerAdresseSuite.$pristine)\n" +
    "                                    && vm.adresseform.etrangerAdresseSuite.$error.pattern}}\" message=\"La saisie comporte des caractères non autorisés.\"></cnaf-cct-erreur-input></div></div></div></div>")

$templateCache.put("components/cnaf-cct-conditions-utilisation/cnaf-cct-conditions-utilisation.html","<div class=row><div class=col-sm-12 style=padding-top:20px><div class=conteneur-docweb-cnaf><div class=\"collapsable-body-cnaf col-sm-12 collapse in\" id=cu-collapse ng-show=!vm.blocCollapsed><div class=collapsable-heading-cnaf ng-click=vm.expandDeclarerCollapse()><h3 class=\"{{vm.cuCollapsed ? 'ouvert' : 'ferme'}}-cnaf\"><a role=button href=javascript:void(0); aria-expanded={{!vm.cuCollapsed}} aria-controls=cu-collapse-inside>Conditions d'utilisation du service et Protection des données personnelles</a></h3></div><div class=\"collapsable-body-cnaf list-group\" ng-show=!vm.cuCollapsed id=cu-collapse-inside><p class=panel-body>Vous déclarez un changement de situation, les informations recueillies à partir de ce formulaire sont nécessaires au traitement de votre dossier.</p><div class=panel-body><p class=text-bold>La valeur juridique de cette démarche en ligne est la même que celle d'une déclaration papier.</p><ul><li>Vous certifiez que les renseignements saisis sont exacts.<br>La loi punit quiconque se rend coupable de fraude ou de fausse déclaration (Articles L. 114-9 - dépôt de plainte de la Caisse pouvant aboutir à : travail d'intérêt général, amende ou peine de prison, L. 114-17 du code de la Sécurité sociale - prononcé de pénalités -, articles 313-1 à 313-3, 441-1 et 441-6 du code Pénal).</li><li>Vous vous engagez à signaler immédiatement à votre Caisse tout changement intervenant dans votre situation (familiale, professionnelle…) ou dans celle de vos enfants.</li><li>Vous prenez connaissance que la Caf vérifie l'exactitude de cette déclaration (article L.114-19 du code de la Sécurité sociale).</li></ul></div><div class=panel-body><p class=text-bold>Vos droits concernant vos données personnelles :</p><ul><li>\"Vos données personnelles sont traitées par votre Caf et par la branche Famille de la Sécurité sociale dans le cadre de la gestion de vos prestations, au titre des missions de service public dont est investie la Cnaf. Elles sont conservées dans ce télé service le temps de leur prise en compte pour l'étude de votre demande.\"<br>Certaines de ces informations peuvent être transmises à nos partenaires dans le cadre de nos missions (Caisse primaire d'assurance maladie, France Travail, Conseil départemental...).</li><li>Conformément à la loi n°78-17 du 6 janvier modifiée, vous disposez d'un droit d'accès et de rectification de ces informations en vous adressant, par courrier postal accompagné d'une preuve d'identité, au directeur de votre Caf.</li></ul></div></div><div class=filet-cnaf></div></div></div><div class=row><div class=\"col-sm-12 form-group has-feedback\" ng-class=\"{ 'has-error' : vm.champsobligatoire }\"><label id=labelCUCheckbox for=accepteCU class=align-middle-cnaf><cnaf-checkbox id=accepteCU title=\"Champ obligatoire\" name=accepteCU ng-model=vm.data.accepteCU class=pull-left aria-labelledby=labelCUCheckbox aria-describedby=\"CGU_obligatoire alerte_input_CGU\" required></cnaf-checkbox>J'ai pris connaissance des Conditions d'utilisation du service et je les accepte.</label><p id=CGU_obligatoire class=sr-only>Champ obligatoire.</p><cnaf-cct-erreur-input iderreur=alerte_input_CGU condition={{vm.champsobligatoire}} message=\"Merci de prendre connaissance des conditions d'utilisation et de cocher la case.\"></cnaf-cct-erreur-input></div></div></div></div>")

$templateCache.put("components/cnaf-cct-coordbanc-socle/cnaf-cct-coordbanc-socle.html","<div ng-if=\"vm.choixtituribs.length === 1\"><div class=row><div class=\"col-sm-12 form-group\"><label class=label-form-cnaf for=choixTituRib>Titulaire du compte : {{vm.choixtituribs[0].libelle}}</label></div></div></div><div class=row><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=iban>IBAN<cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-iban data-container=body data-trigger=manual></label><div lang=en class=hidden id=content-popover-iban>International Bank Account Number</div><div class=form-group ng-class=\"{ 'has-error' : \n" +
    "                vm.coordbancform.iban.$invalid && (vm.controle.submitted || vm.coordbancform.iban.$touched) }\"><input id=iban ng-model=vm.data.iban title=\"Saisie de l’IBAN. Format attendu pour un IBAN français : FR76 3007 6000 4000 3000 0030 050\" name=iban class=\"form-control uppercase\" ui-mask={{vm.data.ibanmask}} ng-blur=vm.controlerIbanOnBlur() ui-options={allowInvalidValue:true,clearOnBlur:false} ng-required=true aria-describedby=\"monFormErreurInputErreurSepaIban \n" +
    "                monFormErreurInputIbanObligatoire \n" +
    "                monFormErreurInputErreurInvalidIban\n" +
    "                monFormErreurInputIbanMask\"><cnaf-cct-erreur-input iderreur=monFormErreurInputErreurSepaIban condition=\"{{vm.coordbancform.iban.$touched  && !vm.coordbancform.iban.$error.required && vm.coordbancform.iban.$error.ibansepa}}\" message=\"Votre compte bancaire doit être domicilié dans un pays membre de l'Union européenne\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=monFormErreurInputIbanObligatoire condition=\"{{(vm.controle.submitted || vm.coordbancform.iban.$touched) && vm.coordbancform.iban.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=monFormErreurInputErreurInvalidIban condition=\"{{vm.coordbancform.iban.$error.ibanvalid && !vm.coordbancform.iban.$error.required && vm.coordbancform.iban.invalidmsg}}\" message={{vm.coordbancform.iban.invalidmsg}} messagesronly=\"Saisie de l’IBAN. Format attendu pour un IBAN français : FR76 3007 6000 4000 3000 0030 050\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=monFormErreurInputIbanMask condition=\"{{(vm.coordbancform.iban.$invalid && !vm.coordbancform.iban.$pristine) && !vm.coordbancform.iban.$error.ibanvalid && vm.coordbancform.iban.maskmsg !== '' && !vm.coordbancform.iban.$error.required}}\" message={{vm.coordbancform.iban.maskmsg}}></cnaf-cct-erreur-input></div></div></div><div class=row><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=bic>BIC</label><div class=form-group ng-class=\"{ 'has-error' : \n" +
    "                (vm.coordbancform.bic.$invalid && (vm.controle.submitted ||  vm.coordbancform.bic.$touched)) }\"><input id=bic ng-model=vm.data.bic title=\"Saisie du BIC. Format attendu pour un BIC français : NORDFRPPXXX\" name=bic class=\"form-control uppercase\" maxlength=11 ui-validate=\"{lengthmsg: 'vm.controlerBicOnBlur($value)' }\" value={{vm.data.bic}} ng-model-options=\"{ updateOn: 'blur'}\" ng-required=true aria-describedby=\"monFormErreurInputErreurTailleBic \n" +
    "                monFormErreurInputBicObligatoire\n" +
    "                monFormErreurInputBicInvalid\n" +
    "                monFormErreurInputErreurInvalidIban\"><cnaf-cct-erreur-input iderreur=monFormErreurInputErreurTailleBic condition=\"{{vm.coordbancform.bic.$touched && vm.coordbancform.bic.$error.lengthmsg}}\" message=\"Le nombre de caractères saisi est incorrect. Un BIC comporte 8 ou 11 caractères. Exemple : AXABFRPP\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=monFormErreurInputBicObligatoire condition=\"{{(vm.controle.submitted || vm.coordbancform.bic.$touched) && vm.coordbancform.bic.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=monFormErreurInputBicInvalid condition=\"{{(vm.controle.submitted || vm.coordbancform.bic.$touched) && vm.coordbancform.bic.$error.bicvalid}}\" message={{vm.coordbancform.bic.invalidmsg}} messagesronly=\"Saisie du BIC. Format attendu pour un BIC français : NORDFRPPXXX\"></cnaf-cct-erreur-input></div></div></div><div ng-if=\"vm.choixtituribs.length > 1\"><div class=row><div class=\"col-sm-12 form-group\"><fieldset><legend class=label-form-cnaf for=choixTituRib>Titulaire du compte</legend><div class=row><div class=\"form-group btn-group-lg-cnaf btn-block\" ng-class=\"{ 'has-error' :\n" +
    "                        vm.coordbancform.choixTituRib.$invalid && !vm.coordbancform.choixTituRib.$pristine\n" +
    "                        || (vm.data.choixTituRib == undefined && (vm.controle.submitted || vm.coordbancform.choixTituRib.$touched))\n" +
    "                        }\" data-toggle=buttons><div ng-class=\"{'col-md-6' : vm.data.libelleLong, 'col-md-4' : !vm.data.libelleLong}\" class=\"col-xs-12 col-md-6\" ng-repeat=\"choixTit in vm.choixtituribs track by $index\"><label class=\"btn btn-default btn-block\" ng-model=vm.data.choixTituRib uib-btn-radio=\"'{{choixTit.cle}}'\" for=choixTituRib{{choixTit.cle}}><input type=radio name=choixTituRib aria-label={{choixTit.libelle}} class=sr-only id=choixTituRib{{choixTit.cle}} ng-model=vm.data.choixTituRib value={{choixTit.cle}} ng-required=true aria-describedby=monFormErreurInputTituRibObligatoire> <span aria-hidden=true>{{choixTit.libelle}}</span></label></div><div class=\"col-xs-12 col-sm-12\"><cnaf-cct-erreur-input iderreur=monFormErreurInputTituRibObligatoire condition=\"{{(vm.controle.submitted || vm.coordbancform.choixTituRib.$touched) && vm.data.choixTituRib == undefined}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input></div></div></div></fieldset></div></div></div>")

$templateCache.put("components/cnaf-cct-courriel-ou-tel/cnaf-cct-courriel-ou-tel.html","<div class=row><div class=col-sm-6><div class=row><label class=\"label-form-cnaf control-label\" for=emailOuTel>Saisir votre courriel ou téléphone portable</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                        (vm.courrieloutelform.emailOuTel.$invalid && !vm.courrieloutelform.emailOuTel.$pristine)\n" +
    "                        || vm.courrieloutelform.emailOuTel.$error.type1\n" +
    "                        || vm.courrieloutelform.emailOuTel.$error.controletel\n" +
    "                        || (vm.data.emailOuTel == undefined && vm.controle.submitted)\n" +
    "                        }\"><input id=emailOuTel ng-model=vm.data.emailOuTel name=emailOuTel maxlength=78 title=\"adresse@xxx.com ou 0600000000\" placeholder=\"adresse@xxx.com ou 0600000000\" class=form-control ng-blur=vm.checkCourrielOuTelephonePortable(vm.data.emailOuTel) required><p class=help-block role=alert ng-show=\"vm.courrieloutelform.emailOuTel.$error.type1 || vm.courrieloutelform.emailOuTel.$error.controletel\">Le format du courriel ou du téléphone portable est incorrect (adresse@xxx.com ou 0600000000)</p><p class=help-block role=alert ng-show=\"(vm.data.emailOuTel == undefined  && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=row><label class=\"label-form-cnaf control-label\" for=emailOuTel2>Confirmer le courriel ou téléphone portable</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                        ((vm.courrieloutelform.emailOuTel2.$invalid && !vm.courrieloutelform.emailOuTel2.$pristine)\n" +
    "                        || vm.courrieloutelform.emailOuTel2.$error.identique\n" +
    "                        || vm.errorcourrieloutel\n" +
    "                        || (vm.data.emailOuTel2 == undefined  && vm.controle.submitted))\n" +
    "                        }\"><input id=emailOuTel2 ng-model=vm.data.emailOuTel2 name=emailOuTel2 maxlength=78 class=form-control title=\"adresse@xxx.com ou 0600000000\" placeholder=\"adresse@xxx.com ou 0600000000\" ng-model-options=\"{ updateOn: 'blur' }\" ui-validate=\"{identique  : 'vm.controleChampsIdentique($value,vm.data.emailOuTel)'}\" ui-validate-watch=\"'vm.data.emailOuTel'\" reset-on-click required><p class=help-block role=alert ng-show=\"vm.courrieloutelform.emailOuTel2.$error.identique && vm.isEmail\">Les courriels doivent être identiques</p><p class=help-block role=alert ng-show=\"vm.courrieloutelform.emailOuTel2.$error.identique && !vm.isEmail\">Les numéros de portable doivent être identiques</p><p class=help-block role=alert ng-show=\"(vm.data.emailOuTel2 == undefined  && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></div>")

$templateCache.put("components/cnaf-cct-courriel/cnaf-cct-courriel.html","<div class=\"row col-sm-12\"><label class=\"col-xs-12 col-sm-12 label-form-cnaf control-label\" for=email{{vm.index}}>Adresse mail</label><div class=\"row form-group\" ng-class=\"{ 'has-error' :\n" +
    "                (vm.courrielform.email{{vm.index}}.$invalid && !vm.courrielform.email{{vm.index}}.$pristine)\n" +
    "                || vm.courrielform.email{{vm.index}}.$error.type1\n" +
    "                }\"><div class=\"col-xs-12 col-sm-12 col-md-10\"><input id=email{{vm.index}} title=\"Saisie d'adresse mail. Format attendu : un@exemple.com\" ng-model=vm.data.email ng-disabled=vm.controle.idConnEmailOK name=email{{vm.index}} aria-describedby=\"\n" +
    "                        format_attendu_email1\n" +
    "                        alerte_input_courriel\" maxlength=78 class=form-control ng-change=\"vm.supprimeConfirmation(vm.data.email,'email2')\" ng-blur=\"vm.testType1(vm.data.email,vm.courrielform,vm.index,'email');vm.supprimeConfirmation(vm.data.email,'email2')\"></div><div class=\"col-xs-12 col-sm-12\"><p id=format_attendu_email1 class=sr-only>Saisie d'adresse mail. Format attendu : adresseexemple@mail.com</p><p id=alerte_input_courriel class=\"hidden help-block\" ng-if='vm.returnError(vm.courrielform,\"email\",vm.index,\"type1\")'>{{vm.returnMessage(vm.courrielform,vm.index,'email')}}</p><p class=help-block role=alert ng-if='vm.returnError(vm.courrielform,\"email\",vm.index,\"type1\")'>{{vm.returnMessage(vm.courrielform,vm.index,'email')}}</p></div></div></div><div class=\"row col-sm-12\" ng-if=\"vm.data.email && vm.data.email !== ''\"><label class=\"col-xs-12 col-sm-12 label-form-cnaf control-label\" for=email2{{vm.index}}>Confirmer le mail</label><div class=\"row form-group\" ng-class=\"{ 'has-error' :\n" +
    "                    ((vm.courrielform.email2{{vm.index}}.$invalid && !vm.courrielform.email2{{vm.index}}.$pristine)\n" +
    "                    || vm.courrielform.email2{{vm.index}}.$error.identique\n" +
    "                    || vm.errorcourriel)\n" +
    "                    }\"><div class=\"col-xs-12 col-sm-12 col-md-10\"><input id=email2{{vm.index}} title=\"Saisie d'adresse mail. Format attendu : un@exemple.com\" ng-model=vm.data.email2 ng-disabled=vm.controle.idConnEmailOK aria-describedby=\"\n" +
    "                        format_attendu_email2 \n" +
    "                        alerte_input_confirmcourriel_identique\n" +
    "                        alerte_input_confirmcourriel_obligatoire\" name=email2{{vm.index}} maxlength=78 class=form-control ng-model-options=\"{ updateOn: 'blur' }\" ui-validate=\"{identique  : 'vm.controleMailidentique($value,vm.data.email)', obligatoire : 'vm.reInitChampObli($value,vm.data.email)'}\" ui-validate-watch=\"'vm.data.email'\" reset-on-click></div><div class=\"col-xs-12 col-sm-12\"><p id=format_attendu_email2 class=sr-only>Saisie d'adresse mail. Champ obligatoire. Format attendu : adresseexemple@mail.com</p><p id=alerte_input_confirmcourriel_identique class=\"hidden help-block\" ng-if='vm.returnError(vm.courrielform,\"email2\",vm.index,\"identique\")'>Les adresses mail doivent être identiques</p><p id=alerte_input_confirmcourriel_obligatoire class=\"hidden help-block\" ng-if=vm.errorcourriel>Champ obligatoire</p><p class=help-block role=alert ng-if='vm.returnError(vm.courrielform,\"email2\",vm.index,\"identique\")'>Les adresses mail doivent être identiques</p><p class=help-block role=alert ng-if=vm.errorcourriel>Champ obligatoire</p></div></div></div><p class=\"row col-xs-12 col-sm-12 text-primary texte-info-cnaf\" ng-if=\"vm.index == undefined || vm.index === 0\">En aucun cas, votre adresse mail ne sera transmise à des tiers ou utilisée à des fins commerciales.</p>")

$templateCache.put("components/cnaf-cct-date-depart/cnaf-cct-date-depart.html","<div class=row><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateDepart><span>Date de départ</span></label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                    ((vm.datedepartform.dateDepart.$invalid\n" +
    "                    && !vm.datedepartform.dateDepart.$pristine)\n" +
    "                    || (vm.datedepartform.dateDepart.$error.pattern && vm.data.dateDepart.length == 10 && vm.data.dateDepart != 'jj/mm/aaaa')\n" +
    "                    || (vm.datedepartform.dateDepart.$error.controleDernierJourMoisPlus1Demarche && vm.data.dateDepart.length == 10 && vm.data.dateDepart != 'jj/mm/aaaa')\n" +
    "                    || (vm.datedepartform.dateDepart.$error.controleDateDebutPresenceDossier && vm.data.dateDepart.length == 10 && vm.data.dateDepart != 'jj/mm/aaaa')\n" +
    "                    || ((vm.data.dateDepart == undefined || vm.data.dateDepart == 'jj/mm/aaaa') && vm.controle.submitted)) }\"><div class=\"form-group input-group\" id=divDateDepart><input id=dateDepart name=dateDepart value={{vm.data.dateDepart}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.dateDepart class=form-control ui-validate=\"{controleDernierJourMoisPlus1Demarche : 'vm.controleDernierJourMoisPlus1Demarche($value, vm.controle.dernierJourMoisSuivant)', controleDateDebutPresenceDossier : 'vm.controleDateDebutPresenceDossier($value,vm.data.choixPersonne.dateDebutPresenceDossier)'}\" ui-validate-watch=\"'vm.data.choixPersonne'\" ng-required=true inputname=vm.data.dateDepart pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.dateDepart start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateDepart></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"vm.datedepartform.dateDepart.$error.pattern && vm.data.dateDepart.length == 10\">Format de date invalide</p><p class=help-block role=alert ng-show=\"vm.datedepartform.dateDepart.$error.controleDernierJourMoisPlus1Demarche && vm.data.dateDepart.length == 10 && vm.data.dateDepart != 'jj/mm/aaaa'\">La date de départ doit être antérieure ou égale au {{vm.controle.dernierJourMoisSuivant | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=\"vm.datedepartform.dateDepart.$error.controleDateDebutPresenceDossier && vm.data.dateDepart.length == 10 && vm.data.dateDepart != 'jj/mm/aaaa'\">La date de départ doit être postérieure ou égale au {{vm.controle.dateDebPresenceDos}}</p><p class=help-block role=alert ng-show=\"((vm.data.dateDepart == undefined || vm.data.dateDepart == 'jj/mm/aaaa') && vm.controle.submitted)\">Champ obligatoire</p></div></div></div>")

$templateCache.put("components/cnaf-cct-dateentreefrance/cnaf-cct-dateentreefrance.html","<cnaf-calendar></cnaf-calendar><div class=row ng-init=vm.init()><div class=col-sm-4><fieldset><legend class=label-form-cnaf ng-if=!vm.conjoint>Vous arrivez de l'étranger</legend><legend class=label-form-cnaf ng-if=vm.conjoint>Votre conjoint arrive de l'étranger</legend><div class=row><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                        vm.dateentreefranceform.arriveEtranger.$invalid && !vm.dateentreefranceform.arriveEtranger.$pristine\n" +
    "                        || (vm.data.arriveEtranger == undefined && vm.controle.submitted)\n" +
    "                       }\"><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.arriveEtranger uib-btn-radio=\"'Oui'\" for=arriveEtrangerOui><input type=radio name=arriveEtranger aria-label=Oui class=sr-only id=arriveEtrangerOui ng-model=vm.data.arriveEtranger value=oui required> <span aria-hidden=true>Oui</span></label></div><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.arriveEtranger uib-btn-radio=\"'Non'\" for=arriveEtrangerNon ng-click=vm.cleanMsg()><input type=radio name=arriveEtranger aria-label=non class=sr-only id=arriveEtrangerNon ng-model=vm.data.arriveEtranger value=non required> <span aria-hidden=true>Non</span></label></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.arriveEtranger == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></fieldset></div></div><div class=row ng-if=\"vm.data.arriveEtranger == 'Oui'\"><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dtEntreeFrance>Date d'entrée en France</label><div id=divDtEntreeFrance class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                    vm.dateentreefranceform.dtEntreeFrance.$invalid\n" +
    "                    && !vm.dateentreefranceform.dtEntreeFrance.$pristine\n" +
    "                    || (vm.dateentreefranceform.dtEntreeFrance.$error.pattern && vm.data.dtEntreeFrance.length == 10)\n" +
    "                    || (vm.data.dtEntreeFrance == undefined && vm.controle.submitted)\n" +
    "                  }\"><div class=\"form-group input-group\"><input id=dtEntreeFrance name=dtEntreeFrance value={{vm.data.dtEntreeFrance}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.dtEntreeFrance class=form-control ng-required=true ui-validate=\"{  dateSuperieurDateNaiss  : 'vm.controleDateSuperieurDateNaiss($value, vm.data.dateNaissance)',\n" +
    "                                    dateInferieureDateJour : 'vm.controleDateInferieureDateJour($value, vm.today)'\n" +
    "                                 }\" ui-validate-watch=\"'vm.data.dateNaissance'\" pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.dtEntreeFrance start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dtEntreeFrance></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"(vm.data.dtEntreeFrance.length == 10) && vm.dateentreefranceform.dtEntreeFrance.$error.pattern\">Format de date invalide</p><p class=help-block role=alert ng-show=\"((vm.data.dtEntreeFrance == undefined  || vm.data.dtEntreeFrance == 'jj/mm/aaaa') && vm.controle.submitted)\">Champ obligatoire</p><p class=help-block role=alert ng-show=\"((vm.data.dtEntreeFrance == undefined  || vm.data.dtEntreeFrance == 'jj/mm/aaaa') && vm.controle.submitted)\">Champ obligatoire</p><p class=help-block role=alert ng-show=vm.dateentreefranceform.dtEntreeFrance.$error.dateSuperieurDateNaiss>Votre date d’entrée en France doit être postérieure ou égale à votre date de naissance</p><p class=help-block role=alert ng-show=vm.dateentreefranceform.dtEntreeFrance.$error.dateInferieureDateJour>Votre date d’entrée en France doit être antérieure au {{vm.today | date:'dd/MM/yyyy'}}</p></div></div></div><div class=row ng-if=\"vm.conjoint && vm.data.arriveEtranger == 'Non'\"><div class=col-sm-4><fieldset><legend class=label-form-cnaf>Votre conjoint réside à l'étranger</legend><div class=row><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                        vm.dateentreefranceform.resideEtranger.$invalid && !vm.dateentreefranceform.resideEtranger.$pristine\n" +
    "                        || (vm.data.resideEtranger == undefined && vm.controle.submitted)\n" +
    "                       }\"><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.resideEtranger uib-btn-radio=\"'Oui'\" for=resideEtrangerOui><input type=radio name=resideEtranger aria-label=Oui class=sr-only id=resideEtrangerOui ng-model=vm.data.resideEtranger value=oui required> <span aria-hidden=true>Oui</span></label></div><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.resideEtranger uib-btn-radio=\"'Non'\" for=resideEtrangerNon><input type=radio name=resideEtranger aria-label=non class=sr-only id=resideEtrangerNon ng-model=vm.data.resideEtranger value=non required> <span aria-hidden=true>Non</span></label></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.resideEtranger == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></fieldset></div></div><div class=row ng-if=\"vm.conjoint && vm.data.resideEtranger == 'Oui' && vm.data.arriveEtranger == 'Non'\"><div class=col-sm-6><label class=label-form-cnaf for=paysResidenceCjt>Pays de résidence du conjoint</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                            (vm.dateentreefranceform.paysResidenceCjt{{vm.index}}.$invalid && !vm.dateentreefranceform.paysResidenceCjt{{vm.index}}.$pristine)\n" +
    "                            || (vm.data.paysResidenceCjt == undefined && vm.controle.submitted)\n" +
    "                    }\"><input id=paysResidenceCjt ng-model=vm.data.paysResidenceCjt name=paysResidenceCjt class=form-control typeahead-min-length=2 uib-typeahead=\"pays as pays.libelleCaffr for pays in vm.getListePaysProposes($viewValue) | filter:$viewValue | limitTo:8\" typeahead-editable=false typeahead-no-results=noPaysFound required><p class=help-block role=alert ng-show=noPaysFound>Pays non trouvé</p><p class=help-block role=alert ng-show=\"(vm.data.paysResidenceCjt == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div>")

$templateCache.put("components/cnaf-cct-entete-recap/cnaf-cct-entete-recap.html","<div class=\"row bloc-recap\"><hr></div><div ng-init=vm.init()><div class=\"row col-sm-12\" cnaf-focus=focusPage tabindex=-1><h3 id=titrepage class=\"collapsable-heading-cnaf titre-bloc-cnaf\">Récapitulatif</h3></div><p id=infos-recap class=texte-clair-cnaf><span class=texte-bold ng-show=!vm.modeenchainement>Pour valider et transmettre votre déclaration, cliquer sur&nbsp;«&nbsp;Valider&nbsp;». </span><span class=texte-bold ng-show=vm.modeenchainement>Pour valider et transmettre votre déclaration, cliquer sur&nbsp;«&nbsp;Valider&nbsp;et&nbsp;Continuer&nbsp;».</span><br><span>Pour modifier votre saisie, cliquer sur le&nbsp; <img alt=\"\" src=/icfstatiquesangularappli/dist/images/usager/pic_modifier.png style=\"position:absolute; margin-top:-10px\"></span><br><span>Pour abandonner, cliquer sur&nbsp;«&nbsp;Quitter&nbsp;».</span></p></div><div class=\"row bloc-recap\"><hr></div>")

$templateCache.put("components/cnaf-cct-erreur-input/cnaf-cct-erreur-input.html","<div id={{vm.iderreur}} ng-if=!vm.show()></div><div class=has-error role=alert ng-if=vm.show()><p class=help-block id={{$parent.vm.iderreur}}>{{$parent.vm.message}} <span ng-if=$parent.vm.messagesronly class=sr-only>{{$parent.vm.messagesronly}}</span></p></div>")

$templateCache.put("components/cnaf-cct-etatcivil-socle/cnaf-cct-etatcivil-socle.html","<cnaf-calendar></cnaf-calendar><div class=row><div class=col-sm-4 ng-if=!vm.data.isAffichageEtatCivilMinimum><fieldset><legend class=label-form-cnaf for=sexe>Sexe</legend><div class=row><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                    vm.etatcivilform.sexe.$invalid && !vm.etatcivilform.sexe.$pristine\n" +
    "                    || (vm.data.sexe == undefined && vm.controle.submitted)\n" +
    "                   }\"><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sexe uib-btn-radio=\"'Masculin'\" for=masculin><input type=radio name=sexe aria-label=masculin class=sr-only id=masculin ng-model=vm.data.sexe value=masculin required> <span aria-hidden=true>Masculin</span></label></div><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sexe uib-btn-radio=\"'Féminin'\" for=feminin><input type=radio name=sexe aria-label=feminin class=sr-only id=feminin ng-model=vm.data.sexe value=feminin required> <span aria-hidden=true>Féminin</span></label></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.sexe == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></fieldset></div></div><div class=row><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=nom>Nom de famille<cnaf-aide ng-if=\"!vm.data.isAffichageEtatCivilSimple && !vm.data.isAffichageEtatCivilMinimum\" styleclass=pull-right data-id-content-cnaf=content-popover-nom data-container=body data-trigger=manual tabindex=0></label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                  (vm.etatcivilform.nom.$invalid && !vm.etatcivilform.nom.$pristine)\n" +
    "                  || vm.etatcivilform.nom.$error.type3\n" +
    "                  || vm.erroretatcivil\n" +
    "                  || (vm.data.nom == undefined && vm.controle.submitted)\n" +
    "                    }\"><div class=hidden id=content-popover-nom>Il s'agit de votre nom de naissance<br><div class=popover-btn-close-cnaf></div></div><input id=nom maxlength=63 ng-model=vm.data.nom ng-change=\"vm.data.nom = vm.data.nom.toUpperCase()\" ng-pattern=\"/^[a-zA-Zà-ÿÀ-Ÿ '-]*$/\" ng-blur=\"vm.testType3(vm.data.nom,vm.etatcivilform.nom,'nom')\" ng-trim=false name=nom class=form-control required><p class=help-block role=alert ng-show=\"vm.etatcivilform.nom.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.etatcivilform.nom.$error.type3>{{vm.etatcivilform.nom.invalidmsg}}</p><p class=help-block role=alert ng-show=\"(vm.data.nom == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div><div class=col-sm-6 ng-if=\"!vm.data.isAffichageEtatCivilSimple && !vm.data.isAffichageEtatCivilMinimum\"><label class=\"label-form-cnaf control-label\" for=nomUsage>Nom d'usage<cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-nomUsage data-container=body data-trigger=manual tabindex=0></label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                (vm.etatcivilform.nomUsage.$invalid && !vm.etatcivilform.nomUsage.$pristine)\n" +
    "                  || vm.etatcivilform.nomUsage.$error.type3\n" +
    "                  }\"><div class=hidden id=content-popover-nomUsage>Le nom d'usage est le nom utilisé dans la vie courante (facultatif, ex : nom du conjoint, de l'ex-conjoint, du père et ou de la mère)<br><div class=popover-btn-close-cnaf></div></div><input id=nomUsage maxlength=50 ng-model=vm.data.nomUsage ng-change=\"vm.data.nomUsage = vm.data.nomUsage.toUpperCase()\" ng-pattern=\"/^[a-zA-Zà-ÿÀ-Ÿ '-]*$/\" ng-blur=\"vm.testType3(vm.data.nomUsage,vm.etatcivilform.nomUsage,'nomUsage')\" ng-trim=false name=nomUsage class=form-control><p class=help-block role=alert ng-show=\"vm.etatcivilform.nomUsage.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.etatcivilform.nomUsage.$error.type3>{{vm.etatcivilform.nomUsage.invalidmsg}}</p></div></div><div class=col-sm-6 ng-if=vm.data.isAffichageEtatCivilSimple><label class=\"label-form-cnaf control-label\" for=prenom>Prénom</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "              (vm.data.isAffichageEtatCivilSimple && vm.etatcivilform.prenom.$invalid && !vm.etatcivilform.prenom.$pristine)\n" +
    "                || vm.etatcivilform.prenom.$error.type13\n" +
    "                || vm.erroretatcivil\n" +
    "                || (vm.data.prenom == undefined && vm.controle.submitted)\n" +
    "              }\"><input id=prenom maxlength=32 ng-model=vm.data.prenom ng-change=\"vm.data.prenom = vm.data.prenom.toUpperCase()\" ng-pattern=\"/^[a-zA-Zà-ÿÀ-Ÿ '-]*$/\" ng-blur=vm.testType13(vm.data.prenom,vm.etatcivilform.prenom) ng-trim=false name=prenom class=form-control ng-required=vm.data.isAffichageEtatCivilSimple><p class=help-block role=alert ng-show=\"vm.data.isAffichageEtatCivilSimple && vm.etatcivilform.prenom.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.etatcivilform.prenom.$error.type13>{{vm.etatcivilform.prenom.invalidmsg}}</p><p class=help-block role=alert ng-show=\"(vm.data.prenom == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div><div class=row><div class=col-sm-6 ng-if=\"!vm.data.isAffichageEtatCivilSimple && !vm.data.isAffichageEtatCivilMinimum\"><label class=\"label-form-cnaf control-label\" for=prenom>Prénom</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "              (!vm.data.isAffichageEtatCivilSimple && vm.etatcivilform.prenom.$invalid && !vm.etatcivilform.prenom.$pristine)\n" +
    "                || vm.etatcivilform.prenom.$error.type13\n" +
    "                || (vm.data.prenom == undefined && vm.controle.submitted)\n" +
    "              }\"><input id=prenom maxlength=32 ng-model=vm.data.prenom ng-change=\"vm.data.prenom = vm.data.prenom.toUpperCase()\" ng-pattern=\"/^[a-zA-Zà-ÿÀ-Ÿ '-]*$/\" ng-blur=vm.testType13(vm.data.prenom,vm.etatcivilform.prenom) ng-trim=false name=prenom class=form-control ng-required=!vm.data.isAffichageEtatCivilSimple><p class=help-block role=alert ng-show=\"!vm.data.isAffichageEtatCivilSimple && vm.etatcivilform.prenom.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.etatcivilform.prenom.$error.type13>{{vm.etatcivilform.prenom.invalidmsg}}</p><p class=help-block role=alert ng-show=\"(vm.data.prenom == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div><div class=row><div class=col-sm-5 ng-if=\"!vm.data.isAffichageEtatCivilSimple && !vm.data.isAffichageEtatCivilMinimum\"><label class=\"label-form-cnaf control-label\" for=nir>Numéro de Sécurité sociale<cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-nir data-container=body data-trigger=manual tabindex=0></label><div class=hidden id=content-popover-nir><img alt=\"Le numéro de Sécurité sociale est la suite de 13 chiffres situés en bas de la carte vitale\" src=/cnafcomponentsteleprocappli/dist/img/Cvitale.png width=225px><div class=popover-btn-close-cnaf></div></div><div id=divNir class=form-group ng-class=\"{ 'has-error' : ((vm.etatcivilform.nir.$invalid && !vm.etatcivilform.nir.$pristine)\n" +
    "          || (vm.data.nir == undefined && vm.controle.submitted && vm.data.lieunaissance == 'FranceDOM')) }\"><input id=nir maxlength=42 ng-model=vm.data.nir ng-change=\"vm.data.nir = vm.data.nir.toUpperCase()\" name=nir class=form-control ui-mask=\"?9 ?9?9 ?9?9 ?9?* ?9?9?9 ?9?9?9 ?9?9\" ui-mask-placeholder-char=space><p tabindex=0 class=help-block ng-if=vm.etatcivilform.nir.$error.invalide>Votre saisie est incorrecte, merci de vérifier les données saisies</p><p tabindex=0 class=help-block ng-if=\"(vm.etatcivilform.nir.$error.obligatoire ||\n" +
    "            (vm.data.nir == undefined && vm.controle.submitted && vm.data.lieunaissance == 'FranceDOM'))\">Champ obligatoire</p></div></div><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateNaissance>Date de naissance</label><div id=divDateNaissance class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                    ((vm.etatcivilform.dateNaissance.$invalid\n" +
    "                    && !vm.etatcivilform.dateNaissance.$pristine)\n" +
    "                    || (vm.data.dateNaissance.length == 10 && vm.etatcivilform.dateNaissance.$error.pattern)\n" +
    "                    || vm.etatcivilform.dateNaissance.$error.controleDateNaissance\n" +
    "                    || vm.etatcivilform.dateNaissance.$error.controleDateNaissanceSpecifique\n" +
    "                    || vm.erroretatcivil\n" +
    "                    || vm.errordatenaissance\n" +
    "                    || (vm.data.dateNaissance == undefined && vm.controle.submitted))\n" +
    "                  }\"><div class=\"form-group input-group\"><input id=dateNaissance title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.dateNaissance class=form-control inputname=vm.data.dateNaissance ui-validate=\"{controleDateNaissanceSpecifique  : 'vm.controleDateNaissanceSpecifique($value, vm.today)', controleDateNaissance  : 'vm.controleDateNaissance($value, vm.today)'}\" ng-required=true name=dateNaissance pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.dateNaissance pattern-cnaf=dd/MM/yyyy inputname=dateNaissance></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"(vm.data.dateNaissance.length == 10) && vm.etatcivilform.dateNaissance.$error.pattern \">Format de date invalide</p><p class=help-block role=alert ng-show=vm.etatcivilform.dateNaissance.$error.controleDateNaissance>La date de naissance ne peut être postérieure au {{vm.today | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=vm.etatcivilform.dateNaissance.$error.controleDateNaissanceSpecifique>{{vm.libelleMessageDateNaissanceSpecifique}}</p><p class=help-block role=alert ng-show=\"((vm.data.dateNaissance == undefined || vm.data.dateNaissance == 'jj/mm/aaaa') && vm.controle.submitted)\">Champ obligatoire</p></div></div></div>")

$templateCache.put("components/cnaf-cct-etatcivil-enfant/cnaf-cct-etatcivil-date-arrivee.html","<div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateArrivee>Date d'arrivée au foyer</label><div id=divDateArrivee class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                ((vm.datearriveeform.dateArrivee.$invalid\n" +
    "                && !vm.datearriveeform.dateArrivee.$pristine)\n" +
    "                || (vm.data.dateArrivee.length == 10 && vm.datearriveeform.dateArrivee.$error.pattern)\n" +
    "                || vm.datearriveeform.dateArrivee.$error.controleDateArrivee\n" +
    "                || vm.datearriveeform.dateArrivee.$error.controleDateArriveeDateDuJour\n" +
    "                || vm.erroretatcivil\n" +
    "                || (vm.data.dateArrivee == undefined && vm.controle.submitted))\n" +
    "                }\"><div class=\"form-group input-group\"><input id=dateArrivee title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.dateArrivee class=form-control inputname=vm.data.dateArrivee ui-validate=\"{controleDateArrivee  : 'vm.controleDateArrivee($value, vm.data.dateNaissance)', controleDateArriveeDateDuJour  : 'vm.controleDateArriveeDateDuJour($value, vm.controle.today)'}\" ui-validate-watch=\"'vm.data.dateNaissance'\" ng-required=true name=dateArrivee pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.dateArrivee pattern-cnaf=dd/MM/yyyy inputname=dateArrivee></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"(vm.data.dateArrivee.length == 10) && vm.datearriveeform.dateArrivee.$error.pattern \">Format de date invalide</p><p class=help-block role=alert ng-show=vm.datearriveeform.dateArrivee.$error.controleDateArrivee>La date d’arrivée doit être postérieure à la date de naissance</p><p class=help-block role=alert ng-show=vm.datearriveeform.dateArrivee.$error.controleDateArriveeDateDuJour>La date d’arrivée ne peut pas être postérieure au {{vm.controle.today | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=\"((vm.data.dateArrivee == undefined || vm.data.dateArrivee == 'jj/mm/aaaa') && vm.controle.submitted)\">Champ obligatoire</p></div></div>")

$templateCache.put("components/cnaf-cct-etatcivil-enfant/cnaf-cct-etatcivil-enfant.html","<cnaf-calendar></cnaf-calendar><div class=row><div class=col-sm-6><fieldset><legend class=label-form-cnaf for=sexe>Sexe</legend><div class=row><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                            vm.etatcivilform.sexe.$invalid && !vm.etatcivilform.sexe.$pristine\n" +
    "                            || (vm.data.sexe == undefined && vm.controle.submitted)\n" +
    "                        }\"><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sexe uib-btn-radio=\"'Masculin'\" for=masculin><input type=radio name=sexe aria-label=masculin class=sr-only id=masculin ng-model=vm.data.sexe value=masculin required> <span aria-hidden=true>Masculin</span></label></div><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sexe uib-btn-radio=\"'Féminin'\" for=feminin><input type=radio name=sexe aria-label=feminin class=sr-only id=feminin ng-model=vm.data.sexe value=feminin required> <span aria-hidden=true>Féminin</span></label></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.sexe == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></fieldset></div></div><div class=row><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=nom>Nom de famille<cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-nom data-container=body data-trigger=manual tabindex=0></label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                        (vm.etatcivilform.nom.$invalid && !vm.etatcivilform.nom.$pristine)\n" +
    "                        || vm.etatcivilform.nom.$error.type3\n" +
    "                        || vm.errorsituation\n" +
    "                        || (vm.data.nom == undefined && vm.controle.submitted)\n" +
    "                            }\"><div class=hidden id=content-popover-nom><div class=popover-btn-close-cnaf></div>Il s'agit du nom de naissance de la personne<br></div><input id=nom maxlength=63 ng-model=vm.data.nom ng-change=\"vm.data.nom = vm.data.nom.toUpperCase()\" ng-pattern=\"/^[a-zA-Zà-ÿÀ-Ÿ '-]*$/\" ng-blur=\"vm.testType3(vm.data.nom,vm.etatcivilform.nom,'nom')\" ng-trim=false name=nom class=form-control required><p class=help-block role=alert ng-show=\"vm.etatcivilform.nom.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.etatcivilform.nom.$error.type3>{{vm.etatcivilform.nom.invalidmsg}}</p><p class=help-block role=alert ng-show=\"(vm.data.nom == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=prenom>Prénom</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                    (vm.etatcivilform.prenom.$invalid && !vm.etatcivilform.prenom.$pristine)\n" +
    "                        || vm.etatcivilform.prenom.$error.type13\n" +
    "                        || vm.errorsituation\n" +
    "                        || (vm.data.prenom == undefined && vm.controle.submitted)\n" +
    "                    }\"><input id=prenom maxlength=32 ng-model=vm.data.prenom ng-change=\"vm.data.prenom = vm.data.prenom.toUpperCase()\" ng-pattern=\"/^[a-zA-Zà-ÿÀ-Ÿ '-]*$/\" ng-blur=vm.testType13(vm.data.prenom,vm.etatcivilform.prenom) ng-trim=false name=prenom class=form-control required><p class=help-block role=alert ng-show=\"vm.etatcivilform.prenom.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.etatcivilform.prenom.$error.type13>{{vm.etatcivilform.prenom.invalidmsg}}</p><p class=help-block role=alert ng-show=\"(vm.data.prenom == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div><div class=row><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateNaissance>Date de naissance</label><div id=divDateNaissance class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                        ((vm.etatcivilform.dateNaissance.$invalid\n" +
    "                        && !vm.etatcivilform.dateNaissance.$pristine)\n" +
    "                        || (vm.data.dateNaissance.length == 10 && vm.etatcivilform.dateNaissance.$error.pattern)\n" +
    "                        || vm.etatcivilform.dateNaissance.$error.controleDateNaissance\n" +
    "                        || vm.etatcivilform.dateNaissance.$error.controleDateNaissanceInf1880\n" +
    "                        || vm.errorsituation\n" +
    "                        || (vm.data.dateNaissance == undefined && vm.controle.submitted))\n" +
    "                        }\"><div class=\"form-group input-group\"><input id=dateNaissance title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.dateNaissance class=form-control inputname=vm.data.dateNaissance ui-validate=\"{controleDateNaissance  : 'vm.controleDateNaissance($value, vm.controle.today)', controleDateNaissanceInf1880 : 'vm.controleDateNaissanceInf1880($value)'}\" ui-validate-watch=\"'vm.data.dateArrivee'\" ng-required=true name=dateNaissance pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.dateNaissance pattern-cnaf=dd/MM/yyyy inputname=dateNaissance></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"(vm.data.dateNaissance.length == 10) && vm.etatcivilform.dateNaissance.$error.pattern \">Format de date invalide</p><p class=help-block role=alert ng-show=vm.etatcivilform.dateNaissance.$error.controleDateNaissanceInf1880>Date de naissance incorrecte</p><p class=help-block role=alert ng-show=vm.etatcivilform.dateNaissance.$error.controleDateNaissance>La date de naissance ne peut être postérieure au {{vm.controle.today | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=\"((vm.data.dateNaissance == undefined || vm.data.dateNaissance == 'jj/mm/aaaa') && vm.controle.submitted)\">Champ obligatoire</p></div></div><cnaf-cct-etatcivil-date-arrivee data=vm.data datearriveeform=vm.etatcivilform controle=vm.controle></cnaf-cct-etatcivil-date-arrivee></div>")

$templateCache.put("components/cnaf-cct-etatcivil-enfant/cnaf-cct-etatcivil-nir.html","<div class=row><div class=col-sm-5><label class=\"label-form-cnaf control-label\" for=nir>Numéro de Sécurité sociale<cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-nir data-container=body data-trigger=manual tabindex=0></label><div class=hidden id=content-popover-nir><img alt=\"Le numéro de Sécurité sociale est la suite de 13 chiffres situés en bas de la carte vitale\" src=/cnafcomponentsteleprocappli/dist/img/Cvitale.png width=225px><div class=popover-btn-close-cnaf></div></div><div id=divNir class=form-group ng-class=\"{ 'has-error' : vm.nirform.nir.$invalid && !vm.nirform.nir.$pristine }\"><input id=nir maxlength=42 ng-model=vm.data.nir ng-change=\"vm.data.nir = vm.data.nir.toUpperCase()\" name=nir class=form-control ui-mask=\"?9 ?9?9 ?9?9 ?9?* ?9?9?9 ?9?9?9 ?9?9\" ui-mask-placeholder-char=space><p tabindex=0 class=help-block ng-if=vm.nirform.nir.$error.invalide>Votre saisie est incorrecte, merci de vérifier les données saisies</p><p tabindex=0 class=help-block ng-if=vm.nirform.nir.$error.obligatoire>Champs obligatoires</p></div></div></div>")

$templateCache.put("components/cnaf-cct-gestion-pdfs-fin/cnaf-cct-gestion-pdfs-fin.html","<div id=fin ng-switch on=vm.etat><cnaf-error ng-switch-when=error></cnaf-error><div ng-switch-when=loaded ng-init=vm.init() ng-if=vm.infosrecapfin><div class=\"row bloc-fin\" ng-hide=vm.infosrecapfin.hideStepSeparator><hr></div><div class=\"row cct-pageFin\" cnaf-focus=focusPage tabindex=-1><h3 class=\"col-sm-12 collapsable-heading-cnaf titre-bloc-cnaf saisie text-primary\" ng-bind-html=vm.trustAsHtml(vm.infosrecapfin.titre)></h3></div><div class=cct-pageFin ng-repeat=\"messAvert in vm.infosrecapfin.listeMessAvert track by $index\"><div class=\"row cct-pageFin-blocMessAvert\" style=padding-bottom:0px><div class=\"col-xs-2 col-sm-1 col-md-1\"><img src=/icfstatiquesangularappli/dist/images/Alertes.png style=\"width:25px; height:25px\" alt=\"\"></div><p class=\"col-xs-10 col-sm-11 col-md-11 cct-pageFin-coteBloc\" ng-bind-html=vm.trustAsHtml(messAvert.mess)></p></div></div><div class=cct-pageFin ng-repeat=\"messReassur in vm.infosrecapfin.listeMessReassur track by $index\"><div class=\"row cct-pageFin-blocMessReassur\" style=padding-bottom:0px><p class=\"col-sm-12 cct-pageFin-coteBloc\">{{messReassur.mess}} <a ng-if=messReassur.libellelien aria-label={{messReassur.libellelien}} ng-href=\"/redirect/s/Redirect?page=monCompteFormulaires\">{{messReassur.libellelien}}</a><br></p></div></div><div ng-if=\"vm.infosrecapfin.listePjsAllModules.length > 0\"><div class=\"row cct-pageFin\"><div class=\"col-xs-2 col-sm-1 col-md-1\"><img src=/icfstatiquesangularappli/dist/images/usager/PicTP-docjoint.png style=max-width:40px;max-height:40px alt=\"pictogramme docjoint\"></div><p class=\"texte-bold col-xs-10 col-sm-11 col-md-11 cct-titre-rubrique-pageFin\">Pour traiter votre demande, vous devez nous fournir les documents suivants&nbsp;:</p></div><div class=\"row cct-pageFin\" ng-repeat=\"listPjsPersonne in vm.infosrecapfin.listePjsAllModules\"><div class=\"col-xs-12 col-sm-offset-1 col-sm-10 col-md-offset-1 col-md-10\"><ul class=liste-a-puces><li ng-repeat=\"personne in listPjsPersonne\"><span class=texte-bold>Pour {{personne.prenomPersonne}} {{personne.nomPersonne}}&nbsp;:</span><ul class=liste-sans-marker><li ng-repeat=\"pjAJoindre in personne.piecesAJoindreList\"><span style=\"text-decoration: underline\">{{pjAJoindre.libelle}}</span><ul class=liste-a-tiret ng-repeat=\"pjComplexe in pjAJoindre.pieceJustificativeComplexeList\"><li ng-repeat=\"pjSimple in pjComplexe.pieceJustificativeSimpleList\"><span>{{pjSimple.libelle}}</span><div class=innerLienLogiquePJ ng-if=!$last>{{pjComplexe.type}}</div></li><div class=outerLienLogiquePJ ng-if=!$last>{{pjAJoindre.type}}</div></ul><br></li></ul></li></ul></div></div><div class=\"row cct-pageFin\"><div class=\"col-xs-12 col-sm-offset-1 col-sm-10 col-md-offset-1 col-md-10\"><p ng-if=vm.libelleDemarche>Dès que votre {{vm.libelleDemarche}} sera validée, vous pourrez joindre les documents dans la rubrique \"Suivre mes démarches\" ou par courrier à l’adresse postale de votre Caf.</p><p ng-if=!vm.libelleDemarche>Vous pouvez les joindre dans l’Espace Mon Compte, rubrique Suivre mes démarches ou par courrier à l’adresse postale de votre Caf.</p><a ng-if=!vm.libelleDemarche role=button ng-href={{vm.lienVersMonCompteMesDemarches}} title=\"Joindre les documents\"><button type=button id=btn-joindreDocument title=\"Joindre les documents\" alt=\"Joindre les documents\" name=BtnJoindreDocument value=\"Joindre le(s) document(s)\" class=\"btn btn-form-cnaf btn-secondaire-cnaf\" style=\"pointer-events: all; cursor: pointer\"><div class=row style=padding-top:3px><div class=\"col-xs-2 col-sm-2 col-md-1\"><img src=/icfstatiquesangularappli/dist/images/usager/PicTP-docjoint.png style=max-width:40px;max-height:40px alt=\"Joindre docs\"></div><div class=\"hidden-xs col-sm-1 col-md-1\"></div><p class=\"col-xs-10 col-sm-9 col-md-11 cct-titre-bouton-pageFin\">Joindre le(s) document(s)</p></div></button></a></div></div></div><div ng-if=\"(!vm.isDemandePrestation || vm.forceBoutonRetourMonCompteSeparation) && vm.infosrecapfin.listePdfs.length > 0\"><div class=\"row cct-pageFin\"><div class=\"col-xs-2 col-sm-1 col-md-1\"><img src=/icfstatiquesangularappli/dist/images/usager/pic-pres-telep.png style=max-width:40px;max-height:40px alt=\"\"></div><p class=\"texte-bold col-xs-10 col-sm-11 col-md-11 cct-titre-rubrique-pageFin\">Vous pouvez télécharger dès maintenant&nbsp;:</p><ul class=\"liste-a-puces col-xs-12 col-sm-offset-1 col-sm-10 col-md-offset-1 col-md-10 col-lg-offset-1 col-lg-10\"><li ng-repeat=\"pdf in vm.infosrecapfin.listePdfs track by $index\"><span>{{pdf.libelle}}&nbsp;:</span> <a href=javascript:void(0); style=\"padding-left:25px; display: inline-block\" cnaf-telechargement-pdf noreplace aria-label=\"Télécharger le récapitulatif de votre déclaration\" title=\"{{pdf.nomPdf}} (nouvelle fenêtre - fichier PDF d'environ 250Ko)\" pdf-promise=\"vm.getNDWeb(vm.infosrecapfin.codeOrga, pdf.identifiantNDWEB)\" on-success=vm.pdfOnSuccess() on-error=vm.pdfOnError()><span class=text-primary>{{pdf.nomPdf}}</span> <img src=/icfstatiquesangularappli/dist/images/pic-docPDF.png style=padding-left:10px alt=\"\"></a></li></ul><p ng-if=vm.isRoleResponsableDossier class=\"col-xs-12 col-sm-offset-1 col-sm-11 col-md-offset-1 col-md-11\">ou le faire plus tard dans l’Espace Mon Compte, rubrique Suivre mes démarches.</p></div></div><div ng-if=vm.afficheBlocLeSaviezVous()><div class=\"row bloc-fin\"><hr></div><div class=\"row cct-pageFin\"><h4 class=\"col-sm-12 collapsable-heading-cnaf titre-bloc-cnaf text-primary\">Le saviez-vous ?</h4><p class=col-sm-12 style=padding-top:12px ng-repeat=\"lienPdf in vm.infosrecapfin.listeLiensPdf track by $index\">{{lienPdf.libavant}} <a href=javascript:void(0); cnaf-telechargement-pdf pdf-promise=\"vm.pdfPromise(lienPdf.prestation, vm.infosrecapfin.codeSituationDossier)\" on-success=\"vm.pdfOnSuccess(lienPdf.prestation, data)\" on-error=\"vm.pdfOnError(lienPdf.prestation, error)\" noreplace title={{lienPdf.titre}}>{{lienPdf.libellelien}}</a></p><p class=col-sm-12 style=padding-top:12px ng-repeat=\"lien in vm.infosrecapfin.listeLiens track by $index\"><strong ng-if=lien.libtitre>{{lien.libtitre}}</strong>{{lien.libavant}} <a ng-href={{lien.href}} title={{lien.titre}} target=_blank>{{lien.libellelien}}</a>{{lien.libapres}}</p></div></div></div><div><div class=\"row cct-pageFin\" ng-if=\"!vm.isDemandePrestation \n" +
    "                                            || vm.isRoleResponsableDossier \n" +
    "                                            || vm.isPrimoSuiteSeparation\"><div class=\"row bloc-fin\" ng-if=!(vm.afficheBlocLeSaviezVous())><hr></div><h4 class=\"col-sm-12 collapsable-heading-cnaf titre-bloc-cnaf text-primary\">Des questions ?</h4><p class=col-sm-12 ng-if=\"vm.isDemandePrestation && vm.isRoleResponsableDossier\">Vous pouvez télécharger vos récapitulatifs dans l'Espace Mon Compte, rubrique Suivre mes démarches.</p><p class=col-sm-12 ng-if=\"!vm.isDemandePrestation && vm.isRoleResponsableDossier\">Vous pouvez suivre le traitement de votre démarche dans l’Espace Mon Compte, rubrique Suivre mes démarches.<br>Pour toute question, vous pouvez contacter votre Caf par <a aria-label=\"Contacter votre Caf par courriel\" ng-href={{vm.lienVersContacterMaCaf}}>mail</a> ou par <a aria-label=\"Contacter votre Caf par téléphone\" ng-href={{vm.lienVersContacterMaCaf}}>téléphone</a>.</p><p class=col-sm-12 ng-if=\"(!vm.isDemandePrestation || vm.isPrimoSuiteSeparation) \n" +
    "                                                && !vm.isRoleResponsableDossier\">Pour toute question, vous pouvez contacter votre Caf par <a aria-label=\"Contacter votre Caf par courriel\" ng-href={{vm.lienVersContacterMaCaf}}>mail</a> ou par <a aria-label=\"Contacter votre Caf par téléphone\" ng-href={{vm.lienVersContacterMaCaf}}>téléphone</a>.</p></div></div><div ng-if=\"!vm.isDemandePrestation || vm.forceBoutonRetourMonCompteSeparation\"><div class=\"row bloc-fin\"><hr></div><div class=\"row cct-pageFin\"><div style=background-color:#ECEFF5;padding-left:10px><div class=row><label for=boutonOUPS class=\"col-xs-10 col-sm-11\"><h4 class=text-primary>Vous pensez avoir fait une erreur&nbsp;?</h4></label><div class=\"col-xs-2 col-sm-1\"><button id=boutonOUPS class=btn title={{vm.titleOupsButtonCollapsable()}} ng-click=vm.toggleOupsCollapse() style=\"border:none; background-color:inherit; width:100%\" aria-expanded={{!vm.oupsCollapsed}} aria-controls=oups-collapse-inside><img alt={{vm.titleOupsButtonCollapsable()}} ng-src={{vm.imgSrcOupsButtonCollapsable()}}></button></div></div><div class=row><p class=col-sm-12>Vous pouvez à tout moment informer la Caf que vous vous êtes trompé dans une déclaration ou que vous avez oublié de déclarer une information. Cela s’appelle le droit à l’erreur.</p><div id=oups-collapse-inside class=col-sm-12 ng-show=!vm.oupsCollapsed aria-hidden={{vm.oupsCollapsed}}><p ng-show=!vm.isPrimoSuiteSeparation>Pour le faire valoir, informez la Caf le plus rapidement possible.</p><ul ng-show=!vm.isPrimoSuiteSeparation><li>Si votre erreur concerne vos coordonnées de contact, votre adresse ou vos coordonnées bancaires, déclarez au plus vite votre rectification > caf.fr > Espace Mon Compte > <a aria-label=\"Déclarer un changement en revenant sur Mon Compte\" ng-href={{vm.lienVersMonCompteMonProfil}}>Déclarer un changement</a></li><li>Pour toutes autres erreurs, contacter votre Caf > caf.fr > Espace Mon Compte > Contacter ma Caf > <a aria-label=\"Informer d'une erreur ma Caf par courriel\" ng-href={{vm.lienVersContacterMaCaf}}>Par courriel</a></li></ul><p ng-show=vm.isPrimoSuiteSeparation>Pour le faire valoir, informez la Caf le plus rapidement possible, contacter votre Caf > caf.fr > Espace Mon Compte > Contacter ma Caf > <a aria-label=\"Informer d'une erreur ma Caf par courriel\" ng-href={{vm.lienVersContacterMaCaf}}>Par courriel</a></p><p>Attention, vous devrez quand même rembourser la Caf si vous avez perçu des aides en trop car vous êtes responsable des déclarations faites à la Caf.<br>Le droit à l’erreur permet, en revanche, de ne pas être sanctionné(e) pour fraude à condition que votre erreur soit involontaire.<br>Si votre Caf démontre que vous avez fait une fausse déclaration volontairement, c’est une fraude et vous pouvez être sanctionné (dépôt de plainte, sanctions financières).</p></div></div></div></div></div><div ng-if=\"vm.demarcheiconique && vm.demarcheiconique.lienVersMonAvisNumerique\"><div class=\"row bloc-fin\"><hr></div><div class=\"row cct-pageFin\"><h4 class=\"col-sm-12 collapsable-heading-cnaf titre-bloc-cnaf text-primary\">Votre avis compte&nbsp;!</h4><p class=col-sm-12>Pour nous aider à améliorer nos services, prenez 2 minutes pour raconter votre expérience sur&nbsp;cette&nbsp;démarche.</p><div class=col-sm-12><a ng-href={{vm.demarcheiconique.lienVersMonAvisNumerique}} title={{vm.demarcheiconique.titleDuLien}}><img alt=\"Je donne mon avis\" src=/icfstatiquesangularappli/dist/images/mon-avis.png></a></div></div></div><div><div class=\"row cct-pageFin\"><button type=submit ng-if=!vm.redirectmoncomptemobile ng-click=vm.revenirAMonProfil() title={{vm.titreduBoutonRevenirAMonProfil}} name=BRevenirAMonProfil value={{vm.texteduBoutonRevenirAMonProfil}} class=\"btn btn-majeur-cnaf col-xs-12\" style=min-height:46px ng-class=\"{\n" +
    "                                'col-sm-offset-7 col-sm-5\n" +
    "                                 col-md-offset-8 col-md-4\n" +
    "                                 col-lg-offset-8 col-lg-4' : !vm.isDemandePrestation,\n" +
    "                                'col-sm-offset-8 col-sm-4\n" +
    "                                 col-md-offset-9 col-md-3\n" +
    "                                 col-lg-offset-9 col-lg-3' : vm.isDemandePrestation\n" +
    "                                            }\"><img alt=\"Pictogramme retour à Mon Profil\" ng-if=!vm.isDemandePrestation src=/icfstatiquesangularappli/dist/images/pic_monC_head-sans.png style=width:40px;max-height:40px class=hidden-xs> {{vm.texteduBoutonRevenirAMonProfil}}</button> <button type=submit ng-if=\"vm.redirectmoncomptemobile && vm.isRoleResponsableDossier && !vm.isDemandePrestation\" cnaf-cct-modal-telepro-fin href={{vm.lienduBoutonRevenirAMonProfil}} typechangement={{vm.typechangement}} title={{vm.titreduBoutonRevenirAMonProfil}} name=BRevenirAMonProfil class=\"btn btn-majeur-cnaf col-xs-12 col-sm-offset-7 col-sm-5 col-md-offset-8 col-md-4 col-lg-offset-8 col-lg-4\">{{vm.texteduBoutonRevenirAMonProfil}}</button> <button type=submit ng-if=\"vm.redirectmoncomptemobile && vm.isRoleResponsableDossier && vm.isDemandePrestation\" ng-click=vm.revenirAMonProfil() title={{vm.titreduBoutonRevenirAMonProfil}} name=BRevenirAMonProfil class=\"btn btn-majeur-cnaf col-xs-12 col-sm-offset-7 col-sm-5 col-md-offset-8 col-md-4 col-lg-offset-8 col-lg-4\">{{vm.texteduBoutonRevenirAMonProfil}}</button> <button type=submit ng-if=\"vm.redirectmoncomptemobile && !vm.isRoleResponsableDossier\" ng-click=vm.revenirAMonProfil() title={{vm.titreduBoutonRevenirAMonProfil}} name=BRevenirAMonProfil class=\"btn btn-majeur-cnaf col-xs-12 col-sm-offset-7 col-sm-5 col-md-offset-8 col-md-4 col-lg-offset-8 col-lg-4\">{{vm.texteduBoutonRevenirAMonProfil}}</button></div></div></div>")

$templateCache.put("components/cnaf-cct-grossesse/cnaf-cct-grossesse.html","<cnaf-calendar></cnaf-calendar><div class=row><div class=col-sm-4><label class=label-form-cnaf for=dateDebutGrossesse>Date de début de grossesse</label><div id=divDateDebutGrossesse class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                    (vm.grossesseform.dateDebutGrossesse.$invalid\n" +
    "                    && !vm.grossesseform.dateDebutGrossesse.$pristine)\n" +
    "                    || (vm.grossesseform.dateDebutGrossesse.$error.pattern)\n" +
    "                    || (!vm.grossesseform.dateDebutGrossesse.$error.dateDebGroSuperieurExamPre\n" +
    "                        && vm.grossesseform.dateDebutGrossesse.$error.controleDateDebGro)\n" +
    "                        || vm.grossesseform.dateDebutGrossesse.$error.controleDateDernierEnfant\n" +
    "                    || (vm.grossesseform.dateDebutGrossesse.$error.dateDebGroSuperieurExamPre\n" +
    "                        && !vm.grossesseform.dateExamPreNat.$error.dateDebGroSuperieurExamPre)\n" +
    "                    || (vm.data.dateDebutGrossesse == undefined && vm.controle.submitted)\n" +
    "                   }\"><div class=\"form-group input-group\"><input id=dateDebutGrossesse title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.dateDebutGrossesse class=form-control ui-validate=\"{controleDateDebGro  : 'vm.controleDateDebGro($value, vm.today)',\n" +
    "                            dateDebGroSuperieurExamPre  : 'vm.controleExamPreNatalDateSuperieur(vm.data.dateExamPreNat, $value)',\n" +
    "                            controleDateDernierEnfant : 'vm.controleDateDernierEnfant($value, vm.data.datNaissDernierEnfant)'}\" ui-validate-watch=\"'vm.data.dateExamPreNat'\" ng-required=true name=dateDebutGrossesse pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.dateDebutGrossesse start-year=2000 pattern-cnaf=dd/MM/yyyy inputname=dateDebutGrossesse></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"(vm.data.dateDebutGrossesse.length == 10 && vm.grossesseform.dateDebutGrossesse.$error.pattern)\">Format de date invalide</p><p class=help-block role=alert ng-show=\"((vm.data.dateDebutGrossesse == undefined  || vm.data.dateDebutGrossesse == 'jj/mm/aaaa') && vm.controle.submitted)\">Champ obligatoire</p><p class=help-block role=alert ng-show=\"(!vm.grossesseform.dateDebutGrossesse.$error.dateDebGroSuperieurExamPre\n" +
    "                && vm.grossesseform.dateDebutGrossesse.$error.controleDateDebGro)\n" +
    "                || vm.grossesseform.dateDebutGrossesse.$error.controleDateDernierEnfant\">Vérifier la date de début de grossesse</p><p class=help-block role=alert ng-show=\"\n" +
    "              vm.grossesseform.dateDebutGrossesse.$error.dateDebGroSuperieurExamPre\n" +
    "               && !vm.grossesseform.dateExamPreNat.$error.dateDebGroSuperieurExamPre\">Vérifier la date de début de grossesse<br>ou la date de l’examen prénatal</p></div></div><div class=col-sm-4><label class=label-form-cnaf for=dateExamPreNat>Date du 1er examen prénatal</label><div id=divDateExamPreNat class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                  (vm.grossesseform.dateExamPreNat.$invalid\n" +
    "                  && !vm.grossesseform.dateExamPreNat.$pristine)\n" +
    "                  || (vm.grossesseform.dateExamPreNat.$error.pattern)\n" +
    "                  || (vm.grossesseform.dateExamPreNat.$error.dateDebGroSuperieurExamPre\n" +
    "                  && !vm.grossesseform.dateDebutGrossesse.$error.dateDebGroSuperieurExamPre)\n" +
    "                  || (vm.grossesseform.dateExamPreNat.$error.dateExamPreSupDateDuJour\n" +
    "                  && !vm.grossesseform.dateExamPreNat.$error.dateDebGroSuperieurExamPre)\n" +
    "                  || (vm.data.dateExamPreNat == undefined && vm.controle.submitted)\n" +
    "                }\"><div class=\"form-group input-group\"><input title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.dateExamPreNat class=form-control ui-validate=\"{dateDebGroSuperieurExamPre  : 'vm.controleExamPreNatalDateSuperieur($value, vm.data.dateDebutGrossesse)',\n" +
    "                            dateExamPreSupDateDuJour : 'vm.controleDateExamPreNat($value, vm.today)'}\" ui-validate-watch=\"'vm.data.dateDebutGrossesse'\" ng-required=true name=dateExamPreNat id=dateExamPreNat pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.dateExamPreNat start-year=2000 pattern-cnaf=dd/MM/yyyy inputname=dateExamPreNat></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"(vm.data.dateExamPreNat.length == 10 && vm.grossesseform.dateExamPreNat.$error.pattern)\">Format de date invalide</p><p class=help-block role=alert ng-show=\"((vm.data.dateExamPreNat == undefined  || vm.data.dateExamPreNat == 'jj/mm/aaaa') && vm.controle.submitted)\">Champ obligatoire</p><p class=help-block role=alert ng-show=\"\n" +
    "              (vm.grossesseform.dateExamPreNat.$error.dateDebGroSuperieurExamPre\n" +
    "              && !vm.grossesseform.dateDebutGrossesse.$error.dateDebGroSuperieurExamPre)\">Vérifier la date de début de grossesse<br>ou la date de l’examen prénatal</p><p class=help-block role=alert ng-show=\"\n" +
    "              vm.grossesseform.dateExamPreNat.$error.dateExamPreSupDateDuJour\n" +
    "              && !vm.grossesseform.dateExamPreNat.$error.dateDebGroSuperieurExamPre\">Vérifier la date de l’examen prénatal</p></div></div><div class=col-sm-4><div class=row><div class=\"col-sm-12 form-group\"><fieldset><legend class=label-form-cnaf for=nbEnfConcus>Nombre d'enfants conçus</legend><div class=\"form-group input-group\"><button type=button class=\"btn btn-majeur-cnaf pull-left\" alt=\"Réduire le nombre d'enfants conçus\" ng-click=vm.btnMoins()>-</button> <input class=\"form-control btn-plus\" id=nbEnfConcus ng-model=vm.data.nbEnf readonly name=nbEnf aria-live=polite> <button type=button class=\"btn btn-majeur-cnaf\" alt=\"Augmenter le nombre d'enfants conçus\" ng-click=vm.btnPlus()>+</button></div></fieldset></div></div></div></div><br><div class=row><div class=col-sm-12><h4 class=\"collapsable-heading-cnaf titre-bloc-cnaf saisie\">Coordonnées du médecin ou de la sage-femme ayant effectué l'examen prénatal</h4></div></div><div class=row><div class=col-sm-4 ng-class=\"{ 'has-error' :\n" +
    "                vm.grossesseform.nomMedecin.$invalid\n" +
    "                && !vm.grossesseform.nomMedecin.$pristine\n" +
    "                || vm.grossesseform.nomMedecin.$error.pattern\n" +
    "                || vm.grossesseform.nomMedecin.$error.type8\n" +
    "                || (vm.data.nomMedecin == undefined && vm.controle.submitted)\n" +
    "              }\"><label class=label-form-cnaf for=nomMedecin>Nom</label><input id=nomMedecin ng-model=vm.data.nomMedecin ng-pattern=\"/^[a-zA-Z0-9áàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ'\\s-]{1,50}$/\" ng-blur=vm.testType8(vm.data.nomMedecin,vm.grossesseform.nomMedecin) name=nomMedecin class=form-control maxlength=50 required><p class=help-block role=alert ng-show=\"vm.grossesseform.nomMedecin.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.grossesseform.nomMedecin.$error.type8>{{vm.grossesseform.nomMedecin.invalidmsg}}</p><p class=help-block role=alert ng-show=\"(vm.data.nomMedecin == undefined && vm.controle.submitted)\">Champ obligatoire</p></div><div class=col-sm-4 ng-class=\"{ 'has-error' :\n" +
    "          (vm.grossesseform.telephoneMedecin.$invalid && !vm.grossesseform.telephoneMedecin.$pristine)\n" +
    "          || vm.grossesseform.telephoneMedecin.$error.type2\n" +
    "          || (vm.data.telephoneMedecin == undefined && vm.controle.submitted)\n" +
    "        }\"><label class=label-form-cnaf for=telephoneMedecin>Téléphone</label><input id=telephoneMedecin ng-model=vm.data.telephoneMedecin maxlength=15 name=telephoneMedecin class=form-control ui-mask=\"99 99 99 99 99\" ui-mask-placeholder-char=space ui-options=\"{clearOnBlur:false, allowInvalidValue:true}\" ng-blur=\"vm.testType2(vm.data.telephoneMedecin,vm.grossesseform.telephoneMedecin,'telephoneMedecin')\" required><p class=help-block role=alert ng-show=\"vm.grossesseform.telephoneMedecin.$error.pattern \">Le numéro de téléphone est incorrect</p><p class=help-block role=alert ng-show=vm.grossesseform.telephoneMedecin.$error.type2>{{vm.grossesseform.telephoneMedecin.invalidmsg}}</p><p class=help-block role=alert ng-show=\"(vm.data.telephoneMedecin == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div>")

$templateCache.put("components/cnaf-cct-hospitalisation/cnaf-cct-hospitalisation.html","<cnaf-calendar></cnaf-calendar><div class=row ng-init=vm.init()><div class=col-sm-4><fieldset><div ng-if=vm.controle.conjoint><legend class=label-form-cnaf for=hospitalisation>Votre conjoint est hospitalisé</legend></div><div ng-if=!vm.controle.conjoint><legend class=label-form-cnaf for=hospitalisation>Vous êtes hospitalisé</legend></div><div class=row><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                        vm.hospitalisationform.hospitalisation.$invalid && !vm.hospitalisationform.hospitalisation.$pristine\n" +
    "                        || (vm.data.hospitalisation == undefined && vm.controle.submitted)\n" +
    "                    }\"><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.hospitalisation uib-btn-radio=\"'Oui'\" for=hospitalisationOui><input type=radio name=hospitalisation aria-label=Oui class=sr-only id=hospitalisationOui ng-model=vm.data.hospitalisation value=oui required> <span aria-hidden=true>Oui</span></label></div><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.hospitalisation uib-btn-radio=\"'Non'\" for=hospitalisationNon><input type=radio name=hospitalisation aria-label=non class=sr-only id=hospitalisationNon ng-model=vm.data.hospitalisation value=non required> <span aria-hidden=true>Non</span></label></div><p class=help-block role=alert ng-show=\"(vm.data.hospitalisation == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></fieldset></div></div><div ng-if=\"vm.data.hospitalisation == 'Oui'\"><div class=row><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateDebHosp>Date de début d'hospitalisation</label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                           vm.hospitalisationform.dateDebHosp.$invalid\n" +
    "                           && !vm.hospitalisationform.dateDebHosp.$pristine\n" +
    "                           || vm.hospitalisationform.dateDebHosp.$error.pattern\n" +
    "                           || (vm.data.dateDebHosp == undefined && vm.controle.submitted)\n" +
    "                         }\"><div class=\"form-group input-group\" id=divDateDebHosp><input id=dateDebHosp name=dateDebHosp value={{dateDebHosp}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.dateDebHosp class=form-control ui-validate=\"{controleSupDateOd  : 'vm.controleSupDateOd($value, vm.controle.dernjourodal)', controleDtDemarche : 'vm.controleDateDemarcheDateHosp($value)'\n" +
    "                                            }\" ng-required=true pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.dateDebHosp start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateDebHosp></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"vm.hospitalisationform.dateDebHosp.$error.pattern && vm.data.dateDebHosp.length == 10\">Format de date invalide</p><p class=help-block role=alert ng-show=vm.hospitalisationform.dateDebHosp.$error.controleSupDateOd>La date saisie ne peut être postérieure à la date du {{vm.controle.dernjourodal | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=vm.hospitalisationform.dateDebHosp.$error.controleDtDemarche>La date saisie ne peut être postérieure à la date du {{vm.dernierJourMoisSuivant | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=\"((vm.data.dateDebHosp == undefined || vm.data.dateDebHosp =='jj/mm/aaaa') && vm.controle.submitted)\">Champ obligatoire</p></div></div><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateFinHosp>Date de fin d'hospitalisation</label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                           vm.hospitalisationform.dateFinHosp.$invalid\n" +
    "                           && !vm.hospitalisationform.dateFinHosp.$pristine\n" +
    "                           || vm.hospitalisationform.dateFinHosp.$error.pattern\n" +
    "                         }\"><div class=\"form-group input-group\" id=divDateFinHosp><input id=dateFinHosp name=dateFinHosp value={{dateFinHosp}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.dateFinHosp class=form-control ui-validate=\"{controleSupDateDeb  : 'vm.controleSupDateDeb($value, vm.data.dateDebHosp)'\n" +
    "                                   }\" ui-validate-watch=\"'vm.data.dateDebHosp'\" pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.dateFinHosp start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateFinHosp></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"vm.hospitalisationform.dateFinHosp.$error.pattern && vm.data.dateFinHosp.length == 10\">Format de date invalide</p><p class=help-block role=alert ng-show=vm.hospitalisationform.dateFinHosp.$error.controleSupDateDeb>La date de fin doit être postérieure à la date de début</p></div></div></div><div class=row><div class=col-sm-6><label class=label-form-cnaf for=nomEtabHosp>Nom de l'établissement</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                   (vm.hospitalisationform.nomEtabHosp.$invalid && !vm.hospitalisationform.nomEtabHosp.$pristine)\n" +
    "                     || vm.hospitalisationform.nomEtabHosp.$error.type8\n" +
    "                     || (vm.data.nomEtabHosp == undefined && vm.controle.submitted)\n" +
    "                     }\"><input id=nomEtabHosp maxlength=30 ng-model=vm.data.nomEtabHosp ng-change=\"vm.data.nomEtabHosp = vm.data.nomEtabHosp.toUpperCase()\" ng-pattern=\"/^[0-9a-zA-Zà-ÿÀ-Ÿ '-]*$/\" ng-blur=\"vm.testType8(vm.data.nomEtabHosp,vm.hospitalisationform,'nomEtabHosp')\" ng-trim=false name=nomEtabHosp class=form-control required><p class=help-block role=alert ng-show=\"vm.hospitalisationform.nomEtabHosp.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.hospitalisationform.nomEtabHosp.$error.type8>{{vm.hospitalisationform.nomEtabHosp.invalidmsg}}</p><p class=help-block role=alert ng-show=\"(vm.data.nomEtabHosp == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div><div class=col-sm-6><label class=label-form-cnaf for=paysEtabHosp>Pays de l'établissement</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                   (vm.hospitalisationform.paysEtabHosp.$invalid && !vm.hospitalisationform.paysEtabHosp.$pristine)\n" +
    "                   || (vm.data.paysEtabHosp == undefined && vm.controle.submitted)\n" +
    "                     }\"><input id=paysEtabHosp ng-model=vm.data.paysEtabHosp name=paysEtabHosp class=form-control typeahead-min-length=2 uib-typeahead=\"pays as pays.libelleCaffr for pays in vm.getListePaysEtabHospProposes($viewValue) | filter:$viewValue | limitTo:8\" typeahead-editable=false typeahead-no-results=noPaysFound required><p class=help-block role=alert ng-show=noPaysFound>Pays non trouvé</p><p class=help-block role=alert ng-show=\"(vm.data.paysEtabHosp == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div><div class=row ng-if=vm.afficheCodePostalVille()><div class=col-sm-6><label class=label-form-cnaf for=codePostalVilleEtabHosp>Code postal / Commune de l'établissement</label><div ng-switch on=vm.autocompletion><div ng-switch-when=on class=form-group ng-class=\"{ 'has-error' :\n" +
    "                          (vm.hospitalisationform.codePostalVilleEtabHosp.$invalid && !vm.hospitalisationform.codePostalVilleEtabHosp.$pristine)\n" +
    "                          || (vm.data.codePostalVilleEtabHosp == undefined && vm.controle.submitted)\n" +
    "                          }\"><input id=codePostalVilleEtabHosp ng-model=vm.data.codePostalVilleEtabHosp name=codePostalVilleEtabHosp class=form-control typeahead-min-length=2 uib-typeahead=\"result as result.lib for result in vm.codePostalVilles($viewValue)\" typeahead-editable=false required><p class=help-block role=alert ng-show=\"(vm.data.codePostalVilleEtabHosp == undefined && vm.controle.submitted)\">Champ obligatoire</p></div><div ng-switch-when=off class=form-group ng-class=\"{ 'has-error' :\n" +
    "                       (vm.hospitalisationform.codePostalVilleEtabHosp.$invalid && !vm.hospitalisationform.codePostalVilleEtabHosp.$pristine)\n" +
    "                       || (vm.data.codePostalVilleEtabHosp == undefined && vm.controle.submitted)\n" +
    "                        }\"><input id=codePostalVilleEtabHosp ng-model=vm.data.codePostalVilleEtabHosp name=codePostalVilleEtabHosp class=form-control ui-validate=\"{controleCodePostalFormat  : 'vm.controleCodePostalFormat($value)'}\" ng-trim=false required><p class=help-block role=alert ng-show=vm.hospitalisationform.codePostalVilleEtabHosp.$error.controleCodePostalFormat>Code postal incorrect</p><p class=help-block role=alert ng-show=\"(vm.data.codePostalVilleEtabHosp == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></div><div class=row ng-if=\"vm.data.paysEtabHosp && vm.data.paysEtabHosp.libelleCaffr != 'FRANCE' && vm.data.paysEtabHosp.libelleCaffr != 'PRINCIPAUTE DE MONACO'\"><div class=col-sm-6><label class=label-form-cnaf for=villeEtabHosp>Ville de l'établissement</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                  (vm.hospitalisationform.villeEtabHosp.$invalid && !vm.hospitalisationform.villeEtabHosp.$pristine)\n" +
    "                  || vm.hospitalisationform.villeEtabHosp.$error.type5\n" +
    "                  || (vm.data.villeEtabHosp == undefined && vm.controle.submitted)\n" +
    "                }\"><input id=villeEtabHosp ng-model=vm.data.villeEtabHosp ng-model-options=\"{ updateOn: 'blur' }\" ui-validate=\"{type5  : 'vm.testType5($value,vm.hospitalisationform.villeEtabHosp)'}\" ng-trim=false name=villeEtabHosp maxlength=38 class=form-control required ng-pattern=\"/^[a-zA-Z0-9à-ÿÀ-Ÿ -']*$/\"><p class=help-block role=alert ng-show=vm.hospitalisationform.villeEtabHosp.$error.pattern>La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.hospitalisationform.villeEtabHosp.$error.type5>{{vm.hospitalisationform.villeEtabHosp.invalidmsg}}</p><p class=help-block role=alert ng-show=\"(vm.data.villeEtabHosp == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></div>")

$templateCache.put("components/cnaf-cct-lienparente/cnaf-cct-lienparente.html","<fieldset><legend class=label-form-cnaf for=situ>Lien de parenté{{vm.infoslienparente.complementlibelle}} avec {{vm.infoslienparente.prenom}} {{vm.infoslienparente.nom}}</legend><div class=row><div class=\"cct-bloc-boutons form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                (vm.lienparenteform.lienParente{{vm.indice}}.$invalid\n" +
    "                && !vm.lienparenteform.lienParente{{vm.indice}}.$pristine)\n" +
    "                || vm.lienparenteform.lienParente{{vm.indice}}.$error.controleDatesNaissance\n" +
    "                || vm.lienparenteform.controleONCASC\n" +
    "                || (vm.errorlienparente)\n" +
    "                || (vm.data.infosLiensParente[vm.indice].lienParente == undefined && vm.controle.submitted)}\"><div class=\"col-xs-12 col-sm-6 col-md-4\" ng-repeat=\"lienParenteOfList in vm.infoslienparente.listeLiensParente\"><span id=lienParenteAide class=pull-right ng-if=lienParenteOfList.popover><cnaf-aide tabindex=0 data-toggle=popover data-id-content-cnaf=popover-lienparente{{$index}} data-container=body data-trigger=manual></span><label class=\"btn btn-default btn-block\" ng-model=vm.data.infosLiensParente[vm.indice].lienParente uib-btn-radio=lienParenteOfList for=LienParente{{vm.indice}}{{lienParenteOfList.code}} ng-class=\"{'align-middle-cnaf' : lienParenteOfList.length <38}\"><input type=radio name=lienParente{{vm.indice}} aria-label=lienParenteOfList class=sr-only ng-model=vm.data.infosLiensParente[vm.indice].lienParente value=lienParenteOfList id=LienParente{{vm.indice}}{{lienParenteOfList.code}} ui-validate=\"{controleDatesNaissance : 'vm.controleDatesNaissance($value)',\n" +
    "                            controleONCASC : 'vm.controleONCASC()'}\" ng-required=true> <span aria-hidden=true>{{lienParenteOfList.libelle}}</span></label><div class=hidden id=popover-lienparente{{$index}}>{{lienParenteOfList.popover}}<div class=popover-btn-close-cnaf></div></div></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.infosLiensParente[vm.indice].lienParente == undefined && vm.controle.submitted)\">Champ obligatoire</p><p class=help-block role=alert ng-show=vm.lienparenteform.lienParente{{vm.indice}}.$error.controleDatesNaissance>Le lien de parenté est incohérent avec la date de naissance</p><p class=help-block role=alert ng-show=vm.lienparenteform.controleONCASC>Veuillez vérifier les liens de parenté pour vous et votre conjoint. Si vous confirmez ceux-ci vous ne pouvez pas poursuivre votre démarche en ligne. Nous vous invitons à prendre contact avec votre CAF</p></div></div></div></fieldset>")

$templateCache.put("components/cnaf-cct-lieunaissance/cnaf-cct-lieunaissance.html","<div class=row ng-init=vm.init()><fieldset><div class=\"col-sm-12 form-group\"><legend class=label-form-cnaf for=lieunaissance>Lieu de naissance</legend></div><div class=\"form-group btn-group-lg-cnaf btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "              vm.lieunaissanceform.lieunaissance.$invalid && !vm.lieunaissanceform.lieunaissance.$pristine\n" +
    "              || (vm.data.lieunaissance == undefined && vm.controle.submitted)\n" +
    "             }\"><div class=\"col-xs-12 col-sm-6 col-md-4\"><label class=\"btn btn-default btn-block align-middle-cnaf\" id=lieunaissanceDivCenterVertically ng-model=vm.data.lieunaissance uib-btn-radio=\"'FranceDOM'\" for=lieuNaissFranceDom><input type=radio name=lieunaissance aria-label=FranceDOM class=sr-only id=lieuNaissFranceDom ng-model=vm.data.lieunaissance value=fr required> <span aria-hidden=true>France métropolitaine ou<br>Département d'Outre-mer</span></label></div><div class=\"col-xs-12 col-sm-6 col-md-4\"><label class=\"btn btn-default btn-block align-middle-cnaf\" ng-model=vm.data.lieunaissance uib-btn-radio=\"'COM'\" for=lieuNaissCOM><input type=radio name=lieunaissance aria-label=COM class=sr-only id=lieuNaissCOM ng-model=vm.data.lieunaissance value=com required> <span aria-hidden=true>Collectivités d’Outre-mer</span></label></div><div class=\"col-xs-12 col-sm-6 col-md-4\"><label class=\"btn btn-default btn-block align-middle-cnaf\" ng-model=vm.data.lieunaissance uib-btn-radio=\"'Etranger'\" for=lieuNaissEtr><input type=radio name=lieunaissance aria-label=Etranger class=sr-only id=lieuNaissEtr ng-model=vm.data.lieunaissance value=etr required> <span aria-hidden=true>Etranger</span></label></div><p class=\"col-xs-12 col-sm-12 help-block\" role=alert ng-show=\"(vm.data.lieunaissance == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></fieldset></div><div class=row ng-if=\"vm.data.lieunaissance == 'FranceDOM'\"><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=codePostalVille>Code postal / Commune de naissance</label><div ng-switch on=vm.autocompletion><div ng-switch-when=on class=form-group ng-class=\"{ 'has-error' :\n" +
    "                  (vm.lieunaissanceform.codePostalVille.$invalid && !vm.lieunaissanceform.codePostalVille.$pristine) || vm.errorlieunaissance\n" +
    "                  || (vm.data.codePostalVille == undefined && vm.controle.submitted)\n" +
    "                }\"><input id=codePostalVille ng-model=vm.data.codePostalVille name=codePostalVille class=form-control typeahead-min-length=2 uib-typeahead=\"result as result.lib for result in vm.codePostalVilles($viewValue)\" typeahead-editable=false required><p class=help-block role=alert ng-show=\"(vm.data.codePostalVille == undefined && vm.controle.submitted)\">Champ obligatoire</p></div><div ng-switch-when=off class=form-group ng-class=\"{ 'has-error' :\n" +
    "              (vm.lieunaissanceform.codePostalVille.$invalid && !vm.lieunaissanceform.codePostalVille.$pristine)\n" +
    "               || vm.errorlieunaissance\n" +
    "               || vm.lieunaissanceform.codePostalVille.$error.type12\n" +
    "               || (vm.data.codePostalVille == undefined && vm.controle.submitted)\n" +
    "               }\"><input id=codePostalVille ng-model=vm.data.codePostalVille name=codePostalVille class=form-control ui-validate=\"{controleCodePostalFormat  : 'vm.controleCodePostalFormat($value)'}\" ng-trim=false required><p class=help-block role=alert ng-show=vm.lieunaissanceform.codePostalVille.$error.controleCodePostalFormat>Code postal incorrect</p><p class=help-block role=alert ng-show=\"(vm.data.codePostalVille == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></div><div class=row ng-if=\"vm.data.lieunaissance == 'COM'\"><fieldset><div class=col-sm-6><legend class=label-form-cnaf for=COMnaissance>Collectivité d’Outre-mer de naissance</legend></div><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "              vm.lieunaissanceform.COMnaissance.$invalid && !vm.lieunaissanceform.COMnaissance.$pristine\n" +
    "              || (vm.data.COMnaissance == undefined && vm.controle.submitted)\n" +
    "            }\"><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.COMnaissance uib-btn-radio=vm.listeComNaissance[0] for=SPM><input type=radio name=COMnaissance aria-label=Saint-Pierre-et-Miquelon class=sr-only id=SPM ng-model=vm.data.COMnaissance value=SPM required> <span aria-hidden=true>{{vm.listeComNaissance[0].libelle}}</span></label></div><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.COMnaissance uib-btn-radio=vm.listeComNaissance[1] for=SB><input type=radio name=COMnaissance aria-label=Saint-Barthélémy class=sr-only id=SB ng-model=vm.data.COMnaissance value=SB required> <span aria-hidden=true>{{vm.listeComNaissance[1].libelle}}</span></label></div><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.COMnaissance uib-btn-radio=vm.listeComNaissance[2] for=SM><input type=radio name=COMnaissance aria-label=Saint-Martin class=sr-only id=SM ng-model=vm.data.COMnaissance value=SM required> <span aria-hidden=true>{{vm.listeComNaissance[2].libelle}}</span></label></div></div><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                    vm.lieunaissanceform.COMnaissance.$invalid && !vm.lieunaissanceform.COMnaissance.$pristine\n" +
    "                    || (vm.data.COMnaissance == undefined && vm.controle.submitted)\n" +
    "                  }\"><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.COMnaissance uib-btn-radio=vm.listeComNaissance[3] for=WF><input type=radio name=COMnaissance aria-label=\"Wallis et Futuna\" class=sr-only id=WF ng-model=vm.data.COMnaissance value=WF required> <span aria-hidden=true>{{vm.listeComNaissance[3].libelle}}</span></label></div><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.COMnaissance uib-btn-radio=vm.listeComNaissance[4] for=PF><input type=radio name=COMnaissance aria-label=\"Polynésie Française\" class=sr-only id=PF ng-model=vm.data.COMnaissance value=PF required> <span aria-hidden=true>{{vm.listeComNaissance[4].libelle}}</span></label></div><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.COMnaissance uib-btn-radio=vm.listeComNaissance[5] for=NC><input type=radio name=COMnaissance aria-label=\"Nouvelle Calédonie\" class=sr-only id=NC ng-model=vm.data.COMnaissance value=NC required> <span aria-hidden=true>{{vm.listeComNaissance[5].libelle}}</span></label></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.COMnaissance == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></fieldset></div><div class=row ng-if=\"vm.data.lieunaissance == 'Etranger'\"><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=paysNaissance>Pays de naissance</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "              (vm.lieunaissanceform.paysNaissance.$invalid && !vm.lieunaissanceform.paysNaissance.$pristine)\n" +
    "              || (vm.data.paysNaissance == undefined && vm.controle.submitted)\n" +
    "            }\"><input id=paysNaissance ng-model=vm.data.paysNaissance name=paysNaissance class=form-control typeahead-min-length=2 uib-typeahead=\"pays as pays.libelleCaffr for pays in vm.getListePaysNaissanceProposes($viewValue) | filter:$viewValue | limitTo:8 | filter:vm.exclusionFrance\" typeahead-editable=false typeahead-no-results=noPaysFound required><p class=help-block role=alert ng-show=noPaysFound>Pays non trouvé</p><p class=help-block role=alert ng-show=\"(vm.data.paysNaissance == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=villeNaiss>Ville de naissance</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                  (vm.lieunaissanceform.villeNaiss.$invalid && !vm.lieunaissanceform.villeNaiss.$pristine)\n" +
    "                  || vm.lieunaissanceform.villeNaiss.$error.type5\n" +
    "                  || (vm.data.villeNaiss == undefined && vm.controle.submitted)\n" +
    "                  }\"><input id=villeNaiss maxlength=26 ng-model=vm.data.villeNaiss ng-change=\"vm.data.villeNaiss = vm.data.villeNaiss.toUpperCase()\" ng-pattern=\"/^[a-zA-Z0-9à-ÿÀ-Ÿ '-]*$/\" ng-blur=vm.testType5(vm.data.villeNaiss,vm.lieunaissanceform.villeNaiss) ng-trim=false name=villeNaiss class=form-control required><p class=help-block role=alert ng-show=\"vm.lieunaissanceform.villeNaiss.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.lieunaissanceform.villeNaiss.$error.type5>{{vm.lieunaissanceform.villeNaiss.invalidmsg}}</p><p class=help-block role=alert ng-show=\"(vm.data.villeNaiss == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div>")

$templateCache.put("components/cnaf-cct-message-champs-obligatoires/cnaf-cct-message-champs-obligatoires.html","<div class=row><div class=col-sm-12><p class=texte-info-cnaf>Tous les champs sont obligatoires, sauf mention contraire.</p></div></div>")

$templateCache.put("components/cnaf-cct-nationalite/cnaf-cct-nationalite.html","<cnaf-cct-nationalite-simple data=vm.data nationaliteform=vm.nationaliteform controle=vm.controle errornationalite=vm.errornationalite></cnaf-cct-nationalite-simple><div class=row ng-if=\"vm.data.lieunaissance && (vm.data.lieunaissance != 'FranceDOM' || vm.data.nationalite.code == 'C' || vm.data.nationalite.code == 'A')\"><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=nomPere>Nom du père</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                (vm.nationaliteform.nomPere.$invalid && !vm.nationaliteform.nomPere.$pristine)\n" +
    "                || vm.nationaliteform.nomPere.$error.type3\n" +
    "                || (vm.data.nomPere == undefined && vm.controle.submitted)\n" +
    "               }\"><input id=nomPere maxlength=28 ng-model=vm.data.nomPere ng-change=\"vm.data.nomPere = vm.data.nomPere.toUpperCase()\" ng-pattern=\"/^[a-zA-Z0-9à-ÿÀ-Ÿ '-]*$/\" ng-blur=\"vm.testType3(vm.data.nomPere,vm.nationaliteform.nomPere,'nomPere')\" name=nomPere class=form-control required><p class=help-block role=alert ng-show=\"vm.nationaliteform.nomPere.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.nationaliteform.nomPere.$error.type3>{{vm.nationaliteform.nomPere.invalidmsg}}</p><p class=help-block role=alert ng-show=\"(vm.data.nomPere == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=prenomPere>Prénom du père</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                    (vm.nationaliteform.prenomPere.$invalid && !vm.nationaliteform.prenomPere.$pristine)\n" +
    "                    || vm.nationaliteform.prenomPere.$error.type3\n" +
    "                    || (vm.data.prenomPere == undefined && vm.controle.submitted)\n" +
    "                   }\"><input id=prenomPere maxlength=32 ng-model=vm.data.prenomPere ng-change=\"vm.data.prenomPere = vm.data.prenomPere.toUpperCase()\" ng-pattern=\"/^[a-zA-Z0-9à-ÿÀ-Ÿ '-]*$/\" ng-blur=\"vm.testType3(vm.data.prenomPere,vm.nationaliteform.prenomPere,'prenomPere')\" name=prenomPere class=form-control required><p class=help-block role=alert ng-show=\"vm.nationaliteform.prenomPere.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.nationaliteform.prenomPere.$error.type3>{{vm.nationaliteform.prenomPere.invalidmsg}}</p><p class=help-block role=alert ng-show=\"(vm.data.prenomPere == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div><div class=row ng-if=\"vm.data.lieunaissance && (vm.data.lieunaissance != 'FranceDOM' || vm.data.nationalite.code == 'C' || vm.data.nationalite.code == 'A' )\"><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=nomMere>Nom de la mère</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                (vm.nationaliteform.nomMere.$invalid && !vm.nationaliteform.nomMere.$pristine)\n" +
    "                || vm.nationaliteform.nomMere.$error.type3\n" +
    "                || (vm.data.nomMere == undefined && vm.controle.submitted)\n" +
    "                }\"><input id=nomMere maxlength=28 ng-model=vm.data.nomMere ng-change=\"vm.data.nomMere = vm.data.nomMere.toUpperCase()\" ng-pattern=\"/^[a-zA-Z0-9à-ÿÀ-Ÿ '-]*$/\" ng-blur=\"vm.testType3(vm.data.nomMere,vm.nationaliteform.nomMere,'nomMere')\" name=nomMere class=form-control required><p class=help-block role=alert ng-show=\"vm.nationaliteform.nomMere.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.nationaliteform.nomMere.$error.type3>{{vm.nationaliteform.nomMere.invalidmsg}}</p><p class=help-block role=alert ng-show=\"(vm.data.nomMere == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=prenomMere>Prénom de la mère</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                  (vm.nationaliteform.prenomMere.$invalid && !vm.nationaliteform.prenomMere.$pristine)\n" +
    "                    || vm.nationaliteform.prenomMere.$error.type3\n" +
    "                    || (vm.data.prenomMere == undefined && vm.controle.submitted)\n" +
    "                  }\"><input id=prenomMere maxlength=32 ng-model=vm.data.prenomMere ng-change=\"vm.data.prenomMere = vm.data.prenomMere.toUpperCase()\" ng-pattern=\"/^[a-zA-Z0-9à-ÿÀ-Ÿ '-]*$/\" ng-blur=\"vm.testType3(vm.data.prenomMere,vm.nationaliteform.prenomMere,'prenomMere')\" name=prenomMere class=form-control required><p class=help-block role=alert ng-show=\"vm.nationaliteform.prenomMere.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.nationaliteform.prenomMere.$error.type3>{{vm.nationaliteform.prenomMere.invalidmsg}}</p><p class=help-block role=alert ng-show=\"(vm.data.prenomMere == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div>")

$templateCache.put("components/cnaf-cct-nationalitesimple/cnaf-cct-nationalitesimple.html","<div class=row><fieldset><div class=\"col-sm-12 form-group\"><legend class=label-form-cnaf for=nationalite>Nationalité</legend></div><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                        vm.nationaliteform.nationalite.$invalid \n" +
    "                            && (!vm.nationaliteform.nationalite.$pristine\n" +
    "                                    || vm.nationaliteform.nationalite.$touched)\n" +
    "                        }\"><div class=\"col-xs-12 col-sm-6 col-md-4\" ng-repeat=\"choixNat in vm.listeNationalite\"><span ng-if=choixNat.popover1 class=pull-right><cnaf-aide tabindex=0 data-toggle=popover data-id-content-cnaf=popover-choixNat{{$index}} data-container=body data-trigger=manual></span><label ng-class=\"{'align-middle-cnaf' : choixNat.libelle.length < 38}\" class=\"btn btn-default btn-block\" ng-model=vm.data.nationalite uib-btn-radio=choixNat title=\"Préciser le type de nationalité. Une sélection est obligatoire.\" for={{choixNat.code}}>{{choixNat.libelle}}</label><input type=radio name=nationalite class=sr-only aria-describedby=\"\n" +
    "                            nationaliteInfochoixNationaliteRequired \n" +
    "                            nationaliteErreurchoixNationaliteRequired\" id={{choixNat.code}} value={{choixNat.code}} ng-model=vm.data.nationalite ng-model-options=\"{ updateOn: 'blur'}\" required><div ng-if=choixNat.popover1 class=hidden id=popover-choixNat{{$index}}>{{choixNat.popover1}}<br>{{choixNat.popover2}}<div class=popover-btn-close-cnaf></div></div></div></div><div id=\"nationaliteInfochoixNationaliteRequired \" class=sr-only><p>Vous devez obligatoirement faire une sélection parmi celles proposées.</p></div><div class=col-sm-12><cnaf-cct-erreur-input iderreur=nationaliteErreurchoixNationaliteRequired condition=\"{{(!vm.nationaliteform.nationalite.$pristine || vm.nationaliteform.nationalite.$touched)\n" +
    "                                                    && vm.nationaliteform.nationalite.$error.required}}\" message=\"Champ obligatoire.\"></cnaf-cct-erreur-input></div><div class=col-sm-12><p class=texte-info-cnaf><img alt=Informations src=/icfstatiquesangularappli/dist/images/InformationsGris.png> <em>Le Royaume-Uni n'est plus membre de l'Union Européenne. Si vous êtes de nationalité britannique, vous devez sélectionner \"Autre\".</em></p></div></fieldset></div>")

$templateCache.put("components/cnaf-cct-nomsparents/cnaf-cct-nomsparents.html","<div class=row ng-if=\"vm.data.lieunaissance && (vm.data.lieunaissance != 'FranceDOM' || vm.data.nationalite.code == 'C' || vm.data.nationalite.code == 'A')\n" +
    "    && ((vm.controle.respSexe === 'M' && vm.data.infosLiensParente[0] && vm.data.infosLiensParente[0].lienParente && vm.data.infosLiensParente[0].lienParente.code != 'ENF')\n" +
    "    || ((vm.controle.respSexe !== 'M') && \n" +
    "        ((vm.controle.cjtSexe === undefined)\n" +
    "        || (vm.controle.cjtSexe === 'M' && vm.data.infosLiensParente[1] && vm.data.infosLiensParente[1].lienParente && vm.data.infosLiensParente[1].lienParente.code != 'ENF'))))\"><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=nomPere>Nom du père</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                (vm.nomsparentsform.nomPere.$invalid && !vm.nomsparentsform.nomPere.$pristine)\n" +
    "                || vm.nomsparentsform.nomPere.$error.type3\n" +
    "                || (vm.controle.nomPrenomParentOblig && (vm.data.nomPere == undefined || vm.data.nomPere == '') && vm.controle.submitted)\n" +
    "               }\"><input id=nomPere maxlength=28 ng-model=vm.data.nomPere ng-change=\"vm.data.nomPere = vm.data.nomPere.toUpperCase()\" ng-pattern=\"/^[a-zA-Z0-9à-ÿÀ-Ÿ '-]*$/\" ng-blur=\"vm.testType3(vm.data.nomPere,vm.nomsparentsform.nomPere,'nomPere')\" name=nomPere class=form-control ng-required=vm.controle.nomPrenomParentOblig><p class=help-block role=alert ng-show=\"vm.nomsparentsform.nomPere.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.nomsparentsform.nomPere.$error.type3>{{ vm.nomsparentsform.nomPere.invalidmsg }}</p><p class=help-block role=alert ng-show=\"(vm.controle.nomPrenomParentOblig && (vm.data.nomPere == undefined || vm.data.nomPere == '') && vm.controle.submitted)\">Champ obligatoire</p></div></div><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=prenomPere>Prénom du père</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                    (vm.nomsparentsform.prenomPere.$invalid && !vm.nomsparentsform.prenomPere.$pristine)\n" +
    "                    || vm.nomsparentsform.prenomPere.$error.type3\n" +
    "                    || (vm.controle.nomPrenomParentOblig && (vm.data.prenomPere == undefined || vm.data.prenomPere == '') && vm.controle.submitted)\n" +
    "                   }\"><input id=prenomPere maxlength=32 ng-model=vm.data.prenomPere ng-change=\"vm.data.prenomPere = vm.data.prenomPere.toUpperCase()\" ng-pattern=\"/^[a-zA-Z0-9à-ÿÀ-Ÿ '-]*$/\" ng-blur=\"vm.testType3(vm.data.prenomPere,vm.nomsparentsform.prenomPere,'prenomPere')\" name=prenomPere class=form-control ng-required=vm.controle.nomPrenomParentOblig><p class=help-block role=alert ng-show=\"vm.nomsparentsform.prenomPere.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.nomsparentsform.prenomPere.$error.type3>{{ vm.nomsparentsform.prenomPere.invalidmsg }}</p><p class=help-block role=alert ng-show=\"(vm.controle.nomPrenomParentOblig && (vm.data.prenomPere == undefined || vm.data.prenomPere == '') && vm.controle.submitted)\">Champ obligatoire</p></div></div></div><div class=row ng-if=\"vm.data.lieunaissance && (vm.data.lieunaissance != 'FranceDOM' || vm.data.nationalite.code == 'C' || vm.data.nationalite.code == 'A' )\n" +
    "    && ((vm.controle.respSexe === 'F' && vm.data.infosLiensParente[0] && vm.data.infosLiensParente[0].lienParente && vm.data.infosLiensParente[0].lienParente.code != 'ENF')\n" +
    "    || ((vm.controle.respSexe !== 'F') && \n" +
    "        ((vm.controle.cjtSexe === undefined) \n" +
    "        || (vm.controle.cjtSexe === 'F' && vm.data.infosLiensParente[1] && vm.data.infosLiensParente[1].lienParente && vm.data.infosLiensParente[1].lienParente.code != 'ENF'))))\"><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=nomMere>Nom de la mère</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                (vm.nomsparentsform.nomMere.$invalid && !vm.nomsparentsform.nomMere.$pristine)\n" +
    "                || vm.nomsparentsform.nomMere.$error.type3\n" +
    "                || (vm.controle.nomPrenomParentOblig && (vm.data.nomMere == undefined || vm.data.nomMere == '') && vm.controle.submitted)\n" +
    "                }\"><input id=nomMere maxlength=28 ng-model=vm.data.nomMere ng-change=\"vm.data.nomMere = vm.data.nomMere.toUpperCase()\" ng-pattern=\"/^[a-zA-Z0-9à-ÿÀ-Ÿ '-]*$/\" ng-blur=\"vm.testType3(vm.data.nomMere,vm.nomsparentsform.nomMere,'nomMere')\" name=nomMere class=form-control ng-required=vm.controle.nomPrenomParentOblig><p class=help-block role=alert ng-show=\"vm.nomsparentsform.nomMere.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.nomsparentsform.nomMere.$error.type3>{{ vm.nomsparentsform.nomMere.invalidmsg }}</p><p class=help-block role=alert ng-show=\"(vm.controle.nomPrenomParentOblig && (vm.data.nomMere == undefined || vm.data.nomMere == '') && vm.controle.submitted)\">Champ obligatoire</p></div></div><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=prenomMere>Prénom de la mère</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                  (vm.nomsparentsform.prenomMere.$invalid && !vm.nomsparentsform.prenomMere.$pristine)\n" +
    "                    || vm.nomsparentsform.prenomMere.$error.type3\n" +
    "                    || (vm.controle.nomPrenomParentOblig && (vm.data.prenomMere == undefined || vm.data.prenomMere == '') && vm.controle.submitted)\n" +
    "                  }\"><input id=prenomMere maxlength=32 ng-model=vm.data.prenomMere ng-change=\"vm.data.prenomMere = vm.data.prenomMere.toUpperCase()\" ng-pattern=\"/^[a-zA-Z0-9à-ÿÀ-Ÿ '-]*$/\" ng-blur=\"vm.testType3(vm.data.prenomMere,vm.nomsparentsform.prenomMere,'prenomMere')\" name=prenomMere class=form-control ng-required=vm.controle.nomPrenomParentOblig><p class=help-block role=alert ng-show=\"vm.nomsparentsform.prenomMere.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.nomsparentsform.prenomMere.$error.type3>{{ vm.nomsparentsform.prenomMere.invalidmsg }}</p><p class=help-block role=alert ng-show=\"(vm.controle.nomPrenomParentOblig && (vm.data.prenomMere == undefined || vm.data.prenomMere == '') && vm.controle.submitted)\">Champ obligatoire</p></div></div></div>")

$templateCache.put("components/cnaf-cct-prestationspercues-sitenf/cnaf-cct-prestationspercues-sitenf.html","<div class=row ng-init=vm.init()><div class=row><div class=col-sm-12><fieldset><legend class=label-form-cnaf for=prestaAutreOrga><span>{{ vm.data.prenom }} {{ vm.data.nom }} a bénéficié de prestations en tant qu'enfant ou personne à charge d'un autre organisme que la Caf</span></legend><div class=row><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                              vm.prestationspercuesform.prestaAutreOrga.$invalid && !vm.prestationspercuesform.prestaAutreOrga.$pristine\n" +
    "                              || (vm.data.prestaAutreOrga == undefined && vm.controle.submitted)\n" +
    "                             }\"><div class=hidden id=content-popover-prestaAutreOrga><div class=popover-btn-close-cnaf></div>Il s’agit des Allocations familiales, Aides au logement, Prestation d’accueil du jeune enfant, Rsa...</div><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.prestaAutreOrga uib-btn-radio=true for=prestaAutreOrgaOui><input type=radio name=prestaAutreOrga aria-label=Oui class=sr-only id=prestaAutreOrgaOui ng-model=vm.data.prestaAutreOrga value=oui required> <span aria-hidden=true>Oui</span></label></div><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.prestaAutreOrga uib-btn-radio=false for=prestaAutreOrgaNon ng-click=vm.cleanMsg()><input type=radio name=prestaAutreOrga aria-label=Non class=sr-only id=prestaAutreOrgaNon ng-model=vm.data.prestaAutreOrga value=non required> <span aria-hidden=true>Non</span></label></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.prestaAutreOrga == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></fieldset></div></div><div class=row ng-if=vm.data.prestaAutreOrga><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=autreOrga>Nom de l'organisme</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                        (vm.prestationspercuesform.autreOrga.$invalid && !vm.prestationspercuesform.autreOrga.$pristine)\n" +
    "                            || vm.prestationspercuesform.autreOrga.$error.type8\n" +
    "                            || (vm.data.autreOrga == undefined && vm.controle.submitted)\n" +
    "                        }\"><input id=autreOrga maxlength=50 ng-model=vm.data.autreOrga ng-change=\"vm.data.autreOrga = vm.data.autreOrga.toUpperCase()\" ng-pattern=\"/^[a-zA-Zà-ÿÀ-Ÿ0-9 '-]*$/\" ng-blur=\"vm.testType8(vm.data.autreOrga,vm.prestationspercuesform.autreOrga,'autreOrga')\" ng-trim=false name=autreOrga class=form-control required><p class=help-block role=alert ng-show=\"vm.prestationspercuesform.autreOrga.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.prestationspercuesform.autreOrga.$error.type8>{{ vm.prestationspercuesform.autreOrga.invalidmsg }}</p><p class=help-block role=alert ng-show=\"(vm.data.autreOrga == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=numOrga>Numéro de dossier</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                        (vm.prestationspercuesform.numOrga.$invalid && !vm.prestationspercuesform.numOrga.$pristine)\n" +
    "                        || vm.prestationspercuesform.numOrga.$error.type10\n" +
    "                        }\"><input id=numOrga maxlength=20 ng-model=vm.data.numOrga ng-change=\"vm.data.numOrga = vm.data.numOrga.toUpperCase()\" ng-pattern=\"/^[a-zA-Zà-ÿÀ-Ÿ0-9 '-]*$/\" ng-blur=\"vm.testType10(vm.data.numOrga,vm.prestationspercuesform.numOrga,'numOrga')\" ng-trim=false name=numOrga class=form-control><p class=help-block role=alert ng-show=\"vm.prestationspercuesform.numOrga.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.prestationspercuesform.numOrga.$error.type10>{{ vm.prestationspercuesform.numOrga.invalidmsg }}</p></div></div><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=paysAutreOrga>Pays de l'organisme</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                        (vm.prestationspercuesform.paysAutreOrga.$invalid && !vm.prestationspercuesform.paysAutreOrga.$pristine)\n" +
    "                        || (vm.data.paysAutreOrga == undefined && vm.controle.submitted)\n" +
    "                        }\"><input id=paysAutreOrga maxlength=26 ng-model=vm.data.paysAutreOrga name=paysAutreOrga class=form-control typeahead-min-length=2 uib-typeahead=\"pays as pays.libelleCaffr for pays in vm.getListePays($viewValue) | filter:$viewValue | limitTo:8\" typeahead-editable=false typeahead-no-results=noPaysFound required><p class=help-block role=alert ng-show=noPaysFound>Pays non trouvé</p><p class=help-block role=alert ng-show=\"(vm.data.paysAutreOrga == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div><div ng-if=\"(vm.controle.agesup16 === true && vm.data.prestaAutreOrga === false && vm.controle.trouveRNB === false)\"><div class=row><div class=col-sm-12><fieldset><legend class=label-form-cnaf for=prestaAlloc>{{ vm.data.prenom }} {{ vm.data.nom }} a bénéficié de prestations en tant qu'allocataire de la Caf</legend><div class=row><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                      vm.prestationspercuesform.prestaAlloc.$invalid && !vm.prestationspercuesform.prestaAlloc.$pristine\n" +
    "                      || (vm.data.prestaAlloc == undefined && vm.controle.submitted)\n" +
    "                     }\"><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.prestaAlloc uib-btn-radio=true for=prestaAllocOui><input type=radio name=prestaAlloc aria-label=Oui class=sr-only id=prestaAllocOui ng-model=vm.data.prestaAlloc value=oui required> <span aria-hidden=true>Oui</span></label></div><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.prestaAlloc uib-btn-radio=false for=prestaAllocNon ng-click=vm.cleanMsg()><input type=radio name=prestaAlloc aria-label=non class=sr-only id=prestaAllocNon ng-model=vm.data.prestaAlloc value=non required> <span aria-hidden=true>Non</span></label></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.prestaAlloc == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></fieldset></div></div><div ng-if=vm.data.prestaAlloc><div class=col-sm-4><div class=row><label class=\"label-form-cnaf control-label\" for=departCaf>Département de la Caf</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                              (vm.prestationspercuesform.departCaf.$invalid && !vm.prestationspercuesform.departCaf.$pristine)\n" +
    "                              || (vm.data.departCaf == undefined && vm.controle.submitted)\n" +
    "                              }\"><input id=departCaf maxlength=26 ng-model=vm.data.departCaf name=departCaf class=form-control typeahead-min-length=2 uib-typeahead=\"departement as departement.libelleCaffr for departement in vm.getListeDepartements($viewValue) | filter:$viewValue | limitTo:8\" typeahead-editable=false typeahead-no-results=noDepartementFound required><p class=help-block role=alert ng-show=noDepartementFound>Département non trouvé</p><p class=help-block role=alert ng-show=\"(vm.data.departCaf == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateFinPerception>Date de fin de perception</label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                             (vm.prestationspercuesform.dateFinPerception.$invalid\n" +
    "                             && !vm.prestationspercuesform.dateFinPerception.$pristine)\n" +
    "                             || vm.prestationspercuesform.dateFinPerception.$error.pattern\n" +
    "                             || vm.prestationspercuesform.dateFinPerception.$error.controleDateFinPerception\n" +
    "                             || ((vm.data.dateFinPerception == undefined || vm.data.dateFinPerception == 'jj/mm/aaaa') && vm.controle.submitted)\n" +
    "                           }\"><div class=\"form-group input-group\" id=divDateFinPerc><input id=dateFinPerception name=dateFinPerception value={{dateFinPerception}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.dateFinPerception class=form-control ui-validate=\"{controleDateFinPerception  : 'vm.controleDateFinPerception($value, vm.controle.today)'\n" +
    "                                            }\" pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.dateFinPerception start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateFinPerception></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"vm.prestationspercuesform.dateFinPerception.$error.pattern && vm.data.dateFinPerception.length == 10\">Format de date invalide</p><p class=help-block role=alert ng-show=\"((vm.data.dateFinPerception == undefined  || vm.data.dateFinPerception == 'jj/mm/aaaa') && vm.controle.submitted)\">Champ obligatoire</p><p class=help-block role=alert ng-show=vm.prestationspercuesform.dateFinPerception.$error.controleDateFinPerception>La date de fin de perception ne peut être postérieure au {{ vm.controle.today | date: 'dd/MM/yyyy' }}</p></div></div></div></div></div>")

$templateCache.put("components/cnaf-cct-prestationspercues-socle/cnaf-cct-prestationspercues-socle.html","<div class=row ng-init=vm.init()><div ng-if=\"vm.controle.agesup25 === false\"><div class=row><div class=col-sm-12><fieldset><legend class=label-form-cnaf for=prestaParents><span ng-if=!vm.controle.conjoint>Vos parents perçoivent des prestations familiales pour vous</span> <span ng-if=vm.controle.conjoint>Les parents de votre conjoint perçoivent des prestations familiales pour lui</span><cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-prestaParents data-container=body data-trigger=manual tabindex=0></legend><div class=row><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                              vm.prestationspercuesform.prestaParents.$invalid && !vm.prestationspercuesform.prestaParents.$pristine\n" +
    "                              || (vm.data.prestaParents == undefined && vm.controle.submitted)\n" +
    "                             }\"><div class=hidden id=content-popover-prestaParents>Il s’agit des Allocations familiales, Aides au logement, Prestation d’accueil du jeune enfant, Rsa...<div class=popover-btn-close-cnaf></div></div><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.prestaParents uib-btn-radio=true for=prestaParentsOui><input type=radio name=prestaParents aria-label=Oui class=sr-only id=prestaParentsOui ng-model=vm.data.prestaParents value=oui required> <span aria-hidden=true>Oui</span></label></div><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.prestaParents uib-btn-radio=false for=prestaParentsNon ng-click=vm.cleanMsg()><input type=radio name=prestaParents aria-label=Non class=sr-only id=prestaParentsNon ng-model=vm.data.prestaParents value=non required> <span aria-hidden=true>Non</span></label></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.prestaParents == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></fieldset></div></div><div ng-if=vm.data.prestaParents><div class=row><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=nomprenom>Nom et prénom du parent bénéficiaire</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                              (vm.prestationspercuesform.nomprenom.$invalid && !vm.prestationspercuesform.nomprenom.$pristine)\n" +
    "                                || vm.prestationspercuesform.nomprenom.$error.type3\n" +
    "                                || (vm.data.nomprenom == undefined && vm.controle.submitted)\n" +
    "                            }\"><input id=nomprenom maxlength=63 ng-model=vm.data.nomprenom ng-pattern=\"/^[a-zA-Zà-ÿÀ-Ÿ '-]*$/\" ng-blur=\"vm.testType3(vm.data.nomprenom,vm.prestationspercuesform.nomprenom,'nomprenom')\" ng-trim=false name=nomprenom class=form-control required><p class=help-block role=alert ng-show=\"vm.prestationspercuesform.nomprenom.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.prestationspercuesform.nomprenom.$error.type3>{{vm.prestationspercuesform.nomprenom.invalidmsg}}</p><p class=help-block role=alert ng-show=\"(vm.data.nomprenom == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div><div class=col-sm-6><label class=label-form-cnaf for=pays>Pays</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                            (vm.prestationspercuesform.pays{{vm.index}}.$invalid && !vm.prestationspercuesform.pays{{vm.index}}.$pristine)\n" +
    "                            || (vm.data.pays == undefined && vm.controle.submitted)\n" +
    "                    }\"><input id=pays ng-model=vm.data.pays name=pays class=form-control typeahead-min-length=2 uib-typeahead=\"pays as pays.libelleCaffr for pays in vm.getListePays($viewValue) | filter:$viewValue | limitTo:8\" typeahead-editable=false typeahead-no-results=noPaysFound required><p class=help-block role=alert ng-show=noPaysFound>Pays non trouvé</p><p class=help-block role=alert ng-show=\"(vm.data.pays == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></div><div ng-if=\"vm.data.pays && vm.data.prestaParents\"><div ng-if=\"vm.data.pays.code == 'FR' || vm.data.pays.code == 'MC'\"><div class=row><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=codePostalVille>Code postal / Commune</label><div ng-switch on=vm.autocompletion><div ng-switch-when=on class=form-group ng-class=\"{ 'has-error' :\n" +
    "                                (vm.prestationspercuesform.codePostalVille.$invalid && !vm.prestationspercuesform.codePostalVille.$pristine)\n" +
    "                                || vm.erroradresse\n" +
    "                                || (vm.data.codePostalVille == undefined && vm.controle.submitted)\n" +
    "                              }\"><input id=codePostalVille ng-model=vm.data.codePostalVille name=codePostalVille class=form-control typeahead-min-length=2 uib-typeahead=\"result as result.lib for result in vm.codePostalVilles($viewValue, vm.data)\" typeahead-editable=false ng-change=vm.reinitErreurAdresse() required><p class=help-block role=alert ng-show=\"(vm.data.codePostalVille == undefined && vm.controle.submitted)\">Champ obligatoire</p></div><div ng-switch-when=off class=form-group ng-class=\"{ 'has-error' :\n" +
    "                  (vm.prestationspercuesform.codePostalVille.$invalid && !vm.prestationspercuesform.codePostalVille.$pristine)\n" +
    "                    || vm.erroradresse\n" +
    "                    || vm.prestationspercuesform.codePostalVille.$error.type12\n" +
    "                    || (vm.data.codePostalVille == undefined && vm.controle.submitted)\n" +
    "                    }\"><input id=codePostalVille ng-model=vm.data.codePostalVille name=codePostalVille class=form-control ui-validate=\"{controleCodePostalFormat  : 'vm.controleCodePostalFormat($value)'}\" ng-trim=false required><p class=help-block role=alert ng-show=vm.prestationspercuesform.codePostalVille.$error.controleCodePostalFormat>Code postal incorrect</p><p class=help-block role=alert ng-show=\"(vm.data.codePostalVille == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=numEtAdresse>N° et voie / Lieu-dit</label><div ng-switch on=vm.autocompletion><div ng-switch-when=on class=form-group ng-class=\"{ 'has-error' :\n" +
    "                              (vm.prestationspercuesform.numEtAdresse.$invalid && !vm.prestationspercuesform.numEtAdresse.$pristine)\n" +
    "                              || (vm.data.numEtAdresse == undefined && vm.controle.submitted)\n" +
    "                             }\"><input id=numEtAdresse ng-model=vm.data.numEtAdresse name=numEtAdresse class=form-control typeahead-min-length=2 uib-typeahead=\"result as result.lib for result in vm.numEtAdresse($viewValue)\" maxlength=38 required><p class=help-block role=alert ng-show=\"(vm.data.numEtAdresse == undefined && vm.controle.submitted)\">Champ obligatoire</p></div><div ng-switch-when=off class=form-group ng-class=\"{ 'has-error' :\n" +
    "                          (vm.prestationspercuesform.numEtAdresse.$invalid && !vm.prestationspercuesform.numEtAdresse.$pristine)\n" +
    "                            || vm.prestationspercuesform.numEtAdresse.$error.type7\n" +
    "                            || (vm.data.numEtAdresse == undefined && vm.controle.submitted)\n" +
    "                        }\"><input id=numEtAdresse ng-model=vm.data.numEtAdresse ng-blur=\"vm.testType7(vm.data.numEtAdresse,vm.prestationspercuesform.numEtAdresse,'numEtAdresse')\" ng-trim=false name=numEtAdresse class=form-control maxlength=38 required><p class=help-block role=alert ng-show=vm.prestationspercuesform.numEtAdresse.$error.type7>{{vm.prestationspercuesform.numEtAdresse.invalidmsg}}</p><p class=help-block role=alert ng-show=\"(vm.data.numEtAdresse == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></div></div><div ng-if=\"vm.data.pays.code != 'FR' && vm.data.pays.code != 'MC'\"><div class=row ng-init=vm.initAdresseEtranger()><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=ville>Ville</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                          (vm.prestationspercuesform.ville.$invalid && !vm.prestationspercuesform.ville.$pristine)\n" +
    "                          || vm.prestationspercuesform.ville.$error.type5\n" +
    "                          || (vm.data.ville == undefined && vm.controle.submitted)\n" +
    "                        }\"><input id=ville ng-model=vm.data.ville ng-model-options=\"{ updateOn: 'blur' }\" ui-validate=\"{type5  : 'vm.testType5($value,vm.prestationspercuesform.ville)'}\" ng-trim=false name=ville maxlength=38 class=form-control required ng-pattern=\"/^[a-zA-Z0-9à-ÿÀ-Ÿ -']*$/\" ng-change=\"vm.data.ville = vm.data.ville.toUpperCase()\"><p class=help-block role=alert ng-show=vm.prestationspercuesform.ville.$error.type5>{{vm.prestationspercuesform.ville.invalidmsg}}</p><p class=help-block role=alert ng-show=\"(vm.data.ville == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=numEtAdresse>Adresse</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                          (vm.prestationspercuesform.numEtAdresse.$invalid && !vm.prestationspercuesform.numEtAdresse.$pristine)\n" +
    "                            || vm.prestationspercuesform.numEtAdresse.$error.type7\n" +
    "                            }\"><input id=numEtAdresse ng-model=vm.data.numEtAdresse ng-blur=\"vm.testType7(vm.data.numEtAdresse,vm.prestationspercuesform.numEtAdresse,'numEtAdresse')\" ng-trim=false name=numEtAdresse class=form-control maxlength=38><p class=help-block role=alert ng-show=vm.prestationspercuesform.numEtAdresse.$error.type7>{{vm.prestationspercuesform.numEtAdresse.invalidmsg}}</p></div></div></div></div><div class=row><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=orgaparents>Nom de l'organisme</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                              (vm.prestationspercuesform.orgaparents.$invalid && !vm.prestationspercuesform.orgaparents.$pristine)\n" +
    "                              || vm.prestationspercuesform.orgaparents.$error.type8\n" +
    "                              || (vm.data.orgaparents == undefined && vm.controle.submitted)\n" +
    "                            }\"><input id=orgaparents maxlength=63 ng-model=vm.data.orgaparents ng-change=\"vm.data.orgaparents = vm.data.orgaparents.toUpperCase()\" ng-pattern=\"/^[a-zA-Zà-ÿÀ-Ÿ0-9 '-]*$/\" ng-blur=\"vm.testType8(vm.data.orgaparents,vm.prestationspercuesform.orgaparents,'orgaparents')\" ng-trim=false name=orgaparents class=form-control required><p class=help-block role=alert ng-show=\"vm.prestationspercuesform.orgaparents.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.prestationspercuesform.orgaparents.$error.type8>{{vm.prestationspercuesform.orgaparents.invalidmsg}}</p><p class=help-block role=alert ng-show=\"(vm.data.orgaparents == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=numdosparents>Numéro de dossier</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                              (vm.prestationspercuesform.numdosparents.$invalid && !vm.prestationspercuesform.numdosparents.$pristine)\n" +
    "                                || vm.prestationspercuesform.numdosparents.$error.type10\n" +
    "                             }\"><input id=numdosparents maxlength=50 ng-model=vm.data.numdosparents ng-change=\"vm.data.numdosparents = vm.data.numdosparents.toUpperCase()\" ng-pattern=\"/^[a-zA-Zà-ÿÀ-Ÿ0-9 '-]*$/\" ng-blur=\"vm.testType10(vm.data.numdosparents,vm.prestationspercuesform.numdosparents,'numdosparents')\" ng-trim=false name=numdosparents class=form-control><p class=help-block role=alert ng-show=\"vm.prestationspercuesform.numdosparents.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.prestationspercuesform.numdosparents.$error.type10>{{vm.prestationspercuesform.numdosparents.invalidmsg}}</p></div></div></div></div></div></div><div ng-if=\"(vm.controle.agesup25 === true || vm.data.prestaParents === false)\"><div class=row><div class=col-sm-12><fieldset class=row><legend class=label-form-cnaf for=prestaAutreOrga ng-if=!vm.controle.conjoint>Vous percevez des prestations familiales d’un autre organisme</legend><legend class=label-form-cnaf for=prestaAutreOrga ng-if=vm.controle.conjoint>Votre conjoint perçoit des prestations familiales d’un autre organisme</legend><div class=row><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                      vm.prestationspercuesform.prestaAutreOrga.$invalid && !vm.prestationspercuesform.prestaAutreOrga.$pristine\n" +
    "                      || (vm.data.prestaAutreOrga == undefined && vm.controle.submitted)\n" +
    "                     }\"><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.prestaAutreOrga uib-btn-radio=\"'Oui'\" for=prestaAutreOrgaOui><input type=radio name=prestaAutreOrga aria-label=Oui class=sr-only id=prestaAutreOrgaOui ng-model=vm.data.prestaAutreOrga value=oui required> <span aria-hidden=true>Oui</span></label></div><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.prestaAutreOrga uib-btn-radio=\"'Non'\" for=prestaAutreOrgaNon ng-click=vm.cleanMsg()><input type=radio name=prestaAutreOrga aria-label=non class=sr-only id=prestaAutreOrgaNon ng-model=vm.data.prestaAutreOrga value=non required> <span aria-hidden=true>Non</span></label></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.prestaAutreOrga == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></fieldset></div></div><div class=row ng-if=\"vm.data.prestaAutreOrga == 'Oui'\"><div class=col-sm-4><div class=row><label class=\"label-form-cnaf control-label\" for=autreorga>Nom de l'organisme</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                        (vm.prestationspercuesform.autreorga.$invalid && !vm.prestationspercuesform.autreorga.$pristine)\n" +
    "                          || vm.prestationspercuesform.autreorga.$error.type8\n" +
    "                          || (vm.data.autreorga == undefined && vm.controle.submitted)\n" +
    "                       }\"><input id=autreorga maxlength=63 ng-model=vm.data.autreorga ng-change=\"vm.data.autreorga = vm.data.autreorga.toUpperCase()\" ng-pattern=\"/^[a-zA-Zà-ÿÀ-Ÿ0-9 '-]*$/\" ng-blur=\"vm.testType8(vm.data.autreorga,vm.prestationspercuesform.autreorga,'autreorga')\" ng-trim=false name=autreorga class=form-control required><p class=help-block role=alert ng-show=\"vm.prestationspercuesform.autreorga.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.prestationspercuesform.autreorga.$error.type8>{{vm.prestationspercuesform.autreorga.invalidmsg}}</p><p class=help-block role=alert ng-show=\"(vm.data.autreorga == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=numdosautreorga>Numéro de dossier</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                        (vm.prestationspercuesform.numdosautreorga.$invalid && !vm.prestationspercuesform.numdosautreorga.$pristine)\n" +
    "                        || vm.prestationspercuesform.numdosautreorga.$error.type10\n" +
    "                       }\"><input id=numdosautreorga maxlength=50 ng-model=vm.data.numdosautreorga ng-change=\"vm.data.numdosautreorga = vm.data.numdosautreorga.toUpperCase()\" ng-pattern=\"/^[a-zA-Zà-ÿÀ-Ÿ0-9 '-]*$/\" ng-blur=\"vm.testType10(vm.data.numdosautreorga,vm.prestationspercuesform.numdosautreorga,'numdosautreorga')\" ng-trim=false name=numdosautreorga class=form-control><p class=help-block role=alert ng-show=\"vm.prestationspercuesform.numdosautreorga.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.prestationspercuesform.numdosautreorga.$error.type10>{{vm.prestationspercuesform.numdosautreorga.invalidmsg}}</p></div></div><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=paysautreorga>Pays de l'organisme</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                      (vm.prestationspercuesform.paysautreorga.$invalid && !vm.prestationspercuesform.paysautreorga.$pristine)\n" +
    "                      || (vm.data.paysautreorga == undefined && vm.controle.submitted)\n" +
    "                      }\"><input id=paysautreorga ng-model=vm.data.paysautreorga name=paysautreorga class=form-control typeahead-min-length=2 uib-typeahead=\"pays as pays.libelleCaffr for pays in vm.getListePays($viewValue) | filter:$viewValue | limitTo:8\" typeahead-editable=false typeahead-no-results=noPaysFound required><p class=help-block role=alert ng-show=noPaysFound>Pays non trouvé</p><p class=help-block role=alert ng-show=\"(vm.data.paysautreorga == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></div>")

$templateCache.put("components/cnaf-cct-question-secrete/cnaf-cct-question-secrete.html","<div class=row><div class=col-sm-12><fieldset><div class=row><legend class=\"label-form-cnaf control-label\">Choisir une question secrète</legend><div class=\"form-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' : (vm.questionsecreteform.questionSecrete.$invalid && !vm.questionsecreteform.questionSecrete.$pristine)\n" +
    "             || (vm.questionsecreteform.questionSecrete == undefined&& vm.controle.submitted)}\"><div class=\"col-sm-5 col-lg-4\" ng-repeat=\"question in vm.listequestions\"><label class=\"row btn btn-default btn-block\" ng-model=vm.data.questionSecrete uib-btn-radio=question.code for={{question.code}}><input type=radio name=questionSecrete ng-model=vm.data.questionSecrete aria-label={{question.libelle}} class=sr-only id={{question.code}} required> <span aria-hidden=true>{{question.libelle}}</span></label></div><p class=help-block role=alert ng-show=\"(vm.data.questionSecrete == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></fieldset></div></div><div class=row ng-if=vm.data.questionSecrete><div class=col-sm-6><div class=row><label class=\"label-form-cnaf control-label\" for=reponseQuestionSecrete>Réponse</label><div class=form-group ng-class=\"{ 'has-error' : (vm.questionsecreteform.reponseQuestionSecrete.$invalid && !vm.questionsecreteform.reponseQuestionSecrete.$pristine)\n" +
    "                                            || vm.questionsecreteform.reponseQuestionSecrete.$error.type10\n" +
    "                                            || (vm.data.reponseQuestionSecrete == undefined  && vm.controle.submitted)}\"><input id=reponseQuestionSecrete ng-model=vm.data.reponseQuestionSecrete maxlength=250 ng-change=\"vm.data.reponseQuestionSecrete = vm.data.reponseQuestionSecrete.toUpperCase()\" ng-blur=\"vm.testType10(vm.data.reponseQuestionSecrete, vm.questionsecreteform.reponseQuestionSecrete, 'reponseQuestionSecrete')\" name=reponseQuestionSecrete class=form-control required><p class=help-block role=alert ng-show=vm.questionsecreteform.reponseQuestionSecrete.$error.type10>{{vm.questionsecreteform.reponseQuestionSecrete.invalidmsg}}</p><p class=help-block role=alert ng-show=\"(vm.data.reponseQuestionSecrete == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></div>")

$templateCache.put("components/cnaf-cct-residence-enfant/cnaf-cct-residence-enfant.html","<div class=row ng-init=vm.init()><fieldset><div class=\"col-sm-12 form-group\"><legend class=label-form-cnaf for=residence>L'enfant réside</legend></div><div class=\"cct-bloc-boutons form-group btn-block btn-group-lg-cnaf\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "              vm.residenceform.residence.$invalid && !vm.residenceform.residence.$pristine\n" +
    "              || (vm.data.residence == undefined && vm.controle.submitted)\n" +
    "             }\"><div class=col-sm-4><label class=\"btn btn-default btn-block\" id=residence ng-model=vm.data.residence uib-btn-radio=\"'france'\" for=resFrance><input type=radio name=residence aria-label=france class=sr-only id=resFrance ng-model=vm.data.residence value=fr required> <span aria-hidden=true>En France métropolitaine</span></label></div><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.residence uib-btn-radio=\"'dom'\" for=resDom><input type=radio name=residence aria-label=dom class=sr-only id=resDom ng-model=vm.data.residence value=dom required> <span aria-hidden=true>Dans un DOM</span></label></div><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.residence uib-btn-radio=\"'EEE'\" for=resEEE><input type=radio name=residence aria-label=EEE class=sr-only id=resEEE ng-model=vm.data.residence value=eee required> <span aria-hidden=true>En EEE ou Suisse</span></label></div><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.residence uib-btn-radio=\"'autre'\" for=resAutre><input type=radio name=residence aria-label=autre class=sr-only id=resAutre ng-model=vm.data.residence value=aut required> <span aria-hidden=true>Autre</span></label></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.residence == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></fieldset><div class=col-sm-4 ng-if=\"vm.data.residence === 'EEE'\"><label class=\"label-form-cnaf control-label\" for=paysResidenceEEE>Pays de résidence</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "              (vm.residenceform.paysResidenceEEE.$invalid && !vm.residenceform.paysResidenceEEE.$pristine)\n" +
    "              || (vm.data.paysResidenceEEE == undefined && vm.controle.submitted)\n" +
    "            }\"><input id=paysResidenceEEE ng-model=vm.data.paysResidenceEEE name=paysResidenceEEE class=form-control typeahead-min-length=2 uib-typeahead=\"pays as pays.libelleCaffr for pays in vm.getListePaysCeeResidenceProposes($viewValue) | filter:$viewValue | limitTo:8\" typeahead-editable=false typeahead-no-results=noPaysFound required><p class=help-block role=alert ng-show=noPaysFound>Pays non trouvé</p><p class=help-block role=alert ng-show=\"(vm.data.paysResidenceEEE == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div><div class=col-sm-4 ng-if=\"vm.data.residence === 'autre'\"><label class=\"label-form-cnaf control-label\" for=paysResidenceAutre>Pays de résidence</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "              (vm.residenceform.paysResidenceAutre.$invalid && !vm.residenceform.paysResidenceAutre.$pristine)\n" +
    "              || (vm.data.paysResidenceAutre == undefined && vm.controle.submitted)\n" +
    "            }\"><input id=paysResidenceAutre ng-model=vm.data.paysResidenceAutre name=paysResidenceAutre class=form-control typeahead-min-length=2 uib-typeahead=\"pays as pays.libelleCaffr for pays in vm.getListePaysAutreResidenceProposes($viewValue) | filter:$viewValue | limitTo:8\" typeahead-editable=false typeahead-no-results=noPaysFound required><p class=help-block role=alert ng-show=noPaysFound>Pays non trouvé</p><p class=help-block role=alert ng-show=\"(vm.data.paysResidenceAutre == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div>")

$templateCache.put("components/cnaf-cct-sitfam/cnaf-cct-sitfam.component.html","<cnaf-calendar></cnaf-calendar><div ng-init=vm.init()><div class=row ng-if=\"vm.controle.sitfamConnue != 'MAR' && vm.controle.sitfamConnue != 'RVM'\"><fieldset class=col-sm-12><div class=row><div class=col-sm-4><legend class=label-form-cnaf>Votre situation</legend></div><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                    (vm.sitfamform.sitfam.$invalid && !vm.sitfamform.sitfam.$pristine)\n" +
    "                    || (vm.data.choixSitfam == undefined && vm.controle.submitted) }\"><div class=col-sm-4 ng-repeat=\"choixSitfam in vm.listeSitfam\"><label class=\"btn btn-default btn-block\" ng-model=vm.data.choixSitfam uib-btn-radio=choixSitfam ng-click=vm.controleChoixSitFam(vm.data.choixSitfam.code) for={{choixSitfam.code}}><input type=radio id={{choixSitfam.code}} name=choixSitfam aria-label={{choixSitfam.libelle}} class=sr-only ng-model=vm.data.choixSitfam value={{choixSitfam.code}} required> <span aria-hidden=true>{{choixSitfam.libelle}}</span></label></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.choixSitfam == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></fieldset></div><div class=row><div class=col-sm-4><div ng-if=\"vm.controle.sitfamConnue != 'MAR' && vm.controle.sitfamConnue != 'RVM'\"><label class=label-form-cnaf for=dateSitfam>Depuis le</label></div><div ng-if=\"vm.controle.sitfamConnue == 'MAR' || vm.controle.sitfamConnue == 'RVM'\"><label class=label-form-cnaf for=dateSitfam>Vous êtes séparé(e) depuis le</label></div><div id=divDateSitfam class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                        (vm.sitfamform.dateSitfam.$invalid\n" +
    "                        && !vm.sitfamform.dateSitfam.$pristine)\n" +
    "                        || (vm.sitfamform.dateSitfam.$error.pattern && vm.data.dateSitfam.length == 10)\n" +
    "                        || vm.sitfamform.dateSitfam.$error.controleInfDateSitfamConnue\n" +
    "                        || vm.sitfamform.dateSitfam.$error.controleDateSitfam\n" +
    "                        || ((vm.data.dateSitfam == undefined || vm.data.dateSitfam == 'jj/mm/aaaa') && vm.controle.submitted)\n" +
    "                      }\"><div class=\"form-group input-group\"><input id=dateSitfam title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.dateSitfam class=form-control ui-validate=\"{controleInfDateSitfamConnue  : 'vm.controleInfDateSitfamConnue($value, vm.dateMinimum)',\n" +
    "                                          controleDateSitfam : 'vm.controleDateSitfam($value, vm.today)'\n" +
    "                            }\" ng-required=true name=dateSitfam pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.dateSitfam start-year=2000 pattern-cnaf=dd/MM/yyyy inputname=dateSitfam></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"(vm.data.dateSitfam.length == 10) && vm.sitfamform.dateSitfam.$error.pattern \">Format de date invalide</p><p class=help-block role=alert ng-show=vm.sitfamform.dateSitfam.$error.controleInfDateSitfamConnue>La date saisie doit être postérieure à {{vm.dateMinimum | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=vm.sitfamform.dateSitfam.$error.controleDateSitfam>La date saisie ne peut être postérieure au {{vm.today | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=\"((vm.data.dateSitfam == undefined || vm.data.dateSitfam == 'jj/mm/aaaa') && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></div>")

$templateCache.put("components/cnaf-cct-sitfam-isolement/cnaf-cct-sitfam-isolement.component.html","<div class=row><fieldset><div class=col-sm-4><legend class=label-form-cnaf>Vous êtes</legend></div><div class=\"form-group btn-group-lg-cnaf btn-group btn-block\" id=isolementRadioGroup data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "              vm.sitfamisolementform.typeIsolement.$invalid && !vm.sitfamisolementform.typeIsolement.$pristine\n" +
    "              || (vm.data.typeIsolement == undefined && vm.controle.submitted)\n" +
    "            }\"><div class=\"col-xs-12 col-sm-4\"><label class=\"btn btn-default align-middle-cnaf btn-block\" ng-model=vm.data.typeIsolement uib-btn-radio=vm.listeTypeIsolement[0].code for=typeIsolementCEL><input type=radio name=typeIsolement aria-label={{vm.listeTypeIsolement[0].libelle}} class=sr-only id=typeIsolementCEL ng-model=vm.data.typeIsolement value=CEL required> <span aria-hidden=true>{{vm.listeTypeIsolement[0].libelle}}</span></label></div><div class=\"col-xs-12 col-sm-4\"><label class=\"btn btn-default align-middle-cnaf btn-block\" ng-model=vm.data.typeIsolement uib-btn-radio=vm.listeTypeIsolement[1].code for=typeIsolementDIV><input type=radio name=typeIsolement aria-label={{vm.listeTypeIsolement[1].libelle}} class=sr-only id=typeIsolementDIV ng-model=vm.data.typeIsolement value=DIV required> <span aria-hidden=true>{{vm.listeTypeIsolement[1].libelle}}</span></label></div><div class=\"col-xs-12 col-sm-4\"><label class=\"btn btn-default btn-block\" ng-model=vm.data.typeIsolement uib-btn-radio=vm.listeTypeIsolement[2].code for=typeIsolementISO><input type=radio name=typeIsolement aria-label={{vm.listeTypeIsolement[2].libelle}} class=sr-only id=typeIsolementISO ng-model=vm.data.typeIsolement value=ISO required> <span aria-hidden=true>{{vm.listeTypeIsolement[2].libelle}}</span></label></div><div class=\"col-xs-12 col-sm-4\"><span class=pull-right><cnaf-aide tabindex=0 data-toggle=popover data-content=\"Couple marié séparé sans jugement\" data-container=body data-trigger=manual></span><label class=\"btn btn-default align-middle-cnaf btn-block\" ng-model=vm.data.typeIsolement uib-btn-radio=vm.listeTypeIsolement[3].code for=typeIsolementSEF><input type=radio name=typeIsolement aria-label={{vm.listeTypeIsolement[3].libelle}} class=sr-only id=typeIsolementSEF ng-model=vm.data.typeIsolement value=SEF required> <span aria-hidden=true>{{vm.listeTypeIsolement[3].libelle}}</span></label></div><div class=\"col-xs-12 col-sm-4\"><span class=pull-right><cnaf-aide tabindex=0 data-toggle=popover data-content=\"Couple marié, séparé avec prononciation d’un jugement de séparation\" data-container=body data-trigger=manual></span><label class=\"btn btn-default align-middle-cnaf btn-block\" ng-model=vm.data.typeIsolement uib-btn-radio=vm.listeTypeIsolement[4].code for=typeIsolementSEL><input type=radio name=typeIsolement aria-label={{vm.listeTypeIsolement[4].libelle}} class=sr-only id=typeIsolementSEL ng-model=vm.data.typeIsolement value=SEL required> <span aria-hidden=true>{{vm.listeTypeIsolement[4].libelle}}</span></label></div><div class=\"col-xs-12 col-sm-4\"><label class=\"btn btn-default align-middle-cnaf btn-block\" ng-model=vm.data.typeIsolement uib-btn-radio=vm.listeTypeIsolement[5].code for=typeIsolementVEU><input type=radio name=typeIsolement aria-label={{vm.listeTypeIsolement[5].libelle}} class=sr-only id=typeIsolementVEU ng-model=vm.data.typeIsolement value=VEU required> <span aria-hidden=true>{{vm.listeTypeIsolement[5].libelle}}</span></label></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.typeIsolement == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></fieldset></div><div class=row ng-if=\"vm.data.typeIsolement && (vm.data.typeIsolement !== vm.listeTypeIsolement[0].code)\"><div class=col-sm-4><label class=label-form-cnaf for=dateTypeIsolement>Depuis le</label><div id=divDateTypeIsolement class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                    (vm.sitfamisolementform.dateTypeIsolement.$invalid\n" +
    "                    && !vm.sitfamisolementform.dateTypeIsolement.$pristine)\n" +
    "                    || (vm.sitfamisolementform.dateTypeIsolement.$error.pattern && vm.data.dateTypeIsolement.length == 10)\n" +
    "                    || (vm.data.dateTypeIsolement == undefined && vm.controle.submitted)\n" +
    "                  }\"><div class=\"form-group input-group\"><input id=dateTypeIsolement title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 value={{vm.data.dateTypeIsolement}} ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.dateTypeIsolement class=form-control ng-required=true name=dateTypeIsolement pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.dateTypeIsolement start-year=2000 pattern-cnaf=dd/MM/yyyy inputname=dateTypeIsolement></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"(vm.data.dateTypeIsolement.length == 10) && vm.sitfamisolementform.dateTypeIsolement.$error.pattern \">Format de date invalide</p><p class=help-block role=alert ng-show=\"((vm.data.dateTypeIsolement == undefined  || vm.data.dateTypeIsolement == 'jj/mm/aaaa') && vm.controle.submitted)\">Champ obligatoire</p></div></div></div>")

$templateCache.put("components/cnaf-cct-sitfam-situationcouple/cnaf-cct-sitfam-situationcouple.component.html","<div class=row><fieldset><div class=col-sm-4><legend class=label-form-cnaf for=sitfam-situationcouple>Vous êtes</legend></div><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "              vm.sitfamsituationcoupleform.situationCouple.$invalid && !vm.sitfamsituationcoupleform.situationCouple.$pristine\n" +
    "              || (vm.data.situationCouple == undefined && vm.controle.submitted)\n" +
    "            }\"><div class=col-sm-4 ng-repeat=\"situationCouple in vm.listeSituationsCouple\"><label class=\"btn btn-default btn-block\" ng-model=vm.data.situationCouple uib-btn-radio=situationCouple.code for={{situationCouple.code}}><input type=radio name=situationCouple ng-model=vm.data.situationCouple aria-label={{situationCouple.libelle}} class=sr-only id={{situationCouple.code}} required> <span aria-hidden=true>{{situationCouple.libelle}}</span></label></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.situationCouple == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></fieldset></div><div class=row><div class=col-sm-4><label class=label-form-cnaf for=dateSituationCouple>Depuis le</label><div id=divDateSituationCouple class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                    (vm.sitfamsituationcoupleform.dateSituationCouple.$invalid\n" +
    "                    && !vm.sitfamsituationcoupleform.dateSituationCouple.$pristine)\n" +
    "                    || (vm.sitfamsituationcoupleform.dateSituationCouple.$error.pattern && vm.data.dateSituationCouple.length == 10)\n" +
    "                    || (vm.data.dateSituationCouple == undefined && vm.controle.submitted)\n" +
    "                  }\"><div class=\"form-group input-group\"><input id=dateSituationCouple title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 value={{vm.data.dateSituationCouple}} ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.dateSituationCouple class=form-control ng-required=true name=dateSituationCouple pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.dateSituationCouple start-year=2000 pattern-cnaf=dd/MM/yyyy inputname=dateSituationCouple></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"(vm.data.dateSituationCouple.length == 10) && vm.sitfamisolementform.dateSituationCouple.$error.pattern \">Format de date invalide</p><p class=help-block role=alert ng-show=\"((vm.data.dateSituationCouple == undefined  || vm.data.dateSituationCouple == 'jj/mm/aaaa') && vm.controle.submitted)\">Champ obligatoire</p></div></div></div>")

$templateCache.put("components/cnaf-cct-sitpro-taux-activite/cnaf-cct-sitpro-taux-activite.html","<cnaf-calendar></cnaf-calendar><div ng-init=vm.init()><div class=row><div class=col-sm-6><div><label class=\"label-form-cnaf control-label\" for=tauxActivite>Préciser le nouveau taux d'activité</label></div><div><div class=\"col-sm-6 form-group input-group has-feedback\" ng-class=\"{'has-error' : (\n" +
    "                  vm.tauxactiviteform.tauxActivite.$invalid && \n" +
    "                  !vm.tauxactiviteform.tauxActivite.$pristine &&\n" +
    "                  vm.tauxactiviteform.tauxActivite.$error.pattern)}\"><input id=tauxActivite ng-model=vm.data.tauxActivite name=tauxActivite class=form-control pattern=(^100(\\.0{1,2})?$)|(^([1-9]([0-9])?)?$) placeholder=\"Exemple : 50\" ng-required=true aria-describedby=\"tauxActiviteRequired \n" +
    "                                            tauxActivitePattern\"> <span class=input-group-btn><span class=\"picto cct-picto-poucentage-cnaf form-control-feedback\"></span><cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-tauxActivite data-container=body data-trigger=manual tabindex=0></span><div class=hidden id=content-popover-tauxActivite><div class=popover-btn-close-cnaf></div>Indiquer le % d'activité figurant sur votre contrat de travail ou son avenant (inutile de saisir les chiffres après la virgule).</div></div><div><cnaf-cct-erreur-input iderreur=tauxActiviteRequired condition=\"{{(vm.tauxactiviteform.tauxActivite.$invalid \n" +
    "                                    && !vm.tauxactiviteform.tauxActivite.$pristine)\n" +
    "                                && vm.tauxactiviteform.tauxActivite.$error.required}}\" message=\"Champ obligatoire.\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=tauxActivitePattern condition=\"{{(vm.tauxactiviteform.tauxActivite.$invalid \n" +
    "                                    && !vm.tauxactiviteform.tauxActivite.$pristine)\n" +
    "                                && vm.tauxactiviteform.tauxActivite.$error.pattern\n" +
    "                                && !vm.tauxactiviteform.tauxActivite.$error.required}}\" message=\"Le taux d’activité doit être supérieur à 0 et inférieur ou égal à 100.\"></cnaf-cct-erreur-input></div></div></div></div><div class=row><div class=col-sm-3><div><label class=label-form-cnaf for=dateChgmtTauxAct>Depuis le</label></div><div id=divDateChgmtTauxAct class=\"form-group input-group\" ng-class=\"\n" +
    "                { 'has-error' :\n" +
    "                    (vm.tauxactiviteform.dateChgmtTauxAct.$invalid\n" +
    "                    && !vm.tauxactiviteform.dateChgmtTauxAct.$pristine\n" +
    "                    && vm.tauxactiviteform.dateChgmtTauxAct.$error.required)\n" +
    "                    || (vm.tauxactiviteform.dateChgmtTauxAct.$error.pattern && vm.data.dateChgmtTauxAct.length == 10)\n" +
    "                    || vm.tauxactiviteform.dateChgmtTauxAct.$error.controleInfDateProConnue\n" +
    "                    || vm.tauxactiviteform.dateChgmtTauxAct.$error.controleDateChgmtTauxAct\n" +
    "                    || (vm.data.controleDateChgmtTauxAct == undefined && vm.controle.submitted)\n" +
    "                    || (vm.data.controleInfDateProConnue == undefined && vm.controle.submitted)\n" +
    "                  }\"><div class=\"form-group input-group\"><input id=dateChgmtTauxAct title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.dateChgmtTauxAct class=form-control ui-validate=\"{controleInfDateProConnue  : 'vm.controleInfDateProConnue($value)',\n" +
    "                            controleDateChgmtTauxAct : 'vm.controleDateChgmtTauxAct($value, vm.today)'}\" ng-required=true name=dateChgmtTauxAct pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.dateChgmtTauxAct start-year=2000 pattern-cnaf=dd/MM/yyyy inputname=dateChgmtTauxAct></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"(vm.data.dateChgmtTauxAct.length == 10) && vm.tauxactiviteform.dateChgmtTauxAct.$error.pattern \">Format de date invalide</p><p class=help-block role=alert ng-show=vm.tauxactiviteform.dateChgmtTauxAct.$error.controleInfDateProConnue>La date saisie doit être postérieure à {{vm.dateSitProMin | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=vm.tauxactiviteform.dateChgmtTauxAct.$error.controleDateChgmtTauxAct>La date saisie ne peut être postérieure au {{vm.today | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=\"((vm.data.dateChgmtTauxAct == undefined || vm.data.dateChgmtTauxAct == 'jj/mm/aaaa') && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></div>")

$templateCache.put("components/cnaf-cct-telcourriel/cnaf-cct-telcourriel.html","<div><div class=row><div class=col-sm-4><label class=label-form-cnaf for=telephonePortable>Téléphone portable</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                            (vm.telcourrielform.telephonePortable.$invalid && !vm.telcourrielform.telephonePortable.$pristine)\n" +
    "                            || vm.telcourrielform.telephonePortable.$error.type2\n" +
    "                             }\"><input id=telephonePortable ng-model=vm.data.telephonePortable ng-disabled=vm.controle.idConnTelOK maxlength=15 name=telephonePortable ui-options=\"{clearOnBlur:false, allowInvalidValue:true}\" class=form-control ui-mask=\"99 99 99 99 99\" ui-mask-placeholder-char=space ng-blur=\"vm.testType2(vm.data.telephonePortable,vm.telcourrielform.telephonePortable,'telephonePortable')\"><p class=help-block role=alert ng-show=vm.telcourrielform.telephonePortable.$error.pattern>Le numéro de téléphone est incorrect</p><p class=help-block role=alert ng-show=vm.telcourrielform.telephonePortable.$error.type2>{{vm.telcourrielform.telephonePortable.invalidmsg}}</p><p class=help-block role=alert ng-show=vm.telcourrielform.telephonePortable.$error.zeroSixSept>Le numéro de portable doit commencer par 06 ou 07</p></div></div></div><cnaf-cct-courriel data=vm.data courrielform=vm.telcourrielform errorcourriel=vm.errortelcourriel controle=vm.controle></cnaf-cct-courriel><br></div>")

$templateCache.put("components/cnaf-cct-telcourriel-couple/cnaf-cct-telcourriel-couple.html","<div><div class=row><div class=col-sm-4><div class=row><label class=label-form-cnaf for=telephonePortable>Téléphone (<em>portable de préférence</em>)</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                            (vm.telcourrielform.telephonePortable.$invalid && !vm.telcourrielform.telephonePortable.$pristine)\n" +
    "                            || vm.telcourrielform.telephonePortable.$error.type2\n" +
    "                             }\"><input id=telephonePortable ng-model=vm.data.telephonePortable ng-readonly=vm.controle.idConnTelOK maxlength=15 name=telephonePortable ui-options=\"{clearOnBlur:false, allowInvalidValue:true}\" class=form-control ui-mask=\"99 99 99 99 99\" ui-mask-placeholder-char=space ng-blur=\"vm.testType2(vm.data.telephonePortable,vm.telcourrielform.telephonePortable,'telephonePortable')\"><p class=help-block role=alert ng-show=vm.telcourrielform.telephonePortable.$error.pattern>Le numéro de téléphone est incorrect</p><p class=help-block role=alert ng-show=vm.telcourrielform.telephonePortable.$error.type2>{{vm.telcourrielform.telephonePortable.invalidmsg}}</p><p class=help-block role=alert ng-show=vm.telcourrielform.telephonePortable.$error.zeroSixSept>Le numéro de portable doit commencer par 06 ou 07</p></div></div></div><div class=\"col-sm-4 col-sm-offset-2\"><label class=label-form-cnaf for=telephone2>Téléphone (<em>portable de préférence</em>)</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                            (vm.telcourrielform.telephone2.$invalid && !vm.telcourrielform.telephone2.$pristine)\n" +
    "                            || vm.telcourrielform.telephone2.$error.type2\n" +
    "                             }\"><input id=telephone2 ng-model=vm.data.telephone2 ng-readonly=vm.controle.idConnTelOK maxlength=15 name=telephone2 ui-options=\"{clearOnBlur:false, allowInvalidValue:true}\" class=form-control ui-mask=\"99 99 99 99 99\" ui-mask-placeholder-char=space ng-blur=\"vm.testType2(vm.data.telephone2,vm.telcourrielform.telephone2,'telephone2')\"><p class=help-block role=alert ng-show=vm.telcourrielform.telephone2.$error.pattern>Le numéro de téléphone est incorrect</p><p class=help-block role=alert ng-show=vm.telcourrielform.telephone2.$error.type2>{{vm.telcourrielform.telephone2.invalidmsg}}</p><p class=help-block role=alert ng-show=vm.telcourrielform.telephone2.$error.zeroSixSept>Le numéro de portable doit commencer par 06 ou 07</p></div></div></div><cnaf-cct-courriel data=vm.data courrielform=vm.telcourrielform errorcourriel=vm.errortelcourriel controle=vm.controle></cnaf-cct-courriel><br></div>")

$templateCache.put("components/cnaf-cct-telephones/cnaf-cct-telephones.html","<div class=row><div class=col-sm-5><label class=label-form-cnaf for=telephone1>Téléphone portable</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                    (vm.telephonesform.telephone1.$invalid && !vm.telephonesform.telephone1.$pristine)\n" +
    "                    || vm.telephonesform.telephone1.$error.type2\n" +
    "                    || vm.telephonesform.telephone1.$error.zeroSixSept\n" +
    "                    || vm.errortelephones\n" +
    "                     }\"><input id=telephone1 title=\"Saisie de numéro de téléphone portable. Format attendu : 06 23 45 67 89\" class=form-control ng-model=vm.data.telephone1 ng-maxlength=15 name=telephone1 aria-describedby=\"\n" +
    "                  format_attendu_tel1\n" +
    "                  alerte_input_telephone1\n" +
    "                  alerte_input_telephone1_zeroSixSept\" ui-options=\"{clearOnBlur:false, allowInvalidValue:true}\" class=form-control ui-mask=\"99 99 99 99 99\" ui-mask-placeholder-char=space ng-blur=\"vm.testType2(vm.data.telephone1,vm.telephonesform.telephone1,'telephone1');vm.controleTelephones(vm.data.telephone1,vm.data.telephone2,vm.telephonesform.telephone1);\"><p id=format_attendu_tel1 class=sr-only>Saisie de numéro de téléphone. Format attendu : 06 11 22 33 44</p><cnaf-cct-erreur-input iderreur=alerte_input_telephone1 condition={{vm.telephonesform.telephone1.$error.type2}} message={{vm.telephonesform.telephone1.invalidmsg}}></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=alerte_input_telephone1_zeroSixSept condition={{vm.telephonesform.telephone1.$error.zeroSixSept}} message=\"Le numéro de portable doit commencer par 06 ou 07. Exemple : 06 21 35 68 98\"></cnaf-cct-erreur-input></div></div><div class=col-sm-5><label class=label-form-cnaf for=telephone2>Téléphone fixe</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                    (vm.telephonesform.telephone2.$invalid && !vm.telephonesform.telephone2.$pristine)\n" +
    "                    || vm.telephonesform.telephone2.$error.type2\n" +
    "                    || vm.telephonesform.telephone2.$error.fixe\n" +
    "                    || vm.errortelephones\n" +
    "                     }\"><input id=telephone2 title=\"Saisie de numéro de téléphone. Format attendu : 02 23 45 67 89\" ng-model=vm.data.telephone2 maxlength=15 name=telephone2 aria-describedby=\"\n" +
    "                    format_attendu_tel2\n" +
    "                    alerte_input_telephone2\n" +
    "                    alerte_input_telephone2_fixe\" ui-options=\"{clearOnBlur:false, allowInvalidValue:true}\" class=form-control ui-mask=\"99 99 99 99 99\" ui-mask-placeholder-char=space ng-blur=\"vm.testType2(vm.data.telephone2,vm.telephonesform.telephone2,'telephone2');\n" +
    "                            vm.controleTelephoneFixe(vm.data.telephone2,vm.telephonesform.telephone2);\"><p id=format_attendu_tel2 class=sr-only>Saisie de numéro de téléphone. Format attendu : 02 11 22 33 44.</p><cnaf-cct-erreur-input iderreur=alerte_input_telephone2 condition={{vm.telephonesform.telephone2.$error.type2}} message={{vm.telephonesform.telephone2.invalidmsg}}></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=alerte_input_telephone2_fixe condition={{vm.telephonesform.telephone2.$error.fixe}} message=\"Numéro de téléphone fixe attendu. Exemple : 03 21 35 68 98.\"></cnaf-cct-erreur-input></div></div></div>")

$templateCache.put("components/cnaf-cct-telephoneseul/cnaf-cct-telephoneseul.html","<div class=row><div class=col-sm-4><div class=row><label class=label-form-cnaf for=telephonePortable>Téléphone (<em>portable de préférence</em>)</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                        (vm.telephoneseulform.telephonePortable.$invalid && !vm.telephoneseulform.telephonePortable.$pristine)\n" +
    "                        || vm.telephoneseulform.telephonePortable.$error.type2\n" +
    "                         }\"><input id=telephonePortable ng-model=vm.data.telephonePortable maxlength=15 name=telephonePortable ui-options=\"{clearOnBlur:false, allowInvalidValue:true}\" class=form-control ui-mask=\"99 99 99 99 99\" ui-mask-placeholder-char=space ng-blur=\"vm.testType2(vm.data.telephonePortable,vm.telephoneseulform.telephonePortable,'telephonePortable')\"><p class=help-block role=alert ng-show=vm.telephoneseulform.telephonePortable.$error.pattern>Le numéro de téléphone est incorrect</p><p class=help-block role=alert ng-show=vm.telephoneseulform.telephonePortable.$error.type2>{{vm.telephoneseulform.telephonePortable.invalidmsg}}</p><p class=help-block role=alert ng-show=vm.telephoneseulform.telephonePortable.$error.zeroSixSept>Le numéro de portable doit commencer par 06 ou 07</p></div></div></div></div>")

$templateCache.put("components/cnaf-cct-recap/cnaf-cct-recap-acces/cnaf-cct-recap-acces.html","<div class=row ng-if=\"vm.data.fiscalementAttacheParents && !vm.data.isf\"><div class=col-sm-12><div class=texte-clair-cnaf><div>Vous êtes rattaché(e) fiscalement à vos parents<br>Vos parents ne sont assujettis ni à l’Impôt de Solidarité sur la Fortune, ni à l'Impôt sur la Fortune Immobilière</div></div></div></div><div class=row ng-if=!vm.data.fiscalementAttacheParents><div class=col-sm-12><div class=texte-clair-cnaf><div>Vous n’êtes pas rattaché(e) fiscalement à vos parents</div></div></div></div><div class=row ng-if=\"vm.data.statutLocation==='SOUS_LOCATAIRE'\"><div class=col-sm-12><div class=texte-clair-cnaf><div>Vous êtes en sous-location</div></div></div></div><div class=row ng-if=\"vm.data.statutLocation==='CROUS'\"><div class=col-sm-12><div class=texte-clair-cnaf ng-if=\"vm.data.sitFam==='couple'\"><div>Vous êtes logés par le CROUS</div></div><div class=texte-clair-cnaf ng-if=\"vm.data.sitFam==='seul'\"><div>Vous êtes logé(e) par le CROUS</div></div></div></div><div class=row ng-if=\"vm.data.statutLocation==='FOYER'\"><div class=col-sm-12><div class=texte-clair-cnaf><div>Vous êtes en foyer hors CROUS</div></div></div></div><div class=row ng-if=\"!vm.data.appartientAscendants && !(vm.data.statutLocation==='CROUS') && !(vm.data.statutLocation==='FOYER')\"><div class=col-sm-12><div class=texte-clair-cnaf><div>Le logement n’appartient ni à vos ascendants, ni à vos descendants, ni à vous-même</div></div></div></div><div class=row ng-if=\"vm.data.appartientAscendants && !(vm.data.statutLocation==='CROUS') && !(vm.data.statutLocation==='FOYER')\"><div class=col-sm-12><div class=texte-clair-cnaf><div>Le logement appartient pour {{vm.data.pourcentDetenuAscendant}}% à vos ascendants, descendants et/ou à vous-même</div></div></div></div><div class=row ng-if=\"vm.data.titulaireBail==='demandeur'\"><div class=col-sm-12><div class=texte-clair-cnaf><div>Vous êtes titulaire du bail</div></div></div></div><div class=row ng-if=\"vm.data.titulaireBail==='parents'\"><div class=col-sm-12><div class=texte-clair-cnaf><div>Vos parents sont titulaires du bail</div></div></div></div>")

$templateCache.put("components/cnaf-cct-recap/cnaf-cct-recap-adresse/cnaf-cct-recap-adresse.html","<div class=row ng-show=\"vm.projet !== 'CDS'\"><div class=col-sm-12><span class=texte-clair-cnaf>Date d’entrée dans le logement : <span class=text-primary>{{vm.data.data.dateLogement}}</span></span></div><div class=col-sm-12><span class=texte-clair-cnaf ng-if=\"vm.data.data.departLog === 'Oui'\">Vous connaissez votre date de départ du logement<div ng-if=vm.data.data.dateDepLog>Date de départ du logement : <span class=text-primary>{{vm.data.data.dateDepLog}}</span></div></span><span class=texte-clair-cnaf ng-if=\"vm.data.data.departLog === 'Non'\">Vous ne connaissez pas votre date de départ du logement</span></div><div class=col-sm-12><span class=text-primary><div ng-if=vm.data.data.numEtAdresse.lib>{{vm.data.data.numEtAdresse.lib}}</div><div ng-if=!vm.data.data.numEtAdresse.lib>{{vm.data.data.numEtAdresse}}</div><div ng-if=vm.data.data.cplAdr1>{{vm.data.data.cplAdr1}}</div><div ng-if=vm.data.data.lieuDit>{{vm.data.data.lieuDit}}</div><div ng-if=vm.data.data.codePostalVille.lib>{{vm.data.data.codePostalVille.lib}}</div><div ng-if=vm.data.data.pays.libelleCaffr>{{vm.data.data.pays.libelleCaffr}}</div></span></div></div><div class=row ng-show=\"vm.projet === 'CDS'\"><div class=col-sm-12><div class=text-primary ng-if=\"vm.data.data.pays.code == 'FR' || vm.data.data.pays.code == 'MC'\"><div ng-if=vm.data.data.numEtAdresse.lib>{{vm.data.data.numEtAdresse.lib}}</div><div ng-if=!vm.data.data.numEtAdresse.lib>{{vm.data.data.numEtAdresse}}</div><div ng-if=vm.data.data.cplAdr1>{{vm.data.data.cplAdr1}}</div><div ng-if=vm.data.data.cplAdr2>{{vm.data.data.cplAdr2}}</div><div ng-if=vm.data.data.lieuDit>{{vm.data.data.lieuDit}}</div><div ng-if=vm.data.data.codePostalVille.lib>{{vm.data.data.codePostalVille.lib}}</div></div><div class=text-primary ng-if=\"vm.data.data.pays.code != 'FR' && vm.data.data.pays.code != 'MC'\"><div ng-if=vm.data.data.etrangerAdresse>{{vm.data.data.etrangerAdresse}}</div><div ng-if=vm.data.data.etrangerAdresseSuite>{{vm.data.data.etrangerAdresseSuite}}</div><div ng-if=vm.data.data.etrangerVille>{{vm.data.data.etrangerVille}}</div></div><div class=text-primary>{{vm.data.data.pays.libelleCaffr}}</div><br><div class=row><div class=col-sm-12 ng-if=vm.data.data.dateLogement><div class=texte-clair-cnaf><span ng-if=\"vm.data.data.pays.code == 'FR' || vm.data.data.pays.code == 'MC'\">Date d'emménagement dans votre nouveau logement : </span><span ng-if=\"vm.data.data.pays.code != 'FR' && vm.data.data.pays.code != 'MC'\">Date de départ : </span><span class=text-primary>{{vm.data.data.dateLogement}}</span></div></div><div class=col-sm-12 ng-if=vm.data.data.tousDemenage><div class=texte-clair-cnaf>Toutes les personnes de votre foyer ont déménagé</div></div><div class=col-sm-12 ng-if=\"vm.data.data.tousDemenage===false\"><div class=texte-clair-cnaf>Toutes les personnes de votre foyer n'ont pas déménagé</div></div></div><div ng-if=\"vm.data.data.dateFinBail || vm.data.data.dateDerniereMensualite\"><div class=row ng-if=vm.data.data.dateFinBail><div class=col-sm-12><div class=texte-clair-cnaf>Date de fin de bail de votre logement : <span class=text-primary>{{vm.data.data.dateFinBail}}</span></div></div></div><div class=row ng-if=\"vm.data.data.loyerPaye === true\"><div class=col-sm-12><div class=texte-clair-cnaf>Vous avez payé un loyer pour votre nouveau logement au cours du mois de <span class=text-primary>{{vm.litteralMonth(vm.parseDate(vm.data.data.dateFinBail))}}</span>.</div></div></div><div class=row ng-if=\"vm.data.data.loyerPaye === false\"><div class=col-sm-12><div class=texte-clair-cnaf>Vous n'avez pas payé de loyer pour votre nouveau logement au cours du mois de <span class=text-primary>{{vm.litteralMonth(vm.parseDate(vm.data.data.dateFinBail))}}</span>.</div></div></div><div class=row ng-if=vm.data.data.dateDerniereMensualite><div class=col-sm-12><div class=texte-clair-cnaf>Date de dernière mensualité de prêt payé : <span class=text-primary>{{vm.data.data.dateDerniereMensualite}}</span></div></div></div></div><div class=row ng-if=vm.data.data.typeLogement><div class=col-sm-12><div class=texte-clair-cnaf>A cette nouvelle adresse, vous êtes : <span class=text-primary>{{vm.data.data.typeLogement.libelle}}</span></div></div></div></div></div>")

$templateCache.put("components/cnaf-cct-recap/cnaf-cct-recap-coordbanc/cnaf-cct-recap-coordbanc.html","<div class=row><div class=col-sm-12><span class=texte-clair-cnaf>Titulaire du compte : <span class=text-primary>{{vm.data.data.libelleTit}}</span></span></div><div class=col-sm-12><span class=texte-clair-cnaf>IBAN : <span class=text-primary>{{vm.affichageIbanAvecBlanc(vm.data.data.iban)}}</span></span></div><div class=col-sm-12><span class=texte-clair-cnaf>BIC : <span class=text-primary>{{vm.data.data.bic}}</span></span></div></div>")

$templateCache.put("components/cnaf-cct-recap/cnaf-cct-recap-courriel/cnaf-cct-recap-courriel.html","<div class=row ng-show=\"vm.projet !== 'CDS'\"><div class=col-sm-12><span class=texte-clair-cnaf>Courriel : <span class=text-primary ng-if=vm.data.data.email>{{vm.data.data.email}} </span><span class=texte-clair-cnaf ng-if=!vm.data.data.email>Non communiqué</span></span></div></div><div class=row ng-show=\"vm.projet === 'CDS'\"><div class=col-sm-12><div class=texte-clair-cnaf><div>Adresse courriel : <span class=text-primary ng-show=vm.data.data.email>{{vm.data.data.email}} </span><span class=text-primary ng-show=!vm.data.data.email>non renseignée</span></div></div></div></div>")

$templateCache.put("components/cnaf-cct-recap/cnaf-cct-recap-etatcivil/cnaf-cct-recap-etatcivil.html","<div class=row><div class=col-sm-12><span class=texte-clair-cnaf ng-switch=vm.data.data.sexe><span ng-switch-when=Féminin>Madame </span><span ng-switch-when=Masculin>Monsieur </span>{{vm.data.data.prenom.toString().charAt(0).toUpperCase() + vm.data.data.prenom.substring(1).toLowerCase()}} {{vm.data.data.nom}}</span></div></div><div class=row ng-if=vm.data.data.nomUsage><div class=col-sm-12><span class=texte-clair-cnaf>Nom d'usage : <span class=text-primary>{{vm.data.data.nomUsage}}</span></span></div></div><div class=row><div class=col-sm-12><span class=texte-clair-cnaf>Date de naissance : <span class=text-primary>{{vm.data.data.dateNaissance}}</span></span></div></div><div class=row ng-if=vm.data.data.nir><div class=col-sm-12><span class=texte-clair-cnaf>Numéro de Sécurité sociale : <span class=text-primary>{{vm.afficherNirAvecBlanc(vm.data.data.nir)}}</span></span></div></div><div class=row ng-if=\"!vm.data.data.nir && !vm.conjoint\"><div class=col-sm-12><span class=texte-clair-cnaf>Numéro de Sécurité sociale : Non communiqué</span></div></div><div class=row ng-if=\"vm.data.data.lieunaissance == 'FranceDOM'\"><div class=col-sm-12><span class=texte-clair-cnaf>Lieu de naissance : <span class=text-primary>{{vm.data.data.codePostalVille.lib}}</span></span></div></div><div class=row ng-if=\"vm.data.data.lieunaissance == 'COM'\"><div class=col-sm-12><span class=texte-clair-cnaf>Lieu de naissance : <span class=text-primary>{{vm.data.data.COMnaissance.libelle}}</span></span></div></div><div class=row ng-if=\"vm.data.data.lieunaissance == 'Etranger'\"><div class=col-sm-12><span class=texte-clair-cnaf>Lieu de naissance : <span class=text-primary>{{vm.data.data.paysNaissance.libelleCaffr}} {{vm.data.data.villeNaiss}}</span></span></div></div><div class=row ng-if=vm.data.data.nationalite><div class=col-sm-12><span class=texte-clair-cnaf>Nationalité : <span class=text-primary>{{vm.data.data.nationalite.libelle}}</span></span></div></div><div class=row ng-if=vm.data.data.nomPere><div class=col-sm-12><span class=texte-clair-cnaf>Nom et prénom du père : <span class=text-primary>{{vm.data.data.nomPere}} {{vm.data.data.prenomPere.toString().charAt(0).toUpperCase() + vm.data.data.prenomPere.substring(1).toLowerCase()}}</span></span></div></div><div class=row ng-if=vm.data.data.nomMere><div class=col-sm-12><span class=texte-clair-cnaf>Nom et prénom de la mère : <span class=text-primary>{{vm.data.data.nomMere}} {{vm.data.data.prenomMere.toString().charAt(0).toUpperCase() + vm.data.data.prenomMere.substring(1).toLowerCase()}}</span></span></div></div><div class=row ng-if=\"vm.data.data.arriveEtranger == 'Oui'\"><div class=col-sm-12><span class=texte-clair-cnaf>{{vm.data.data.prenom.toString().charAt(0).toUpperCase() + vm.data.data.prenom.substring(1).toLowerCase()}} {{vm.data.data.nom}} arrive de l'étranger</span><br><span class=texte-clair-cnaf>Date d'entrée en France : <span class=text-primary>{{vm.data.data.dtEntreeFrance}}</span></span></div></div><div class=row ng-if=\"vm.data.data.arriveEtranger != 'Oui'\"><div class=col-sm-12><span class=texte-clair-cnaf>{{vm.data.data.prenom.toString().charAt(0).toUpperCase() + vm.data.data.prenom.substring(1).toLowerCase()}} {{vm.data.data.nom}} n'arrive pas de l'étranger</span></div></div><div class=row ng-if=\"vm.conjoint == true && vm.data.data.resideEtranger == 'Oui'\"><div class=col-sm-12><span class=texte-clair-cnaf>{{vm.data.data.prenom.toString().charAt(0).toUpperCase() + vm.data.data.prenom.substring(1).toLowerCase()}} {{vm.data.data.nom}} réside à l'étranger</span></div></div><div class=row ng-if=\"vm.conjoint == true && vm.data.data.resideEtranger == 'Oui'\"><div class=col-sm-12><span class=texte-clair-cnaf>Pays de résidence : {{vm.data.data.paysResidenceCjt.libelleCaffr}}</span></div></div><div class=row ng-if=\"vm.conjoint == true && vm.data.data.resideEtranger != 'Oui'\"><div class=col-sm-12><span class=texte-clair-cnaf>{{vm.data.data.prenom.toString().charAt(0).toUpperCase() + vm.data.data.prenom.substring(1).toLowerCase()}} {{vm.data.data.nom}} ne réside pas à l'étranger</span></div></div>")

$templateCache.put("components/cnaf-cct-recap/cnaf-cct-recap-grossesse/cnaf-cct-recap-grossesse.html","<div class=row ng-if=\"vm.data.data.grossesseConfirme === true && vm.data.data.examPreNat === false\"><div class=col-sm-12><span class=texte-clair-cnaf>Le médecin ou la sage-femme a réalisé le 1er examen prénatal et a confirmé la grossesse</span></div></div><div class=row ng-if=\"vm.data.data.grossesseConfirme === false\"><div class=col-sm-12><span class=texte-clair-cnaf>Le médecin ou la sage-femme n'a pas réalisé le 1er examen prénatal et n'a pas confirmé la grossesse</span></div></div><div class=row ng-if=\"vm.data.data.examPreNat === false\"><div class=col-sm-12><span class=texte-clair-cnaf>Le médecin ou la sage-femme ne vous a pas remis le certificat du 1er examen prénatal</span></div></div><div class=row ng-if=\"vm.data.data.grossesseConfirme == true && vm.data.data.examPreNat == true\"><div class=col-sm-12><span class=texte-clair-cnaf>Date de début de grossesse : <span class=text-primary>{{vm.data.data.dateDebutGrossesse}}</span></span><br><span class=texte-clair-cnaf>Date du 1er examen prénatal : <span class=text-primary>{{vm.data.data.dateExamPreNat}}</span></span><br><span class=texte-clair-cnaf>Nombre d'enfants conçus : <span class=text-primary ng-if=\"vm.data.data.nbEnf != '3Plus'\">{{vm.data.data.nbEnf}}</span><span class=text-primary ng-if=\"vm.data.data.nbEnf == '3Plus'\">{{vm.data.data.nbEnfants}}</span></span><br><span class=texte-clair-cnaf>Nom du médecin ou de la sage-femme ayant effectué l'examen prénatal : <span class=text-primary>{{vm.data.data.nomMedecin}}</span></span><br><span class=texte-clair-cnaf>Téléphone du médecin ou de la sage-femme : <span class=text-primary>{{vm.affichageTelephoneAvecBlanc(vm.data.data.telephoneMedecin)}}</span></span></div></div>")

$templateCache.put("components/cnaf-cct-recap/cnaf-cct-recap-hospitalisation/cnaf-cct-recap-hospitalisation.html","<div class=row><div class=col-sm-12><span class=texte-clair-cnaf>{{vm.donneecommune.personneEnCours}} <span ng-if=\"vm.data.data.hospitalisation === 'Oui'\">est hospitalisé </span><span ng-if=\"vm.data.data.hospitalisation === 'Non'\">n’est pas hospitalisé</span></span></div><span ng-if=\"vm.data.data.hospitalisation === 'Oui'\"><div class=col-sm-12><span class=texte-clair-cnaf>Date de début d’hospitalisation : <span class=text-primary>{{vm.data.data.dateDebHosp}}</span></span></div><div class=col-sm-12><span class=texte-clair-cnaf><span ng-if=\"vm.data.data.dateFinHosp !== undefined && vm.data.data.dateFinHosp !== 'jj/mm/aaaa'\">Date de fin d’hospitalisation : <span class=text-primary>{{vm.data.data.dateFinHosp}} </span></span><span ng-if=\"vm.data.data.dateFinHosp === undefined || vm.data.data.dateFinHosp === 'jj/mm/aaaa'\">Date de fin d’hospitalisation : Non communiquée</span></span></div><div class=\"col-sm-12 texte-clair-cnaf\">Nom de l’établissement : <span class=text-primary>{{vm.data.data.nomEtabHosp}}</span></div><div class=\"col-sm-12 texte-clair-cnaf\">Pays de l’établissement : <span class=text-primary>{{vm.data.data.paysEtabHosp.libelleCaffr}}</span></div><div class=col-sm-12><span class=texte-clair-cnaf><span ng-if=\"vm.data.data.paysEtabHosp.libelleCaffr === 'FRANCE'\">Code postal / Commune : <span class=text-primary>{{vm.data.data.codePostalVilleEtabHosp.lib}} </span></span><span ng-if=\"vm.data.data.paysEtabHosp.libelleCaffr !== 'FRANCE'\">Ville : <span class=text-primary>{{vm.data.data.villeEtabHosp}}</span></span></span></div></span></div>")

$templateCache.put("components/cnaf-cct-recap/cnaf-cct-recap-prestationspercues/cnaf-cct-recap-prestationspercues.html","<div class=row ng-if=vm.data.data.prestaParents><div class=col-sm-12><span class=texte-clair-cnaf>Les parents de {{vm.donneecommune.personneEnCours}} perçoivent des prestations familiales.</span></div><div class=\"col-sm-12 texte-clair-cnaf\">Nom et prénom du parent bénéficiaire : <span class=text-primary>{{vm.data.data.nomprenom}}</span></div><div class=\"col-sm-12 texte-clair-cnaf\">Pays : <span class=text-primary>{{vm.data.data.pays.libelleCaffr}}</span></div><div class=col-sm-12><span class=texte-clair-cnaf ng-if=\"vm.data.data.pays.libelleCaffr === 'FRANCE'\">N° et voie / Lieu-dit : <span class=text-primary ng-if=vm.data.data.numEtAdresse.lib>{{vm.data.data.numEtAdresse.lib}} </span><span class=texte-clair-cnaf ng-if=!vm.data.data.numEtAdresse.lib>Non communiqué </span></span><span ng-if=\"vm.data.data.pays.libelleCaffr !== 'FRANCE'\"><span class=texte-clair-cnaf>Adresse : </span><span class=text-primary ng-if=vm.data.data.numEtAdresse>{{vm.data.data.numEtAdresse}} </span><span class=texte-clair-cnaf ng-if=!vm.data.data.numEtAdresse>Non communiqué</span></span></div><div class=col-sm-12><span class=texte-clair-cnaf ng-if=\"vm.data.data.pays.libelleCaffr === 'FRANCE'\">Code postal / Commune : <span class=text-primary>{{vm.data.data.codePostalVille.lib}} </span></span><span class=texte-clair-cnaf ng-if=\"vm.data.data.pays.libelleCaffr !== 'FRANCE'\">Ville : <span class=text-primary>{{vm.data.data.ville}}</span></span></div><div class=\"col-sm-12 texte-clair-cnaf\">Nom de l'organisme : <span class=text-primary>{{vm.data.data.orgaparents}}</span></div><div class=\"col-sm-12 texte-clair-cnaf\">Numéro de dossier : <span class=text-primary ng-if=vm.data.data.numdosparents>{{vm.data.data.numdosparents}} </span><span class=texte-clair-cnaf ng-if=!vm.data.data.numdosparents>Non communiqué</span></div></div><div class=row ng-if=!vm.data.data.prestaParents><div class=col-sm-12><span ng-if=\"vm.data.data.prestaParents === false\" class=texte-clair-cnaf>Les parents de {{vm.donneecommune.personneEnCours}} ne perçoivent pas de prestations familiales.</span></div><div class=col-sm-12><span class=texte-clair-cnaf>{{vm.donneecommune.personneEnCours}} <span ng-if=\"vm.data.data.prestaAutreOrga === 'Non'\">ne perçoit pas de prestations familiales d’un autre organisme. </span><span ng-if=\"vm.data.data.prestaAutreOrga === 'Oui'\">perçoit des prestations familiales d’un autre organisme.</span></span></div><span ng-if=\"vm.data.data.prestaAutreOrga === 'Oui'\"><div class=\"col-sm-12 texte-clair-cnaf\">Nom de l'organisme : <span class=text-primary>{{vm.data.data.autreorga}}</span></div><div class=\"col-sm-12 texte-clair-cnaf\">Numéro de dossier : <span class=text-primary ng-if=vm.data.data.numdosautreorga>{{vm.data.data.numdosautreorga}} </span><span class=texte-clair-cnaf ng-if=!vm.data.data.numdosautreorga>Non communiqué</span></div><div class=\"col-sm-12 texte-clair-cnaf\">Pays de l'organisme : <span class=text-primary>{{vm.data.data.paysautreorga.libelleCaffr}}</span></div></span></div>")

$templateCache.put("components/cnaf-cct-recap/cnaf-cct-recap-ressources/cnaf-cct-recap-ressources.html","<div class=row ng-if=\"vm.data.data.controle.aucunrevenuChckBx === true\"><div class=col-sm-12><span class=texte-clair-cnaf>{{vm.donneecommune.personneEnCours}} n’a déclaré aucun revenu pour cette année.</span></div></div><div class=row ng-if=\"vm.data.data.controle.aucunrevenuChckBx === false\"><div class=col-sm-12><span class=texte-clair-cnaf>{{vm.donneecommune.personneEnCours}} a déclaré pour cette année :</span></div></div><div class=row ng-if=\"vm.data.data.ressources.salaire > 0\"><div class=col-sm-12><span class=texte-clair-cnaf>Salaires, traitements, heures supplémentaires, bourses de recherches : <span class=text-primary>{{vm.data.data.ressources.salaire}} €</span></span></div></div><div class=row ng-if=\"vm.data.data.ressources.chomage > 0\"><div class=col-sm-12><span class=texte-clair-cnaf>Allocations de chômage et préretraites : <span class=text-primary>{{vm.data.data.ressources.chomage}} €</span></span></div></div><div class=row ng-if=\"vm.data.data.ressources.fraisReels > 0\"><div class=col-sm-12><span class=texte-clair-cnaf>Frais réels déductibles : <span class=text-primary>{{vm.data.data.ressources.fraisReels}} €</span></span></div></div><div class=row ng-if=\"vm.data.data.ressources.indemnitesJournaFracImpos > 0\"><div class=col-sm-12><span class=texte-clair-cnaf>Indemnités journalières de maladie, maternité, paternité, adoption, et fraction imposable d'accident du travail ou de maladie professionnelle : <span class=text-primary>{{vm.data.data.ressources.indemnitesJournaFracImpos}} €</span></span></div></div><div class=row ng-if=\"vm.data.data.ressources.indemnitesJournaFracNonImpos > 0\"><div class=col-sm-12><span class=texte-clair-cnaf>Indemnités journalières d'accident du travail ou de maladie professionnelle, fraction non imposable : <span class=text-primary>{{vm.data.data.ressources.indemnitesJournaFracNonImpos}} €</span></span></div></div><div class=row ng-if=\"vm.data.data.ressources.benefEntrepreneur > 0\"><div class=col-sm-12><span class=texte-clair-cnaf>Bénéfices (Bic, Bnc, Ba, micro Bic, micro Bnc, micro Ba), Adhérents d'un centre de gestion agréé, ou «régime micro» ou Auto-entrepreneur/Micro-entrepreneur : <span class=text-primary>{{vm.data.data.ressources.benefEntrepreneur}} €</span></span></div></div><div class=row ng-if=\"vm.data.data.ressources.benefNonAdherents > 0\"><div class=col-sm-12><span class=texte-clair-cnaf>Bénéfices (Bic, Bnc, Ba, micro Bic, micro Bnc, micro Ba), Non adhérents d'un centre de gestion agréé : <span class=text-primary>{{vm.data.data.ressources.benefNonAdherents}} €</span></span></div></div><div class=row ng-if=\"vm.data.data.ressources.deficitPro > 0\"><div class=col-sm-12><span class=texte-clair-cnaf>Déficits professionnels de l’année {{vm.data.data.anneeReference}} : <span class=text-primary>{{vm.data.data.ressources.deficitPro}} €</span></span></div></div><div class=row ng-if=\"vm.data.data.ressources.pensionsRetraitesRentesImposables > 0\"><div class=col-sm-12><span class=texte-clair-cnaf>Retraites, pension et rentes imposables : <span class=text-primary>{{vm.data.data.ressources.pensionsRetraitesRentesImposables}} €</span></span></div></div><div class=row ng-if=\"vm.data.data.ressources.pensionInvalidite > 0\"><div class=col-sm-12><span class=texte-clair-cnaf>Pension d'invalidité : <span class=text-primary>{{vm.data.data.ressources.pensionInvalidite}} €</span></span></div></div><div class=row ng-if=\"vm.data.data.ressources.pensionsAlimentaires > 0\"><div class=col-sm-12><span class=texte-clair-cnaf>Pensions alimentaires reçues : <span class=text-primary>{{vm.data.data.ressources.pensionsAlimentaires}} €</span></span></div></div><div class=row ng-if=\"vm.data.data.ressources.beneficesFonciers > 0\"><div class=col-sm-12><span class=texte-clair-cnaf>Bénéfices fonciers : <span class=text-primary>{{vm.data.data.ressources.beneficesFonciers}} €</span></span></div></div><div class=row ng-if=\"vm.data.data.ressources.deficitsFonciers > 0\"><div class=col-sm-12><span class=texte-clair-cnaf>Déficits fonciers : <span class=text-primary>{{vm.data.data.ressources.deficitsFonciers}} €</span></span></div></div><div class=row ng-if=\"vm.data.data.ressources.epargneHandicap > 0\"><div class=col-sm-12><span class=texte-clair-cnaf>Contrat d'épargne handicap : <span class=text-primary>{{vm.data.data.ressources.epargneHandicap}} €</span></span></div></div><div class=row ng-if=\"vm.data.data.ressources.revenusAutres > 0\"><div class=col-sm-12><span class=texte-clair-cnaf>Autres : <span class=text-primary>{{vm.data.data.ressources.revenusAutres}} €</span></span></div></div><div class=row ng-if=\"vm.data.data.ressources.pensionsAlimVersees > 0\"><div class=col-sm-12><span class=texte-clair-cnaf>Pensions alimentaires versées : <span class=text-primary>{{vm.data.data.ressources.pensionsAlimVersees}} €</span></span></div></div><div class=row ng-if=\"vm.data.data.ressources.pensionDecisionJustice === true\"><div class=col-sm-12><span class=texte-clair-cnaf>La pension a été fixée suite à décision de justice intervenue avant janvier 2006.</span></div></div><div class=row ng-if=\"vm.data.data.ressources.pensionDecisionJustice === false\"><div class=col-sm-12><span class=texte-clair-cnaf>La pension n’a pas été fixée suite à décision de justice intervenue avant janvier 2006.</span></div></div><div class=row ng-if=\"vm.data.data.ressources.csgDeductibles > 0\"><div class=col-sm-12><span class=texte-clair-cnaf>CSG déductible sur les revenus du patrimoine : <span class=text-primary>{{vm.data.data.ressources.csgDeductibles}} €</span></span></div></div><div class=row ng-if=\"vm.data.data.ressources.epargneRetraite > 0\"><div class=col-sm-12><span class=texte-clair-cnaf>Epargne retraite (Perp, Préfon...) cotisations Volontariats de Sécurité sociale : <span class=text-primary>{{vm.data.data.ressources.epargneRetraite}} €</span></span></div></div>")

$templateCache.put("components/cnaf-cct-recap/cnaf-cct-recap-sitpro/cnaf-cct-recap-sitpro.html","<div class=\"row col-sm-12 texte-clair-cnaf\"><span ng-if=\"vm.data.data.sitPros[0].sitproetu === 'ets'\">{{vm.donneecommune.personneEnCours}} est étudiant(e) et a une activité salariée </span><span ng-if=\"vm.data.data.sitPros[0].sitproetu === 'etu' && !vm.data.data.sitPros[0].boursier\">{{vm.donneecommune.personneEnCours}} est étudiant(e) </span><span ng-if=\"vm.data.data.sitPros[0].sitproetu === 'etudiantActNonSal'\">{{vm.donneecommune.personneEnCours}} est étudiant(e) et a une activité non salariée</span></div><div class=\"row col-sm-12\" ng-if=vm.data.data.sitPros[0].dtDebContrat><span class=texte-clair-cnaf>Date de début de contrat : <span class=text-primary>{{vm.data.data.sitPros[0].dtDebContrat}}</span></span></div><div class=\"row col-sm-12\" ng-if=vm.data.data.sitPros[0].dateActNonSal><span class=texte-clair-cnaf>Date de début de contrat de l'activité non salariée : <span class=text-primary>{{vm.data.data.sitPros[0].dateActNonSal}}</span></span></div><div class=\"row col-sm-12 texte-clair-cnaf\"><span ng-if=\"vm.data.data.sitPros[0].couvreanneesco === 'Oui'\">Le contrat de travail couvre la période du 01/09/{{vm.donneecommune.anneePeriode}} au 31/08/{{vm.donneecommune.anneePeriode--1}} </span><span ng-if=\"vm.data.data.sitPros[0].couvreanneesco === 'Non'\">Le contrat de travail ne couvre pas la période du 01/09/{{vm.donneecommune.anneePeriode}} au 31/08/{{vm.donneecommune.anneePeriode--1}}</span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[0].typeheurescontrat === 'hebdo'\">Le nombre d’heures inscrit au contrat est hebdomadaire : <span class=text-primary>{{vm.data.data.sitPros[0].nbheures}} heures </span></span><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[0].typeheurescontrat === 'mensuel'\">Le nombre d’heures inscrit au contrat est mensuel : <span class=text-primary>{{vm.data.data.sitPros[0].nbheures}} heures </span></span><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[0].typeheurescontrat === 'trimestriel'\">Le nombre d’heures inscrit au contrat est trimestriel : <span class=text-primary>{{vm.data.data.sitPros[0].nbheures}} heures </span></span><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[0].typeheurescontrat === 'nonprecise'\">Le nombre d’heures inscrit au contrat est non précisé</span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[0].cotisEmployeur.libelle === 'Urssaf'\">L’employeur cotise à l’Urssaf </span><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[0].cotisEmployeur.libelle === 'MSA'\">L’employeur cotise à la MSA </span><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[0].cotisEmployeur.libelle === 'Autre régime'\">L’employeur cotise à <span class=text-primary>{{vm.data.data.sitPros[0].nomOrganisme}} </span></span><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[0].cotisEmployeur.libelle === 'Régime étranger'\">L’employeur cotise à un régime étranger<div>Pays de cotisation : <span class=text-primary>{{vm.data.data.sitPros[0].paysCotisation.libelleCaffr}}</span></div></span></div><div class=\"row col-sm-12 texte-clair-cnaf\"><span ng-if=\"vm.data.data.sitPros[0].sitproetu === 'etu' && vm.data.data.sitPros[0].boursier === 'Non'\">{{vm.donneecommune.personneEnCours}} est étudiant(e) et n’est pas boursier(ère) </span><span ng-if=\"vm.data.data.sitPros[0].sitproetu === 'etu' && vm.data.data.sitPros[0].boursier === 'Oui'\">{{vm.donneecommune.personneEnCours}} est étudiant(e) boursier(ère) </span><span ng-if=\"vm.data.data.sitPros[0].sitproetu === 'ets' && vm.data.data.sitPros[0].boursier === 'Non'\">{{vm.donneecommune.personneEnCours}} n’est pas étudiant(e) boursier(ère) </span><span ng-if=\"vm.data.data.sitPros[0].sitproetu === 'ets' && vm.data.data.sitPros[0].boursier === 'Oui'\">{{vm.donneecommune.personneEnCours}} est étudiant(e) boursier(ère) </span><span ng-if=\"vm.data.data.sitPros[0].sitproetu === 'etudiantActNonSal' && vm.data.data.sitPros[0].boursier === 'Non'\">{{vm.donneecommune.personneEnCours}} n’est pas étudiant(e) boursier(ère) </span><span ng-if=\"vm.data.data.sitPros[0].sitproetu === 'etudiantActNonSal' && vm.data.data.sitPros[0].boursier === 'Oui'\">{{vm.donneecommune.personneEnCours}} est étudiant(e) boursier(ère)</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.data.sitPros[0].boursier === 'Oui'\"><div>Nom de l’organisme qui a accordé la bourse : <span class=text-primary>{{vm.data.data.sitPros[0].orgabourse}}</span></div><div>Pays de l’organisme : <span class=text-primary>{{vm.data.data.sitPros[0].orgaPays.libelleCaffr}}</span></div><div>Adresse de l’organisme : <span class=text-primary>{{vm.data.data.sitPros[0].orgaadresse}}</span></div></div><div class=\"row texte-clair-cnaf col-sm-12\"><span ng-if=\"vm.data.data.sitPros[0].orgasecu === 'ssetu'\">{{vm.donneecommune.personneEnCours}} est affilié(e) à la Sécurité sociale étudiante </span><span ng-if=\"vm.data.data.sitPros[0].orgasecu === 'ssparents'\">{{vm.donneecommune.personneEnCours}} est couvert(e) par la Sécurité sociale de ses parents </span><span ng-if=\"vm.data.data.sitPros[0].orgasecu === 'ssconjoint'\">{{vm.donneecommune.personneEnCours}} est couvert(e) par la Sécurité sociale de son conjoint </span><span ng-if=\"vm.data.data.sitPros[0].orgasecu === 'ssetranger'\">{{vm.donneecommune.personneEnCours}} est couvert(e) par un régime étranger</span></div><div class=\"row col-sm-12 texte-clair-cnaf\"><span ng-if=vm.data.data.sitPros[0].ressSuffisantesChckBx>{{vm.donneecommune.personneEnCours}} déclare des ressources suffisantes pour vivre</span></div>")

$templateCache.put("components/cnaf-cct-recap/cnaf-cct-recap-sitpro-choixactiviteautresituation/cnaf-cct-sitpro-recap-choixactiviteautresituation.html","<div class=\"row col-sm-12 texte-clair-cnaf\">{{vm.donneecommune.personneEnCours}} <span ng-if=\"vm.data.data.sitPros[vm.index].choixAutreSituation.id == 'activiteSansActivite'\">est sans activité </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixAutreSituation.id == 'activiteArretMaladie'\">est en arrêt maladie </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixAutreSituation.id == 'activiteMOC'\">est membre d’une organisation communautaire </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixAutreSituation.id == 'activiteDetention'\">est en détention </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixAutreSituation.id == 'activiteVolontariat'\"><span ng-if=\"vm.data.data.sitPros[vm.index].choixAutreSituationVolontariat.id == 'volontaireServiceCivique'\">est en service civique </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixAutreSituationVolontariat.id == 'volontaireSapeurPompier'\">est sapeur-pompier volontaire </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixAutreSituationVolontariat.id == 'volontaireArmees'\">est volontaire dans les armées </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixAutreSituationVolontariat.id == 'volontaireInternational'\">est volontaire international </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixAutreSituationVolontariat.id == 'volontaireInsertion'\">est volontaire pour insertion</span></span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].choixAutreSituation.id == 'activiteSansActivite'\n" +
    "                  || vm.data.data.sitPros[vm.index].choixAutreSituation.id == 'activiteArretMaladie'\n" +
    "                  || vm.data.data.sitPros[vm.index].choixAutreSituation.id == 'activiteMOC'\">Date de début de la situation : </span><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].choixAutreSituation.id == 'activiteDetention'\">Date de début de la détention : </span><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].choixAutreSituation.id == 'activiteVolontariat'\">Date de début du volontariat : </span><span class=text-primary>{{vm.data.data.sitPros[vm.index].dateActivite}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"(vm.data.data.sitPros[vm.index].choixAutreSituation.id == 'activiteSansActivite'\n" +
    "            || vm.data.data.sitPros[vm.index].choixAutreSituation.id == 'activiteArretMaladie'\n" +
    "            || vm.data.data.sitPros[vm.index].choixAutreSituation.id == 'activiteMOC')\n" +
    "        && vm.index > 0 && vm.data.data.sitPros[vm.index].dateFinActivite != undefined\">Date de fin de de la situation : <span class=text-primary>{{vm.data.data.sitPros[vm.index].dateFinActivite}}</span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].choixAutreSituation.id == 'activiteDetention'\n" +
    "                        && vm.data.data.sitPros[vm.index].dateFinActivite !== undefined\">Date de fin de la détention : <span class=text-primary>{{vm.data.data.sitPros[vm.index].dateFinActivite}} </span></span><span class=texte-clair-cnaf ng-if=\"(vm.data.data.sitPros[vm.index].choixAutreSituation.id == 'activiteVolontariat' \n" +
    "                && (vm.data.data.sitPros[vm.index].choixAutreSituationVolontariat.id == 'volontaireServiceCivique'\n" +
    "                    || vm.data.data.sitPros[vm.index].choixAutreSituationVolontariat.id == 'volontaireInternational'))\n" +
    "                || (vm.data.data.sitPros[vm.index].choixAutreSituation.id == 'activiteVolontariat' && vm.index > 0 \n" +
    "                    && vm.data.data.sitPros[vm.index].dateFinActivite != undefined)\">Date de fin du volontariat : <span class=text-primary>{{vm.data.data.sitPros[vm.index].dateFinActivite}}</span></span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].choixAutreSituation.id == 'activiteArretMaladie'\"><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].affectionLongueDuree === 'Oui'\">Il s’agit d’une affection longue durée<div>Date de prise en compte de cette affection par l’organisme d’assurance maladie : <span class=text-primary>{{vm.data.data.sitPros[vm.index].datePriseEnCompteAffection}}</span></div></span><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].affectionLongueDuree === 'Non'\">Il ne s’agit pas d’une affection longue durée</span></span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].choixAutreSituation.id == 'activiteMOC'\">Nom de l’organisation communautaire : <span class=text-primary>{{vm.data.data.sitPros[vm.index].nomOrganisationCommunautaire}}</span><div><span class=texte-clair-cnaf>Pays de l’organisation communautaire : </span><span class=text-primary>{{vm.data.data.sitPros[vm.index].paysActivite.libelleCaffr}}</span></div><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].paysActivite.libelleCaffr == 'FRANCE'\">Code postal/Commune de l’organisation communautaire : </span><span ng-if=\"vm.data.data.sitPros[vm.index].paysActivite.libelleCaffr !== 'FRANCE'\">Ville de l’organisation communautaire : </span><span class=text-primary ng-if=vm.data.data.sitPros[vm.index].codePostalZoneActivite.lib>{{vm.data.data.sitPros[vm.index].codePostalZoneActivite.lib}} </span><span class=text-primary ng-if=!vm.data.data.sitPros[vm.index].codePostalZoneActivite.lib>{{vm.data.data.sitPros[vm.index].codePostalZoneActivite}}</span></span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].choixAutreSituation.id == 'activiteDetention'\">Nom de l’établissement pénitentiaire : <span class=text-primary>{{vm.data.data.sitPros[vm.index].nomOrganisationCommunautaire}}</span><div><span class=texte-clair-cnaf>Pays de l’établissement : </span><span class=text-primary>{{vm.data.data.sitPros[vm.index].paysActivite.libelleCaffr}}</span></div><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].paysActivite.libelleCaffr == 'FRANCE'\">Code postal/Commune de l’établissement : </span><span ng-if=\"vm.data.data.sitPros[vm.index].paysActivite.libelleCaffr !== 'FRANCE'\">Ville de l’établissement : </span><span class=text-primary ng-if=vm.data.data.sitPros[vm.index].codePostalZoneActivite.lib>{{vm.data.data.sitPros[vm.index].codePostalZoneActivite.lib}} </span><span class=text-primary ng-if=!vm.data.data.sitPros[vm.index].codePostalZoneActivite.lib>{{vm.data.data.sitPros[vm.index].codePostalZoneActivite}}</span></span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].choixAutreSituation.id == 'activiteVolontariat'\n" +
    "                  && vm.data.data.sitPros[vm.index].choixAutreSituationVolontariat.id == 'volontaireInternational'\">Pays où se déroule le volontariat : <span class=text-primary>{{vm.data.data.sitPros[vm.index].paysActivite.libelleCaffr}}</span></span></div>")

$templateCache.put("components/cnaf-cct-recap/cnaf-cct-recap-sitpro-choixactivitechomage/cnaf-cct-sitpro-recap-choixactivitechomage.html","<div class=\"row col-sm-12\"><span class=texte-clair-cnaf>{{vm.donneecommune.personneEnCours}} est au chômage</span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf>Date de début de la situation : </span><span class=text-primary>{{vm.data.data.sitPros[vm.index].dateActivite}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.index > 0 && vm.data.data.sitPros[vm.index].dateFinActivite != undefined\">Date de fin de la situation : <span class=text-primary>{{vm.data.data.sitPros[vm.index].dateFinActivite}}</span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf>{{vm.donneecommune.personneEnCours}} <span ng-if=\"vm.data.data.sitPros[vm.index].orgInscription.libelle == 'France Travail'\">est inscrit auprès de France Travail </span><span ng-if=\"vm.data.data.sitPros[vm.index].orgInscription.libelle == 'Autre organisme'\">est inscrit auprès de : <span class=text-primary>{{vm.data.data.sitPros[vm.index].nomOrganisme}}</span></span></span></div>")

$templateCache.put("components/cnaf-cct-recap/cnaf-cct-recap-sitpro-choixactivitecongesdivers/cnaf-cct-sitpro-recap-choixactivitecongesdivers.html","<div class=\"row col-sm-12\"><span class=texte-clair-cnaf>{{vm.donneecommune.personneEnCours}} <span ng-if=\"vm.data.data.sitPros[0].choixCongesDivers.code == 'MAT'\">est en congé maternité </span><span ng-if=\"vm.data.data.sitPros[0].choixCongesDivers.code == 'CCV'\">est en congé conventionnel </span><span ng-if=\"vm.data.data.sitPros[0].choixCongesDivers.code == 'CSS-PARENT'\">est en congé parental ou d’adoption </span><span ng-if=\"vm.data.data.sitPros[0].choixCongesDivers.code == 'CSS'\">est en congé sans solde </span><span ng-if=\"vm.data.data.sitPros[0].choixCongesDivers.code == 'SAB'\">est en congé sabbatique</span></span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf>Date de début de congé : <span class=text-primary>{{vm.data.data.sitPros[vm.index].dateActivite}}</span></span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf>Date de fin de congé : <span class=text-primary>{{vm.data.data.sitPros[vm.index].dateFinActivite}}</span></span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[0].choixCongesDivers.code == 'MAT'\n" +
    "                    || vm.data.data.sitPros[0].choixCongesDivers.code == 'CCV'\"><span ng-if=\"vm.data.data.sitPros[0].choixCongesDivers.code == 'MAT'\">L’organisme qui verse les indemnités cotise </span><span ng-if=\"vm.data.data.sitPros[0].choixCongesDivers.code == 'CCV'\">L’employeur cotise </span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'Régime général'\">au régime général </span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'MSA'\">à la MSA </span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'CGSS'\">à la CGSS </span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'Autre régime'\">à un autre régime</span></span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[0].choixCongesDivers.code === 'CSS-PARENT'\n" +
    "                || vm.data.data.sitPros[0].choixCongesDivers.code === 'CSS'\n" +
    "                || vm.data.data.sitPros[0].choixCongesDivers.code === 'SAB'\">L’assurance maladie de {{vm.donneecommune.personneEnCours}} <span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle == 'CPAM'\">est la CPAM </span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle == 'MSA'\">est la MSA </span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle == 'CGSS'\">est la CGSS </span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle == 'Autre'\">est un autre organisme</span></span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].nomOrganisme != undefined\">Nom de l'organisme : {{vm.data.data.sitPros[vm.index].nomOrganisme}}</span></div>")

$templateCache.put("components/cnaf-cct-recap/cnaf-cct-recap-sitpro-choixactiviteetudiant/cnaf-cct-recap-sitpro-choixactiviteetudiant.html","<div class=\"row col-sm-12 texte-clair-cnaf\"><span ng-if=\"vm.data.data.sitPros[vm.index].sitproetu === 'ets'\">{{vm.donneecommune.personneEnCours}} est étudiant(e) et a une activité salariée </span><span ng-if=\"vm.data.data.sitPros[vm.index].sitproetu === 'etu' && !vm.data.data.sitPros[vm.index].boursier\">{{vm.donneecommune.personneEnCours}} est étudiant(e) </span><span ng-if=\"vm.data.data.sitPros[vm.index].sitproetu === 'etudiantActNonSal'\">{{vm.donneecommune.personneEnCours}} est étudiant(e) et a une activité non salariée</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.index > 0 && vm.data.data.sitPros[vm.index].dateActivite != undefined\">Date de début de la situation : <span class=text-primary>{{vm.data.data.sitPros[vm.index].dateActivite}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.index > 0 && vm.data.data.sitPros[vm.index].dateFinActivite != undefined\">Date de fin de la situation : <span class=text-primary>{{vm.data.data.sitPros[vm.index].dateFinActivite}}</span></div><div class=\"row col-sm-12\" ng-if=vm.data.data.sitPros[vm.index].dtDebContrat><span class=texte-clair-cnaf>Date de début de contrat : <span class=text-primary>{{vm.data.data.sitPros[vm.index].dtDebContrat}}</span></span></div><div class=\"row col-sm-12\" ng-if=vm.data.data.sitPros[vm.index].dateActNonSal><span class=texte-clair-cnaf>Date de début de contrat de l'activité non salariée : <span class=text-primary>{{vm.data.data.sitPros[vm.index].dateActNonSal}}</span></span></div><div class=\"row col-sm-12 texte-clair-cnaf\"><span ng-if=\"vm.data.data.sitPros[vm.index].couvreanneesco === 'Oui'\">Le contrat de travail couvre la période du 01/09/{{vm.donneecommune.anneePeriode}} au 31/08/{{vm.donneecommune.anneePeriode--1}} </span><span ng-if=\"vm.data.data.sitPros[vm.index].couvreanneesco === 'Non'\">Le contrat de travail ne couvre pas la période du 01/09/{{vm.donneecommune.anneePeriode}} au 31/08/{{vm.donneecommune.anneePeriode--1}}</span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].typeheurescontrat === 'hebdo'\">Le nombre d’heures inscrit au contrat est hebdomadaire : <span class=text-primary>{{vm.data.data.sitPros[vm.index].nbheures}} heures </span></span><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].typeheurescontrat === 'mensuel'\">Le nombre d’heures inscrit au contrat est mensuel : <span class=text-primary>{{vm.data.data.sitPros[vm.index].nbheures}} heures </span></span><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].typeheurescontrat === 'trimestriel'\">Le nombre d’heures inscrit au contrat est trimestriel : <span class=text-primary>{{vm.data.data.sitPros[vm.index].nbheures}} heures </span></span><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].typeheurescontrat === 'nonprecise'\">Le nombre d’heures inscrit au contrat est non précisé</span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'Urssaf'\">L’employeur cotise à l’Urssaf </span><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'MSA'\">L’employeur cotise à la MSA </span><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'Autre régime'\">L’employeur cotise à <span class=text-primary>{{vm.data.data.sitPros[vm.index].nomOrganisme}} </span></span><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'Régime étranger'\">L’employeur cotise à un régime étranger<div>Pays de cotisation : <span class=text-primary>{{vm.data.data.sitPros[vm.index].paysCotisation.libelleCaffr}}</span></div></span></div><div class=\"row col-sm-12 texte-clair-cnaf\"><span ng-if=\"vm.data.data.sitPros[vm.index].sitproetu === 'etu' && vm.data.data.sitPros[vm.index].boursier === 'Non'\">{{vm.donneecommune.personneEnCours}} est étudiant(e) et n’est pas boursier(ère) </span><span ng-if=\"vm.data.data.sitPros[vm.index].sitproetu === 'etu' && vm.data.data.sitPros[vm.index].boursier === 'Oui'\">{{vm.donneecommune.personneEnCours}} est étudiant(e) boursier(ère) </span><span ng-if=\"vm.data.data.sitPros[vm.index].sitproetu === 'ets' && vm.data.data.sitPros[vm.index].boursier === 'Non'\">{{vm.donneecommune.personneEnCours}} n’est pas étudiant(e) boursier(ère) </span><span ng-if=\"vm.data.data.sitPros[vm.index].sitproetu === 'ets' && vm.data.data.sitPros[vm.index].boursier === 'Oui'\">{{vm.donneecommune.personneEnCours}} est étudiant(e) boursier(ère) </span><span ng-if=\"vm.data.data.sitPros[vm.index].sitproetu === 'etudiantActNonSal' && vm.data.data.sitPros[vm.index].boursier === 'Non'\">{{vm.donneecommune.personneEnCours}} n’est pas étudiant(e) boursier(ère) </span><span ng-if=\"vm.data.data.sitPros[vm.index].sitproetu === 'etudiantActNonSal' && vm.data.data.sitPros[vm.index].boursier === 'Oui'\">{{vm.donneecommune.personneEnCours}} est étudiant(e) boursier(ère)</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.data.sitPros[vm.index].boursier === 'Oui'\"><div>Nom de l’organisme qui a accordé la bourse : <span class=text-primary>{{vm.data.data.sitPros[vm.index].orgabourse}}</span></div><div>Pays de l’organisme : <span class=text-primary>{{vm.data.data.sitPros[vm.index].orgapays.libelleCaffr}}</span></div><div>Adresse de l’organisme : <span class=text-primary>{{vm.data.data.sitPros[vm.index].orgaadresse}}</span></div></div><div class=\"row texte-clair-cnaf col-sm-12\"><span ng-if=\"vm.data.data.sitPros[vm.index].orgasecu === 'ssetu'\">{{vm.donneecommune.personneEnCours}} est affilié(e) à la Sécurité sociale étudiante </span><span ng-if=\"vm.data.data.sitPros[vm.index].orgasecu === 'ssparents'\">{{vm.donneecommune.personneEnCours}} est couvert(e) par la Sécurité sociale de ses parents </span><span ng-if=\"vm.data.data.sitPros[vm.index].orgasecu === 'ssconjoint'\">{{vm.donneecommune.personneEnCours}} est couvert(e) par la Sécurité sociale de son conjoint </span><span ng-if=\"vm.data.data.sitPros[vm.index].orgasecu === 'ssetranger'\">{{vm.donneecommune.personneEnCours}} est couvert(e) par un régime étranger</span></div><div class=\"row col-sm-12 texte-clair-cnaf\"><span ng-if=vm.data.data.sitPros[vm.index].ressSuffisantesChckBx>{{vm.donneecommune.personneEnCours}} déclare des ressources suffisantes pour vivre</span></div>")

$templateCache.put("components/cnaf-cct-recap/cnaf-cct-recap-sitpro-choixactiviteinvalidite/cnaf-cct-sitpro-recap-choixactiviteinvalidite.html","<div class=\"row col-sm-12 texte-clair-cnaf\">{{vm.donneecommune.personneEnCours}} <span ng-if=\"vm.data.data.sitPros[vm.index].invalRente == 'inval'\">perçoit une pension d’invalidité </span><span ng-if=\"vm.data.data.sitPros[vm.index].invalRente == 'rente'\">perçoit une rente accident du travail</span></div><div class=\"row col-sm-12 texte-clair-cnaf\">{{vm.donneecommune.personneEnCours}} <span ng-if=\"vm.data.data.sitPros[vm.index].cesseActProPens == false\">n’a pas cessé totalement son activité professionnelle </span><span ng-if=\"vm.data.data.sitPros[vm.index].cesseActProPens == true\">a cessé totalement son activité professionnelle</span></div><div class=\"row col-sm-12\" ng-if=\"vm.data.data.sitPros[vm.index].cesseActProPens == true\"><span class=texte-clair-cnaf>Date de début de la situation : </span><span class=text-primary>{{vm.data.data.sitPros[vm.index].dateActivite}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.data.sitPros[vm.index].cesseActProPens == true\n" +
    "                                                && vm.index > 0\n" +
    "                                                && vm.data.data.sitPros[vm.index].dateFinActivite != undefined\">Date de fin de la situation : <span class=text-primary>{{vm.data.data.sitPros[vm.index].dateFinActivite}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.data.sitPros[vm.index].cesseActProPens == true\">L’organisme qui verse la pension ou la rente la plus élevée <span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'Régime général'\">relève du régime général </span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'MSA'\">cotise à la MSA </span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'CGSS'\">cotise à la CGSS </span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'Autre régime'\">cotise à un autre régime<div class=\"row col-sm-12\">Nom de l’organisme : <span class=text-primary>{{vm.data.data.sitPros[vm.index].nomOrganisme}}</span></div></span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.data.sitPros[vm.index].cesseActProPens == false\"><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteComplementInvalidite == 'ETU'\"><cnaf-cct-recap-sitpro data=vm.data donneecommune=vm.donneecommune></cnaf-cct-recap-sitpro></span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteComplementInvalidite == 'CONG'\"><cnaf-cct-recap-choixactivitecongesdivers data=vm.data donneecommune=vm.donneecommune index=vm.index></cnaf-cct-recap-choixactivitecongesdivers></span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteComplementInvalidite == 'AUT'\"><cnaf-cct-recap-choixactiviteautresituation data=vm.data donneecommune=vm.donneecommune index=vm.index></cnaf-cct-recap-choixactiviteautresituation></span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteComplementInvalidite == 'CHO'\"><cnaf-cct-recap-choixactivitechomage data=vm.data donneecommune=vm.donneecommune index=vm.index></cnaf-cct-recap-choixactivitechomage></span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteComplementInvalidite == 'PENS'\"><cnaf-cct-recap-choixactiviteinvalidite data=vm.data donneecommune=vm.donneecommune index=vm.index></cnaf-cct-recap-choixactiviteinvalidite></span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteComplementInvalidite == 'NSAL'\"><cnaf-cct-recap-choixactivitenonsalariee data=vm.data donneecommune=vm.donneecommune index=vm.index></cnaf-cct-recap-choixactivitenonsalariee></span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteComplementInvalidite == 'SAL'\"><cnaf-cct-recap-choixactivitesalariee data=vm.data donneecommune=vm.donneecommune index=vm.index></cnaf-cct-recap-choixactivitesalariee></span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteComplementInvalidite == 'APP'\"><cnaf-cct-recap-choixactivitestagiaire data=vm.data donneecommune=vm.donneecommune index=vm.index></cnaf-cct-recap-choixactivitestagiaire></span></div>")

$templateCache.put("components/cnaf-cct-recap/cnaf-cct-recap-sitpro-choixactivitenonsalariee/cnaf-cct-sitpro-recap-choixactivitenonsalariee.html","<div class=\"row col-sm-12 texte-clair-cnaf\">{{vm.donneecommune.personneEnCours}} <span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteNonSalariee.libelle == 'Travailleur indépendant'\">est travailleur indépendant </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteNonSalariee.libelle == 'Auto-entrepreneur ou Micro-entrepreneur'\">est auto-entrepreneur ou micro-entrepreneur </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteNonSalariee.libelle == 'Vendeur à domicile indépendant'\">est vendeur à domicile indépendant </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteNonSalariee.libelle == 'Gérant non salarié'\">est gérant non salarié </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteNonSalariee.libelle == 'VRP (Voyageur Représentant Placier)'\">est VRP (Voyageur Représentant Placier) </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteNonSalariee.libelle == 'Marin pêcheur'\">est marin pêcheur </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteNonSalariee.libelle == 'Exploitant agricole'\">est exploitant agricole </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteNonSalariee.libelle == 'Artiste auteur'\">est artiste auteur </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteNonSalariee.libelle == 'Aide familiale agricole'\">est aide familiale agricole </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteNonSalariee.libelle == 'Conjoint collaborateur'\">est conjoint collaborateur</span></div><div class=\"row col-sm-12 texte-clair-cnaf\">Date de début de l’activité : <span class=text-primary>{{vm.data.data.sitPros[vm.index].dateActivite}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.index > 0 && vm.data.data.sitPros[vm.index].dateFinActivite != undefined\">Date de fin de l’activité : <span class=text-primary>{{vm.data.data.sitPros[vm.index].dateFinActivite}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\">{{vm.donneecommune.personneEnCours}} cotise à <span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'Urssaf / SSI'\">l’Urssaf ou à la SSI </span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'MSA'\">la MSA </span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'CGSS'\">la CGSS </span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'Autre régime'\">un autre régime </span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'Maison des artistes / AGESSA'\">la maison des artistes / AGESSA</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.data.sitPros[vm.index].nomOrganisme != undefined\">Nom de l’organisme : <span class=text-primary>{{vm.data.data.sitPros[vm.index].nomOrganisme}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteNonSalariee.libelle == 'Artiste auteur'\n" +
    "                               || vm.data.data.sitPros[vm.index].choixActiviteNonSalariee.libelle == 'Vendeur à domicile indépendant'\"><span ng-if=\"vm.data.data.sitPros[vm.index].regImpos.libelle == 'Réel'\">Le régime d’imposition est réel </span><span ng-if=\"vm.data.data.sitPros[vm.index].regImpos.libelle == 'Forfaitaire'\">Le régime d’imposition est forfaitaire</span></div>")

$templateCache.put("components/cnaf-cct-recap/cnaf-cct-recap-sitpro-choixactiviteretraite/cnaf-cct-sitpro-recap-choixactiviteretraite.html","<div class=\"row col-sm-12 texte-clair-cnaf\">{{vm.donneecommune.personneEnCours}} est en retraite ou en pré-retraite <span ng-if=\"vm.data.data.sitPros[vm.index].cesseActProRet == false\">mais n’a pas cessé totalement son activité professionnelle </span><span ng-if=\"vm.data.data.sitPros[vm.index].cesseActProRet == true\">et a cessé totalement son activité professionnelle</span></div><div class=\"row col-sm-12\" ng-if=\"vm.data.data.sitPros[vm.index].cesseActProRet == true\"><span class=texte-clair-cnaf>Date de début de la situation : </span><span class=text-primary>{{vm.data.data.sitPros[vm.index].dateActivite}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.data.sitPros[vm.index].cesseActProRet == true\n" +
    "                                                && vm.index > 0\n" +
    "                                                && vm.data.data.sitPros[vm.index].dateFinActivite != undefined\">Date de fin de la situation : <span class=text-primary>{{vm.data.data.sitPros[vm.index].dateFinActivite}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.data.sitPros[vm.index].cesseActProRet == true\">L’organisme qui verse la pension ou la rente la plus élevée <span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'Régime général'\">relève du régime général </span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'MSA'\">cotise à la MSA </span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'CGSS'\">cotise à la CGSS </span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'Autre régime'\">cotise à un autre régime<div class=\"row col-sm-12\">Nom de l’organisme : <span class=text-primary>{{vm.data.data.sitPros[vm.index].nomOrganisme}}</span></div></span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.data.sitPros[vm.index].cesseActProRet == false\"><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteComplementRetraite == 'ETU'\"><cnaf-cct-recap-sitpro data=vm.data donneecommune=vm.donneecommune></cnaf-cct-recap-sitpro></span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteComplementRetraite == 'CONG'\"><cnaf-cct-recap-choixactivitecongesdivers data=vm.data donneecommune=vm.donneecommune index=vm.index></cnaf-cct-recap-choixactivitecongesdivers></span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteComplementRetraite == 'AUT'\"><cnaf-cct-recap-choixactiviteautresituation data=vm.data donneecommune=vm.donneecommune index=vm.index></cnaf-cct-recap-choixactiviteautresituation></span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteComplementRetraite == 'CHO'\"><cnaf-cct-recap-choixactivitechomage data=vm.data donneecommune=vm.donneecommune index=vm.index></cnaf-cct-recap-choixactivitechomage></span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteComplementRetraite == 'PENS'\"><cnaf-cct-recap-choixactiviteinvalidite data=vm.data donneecommune=vm.donneecommune index=vm.index></cnaf-cct-recap-choixactiviteinvalidite></span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteComplementRetraite == 'NSAL'\"><cnaf-cct-recap-choixactivitenonsalariee data=vm.data donneecommune=vm.donneecommune index=vm.index></cnaf-cct-recap-choixactivitenonsalariee></span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteComplementRetraite == 'SAL'\"><cnaf-cct-recap-choixactivitesalariee data=vm.data donneecommune=vm.donneecommune index=vm.index></cnaf-cct-recap-choixactivitesalariee></span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteComplementRetraite == 'APP'\"><cnaf-cct-recap-choixactivitestagiaire data=vm.data donneecommune=vm.donneecommune index=vm.index></cnaf-cct-recap-choixactivitestagiaire></span></div>")

$templateCache.put("components/cnaf-cct-recap/cnaf-cct-recap-sitpro-choixactivitesalariee/cnaf-cct-sitpro-recap-choixactivitesalariee.html","<div class=\"row col-sm-12 texte-clair-cnaf\">{{vm.donneecommune.personneEnCours}} <span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteSalariee.libelle == 'Salarié'\">est salarié(e) </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteSalariee.libelle == 'Assitant(e) maternel(le)'\">est assistant(e) maternel(le) </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteSalariee.libelle == 'Gérant salarié'\">est gérant(e) salarié(e) </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteSalariee.libelle == 'Travailleur saisonnier'\">est travailleur(se) saisonnier(e) </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteSalariee.libelle == 'Intérimaire'\">est intérimaire </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteSalariee.libelle == 'Intermittent du spectacle'\">est intermittent(e) du spectacle </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteSalariee.libelle == 'Vendeur à domicile salarié'\">est vendeur(se) à domicile salarié(e)</span></div><div class=\"row col-sm-12 texte-clair-cnaf\">Date de début de l’activité : <span class=text-primary>{{vm.data.data.sitPros[vm.index].dateActivite}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.index > 0 && vm.data.data.sitPros[vm.index].dateFinActivite != undefined\">Date de fin de l’activité : <span class=text-primary>{{vm.data.data.sitPros[vm.index].dateFinActivite}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.data.sitPros[vm.index].nomEmployeur != undefined\"><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteSalariee.libelle != 'Gérant salarié'\">Nom de l’employeur : </span><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteSalariee.libelle == 'Gérant salarié'\">Nom de l’entreprise : </span><span class=text-primary ng-if=\"vm.data.data.sitPros[vm.index].nomEmployeur != undefined\">{{vm.data.data.sitPros[vm.index].nomEmployeur}}</span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteSalariee.libelle == 'Salarié'\n" +
    "                || vm.data.data.sitPros[vm.index].choixActiviteSalariee.libelle == 'Intérimaire'\n" +
    "                || vm.data.data.sitPros[vm.index].choixActiviteSalariee.libelle == 'Vendeur à domicile salarié'\">Pays de l’employeur : </span><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteSalariee.libelle == 'Gérant salarié'\">Pays de l’entreprise : </span><span class=text-primary>{{vm.data.data.sitPros[vm.index].paysEmployeur.libelleCaffr}}</span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].paysEmployeur.libelleCaffr == 'FRANCE'\"><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteSalariee.libelle != 'Gérant salarié'\">Code postal/Commune de l’employeur : </span><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteSalariee.libelle == 'Gérant salarié'\">Code postal/Commune de l’entreprise : </span><span class=text-primary>{{vm.data.data.sitPros[vm.index].codePostalVilleEmployeur.lib}} </span></span><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].paysEmployeur.libelleCaffr != 'FRANCE'\"><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteSalariee.libelle != 'Gérant salarié'\n" +
    "                                           && vm.data.data.sitPros[vm.index].villeEmployeur != undefined\">Ville de l’employeur : </span><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteSalariee.libelle == 'Gérant salarié'\">Ville de l’entreprise : </span><span class=text-primary>{{vm.data.data.sitPros[vm.index].villeEmployeur}}</span></span></div><div class=\"row col-sm-12 texte-clair-cnaf\"><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteSalariee.libelle != 'Gérant salarié'\n" +
    "              && vm.data.data.sitPros[vm.index].choixActiviteSalariee.libelle != 'Travailleur saisonnier'\">L’employeur cotise </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteSalariee.libelle == 'Gérant salarié'\">{{vm.donneecommune.personneEnCours}} cotise </span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'Urssaf'\">à l’Urssaf </span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'MSA'\">à la MSA </span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'CGSS'\">à la CGSS </span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'Autre régime'\">à un autre régime<div ng-if=\"vm.data.data.sitPros[vm.index].choixActiviteSalariee.libelle === 'Salarié'\"><span ng-if=\"vm.data.data.sitPros[vm.index].choixAutRegSal.libelle === 'Membre d’une organisation internationale'\n" +
    "                      || vm.data.data.sitPros[vm.index].choixAutRegSal.libelle === 'Fonctionnaire'\n" +
    "                      || vm.data.data.sitPros[vm.index].choixAutRegSal.libelle === 'Membre du Parlement (Assemblée nationale ou Sénat)'\">{{vm.donneecommune.personneEnCours}} </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixAutRegSal.libelle === 'Membre d’une organisation internationale'\">est membre d’une organisation internationale </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixAutRegSal.libelle === 'Fonctionnaire'\n" +
    "                    && vm.donneecommune.encouple != undefined && vm.donneecommune.encouple == true\">est fonctionnaire<div><span ng-if=\"vm.data.data.sitPros[vm.index].choixPosteFonct.libelle === 'En France'\">{{vm.donneecommune.personneEnCours}} est en poste en France </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixPosteFonct.libelle === 'A l\\'étranger'\">{{vm.donneecommune.personneEnCours}} est en poste à l’étranger</span></div></span><span ng-if=\"vm.data.data.sitPros[vm.index].choixAutRegSal.libelle === 'Membre du Parlement (Assemblée nationale ou Sénat)'\">est membre du Parlement</span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].nomOrganisme != undefined\">Nom de l'organisme : <span class=text-primary>{{vm.data.data.sitPros[vm.index].nomOrganisme}}</span></span></div></span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'Régime étranger'\">à un régime étranger<div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].paysOrganisme != undefined\">Pays de l’organisme : <span class=text-primary>{{vm.data.data.sitPros[vm.index].paysOrganisme}} </span></span><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].paysCotisation != undefined\">Pays de cotisation : <span class=text-primary>{{vm.data.data.sitPros[vm.index].paysCotisation.libelleCaffr}}</span></span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.data.sitPros[vm.index].detacheFrance != undefined\">{{vm.donneecommune.personneEnCours}} <span ng-if=\"vm.data.data.sitPros[vm.index].detacheFrance == 'Oui'\">est détaché(e) en France </span><span ng-if=\"vm.data.data.sitPros[vm.index].detacheFrance == 'Non'\">n’est pas détaché(e) en France</span></div></span></div>")

$templateCache.put("components/cnaf-cct-recap/cnaf-cct-recap-telcourriel/cnaf-cct-recap-telcourriel.html","<div class=row><div class=col-sm-12><span class=texte-clair-cnaf>Téléphone <span ng-show=\"vm.data.data.encouple!==false\">1</span> : <span class=text-primary if=vm.data.data.telephonePortable>{{vm.affichageTelephoneAvecBlanc(vm.data.data.telephonePortable)}} </span><span class=texte-clair-cnaf ng-if=!vm.data.data.telephonePortable>Non communiqué</span></span></div></div><div class=row ng-show=\"vm.data.data.encouple!==false\"><div class=col-sm-12><span class=texte-clair-cnaf>Téléphone 2 : <span class=text-primary if=vm.data.data.telephone2>{{vm.affichageTelephoneAvecBlanc(vm.data.data.telephone2)}} </span><span class=texte-clair-cnaf ng-if=!vm.data.data.telephone2>Non communiqué</span></span></div></div>")

$templateCache.put("components/cnaf-cct-recap/cnaf-cct-recap-sitpro-choixactivitestagiaire/cnaf-cct-sitpro-recap-choixactivitestagiaire.html","<div class=\"row col-sm-12 texte-clair-cnaf\">{{vm.donneecommune.personneEnCours}} <span ng-if=\"vm.data.data.sitPros[vm.index].choixStagiaire.libelle == 'Stagiaire'\">est stagiaire </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixStagiaire.libelle == 'Apprenti'\">est apprenti </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixStagiaire.libelle == 'En contrat de professionnalisation - En alternance'\">est en contrat de professionnalisation ou en alternance</span></div><div class=\"row col-sm-12 texte-clair-cnaf\"><span ng-if=\"vm.data.data.sitPros[vm.index].choixStagiaire.libelle == 'Stagiaire'\">Date de début de l’activité : </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixStagiaire.libelle == 'Apprenti'\">Date de début de l’apprentissage : </span><span ng-if=\"vm.data.data.sitPros[vm.index].choixStagiaire.libelle == 'En contrat de professionnalisation - En alternance'\">Date de début du contrat : </span><span class=text-primary>{{vm.data.data.sitPros[vm.index].dateActivite}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.data.sitPros[vm.index].choixStagiaire.libelle == 'Stagiaire'\n" +
    "                                                && vm.index > 0 && vm.data.data.sitPros[vm.index].dateFinActivite != undefined\">Date de fin de l’activité : <span class=text-primary>{{vm.data.data.sitPros[vm.index].dateFinActivite}}</span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.data.sitPros[vm.index].dateFinActivite !== undefined\"><span ng-if=\"vm.data.data.sitPros[vm.index].choixStagiaire.libelle == 'Apprenti'\">Date de fin de l’apprentissage : <span class=text-primary>{{vm.data.data.sitPros[vm.index].dateFinActivite}} </span></span><span ng-if=\"vm.data.data.sitPros[vm.index].choixStagiaire.libelle == 'En contrat de professionnalisation - En alternance'\">Date de fin du contrat : <span class=text-primary>{{vm.data.data.sitPros[vm.index].dateFinActivite}}</span></span></span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.data.sitPros[vm.index].choixStagiaire.libelle === 'Stagiaire'\"><span ng-if=\"vm.data.data.sitPros[vm.index].indemnise == true\">Le stage est indemnisé par <span ng-if=\"vm.data.data.sitPros[vm.index].regimeIndemnisation.libelle === 'France Travail'\">France Travail </span><span ng-if=\"vm.data.data.sitPros[vm.index].regimeIndemnisation.libelle === 'Fonction publique'\">la fonction publique </span><span ng-if=\"vm.data.data.sitPros[vm.index].regimeIndemnisation.libelle === 'Employeur ou autre'\">l’employeur ou par un autre organisme </span></span><span ng-if=\"vm.data.data.sitPros[vm.index].indemnise == false\">Le stage n’est pas indemnisé</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.data.sitPros[vm.index].choixStagiaire.libelle === 'Apprenti'\n" +
    "                  || vm.data.data.sitPros[vm.index].choixStagiaire.libelle === 'En contrat de professionnalisation - En alternance'\">L’employeur cotise <span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'Régime général'\">au régime général </span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'MSA'\">à la MSA </span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'CGSS'\">à la CGSS </span><span ng-if=\"vm.data.data.sitPros[vm.index].cotisEmployeur.libelle === 'Autre régime'\">à un autre régime<div class=\"col-sm-12 row\">Nom de l’organisme : <span class=text-primary>{{vm.data.data.sitPros[vm.index].nomOrganisme}}</span></div></span></div>")

$templateCache.put("components/cnaf-cct-recap/cnaf-cct-recap-telephones/cnaf-cct-recap-telephones.html","<div class=row><div class=col-sm-12><div class=texte-clair-cnaf><div>Téléphone 1 : <span class=text-primary ng-show=vm.data.data.telephone1>{{vm.numTelAvecBlanc(vm.data.data.telephone1)}} </span><span class=text-primary ng-show=!vm.data.data.telephone1>non renseigné</span></div></div></div></div><div class=row><div class=col-sm-12><div class=texte-clair-cnaf><div>Téléphone 2 : <span class=text-primary ng-show=vm.data.data.telephone2>{{vm.numTelAvecBlanc(vm.data.data.telephone2)}} </span><span class=text-primary ng-show=!vm.data.data.telephone2>non renseigné</span></div></div></div></div>")

$templateCache.put("components/cnaf-cct-ressources/cnaf-cct-aucun-revenu/cnaf-cct-aucun-revenu.component.html","<div class=\"row cct-ressources-rubrique\"><div class=\"col-sm-6 form-group\"><label for=aucunrevenuChckBx class=\"texte-ss-titre-cnaf align-middle-cnaf\" ng-class=\"{'cnaf-checkboxSelected': vm.data.controle.aucunrevenuChckBx}\"><cnaf-checkbox ng-disabled=vm.desactive id=aucunrevenuChckBx name=aucunrevenuChckBx ng-model=vm.data.controle.aucunrevenuChckBx aria-labelledby=labelaucunrevenuChckBx class=pull-left></cnaf-checkbox><div id=labelaucunrevenuChckBx>Aucun revenu</div></label><span><cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-aucunrevenu data-container=body data-trigger=manual tabindex=0></span><div class=hidden id=content-popover-aucunrevenu><div class=popover-btn-close-cnaf></div>Si vous n’avez perçu aucun revenu au cours de l’année, cocher cette case.</div></div></div>")

$templateCache.put("components/cnaf-cct-ressources/cnaf-cct-autres-revenus/cnaf-cct-autres-revenus.component.html","<div class=\"row cct-ressources-rubrique\"><div class=\"col-sm-6 form-group\"><label for=autresrevenusChckBx class=\"texte-ss-titre-cnaf align-middle-cnaf\" ng-class=\"{'cnaf-checkboxSelected': vm.data.controle.autresrevenusChckBx}\"><cnaf-checkbox ng-disabled=\"vm.champsVideOuZero() || vm.desactive\" id=autresrevenusChckBx name=autresrevenusChckBx ng-model=vm.data.controle.autresrevenusChckBx aria-labelledby=labelautresrevenusChckBx class=pull-left></cnaf-checkbox><div id=labelautresrevenusChckBx>Autres revenus</div></label></div></div><div class=row ng-show=vm.data.controle.autresrevenusChckBx><div class=col-sm-12><label class=\"label-form-cnaf control-label col-sm-6 col-md-4\" for=epargneHandicap>Contrat d'épargne handicap</label><div class=\"col-sm-6 col-md-3\" ng-class=\"{'has-error' : (vm.autresrevenusform.epargneHandicap.$invalid && !vm.autresrevenusform.epargneHandicap.$pristine)}\"><div class=\"row form-group input-group has-feedback\"><input id=epargneHandicap name=epargneHandicap class=\"form-control ferrage-droite-cnaf millier-cnaf\" ng-model=vm.data.ressources.epargneHandicap title=\"en euros\" ui-mask=?9?9?9?9?9?9?9 ui-options={clearOnBlur:false} ui-mask-placeholder-char=space> <span class=input-group-btn><span class=\"picto picto-euro form-control-feedback\"></span><cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-epargneHandicap data-container=body data-trigger=manual tabindex=0></span><div class=hidden id=content-popover-epargneHandicap><div class=popover-btn-close-cnaf></div>Déclarer uniquement les rentes de contrat d'épargne-handicap souscrites par vous-même, après abattements fiscaux.<br><div class=cct-picto-alerte-ressources-cnaf>Ne pas déclarer les rentes-survie souscrites par votre famille en votre faveur.<br><br></div></div></div></div></div><div class=col-sm-12><label class=\"label-form-cnaf control-label col-sm-6 col-md-4\" for=revenusAutres>Autres</label><div class=\"col-sm-6 col-md-3\" ng-class=\"{'has-error' : (vm.autresrevenusform.revenusAutres.$invalid && !vm.autresrevenusform.revenusAutres.$pristine)}\"><div class=\"row form-group input-group has-feedback\"><input id=revenusAutres name=revenusAutres class=\"form-control ferrage-droite-cnaf millier-cnaf\" ng-model=vm.data.ressources.revenusAutres title=\"en euros\" ui-mask=?9?9?9?9?9?9?9 ui-options={clearOnBlur:false} ui-mask-placeholder-char=space> <span class=input-group-btn><span class=\"picto picto-euro form-control-feedback\"></span><cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-revenusAutres data-container=body data-trigger=manual tabindex=0></span><div class=hidden id=content-popover-revenusAutres><div class=popover-btn-close-cnaf></div>Déclarer :<ul tabindex=0><li>les revenus des capitaux et des valeurs mobilières (actions, obligations...) après abattements fiscaux,</li><li>les plus-values et gains divers taxés à un taux forfaitaire, y compris les plus-values de cession des professions non salariées,</li><li>les rentes viagères à titre onéreux.</li></ul><div class=cct-picto-alerte-ressources-cnaf>Ne pas déclarer : les rentes-survie souscrites par votre famille en votre faveur.<br><br></div><div class=cct-picto-alerte-ressources-cnaf>Ne pas déduire : les avoirs fiscaux, les crédits d'impôts et les pertes des années antérieures.<br><br></div></div></div></div></div></div>")

$templateCache.put("components/cnaf-cct-ressources/cnaf-cct-charges-deductibles/cnaf-cct-charges-deductibles.component.html","<div class=\"row cct-ressources-rubrique\"><div class=\"col-sm-6 form-group\"><label for=chargesdeductiblesChckBx class=\"texte-ss-titre-cnaf align-middle-cnaf\" ng-class=\"{'cnaf-checkboxSelected': vm.data.controle.chargesdeductiblesChckBx}\"><cnaf-checkbox ng-disabled=\"vm.champsVideOuZero() || vm.desactive\" id=chargesdeductiblesChckBx name=chargesdeductiblesChckBx ng-model=vm.data.controle.chargesdeductiblesChckBx aria-labelledby=labelchargesdeductiblesChckBx class=pull-left></cnaf-checkbox><div id=labelchargesdeductiblesChckBx>Charges déductibles</div></label></div></div><div class=row ng-show=vm.data.controle.chargesdeductiblesChckBx><div class=col-sm-12><label class=\"label-form-cnaf control-label col-sm-6 col-md-4\" for=pensionsAlimVersees>Pensions alimentaires versées</label><div class=\"col-sm-6 col-md-3\" ng-class=\"{'has-error' : (vm.chargesdeductiblesform.pensionsAlimVersees.$invalid && !vm.chargesdeductiblesform.pensionsAlimVersees.$pristine)}\"><div class=\"row form-group input-group has-feedback\"><input id=pensionsAlimVersees name=pensionsAlimVersees class=\"form-control ferrage-droite-cnaf millier-cnaf\" ng-model=vm.data.ressources.pensionsAlimVersees title=\"en euros\" ui-mask=?9?9?9?9?9?9?9 ui-options={clearOnBlur:false} ui-mask-placeholder-char=space> <span class=input-group-btn><span class=\"picto picto-euro form-control-feedback\"></span><cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-pensionsAlimVersees data-container=body data-trigger=manual tabindex=0></span><div class=hidden id=content-popover-pensionsAlimVersees><div class=popover-btn-close-cnaf></div>Déclarer le montant des pensions alimentaires versées en {{vm.data.anneeReference}}.<br><div class=cct-picto-alerte-ressources-cnaf>Ne déclarer pas :<ul tabindex=0><li>les pensions versées aux enfants pour lesquels vous recevez des prestations familiales,</li><li>les prestations compensatoires versées sous forme de capital et sur une période inférieure ou égale à 12 mois.</li></ul></div></div></div></div></div><div class=col-sm-8 ng-if=vm.data.ressources.pensionsAlimVersees><fieldset><legend class=\"label-form-cnaf control-label col-sm-8\" for=pensionDecisionJustice>La pension a été fixée suite à décision de justice intervenue avant janvier 2006</legend><div class=row><div class=\"form-group btn-group btn-block\" data-toggle=buttons ng-class=\"{ 'has-error' :\n" +
    "                      (vm.chargesdeductiblesform.pensionDecisionJustice.$invalid && !vm.chargesdeductiblesform.pensionDecisionJustice.$pristine)\n" +
    "                      || (vm.data.ressources.pensionDecisionJustice == undefined && vm.controle.submitted)\n" +
    "                    }\"><div class=\"col-xs-6 col-sm-3\"><label class=\"btn btn-default btn-block\" ng-model=vm.data.ressources.pensionDecisionJustice uib-btn-radio=true for=pensionDecisionJusticeOui><input type=radio name=pensionDecisionJustice class=sr-only id=pensionDecisionJusticeOui ng-model=vm.data.ressources.pensionDecisionJustice value=true required> <span>Oui</span></label></div><div class=\"col-xs-6 col-sm-3\"><label class=\"btn btn-default btn-block\" ng-model=vm.data.ressources.pensionDecisionJustice uib-btn-radio=false for=pensionDecisionJusticeNon><input type=radio name=pensionDecisionJustice class=sr-only id=pensionDecisionJusticeNon ng-model=vm.data.ressources.pensionDecisionJustice value=false required> <span>Non</span></label></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.ressources.pensionDecisionJustice == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></fieldset></div><div class=col-sm-12><label class=\"label-form-cnaf control-label col-sm-6 col-md-4\" for=csgDeductibles>CSG déductibles sur les revenus du patrimoine</label><div class=\"col-sm-6 col-md-3\" ng-class=\"{'has-error' : (vm.chargesdeductiblesform.csgDeductibles.$invalid && !vm.chargesdeductiblesform.csgDeductibles.$pristine)}\"><div class=\"row form-group input-group has-feedback\"><input id=csgDeductibles name=csgDeductibles class=\"form-control ferrage-droite-cnaf millier-cnaf\" ng-model=vm.data.ressources.csgDeductibles title=\"en euros\" ui-mask=?9?9?9?9?9?9?9 ui-options={clearOnBlur:false} ui-mask-placeholder-char=space> <span class=input-group-btn><span class=\"picto picto-euro form-control-feedback\"></span><cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-csgDeductibles data-container=body data-trigger=manual tabindex=0></span><div class=hidden id=content-popover-csgDeductibles><div class=popover-btn-close-cnaf></div>Déclarer le montant de la contribution sociale généralisée (CSG) déductible, sur les revenus du patrimoine. Il s'agit de la CSG acquittée en {{vm.data.anneeReference}} sur les capitaux mobiliers, les revenus fonciers déclarés en {{vm.data.anneeReference}}.<br><br>Elle est déductible des revenus du foyer (si vous vivez en couple, elle doit être déclarée par celui qui a perçu les revenus).</div></div></div></div><div class=col-sm-12><label class=\"label-form-cnaf control-label col-sm-6 col-md-4\" for=epargneRetraite>Epargne retraite (Perp, Préfon,...) cotisations volontaires de Sécurité sociale</label><div class=\"col-sm-6 col-md-3\" ng-class=\"{'has-error' : (vm.chargesdeductiblesform.epargneRetraite.$invalid && !vm.chargesdeductiblesform.epargneRetraite.$pristine)}\"><div class=\"row form-group input-group has-feedback\"><input id=epargneRetraite name=epargneRetraite class=\"form-control ferrage-droite-cnaf millier-cnaf\" ng-model=vm.data.ressources.epargneRetraite title=\"en euros\" ui-mask=?9?9?9?9?9?9?9 ui-options={clearOnBlur:false} ui-mask-placeholder-char=space> <span class=input-group-btn><span class=\"picto picto-euro form-control-feedback\"></span><cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-epargneRetraite data-container=body data-trigger=manual tabindex=0></span><div class=hidden id=content-popover-epargneRetraite><div class=popover-btn-close-cnaf></div>Déclarer les montants versés au titre des plans d'épargne retraite (Perp, Préfon...) et des cotisations volontaires de Sécurité sociale y compris les cotisations de rachat au titre de la retraite pour les personnes ne percevant ni salaire, ni pension.<br><br>Il s'agit des cotisations autres que celles qui viennent en déduction des salaires ou qui sont versées par les travailleurs indépendants.</div></div></div></div></div>")

$templateCache.put("components/cnaf-cct-ressources/cnaf-cct-indemnites-secu/cnaf-cct-indemnites-secu.component.html","<div class=\"row cct-ressources-rubrique\"><div class=\"col-sm-6 form-group\"><label for=indemnitesSecuChckBx class=\"texte-ss-titre-cnaf align-middle-cnaf\" ng-class=\"{'cnaf-checkboxSelected': vm.data.controle.indemnitesSecuChckBx}\"><cnaf-checkbox ng-disabled=\"vm.champsVideOuZero() || vm.desactive\" id=indemnitesSecuChckBx name=indemnitesSecuChckBx ng-model=vm.data.controle.indemnitesSecuChckBx aria-labelledby=labelindemnitesSecuChckBx class=pull-left></cnaf-checkbox><div id=labelindemnitesSecuChckBx>Indemnités de Sécurité sociale</div></label></div></div><div class=row ng-show=vm.data.controle.indemnitesSecuChckBx><div class=col-sm-12><label class=\"label-form-cnaf control-label col-sm-6 col-md-4\" for=indemnitesJournaFracImpos>Indemnités journalières de maladie, maternité, paternité, adoption, et fraction imposable d'accident du travail ou de maladie professionnelle</label><div class=\"col-sm-6 col-md-3\" ng-class=\"{'has-error' : (vm.indemnitessecuform.indemnitesJournaFracImpos.$invalid && !vm.indemnitessecuform.indemnitesJournaFracImpos.$pristine)}\"><div class=\"row form-group input-group has-feedback\"><input id=indemnitesJournaFracImpos name=indemnitesJournaFracImpos class=\"form-control ferrage-droite-cnaf millier-cnaf\" ng-model=vm.data.ressources.indemnitesJournaFracImpos title=\"en euros\" ui-mask=?9?9?9?9?9?9?9 ui-options={clearOnBlur:false} ui-mask-placeholder-char=space> <span class=input-group-btn><span class=\"picto picto-euro form-control-feedback\"></span><cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-indemnitesJournaFracImpos data-container=body data-trigger=manual tabindex=0></span><div class=hidden id=content-popover-indemnitesJournaFracImpos><div class=popover-btn-close-cnaf></div>Déclarer :<br><ul tabindex=0><li>les indemnités journalières de maladie, maternité, paternité, adoption versées par votre organisme d'assurance maladie,</li><li>les indemnités journalières d'accident du travail ou de maladie professionnelle : pour la fraction imposable : elles correspondent à 50% du montant total versé par votre organisme d'assurance maladie.</li></ul><div class=cct-picto-info-ressources-cnaf>Votre organisme d’assurance maladie (CPAM, MGEN…) tient ces montants à votre disposition.</div></div></div></div></div><div class=col-sm-12><label class=\"label-form-cnaf control-label col-sm-6 col-md-4\" for=indemnitesJournaFracNonImpos>Indemnités journalières d'accident du travail ou de maladie professionnelle, fraction non imposable</label><div class=\"col-sm-6 col-md-3\" ng-class=\"{'has-error' : (vm.indemnitessecuform.indemnitesJournaFracNonImpos.$invalid && !vm.indemnitessecuform.indemnitesJournaFracNonImpos.$pristine)}\"><div class=\"row form-group input-group has-feedback\"><input id=indemnitesJournaFracNonImpos name=indemnitesJournaFracNonImpos class=\"form-control ferrage-droite-cnaf millier-cnaf\" ng-model=vm.data.ressources.indemnitesJournaFracNonImpos title=\"en euros\" ui-mask=?9?9?9?9?9?9?9 ui-options={clearOnBlur:false} ui-mask-placeholder-char=space> <span class=input-group-btn><span class=\"picto picto-euro form-control-feedback\"></span><cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-indemnitesJournaFracNonImpos data-container=body data-trigger=manual tabindex=0></span><div class=hidden id=content-popover-indemnitesJournaFracNonImpos><div class=popover-btn-close-cnaf></div>Déclarer la fraction non imposable des indemnités journalières perçues pour accident du travail et maladie professionnelle : elles correspondent à 50% du montant total versé par votre organisme d'assurance maladie.<br><div class=cct-picto-info-ressources-cnaf>Votre organisme d’assurance maladie (CPAM, MGEN…) tient ces montants à votre disposition.</div></div></div></div></div></div>")

$templateCache.put("components/cnaf-cct-ressources/cnaf-cct-pensions-alimentaires/cnaf-cct-pensions-alimentaires.component.html","<div class=\"row cct-ressources-rubrique\"><div class=\"col-sm-6 form-group\"><label for=pensionsalimentairesChckBx class=\"texte-ss-titre-cnaf align-middle-cnaf\" ng-class=\"{'cnaf-checkboxSelected': vm.data.controle.pensionsalimentairesChckBx}\"><cnaf-checkbox ng-disabled=\"vm.champsVideOuZero() || vm.desactive\" id=pensionsalimentairesChckBx name=pensionsalimentairesChckBx ng-model=vm.data.controle.pensionsalimentairesChckBx aria-labelledby=labelpensionsalimentairesChckBx class=pull-left></cnaf-checkbox><div id=labelpensionsalimentairesChckBx>Pensions alimentaires reçues</div></label></div></div><div class=row ng-show=vm.data.controle.pensionsalimentairesChckBx><div class=col-sm-12><label class=\"label-form-cnaf control-label col-sm-6 col-md-4\" for=pensionsAlimentaires>Pensions alimentaires</label><div class=\"col-sm-6 col-md-3\" ng-class=\"{'has-error': vm.pensionsalimentairesform.pensionsAlimentaires.$invalid && !vm.pensionsalimentairesform.pensionsAlimentaires.$pristine}\"><div class=\"row form-group input-group has-feedback\"><input id=pensionsAlimentaires name=pensionsAlimentaires class=\"form-control ferrage-droite-cnaf millier-cnaf\" ng-model=vm.data.ressources.pensionsAlimentaires title=\"en euros\" ui-mask=?9?9?9?9?9?9?9 ui-options={clearOnBlur:false} ui-mask-placeholder-char=space> <span class=input-group-btn><span class=\"picto picto-euro form-control-feedback\"></span><cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-pensionsalimentaires data-container=body data-trigger=manual tabindex=0></span><div class=hidden id=content-popover-pensionsalimentaires><div class=popover-btn-close-cnaf></div>Déclarer les pensions alimentaires reçues en {{vm.data.anneeReference}}.<br>Ne pas déduire l'abattement fiscal.<br><div class=cct-picto-info-ressources-cnaf>Vos parents ont déclaré vous verser une pension alimentaire auprès des impôts, vous devez déclarer cette somme.</div></div></div></div></div></div>")

$templateCache.put("components/cnaf-cct-ressources/cnaf-cct-pensions-retraites-rentes/cnaf-cct-pensions-retraites-rentes.component.html","<div class=\"row cct-ressources-rubrique\"><div class=\"col-sm-12 form-group\"><label for=pensionsretraitesrentesChckBx class=\"texte-ss-titre-cnaf align-middle-cnaf\" ng-class=\"{'cnaf-checkboxSelected': vm.data.controle.pensionsretraitesrentesChckBx}\"><cnaf-checkbox ng-disabled=\"vm.champsVideOuZero() || vm.desactive\" id=pensionsretraitesrentesChckBx name=pensionsretraitesrentesChckBx ng-model=vm.data.controle.pensionsretraitesrentesChckBx aria-labelledby=labelpensionsretraitesrentesChckBx class=pull-left></cnaf-checkbox><div id=labelpensionsretraitesrentesChckBx>Pensions, retraites et rentes imposables</div></label></div></div><div class=row ng-show=vm.data.controle.pensionsretraitesrentesChckBx><div class=col-sm-12><label class=\"label-form-cnaf control-label col-sm-6 col-md-4\" for=pensionsRetraitesRentesImposables>Retraites, pension et rentes imposables</label><div class=\"col-sm-6 col-md-3\" ng-class=\"{'has-error' : (vm.pensionsretraitesrentesform.pensionsRetraitesRentesImposables.$invalid && !vm.pensionsretraitesrentesform.pensionsRetraitesRentesImposables.$pristine)}\"><div class=\"row form-group input-group has-feedback\"><input id=pensionsRetraitesRentesImposables name=pensionsRetraitesRentesImposables class=\"form-control ferrage-droite-cnaf millier-cnaf\" ng-model=vm.data.ressources.pensionsRetraitesRentesImposables title=\"en euros\" ui-mask=?9?9?9?9?9?9?9 ui-options={clearOnBlur:false} ui-mask-placeholder-char=space> <span class=input-group-btn><span class=\"picto picto-euro form-control-feedback\"></span><cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-pensionsretraitesrentesimposables data-container=body data-trigger=manual tabindex=0></span><div class=hidden id=content-popover-pensionsretraitesrentesimposables><div class=popover-btn-close-cnaf></div>Déclarer toutes les pensions et rentes imposables reçues en {{vm.data.anneeReference}}, sans déduire l'abattement fiscal de 10%, y compris les majorations de retraite ou de pension pour charges de familles et l'allocation de préparation à la retraite perçue au titre du Fonds de solidarité des anciens combattants d'Afrique du Nord<br><div class=cct-picto-alerte-ressources-cnaf>L'Allocation supplémentaire vieillesse et l'Allocation de solidarité aux personnes âgées ne sont pas à déclarer.<br><br></div></div></div></div></div><div class=col-sm-12><label class=\"label-form-cnaf control-label col-sm-6 col-md-4\" for=pensionInvalidite>Pension d'invalidité</label><div class=\"col-sm-6 col-md-3\" ng-class=\"{'has-error' : (vm.pensionsretraitesrentesform.pensionInvalidite.$invalid && !vm.pensionsretraitesrentesform.pensionInvalidite.$pristine)}\"><div class=\"row form-group input-group has-feedback\"><input id=pensionInvalidite name=pensionInvalidite class=\"form-control ferrage-droite-cnaf millier-cnaf\" ng-model=vm.data.ressources.pensionInvalidite title=\"en euros\" ui-mask=?9?9?9?9?9?9?9 ui-options={clearOnBlur:false} ui-mask-placeholder-char=space> <span class=input-group-btn><span class=\"picto picto-euro form-control-feedback\"></span><cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-pensionInvalidite data-container=body data-trigger=manual tabindex=0></span><div class=hidden id=content-popover-pensionInvalidite><div class=popover-btn-close-cnaf></div>Pension d’invalidité imposable.<br><div class=cct-picto-alerte-ressources-cnaf>L'Allocation supplémentaire d’invalidité n’est pas à déclarer.<br><br></div></div></div></div></div></div>")

$templateCache.put("components/cnaf-cct-ressources/cnaf-cct-revenus-deficits-fonciers/cnaf-cct-revenus-deficits-fonciers.component.html","<div class=\"row cct-ressources-rubrique\"><div class=\"col-sm-6 form-group\"><label for=revenusdeficitsfonciersChckBx class=\"texte-ss-titre-cnaf align-middle-cnaf\" ng-class=\"{'cnaf-checkboxSelected': vm.data.controle.revenusdeficitsfonciersChckBx}\"><cnaf-checkbox ng-disabled=\"vm.champsVideOuZero() || vm.desactive\" id=revenusdeficitsfonciersChckBx name=revenusdeficitsfonciersChckBx ng-model=vm.data.controle.revenusdeficitsfonciersChckBx aria-labelledby=labelrevenusdeficitsfonciersChckBx class=pull-left></cnaf-checkbox><div id=labelrevenusdeficitsfonciersChckBx>Revenus ou déficits fonciers</div></label></div></div><div class=row ng-show=vm.data.controle.revenusdeficitsfonciersChckBx><div class=col-sm-12><label class=\"label-form-cnaf control-label col-sm-6 col-md-4\" for=beneficesFonciers>Bénéfices fonciers</label><div class=\"col-sm-6 col-md-3\" ng-class=\"{'has-error' : (vm.revenusdeficitsfonciersform.beneficesFonciers.$invalid && !vm.revenusdeficitsfonciersform.beneficesFonciers.$pristine)}\"><div class=\"row form-group input-group has-feedback\"><input id=beneficesFonciers name=beneficesFonciers class=\"form-control ferrage-droite-cnaf millier-cnaf\" ng-model=vm.data.ressources.beneficesFonciers title=\"en euros\" ui-mask=?9?9?9?9?9?9?9 ui-options={clearOnBlur:false} ui-mask-placeholder-char=space> <span class=input-group-btn><span class=\"picto picto-euro form-control-feedback\"></span><cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-beneficesfonciers data-container=body data-trigger=manual tabindex=0></span><div class=hidden id=content-popover-beneficesfonciers><div class=popover-btn-close-cnaf></div>Déclarer les bénéfices fonciers (revenus de biens immobiliers), micro fonciers (après déduction de l'abattement fiscal forfaitaire). Ne pas déduire les déficits des années antérieures.</div></div></div></div><div class=col-sm-12><label class=\"label-form-cnaf control-label col-sm-6 col-md-4\" for=deficitsFonciers>Déficits fonciers</label><div ng-class=\"{'has-error' :\n" +
    "                 vm.revenusdeficitsfonciersform.deficitsFonciers.$invalid\n" +
    "                 && !vm.revenusdeficitsfonciersform.deficitsFonciers.$pristine\n" +
    "                 || vm.data.ressources.deficitsFonciers > 15300\n" +
    "               }\"><div class=\"col-sm-6 col-md-3 row form-group input-group has-feedback\"><input id=deficitsFonciers name=deficitsFonciers class=\"form-control ferrage-droite-cnaf millier-cnaf\" ng-model=vm.data.ressources.deficitsFonciers title=\"en euros\" ui-mask=?9?9?9?9?9?9?9 ui-options={clearOnBlur:false} ui-mask-placeholder-char=space> <span class=input-group-btn><span class=\"picto picto-euro form-control-feedback\"></span><cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-deficitsFonciers data-container=body data-trigger=manual tabindex=0></span><div class=hidden id=content-popover-deficitsFonciers><div class=popover-btn-close-cnaf></div>Déclarer uniquement les déficits fonciers de l'année {{vm.data.anneeReference}}, sans reporter les déficits des années antérieures.</div></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.ressources.deficitsFonciers > 15300)\">Le déficit foncier ne peut pas être supérieur à 15 300€.</p></div></div></div></div>")

$templateCache.put("components/cnaf-cct-ressources/cnaf-cct-revenus-non-salaries/cnaf-cct-revenus-non-salaries.component.html","<div class=\"row cct-ressources-rubrique\"><div class=\"col-sm-6 form-group\"><label for=revenusnonsalariesChckBx class=\"texte-ss-titre-cnaf align-middle-cnaf\" ng-class=\"{'cnaf-checkboxSelected': vm.data.controle.revenusnonsalariesChckBx}\"><cnaf-checkbox ng-disabled=\"vm.champsVideOuZero() || vm.desactive\" id=revenusnonsalariesChckBx name=revenusnonsalariesChckBx ng-model=vm.data.controle.revenusnonsalariesChckBx aria-labelledby=labelrevenusnonsalariesChckBx class=pull-left></cnaf-checkbox><div id=labelrevenusnonsalariesChckBx>Revenus non salariés</div></label></div></div><div class=row ng-show=vm.data.controle.revenusnonsalariesChckBx><div class=col-sm-12><label class=\"label-form-cnaf control-label col-sm-6 col-md-4\" for=benefEntrepreneur>Bénéfices (Bic, Bnc, Ba, micro Bic, micro Bnc, micro Ba), Adhérent d'un centre de gestion agréé, ou «régime micro» ou Auto-entrepreneur/Micro-entrepreneur</label><div class=\"col-sm-6 col-md-3\" ng-class=\"{'has-error' : (vm.revenusnonsalariesform.benefEntrepreneur.$invalid && !vm.revenusnonsalariesform.benefEntrepreneur.$pristine)}\"><div class=\"row form-group input-group has-feedback\"><input id=benefEntrepreneur name=benefEntrepreneur class=\"form-control ferrage-droite-cnaf millier-cnaf\" ng-model=vm.data.ressources.benefEntrepreneur title=\"en euros\" ui-mask=?9?9?9?9?9?9?9 ui-options={clearOnBlur:false} ui-mask-placeholder-char=space> <span class=input-group-btn><span class=\"picto picto-euro form-control-feedback\"></span><cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-benefEntrepreneur data-container=body data-trigger=manual tabindex=0></span><div class=hidden id=content-popover-benefEntrepreneur><div class=popover-btn-close-cnaf></div>Indiquer les montants suivants :<br><ul tabindex=0><li>les bénéfices industriels ou commerciaux (Bic),</li><li>les bénéfices non commerciaux (Bnc),</li><li>les bénéfices agricoles (Ba),</li><li>les bénéfices micro Bic, micro Bnc, micro Ba et plus-values à court terme (après déduction des abattements fiscaux forfaitaires),</li><li>Auto-entrepreneurs/Micro-entrepreneur (y compris ceux ayant opté pour le versement libératoire) : chiffre d'affaires ou recettes après déduction des abattements fiscaux applicables au régime «micro»</li><li>la rémunération non soumise au régime fiscal des \"traitements et salaires\" des gérants et associés</li></ul><div class=cct-picto-alerte-ressources-cnaf>Ne pas déduire les déficits des années antérieures.<br><br></div></div></div></div></div><div class=col-sm-12><label class=\"label-form-cnaf control-label col-sm-6 col-md-4\" for=benefNonAdherents>Bénéfices (Bic, Bnc, Ba, micro Bic, micro Bnc, micro Ba) Non adhérents d'un centre de gestion agréé</label><div class=\"col-sm-6 col-md-3\" ng-class=\"{'has-error' : (vm.revenusnonsalariesform.benefNonAdherents.$invalid && !vm.revenusnonsalariesform.benefNonAdherents.$pristine)}\"><div class=\"row form-group input-group has-feedback\"><input id=benefNonAdherents name=benefNonAdherents class=\"form-control ferrage-droite-cnaf millier-cnaf\" ng-model=vm.data.ressources.benefNonAdherents title=\"en euros\" ui-mask=?9?9?9?9?9?9?9 ui-options={clearOnBlur:false} ui-mask-placeholder-char=space> <span class=input-group-btn><span class=\"picto picto-euro form-control-feedback\"></span><cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-benefNonAdherents data-container=body data-trigger=manual tabindex=0></span><div class=hidden id=content-popover-benefNonAdherents><div class=popover-btn-close-cnaf></div>Indiquer les montants suivants :<br><ul tabindex=0><li>les bénéfices industriels ou commerciaux (Bic),</li><li>les bénéfices non commerciaux (Bnc),</li><li>les bénéfices agricoles (Ba),</li><li>les bénéfices micro Bic, micro Bnc, micro Ba et plus-values à court terme (après déduction des abattements fiscaux forfaitaires),</li><li>la rémunération non soumise au régime fiscal des \"traitements et salaires\" des gérants et associés</li></ul><div class=cct-picto-alerte-ressources-cnaf>Ne pas déduire les déficits des années antérieures.<br><br></div></div></div></div></div><div class=col-sm-12><label class=\"label-form-cnaf control-label col-sm-6 col-md-4\" for=deficitPro>Déficits professionnels de l’année ({{vm.data.anneeReference}})</label><div class=\"col-sm-6 col-md-3\" ng-class=\"{'has-error' : (vm.revenusnonsalariesform.deficitPro.$invalid && !vm.revenusnonsalariesform.deficitPro.$pristine)}\"><div class=\"row form-group input-group has-feedback\"><input id=deficitPro name=deficitPro class=\"form-control ferrage-droite-cnaf millier-cnaf\" ng-model=vm.data.ressources.deficitPro title=\"en euros\" ui-mask=?9?9?9?9?9?9?9 ui-options={clearOnBlur:false} ui-mask-placeholder-char=space> <span class=input-group-btn><span class=\"picto picto-euro form-control-feedback\"></span><cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-deficitPro data-container=body data-trigger=manual tabindex=0></span><div class=hidden id=content-popover-deficitPro><div class=popover-btn-close-cnaf></div>Déclarer uniquement les déficits -montants réels- de l'année {{vm.data.anneeReference}}, sans reporter les déficits des années antérieures.</div></div></div></div></div>")

$templateCache.put("components/cnaf-cct-ressources/cnaf-cct-salaires/cnaf-cct-salaires.component.html","<div class=\"row cct-ressources-rubrique\"><div class=\"col-sm-6 form-group\"><label for=salairesChckBx class=\"texte-ss-titre-cnaf align-middle-cnaf\" ng-class=\"{'cnaf-checkboxSelected': vm.data.controle.salairesChckBx}\"><cnaf-checkbox ng-disabled=\"vm.champsVideOuZero() || vm.desactive\" id=salairesChckBx name=salairesChckBx ng-model=vm.data.controle.salairesChckBx aria-labelledby=labelsalairesChckBx class=pull-left></cnaf-checkbox><div id=labelsalairesChckBx>Salaires et indemnités de chômage</div></label></div></div><div class=row ng-show=vm.data.controle.salairesChckBx><div class=col-sm-12><label class=\"label-form-cnaf control-label col-sm-6 col-md-4\" for=salaire>Salaires, traitements, heures supplémentaires, bourses de recherches</label><div class=\"col-sm-6 col-md-3\" ng-class=\"{'has-error' : (vm.salairesform.salaire.$invalid && !vm.salairesform.salaire.$pristine)}\"><div class=\"row form-group input-group has-feedback\"><input id=salaire ui-mask=?9?9?9?9?9?9?9 ui-options={clearOnBlur:false} ui-mask-placeholder-char=space name=salaire class=\"form-control ferrage-droite-cnaf millier-cnaf\" ng-model=vm.data.ressources.salaire title=\"en euros\"> <span class=input-group-btn><span class=\"picto picto-euro form-control-feedback\"></span><cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-salaire data-container=body data-trigger=manual tabindex=0></span><div class=\"hidden col-sm-12\" id=content-popover-salaire><div class=popover-btn-close-cnaf></div><strong>Indiquer le montant des salaires et traitements perçus (le net imposable) en France et à l'étranger ou ceux versés par une organisation internationale sans déduire l’abattement fiscal.</strong><br><br><div class=col-sm-6><p class=text-primary><strong>Salaires et traitements :</strong></p><ul tabindex=0><li>les heures supplémentaires,</li><li>les congés payés,</li><li>la partie imposable des indemnités de licenciement,</li><li>les traitements</li><li>les revenus de stages imposables,</li><li>les contrats aidés,</li><li>le Contrat unique d’insertion (CUI),</li><li>le Contrat à durée déterminée d’insertion (CDDI),</li><li>les contrats de professionnalisation,</li><li>l’Aide différentielle au reclassement (ADR),</li><li>les indemnités des élus locaux,</li><li>les compléments familiaux pour les organisations internationales</li><li>les rémunérations des gérants et associés,</li><li>les avantages en nature,</li><li>la partie imposable des ressources pour les apprentis sous contrat et les assistantes maternelles,</li><li>la rémunération garantie des travailleurs handicapés,</li><li>les bourses d'études et de recherche imposables.</li><br><br></ul></div><div class=col-sm-6><p class=text-primary><strong>Apprentis :</strong></p><strong>Les salaires des apprentis sont exonérés d'impôt jusqu'à <span style=white-space:nowrap>{{vm.data.varApprenti}}.</span></strong><br><br><ul tabindex=0><li>Si les salaires perçus sont inférieurs à ce montant, ne déclarez rien.</li><li>S'ils sont supérieurs, déduisez les <span style=white-space:nowrap>{{vm.data.varApprenti}}</span> du total des salaires perçus avant de les déclarer.</li><br><br></ul><p class=text-primary><strong>Etudiants :</strong></p><strong>Les salaires perçus pendant les études ou les vacances scolaires ou universitaires par les jeunes âgés de moins de 26 ans au 1er janvier {{vm.data.anneeReference}} sont exonérées d'impôt jusqu'à <span style=white-space:nowrap>{{vm.data.varImpot}}</span></strong><br><br><ul tabindex=0><li>Si les salaires perçus sont inférieurs à ce montant, ne déclarez rien.</li><li>S'ils sont supérieurs, déduisez les <span style=white-space:nowrap>{{vm.data.varImpot}}</span> du total des salaires perçus avant de les déclarer.</li></ul></div><div class=col-sm-12><p class=text-primary><strong>Tutelle/Curatelle, Retraite :</strong></p>Si vous avez payé des frais de tutelle ou de curatelle, ou si vous avez racheté des trimestres pour votre retraite, vous devez les déduire des montants que vous déclarez.<br><br><br></div></div></div></div></div><div class=col-sm-12><label class=\"label-form-cnaf control-label col-sm-6 col-md-4\" for=chomage>Allocations de chômage et préretraites</label><div class=\"col-sm-6 col-md-3\" ng-class=\"{'has-error' : (vm.salairesform.chomage.$invalid && !vm.salairesform.chomage.$pristine)}\"><div class=\"row form-group input-group has-feedback\"><input ui-mask=?9?9?9?9?9?9?9 ui-options={clearOnBlur:false} ui-mask-placeholder-char=space id=chomage name=chomage class=\"form-control ferrage-droite-cnaf millier-cnaf\" ng-model=vm.data.ressources.chomage title=\"en euros\"> <span class=input-group-btn><span class=\"picto picto-euro form-control-feedback\"></span><cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-chomage data-container=body data-trigger=manual tabindex=0></span><div class=hidden id=content-popover-chomage><div class=popover-btn-close-cnaf></div><strong>Déclarer le montant des allocations de chômage et préretraites avant abattement fiscal : </strong><br><br><ul tabindex=0><li>les allocations de chômage total ou partiel versées par France Travail,</li><li>l'allocation spécifique de reclassement (Asr),</li><li>les allocations de formation-reclassement (AREF),</li><li>les allocations formation de fin de stage (Affs),</li><li>les rémunérations des stagiaires du public (Rsp),</li><li>l'allocation différentielle perçue au titre du Fonds de solidarité des anciens combattants d'Afrique du Nord,</li><li>l'allocation équivalent retraite (Aer),</li><li>et les allocations de préretraite totale, préretraite progressive,</li><li>les allocations de chômage du Fonds national de l'emploi versées par France Travail,</li><li>les allocations de remplacement pour l'emploi (Arpe) ou pour cessation anticipée d'activité (CATS),</li><li>préretraite amiante,</li><li>congés de fin d'activité du secteur public,</li><li>l'allocation de sécurisation professionnelle (Asp)</li></ul></div></div></div></div><div class=col-sm-12><label class=\"label-form-cnaf control-label col-sm-6 col-md-4\" for=fraisReels>Frais réels déductibles</label><div class=\"col-sm-6 col-md-3\" ng-class=\"{'has-error' : (vm.salairesform.fraisReels.$invalid && !vm.salairesform.fraisReels.$pristine)}\"><div class=\"row form-group input-group has-feedback\"><input ui-mask=?9?9?9?9?9?9?9 ui-options={clearOnBlur:false} ui-mask-placeholder-char=space id=fraisReels name=fraisReels class=\"form-control ferrage-droite-cnaf millier-cnaf\" ng-model=vm.data.ressources.fraisReels title=\"en euros\"> <span class=input-group-btn><span class=\"picto picto-euro form-control-feedback\"></span><cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-fraisreels data-container=body data-trigger=manual tabindex=0></span><div class=hidden id=content-popover-fraisreels><div class=popover-btn-close-cnaf></div>Indiquer le montant des frais réels déclarés aux Impôts.</div></div></div></div></div><style>/* comportement d'une popup pour les mobiles */\n" +
    "@media (max-width: 639px) {\n" +
    "    .popover{\n" +
    "      max-width:100%;\n" +
    "  }\n" +
    "}\n" +
    "\n" +
    "/* comportement d'une popup pour les tablettes */\n" +
    "@media (min-width: 640px) and (max-width: 1023px) {\n" +
    "    .popover{\n" +
    "      max-width:100%;\n" +
    "  }\n" +
    "}\n" +
    "\n" +
    "\n" +
    "/* comportement d'une popup pour les autres écrans */\n" +
    "@media (min-width: 640px) {\n" +
    "    .popover{\n" +
    "      max-width:50%;\n" +
    "  }\n" +
    "}</style>")

$templateCache.put("components/cnaf-cct-retour-enfant/cnaf-cct-arrive-etranger-enfant/cnaf-cct-arrive-etranger-enfant.html","<fieldset><legend class=\"label-form-cnaf col-sm-12 row\">{{vm.controle.prenom}} {{vm.controle.nom}} arrive de l'étranger</legend><div class=row><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                vm.arriveetrangerform.arriveEtranger.$invalid && !vm.arriveetrangerform.arriveEtranger.$pristine\n" +
    "                || (vm.data.arriveEtranger == undefined && vm.controle.submitted)\n" +
    "                }\"><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.arriveEtranger uib-btn-radio=\"'Oui'\" for=arriveEtrangerOui><input type=radio name=arriveEtranger aria-label=Oui class=sr-only id=arriveEtrangerOui ng-model=vm.data.arriveEtranger value=oui required> <span aria-hidden=true>Oui</span></label></div><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.arriveEtranger uib-btn-radio=\"'Non'\" for=arriveEtrangerNon ng-click=vm.cleanMsg()><input type=radio name=arriveEtranger aria-label=non class=sr-only id=arriveEtrangerNon ng-model=vm.data.arriveEtranger value=non required> <span aria-hidden=true>Non</span></label></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.arriveEtranger == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></fieldset>")

$templateCache.put("components/cnaf-cct-retour-enfant/cnaf-cct-date-retour-enfant/cnaf-cct-date-retour-enfant.html","<div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateRetour>Date de retour</label><div id=divDateRetour class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                    ((vm.dateretourform.dateRetour.$invalid\n" +
    "                    && !vm.dateretourform.dateRetour.$pristine)\n" +
    "                    || (vm.data.dateRetour.length == 10 && vm.dateretourform.dateRetour.$error.pattern)\n" +
    "                    || vm.dateretourform.dateRetour.$error.controleDateRetour\n" +
    "                    || vm.dateretourform.dateRetour.$error.controleDateRetourDateDuJour\n" +
    "                    || vm.dateretourform.dateRetour.$error.controleDateRetourDateDepart\n" +
    "                    || vm.erroretatcivil\n" +
    "                    || (vm.data.dateRetour == undefined && vm.controle.submitted))\n" +
    "                    }\"><div class=\"form-group input-group\"><input id=dateRetour title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.dateRetour class=form-control inputname=vm.data.dateRetour ui-validate=\"{controleDateRetourDateDepart  : 'vm.controleDateRetour($value, vm.controle.dateDepart)', controleDateRetour  : 'vm.controleDateRetour($value, vm.controle.dateNaissance)', controleDateRetourDateDuJour  : 'vm.controleDateRetourDateDuJour($value, vm.controle.today)'}\" ui-validate-watch=\"'vm.data.choixPersonne'\" ng-required=true name=dateRetour pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.dateRetour pattern-cnaf=dd/MM/yyyy inputname=dateRetour></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"(vm.data.dateRetour.length == 10) && vm.dateretourform.dateRetour.$error.pattern \">Format de date invalide</p><p class=help-block role=alert ng-show=vm.dateretourform.dateRetour.$error.controleDateRetourDateDepart>La date de retour doit être postérieure à la date de départ</p><p class=help-block role=alert ng-show=vm.dateretourform.dateRetour.$error.controleDateRetour>La date de retour doit être postérieure à la date de naissance</p><p class=help-block role=alert ng-show=vm.dateretourform.dateRetour.$error.controleDateRetourDateDuJour>La date de retour ne peut pas être postérieure au {{vm.controle.today | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=\"((vm.data.dateRetour == undefined || vm.data.dateRetour == 'jj/mm/aaaa') && vm.controle.submitted)\">Champ obligatoire</p></div></div>")

$templateCache.put("components/cnaf-cct-sitenf-chgsit/cnaf-cct-adresse-etablissement/cnaf-cct-adresse-etablissement.html","<div class=row><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=nomEtab>Nom de l'établissement fréquenté</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                                  (vm.adresseetablissementform.nomEtab.$invalid && !vm.adresseetablissementform.nomEtab.$pristine)\n" +
    "                                  || vm.adresseetablissementform.nomEtab.$error.type8\n" +
    "                                  || (vm.data.nomEtab == undefined && vm.controle.submitted)\n" +
    "                                }\"><input id=nomEtab maxlength=50 ng-model=vm.data.nomEtab ng-change=\"vm.data.nomEtab = vm.data.nomEtab.toUpperCase()\" ng-pattern=\"/^[a-zA-Zà-ÿÀ-Ÿ0-9 '-]*$/\" ng-blur=\"vm.testType8(vm.data.nomEtab,vm.adresseetablissementform.nomEtab,'nomEtab')\" ng-trim=false name=nomEtab class=form-control required><p class=help-block role=alert ng-show=\"vm.adresseetablissementform.nomEtab.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.adresseetablissementform.nomEtab.$error.type8>{{vm.adresseetablissementform.nomEtab.invalidmsg}}</p><p class=help-block role=alert ng-show=\"(vm.data.nomEtab == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div><div class=col-sm-6><label class=label-form-cnaf for=telEtab>Numéro de téléphone de l'établissement</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                            (vm.adresseetablissementform.telEtab.$invalid && !vm.adresseetablissementform.telEtab.$pristine)\n" +
    "                            || vm.adresseetablissementform.telEtab.$error.type2\n" +
    "                            || (vm.data.telEtab == undefined && vm.controle.submitted)\n" +
    "                             }\"><input id=telEtab ng-model=vm.data.telEtab maxlength=15 name=telEtab ui-options=\"{clearOnBlur:false, allowInvalidValue:true}\" class=form-control ui-mask=\"99 99 99 99 99\" ui-mask-placeholder-char=space ng-blur=\"vm.testType2(vm.data.telEtab,vm.adresseetablissementform.telEtab,'telEtab')\" required><p class=help-block role=alert ng-show=vm.adresseetablissementform.telEtab.$error.pattern>Le numéro de téléphone est incorrect</p><p class=help-block role=alert ng-show=\"(vm.data.telEtab == undefined && vm.controle.submitted)\">Champ obligatoire</p><p class=help-block role=alert ng-show=vm.adresseetablissementform.telEtab.$error.type2>{{vm.adresseetablissementform.telEtab.invalidmsg}}</p></div></div></div><div class=row><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=cpComEtab>Code postal / Commune de l'établissement</label><div ng-switch on=vm.autocompletion><div ng-switch-when=on class=form-group ng-class=\"{ 'has-error' :\n" +
    "                            (vm.adresseetablissementform.cpComEtab.$invalid && !vm.adresseetablissementform.cpComEtab.$pristine)\n" +
    "                            || vm.erroradresse || (vm.data.cpComEtab == undefined && vm.controle.submitted)\n" +
    "                        }\"><input id=cpComEtab ng-model=vm.data.cpComEtab name=cpComEtab class=form-control typeahead-min-length=2 uib-typeahead=\"result as result.lib for result in vm.codePostalVilles($viewValue, vm.data)\" typeahead-editable=false ng-change=vm.reinitErreurAdresse() required><p class=help-block role=alert ng-show=\"(vm.data.cpComEtab == undefined && vm.controle.submitted)\">Champ obligatoire</p></div><div ng-switch-when=off class=form-group ng-class=\"{ 'has-error' :\n" +
    "                            (vm.adresseetablissementform.cpComEtab.$invalid && !vm.adresseetablissementform.cpComEtab.$pristine)\n" +
    "                                || vm.erroradresse\n" +
    "                                || vm.adresseetablissementform.cpComEtab.$error.type12\n" +
    "                                || (vm.data.cpComEtab == undefined && vm.controle.submitted)\n" +
    "                            }\"><input id=cpComEtab ng-model=vm.data.cpComEtab name=cpComEtab class=form-control ui-validate=\"{controleCodePostalFormat  : 'vm.controleCodePostalFormat($value)'}\" ng-trim=false required><p class=help-block role=alert ng-show=vm.adresseetablissementform.cpComEtab.$error.controleCodePostalFormat>Code postal incorrect</p><p class=help-block role=alert ng-show=\"(vm.data.cpComEtab == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=adresseEtab>N° et voie / Lieu-dit de l'établissement</label><div ng-switch on=vm.autocompletion><div ng-switch-when=on class=form-group ng-class=\"{ 'has-error' :\n" +
    "                            (vm.adresseetablissementform.adresseEtab.$invalid && !vm.adresseetablissementform.adresseEtab.$pristine)\n" +
    "                            || vm.erroradresse\n" +
    "                            || (vm.data.adresseEtab == undefined && vm.controle.submitted)\n" +
    "                            }\"><input id=adresseEtab ng-model=vm.data.adresseEtab name=adresseEtab class=form-control typeahead-min-length=2 uib-typeahead=\"result as result.lib for result in vm.numEtAdresse($viewValue)\" maxlength=38 ng-change=vm.reinitErreurAdresse() required><p class=help-block role=alert ng-show=\"(vm.data.adresseEtab == undefined && vm.controle.submitted)\">Champ obligatoire</p></div><div ng-switch-when=off class=form-group ng-class=\"{ 'has-error' :\n" +
    "                                (vm.adresseetablissementform.adresseEtab.$invalid && !vm.adresseetablissementform.adresseEtab.$pristine)\n" +
    "                                || vm.erroradresse\n" +
    "                                || vm.adresseetablissementform.adresseEtab.$error.type7\n" +
    "                                || (vm.data.adresseEtab == undefined && vm.controle.submitted)\n" +
    "                                }\"><input id=adresseEtab ng-model=vm.data.adresseEtab ng-blur=\"vm.testType7(vm.data.adresseEtab,vm.adresseetablissementform.adresseEtab,'numEtAdresse')\" ng-trim=false name=adresseEtab class=form-control maxlength=38 required><p class=help-block role=alert ng-show=vm.adresseetablissementform.adresseEtab.$error.type7>{{vm.adresseetablissementform.numEtAdresse.invalidmsg}}</p><p class=help-block role=alert ng-show=\"(vm.data.adresseEtab == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></div>")

$templateCache.put("components/cnaf-cct-sitenf-chgsit/cnaf-cct-sitenf-chgsit-ado1/cnaf-cct-sitenf-chgsit-ado1.html","<div ng-init=vm.init() class=row><div class=\"cct-bloc-boutons form-group btn-group btn-group-lg-cnaf btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                vm.chgsitado1form.situationAdo1.$invalid\n" +
    "                && !vm.chgsitado1form.situationAdo1.$pristine\n" +
    "                || (vm.data.situationAdo1 == undefined && vm.controle.submitted)\n" +
    "              }\"><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.situationAdo1 uib-btn-radio=vm.listeSituationAdo1[0].code for=congemat><input type=radio name=situationAdo1 aria-label=vm.listeSituationAdo1[0].code class=sr-only id=congemat ng-model=vm.data.situationAdo1 required> <span aria-hidden=true>{{vm.listeSituationAdo1[0].libelle}}</span></label></div><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.situationAdo1 uib-btn-radio=vm.listeSituationAdo1[1].code for=congeconv><input type=radio name=situationAdo1 aria-label=vm.listeSituationAdo1[1].code class=sr-only id=congeconv ng-model=vm.data.situationAdo1 required> <span aria-hidden=true>{{vm.listeSituationAdo1[1].libelle}}</span></label></div><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.situationAdo1 uib-btn-radio=vm.listeSituationAdo1[2].code for=congeparent><input type=radio name=situationAdo1 aria-label=vm.listeSituationAdo1[2].code class=sr-only id=congeparent ng-model=vm.data.situationAdo1 required> <span aria-hidden=true>{{vm.listeSituationAdo1[2].libelle}}</span></label></div><div class=col-sm-6 ng-if=vm.contratProfessionalisation()><label class=\"btn btn-default btn-block\" ng-model=vm.data.situationAdo1 uib-btn-radio=vm.listeSituationAdo1[3].code for=congesssolde><input type=radio name=situationAdo1 aria-label=vm.listeSituationAdo1[3].code class=sr-only id=congesssolde ng-model=vm.data.situationAdo1 required> <span aria-hidden=true>{{vm.listeSituationAdo1[3].libelle}}</span></label></div><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.situationAdo1 uib-btn-radio=vm.listeSituationAdo1[4].code for=congesab><input type=radio name=situationAdo1 aria-label=vm.listeSituationAdo1[4].code class=sr-only id=congesab ng-model=vm.data.situationAdo1 required> <span aria-hidden=true>{{vm.listeSituationAdo1[4].libelle}}</span></label></div><div class=col-sm-12><p class=help-block role=alert ng-show=\"(vm.data.situationAdo1 == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div>")

$templateCache.put("components/cnaf-cct-sitenf-chgsit/cnaf-cct-sitenf-chgsit-ado2/cnaf-cct-sitenf-chgsit-ado2.html","<div ng-init=vm.init()><div class=row><div class=\"cct-bloc-boutons form-group btn-group btn-group-lg-cnaf btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' : vm.chgsitado2form.situationAdo2.$invalid && !vm.chgsitado2form.situationAdo2.$pristine\n" +
    "                || (vm.data.situationAdo2 == undefined && vm.controle.submitted)\n" +
    "                }\"><div class=col-sm-6 ng-repeat=\"actvite in vm.listesituationsado2\"><label class=\"btn btn-default btn-block\" ng-model=vm.data.situationAdo2 uib-btn-radio=\"'{{actvite.code}}'\" for=situationAdo2{{actvite.code}}><input type=radio id=situationAdo2{{actvite.code}} name=situationAdo2 aria-label={{actvite.libelle}} clpopover-tsaass=sr-only ng-model=vm.data.situationAdo2 value={{actvite.code}} required> <span aria-hidden=true>{{actvite.libelle}}</span></label></div><div class=col-sm-12><p class=help-block role=alert ng-show=\"(vm.data.situationAdo2 == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></div><div class=row ng-if=\"vm.data.situationAdo2 === 'APP'\"><div class=col-sm-12><legend class=label-form-cnaf>Préciser la situation</legend></div><div class=\"cct-bloc-boutons form-group btn-group-lg-cnaf btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "        vm.chgsitado2form.situationAdo2StagAppAlt.$invalid\n" +
    "        && !vm.chgsitado2form.situationAdo2StagAppAlt.$pristine\n" +
    "        || (vm.data.situationAdo2StagAppAlt == undefined && vm.controle.submitted)\n" +
    "            }\"><div class=col-sm-6 ng-repeat=\"actvitePrecise in vm.listesituationsado2precises\" ng-class=\"{'::before' : actvitePrecise.length >38}\"><label class=\"btn btn-default btn-block\" ng-model=vm.data.situationAdo2StagAppAlt uib-btn-radio=\"'{{actvitePrecise.code}}'\" for=situationAdo2StagAppAlt{{actvitePrecise.code}} ng-class=\"{'align-middle-cnaf' : actvitePrecise.length >38}\"><input type=radio id=situationAdo2StagAppAlt{{actvitePrecise.code}} name=situationAdo2StagAppAlt aria-label={{actvitePrecise.libelle}} class=sr-only ng-model=vm.data.situationAdo2StagAppAlt value={{actvitePrecise.code}} required> <span aria-hidden=true>{{actvitePrecise.libelle}}</span></label></div><div class=col-sm-12><p class=help-block role=alert ng-show=\"(vm.data.situationAdo2StagAppAlt == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div><div class=row ng-if=\"vm.data.situationAdo2 === 'AUT'\"><div class=col-sm-12><legend class=label-form-cnaf>Préciser la situation</legend></div><div class=\"form-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "            vm.chgsitado2form.situationAdo2AutreSituation.$invalid\n" +
    "            && !vm.chgsitado2form.situationAdo2AutreSituation.$pristine\n" +
    "            || (vm.data.situationAdo2AutreSituation == undefined && vm.controle.submitted)\n" +
    "            }\"><div class=col-sm-6 ng-repeat=\"actvitePreciseAutre in vm.listesituationsado2precisesaut\" ng-class=\"{'::before' : actvitePreciseAutre.length >38}\"><span class=pull-right ng-if=actvitePreciseAutre.popover><cnaf-aide tabindex=0 data-toggle=popover data-id-content-cnaf=popover-actvitePreciseAutre{{$index}} data-container=body data-trigger=manual></span><label class=\"btn btn-default btn-block\" ng-model=vm.data.situationAdo2AutreSituation uib-btn-radio=\"'{{actvitePreciseAutre.code}}'\" for=situationAdo2AutreSituation{{$index}} ng-class=\"{'align-middle-cnaf' : actvitePreciseAutre.length >38}\"><input type=radio id=situationAdo2AutreSituation{{$index}} name=situationAdo2AutreSituation aria-label={{actvitePreciseAutre.libelle}} class=sr-only ng-model=vm.data.situationAdo2AutreSituation value={{actvitePreciseAutre.code}} required> <span aria-hidden=true>{{actvitePreciseAutre.libelle}}</span></label><div class=hidden id=popover-actvitePreciseAutre{{$index}}>{{actvitePreciseAutre.popover}}<div class=popover-btn-close-cnaf></div></div></div><div class=col-sm-12><p class=help-block role=alert ng-show=\"(vm.data.situationAdo2AutreSituation == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div>")

$templateCache.put("components/cnaf-cct-sitenf-chgsit/cnaf-cct-sitenf-chgsit-adulte/cnaf-cct-sitenf-chgsit-adulte.html","<div ng-init=vm.init()><div class=row><div class=\"cct-bloc-boutons form-group btn-group btn-group-lg-cnaf btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                  vm.chgsitadulteform.situationAdulte.$invalid\n" +
    "                  && !vm.chgsitadulteform.situationAdulte.$pristine\n" +
    "                  || (vm.data.situationAdulte == undefined && vm.controle.submitted)\n" +
    "                 }\"><div class=col-sm-6 ng-repeat=\"choixActi1 in vm.listeSituationAdulte\" ng-class=\"{'::before' : choixActi1.libelle.length >38}\"><div ng-if=\"choixActi1.libelle == 'Volontariat'\"><span class=pull-right><cnaf-aide tabindex=0 data-toggle=popover data-id-content-cnaf=content-popover-AideVolontariat data-container=body data-trigger=manual></span></div><div ng-if=\"choixActi1.libelle == 'Activité salariée'\"><span class=pull-right><cnaf-aide tabindex=0 data-toggle=popover data-id-content-cnaf=content-popover-AideActSal data-container=body data-trigger=manual></span></div><label class=\"btn btn-default btn-block\" ng-model=vm.data.situationAdulte uib-btn-radio=\"'{{choixActi1.code}}'\" for=situationAdulte{{choixActi1.code}}><input type=radio id=situationAdulte{{choixActi1.code}} name=situationAdulte aria-label={{choixActi1.code}} clpopover-tsaass=sr-only ng-model=vm.data.situationAdulte value={{choixActi1.code}} required> <span aria-hidden=true>{{choixActi1.libelle}}</span></label><div class=hidden id=content-popover-AideActSal>Salarié, engagé volontaire à l’armée et gérant salarié minoritaire ou égalitaire (affiliation au régime général de la Sécurité Sociale)<div class=popover-btn-close-cnaf></div></div><div class=hidden id=content-popover-AideVolontariat>Volontariat international, Volontariat civil, Volontariat pour l’insertion EPIDE, Service civique et Sapeur-pompier volontaire<div class=popover-btn-close-cnaf></div></div></div><div class=col-sm-12><p class=help-block role=alert ng-show=\"(vm.data.situationAdulte == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div><div class=row ng-if=\"vm.data.situationAdulte == 'ETU-STA-APP-ALT'\"><div class=col-sm-12><legend class=label-form-cnaf>Préciser la situation</legend></div><div class=\"cct-bloc-boutons form-group btn-group btn-group-lg-cnaf btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "            vm.chgsitadulteform.situationAdulteEtuStagAppAlt.$invalid\n" +
    "            && !vm.chgsitadulteform.situationAdulteEtuStagAppAlt.$pristine\n" +
    "            || (vm.data.situationAdulteEtuStagAppAlt == undefined && vm.controle.submitted)\n" +
    "                }\"><div class=col-sm-6 ng-repeat=\"choixActi in vm.choixactivites\" ng-class=\"{'::before' : choixActi.length >38}\"><label class=\"btn btn-default btn-block\" ng-model=vm.data.situationAdulteEtuStagAppAlt uib-btn-radio=\"'{{choixActi.code}}'\" for=situationAdulteEtuStagAppAlt{{choixActi.code}}><input type=radio id=situationAdulteEtuStagAppAlt{{choixActi.code}} name=situationAdulteEtuStagAppAlt aria-label={{choixActi.libelle}} class=sr-only ng-model=vm.data.situationAdulteEtuStagAppAlt value={{choixActi.code}} required> <span aria-hidden=true>{{choixActi.libelle}}</span></label></div><div class=col-sm-12><p class=help-block role=alert ng-show=\"(vm.data.situationAdulteEtuStagAppAlt == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></div>")

$templateCache.put("components/cnaf-cct-sitenf-chgsit/cnaf-cct-sitenf-chgsit-enfant2/cnaf-cct-sitenf-chgsit-enfant2.html","<div class=row><div class=\"form-group btn-group-lg-cnaf btn-group-justified\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                  vm.chgsitenfant2form.situationEnfant2.$invalid\n" +
    "                  && !vm.chgsitenfant2form.situationEnfant2.$pristine\n" +
    "                  || (vm.data.situationEnfant2 == undefined && vm.controle.submitted)\n" +
    "                 }\"><div class=\"col-sm-6 col-md-4\" ng-repeat=\"choixActi1 in vm.listeSituationEnfant2\"><label class=\"btn btn-default btn-block\" ng-model=vm.data.situationEnfant2 uib-btn-radio=\"'{{choixActi1.code}}'\" for=situationEnfant2{{choixActi1.code}} ng-class=\"{'align-middle-cnaf' : choixActi1.libelle.length <= 38}\"><input type=radio id=situationEnfant2{{choixActi1.code}} name=situationEnfant2 aria-label={{choixActi1.code}} clpopover-tsaass=sr-only ng-model=vm.data.situationEnfant2 value={{choixActi1.code}} required> <span aria-hidden=true>{{choixActi1.libelle}}</span></label></div><div class=col-sm-12><p class=help-block role=alert ng-show=\"(vm.data.situationEnfant2 == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div>")

$templateCache.put("components/cnaf-cct-sitenf-chgsit/cnaf-cct-situation-date-debut/cnaf-cct-situation-date-debut.html","<div class=row ng-init=vm.init()><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateActivite><span>Date de début de {{vm.controle.typeSituation}}</span></label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                    (vm.datedebutsituationform.dateActivite.$invalid\n" +
    "                    && !vm.datedebutsituationform.dateActivite.$pristine)\n" +
    "                    || (vm.datedebutsituationform.dateActivite.$error.pattern && vm.data.dateActivite.length == 10 && vm.data.dateActivite != 'jj/mm/aaaa')\n" +
    "                    || (vm.datedebutsituationform.dateActivite.$error.controleInfDateNaissance && vm.data.dateActivite.length == 10 && vm.data.dateActivite != 'jj/mm/aaaa')\n" +
    "                    || (vm.datedebutsituationform.dateActivite.$error.controleDateDuJour && vm.data.dateActivite.length == 10 && vm.data.dateActivite != 'jj/mm/aaaa')\n" +
    "                    || (vm.datedebutsituationform.dateActivite.$error.controleEntreAgeEtDateSit && vm.data.dateActivite.length == 10 && vm.data.dateActivite != 'jj/mm/aaaa')\n" +
    "                    || ((vm.data.dateActivite == undefined || vm.data.dateActivite == 'jj/mm/aaaa') && vm.controle.submitted) }\"><div class=\"form-group input-group\" id=divDateActivite><input id=dateActivite name=dateActivite value={{vm.data.dateActivite}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.dateActivite class=form-control ui-validate=\"{controleInfDateNaissance  : 'vm.controleDateNaissance($value)', controleDateDuJour  : 'vm.controleDateDuJour($value, vm.controle.today)', controleEntreAgeEtDateSit : 'vm.controleEntreAgeEtDateSit($value)'}\" ui-validate-watch-collection=vm.tableauControle ng-required=true inputname=vm.data.dateActivite pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.dateActivite start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateActivite></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"vm.datedebutsituationform.dateActivite.$error.pattern && vm.data.dateActivite.length == 10\">Format de date invalide</p><p class=help-block role=alert ng-show=vm.datedebutsituationform.dateActivite.$error.controleInfDateNaissance>La date de début de {{vm.controle.typeSituation}} doit être postérieure à la date de naissance</p><p class=help-block role=alert ng-show=vm.datedebutsituationform.dateActivite.$error.controleDateDuJour>La date de début de {{vm.controle.typeSituation}} doit être antérieure ou égale à la date du jour</p><p class=help-block role=alert ng-show=\"vm.datedebutsituationform.dateActivite.$error.controleEntreAgeEtDateSit && !vm.datedebutsituationform.dateActivite.$error.controleInfDateNaissance\">Pour ce choix de situation, vous ne pouvez pas déclarer un début de {{vm.controle.typeSituation}} antérieure au {{vm.sDateDebutAutorisee}}</p><p class=help-block role=alert ng-show=\"((vm.data.dateActivite == undefined || vm.data.dateActivite == 'jj/mm/aaaa') && vm.controle.submitted)\">Champ obligatoire</p></div></div></div>")

$templateCache.put("components/cnaf-cct-sitenf-chgsit/cnaf-cct-situation-date-fin/cnaf-cct-situation-date-fin.html","<div class=row><div class=col-sm-4><label class=label-form-cnaf for=dateFinSituation>Date de fin de contrat</label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                (vm.datefinsituationform.dateFinSituation.$invalid\n" +
    "                && !vm.datefinsituationform.dateFinSituation.$pristine)\n" +
    "                || (vm.datefinsituationform.dateFinSituation.$error.pattern)\n" +
    "                || ((vm.data.dateFinSituation == undefined || vm.data.dateFinSituation == 'jj/mm/aaaa') && vm.controle.submitted && vm.controle.dateFinObligatoire\n" +
    "                || vm.datefinsituationform.dateFinSituation.$error.controleSupDateDeb)\n" +
    "            }\"><div class=\"form-group input-group\" id=divdateFinSituation><input id=dateFinSituation name=dateFinSituation value={{vm.data.dateFinSituation}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.dateFinSituation class=form-control ui-validate=\"{controleSupDateDeb : 'vm.controleSupDateDeb($value)'}\" ui-validate-watch=\"'vm.data.dateActivite'\" pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$ ng-required=vm.controle.dateFinObligatoire><cnaf-date-picker ng-model=vm.data.dateFinSituation start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateFinSituation></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"vm.datefinsituationform.dateFinSituation.$error.pattern && vm.data.dateFinSituation.length == 10\">Format de date invalide</p><p class=help-block role=alert ng-show=vm.datefinsituationform.dateFinSituation.$error.controleSupDateDeb>La date de fin de contrat doit être postérieure à la date de début de {{vm.controle.typeSituation}}</p><p class=help-block role=alert ng-show=\"(vm.controle.dateFinObligatoire && (vm.data.dateFinSituation == undefined || vm.data.dateFinSituation == 'jj/mm/aaaa') && vm.controle.submitted)\">Champ obligatoire</p></div></div></div>")

$templateCache.put("components/cnaf-cct-sitenf-chgsit/cnaf-cct-situation-enfant1/cnaf-cct-situation-enfant1.html","<div class=row><div class=\"form-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "            vm.situationenfant1form.situationEnfant1.$invalid && !vm.situationenfant1form.situationEnfant1.$pristine\n" +
    "            || (vm.data.situationEnfant1 == undefined && vm.controle.submitted)\n" +
    "            }\"><div class=col-sm-4><label class=\"btn btn-default btn-block\" id=situationEnfant1 ng-model=vm.data.situationEnfant1 uib-btn-radio=\"'SCO'\" for=SCO><input type=radio name=situationEnfant1 aria-label=SCO class=sr-only id=SCO ng-model=vm.data.situationEnfant1 value=SCO required> <span aria-hidden=true>Scolarisé en CP</span></label></div><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.situationEnfant1 uib-btn-radio=\"'NonSCO'\" for=NonSCO><input type=radio name=situationEnfant1 aria-label=NonSCO class=sr-only id=NonSCO ng-model=vm.data.situationEnfant1 value=NonSCO required> <span aria-hidden=true>Non scolarisé en CP</span></label></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.situationEnfant1 == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div>")

$templateCache.put("components/cnaf-cct-sitpro/cnaf-cct-sitpro-choix-activite/cnaf-cct-sitpro-choix-activite.html","<div ng-init=vm.init()><div class=row><div class=\"form-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                vm.choixactiviteform.choixActivite{{vm.index}}.$invalid\n" +
    "                && !vm.choixactiviteform.choixActivite{{vm.index}}.$pristine }\"><div class=col-sm-6 ng-repeat=\"choixActi in vm.choixactivites\" ng-class=\"{'::before' : choixActi.libelle.length >38}\"><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixActivite uib-btn-radio=\"'{{choixActi.code}}'\" for=choixActivite{{choixActi.code}} ng-class=\"{'align-middle-cnaf' : choixActi.libelle.length >38}\"><input type=radio id=choixActivite{{choixActi.code}} name=choixActivite{{vm.index}} aria-label={{choixActi.libelle}} class=sr-only ng-model=vm.data.sitPros[vm.index].choixActivite value={{choixActi.code}} required> <span aria-hidden=true>{{choixActi.libelle}}</span></label></div></div></div><div ng-if=\"vm.data.sitPros[vm.index].choixActivite == 'SAL'\"><cnaf-cct-sitpro-choix-activite-salariee autocompletion=vm.autocompletion data=vm.data choixactivitesalarieeform=vm.choixactiviteform errorchoixactivitesalariee=vm.errorchoixactivitesalariee controle=vm.controle index=vm.index></cnaf-cct-sitpro-choix-activite-salariee></div><div ng-if=\"vm.data.sitPros[vm.index].choixActivite == 'RET'\"><cnaf-cct-sitpro-choix-activite-retraite autocompletion=vm.autocompletion data=vm.data choixactiviteretraiteform=vm.choixactiviteform errorchoixactiviteretraite=vm.errorchoixactiviteretraite controle=vm.controle index=vm.index></cnaf-cct-sitpro-choix-activite-retraite></div><div ng-if=\"vm.data.sitPros[vm.index].choixActivite == 'PENS'\"><cnaf-cct-sitpro-choix-activite-invalidite autocompletion=vm.autocompletion data=vm.data choixactiviteinvaliditeform=vm.choixactiviteform errorchoixactiviteinvalidite=vm.errorchoixactiviteinvalidite controle=vm.controle index=vm.index></cnaf-cct-sitpro-choix-activite-invalidite></div><div ng-if=\"vm.data.sitPros[vm.index].choixActivite == 'NSAL'\"><cnaf-cct-sitpro-choix-activite-non-salariee autocompletion=vm.autocompletion data=vm.data choixactivitenonsalarieeform=vm.choixactiviteform errorchoixactivitenonsalariee=vm.errorchoixactivitenonsalariee controle=vm.controle index=vm.index></cnaf-cct-sitpro-choix-activite-non-salariee></div><div ng-if=\"vm.data.sitPros[vm.index].choixActivite == 'CHO'\"><cnaf-cct-sitpro-choix-activite-chomage autocompletion=vm.autocompletion data=vm.data choixactivitechomageform=vm.choixactiviteform errorchoixactivitechomage=vm.errorchoixactivitechomage controle=vm.controle index=vm.index></cnaf-cct-sitpro-choix-activite-chomage></div><div ng-if=\"vm.data.sitPros[vm.index].choixActivite == 'CONG'\"><cnaf-cct-sitpro-choix-activite-conges-divers autocompletion=vm.autocompletion data=vm.data choixactivitecongesdiversform=vm.choixactiviteform errorchoixactivitecongesdivers=vm.errorchoixactivitecongesdivers controle=vm.controle index=vm.index></cnaf-cct-sitpro-choix-activite-conges-divers></div><div ng-if=\"vm.data.sitPros[vm.index].choixActivite == 'AUT'\"><cnaf-cct-sitpro-choix-activite-autre-situation autocompletion=vm.autocompletion data=vm.data choixactiviteautresituationform=vm.choixactiviteform errorchoixactiviteautresituation=vm.errorchoixactiviteautresituation controle=vm.controle index=vm.index></cnaf-cct-sitpro-choix-activite-autre-situation></div><div ng-if=\"vm.data.sitPros[vm.index].choixActivite == 'ETU'\"><cnaf-cct-sitpro-etudiant data=vm.data sitproetudiantform=vm.choixactiviteform errorsitproetudiant=vm.errorsitproetudiant controle=vm.controle index=vm.index></cnaf-cct-sitpro-etudiant></div><div ng-if=\"vm.data.sitPros[vm.index].choixActivite == 'APP'\"><cnaf-cct-sitpro-choix-activite-stagiaire autocompletion=vm.autocompletion data=vm.data choixactivitestagiaireform=vm.choixactiviteform errorchoixactivitestagiaire=vm.errorchoixactivitestagiaire controle=vm.controle index=vm.index></cnaf-cct-sitpro-choix-activite-stagiaire></div></div>")

$templateCache.put("components/cnaf-cct-sitpro/cnaf-cct-sitpro-choix-activite-autre-situation/cnaf-cct-sitpro-choix-activite-autre-situation.html","<div ng-init=vm.init()><div class=row><fieldset><div class=col-sm-12><legend class=label-form-cnaf>Préciser la situation</legend></div><div class=\"form-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                vm.choixactiviteautresituationform.choixAutreSituation{{vm.index}}.$invalid\n" +
    "                && !vm.choixactiviteautresituationform.choixAutreSituation{{vm.index}}.$pristine}\"><div class=col-sm-6 ng-repeat=\"situation in vm.listeChoixAutreSituation\"><span class=pull-right ng-if=situation.ael><cnaf-aide tabindex=0 data-toggle=popover data-id-content-cnaf=popover-tsa data-container=body data-trigger=manual></span><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixAutreSituation uib-btn-radio=situation for={{situation.id}}><input type=radio name=choixAutreSituation{{vm.index}} aria-label={{situation.libelle}} class=sr-only id={{situation.id}} ng-model=vm.data.sitPros[vm.index].choixAutreSituation required> <span aria-hidden=true>{{situation.libelle}}</span></label><div class=hidden id=popover-tsa ng-if=situation.ael>{{situation.ael}}</div></div></div></fieldset></div><div class=row ng-if=\"vm.data.sitPros[vm.index].choixAutreSituation.id == 'activiteSansActivite'\"><div class=col-sm-4><label ng-if=\"vm.index == 0\" class=\"label-form-cnaf control-label\" for=dateActivite{{vm.index}}>Depuis le</label><label ng-if=\"vm.index > 0\" class=\"label-form-cnaf control-label\" for=dateActivite{{vm.index}}>Date de début de situation</label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                     vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$invalid\n" +
    "                     && !vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$pristine\n" +
    "                     || vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.pattern}\"><div class=\"form-group input-group\" id=divDateActivite{{vm.index}}><input id=dateActivite{{vm.index}} name=dateActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateActivite}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActivite class=form-control ui-validate=\"{controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                      controleSupDernJourMoisSuivDemAL  : 'vm.controleSupDernJourMoisSuivDemAL($value, vm.controle.dernjourodal, vm.index)',\n" +
    "                                      controleDateSitPro : 'vm.controlerDateSitPro($value, vm.index, vm.data.sitPros, vm.datePosterieure, vm.controle.datedebperiodeactal)'\n" +
    "                             }\" ng-required=true inputname=vm.data.sitPros[vm.index].dateActivite pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActivite start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateActivite{{vm.index}}></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.pattern && vm.data.sitPros[vm.index].dateActivite.length == 10\">Format de date invalide</p><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.controleInfDateNaissance>Date saisie incorrecte</p><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.controleSupDernJourMoisSuivDemAL>La date saisie ne peut être postérieure à la date du {{vm.controle.dernjourodal | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.controleDateSitPro ng-init=vm.generationDatePosterieure(vm.index)>La date saisie doit être antérieure à {{vm.datePosterieure | date:'dd/MM/yyyy'}}</p></div></div><div class=col-sm-4 ng-if=\"vm.index > 0\" ng-init=vm.dateActivitePrecMoins1jour(vm.index,vm.data.sitPros[vm.index-1].dateActivite,vm.data.sitPros)><div ng-if=\"vm.data.sitPros[vm.index].dateFinActivite != undefined\"><label class=\"label-form-cnaf control-label\" for=dateFinActivite{{vm.index}}>Date de fin de situation</label><div class=\"form-group input-group\"><div class=\"form-group input-group\" id=divDateFinActivite{{vm.index}}><input id=dateFinActivite{{vm.index}} name=dateFinActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateFinActivite}} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateFinActivite ng-disabled=true class=form-control></div></div></div></div></div><div ng-if=\"vm.data.sitPros[vm.index].choixAutreSituation.id == 'activiteArretMaladie'\"><div class=row><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateActivite{{vm.index}}>Date de début de la maladie</label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                    vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$invalid\n" +
    "                    && !vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$pristine\n" +
    "                    || vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.pattern}\"><div class=\"form-group input-group\" id=divDateActivite{{vm.index}}><input id=dateActivite{{vm.index}} name=dateActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateActivite}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActivite class=form-control ui-validate=\"{  controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                        controleSupDernJourMoisSuivDemAL  : 'vm.controleSupDernJourMoisSuivDemAL($value, vm.controle.dernjourodal, vm.index)',\n" +
    "                                        controleDateSitPro : 'vm.controlerDateSitPro($value, vm.index, vm.data.sitPros, vm.datePosterieure, vm.controle.datedebperiodeactal)'\n" +
    "                                  }\" ng-required=true inputname=vm.data.sitPros[vm.index].dateActivite pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActivite start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateActivite{{vm.index}}></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.pattern && vm.data.sitPros[vm.index].dateActivite.length == 10\">Format de date invalide</p><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.controleInfDateNaissance>Date saisie incorrecte</p><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.controleSupDernJourMoisSuivDemAL>La date saisie ne peut être postérieure à la date du {{vm.controle.dernjourodal | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.controleDateSitPro ng-init=vm.generationDatePosterieure(vm.index)>La date saisie doit être antérieure à {{vm.datePosterieure | date:'dd/MM/yyyy'}}</p></div></div><div class=col-sm-4 ng-if=\"vm.index > 0\" ng-init=vm.dateActivitePrecMoins1jour(vm.index,vm.data.sitPros[vm.index-1].dateActivite,vm.data.sitPros)><div ng-if=\"vm.data.sitPros[vm.index].dateFinActivite != undefined\"><label class=\"label-form-cnaf control-label\" for=dateFinActivite{{vm.index}}>Date de fin de situation</label><div class=\"form-group input-group\"><div class=\"form-group input-group\" id=divDateFinActivite{{vm.index}}><input id=dateFinActivite{{vm.index}} name=dateFinActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateFinActivite}} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateFinActivite ng-disabled=true class=form-control></div></div></div></div></div><div class=row><fieldset><div class=col-sm-4><legend class=label-form-cnaf>Il s'agit d'une affection longue durée</legend><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' : vm.choixactiviteautresituationform.affectionLongueDuree.$invalid && !vm.choixactiviteautresituationform.affectionLongueDuree.$pristine }\"><div class=row><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].affectionLongueDuree uib-btn-radio=\"'Oui'\" for=affectionLongueDureeOui><input type=radio name=affectionLongueDuree aria-label=Oui class=sr-only id=affectionLongueDureeOui ng-model=vm.data.sitPros[vm.index].affectionLongueDuree value=oui required> <span aria-hidden=true>Oui</span></label></div><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].affectionLongueDuree uib-btn-radio=\"'Non'\" for=affectionLongueDureeNon><input type=radio name=affectionLongueDuree aria-label=non class=sr-only id=affectionLongueDureeNon ng-model=vm.data.sitPros[vm.index].affectionLongueDuree value=non required> <span aria-hidden=true>Non</span></label></div></div></div></div></fieldset></div><div class=row ng-if=\"vm.data.sitPros[vm.index].affectionLongueDuree == 'Oui'\"><div class=col-sm-12><label class=\"label-form-cnaf control-label\" for=datePriseEnCompteAffection{{vm.index}}>Date de prise en compte de cette affection par l'organisme d'assurance maladie</label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                    vm.choixactiviteautresituationform.datePriseEnCompteAffection{{vm.index}}.$invalid\n" +
    "                    && !vm.choixactiviteautresituationform.datePriseEnCompteAffection{{vm.index}}.$pristine\n" +
    "                    || vm.choixactiviteautresituationform.datePriseEnCompteAffection{{vm.index}}.$error.pattern}\"><div class=\"form-group input-group\" id=divDatePriseEnCompteAffection{{vm.index}}><input id=datePriseEnCompteAffection{{vm.index}} name=datePriseEnCompteAffection{{vm.index}} value={{vm.data.sitPros[vm.index].datePriseEnCompteAffection}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].datePriseEnCompteAffection class=form-control ng-required=true ui-validate=\"{\n" +
    "                                controleDateSupOuEgale  : 'vm.controleDateSupOuEgale(vm.data.sitPros[vm.index].dateActivite, $value)'\n" +
    "                                 }\" pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].datePriseEnCompteAffection start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=datePriseEnCompteAffection{{vm.index}}></cnaf-date-picker></div><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.datePriseEnCompteAffection{{vm.index}}.$error.controleDateSupOuEgale>La date de prise en compte de la maladie doit être postérieure à la date de début de maladie</p><p class=help-block role=alert ng-show=\"vm.choixactiviteautresituationform.datePriseEnCompteAffection{{vm.index}}.$error.pattern && vm.data.sitPros[vm.index].datePriseEnCompteAffection.length == 10\">Format de date invalide</p></div></div></div></div><div ng-if=\"vm.data.sitPros[vm.index].choixAutreSituation.id == 'activiteMOC'\"><div class=row><div class=col-sm-4><label ng-if=\"vm.index == 0\" class=\"label-form-cnaf control-label\" for=dateActivite{{vm.index}}>Depuis le</label><label ng-if=\"vm.index > 0\" class=\"label-form-cnaf control-label\" for=dateActivite{{vm.index}}>Date de début de situation</label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                    vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$invalid\n" +
    "                    && !vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$pristine\n" +
    "                    || vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.pattern}\"><div class=\"form-group input-group\" id=divDateActivite{{vm.index}}><input id=dateActivite{{vm.index}} name=dateActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateActivite}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActivite class=form-control ng-required=true ui-validate=\"{  controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                        controleSupDernJourMoisSuivDemAL  : 'vm.controleSupDernJourMoisSuivDemAL($value, vm.controle.dernjourodal, vm.index)',\n" +
    "                                        controleDateSitPro : 'vm.controlerDateSitPro($value, vm.index, vm.data.sitPros, vm.datePosterieure, vm.controle.datedebperiodeactal)'\n" +
    "                                  }\" inputname=vm.data.sitPros[vm.index].dateActivite pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActivite start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateActivite{{vm.index}}></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.pattern && vm.data.sitPros[vm.index].dateActivite.length == 10\">Format de date invalide</p><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.controleInfDateNaissance>Date saisie incorrecte</p><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.controleSupDernJourMoisSuivDemAL>La date saisie ne peut être postérieure à la date du {{vm.controle.dernjourodal | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.controleDateSitPro ng-init=vm.generationDatePosterieure(vm.index)>La date saisie doit être antérieure à {{vm.datePosterieure | date:'dd/MM/yyyy'}}</p></div></div><div class=col-sm-4 ng-if=\"vm.index > 0\" ng-init=vm.dateActivitePrecMoins1jour(vm.index,vm.data.sitPros[vm.index-1].dateActivite,vm.data.sitPros)><div ng-if=\"vm.data.sitPros[vm.index].dateFinActivite != undefined\"><label class=\"label-form-cnaf control-label\" for=dateFinActivite{{vm.index}}>Date de fin de situation</label><div class=\"form-group input-group\"><div class=\"form-group input-group\" id=divDateFinActivite{{vm.index}}><input id=dateFinActivite{{vm.index}} name=dateFinActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateFinActivite}} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateFinActivite ng-disabled=true class=form-control></div></div></div></div></div><div class=row><div class=col-sm-6><label class=label-form-cnaf for=nomOrganisationCommunautaire{{vm.index}}>Nom de l’organisation communautaire</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "               (vm.choixactiviteautresituationform.nomOrganisationCommunautaire{{vm.index}}.$invalid && !vm.choixactiviteautresituationform.nomOrganisationCommunautaire{{vm.index}}.$pristine)\n" +
    "                 || vm.choixactiviteautresituationform.nomOrganisationCommunautaire{{vm.index}}.$error.type8\n" +
    "                 }\"><input id=nomOrganisationCommunautaire{{vm.index}} maxlength=30 ng-model=vm.data.sitPros[vm.index].nomOrganisationCommunautaire ng-change=\"vm.data.sitPros[vm.index].nomOrganisationCommunautaire = vm.data.sitPros[vm.index].nomOrganisationCommunautaire.toUpperCase()\" ng-pattern=\"/^[0-9a-zA-Zà-ÿÀ-Ÿ '-]*$/\" ng-blur=\"vm.testType8(vm.data.sitPros[vm.index].nomOrganisationCommunautaire,vm.choixactiviteautresituationform,'nomOrganisationCommunautaire{{vm.index}}')\" ng-trim=false name=nomOrganisationCommunautaire{{vm.index}} class=form-control required><p class=help-block role=alert ng-show=\"vm.choixactiviteautresituationform.nomOrganisationCommunautaire{{vm.index}}.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.nomOrganisationCommunautaire{{vm.index}}.$error.type8>{{vm.choixactiviteautresituationform.nomOrganisationCommunautaire.invalidmsg}}</p></div></div><div class=col-sm-6><label class=label-form-cnaf for=paysActivite{{vm.index}}>Pays de l'organisation communautaire</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "               (vm.choixactiviteautresituationform.paysActivite{{vm.index}}.$invalid && !vm.choixactiviteautresituationform.paysActivite{{vm.index}}.$pristine)\n" +
    "                 }\"><input id=paysActivite{{vm.index}} ng-model=vm.data.sitPros[vm.index].paysActivite name=paysActivite{{vm.index}} class=form-control typeahead-min-length=2 uib-typeahead=\"pays as pays.libelleCaffr for pays in vm.getListePaysEmployeurProposes($viewValue) | filter:$viewValue | limitTo:8\" typeahead-editable=false typeahead-no-results=noPaysFound required><p class=help-block role=alert ng-show=noPaysFound>Pays non trouvé</p></div></div></div><div class=row ng-if=\"vm.data.sitPros[vm.index].paysActivite && vm.data.sitPros[vm.index].paysActivite.libelleCaffr != 'FRANCE' && vm.data.sitPros[vm.index].paysActivite.libelleCaffr != 'PRINCIPAUTE DE MONACO'\"><div class=col-sm-6><label class=label-form-cnaf for=codePostalZoneActivite{{vm.index}}>Ville de l’organisation communautaire</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "              (vm.choixactiviteautresituationform.codePostalZoneActivite{{vm.index}}.$invalid && !vm.choixactiviteautresituationform.codePostalZoneActivite{{vm.index}}.$pristine)\n" +
    "              || vm.choixactiviteautresituationform.codePostalZoneActivite{{vm.index}}.$error.type5\n" +
    "            }\"><input id=codePostalZoneActivite{{vm.index}} ng-model=vm.data.sitPros[vm.index].codePostalZoneActivite ng-model-options=\"{ updateOn: 'blur' }\" ui-validate=\"{type5  : 'vm.testType5($value,vm.choixactiviteautresituationform.codePostalZoneActivite{{vm.index}}, {{vm.index}})'}\" ng-trim=false name=codePostalZoneActivite{{vm.index}} class=form-control required ng-pattern=\"/^[a-zA-Z0-9à-ÿÀ-Ÿ -']*$/\"><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.codePostalZoneActivite{{vm.index}}.$error.pattern>La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.codePostalZoneActivite{{vm.index}}.$error.type5>{{vm.choixactiviteautresituationform.codePostalZoneActivite.invalidmsg}}</p></div></div></div><div class=row ng-if=vm.afficheCodePostalVille(vm.index)><div class=col-sm-6><label class=label-form-cnaf for=codePostalZoneActivite{{vm.index}}>Code postal / Commune de l'organisation communautaire</label><div ng-switch on=vm.autocompletion><div ng-switch-when=on class=form-group ng-class=\"{ 'has-error' :\n" +
    "                        (vm.choixactiviteautresituationform.codePostalZoneActivite{{vm.index}}.$invalid && !vm.choixactiviteautresituationform.codePostalZoneActivite{{vm.index}}.$pristine)\n" +
    "                        }\"><input id=codePostalZoneActivite{{vm.index}} ng-model=vm.data.sitPros[vm.index].codePostalZoneActivite name=codePostalZoneActivite{{vm.index}} class=form-control typeahead-min-length=2 uib-typeahead=\"result as result.lib for result in vm.codePostalVilles($viewValue)\" typeahead-editable=false required></div><div ng-switch-when=off class=form-group ng-class=\"{ 'has-error' :\n" +
    "                     (vm.choixactiviteautresituationform.codePostalZoneActivite{{vm.index}}.$invalid && !vm.choixactiviteautresituationform.codePostalZoneActivite{{vm.index}}.$pristine)\n" +
    "                      }\"><input id=codePostalZoneActivite{{vm.index}} ng-model=vm.data.sitPros[vm.index].codePostalZoneActivite name=codePostalZoneActivite{{vm.index}} class=form-control ui-validate=\"{controleCodePostalFormat  : 'vm.controleCodePostalFormat($value)'}\" ng-trim=false required><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.codePostalZoneActivite{{vm.index}}.$error.controleCodePostalFormat>Code postal incorrect</p></div></div></div></div><div class=row ng-if=\"vm.data.sitPros[vm.index].paysActivite && vm.data.sitPros[vm.index].paysActivite.libelleCaffr != 'FRANCE' && vm.data.sitPros[vm.index].paysActivite.libelleCaffr != 'PRINCIPAUTE DE MONACO'\"><div class=col-sm-6><label class=label-form-cnaf for=villeOrgaComm{{vm.index}}>Ville de l'employeur</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "              (vm.choixactiviteautresituationform.villeOrgaComm{{vm.index}}.$invalid && !vm.choixactiviteautresituationform.villeOrgaComm{{vm.index}}.$pristine)\n" +
    "              || vm.choixactiviteautresituationform.villeOrgaComm{{vm.index}}.$error.type5\n" +
    "            }\"><input id=villeOrgaComm{{vm.index}} ng-model=vm.data.sitPros[vm.index].villeOrgaComm ng-model-options=\"{ updateOn: 'blur' }\" ui-validate=\"{type5  : 'vm.testType5($value,vm.choixactiviteautresituationform.villeOrgaComm{{vm.index}}, {{vm.index}})'}\" ng-trim=false name=villeOrgaComm{{vm.index}} class=form-control required ng-pattern=\"/^[a-zA-Z0-9à-ÿÀ-Ÿ -']*$/\"><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.villeOrgaComm{{vm.index}}.$error.pattern>La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.villeOrgaComm{{vm.index}}.$error.type5>{{vm.choixactiviteautresituationform.villeOrgaComm{{vm.index}}.invalidmsg}}</p></div></div></div></div><div class=row ng-if=\"vm.data.sitPros[vm.index].choixAutreSituation.id == 'activiteDetention'\"><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateActivite{{vm.index}}>Date de début de détention</label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                    vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$invalid\n" +
    "                    && !vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$pristine\n" +
    "                    || vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.pattern}\"><div class=\"form-group input-group\" id=divDateActivite{{vm.index}}><input id=dateActivite{{vm.index}} name=dateActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateActivite}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActivite class=form-control ui-validate=\"{  controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                        controleSupDernJourMoisSuivDemAL  : 'vm.controleSupDernJourMoisSuivDemAL($value, vm.controle.dernjourodal, vm.index)',\n" +
    "                                        controleDateSitPro : 'vm.controlerDateSitPro($value, vm.index, vm.data.sitPros, vm.datePosterieure, vm.controle.datedebperiodeactal)'\n" +
    "                                  }\" ng-required=true inputname=vm.data.sitPros[vm.index].dateActivite pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActivite start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateActivite{{vm.index}}></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.pattern && vm.data.sitPros[vm.index].dateActivite.length == 10\">Format de date invalide</p><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.controleInfDateNaissance>Date saisie incorrecte</p><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.controleSupDernJourMoisSuivDemAL>La date saisie ne peut être postérieure à la date du {{vm.controle.dernjourodal | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.controleDateSitPro ng-init=vm.generationDatePosterieure(vm.index)>La date saisie doit être antérieure à {{vm.datePosterieure | date:'dd/MM/yyyy'}}</p></div></div><div class=col-sm-4 ng-if=\"vm.index == 0\"><label class=\"label-form-cnaf control-label\" for=dateFinActivite{{vm.index}}>Date de fin de détention</label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                    vm.choixactiviteautresituationform.dateFinActivite{{vm.index}}.$invalid\n" +
    "                    && !vm.choixactiviteautresituationform.dateFinActivite{{vm.index}}.$pristine\n" +
    "                    || vm.choixactiviteautresituationform.dateFinActivite{{vm.index}}.$error.pattern}\"><div class=\"form-group input-group\" id=divDateFinActivite{{vm.index}}><input id=dateFinActivite{{vm.index}} name=dateFinActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateFinActivite}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateFinActivite ui-validate=\"{controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                      controleDateSup  : 'vm.controleDateSup(vm.data.sitPros[vm.index].dateActivite, $value)'\n" +
    "                             }\" class=form-control pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateFinActivite start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateFinActivite{{vm.index}}></cnaf-date-picker></div><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.dateFinActivite{{vm.index}}.$error.controleDateSup>La date de fin doit être postérieure à la date de début</p><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.controleInfDateNaissance>Date saisie incorrecte</p><p class=help-block role=alert ng-show=\"vm.choixactiviteautresituationform.dateFinActivite{{vm.index}}.$error.pattern && vm.data.sitPros[vm.index].dateFinActivite.length == 10\">Format de date invalide</p></div></div><div class=col-sm-4 ng-if=\"vm.index > 0\" ng-init=vm.dateActivitePrecMoins1jour(vm.index,vm.data.sitPros[vm.index-1].dateActivite,vm.data.sitPros)><div ng-if=\"vm.data.sitPros[vm.index].dateFinActivite != undefined\"><label class=\"label-form-cnaf control-label\" for=dateFinActivite{{vm.index}}>Date de fin de situation</label><div class=\"form-group input-group\"><div class=\"form-group input-group\" id=divDateFinActivite{{vm.index}}><input id=dateFinActivite{{vm.index}} name=dateFinActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateFinActivite}} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateFinActivite ng-disabled=true class=form-control></div></div></div></div><div class=col-sm-6><label class=label-form-cnaf for=nomOrganisationCommunautaire{{vm.index}}>Nom de l'établissement pénitentiaire</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "            (vm.choixactiviteautresituationform.nomOrganisationCommunautaire{{vm.index}}.$invalid && !vm.choixactiviteautresituationform.nomOrganisationCommunautaire{{vm.index}}.$pristine)\n" +
    "                || vm.choixactiviteautresituationform.nomOrganisationCommunautaire{{vm.index}}.$error.type8\n" +
    "                }\"><input id=nomOrganisationCommunautaire{{vm.index}} maxlength=30 ng-model=vm.data.sitPros[vm.index].nomOrganisationCommunautaire ng-change=\"vm.data.sitPros[vm.index].nomOrganisationCommunautaire = vm.data.sitPros[vm.index].nomOrganisationCommunautaire.toUpperCase()\" ng-pattern=\"/^[0-9a-zA-Zà-ÿÀ-Ÿ '-]*$/\" ng-blur=\"vm.testType8(vm.data.sitPros[vm.index].nomOrganisationCommunautaire,vm.choixactiviteautresituationform,'nomOrganisationCommunautaire{{vm.index}}')\" ng-trim=false name=nomOrganisationCommunautaire{{vm.index}} class=form-control required><p class=help-block role=alert ng-show=\"vm.choixactiviteautresituationform.nomOrganisationCommunautaire{{vm.index}}.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.nomOrganisationCommunautaire{{vm.index}}.$error.type8>{{vm.choixactiviteautresituationform.nomOrganisationCommunautaire.invalidmsg}}</p></div></div><div class=col-sm-6><label class=label-form-cnaf for=paysActivite{{vm.index}}>Pays de l'établissement</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "            (vm.choixactiviteautresituationform.paysActivite{{vm.index}}.$invalid && !vm.choixactiviteautresituationform.paysActivite{{vm.index}}.$pristine)\n" +
    "                }\"><input id=paysActivite{{vm.index}} ng-model=vm.data.sitPros[vm.index].paysActivite name=paysActivite{{vm.index}} class=form-control typeahead-min-length=2 uib-typeahead=\"pays as pays.libelleCaffr for pays in vm.getListePaysEmployeurProposes($viewValue) | filter:$viewValue | limitTo:8\" typeahead-editable=false typeahead-no-results=noPaysFound required><p class=help-block role=alert ng-show=noPaysFound>Pays non trouvé</p></div></div><div ng-if=vm.afficheCodePostalVille(vm.index)><div class=col-sm-6><label class=label-form-cnaf for=codePostalZoneActivite{{vm.index}}>Code postal / Commune de l'établissement</label><div ng-switch on=vm.autocompletion><div ng-switch-when=on class=form-group ng-class=\"{ 'has-error' :\n" +
    "                        (vm.choixactiviteautresituationform.codePostalZoneActivite{{vm.index}}.$invalid && !vm.choixactiviteautresituationform.codePostalZoneActivite{{vm.index}}.$pristine)\n" +
    "                        }\"><input id=codePostalZoneActivite{{vm.index}} ng-model=vm.data.sitPros[vm.index].codePostalZoneActivite name=codePostalZoneActivite{{vm.index}} class=form-control typeahead-min-length=2 uib-typeahead=\"result as result.lib for result in vm.codePostalVilles($viewValue)\" typeahead-editable=false required></div><div ng-switch-when=off class=form-group ng-class=\"{ 'has-error' :\n" +
    "                     (vm.choixactiviteautresituationform.codePostalZoneActivite{{vm.index}}.$invalid && !vm.choixactiviteautresituationform.codePostalZoneActivite{{vm.index}}.$pristine)\n" +
    "                      }\"><input id=codePostalZoneActivite{{vm.index}} ng-model=vm.data.sitPros[vm.index].codePostalZoneActivite name=codePostalZoneActivite{{vm.index}} class=form-control ui-validate=\"{controleCodePostalFormat  : 'vm.controleCodePostalFormat($value)'}\" ng-trim=false required><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.codePostalZoneActivite{{vm.index}}.$error.controleCodePostalFormat>Code postal incorrect</p></div></div></div></div><div ng-if=\"vm.data.sitPros[vm.index].paysActivite && vm.data.sitPros[vm.index].paysActivite.libelleCaffr != 'FRANCE' && vm.data.sitPros[vm.index].paysActivite.libelleCaffr != 'PRINCIPAUTE DE MONACO'\"><div class=col-sm-6><label class=label-form-cnaf for=codePostalZoneActivite{{vm.index}}>Ville de l’établissement pénitentiaire</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "              (vm.choixactiviteautresituationform.codePostalZoneActivite{{vm.index}}.$invalid && !vm.choixactiviteautresituationform.codePostalZoneActivite{{vm.index}}.$pristine)\n" +
    "              || vm.choixactiviteautresituationform.codePostalZoneActivite{{vm.index}}.$error.type5\n" +
    "            }\"><input id=codePostalZoneActivite{{vm.index}} ng-model=vm.data.sitPros[vm.index].codePostalZoneActivite ng-model-options=\"{ updateOn: 'blur' }\" ui-validate=\"{type5  : 'vm.testType5($value,vm.choixactiviteautresituationform.codePostalZoneActivite{{vm.index}}, {{vm.index}})'}\" ng-trim=false name=codePostalZoneActivite{{vm.index}} class=form-control required ng-pattern=\"/^[a-zA-Z0-9à-ÿÀ-Ÿ -']*$/\"><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.codePostalZoneActivite{{vm.index}}.$error.pattern>La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.codePostalZoneActivite{{vm.index}}.$error.type5>{{vm.choixactiviteautresituationform.codePostalZoneActivite.invalidmsg}}</p></div></div></div></div><div class=row ng-if=\"vm.data.sitPros[vm.index].choixAutreSituation.id == 'activiteVolontariat'\"><fieldset><div class=col-sm-12><legend class=label-form-cnaf>Préciser la situation</legend></div><div class=row><div class=col-sm-12 class=\"form-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                vm.choixactiviteautresituationform.choixAutreSituationVolontariat{{vm.index}}.$invalid\n" +
    "                && !vm.choixactiviteautresituationform.choixAutreSituationVolontariat{{vm.index}}.$pristine}\"><div class=col-sm-6 ng-repeat=\"volontariat in vm.listeChoixAutreSituationVolontariat\"><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixAutreSituationVolontariat uib-btn-radio=volontariat for={{volontariat.id}}><input type=radio name=choixAutreSituationVolontariat{{vm.index}} aria-label={{volontariat.libelle}} class=sr-only id={{volontariat.id}} ng-model=vm.data.sitPros[vm.index].choixAutreSituationVolontariat required> <span aria-hidden=true>{{volontariat.libelle}}</span></label></div></div></div></fieldset><div class=col-sm-12 ng-if=\"vm.data.sitPros[vm.index].choixAutreSituationVolontariat.id\n" +
    "                    && vm.data.sitPros[vm.index].choixAutreSituationVolontariat.id != 'volontaireServiceCivique'\n" +
    "                    && vm.data.sitPros[vm.index].choixAutreSituationVolontariat.id != 'volontaireInternational'\"><div class=row><div class=col-sm-4><label ng-if=\"vm.index == 0\" class=\"label-form-cnaf control-label\" for=dateActivite{{vm.index}}>Depuis le</label><label ng-if=\"vm.index > 0\" class=\"label-form-cnaf control-label\" for=dateActivite{{vm.index}}>Date de début de situation</label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                        vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$invalid\n" +
    "                        && !vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$pristine\n" +
    "                        || vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.pattern}\"><div class=\"form-group input-group\" id=divDateActivite{{vm.index}}><input id=dateActivite{{vm.index}} name=dateActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateActivite}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActivite class=form-control ui-validate=\"{  controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                            controleSupDernJourMoisSuivDemAL  : 'vm.controleSupDernJourMoisSuivDemAL($value, vm.controle.dernjourodal, vm.index)',\n" +
    "                                            controleDateSitPro : 'vm.controlerDateSitPro($value, vm.index, vm.data.sitPros, vm.datePosterieure, vm.controle.datedebperiodeactal)'\n" +
    "                                    }\" ng-required=true inputname=vm.data.sitPros[vm.index].dateActivite pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActivite start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateActivite{{vm.index}}></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.pattern && vm.data.sitPros[vm.index].dateActivite.length == 10\">Format de date invalide</p><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.controleInfDateNaissance>Date saisie incorrecte</p><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.controleSupDernJourMoisSuivDemAL>La date saisie ne peut être postérieure à la date du {{vm.controle.dernjourodal | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.controleDateSitPro ng-init=vm.generationDatePosterieure(vm.index)>La date saisie doit être antérieure à {{vm.datePosterieure | date:'dd/MM/yyyy'}}</p></div></div><div class=col-sm-4 ng-if=\"vm.index > 0\" ng-init=vm.dateActivitePrecMoins1jour(vm.index,vm.data.sitPros[vm.index-1].dateActivite,vm.data.sitPros)><div ng-if=\"vm.data.sitPros[vm.index].dateFinActivite != undefined\"><label class=\"label-form-cnaf control-label\" for=dateFinActivite{{vm.index}}>Date de fin de situation</label><div class=\"form-group input-group\"><div class=\"form-group input-group\" id=divDateFinActivite{{vm.index}}><input id=dateFinActivite{{vm.index}} name=dateFinActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateFinActivite}} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateFinActivite ng-disabled=true class=form-control></div></div></div></div></div></div><div class=col-sm-12 ng-if=\"vm.data.sitPros[vm.index].choixAutreSituationVolontariat.id\n" +
    "                    && (vm.data.sitPros[vm.index].choixAutreSituationVolontariat.id == 'volontaireServiceCivique'\n" +
    "                    || vm.data.sitPros[vm.index].choixAutreSituationVolontariat.id == 'volontaireInternational')\"><div class=row><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateActivite{{vm.index}}>Date de début</label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                    vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$invalid\n" +
    "                    && !vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$pristine\n" +
    "                    || vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.pattern}\"><div class=\"form-group input-group\" id=divDateActivite{{vm.index}}><input id=dateActivite{{vm.index}} name=dateActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateActivite}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActivite class=form-control ng-required=true ui-validate=\"{  controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                        controleSupDernJourMoisSuivDemAL  : 'vm.controleSupDernJourMoisSuivDemAL($value, vm.controle.dernjourodal, vm.index)',\n" +
    "                                        controleDateSitPro : 'vm.controlerDateSitPro($value, vm.index, vm.data.sitPros, vm.datePosterieure, vm.controle.datedebperiodeactal)'\n" +
    "                                  }\" inputname=vm.data.sitPros[vm.index].dateActivite pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActivite start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateActivite{{vm.index}}></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.pattern && vm.data.sitPros[vm.index].dateActivite.length == 10\">Format de date invalide</p><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.controleInfDateNaissance>Date saisie incorrecte</p><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.controleSupDernJourMoisSuivDemAL>La date saisie ne peut être postérieure à la date du {{vm.controle.dernjourodal | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.dateActivite{{vm.index}}.$error.controleDateSitPro ng-init=vm.generationDatePosterieure(vm.index)>La date saisie doit être antérieure à {{vm.datePosterieure | date:'dd/MM/yyyy'}}</p></div></div><div class=col-sm-4 ng-if=\"vm.index == 0\"><label class=\"label-form-cnaf control-label\" for=dateFinActivite{{vm.index}}>Date de fin</label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                    vm.choixactiviteautresituationform.dateFinActivite{{vm.index}}.$invalid\n" +
    "                    && !vm.choixactiviteautresituationform.dateFinActivite{{vm.index}}.$pristine\n" +
    "                    || vm.choixactiviteautresituationform.dateFinActivite{{vm.index}}.$error.pattern}\"><div class=\"form-group input-group\" id=divDateFinActivite{{vm.index}}><input id=dateFinActivite{{vm.index}} name=dateFinActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateFinActivite}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateFinActivite class=form-control ng-required=true ui-validate=\"{\n" +
    "                                   controleDateSup  : 'vm.controleDateSup(vm.data.sitPros[vm.index].dateActivite, $value)'\n" +
    "                                    }\" pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateFinActivite start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateFinActivite{{vm.index}}></cnaf-date-picker></div><p class=help-block role=alert ng-show=vm.choixactiviteautresituationform.dateFinActivite{{vm.index}}.$error.controleDateSup>La date de fin doit être postérieure à la date de début</p><p class=help-block role=alert ng-show=\"vm.choixactiviteautresituationform.dateFinActivite{{vm.index}}.$error.pattern && vm.data.sitPros[vm.index].dateFinActivite.length == 10\">Format de date invalide</p></div></div><div class=col-sm-4 ng-if=\"vm.index > 0\" ng-init=vm.dateActivitePrecMoins1jour(vm.index,vm.data.sitPros[vm.index-1].dateActivite,vm.data.sitPros)><div ng-if=\"vm.data.sitPros[vm.index].dateFinActivite != undefined\"><label class=\"label-form-cnaf control-label\" for=dateFinActivite{{vm.index}}>Date de fin de situation</label><div class=\"form-group input-group\"><div class=\"form-group input-group\" id=divDateFinActivite{{vm.index}}><input id=dateFinActivite{{vm.index}} name=dateFinActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateFinActivite}} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateFinActivite ng-disabled=true class=form-control></div></div></div></div></div><div class=row ng-if=\"vm.data.sitPros[vm.index].choixAutreSituationVolontariat.id == 'volontaireInternational'\"><div class=col-sm-6><label class=label-form-cnaf for=paysActivite{{vm.index}}>Pays où se déroule le volontariat</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "               (vm.choixactiviteautresituationform.paysActivite{{vm.index}}.$invalid && !vm.choixactiviteautresituationform.paysActivite{{vm.index}}.$pristine)\n" +
    "                 }\"><input id=paysActivite{{vm.index}} ng-model=vm.data.sitPros[vm.index].paysActivite name=paysActivite{{vm.index}} class=form-control typeahead-min-length=2 uib-typeahead=\"pays as pays.libelleCaffr for pays in vm.getListePaysEmployeurProposes($viewValue) | filter:$viewValue | limitTo:8\" typeahead-editable=false typeahead-no-results=noPaysFound required><p class=help-block role=alert ng-show=noPaysFound>Pays non trouvé</p></div></div></div></div></div></div>")

$templateCache.put("components/cnaf-cct-sitpro/cnaf-cct-sitpro-choix-activite-chomage/cnaf-cct-sitpro-choix-activite-chomage.html","<div class=row ng-init=vm.init()><div class=col-sm-12><div class=row><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateActivite{{vm.index}}><span ng-if=\"!vm.index || vm.index == 0\">Depuis le</span> <span ng-if=\"vm.index > 0\">Date de début de situation</span></label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                            vm.choixactivitechomageform.dateActivite{{vm.index}}.$invalid\n" +
    "                            && !vm.choixactivitechomageform.dateActivite{{vm.index}}.$pristine\n" +
    "                            || vm.choixactivitechomageform.dateActivite{{vm.index}}.$error.pattern}\"><div class=\"form-group input-group\" id=divDateActivite><input id=dateActivite{{vm.index}} name=dateActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateActivite}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActivite class=form-control ui-validate=\"{  controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                            controleSupDernJourMoisSuivDemAL  : 'vm.controleSupDernJourMoisSuivDemAL($value, vm.controle.dernJourMoisSuivDemAL, vm.index)',\n" +
    "                                            controleDateSitPro : 'vm.controlerDateSitPro($value, vm.index, vm.data.sitPros, vm.datePosterieure, vm.controle.datedebperiodeactal)'\n" +
    "                                        }\" ng-required=true inputname=vm.data.sitPros[vm.index].dateActivite pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActivite start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateActivite{{vm.index}}></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"vm.choixactivitechomageform.dateActivite{{vm.index}}.$error.pattern && vm.data.sitPros[vm.index].dateActivite.length == 10\">Format de date invalide</p><p class=help-block role=alert ng-show=vm.choixactivitechomageform.dateActivite{{vm.index}}.$error.controleInfDateNaissance>Date saisie incorrecte</p><p class=help-block role=alert ng-show=\"vm.choixactivitechomageform.dateActivite{{vm.index}}.$error.controleSupDernJourMoisSuivDemAL \">La date saisie ne peut être postérieure à la date du {{vm.controle.dernJourMoisSuivDemAL | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=vm.choixactivitechomageform.dateActivite{{vm.index}}.$error.controleDateSitPro ng-init=vm.generationDatePosterieure(vm.index)>La date saisie doit être antérieure à {{vm.datePosterieure | date:'dd/MM/yyyy'}}</p></div></div><div class=col-sm-4 ng-if=\"vm.index > 0\" ng-init=vm.dateActivitePrecMoins1jour(vm.index,vm.data.sitPros[vm.index-1].dateActivite,vm.data.sitPros)><div ng-if=\"vm.data.sitPros[vm.index].dateFinActivite != undefined\"><label class=\"label-form-cnaf control-label\" for=dateFinActivite{{vm.index}}>Date de fin de situation</label><div class=\"form-group input-group\"><div class=\"form-group input-group\" id=divDateFinActivite><input id=dateFinActivite{{vm.index}} name=dateFinActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateFinActivite}} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateFinActivite ng-disabled=true class=form-control></div></div></div></div></div><div class=row><fieldset><div class=col-sm-12><legend class=\"label-form-cnaf control-label\" for=orgInscription ng-if=!vm.controle.conjoint>Vous êtes inscrit auprès de</legend><legend class=\"label-form-cnaf control-label\" for=orgInscription ng-if=vm.controle.conjoint>Votre conjoint est inscrit auprès de</legend></div><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                        vm.choixactivitechomageform.orgInscription{{vm.index}}.$invalid\n" +
    "                        && !vm.choixactivitechomageform.orgInscription{{vm.index}}.$pristine }\"><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].orgInscription uib-btn-radio=vm.listeOrgInscription[0] for=poleemploi><input type=radio name=orgInscription{{vm.index}} aria-label=vm.listeOrgInscription[0].libelle class=sr-only id=poleemploi ng-model=vm.data.sitPros[vm.index].orgInscription required> <span aria-hidden=true>{{vm.listeOrgInscription[0].libelle}}</span></label></div><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].orgInscription uib-btn-radio=vm.listeOrgInscription[1] for=autreorg><input type=radio name=orgInscription{{vm.index}} aria-label=vm.listeOrgInscription[1].libelle class=sr-only id=autreorg ng-model=vm.data.sitPros[vm.index].orgInscription required> <span aria-hidden=true>{{vm.listeOrgInscription[1].libelle}}</span></label></div></div></fieldset></div><div class=row ng-if=\"vm.data.sitPros[vm.index].orgInscription && vm.data.sitPros[vm.index].orgInscription.libelle == vm.listeOrgInscription[1].libelle\"><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=nomOrganisme{{vm.index}}>Nom de l'organisme</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                            (vm.choixactivitechomageform.nomOrganisme{{vm.index}}.$invalid && !vm.choixactivitechomageform.nomOrganisme{{vm.index}}.$pristine)\n" +
    "                                || vm.choixactivitechomageform.nomOrganisme{{vm.index}}.$error.type8\n" +
    "                                }\"><input id=nomOrganisme{{vm.index}} maxlength=25 ng-model=vm.data.sitPros[vm.index].nomOrganisme ng-change=\"vm.data.sitPros[vm.index].nomOrganisme = vm.data.sitPros[vm.index].nomOrganisme.toUpperCase()\" ng-pattern=\"/^[0-9a-zA-Zà-ÿÀ-Ÿ '-]*$/\" ng-blur=\"vm.testType8(vm.data.sitPros[vm.index].nomOrganisme,vm.choixactivitechomageform,'nomOrganisme{{vm.index}}')\" ng-trim=false name=nomOrganisme{{vm.index}} class=form-control required><p class=help-block role=alert ng-show=\"vm.choixactivitechomageform.nomOrganisme{{vm.index}}.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.choixactivitechomageform.nomOrganisme{{vm.index}}.$error.type8>{{vm.choixactivitechomageform.nomOrganisme.invalidmsg}}</p></div></div></div></div></div>")

$templateCache.put("components/cnaf-cct-sitpro/cnaf-cct-sitpro-choix-activite-conges-divers/cnaf-cct-sitpro-choix-activite-conges-divers.html","<div ng-init=vm.init()><div class=row><fieldset><div class=col-sm-12><legend class=label-form-cnaf>Préciser la situation</legend></div><div class=\"form-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                vm.choixactivitecongesdiversform.choixCongesDivers{{vm.index}}.$invalid\n" +
    "                && !vm.choixactivitecongesdiversform.choixCongesDivers{{vm.index}}.$pristine}\"><div class=col-sm-4 ng-if=\"vm.index == 0 || (vm.data.sitPros[vm.index-1] && !vm.data.sitPros[vm.index-1].choixActiviteComplementRetraite)\"><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixCongesDivers uib-btn-radio=vm.listeChoixCongesDivers[0] for=congemat><input type=radio name=choixCongesDivers{{vm.index}} aria-label=vm.listeChoixCongesDivers[0].libelle class=sr-only id=congemat ng-model=vm.data.sitPros[vm.index].choixCongesDivers required> <span aria-hidden=true>{{vm.listeChoixCongesDivers[0].libelle}}</span></label></div><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixCongesDivers uib-btn-radio=vm.listeChoixCongesDivers[1] for=congeconv><input type=radio name=choixCongesDivers{{vm.index}} aria-label=vm.listeChoixCongesDivers[1].libelle class=sr-only id=congeconv ng-model=vm.data.sitPros[vm.index].choixCongesDivers required> <span aria-hidden=true>{{vm.listeChoixCongesDivers[1].libelle}}</span></label></div><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixCongesDivers uib-btn-radio=vm.listeChoixCongesDivers[2] for=congeparent><input type=radio name=choixCongesDivers{{vm.index}} aria-label=vm.listeChoixCongesDivers[2].libelle class=sr-only id=congeparent ng-model=vm.data.sitPros[vm.index].choixCongesDivers required> <span aria-hidden=true>{{vm.listeChoixCongesDivers[2].libelle}}</span></label></div><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixCongesDivers uib-btn-radio=vm.listeChoixCongesDivers[3] for=congesssolde><input type=radio name=choixCongesDivers{{vm.index}} aria-label=vm.listeChoixCongesDivers[3].libelle class=sr-only id=congesssolde ng-model=vm.data.sitPros[vm.index].choixCongesDivers required> <span aria-hidden=true>{{vm.listeChoixCongesDivers[3].libelle}}</span></label></div><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixCongesDivers uib-btn-radio=vm.listeChoixCongesDivers[4] for=congesab><input type=radio name=choixCongesDivers{{vm.index}} aria-label=vm.listeChoixCongesDivers[4].libelle class=sr-only id=congesab ng-model=vm.data.sitPros[vm.index].choixCongesDivers required> <span aria-hidden=true>{{vm.listeChoixCongesDivers[4].libelle}}</span></label></div></div></fieldset></div><div class=row ng-if=vm.data.sitPros[vm.index].choixCongesDivers><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateActivite{{vm.index}}>Date de début du congé</label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                    vm.choixactivitecongesdiversform.dateActivite{{vm.index}}.$invalid\n" +
    "                    && !vm.choixactivitecongesdiversform.dateActivite{{vm.index}}.$pristine\n" +
    "                    || vm.choixactivitecongesdiversform.dateActivite{{vm.index}}.$error.pattern}\"><div class=\"form-group input-group\" id=divDateActivite><input id=dateActivite{{vm.index}} name=dateActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateActivite}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActivite class=form-control ui-validate=\"{  controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                        controleSupDernJourMoisSuivDemAL  : 'vm.controleSupDernJourMoisSuivDemAL($value, vm.controle.dernJourMoisSuivDemAL, vm.index)',\n" +
    "                                        controleDateSitPro : 'vm.controlerDateSitPro($value, vm.index, vm.data.sitPros, vm.datePosterieure, vm.controle.datedebperiodeactal)'\n" +
    "                                  }\" ng-required=true inputname=vm.data.sitPros[vm.index].dateActivite pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActivite start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateActivite{{vm.index}}></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"vm.choixactivitecongesdiversform.dateActivite{{vm.index}}.$error.pattern && vm.data.sitPros[vm.index].dateActivite.length == 10\">Format de date invalide</p><p class=help-block role=alert ng-show=vm.choixactivitecongesdiversform.dateActivite{{vm.index}}.$error.controleInfDateNaissance>Date saisie incorrecte</p><p class=help-block role=alert ng-show=vm.choixactivitecongesdiversform.dateActivite{{vm.index}}.$error.controleSupDernJourMoisSuivDemAL>La date saisie ne peut être postérieure à la date du {{vm.controle.dernJourMoisSuivDemAL | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=vm.choixactivitecongesdiversform.dateActivite{{vm.index}}.$error.controleDateSitPro ng-init=vm.generationDatePosterieure(vm.index)>La date saisie doit être antérieure à {{vm.datePosterieure | date:'dd/MM/yyyy'}}</p></div></div><div class=col-sm-4 ng-if=\"vm.index == 0\"><label class=\"label-form-cnaf control-label\" for=dateFinActivite{{vm.index}}>Date de fin du congé</label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                        vm.choixactivitecongesdiversform.dateFinActivite{{vm.index}}.$invalid\n" +
    "                        && !vm.choixactivitecongesdiversform.dateFinActivite{{vm.index}}.$pristine\n" +
    "                        || vm.choixactivitecongesdiversform.dateFinActivite{{vm.index}}.$error.pattern}\"><div class=\"form-group input-group\" id=divDateFinActivite><input id=dateFinActivite{{vm.index}} name=dateFinActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateFinActivite}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateFinActivite class=form-control ui-validate=\"{controleSupDateDeb  : 'vm.controleSupDateDeb($value, vm.data.sitPros[vm.index].dateActivite)'}\" ui-validate-watch=\"'vm.data.sitPros[vm.index].dateActivite'\" ng-required=true pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateFinActivite start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateFinActivite{{vm.index}}></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"vm.choixactivitecongesdiversform.dateFinActivite{{vm.index}}.$error.pattern && vm.data.sitPros[vm.index].dateFinActivite.length == 10\">Format de date invalide</p><p class=help-block role=alert ng-show=vm.choixactivitecongesdiversform.dateFinActivite{{vm.index}}.$error.controleSupDateDeb>La date de fin doit être postérieure à la date de début</p></div></div><div class=col-sm-4 ng-if=\"vm.index > 0\" ng-init=vm.dateActivitePrecMoins1jour(vm.index,vm.data.sitPros[vm.index-1].dateActivite,vm.data.sitPros)><div ng-if=\"vm.data.sitPros[vm.index].dateFinActivite != undefined\"><label class=\"label-form-cnaf control-label\" for=dateFinActivite{{vm.index}}>Date de fin de situation</label><div class=\"form-group input-group\"><div class=\"form-group input-group\" id=divDateFinActivite><input id=dateFinActivite{{vm.index}} name=dateFinActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateFinActivite}} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateFinActivite ng-disabled=true class=form-control></div></div></div></div></div><div ng-if=vm.data.sitPros[vm.index].choixCongesDivers><cnaf-cct-sitpro-cotis-employeur data=vm.data cotisemployeurform=vm.choixactivitecongesdiversform errorcotisemployeur=vm.errorcotisemployeur controle=vm.controle index=vm.index></cnaf-cct-sitpro-cotis-employeur></div></div>")

$templateCache.put("components/cnaf-cct-sitpro/cnaf-cct-sitpro-choix-activite-invalidite/cnaf-cct-sitpro-choix-activite-invalidite.html","<div class=row ng-init=vm.init()><div class=col-sm-12><fieldset><legend class=label-form-cnaf><span class=label-form-cnaf for=invalRente{{vm.index}} ng-if=!vm.controle.conjoint>Vous percevez</span> <span class=label-form-cnaf for=invalRente{{vm.index}} ng-if=vm.controle.conjoint>Votre conjoint perçoit </span><span class=texte-info-cnaf for=invalRente{{vm.index}}>&nbsp;(si perception des deux, sélectionner la plus ancienne)</span></legend><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' : vm.choixactiviteinvaliditeform.invalRente{{vm.index}}.$invalid && !vm.choixactiviteinvaliditeform.invalRente{{vm.index}}.$pristine }\"><div class=row><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].invalRente uib-btn-radio=\"'inval'\" for=inval{{vm.index}}><input type=radio name=invalRente{{vm.index}} aria-label=inval class=sr-only id=inval{{vm.index}} ng-model=vm.data.sitPros[vm.index].invalRente value=inval required> <span aria-hidden=true>Pension d'invalidité</span></label></div><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].invalRente uib-btn-radio=\"'rente'\" for=rente{{vm.index}}><input type=radio name=invalRente{{vm.index}} aria-label=rente class=sr-only id=rente{{vm.index}} ng-model=vm.data.sitPros[vm.index].invalRente value=rente required> <span aria-hidden=true>Rente accident du travail</span></label></div></div></div></fieldset></div><div class=col-sm-12><fieldset><legend class=label-form-cnaf for=cesseActProPens{{vm.index}} ng-if=!vm.controle.conjoint>Vous avez totalement cessé votre activité professionnelle</legend><legend class=label-form-cnaf for=cesseActProPens{{vm.index}} ng-if=vm.controle.conjoint>Votre conjoint a totalement cessé son activité professionnelle</legend><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' : vm.choixactiviteinvaliditeform.cesseActProPens{{vm.index}}.$invalid && !vm.choixactiviteinvaliditeform.cesseActProPens{{vm.index}}.$pristine }\"><div class=row><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].cesseActProPens uib-btn-radio=true for=cesseActProPensOui{{vm.index}}><input type=radio name=cesseActProPens{{vm.index}} aria-label=Oui class=sr-only id=cesseActProPensOui{{vm.index}} ng-model=vm.data.sitPros[vm.index].cesseActProPens value=oui required> <span aria-hidden=true>Oui</span></label></div><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].cesseActProPens uib-btn-radio=false for=cesseActProPensNon{{vm.index}}><input type=radio name=cesseActProPens{{vm.index}} aria-label=non class=sr-only id=cesseActProPensNon{{vm.index}} ng-model=vm.data.sitPros[vm.index].cesseActProPens value=non required> <span aria-hidden=true>Non</span></label></div></div></div></fieldset></div></div><div class=row ng-if=vm.data.sitPros[vm.index].cesseActProPens><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateActivite{{vm.index}}><span ng-if=\"!vm.index || vm.index == 0\">Depuis le</span> <span ng-if=\"vm.index > 0\">Date de début de situation</span></label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                     vm.choixactiviteinvaliditeform.dateActivite{{vm.index}}.$invalid\n" +
    "                     && !vm.choixactiviteinvaliditeform.dateActivite{{vm.index}}.$pristine\n" +
    "                     || vm.choixactiviteinvaliditeform.dateActivite{{vm.index}}.$error.pattern}\"><div class=\"form-group input-group\" id=divDateActivite><input id=dateActivite{{vm.index}} name=dateActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateActivite}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActivite class=form-control ui-validate=\"{  controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                    controleSupDernJourMoisSuivDemAL  : 'vm.controleSupDernJourMoisSuivDemAL($value, vm.controle.dernJourMoisSuivDemAL, vm.index)',\n" +
    "                                    controleDateSitPro : 'vm.controlerDateSitPro($value, vm.index, vm.data.sitPros, vm.datePosterieure, vm.controle.datedebperiodeactal)'\n" +
    "                             }\" ng-required=true inputname=vm.data.sitPros[vm.index].dateActivite pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActivite start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateActivite{{vm.index}}></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"vm.choixactiviteinvaliditeform.dateActivite{{vm.index}}.$error.pattern && vm.data.sitPros[vm.index].dateActivite.length == 10\">Format de date invalide</p><p class=help-block role=alert ng-show=vm.choixactiviteinvaliditeform.dateActivite{{vm.index}}.$error.controleInfDateNaissance>Date saisie incorrecte</p><p class=help-block role=alert ng-show=vm.choixactiviteinvaliditeform.dateActivite{{vm.index}}.$error.controleSupDernJourMoisSuivDemAL>La date saisie ne peut être postérieure à la date du {{vm.controle.dernJourMoisSuivDemAL | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=vm.choixactiviteinvaliditeform.dateActivite{{vm.index}}.$error.controleDateSitPro ng-init=vm.generationDatePosterieure(vm.index)>La date saisie doit être antérieure à {{vm.datePosterieure | date:'dd/MM/yyyy'}}</p></div></div><div class=row ng-if=\"vm.index > 0\" ng-init=vm.dateActivitePrecMoins1jour(vm.index,vm.data.sitPros[vm.index-1].dateActivite,vm.data.sitPros)><div ng-if=\"vm.data.sitPros[vm.index].dateFinActivite != undefined\"><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateFinActivite{{vm.index}}>Date de fin de situation</label><div class=\"form-group input-group\"><div class=\"form-group input-group\" id=divDateFinActivite><input id=dateFinActivite{{vm.index}} name=dateFinActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateFinActivite}} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateFinActivite ng-disabled=true class=form-control></div></div></div></div></div></div><div ng-if=vm.data.sitPros[vm.index].cesseActProPens><cnaf-cct-sitpro-cotis-employeur data=vm.data cotisemployeurform=vm.choixactiviteinvaliditeform errorcotisemployeur=vm.errorcotisemployeur controle=vm.controle index=vm.index></cnaf-cct-sitpro-cotis-employeur></div><div ng-if=\"vm.data.sitPros[vm.index].cesseActProPens===false\"><label class=label-form-cnaf>Préciser l'activité professionnelle exercée</label><div class=collapse uib-collapse=sitpro.blocSitproIterCollapsed><div class=row><div class=\"form-group btn-block\" data-toggle=buttons ng-class=\"{ 'has-error' :\n" +
    "                vm.choixactiviteinvaliditeform.choixActiviteComplementInvalidite{{vm.index}}.$invalid\n" +
    "                && !vm.choixactiviteinvaliditeform.choixActiviteComplementInvalidite{{vm.index}}.$pristine }\"><div class=col-md-6 ng-repeat=\"choixActi in vm.choixactivites3\"><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixActiviteComplementInvalidite uib-btn-radio=\"'{{choixActi.code}}'\" for=choixActiviteComplementInvalidite{{choixActi.code}}><input type=radio id=choixActiviteComplementInvalidite{{choixActi.code}} name=choixActiviteComplementInvalidite{{vm.index}} aria-label={{choixActi.libelle}} class=sr-only ng-model=vm.data.sitPros[vm.index].choixActiviteComplementInvalidite value={{choixActi.code}} ng-required=true> <span aria-hidden=true>{{choixActi.libelle}}</span></label></div></div></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteComplementInvalidite == 'SAL'\"><cnaf-cct-sitpro-choix-activite-salariee autocompletion=vm.autocompletion data=vm.data choixactivitesalarieeform=vm.choixactiviteinvaliditeform errorchoixactivitesalariee=vm.errorchoixactivitesalariee controle=vm.controle index=vm.index></cnaf-cct-sitpro-choix-activite-salariee></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteComplementInvalidite == 'RET'\"><cnaf-cct-sitpro-choix-activite-retraite autocompletion=vm.autocompletion data=vm.data choixactiviteretraiteform=vm.choixactiviteinvaliditeform errorchoixactiviteretraite=vm.errorchoixactiviteretraite controle=vm.controle index=vm.index></cnaf-cct-sitpro-choix-activite-retraite></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteComplementInvalidite == 'NSAL'\"><cnaf-cct-sitpro-choix-activite-non-salariee autocompletion=vm.autocompletion data=vm.data choixactivitenonsalarieeform=vm.choixactiviteinvaliditeform errorchoixactivitenonsalariee=vm.errorchoixactivitenonsalariee controle=vm.controle index=vm.index></cnaf-cct-sitpro-choix-activite-non-salariee></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteComplementInvalidite == 'CHO'\"><cnaf-cct-sitpro-chomage autocompletion=vm.autocompletion data=vm.data chomageform=vm.choixactiviteinvaliditeform errorchomage=vm.errorchoixactivitechomage controle=vm.controle index=vm.index></cnaf-cct-sitpro-chomage></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteComplementInvalidite == 'CONG'\"><cnaf-cct-sitpro-choix-activite-conges-divers autocompletion=vm.autocompletion data=vm.data choixactivitecongesdiversform=vm.choixactiviteinvaliditeform errorchoixactivitecongesdivers=vm.errorchoixactivitecongesdivers controle=vm.controle index=vm.index></cnaf-cct-sitpro-choix-activite-conges-divers></div></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteComplementInvalidite == 'ETU'\"><cnaf-cct-sitpro-etudiant data=vm.data sitproetudiantform=vm.choixactiviteinvaliditeform errorsitproetudiant=vm.errorsitproetudiant controle=vm.controle index=vm.index></cnaf-cct-sitpro-etudiant></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteComplementInvalidite == 'AUT'\"><cnaf-cct-sitpro-choix-activite-autre-situation autocompletion=vm.autocompletion data=vm.data choixactiviteautresituationform=vm.choixactiviteform errorchoixactiviteautresituation=vm.errorchoixactiviteautresituation controle=vm.controle index=vm.index></cnaf-cct-sitpro-choix-activite-autre-situation></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteComplementInvalidite == 'APP'\"><cnaf-cct-sitpro-choix-activite-stagiaire autocompletion=vm.autocompletion data=vm.data choixactivitestagiaireform=vm.choixactiviteform errorchoixactivitestagiaire=vm.errorchoixactivitestagiaire controle=vm.controle index=vm.index></cnaf-cct-sitpro-choix-activite-stagiaire></div></div>")

$templateCache.put("components/cnaf-cct-sitpro/cnaf-cct-sitpro-choix-activite-non-salariee/cnaf-cct-sitpro-choix-activite-non-salariee.html","<div ng-init=vm.init()><fieldset><div class=row><div class=col-sm-12><legend class=label-form-cnaf>Préciser la situation</legend></div><div class=\"form-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                vm.choixactivitenonsalarieeform.choixActiviteNonSalariee{{vm.index}}.$invalid\n" +
    "                && !vm.choixactivitenonsalarieeform.choixActiviteNonSalariee{{vm.index}}.$pristine}\"><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixActiviteNonSalariee uib-btn-radio=vm.listeActivitenonsalariee[0] for=travailindep><input type=radio name=choixActiviteNonSalariee{{vm.index}} aria-label=vm.listeActivitenonsalariee[0].libelle class=sr-only id=travailindep ng-model=vm.data.sitPros[vm.index].choixActiviteNonSalariee required> <span aria-hidden=true>{{vm.listeActivitenonsalariee[0].libelle}}</span></label></div><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixActiviteNonSalariee uib-btn-radio=vm.listeActivitenonsalariee[1] for=autoentrepren><input type=radio name=choixActiviteNonSalariee{{vm.index}} aria-label=vm.listeActivitenonsalariee[1].libelle class=sr-only id=autoentrepren ng-model=vm.data.sitPros[vm.index].choixActiviteNonSalariee required> <span aria-hidden=true>{{vm.listeActivitenonsalariee[1].libelle}}</span></label></div><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixActiviteNonSalariee uib-btn-radio=vm.listeActivitenonsalariee[2] for=gerantnonsal><input type=radio name=choixActiviteNonSalariee{{vm.index}} aria-label=vm.listeActivitenonsalariee[2].libelle class=sr-only id=gerantnonsal ng-model=vm.data.sitPros[vm.index].choixActiviteNonSalariee required> <span aria-hidden=true>{{vm.listeActivitenonsalariee[2].libelle}}</span></label></div><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixActiviteNonSalariee uib-btn-radio=vm.listeActivitenonsalariee[3] for=vendeurdom><input type=radio name=choixActiviteNonSalariee{{vm.index}} aria-label=vm.listeActivitenonsalariee[3].libelle class=sr-only id=vendeurdom ng-model=vm.data.sitPros[vm.index].choixActiviteNonSalariee required> <span aria-hidden=true>{{vm.listeActivitenonsalariee[3].libelle}}</span></label></div><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixActiviteNonSalariee uib-btn-radio=vm.listeActivitenonsalariee[4] for=vrp><input type=radio name=choixActiviteNonSalariee{{vm.index}} aria-label=vm.listeActivitenonsalariee[4].libelle class=sr-only id=vrp ng-model=vm.data.sitPros[vm.index].choixActiviteNonSalariee required> <span aria-hidden=true>{{vm.listeActivitenonsalariee[4].libelle}}</span></label></div><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixActiviteNonSalariee uib-btn-radio=vm.listeActivitenonsalariee[5] for=marinpecheur><input type=radio name=choixActiviteNonSalariee{{vm.index}} aria-label=vm.listeActivitenonsalariee[5].libelle class=sr-only id=marinpecheur ng-model=vm.data.sitPros[vm.index].choixActiviteNonSalariee required> <span aria-hidden=true>{{vm.listeActivitenonsalariee[5].libelle}}</span></label></div><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixActiviteNonSalariee uib-btn-radio=vm.listeActivitenonsalariee[6] for=exploitagric><input type=radio name=choixActiviteNonSalariee{{vm.index}} aria-label=vm.listeActivitenonsalariee[6].libelle class=sr-only id=exploitagric ng-model=vm.data.sitPros[vm.index].choixActiviteNonSalariee required> <span aria-hidden=true>{{vm.listeActivitenonsalariee[6].libelle}}</span></label></div><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixActiviteNonSalariee uib-btn-radio=vm.listeActivitenonsalariee[7] for=artisteauteur><input type=radio name=choixActiviteNonSalariee{{vm.index}} aria-label=vm.listeActivitenonsalariee[7].libelle class=sr-only id=artisteauteur ng-model=vm.data.sitPros[vm.index].choixActiviteNonSalariee required> <span aria-hidden=true>{{vm.listeActivitenonsalariee[7].libelle}}</span></label></div><div ng-if=vm.controle.encouple class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixActiviteNonSalariee uib-btn-radio=vm.listeActivitenonsalariee[8] for=conjointcollab><input type=radio name=choixActiviteNonSalariee{{vm.index}} aria-label=vm.listeActivitenonsalariee[8].libelle class=sr-only id=conjointcollab ng-model=vm.data.sitPros[vm.index].choixActiviteNonSalariee required> <span aria-hidden=true>{{vm.listeActivitenonsalariee[8].libelle}}</span></label></div><div class=col-sm-6 ng-if=\"vm.afficheMetropole(vm.index) === false\"><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixActiviteNonSalariee uib-btn-radio=vm.listeActivitenonsalariee[9] for=aidefamilialeagricole><input type=radio name=choixActiviteNonSalariee{{vm.index}} aria-label=vm.listeActivitenonsalariee[9].libelle class=sr-only id=aidefamilialeagricole ng-model=vm.data.sitPros[vm.index].choixActiviteNonSalariee required> <span aria-hidden=true>{{vm.listeActivitenonsalariee[9].libelle}}</span></label></div></div></div></fieldset></div><div class=row ng-if=vm.data.sitPros[vm.index].choixActiviteNonSalariee><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateActivite{{vm.index}}><span ng-if=\"!vm.index || vm.index == 0\">Depuis le</span> <span ng-if=\"vm.index > 0\">Date de début de situation</span></label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                        vm.choixactivitenonsalarieeform.dateActivite{{vm.index}}.$invalid\n" +
    "                        && !vm.choixactivitenonsalarieeform.dateActivite{{vm.index}}.$pristine\n" +
    "                        || vm.choixactivitenonsalarieeform.dateActivite{{vm.index}}.$error.pattern}\"><div class=\"form-group input-group\" id=divDateActivite><input id=dateActivite{{vm.index}} name=dateActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateActivite}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActivite class=form-control ui-validate=\"{controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                         controleSupDernJourMoisSuivDemAL  : 'vm.controleSupDernJourMoisSuivDemAL($value, vm.controle.dernJourMoisSuivDemAL, vm.index)',\n" +
    "                                         controleDateSitPro : 'vm.controlerDateSitPro($value, vm.index, vm.data.sitPros, vm.datePosterieure, vm.controle.datedebperiodeactal)'\n" +
    "                                }\" ng-required=true inputname=vm.data.sitPros[vm.index].dateActivite pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActivite start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateActivite{{vm.index}}></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"vm.choixactivitenonsalarieeform.dateActivite{{vm.index}}.$error.pattern && vm.data.sitPros[vm.index].dateActivite.length == 10\">Format de date invalide</p><p class=help-block role=alert ng-show=vm.choixactivitenonsalarieeform.dateActivite{{vm.index}}.$error.controleInfDateNaissance>Date saisie incorrecte</p><p class=help-block role=alert ng-show=vm.choixactivitenonsalarieeform.dateActivite{{vm.index}}.$error.controleSupDernJourMoisSuivDemAL>La date saisie ne peut être postérieure à la date du {{vm.controle.dernJourMoisSuivDemAL | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=vm.choixactivitenonsalarieeform.dateActivite{{vm.index}}.$error.controleDateSitPro ng-init=vm.generationDatePosterieure(vm.index)>La date saisie doit être antérieure à {{vm.datePosterieure | date:'dd/MM/yyyy'}}</p></div></div></div><div class=row ng-if=\"vm.index > 0\" ng-init=vm.dateActivitePrecMoins1jour(vm.index,vm.data.sitPros[vm.index-1].dateActivite,vm.data.sitPros)><div ng-if=\"vm.data.sitPros[vm.index].dateFinActivite != undefined\"><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateFinActivite{{vm.index}}>Date de fin de situation</label><div class=\"form-group input-group\"><div class=\"form-group input-group\" id=divDateFinActivite><input id=dateFinActivite{{vm.index}} name=dateFinActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateFinActivite}} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateFinActivite ng-disabled=true class=form-control></div></div></div></div></div><div ng-if=vm.data.sitPros[vm.index].choixActiviteNonSalariee><cnaf-cct-sitpro-cotis-employeur data=vm.data cotisemployeurform=vm.choixactivitenonsalarieeform errorcotisemployeur=vm.errorcotisemployeur controle=vm.controle index=vm.index></cnaf-cct-sitpro-cotis-employeur></div><div class=row ng-if=vm.afficheRegimeImposition(vm.index)><div class=col-sm-4><label class=label-form-cnaf>Le régime d'imposition choisi est</label></div><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                vm.choixactivitenonsalarieeform.regImpos{{vm.index}}.$invalid\n" +
    "                && !vm.choixactivitenonsalarieeform.regImpos{{vm.index}}.$pristine}\"><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].regImpos uib-btn-radio=vm.listeRegimeImposition[0] for=reel><input type=radio name=regImpos{{vm.index}} aria-label=vm.listeRegimeImposition[0].libelle class=sr-only id=reel ng-model=vm.data.sitPros[vm.index].regImpos required> <span aria-hidden=true>{{vm.listeRegimeImposition[0].libelle}}</span></label></div><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].regImpos uib-btn-radio=vm.listeRegimeImposition[1] for=forfaitaire><input type=radio name=regImpos{{vm.index}} aria-label=vm.listeRegimeImposition[1].libelle class=sr-only id=forfaitaire ng-model=vm.data.sitPros[vm.index].regImpos required> <span aria-hidden=true>{{vm.listeRegimeImposition[1].libelle}}</span></label></div></div></div>")

$templateCache.put("components/cnaf-cct-sitpro/cnaf-cct-sitpro-choix-activite-retraite/cnaf-cct-sitpro-choix-activite-retraite.html","<div class=row ng-init=vm.init()><fieldset><div class=col-sm-12><legend class=label-form-cnaf for=cesseActProRet{{vm.index}} ng-if=!vm.controle.conjoint>Vous avez totalement cessé votre activité professionnelle</legend><legend class=label-form-cnaf for=cesseActProRet{{vm.index}} ng-if=vm.controle.conjoint>Votre conjoint a totalement cessé son activité professionnelle</legend><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' : vm.choixactiviteretraiteform.cesseActProRet{{vm.index}}.$invalid && !vm.choixactiviteretraiteform.cesseActProRet{{vm.index}}.$pristine }\"><div class=row><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].cesseActProRet uib-btn-radio=true for=cesseActProRetOui{{vm.index}}><input type=radio name=cesseActProRet{{vm.index}} aria-label=Oui class=sr-only id=cesseActProRetOui{{vm.index}} ng-model=vm.data.sitPros[vm.index].cesseActProRet value=oui required> <span aria-hidden=true>Oui</span></label></div><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].cesseActProRet uib-btn-radio=false for=cesseActProRetNon{{vm.index}}><input type=radio name=cesseActProRet{{vm.index}} aria-label=non class=sr-only id=cesseActProRetNon{{vm.index}} ng-model=vm.data.sitPros[vm.index].cesseActProRet value=non required> <span aria-hidden=true>Non</span></label></div></div></div></div></fieldset></div><div class=row ng-if=vm.data.sitPros[vm.index].cesseActProRet><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateActivite{{vm.index}}><span ng-if=\"!vm.index || vm.index == 0\">Depuis le</span> <span ng-if=\"vm.index > 0\">Date de début de situation</span></label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                     vm.choixactiviteretraiteform.dateActivite{{vm.index}}.$invalid\n" +
    "                     && !vm.choixactiviteretraiteform.dateActivite{{vm.index}}.$pristine\n" +
    "                     || vm.choixactiviteretraiteform.dateActivite{{vm.index}}.$error.pattern}\"><div class=\"form-group input-group\" id=divDateActivite><input id=dateActivite{{vm.index}} name=dateActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateActivite}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActivite class=form-control ui-validate=\"{  controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                    controleSupDernJourMoisSuivDemAL  : 'vm.controleSupDernJourMoisSuivDemAL($value, vm.controle.dernJourMoisSuivDemAL, vm.index)',\n" +
    "                                    controleDateSitPro : 'vm.controlerDateSitPro($value, vm.index, vm.data.sitPros, vm.datePosterieure, vm.controle.datedebperiodeactal)'\n" +
    "                             }\" ng-required=true inputname=vm.data.sitPros[vm.index].dateActivite pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActivite start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateActivite{{vm.index}}></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"vm.choixactiviteretraiteform.dateActivite{{vm.index}}.$error.pattern && vm.data.sitPros[vm.index].dateActivite.length == 10\">Format de date invalide</p><p class=help-block role=alert ng-show=vm.choixactiviteretraiteform.dateActivite{{vm.index}}.$error.controleInfDateNaissance>Date saisie incorrecte</p><p class=help-block role=alert ng-show=vm.choixactiviteretraiteform.dateActivite{{vm.index}}.$error.controleSupDernJourMoisSuivDemAL>La date saisie ne peut être postérieure à la date du {{vm.controle.dernJourMoisSuivDemAL | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=vm.choixactiviteretraiteform.dateActivite{{vm.index}}.$error.controleDateSitPro ng-init=vm.generationDatePosterieure(vm.index)>La date saisie doit être antérieure à {{vm.datePosterieure | date:'dd/MM/yyyy'}}</p></div></div><div class=row ng-if=\"vm.index > 0\" ng-init=vm.dateActivitePrecMoins1jour(vm.index,vm.data.sitPros[vm.index-1].dateActivite,vm.data.sitPros)><div ng-if=\"vm.data.sitPros[vm.index].dateFinActivite != undefined\"><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateFinActivite{{vm.index}}>Date de fin de situation</label><div class=\"form-group input-group\"><div class=\"form-group input-group\" id=divDateFinActivite><input id=dateFinActivite{{vm.index}} name=dateFinActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateFinActivite}} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateFinActivite ng-disabled=true class=form-control></div></div></div></div></div></div><div ng-if=vm.data.sitPros[vm.index].cesseActProRet><cnaf-cct-sitpro-cotis-employeur data=vm.data cotisemployeurform=vm.choixactiviteretraiteform errorcotisemployeur=vm.errorcotisemployeur controle=vm.controle index=vm.index></cnaf-cct-sitpro-cotis-employeur></div><div ng-if=\"vm.data.sitPros[vm.index].cesseActProRet===false\"><label class=label-form-cnaf>Préciser l'activité professionnelle exercée</label><div class=collapse uib-collapse=sitpro.blocSitproIterCollapsed><div class=row><div class=\"form-group btn-block\" data-toggle=buttons ng-class=\"{ 'has-error' :\n" +
    "                vm.choixactiviteretraiteform.choixActiviteComplementRetraite{{vm.index}}.$invalid\n" +
    "                && !vm.choixactiviteretraiteform.choixActiviteComplementRetraite{{vm.index}}.$pristine }\"><div class=col-md-6 ng-repeat=\"choixActi in vm.choixactivites2\"><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixActiviteComplementRetraite uib-btn-radio=\"'{{choixActi.code}}'\" for=choixActiviteComplementRetraite{{choixActi.code}}><input type=radio id=choixActiviteComplementRetraite{{choixActi.code}} name=choixActiviteComplementRetraite{{vm.index}} aria-label={{choixActi.libelle}} class=sr-only ng-model=vm.data.sitPros[vm.index].choixActiviteComplementRetraite value={{choixActi.code}} ng-required=true> <span aria-hidden=true>{{choixActi.libelle}}</span></label></div></div></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteComplementRetraite == 'SAL'\"><cnaf-cct-sitpro-choix-activite-salariee autocompletion=vm.autocompletion data=vm.data choixactivitesalarieeform=vm.choixactiviteretraiteform errorchoixactivitesalariee=vm.errorchoixactivitesalariee controle=vm.controle index=vm.index></cnaf-cct-sitpro-choix-activite-salariee></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteComplementRetraite == 'NSAL'\"><cnaf-cct-sitpro-choix-activite-non-salariee autocompletion=vm.autocompletion data=vm.data choixactivitenonsalarieeform=vm.choixactiviteretraiteform errorchoixactivitenonsalariee=vm.errorchoixactivitenonsalariee controle=vm.controle index=vm.index></cnaf-cct-sitpro-choix-activite-non-salariee></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteComplementRetraite == 'PENS'\"><cnaf-cct-sitpro-choix-activite-invalidite autocompletion=vm.autocompletion data=vm.data choixactiviteinvaliditeform=vm.choixactiviteretraiteform errorchoixactiviteinvalidite=vm.errorchoixactiviteinvalidite controle=vm.controle index=vm.index></cnaf-cct-sitpro-choix-activite-invalidite></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteComplementRetraite == 'CHO'\"><cnaf-cct-sitpro-choix-activite-chomage autocompletion=vm.autocompletion data=vm.data choixactivitechomageform=vm.choixactiviteretraiteform errorchoixactivitechomage=vm.errorchoixactivitechomage controle=vm.controle index=vm.index></cnaf-cct-sitpro-choix-activite-chomage></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteComplementRetraite == 'CONG'\"><cnaf-cct-sitpro-choix-activite-conges-divers autocompletion=vm.autocompletion data=vm.data choixactivitecongesdiversform=vm.choixactiviteretraiteform errorchoixactivitecongesdivers=vm.errorchoixactivitecongesdivers controle=vm.controle index=vm.index></cnaf-cct-sitpro-choix-activite-conges-divers></div></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteComplementRetraite == 'ETU'\"><cnaf-cct-sitpro-etudiant data=vm.data sitproetudiantform=vm.choixactiviteretraiteform errorsitproetudiant=vm.errorsitproetudiant controle=vm.controle index=vm.index></cnaf-cct-sitpro-etudiant></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteComplementRetraite == 'AUT'\"><cnaf-cct-sitpro-choix-activite-autre-situation autocompletion=vm.autocompletion data=vm.data choixactiviteautresituationform=vm.choixactiviteform errorchoixactiviteautresituation=vm.errorchoixactiviteautresituation controle=vm.controle index=vm.index></cnaf-cct-sitpro-choix-activite-autre-situation></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteComplementRetraite == 'APP'\"><cnaf-cct-sitpro-choix-activite-stagiaire autocompletion=vm.autocompletion data=vm.data choixactivitestagiaireform=vm.choixactiviteform errorchoixactivitestagiaire=vm.errorchoixactivitestagiaire controle=vm.controle index=vm.index></cnaf-cct-sitpro-choix-activite-stagiaire></div></div>")

$templateCache.put("components/cnaf-cct-sitpro/cnaf-cct-sitpro-choix-activite-salariee/cnaf-cct-sitpro-choix-activite-salariee.html","<div class=row ng-init=vm.init()><fieldset><div class=col-sm-12><legend class=label-form-cnaf>Préciser la situation</legend></div><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                vm.choixactivitesalarieeform.choixActiviteSalariee{{vm.index}}.$invalid\n" +
    "                && !vm.choixactivitesalarieeform.choixActiviteSalariee{{vm.index}}.$pristine }\"><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixActiviteSalariee uib-btn-radio=vm.listeActivitesalariee[0] for=salarie><input type=radio name=choixActiviteSalariee{{vm.index}} aria-label=vm.listeActivitesalariee[0].libelle class=sr-only id=salarie ng-model=vm.data.sitPros[vm.index].choixActiviteSalariee required> <span aria-hidden=true>{{vm.listeActivitesalariee[0].libelle}}</span></label></div><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixActiviteSalariee uib-btn-radio=vm.listeActivitesalariee[1] for=assmat><input type=radio name=choixActiviteSalariee{{vm.index}} aria-label=vm.listeActivitesalariee[1].libelle class=sr-only id=assmat ng-model=vm.data.sitPros[vm.index].choixActiviteSalariee required> <span aria-hidden=true>{{vm.listeActivitesalariee[1].libelle}}</span></label></div><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixActiviteSalariee uib-btn-radio=vm.listeActivitesalariee[2] for=vrp><input type=radio name=choixActiviteSalariee{{vm.index}} aria-label=vm.listeActivitesalariee[2].libelle class=sr-only id=vrp ng-model=vm.data.sitPros[vm.index].choixActiviteSalariee required> <span aria-hidden=true>{{vm.listeActivitesalariee[2].libelle}}</span></label></div><div class=col-sm-4><span class=pull-right><cnaf-aide tabindex=0 data-toggle=popover data-id-content-cnaf=popover-tsa data-container=body data-trigger=manual></span><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixActiviteSalariee uib-btn-radio=vm.listeActivitesalariee[3] for=tsa><input type=radio name=choixActiviteSalariee{{vm.index}} aria-label=vm.listeActivitesalariee[3].libelle class=sr-only id=tsa ng-model=vm.data.sitPros[vm.index].choixActiviteSalariee required> <span aria-hidden=true>{{vm.listeActivitesalariee[3].libelle}}</span></label><div class=hidden id=popover-tsa>Le travail saisonnier se caractérise par l'exécution de tâches normalement appelées à se répéter chaque année, à des dates à peu près fixes, en fonction du rythme des saisons (récolte, cueillette) ou des modes de vie collectifs (tourisme).</div></div><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixActiviteSalariee uib-btn-radio=vm.listeActivitesalariee[4] for=int><input type=radio name=choixActiviteSalariee{{vm.index}} aria-label=vm.listeActivitesalariee[4].libelle class=sr-only id=int ng-model=vm.data.sitPros[vm.index].choixActiviteSalariee required> <span aria-hidden=true>{{vm.listeActivitesalariee[4].libelle}}</span></label></div><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixActiviteSalariee uib-btn-radio=vm.listeActivitesalariee[5] for=spec><input type=radio name=choixActiviteSalariee{{vm.index}} aria-label=vm.listeActivitesalariee[5].libelle class=sr-only id=spec ng-model=vm.data.sitPros[vm.index].choixActiviteSalariee required> <span aria-hidden=true>{{vm.listeActivitesalariee[5].libelle}}</span></label></div><div class=col-sm-4><span class=pull-right><cnaf-aide tabindex=0 data-toggle=popover data-id-content-cnaf=popover-vds data-container=body data-trigger=manual></span><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixActiviteSalariee uib-btn-radio=vm.listeActivitesalariee[6] for=vds><input type=radio name=choixActiviteSalariee{{vm.index}} aria-label=vm.listeActivitesalariee[6].libelle class=sr-only id=vds ng-model=vm.data.sitPros[vm.index].choixActiviteSalariee required> <span aria-hidden=true>{{vm.listeActivitesalariee[6].libelle}}</span></label><div class=hidden id=popover-vds>Se caractérise par la vente des produits ou de services au moyen du démarchage direct auprès de particuliers et être salarié d'une entreprise ou indépendant mais non inscrit au RCS ou RSAC et donc relever du régime général de la sécurité sociale.</div></div></div></fieldset></div><div class=row ng-if=vm.data.sitPros[vm.index].choixActiviteSalariee><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateActivite{{vm.index}}><span ng-if=\"!vm.index || vm.index == 0\">Depuis le</span> <span ng-if=\"vm.index > 0\">Date de début de situation</span></label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                     vm.choixactivitesalarieeform.dateActivite{{vm.index}}.$invalid\n" +
    "                     && !vm.choixactivitesalarieeform.dateActivite{{vm.index}}.$pristine\n" +
    "                     || vm.choixactivitesalarieeform.dateActivite{{vm.index}}.$error.pattern}\"><div class=\"form-group input-group\" id=divDateActivite><input id=dateActivite{{vm.index}} name=dateActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateActivite}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActivite class=form-control ui-validate=\"{  controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                        controleSupDernJourMoisSuivDemAL  : 'vm.controleSupDernJourMoisSuivDemAL($value, vm.controle.dernJourMoisSuivDemAL, vm.index)',\n" +
    "                                        controleDateSitPro : 'vm.controlerDateSitPro($value, vm.index, vm.data.sitPros, vm.datePosterieure, vm.controle.datedebperiodeactal)'\n" +
    "                             }\" ng-required=true inputname=vm.data.sitPros[vm.index].dateActivite pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActivite start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateActivite{{vm.index}}></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"vm.choixactivitesalarieeform.dateActivite{{vm.index}}.$error.pattern && vm.data.sitPros[vm.index].dateActivite.length == 10\">Format de date invalide</p><p class=help-block role=alert ng-show=vm.choixactivitesalarieeform.dateActivite{{vm.index}}.$error.controleInfDateNaissance>Date saisie incorrecte</p><p class=help-block role=alert ng-show=vm.choixactivitesalarieeform.dateActivite{{vm.index}}.$error.controleSupDernJourMoisSuivDemAL>La date saisie ne peut être postérieure à la date du {{vm.controle.dernJourMoisSuivDemAL | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=vm.choixactivitesalarieeform.dateActivite{{vm.index}}.$error.controleDateSitPro ng-init=vm.generationDatePosterieure(vm.index)>La date saisie doit être antérieure à {{vm.datePosterieure | date:'dd/MM/yyyy'}}</p></div></div><div class=row ng-if=\"vm.index > 0\" ng-init=vm.dateActivitePrecMoins1jour(vm.index,vm.data.sitPros[vm.index-1].dateActivite,vm.data.sitPros)><div ng-if=\"vm.data.sitPros[vm.index].dateFinActivite != undefined\" class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateFinActivite{{vm.index}}>Date de fin de situation</label><div class=\"form-group input-group\"><div class=\"form-group input-group\" id=divDateFinActivite><input id=dateFinActivite{{vm.index}} name=dateFinActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateFinActivite}} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateFinActivite ng-disabled=true class=form-control></div></div></div></div></div><div class=row ng-if=vm.afficheEmployeur(vm.index)><div class=col-sm-6><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteSalariee.libelle == 'Gérant salarié'\"><label class=label-form-cnaf for=nomEmployeur>Nom de l'entreprise</label></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteSalariee.libelle != 'Gérant salarié'\"><label class=label-form-cnaf for=nomEmployeur>Nom de l'employeur</label></div><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "               (vm.choixactivitesalarieeform.nomEmployeur{{vm.index}}.$invalid && !vm.choixactivitesalarieeform.nomEmployeur{{vm.index}}.$pristine)\n" +
    "                 || vm.choixactivitesalarieeform.nomEmployeur{{vm.index}}.$error.type8\n" +
    "                 }\"><input id=nomEmployeur maxlength=30 ng-model=vm.data.sitPros[vm.index].nomEmployeur ng-change=\"vm.data.sitPros[vm.index].nomEmployeur = vm.data.sitPros[vm.index].nomEmployeur.toUpperCase()\" ng-pattern=\"/^[0-9a-zA-Zà-ÿÀ-Ÿ '-]*$/\" ng-blur=\"vm.testType8(vm.data.sitPros[vm.index].nomEmployeur,vm.choixactivitesalarieeform,'nomEmployeur{{vm.index}}')\" ng-trim=false name=nomEmployeur{{vm.index}} class=form-control required><p class=help-block role=alert ng-show=\"vm.choixactivitesalarieeform.nomEmployeur{{vm.index}}.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.choixactivitesalarieeform.nomEmployeur{{vm.index}}.$error.type8>{{vm.choixactivitesalarieeform.nomEmployeur.invalidmsg}}</p></div></div><div class=col-sm-6><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteSalariee.libelle == 'Gérant salarié'\"><label class=label-form-cnaf for=paysEmployeur>Pays de l'entreprise</label></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteSalariee.libelle != 'Gérant salarié'\"><label class=label-form-cnaf for=paysEmployeur>Pays de l'employeur</label></div><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "               (vm.choixactivitesalarieeform.paysEmployeur{{vm.index}}.$invalid && !vm.choixactivitesalarieeform.paysEmployeur{{vm.index}}.$pristine)\n" +
    "                 }\"><input id=paysEmployeur ng-model=vm.data.sitPros[vm.index].paysEmployeur name=paysEmployeur{{vm.index}} class=form-control typeahead-min-length=2 uib-typeahead=\"pays as pays.libelleCaffr for pays in vm.getListePaysEmployeurProposes($viewValue) | filter:$viewValue | limitTo:8\" typeahead-editable=false typeahead-no-results=noPaysFound required><p class=help-block role=alert ng-show=noPaysFound>Pays non trouvé</p></div></div></div><div class=row ng-if=\"vm.afficheEmployeur(vm.index) && vm.afficheCodePostalVille(vm.index)\"><div class=col-sm-6><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteSalariee.libelle == 'Gérant salarié'\"><label class=label-form-cnaf for=codePostalVilleEmployeur>Code postal / Commune de l'entreprise</label></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteSalariee.libelle != 'Gérant salarié'\"><label class=label-form-cnaf for=codePostalVilleEmployeur>Code postal / Commune de l'employeur</label></div><div ng-switch on=vm.autocompletion><div ng-switch-when=on class=form-group ng-class=\"{ 'has-error' :\n" +
    "                        (vm.choixactivitesalarieeform.codePostalVilleEmployeur{{vm.index}}.$invalid && !vm.choixactivitesalarieeform.codePostalVilleEmployeur{{vm.index}}.$pristine)\n" +
    "                        }\"><input id=codePostalVilleEmployeur ng-model=vm.data.sitPros[vm.index].codePostalVilleEmployeur name=codePostalVilleEmployeur{{vm.index}} class=form-control typeahead-min-length=2 uib-typeahead=\"result as result.lib for result in vm.codePostalVilles($viewValue)\" typeahead-editable=false required></div><div ng-switch-when=off class=form-group ng-class=\"{ 'has-error' :\n" +
    "                     (vm.choixactivitesalarieeform.codePostalVilleEmployeur{{vm.index}}.$invalid && !vm.choixactivitesalarieeform.codePostalVilleEmployeur{{vm.index}}.$pristine)\n" +
    "                      }\"><input id=codePostalVilleEmployeur ng-model=vm.data.sitPros[vm.index].codePostalVilleEmployeur name=codePostalVilleEmployeur{{vm.index}} class=form-control ui-validate=\"{controleCodePostalFormat  : 'vm.controleCodePostalFormat($value)'}\" ng-trim=false required><p class=help-block role=alert ng-show=vm.choixactivitesalarieeform.codePostalVilleEmployeur{{vm.index}}.$error.controleCodePostalFormat>Code postal incorrect</p></div></div></div></div><div class=row ng-if=\"vm.afficheEmployeur(vm.index) && vm.data.sitPros[vm.index].paysEmployeur && vm.data.sitPros[vm.index].paysEmployeur.libelleCaffr != 'FRANCE' && vm.data.sitPros[vm.index].paysEmployeur.libelleCaffr != 'PRINCIPAUTE DE MONACO'\"><div class=col-sm-6><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteSalariee.libelle == 'Gérant salarié'\"><label class=label-form-cnaf for=villeEmployeur>Ville de l'entreprise</label></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteSalariee.libelle != 'Gérant salarié'\"><label class=label-form-cnaf for=villeEmployeur>Ville de l'employeur</label></div><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "              (vm.choixactivitesalarieeform.villeEmployeur{{vm.index}}.$invalid && !vm.choixactivitesalarieeform.villeEmployeur{{vm.index}}.$pristine)\n" +
    "              || vm.choixactivitesalarieeform.villeEmployeur{{vm.index}}.$error.type5\n" +
    "            }\"><input id=villeEmployeur ng-model=vm.data.sitPros[vm.index].villeEmployeur ng-model-options=\"{ updateOn: 'blur' }\" ui-validate=\"{type5  : 'vm.testType5($value,vm.choixactivitesalarieeform.villeEmployeur{{vm.index}}, {{vm.index}})'}\" ng-trim=false name=villeEmployeur{{vm.index}} class=form-control required ng-pattern=\"/^[a-zA-Z0-9à-ÿÀ-Ÿ -']*$/\"><p class=help-block role=alert ng-show=vm.choixactivitesalarieeform.villeEmployeur{{vm.index}}.$error.pattern>La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.choixactivitesalarieeform.villeEmployeur{{vm.index}}.$error.type5>{{vm.choixactivitesalarieeform.villeEmployeur.invalidmsg}}</p></div></div></div><div ng-if=vm.afficheRegimeCotisation(vm.index)><cnaf-cct-sitpro-cotis-employeur data=vm.data cotisemployeurform=vm.choixactivitesalarieeform errorcotisemployeur=vm.errorcotisemployeur controle=vm.controle index=vm.index></cnaf-cct-sitpro-cotis-employeur></div>")

$templateCache.put("components/cnaf-cct-sitpro/cnaf-cct-sitpro-choix-activite-stagiaire/cnaf-cct-sitpro-choix-activite-stagiaire.html","<div ng-init=vm.init()><div class=row><fieldset><div class=col-sm-12><legend class=label-form-cnaf>Préciser la situation</legend></div><div ng-class=\"{'btn-group-lg-cnaf' : vm.listeChoixStagiaire[2]}\" class=\"form-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                vm.choixactivitestagiaireform.choixStagiaire{{vm.index}}.$invalid\n" +
    "                && !vm.choixactivitestagiaireform.choixStagiaire{{vm.index}}.$pristine}\"><div class=col-sm-4 ng-repeat=\"acti in vm.listeChoixStagiaire\"><label ng-class=\"{'align-middle-cnaf' : acti.libelle.length < 38}\" class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixStagiaire uib-btn-radio=acti for=acti.libelle><input type=radio name=choixStagiaire{{vm.index}} aria-label=acti.libelle class=sr-only id=acti.libelle ng-model=vm.data.sitPros[vm.index].choixStagiaire required> <span aria-hidden=true>{{acti.libelle}}</span></label></div></div></fieldset></div><div class=row ng-if=vm.data.sitPros[vm.index].choixStagiaire><div class=col-sm-4><div ng-if=\"vm.index == 0 && vm.data.sitPros[vm.index].choixStagiaire.libelle == 'Stagiaire'\"><label class=label-form-cnaf for=dateActivite{{vm.index}}>Depuis le</label></div><div ng-if=\"vm.index > 0 && vm.data.sitPros[vm.index].choixStagiaire.libelle == 'Stagiaire'\"><label class=label-form-cnaf for=dateActivite{{vm.index}}>Date de début de situation</label></div><div ng-if=\"vm.data.sitPros[vm.index].choixStagiaire.libelle == 'Apprenti'\"><label class=label-form-cnaf for=dateActivite{{vm.index}}>Date de début d'apprentissage</label></div><div ng-if=\"vm.data.sitPros[vm.index].choixStagiaire.libelle == 'En contrat de professionnalisation - En alternance'\"><label class=label-form-cnaf for=dateActivite{{vm.index}}>Date de début de contrat</label></div><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                        vm.choixactivitestagiaireform.dateActivite{{vm.index}}.$invalid\n" +
    "                        && !vm.choixactivitestagiaireform.dateActivite{{vm.index}}.$pristine\n" +
    "                        || vm.choixactivitestagiaireform.dateActivite{{vm.index}}.$error.pattern}\"><div class=\"form-group input-group\" id=divDateActivite><input id=dateActivite{{vm.index}} name=dateActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateActivite}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActivite class=form-control ui-validate=\"{  controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                           controleSupDernJourMoisSuivDemAL  : 'vm.controleSupDernJourMoisSuivDemAL($value, vm.controle.dernJourMoisSuivDemAL, vm.index)',\n" +
    "                                           controleDateSitPro : 'vm.controlerDateSitPro($value, vm.index, vm.data.sitPros, vm.datePosterieure, vm.controle.datedebperiodeactal)'\n" +
    "                                }\" ng-required=true inputname=vm.data.sitPros[vm.index].dateActivite pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActivite start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateActivite{{vm.index}}></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"vm.choixactivitestagiaireform.dateActivite{{vm.index}}.$error.pattern && vm.data.sitPros[vm.index].dateActivite.length == 10\">Format de date invalide</p><p class=help-block role=alert ng-show=vm.choixactivitestagiaireform.dateActivite{{vm.index}}.$error.controleInfDateNaissance>Date saisie incorrecte</p><p class=help-block role=alert ng-show=vm.choixactivitestagiaireform.dateActivite{{vm.index}}.$error.controleSupDernJourMoisSuivDemAL>La date saisie ne peut être postérieure à la date du {{vm.controle.dernJourMoisSuivDemAL | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=vm.choixactivitestagiaireform.dateActivite{{vm.index}}.$error.controleDateSitPro ng-init=vm.generationDatePosterieure(vm.index)>La date saisie doit être antérieure à {{vm.datePosterieure | date:'dd/MM/yyyy'}}</p></div></div><div class=col-sm-4 ng-if=\"vm.index == 0 && (vm.data.sitPros[vm.index].choixStagiaire.libelle == 'Apprenti' ||vm.data.sitPros[vm.index].choixStagiaire.libelle == 'En contrat de professionnalisation - En alternance')\"><div ng-if=\"vm.data.sitPros[vm.index].choixStagiaire.libelle == 'Apprenti'\"><label class=label-form-cnaf for=dateFinActivite{{vm.index}}>Date de fin d'apprentissage</label></div><div ng-if=\"vm.data.sitPros[vm.index].choixStagiaire.libelle == 'En contrat de professionnalisation - En alternance'\"><label class=label-form-cnaf for=dateFinActivite{{vm.index}}>Date de fin de contrat</label></div><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                        vm.choixactivitestagiaireform.dateFinActivite{{vm.index}}.$invalid\n" +
    "                        && !vm.choixactivitestagiaireform.dateFinActivite{{vm.index}}.$pristine\n" +
    "                        || vm.choixactivitestagiaireform.dateFinActivite{{vm.index}}.$error.pattern}\"><div class=\"form-group input-group\" id=divDateFinActivite><input id=dateFinActivite{{vm.index}} name=dateFinActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateFinActivite}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateFinActivite class=form-control ui-validate=\"{controleSupDateDeb  : 'vm.controleSupDateDeb($value, vm.data.sitPros[vm.index].dateActivite)'}\" ui-validate-watch=\"'vm.data.sitPros[vm.index].dateActivite'\" ng-required=true pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateFinActivite start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateFinActivite{{vm.index}}></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"vm.choixactivitestagiaireform.dateFinActivite{{vm.index}}.$error.pattern && vm.data.sitPros[vm.index].dateFinActivite.length == 10\">Format de date invalide</p><p class=help-block role=alert ng-show=vm.choixactivitestagiaireform.dateFinActivite{{vm.index}}.$error.controleSupDateDeb>La date de fin doit être postérieure à la date de début</p></div></div><div class=col-sm-4 ng-if=\"vm.index > 0\" ng-init=vm.dateActivitePrecMoins1jour(vm.index,vm.data.sitPros[vm.index-1].dateActivite,vm.data.sitPros)><div ng-if=\"vm.data.sitPros[vm.index].dateFinActivite != undefined\"><div ng-if=\"vm.data.sitPros[vm.index].choixStagiaire.libelle == 'Stagiaire'\"><label class=\"label-form-cnaf control-label\" for=dateFinActivite>Date de fin de situation</label></div><div ng-if=\"vm.data.sitPros[vm.index].choixStagiaire.libelle == 'Apprenti'\"><label class=label-form-cnaf for=dateFinActivite{{vm.index}}>Date de fin d'apprentissage</label></div><div ng-if=\"vm.data.sitPros[vm.index].choixStagiaire.libelle == 'En contrat de professionnalisation - En alternance'\"><label class=label-form-cnaf for=dateFinActivite{{vm.index}}>Date de fin de contrat</label></div><div class=\"form-group input-group\"><div class=\"form-group input-group\" id=divDateFinActivite><input id=dateFinActivite{{vm.index}} name=dateFinActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateFinActivite}} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateFinActivite ng-disabled=true class=form-control></div></div></div></div></div><div ng-if=vm.data.sitPros[vm.index].choixStagiaire><div ng-if=\"vm.data.sitPros[vm.index].choixStagiaire.libelle == 'Stagiaire'\"><div class=row><fieldset><div class=col-sm-12><legend class=label-form-cnaf for=indemnise>Le stage est indemnisé</legend></div><div class=col-sm-4><div class=row><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' : vm.choixactivitestagiaireform.indemnise{{vm.index}}.$invalid\n" +
    "                                              && !vm.choixactivitestagiaireform.indemnise{{vm.index}}.$pristine }\"><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].indemnise uib-btn-radio=true for=indemniseOui{{vm.index}}><input type=radio name=indemnise{{vm.index}} aria-label=Oui class=sr-only id=indemniseOui{{vm.index}} ng-model=vm.data.sitPros[vm.index].indemnise value=oui required> <span aria-hidden=true>Oui</span></label></div><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].indemnise uib-btn-radio=false for=indemniseNon{{vm.index}}><input type=radio name=indemnise{{vm.index}} aria-label=Non class=sr-only id=indemniseNon{{vm.index}} ng-model=vm.data.sitPros[vm.index].indemnise value=non required> <span aria-hidden=true>Non</span></label></div></div></div></div></fieldset></div><div class=row ng-if=vm.data.sitPros[vm.index].indemnise><fieldset><div class=col-sm-12><legend class=label-form-cnaf for=regimeIndemnisation>Indemnisé par</legend></div><div class=\"form-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                        vm.choixactivitestagiaireform.regimeIndemnisation{{vm.index}}.$invalid\n" +
    "                        && !vm.choixactivitestagiaireform.regimeIndemnisation{{vm.index}}.$pristine}\"><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].regimeIndemnisation uib-btn-radio=vm.listeRegimeIndemnisation[0] for=pole><input type=radio name=regimeIndemnisation{{vm.index}} aria-label=vm.listeRegimeIndemnisation[0].libelle class=sr-only id=pole ng-model=vm.data.sitPros[vm.index].regimeIndemnisation required> <span aria-hidden=true>{{vm.listeRegimeIndemnisation[0].libelle}}</span></label></div><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].regimeIndemnisation uib-btn-radio=vm.listeRegimeIndemnisation[1] for=fonction><input type=radio name=regimeIndemnisation{{vm.index}} aria-label=vm.listeRegimeIndemnisation[1].libelle class=sr-only id=fonction ng-model=vm.data.sitPros[vm.index].regimeIndemnisation required> <span aria-hidden=true>{{vm.listeRegimeIndemnisation[1].libelle}}</span></label></div><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].regimeIndemnisation uib-btn-radio=vm.listeRegimeIndemnisation[2] for=employeur><input type=radio name=regimeIndemnisation{{vm.index}} aria-label=vm.listeRegimeIndemnisation[2].libelle class=sr-only id=employeur ng-model=vm.data.sitPros[vm.index].regimeIndemnisation required> <span aria-hidden=true>{{vm.listeRegimeIndemnisation[2].libelle}}</span></label></div></div></fieldset></div></div></div><div ng-if=vm.data.sitPros[vm.index].choixStagiaire><div ng-if=\"vm.data.sitPros[vm.index].choixStagiaire.libelle == 'Apprenti' || vm.data.sitPros[vm.index].choixStagiaire.libelle == 'En contrat de professionnalisation - En alternance'\"><cnaf-cct-sitpro-cotis-employeur data=vm.data cotisemployeurform=vm.choixactivitestagiaireform errorcotisemployeur=vm.errorcotisemployeur controle=vm.controle index=vm.index></cnaf-cct-sitpro-cotis-employeur></div></div></div>")

$templateCache.put("components/cnaf-cct-sitpro/cnaf-cct-sitpro-cotis-employeur/cnaf-cct-sitpro-cotis-employeur.html","<div class=row ng-init=vm.init()><fieldset><div class=col-sm-4 ng-if=vm.gerantSalarie(vm.index)><div ng-if=vm.controle.conjoint><legend class=label-form-cnaf for=cotisEmployeur{{$index}}{{vm.index}}>Votre conjoint cotise à</legend></div><div ng-if=!vm.controle.conjoint><legend class=label-form-cnaf for=cotisEmployeur{{$index}}{{vm.index}}>Vous cotisez à</legend></div></div><div class=col-sm-12 ng-if=\"vm.gerantSalarie(vm.index) == false\"><div ng-if=\"vm.activiteCONG(vm.index) == false\n" +
    "                     && vm.activiteNSAL(vm.index) == false\n" +
    "                     && vm.cesseActProRETouPENS(vm.index) == false\"><legend class=label-form-cnaf for=cotisEmployeur>L'employeur cotise à</legend></div><div ng-if=vm.cesseActProRETouPENS(vm.index)><legend class=label-form-cnaf for=cotisEmployeur>L'organisme qui verse la pension/rente la plus élevée est</legend></div><div ng-if=vm.activiteCONG(vm.index)><div ng-if=\"vm.data.sitPros[vm.index].choixCongesDivers.libelle == 'Congé maternité'\"><legend class=label-form-cnaf for=cotisEmployeur>L'organisme qui verse les indemnités est</legend></div><div ng-if=\"vm.data.sitPros[vm.index].choixCongesDivers.libelle == 'Congé conventionnel'\"><legend class=label-form-cnaf for=cotisEmployeur>L’employeur cotise à</legend></div><div ng-if=\"vm.data.sitPros[vm.index].choixCongesDivers.libelle !== 'Congé maternité'\n" +
    "                    && vm.data.sitPros[vm.index].choixCongesDivers.libelle !== 'Congé conventionnel'\"><legend class=label-form-cnaf ng-if=!vm.controle.conjoint>Votre assurance maladie est</legend><legend class=label-form-cnaf ng-if=vm.controle.conjoint>L’assurance maladie de votre conjoint est</legend></div></div><div ng-if=vm.activiteNSAL(vm.index)><legend class=label-form-cnaf for=cotisEmployeur>Le régime de cotisation est</legend></div></div><div ng-if=\"vm.activiteCONG(vm.index) == false\n" +
    "                 && vm.activiteNSAL(vm.index) == false\"><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                    vm.cotisemployeurform.cotisEmployeur{{vm.index}}.$invalid\n" +
    "                    && !vm.cotisemployeurform.cotisEmployeur{{vm.index}}.$pristine\n" +
    "                    || (vm.data.sitPros[vm.index].cotisEmployeur == undefined && vm.controle.submitted)}\"><div class=col-md-3 ng-repeat=\"choixCotis in vm.listeRegimeCotisation\"><div ng-if=\"choixCotis.libelle == 'Régime général' &&\n" +
    "                                  vm.cesseActProRETouPENS(vm.index)\"><span class=pull-right><cnaf-aide tabindex=0 data-toggle=popover data-id-content-cnaf=popover-tsa data-container=body data-trigger=manual></span></div><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].cotisEmployeur uib-btn-radio={{choixCotis}} for=cotisEmployeur{{$index}}{{vm.index}}><input type=radio id=cotisEmployeur{{$index}}{{vm.index}} name=cotisEmployeur{{vm.index}} aria-label={{choixCotis.libelle}} class=sr-only ng-model=vm.data.sitPros[vm.index].cotisEmployeur value={{choixCotis}} ng-required=true> <span aria-hidden=true>{{choixCotis.libelle}}</span></label><div ng-if=\"choixCotis.libelle == 'Régime général' &&\n" +
    "                                vm.cesseActProRETouPENS(vm.index)\"><div class=hidden id=popover-tsa>Carsat (ex Cram), Caisse des dépôts, Régime social des indépendants, Cnro, Sncf</div></div></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.sitPros[vm.index].cotisEmployeur == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div><div ng-if=\"vm.activiteNSAL(vm.index) == true\"><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                vm.cotisemployeurform.cotisEmployeur{{vm.index}}.$invalid\n" +
    "                && !vm.cotisemployeurform.cotisEmployeur{{vm.index}}.$pristine\n" +
    "                || (vm.data.sitPros[vm.index].cotisEmployeur == undefined && vm.controle.submitted)}\"><div ng-if=\"vm.afficheMetropole(vm.index) === false\"><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].cotisEmployeur uib-btn-radio=vm.listeRegimeCotisation[4] for=cgss><input type=radio name=cotisEmployeur{{vm.index}} aria-label=vm.listeRegimeCotisation[4] class=sr-only id=cgss ng-model=vm.data.sitPros[vm.index].cotisEmployeur required> <span aria-hidden=true>{{vm.listeRegimeCotisation[4].libelle}}</span></label></div></div><div ng-if=vm.afficheMetropole(vm.index)><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].cotisEmployeur uib-btn-radio=vm.listeRegimeCotisation[0] for=ursaff><input type=radio name=cotisEmployeur{{vm.index}} aria-label=vm.listeRegimeCotisation[0] class=sr-only id=ursaff ng-model=vm.data.sitPros[vm.index].cotisEmployeur required> <span aria-hidden=true>{{vm.listeRegimeCotisation[0].libelle}}</span></label></div></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteNonSalariee.libelle !== 'Artiste auteur'\n" +
    "                         && vm.afficheMetropole(vm.index)\"><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].cotisEmployeur uib-btn-radio=vm.listeRegimeCotisation[1] for=msa><input type=radio name=cotisEmployeur{{vm.index}} aria-label=vm.listeRegimeCotisation[1] class=sr-only id=msa ng-model=vm.data.sitPros[vm.index].cotisEmployeur required> <span aria-hidden=true>{{vm.listeRegimeCotisation[1].libelle}}</span></label></div></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteNonSalariee.libelle === 'Artiste auteur'\"><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].cotisEmployeur uib-btn-radio=vm.listeRegimeCotisation[3] for=agessa><input type=radio name=cotisEmployeur{{vm.index}} aria-label=vm.listeRegimeCotisation[3] class=sr-only id=agessa ng-model=vm.data.sitPros[vm.index].cotisEmployeur required> <span aria-hidden=true>{{vm.listeRegimeCotisation[3].libelle}}</span></label></div></div><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].cotisEmployeur uib-btn-radio=vm.listeRegimeCotisation[2] for=autre><input type=radio name=cotisEmployeur{{vm.index}} aria-label=vm.listeRegimeCotisation[2] class=sr-only id=autre ng-model=vm.data.sitPros[vm.index].cotisEmployeur required> <span aria-hidden=true>{{vm.listeRegimeCotisation[2].libelle}}</span></label></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.sitPros[vm.index].cotisEmployeur == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div><div ng-if=\"vm.activiteCONG(vm.index) == true\"><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                vm.cotisemployeurform.cotisEmployeur{{vm.index}}.$invalid\n" +
    "                && !vm.cotisemployeurform.cotisEmployeur{{vm.index}}.$pristine\n" +
    "                || (vm.data.sitPros[vm.index].cotisEmployeur == undefined && vm.controle.submitted)}\"><div ng-if=vm.afficheMetropole(vm.index)><div ng-if=\"vm.data.sitPros[vm.index].choixCongesDivers.libelle === 'Congé maternité'\n" +
    "                        || vm.data.sitPros[vm.index].choixCongesDivers.libelle === 'Congé conventionnel'\"><div class=col-sm-4><span class=pull-right><cnaf-aide tabindex=0 data-toggle=popover data-id-content-cnaf=popover-tsa data-container=body data-trigger=manual></span><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].cotisEmployeur uib-btn-radio=vm.listeRegimeCotisation[0] for=regimeGeneral><input type=radio name=cotisEmployeur{{vm.index}} aria-label=vm.listeRegimeCotisation[0] class=sr-only id=regimeGeneral ng-model=vm.data.sitPros[vm.index].cotisEmployeur required> <span aria-hidden=true>{{vm.listeRegimeCotisation[0].libelle}}</span></label><div class=hidden id=popover-tsa>Carsat (ex Cram), Caisse des dépôts, Régime social des indépendants, Cnro, Sncf</div></div></div><div ng-if=\"vm.data.sitPros[vm.index].choixCongesDivers.libelle !== 'Congé maternité'\n" +
    "                        && vm.data.sitPros[vm.index].choixCongesDivers.libelle !== 'Congé conventionnel'\"><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].cotisEmployeur uib-btn-radio=vm.listeRegimeCotisation[3] for=cpam><input type=radio name=cotisEmployeur{{vm.index}} aria-label=vm.listeRegimeCotisation[3] class=sr-only id=cpam ng-model=vm.data.sitPros[vm.index].cotisEmployeur required> <span aria-hidden=true>{{vm.listeRegimeCotisation[3].libelle}}</span></label></div></div></div><div ng-if=vm.afficheMetropole(vm.index)><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].cotisEmployeur uib-btn-radio=vm.listeRegimeCotisation[1] for=msa><input type=radio name=cotisEmployeur{{vm.index}} aria-label=vm.listeRegimeCotisation[1] class=sr-only id=msa ng-model=vm.data.sitPros[vm.index].cotisEmployeur required> <span aria-hidden=true>{{vm.listeRegimeCotisation[1].libelle}}</span></label></div></div><div ng-if=\"vm.afficheMetropole(vm.index) === false\"><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].cotisEmployeur uib-btn-radio=vm.listeRegimeCotisation[0] for=cgss><input type=radio name=cotisEmployeur{{vm.index}} aria-label=vm.listeRegimeCotisation[0] class=sr-only id=cgss ng-model=vm.data.sitPros[vm.index].cotisEmployeur required> <span aria-hidden=true>{{vm.listeRegimeCotisation[0].libelle}}</span></label></div></div><div ng-if=vm.afficheMetropole(vm.index)><div ng-if=\"vm.data.sitPros[vm.index].choixCongesDivers.libelle === 'Congé maternité'\n" +
    "                        || vm.data.sitPros[vm.index].choixCongesDivers.libelle === 'Congé conventionnel'\"><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].cotisEmployeur uib-btn-radio=vm.listeRegimeCotisation[2] for=msa><input type=radio name=cotisEmployeur{{vm.index}} aria-label=vm.listeRegimeCotisation[2] class=sr-only id=msa ng-model=vm.data.sitPros[vm.index].cotisEmployeur required> <span aria-hidden=true>{{vm.listeRegimeCotisation[2].libelle}}</span></label></div></div><div ng-if=\"vm.data.sitPros[vm.index].choixCongesDivers.libelle !== 'Congé maternité'\n" +
    "                        && vm.data.sitPros[vm.index].choixCongesDivers.libelle !== 'Congé conventionnel'\"><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].cotisEmployeur uib-btn-radio=vm.listeRegimeCotisation[4] for=cpam><input type=radio name=cotisEmployeur{{vm.index}} aria-label=vm.listeRegimeCotisation[4] class=sr-only id=cpam ng-model=vm.data.sitPros[vm.index].cotisEmployeur required> <span aria-hidden=true>{{vm.listeRegimeCotisation[4].libelle}}</span></label></div></div></div><div ng-if=\"vm.afficheMetropole(vm.index) === false\"><div ng-if=\"vm.data.sitPros[vm.index].choixCongesDivers.libelle === 'Congé maternité'\n" +
    "                        || vm.data.sitPros[vm.index].choixCongesDivers.libelle === 'Congé conventionnel'\"><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].cotisEmployeur uib-btn-radio=vm.listeRegimeCotisation[1] for=cgss><input type=radio name=cotisEmployeur{{vm.index}} aria-label=vm.listeRegimeCotisation[1] class=sr-only id=cgss ng-model=vm.data.sitPros[vm.index].cotisEmployeur required> <span aria-hidden=true>{{vm.listeRegimeCotisation[1].libelle}}</span></label></div></div><div ng-if=\"vm.data.sitPros[vm.index].choixCongesDivers.libelle !== 'Congé maternité'\n" +
    "                        && vm.data.sitPros[vm.index].choixCongesDivers.libelle !== 'Congé conventionnel'\"><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].cotisEmployeur uib-btn-radio=vm.listeRegimeCotisation[2] for=autreregime><input type=radio name=cotisEmployeur{{vm.index}} aria-label=vm.listeRegimeCotisation[2] class=sr-only id=autreregime ng-model=vm.data.sitPros[vm.index].cotisEmployeur required> <span aria-hidden=true>{{vm.listeRegimeCotisation[2].libelle}}</span></label></div></div></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.sitPros[vm.index].cotisEmployeur == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div><div ng-if=vm.afficheNomOrganisme(vm.index)><div ng-if=\"(vm.activiteSAL(vm.index) == false\n" +
    "                     || (vm.activiteSAL(vm.index) == true\n" +
    "                         && vm.data.sitPros[vm.index].choixActiviteSalariee.libelle != 'Salarié'))\"><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=nomOrganisme{{vm.index}}>Nom de l'organisme</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                (vm.cotisemployeurform.nomOrganisme{{vm.index}}.$invalid && !vm.cotisemployeurform.nomOrganisme{{vm.index}}.$pristine)\n" +
    "                    || (vm.data.sitPros[vm.index].nomOrganisme == undefined && vm.controle.submitted)\n" +
    "                    }\"><input id=nomOrganisme{{vm.index}} maxlength=25 ng-model=vm.data.sitPros[vm.index].nomOrganisme ng-change=\"vm.data.sitPros[vm.index].nomOrganisme = vm.data.sitPros[vm.index].nomOrganisme.toUpperCase()\" ng-pattern=\"/^[0-9a-zA-Zà-ÿÀ-Ÿ '-]*$/\" ng-blur=\"vm.testType8(vm.data.sitPros[vm.index].nomOrganisme,vm.cotisemployeurform,'nomOrganisme')\" ng-trim=false name=nomOrganisme{{vm.index}} class=form-control required><p class=help-block role=alert ng-show=\"vm.cotisemployeurform.nomOrganisme{{vm.index}}.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=\"(vm.data.sitPros[vm.index].nomOrganisme == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div><div ng-if=\"vm.activiteSAL(vm.index) == true\n" +
    "                      && vm.data.sitPros[vm.index].choixActiviteSalariee.libelle == 'Salarié'\"><div class=col-sm-12><fieldset><legend class=label-form-cnaf for=choixAutRegSal ng-if=!vm.controle.conjoint>Vous êtes</legend><legend class=label-form-cnaf for=choixAutRegSal ng-if=vm.controle.conjoint>Votre conjoint est</legend><div class=row><div class=\"form-group btn-block\" data-toggle=buttons ng-class=\"{ 'has-error' :\n" +
    "                        vm.cotisemployeurform.choixAutRegSal{{vm.index}}.$invalid\n" +
    "                        && !vm.cotisemployeurform.choixAutRegSal{{vm.index}}.$pristine\n" +
    "                        || (vm.data.sitPros[vm.index].choixAutRegSal == undefined && vm.controle.submitted)}\"><div class=col-md-6 ng-repeat=\"itAutRegSal in vm.listeChoixAutRegSal\"><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixAutRegSal uib-btn-radio={{itAutRegSal}} for=choixAutRegSal{{$index}}{{vm.index}}><input type=radio id=choixAutRegSal{{$index}}{{vm.index}} name=choixAutRegSal{{vm.index}} aria-label={{itAutRegSal.libelle}} class=sr-only ng-model=vm.data.sitPros[vm.index].choixAutRegSal value={{itAutRegSal}} ng-required=true> <span aria-hidden=true>{{itAutRegSal.libelle}}</span></label></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.sitPros[vm.index].choixAutRegSal == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></fieldset></div><div ng-if=\"vm.data.sitPros[vm.index].choixAutRegSal.libelle == 'Fonctionnaire'\"><div class=col-sm-6 ng-if=vm.controle.encouple><fieldset><legend class=label-form-cnaf for=choixPosteFonct ng-if=!vm.controle.conjoint>Vous êtes en poste</legend><legend class=label-form-cnaf for=choixPosteFonct ng-if=vm.controle.conjoint>Votre conjoint est en poste</legend><div class=row><div class=\"form-group btn-block\" data-toggle=buttons ng-class=\"{ 'has-error' :\n" +
    "                            vm.cotisemployeurform.choixPosteFonct{{vm.index}}.$invalid\n" +
    "                            && !vm.cotisemployeurform.choixPosteFonct{{vm.index}}.$pristine\n" +
    "                            || (vm.data.sitPros[vm.index].choixPosteFonct == undefined && vm.controle.submitted)}\"><div class=col-md-6 ng-repeat=\"itChoixPosteFonct in vm.listeChoixPosteFonct\"><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixPosteFonct uib-btn-radio={{itChoixPosteFonct}} for=choixPosteFonct{{$index}}{{vm.index}}><input type=radio id=choixPosteFonct{{$index}}{{vm.index}} name=choixPosteFonct{{vm.index}} aria-label={{itChoixPosteFonct.libelle}} class=sr-only ng-model=vm.data.sitPros[vm.index].choixPosteFonct value={{itChoixPosteFonct}} ng-required=true> <span aria-hidden=true>{{itChoixPosteFonct.libelle}}</span></label></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.sitPros[vm.index].choixPosteFonct == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></fieldset></div></div><div ng-if=\"vm.data.sitPros[vm.index].choixAutRegSal.libelle == 'Autre'\"><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=nomOrganisme{{vm.index}}>Nom de l'organisme</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                    (vm.cotisemployeurform.nomOrganisme{{vm.index}}.$invalid && !vm.cotisemployeurform.nomOrganisme{{vm.index}}.$pristine)\n" +
    "                        || (vm.data.sitPros[vm.index].nomOrganisme == undefined && vm.controle.submitted)\n" +
    "                        }\"><input id=nomOrganisme{{vm.index}} maxlength=25 ng-model=vm.data.sitPros[vm.index].nomOrganisme ng-change=\"vm.data.sitPros[vm.index].nomOrganisme = vm.data.sitPros[vm.index].nomOrganisme.toUpperCase()\" ng-pattern=\"/^[0-9a-zA-Zà-ÿÀ-Ÿ '-]*$/\" ng-blur=\"vm.testType8(vm.data.sitPros[vm.index].nomOrganisme,vm.cotisemployeurform,'nomOrganisme')\" ng-trim=false name=nomOrganisme{{vm.index}} class=form-control required><p class=help-block role=alert ng-show=\"vm.cotisemployeurform.nomOrganisme{{vm.index}}.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=\"(vm.data.sitPros[vm.index].nomOrganisme == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></div></div><div ng-if=vm.affichePaysCotisation(vm.index)><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=paysCotisation{{vm.index}}>Pays de cotisation</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "               (vm.cotisemployeurform.paysCotisation{{vm.index}}.$invalid && !vm.cotisemployeurform.paysCotisation{{vm.index}}.$pristine)\n" +
    "                 || (vm.data.sitPros[vm.index].paysCotisation == undefined && vm.controle.submitted)\n" +
    "                 }\"><input id=paysCotisation{{vm.index}} ng-model=vm.data.sitPros[vm.index].paysCotisation name=paysCotisation{{vm.index}} class=form-control typeahead-min-length=2 uib-typeahead=\"pays as pays.libelleCaffr for pays in vm.getListePaysCotisationProposes($viewValue) | filter:$viewValue | limitTo:8\" typeahead-editable=false typeahead-no-results=noPaysFound required><p class=help-block role=alert ng-show=noPaysFound>Pays non trouvé</p><p class=help-block role=alert ng-show=\"(vm.data.sitPros[vm.index].paysCotisation == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div><div class=col-sm-4 ng-if=vm.afficheDetache(vm.index)><fieldset><div ng-if=vm.controle.conjoint><legend class=label-form-cnaf for=detacheFrance>Votre conjoint est détaché(e) en France</legend></div><div ng-if=!vm.controle.conjoint><legend class=\"label-form-cnaf control-label\" for=detacheFrance>Vous êtes détaché(e) en France</legend></div><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' : vm.cotisemployeurform.detacheFrance{{vm.index}}.$invalid && !vm.cotisemployeurform.detacheFrance{{vm.index}}.$pristine\n" +
    "                         || (vm.data.sitPros[vm.index].detacheFrance == undefined && vm.controle.submitted)\n" +
    "                         }\"><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].detacheFrance uib-btn-radio=\"'Oui'\" for=detacheFranceOui{{vm.index}}><input type=radio name=detacheFrance{{vm.index}} aria-label=Oui class=sr-only id=detacheFranceOui{{vm.index}} ng-model=vm.data.sitPros[vm.index].detacheFrance value=oui required> <span aria-hidden=true>Oui</span></label></div><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].detacheFrance uib-btn-radio=\"'Non'\" for=detacheFranceNon{{vm.index}}><input type=radio name=detacheFrance{{vm.index}} aria-label=non class=sr-only id=detacheFranceNon{{vm.index}} ng-model=vm.data.sitPros[vm.index].detacheFrance value=non required> <span aria-hidden=true>Non</span></label></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.sitPros[vm.index].detacheFrance == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></fieldset></div></div></fieldset></div>")

$templateCache.put("components/cnaf-cct-sitpro/cnaf-cct-sitpro-etudiant/cnaf-cct-sitpro-etudiant.html","<div class=row ng-init=vm.init()><fieldset><div class=col-sm-12><legend class=label-form-cnaf for=sitproetu ng-if=!vm.controle.conjoint>Vous êtes</legend><legend class=label-form-cnaf for=sitproetu ng-if=vm.controle.conjoint>Votre conjoint est</legend><div class=\"cct-bloc-boutons form-group btn-group btn-block btn-group-lg-cnaf\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                            vm.sitproetudiantform.sitproetu{{vm.index}}.$invalid\n" +
    "                            && !vm.sitproetudiantform.sitproetu{{vm.index}}.$pristine\n" +
    "                             || (vm.data.sitPros[vm.index].sitproetu == undefined && vm.controle.submitted)}\"><div class=row><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].sitproetu uib-btn-radio=\"'etu'\" for=sitproetuEtu{{vm.index}}><input type=radio name=sitproetu{{vm.index}} aria-label=etu class=sr-only id=sitproetuEtu{{vm.index}} ng-model=vm.data.sitPros[vm.index].sitproetu value=etu required> <span aria-hidden=true>Etudiant</span></label></div><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].sitproetu uib-btn-radio=\"'ets'\" for=sitproetuEts{{vm.index}}><input type=radio name=sitproetu{{vm.index}} aria-label=ets class=sr-only id=sitproetuEts{{vm.index}} ng-model=vm.data.sitPros[vm.index].sitproetu value=ets required> <span aria-hidden=true>Etudiant et activité salariée</span></label></div><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].sitproetu uib-btn-radio=\"'etudiantActNonSal'\" for=sitproetuEtnonsal{{vm.index}}><input type=radio name=sitproetu{{vm.index}} aria-label=etudiantActNonSal class=sr-only id=sitproetuEtnonsal{{vm.index}} ng-model=vm.data.sitPros[vm.index].sitproetu value=etudiantActNonSal required> <span aria-hidden=true>Etudiant et activité non salariée</span></label></div></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.sitPros[vm.index].sitproetu == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></fieldset><div ng-if=\"vm.index > 0 && vm.data.sitPros[vm.index].sitproetu\"><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateActivite{{vm.index}}><span ng-if=\"vm.index > 0\">Date de début de situation</span></label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                        (vm.sitproetudiantform.dateActivite{{vm.index}}.$invalid\n" +
    "                        && !vm.sitproetudiantform.dateActivite{{vm.index}}.$pristine)\n" +
    "                        || vm.sitproetudiantform.dateActivite{{vm.index}}.$error.pattern\n" +
    "                        || (vm.data.sitPros[vm.index].dateActivite == undefined && vm.controle.submitted) }\"><div class=\"form-group input-group\" id=divDateActivite{{vm.index}}><input id=dateActivite{{vm.index}} name=dateActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateActivite}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActivite class=form-control ui-validate=\"{controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                         controleSupDateOd  : 'vm.controleSupDateOd($value, vm.controle.dernjourodal, vm.index)',\n" +
    "                                         controleDateSitPro : 'vm.controlerDateSitPro($value, vm.index, vm.data.sitPros, vm.datePosterieure, vm.controle.datedebperiodeactal)'\n" +
    "                                }\" ng-required=true inputname=vm.data.sitPros[vm.index].dateActivite pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActivite start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateActivite{{vm.index}}></cnaf-date-picker></div><p class=help-block role=alert ng-show=\"vm.sitproetudiantform.dateActivite{{vm.index}}.$error.pattern && vm.data.sitPros[vm.index].dateActivite.length == 10\">Format de date invalide</p><p class=help-block role=alert ng-show=vm.sitproetudiantform.dateActivite{{vm.index}}.$error.controleInfDateNaissance>Date saisie incorrecte</p><p class=help-block role=alert ng-show=vm.sitproetudiantform.dateActivite{{vm.index}}.$error.controleSupDateOd>La date saisie ne peut être postérieure à la date du {{vm.controle.dernjourodal | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=vm.sitproetudiantform.dateActivite{{vm.index}}.$error.controleDateSitPro ng-init=vm.generationDatePosterieure(vm.index)>La date saisie doit être antérieure à {{vm.datePosterieure | date:'dd/MM/yyyy'}}</p><p class=help-block role=alert ng-show=\"((vm.data.sitPros[vm.index].dateActivite == undefined || vm.data.sitPros[vm.index].dateActivite == 'jj/mm/aaaa') && vm.controle.submitted)\">Champ obligatoire</p></div></div><div class=row ng-if=\"vm.index > 0\" ng-init=\"vm.dateActivitePrecMoins1jour(vm.index,vm.data.sitPros[vm.index-1].dateActivite, vm.data.sitPros)\"><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateFinActivite{{vm.index}}>Date de fin de situation</label><div class=\"form-group input-group\"><div class=\"form-group input-group\" id=divDateFinActivite{{vm.index}}><input id=dateFinActivite{{vm.index}} name=dateFinActivite{{vm.index}} value={{vm.data.sitPros[vm.index].dateFinActivite}} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateFinActivite ng-disabled=true class=form-control></div></div></div></div></div><div class=col-sm-12 ng-if=\"vm.data.sitPros[vm.index].sitproetu === 'ets'\"><label class=\"label-form-cnaf control-label\" for=dtDebContrat{{vm.index}}>Date de début de contrat</label><div id=divdtDebContrat class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                    vm.sitproetudiantform.dtDebContrat{{vm.index}}.$invalid\n" +
    "                    && !vm.sitproetudiantform.dtDebContrat{{vm.index}}.$pristine\n" +
    "                    || vm.sitproetudiantform.dtDebContrat{{vm.index}}.$error.pattern\n" +
    "                    || (vm.data.sitPros[vm.index].dtDebContrat == undefined && vm.controle.submitted)}\"><div class=\"form-group input-group\"><input id=dtDebContrat{{vm.index}} name=dtDebContrat{{vm.index}} value={{vm.data.dtDebContrat}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dtDebContrat class=form-control ng-required=true pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dtDebContrat start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dtDebContrat{{vm.index}}></cnaf-date-picker></div><p class=help-block role=alert ng-show=vm.sitproetudiantform.dtDebContrat{{vm.index}}.$error.pattern>Format de date invalide</p><p class=help-block role=alert ng-show=\"((vm.data.sitPros[vm.index].dtDebContrat == undefined || vm.data.sitPros[vm.index].dtDebContrat == 'jj/mm/aaaa') && vm.controle.submitted)\">Champ obligatoire</p></div><div ng-if=\"vm.parseDate(vm.data.sitPros[vm.index].dtDebContrat) < vm.controle.deuxSeptembreAnneeOD\"><fieldset><legend class=label-form-cnaf for=couvreanneesco>Le contrat de travail couvre la période du 01/09/{{vm.controle.anneeperiodeDu}} au 31/08/{{vm.controle.anneeperiodeAu}}</legend><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                            vm.sitproetudiantform.couvreanneesco{{vm.index}}.$invalid\n" +
    "                            && !vm.sitproetudiantform.couvreanneesco{{vm.index}}.$pristine\n" +
    "                             || (vm.data.sitPros[vm.index].couvreanneesco == undefined && vm.controle.submitted)}\"><div class=row><div class=col-sm-2><label class=\"btn btn-default btn-block align-middle-cnaf\" ng-model=vm.data.sitPros[vm.index].couvreanneesco uib-btn-radio=\"'Oui'\" for=couvreanneescoOui{{vm.index}}><input type=radio name=couvreanneesco{{vm.index}} aria-label=couvreanneescoo class=sr-only id=couvreanneescoOui{{vm.index}} ng-model=vm.data.sitPros[vm.index].couvreanneesco required> <span aria-hidden=true>Oui</span></label></div><div class=col-sm-2><label class=\"btn btn-default btn-block align-middle-cnaf\" ng-model=vm.data.sitPros[vm.index].couvreanneesco uib-btn-radio=\"'Non'\" for=couvreanneescoNon{{vm.index}}><input type=radio name=couvreanneesco{{vm.index}} aria-label=couvreanneescon class=sr-only id=couvreanneescoNon{{vm.index}} ng-model=vm.data.sitPros[vm.index].couvreanneesco required> <span aria-hidden=true>Non</span></label></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.sitPros[vm.index].couvreanneesco == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></fieldset><div ng-if=\"vm.data.sitPros[vm.index].couvreanneesco === 'Oui'\"><fieldset><legend class=label-form-cnaf for=typeheurescontrat>Le nombre d'heures inscrit au contrat est</legend><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                            vm.sitproetudiantform.typeheurescontrat{{vm.index}}.$invalid\n" +
    "                            && !vm.sitproetudiantform.typeheurescontrat{{vm.index}}.$pristine\n" +
    "                            || (vm.data.sitPros[vm.index].typeheurescontrat == undefined && vm.controle.submitted)}\"><div class=row><div class=col-sm-3><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].typeheurescontrat uib-btn-radio=\"'hebdo'\" for=hebdo{{vm.index}}><input type=radio name=typeheurescontrat{{vm.index}} aria-label=hebdo class=sr-only id=hebdo{{vm.index}} ng-model=vm.data.sitPros[vm.index].typeheurescontrat required> <span aria-hidden=true>Hebdomadaire</span></label></div><div class=col-sm-3><label class=\"btn btn-default btn-block align-middle-cnaf\" ng-model=vm.data.sitPros[vm.index].typeheurescontrat uib-btn-radio=\"'mensuel'\" for=mensuel{{vm.index}}><input type=radio name=typeheurescontrat{{vm.index}} aria-label=mensuel class=sr-only id=mensuel{{vm.index}} ng-model=vm.data.sitPros[vm.index].typeheurescontrat required> <span aria-hidden=true>Mensuel</span></label></div><div class=col-sm-3><label class=\"btn btn-default btn-block align-middle-cnaf\" ng-model=vm.data.sitPros[vm.index].typeheurescontrat uib-btn-radio=\"'trimestriel'\" for=trimestriel{{vm.index}}><input type=radio name=typeheurescontrat{{vm.index}} aria-label=trimestriel class=sr-only id=trimestriel{{vm.index}} ng-model=vm.data.sitPros[vm.index].typeheurescontrat required> <span aria-hidden=true>Trimestriel</span></label></div><div class=col-sm-3><label class=\"btn btn-default btn-block align-middle-cnaf\" ng-model=vm.data.sitPros[vm.index].typeheurescontrat uib-btn-radio=\"'nonprecise'\" for=nonprecise{{vm.index}}><input type=radio name=typeheurescontrat{{vm.index}} aria-label=nonprecise class=sr-only id=nonprecise{{vm.index}} ng-model=vm.data.sitPros[vm.index].typeheurescontrat required> <span aria-hidden=true>Non précisé</span></label></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.sitPros[vm.index].typeheurescontrat == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></fieldset><div ng-if=\"vm.data.sitPros[vm.index].typeheurescontrat && vm.data.sitPros[vm.index].typeheurescontrat != 'nonprecise'\"><label class=label-form-cnaf>Nombre d'heures</label><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                                    vm.sitproetudiantform.nbheures{{vm.index}}.$invalid\n" +
    "                                    && !vm.sitproetudiantform.nbheures{{vm.index}}.$pristine\n" +
    "                                    || vm.sitproetudiantform.nbheures{{vm.index}}.$error.controleNbreHeures\n" +
    "                                    || (vm.data.sitPros[vm.index].nbheures == undefined && vm.controle.submitted)}\"><div class=row><div class=col-sm-2><label class=form-group for=nbheures{{vm.index}}><input id=nbheures{{vm.index}} ng-model=vm.data.sitPros[vm.index].nbheures name=nbheures{{vm.index}} class=form-control typeahead-min-length=1 pattern=^[0-9]{1,4}$ ui-validate-watch=\"'vm.data.sitPros[vm.index].typeheurescontrat'\" ui-validate=\"{controleNbreHeures : 'vm.controleNbreHeures($value, vm.data.sitPros[vm.index].typeheurescontrat)'}\" required></label></div></div><p class=help-block role=alert ng-show=vm.sitproetudiantform.nbheures{{vm.index}}.$error.pattern>Format invalide</p><p class=help-block role=alert ng-show=\"vm.data.sitPros[vm.index].typeheurescontrat === 'hebdo' && vm.sitproetudiantform.nbheures{{vm.index}}.$error.controleNbreHeures\">Le nombre d'heures ne peut pas excéder 39 heures</p><p class=help-block role=alert ng-show=\"vm.data.sitPros[vm.index].typeheurescontrat === 'mensuel' && vm.sitproetudiantform.nbheures{{vm.index}}.$error.controleNbreHeures\">Le nombre d'heures ne peut pas excéder 169 heures</p><p class=help-block role=alert ng-show=\"vm.data.sitPros[vm.index].typeheurescontrat === 'trimestriel' && vm.sitproetudiantform.nbheures{{vm.index}}.$error.controleNbreHeures\">Le nombre d'heures ne peut pas excéder 507 heures</p><p class=help-block role=alert ng-show=\"(vm.data.sitPros[vm.index].nbheures == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></div></div><div class=col-sm-12 ng-if=\"vm.data.sitPros[vm.index].sitproetu === 'etudiantActNonSal'\"><label class=\"label-form-cnaf control-label\" for=dateActNonSal{{vm.index}}>Date de début de l'activité non salariée</label><div id=divDateActNonSal class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                    vm.sitproetudiantform.dateActNonSal{{vm.index}}.$invalid\n" +
    "                    && !vm.sitproetudiantform.dateActNonSal{{vm.index}}.$pristine\n" +
    "                    || vm.sitproetudiantform.dateActNonSal{{vm.index}}.$error.pattern\n" +
    "                    || (vm.data.sitPros[vm.index].dateActNonSal == undefined && vm.controle.submitted)}\"><div class=\"form-group input-group\"><input id=dateActNonSal{{vm.index}} name=dateActNonSal{{vm.index}} value={{vm.data.dateActNonSal}} title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActNonSal class=form-control ng-required=true pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActNonSal start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=dateActNonSal{{vm.index}}></cnaf-date-picker></div><p class=help-block role=alert ng-show=vm.sitproetudiantform.dateActNonSal{{vm.index}}.$error.pattern>Format de date invalide</p><p class=help-block role=alert ng-show=\"((vm.data.sitPros[vm.index].dateActNonSal == undefined || vm.data.sitPros[vm.index].dateActNonSal == 'jj/mm/aaaa') && vm.controle.submitted)\">Champ obligatoire</p></div></div><div class=col-sm-12 ng-if=\"vm.afficheBoursier(vm.index) \"><div ng-if=!vm.controle.agesup29><fieldset class=row><div class=col-sm-12><legend class=label-form-cnaf for=orgasecu ng-if=!vm.controle.conjoint>Vous êtes étudiant boursier<cnaf-aide styleclass=pull-right id=test data-id-content-cnaf=popover-ebo data-container=body data-trigger=manual tabindex=0></legend><legend class=label-form-cnaf for=orgasecu ng-if=vm.controle.conjoint>Votre conjoint est étudiant boursier<cnaf-aide styleclass=pull-right data-id-content-cnaf=popover-ebo data-container=body data-trigger=manual tabindex=0></legend></div><div class=col-sm-4><div class=row><div class=\"form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' : vm.sitproetudiantform.boursier{{vm.index}}.$invalid\n" +
    "                                            && !vm.sitproetudiantform.boursier{{vm.index}}.$pristine\n" +
    "                                            || (vm.data.sitPros[vm.index].boursier == undefined && vm.controle.submitted)}\"><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].boursier uib-btn-radio=\"'Oui'\" for=boursierOui{{vm.index}}><input type=radio name=boursier{{vm.index}} aria-label=Oui class=sr-only id=boursierOui{{vm.index}} ng-model=vm.data.sitPros[vm.index].boursier value=oui required> <span aria-hidden=true>Oui</span></label></div><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].boursier uib-btn-radio=\"'Non'\" for=boursierNon{{vm.index}}><input type=radio name=boursier{{vm.index}} aria-label=non class=sr-only id=boursierNon{{vm.index}} ng-model=vm.data.sitPros[vm.index].boursier value=non required> <span aria-hidden=true>Non</span></label></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.sitPros[vm.index].boursier == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></div><div class=col-sm-12><cnaf-cct-situationpro-texte-ebo ng-if=\"vm.data.sitPros[vm.index].boursier === 'Oui'\"></cnaf-cct-situationpro-texte-ebo></div><div id=popover-ebo class=hidden>Vous êtes considéré étudiant boursier si vous percevez une bourse sur critères sociaux. Les bourses attribuées dans le cadre de recherche, de stage (CNRS, CNE...) ou d'échanges européens (Erasmus, Socrates...) ou bourses d'excellence ne permettent pas le statut d'étudiant boursier.</div></fieldset></div><div class=col-sm-12 ng-if=vm.afficheRegimeAffil(vm.index)><fieldset class=row><legend class=label-form-cnaf for=orgasecu ng-if=!vm.controle.conjoint>Vous êtes</legend><legend class=label-form-cnaf for=orgasecu ng-if=vm.controle.conjoint>Votre conjoint est</legend><div class=row><div class=\"form-group btn-group-lg-cnaf btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                                    vm.sitproetudiantform.orgasecu{{vm.index}}.$invalid && !vm.sitproetudiantform.orgasecu{{vm.index}}.$pristine\n" +
    "                                    || (vm.data.sitPros[vm.index].orgasecu == undefined && vm.controle.submitted)}\"><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].orgasecu uib-btn-radio=\"'ssetu'\" for=orgasecuSsetrangerSsetu{{vm.index}}><input type=radio name=orgasecu{{vm.index}} aria-label=ssetu class=sr-only id=orgasecuSsetrangerSsetu{{vm.index}} ng-model=vm.data.sitPros[vm.index].orgasecu required> <span aria-hidden=true>Affilié à la Sécurité sociale étudiante (LMDE, SMEBA, SME...)</span></label></div><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-class=\"{'align-middle-cnaf' : vm.isXs}\" ng-model=vm.data.sitPros[vm.index].orgasecu uib-btn-radio=\"'ssparents'\" for=orgasecuSsetrangerSsparents{{vm.index}}><input type=radio name=orgasecu{{vm.index}} aria-label=ssparents class=sr-only id=orgasecuSsetrangerSsparents{{vm.index}} ng-model=vm.data.sitPros[vm.index].orgasecu required> <span aria-hidden=true>Couvert par la Sécurité sociale des parents</span></label></div><div class=col-sm-6 ng-if=vm.controle.encouple><label class=\"btn btn-default btn-block\" ng-class=\"{'align-middle-cnaf' : vm.isXs}\" ng-model=vm.data.sitPros[vm.index].orgasecu uib-btn-radio=\"'ssconjoint'\" for=orgasecuSsetrangerSsconjoint{{vm.index}}><input type=radio name=orgasecu{{vm.index}} aria-label=ssconjoint class=sr-only id=orgasecuSsetrangerSsconjoint{{vm.index}} ng-model=vm.data.sitPros[vm.index].orgasecu required> <span aria-hidden=true>Couvert par la Sécurité sociale du conjoint</span></label></div><div class=col-sm-6 ng-if=\"vm.controle.nationalite!='F'\"><label class=\"btn btn-default btn-block align-middle-cnaf\" ng-model=vm.data.sitPros[vm.index].orgasecu uib-btn-radio=\"'ssetranger'\" for=orgasecuSsetrangerSsetranger{{vm.index}}><input type=radio name=orgasecu{{vm.index}} aria-label=ssetranger class=sr-only id=orgasecuSsetrangerSsetranger{{vm.index}} ng-model=vm.data.sitPros[vm.index].orgasecu required> <span aria-hidden=true>Régime étranger</span></label></div><div class=\"col-xs-12 col-sm-12\"><p class=help-block role=alert ng-show=\"(vm.data.sitPros[vm.index].orgasecu == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></fieldset></div><div class=col-sm-12 ng-if=\"vm.data.sitPros[vm.index].boursier === 'Oui'\"><fieldset><div class=row><div class=col-sm-6><div class=row><label class=\"label-form-cnaf control-label\" for=orgabourse{{vm.index}}>Nom de l'organisme qui a accordé la bourse</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                        (vm.sitproetudiantform.orgabourse{{vm.index}}.$invalid && !vm.sitproetudiantform.orgabourse{{vm.index}}.$pristine)\n" +
    "                        || vm.sitproetudiantform.orgabourse{{vm.index}}.$error.type8\n" +
    "                        || (vm.data.sitPros[vm.index].orgabourse == undefined && vm.controle.submitted)\n" +
    "                        }\"><input id=orgabourse{{vm.index}} maxlength=60 ng-model=vm.data.sitPros[vm.index].orgabourse ng-change=\"vm.data.orgabourse = vm.data.orgabourse.toUpperCase()\" ng-pattern=\"/^[a-zA-Zà-ÿÀ-Ÿ0-9 '-]*$/\" ng-blur=\"vm.testType8(vm.data.orgabourse,vm.sitproetudiantform.orgabourse,'orgabourse')\" ng-trim=false name=orgabourse{{vm.index}} class=form-control required><p class=help-block role=alert ng-show=\"vm.sitproetudiantform.orgabourse{{vm.index}}.$error.pattern \">La saisie comporte des caractères non autorisés</p><p class=help-block role=alert ng-show=vm.sitproetudiantform.orgabourse{{vm.index}}.$error.type8>{{vm.sitproetudiantform.orgabourse.invalidmsg}}</p><p class=help-block role=alert ng-show=\"(vm.data.sitPros[vm.index].orgabourse == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=orgaPays{{vm.index}}>Pays de l'organisme</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                                (vm.sitproetudiantform.orgaPays{{vm.index}}.$invalid\n" +
    "                                    && !vm.sitproetudiantform.orgaPays{{vm.index}}.$pristine)\n" +
    "                                    || (vm.data.sitPros[vm.index].pays == undefined && vm.controle.submitted)}\"><input id=orgaPays{{vm.index}} ng-model=vm.data.sitPros[vm.index].pays name=orgaPays{{vm.index}} class=form-control typeahead-min-length=2 uib-typeahead=\"pays as pays.libelleCaffr for pays in vm.getListePaysBourseProposes($viewValue) | filter:$viewValue | limitTo:8\" typeahead-editable=false typeahead-no-results=noPaysFound required><p class=help-block role=alert ng-show=noPaysFound>Pays non trouvé</p><p class=help-block role=alert ng-show=\"(vm.data.sitPros[vm.index].pays == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div><div class=row><div class=col-sm-6><div class=row><label class=\"label-form-cnaf control-label\" for=orgaadresse{{vm.index}}>Adresse de l'organisme</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                        (vm.sitproetudiantform.orgaadresse{{vm.index}}.$invalid\n" +
    "                            && !vm.sitproetudiantform.orgaadresse{{vm.index}}.$pristine)\n" +
    "                            || (vm.data.sitPros[vm.index].orgaadresse == undefined && vm.controle.submitted)\n" +
    "                    }\"><textarea id=orgaadresse{{vm.index}} ng-model=vm.data.sitPros[vm.index].orgaadresse name=orgaadresse{{vm.index}} class=form-control rows=3 maxlength=100 required>\n" +
    "                      </textarea><div class=\"col-xs-12 col-sm-12\"><p class=\"row help-block\" role=alert ng-show=\"(vm.data.sitPros[vm.index].orgaadresse == undefined && vm.controle.submitted)\">Champ obligatoire</p></div></div></div></div></div></fieldset></div></div><div class=\"col-sm-12 form-group\" ng-if=vm.afficheRegimeCotisation(vm.index)><cnaf-cct-sitpro-cotis-employeur data=vm.data cotisemployeurform=vm.sitproetudiantform errorcotisemployeur=vm.errorcotisemployeur controle=vm.controle index=vm.index></cnaf-cct-sitpro-cotis-employeur></div><div ng-if=\"vm.controle.nationalite==='C'\" class=\"col-sm-12 form-group\" ng-class=\"{ 'has-error' :\n" +
    "                    (vm.data.sitPros[vm.index].controle.ressSuffisantesChckBx == false && vm.controle.submitted)\n" +
    "                   }\"><label for=ressSuffisantesChckBx{{vm.index}} class=\"label-form-cnaf align-middle-cnaf\" ng-class=\"{'cnaf-checkboxSelected': vm.data.sitPros[vm.index].controle.ressSuffisantesChckBx}\"><cnaf-checkbox id=ressSuffisantesChckBx{{vm.index}} name=ressSuffisantesChckBx ng-model=vm.data.sitPros[vm.index].controle.ressSuffisantesChckBx ng-blur=vm.controleRessSuffisantesChckBx(vm.data.sitPros[vm.index].controle.ressSuffisantesChckBx,vm.sitproetudiantform) class=pull-left ng-required=true></cnaf-checkbox>Vous déclarez avoir des ressources suffisantes pour vivre<cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-ressSuffisantes data-container=body data-trigger=manual tabindex=0></label><div class=hidden id=content-popover-ressSuffisantes>Votre famille vous aide financièrement, vous percevez une bourse, etc..</div><p class=help-block role=alert ng-show=\"((vm.data.sitPros[vm.index].controle.ressSuffisantesChckBx == undefined || vm.data.sitPros[vm.index].controle.ressSuffisantesChckBx == false) && vm.controle.submitted)\">La case à cocher doit être saisie pour continuer</p></div></div><div class=visible-xs-inline><span ng-init=vm.initClassXs()></span></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-assurance-pret/cnaf-cct-situationpro-assurance-pret.html","<div class=row><div class=col-sm-12><fieldset><legend class=label-form-cnaf>Un ou plusieurs prêts sont pris en charge par une assurance</legend><div class=\"row form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                                vm.assurancepretform.pretAvecAssurance.$invalid\n" +
    "                                    && (!vm.assurancepretform.pretAvecAssurance.$pristine\n" +
    "                                        || vm.assurancepretform.pretAvecAssurance.$touched)\n" +
    "                                \n" +
    "                            }\"><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].pretAvecAssurance uib-btn-radio=\"'Oui'\" title=\"Indiquer si un ou plusieurs prêts sont pris en charge par une assurance. Une sélection est obligatoire.\" for=pretAvecAssuranceoui><input type=radio name=pretAvecAssurance class=sr-only id=pretAvecAssuranceoui ng-model=vm.data.sitPros[vm.index].pretAvecAssurance ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"\n" +
    "                                    assurancepretInfopretAvecAssuranceRequired\n" +
    "                                    assurancepretErreurpretAvecAssuranceRequired\" value=oui required> Oui</label></div><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].pretAvecAssurance uib-btn-radio=\"'Non'\" title=\"Indiquer si un ou plusieurs prêts sont pris en charge par une assurance. Une sélection est obligatoire.\" for=pretAvecAssurancenon><input type=radio name=pretAvecAssurance class=sr-only id=pretAvecAssurancenon ng-model=vm.data.sitPros[vm.index].pretAvecAssurance ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"\n" +
    "                                    assurancepretInfopretAvecAssuranceRequired\n" +
    "                                    assurancepretErreurpretAvecAssuranceRequired\" value=non required> Non</label></div></div><div id=assurancepretInfopretAvecAssuranceRequired class=sr-only><p>Vous devez obligatoirement indiquer si un ou plusieurs prêts sont pris en charge par une assurance.</p></div><cnaf-cct-erreur-input iderreur=assurancepretErreurpretAvecAssuranceRequired condition=\"{{(!vm.assurancepretform.pretAvecAssurance.$pristine || vm.assurancepretform.pretAvecAssurance.$touched) && vm.assurancepretform.pretAvecAssurance.$error.required}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></fieldset></div></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-autre-situation/cnaf-cct-situationpro-autre-situation.html","<div ng-init=vm.init()><fieldset><legend class=label-form-cnaf>Préciser la situation</legend><div class=\"row form-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                vm.autresituationform.choixAutreSituation.$invalid\n" +
    "                   && (!vm.autresituationform.choixAutreSituation.$pristine\n" +
    "                   || vm.autresituationform.choixAutreSituation.$touched)\n" +
    "                \n" +
    "              }\"><div class=col-sm-6 ng-repeat=\"situation in vm.listeChoixAutreSituation\"><span class=pull-right ng-if=situation.ael><cnaf-aide tabindex=0 data-toggle=popover data-id-content-cnaf=popover-tsa data-container=body data-trigger=manual></span><label ng-class=\"{'align-middle-cnaf' : situation.libelle.length < 38}\" class=\"btn btn-default cct-btn-block-probleme-hauteur\" ng-model=vm.data.sitPros[vm.index].choixAutreSituation ng-change=vm.deletechoixAutreSituation() title=\"Sélection obligatoire.\" uib-btn-radio=situation for={{situation.id}}><input type=radio name=choixAutreSituation class=sr-only id={{situation.id}} aria-describedby=\"\n" +
    "                                autresituationInfochoixAutreSituationRequired \n" +
    "                                autresituationErreurchoixAutreSituationRequired\" ng-model=vm.data.sitPros[vm.index].choixAutreSituation ng-model-options=\"{ updateOn: 'blur'}\" required> {{situation.libelle}}</label><div class=hidden id=popover-tsa ng-if=situation.ael>{{situation.ael}}<div class=popover-btn-close-cnaf></div></div></div></div><div id=autresituationInfochoixAutreSituationRequired class=sr-only><p>Vous devez obligatoirement choisir une situation parmi celles proposées.</p></div><cnaf-cct-erreur-input iderreur=autresituationErreurchoixAutreSituationRequired condition=\"{{(!vm.autresituationform.choixAutreSituation.$pristine\n" +
    "                                || vm.autresituationform.choixAutreSituation.$touched) && vm.autresituationform.choixAutreSituation.$error.required}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></fieldset><div ng-if=\"vm.data.sitPros[vm.index].choixAutreSituation.id == 'AIDANT' ||\n" +
    "                            vm.data.sitPros[vm.index].choixAutreSituation.id == 'JEUNE'\"><div class=row><div class=col-sm-4><cnaf-cct-situationpro-datedeb autocompletion=vm.autocompletion data=vm.data datedebform=vm.autresituationform errordatedeb=vm.errordatedeb intitulelabel=\"'Depuis le'\" controle=vm.controle index=vm.index></cnaf-cct-situationpro-datedeb></div></div></div><div ng-if=\"vm.data.sitPros[vm.index].choixAutreSituation.id == 'SSA'\"><cnaf-cct-situationpro-sansactivite autocompletion=vm.autocompletion data=vm.data sansactiviteform=vm.autresituationform errorsansactivite=vm.errorsansactivite controle=vm.controle index=vm.index></cnaf-cct-situationpro-sansactivite></div><div ng-if=\"vm.data.sitPros[vm.index].choixAutreSituation.id == 'MAL'\"><cnaf-cct-situationpro-maladie autocompletion=vm.autocompletion data=vm.data maladieform=vm.autresituationform errormaladie=vm.errormaladie controle=vm.controle index=vm.index></cnaf-cct-situationpro-maladie></div><div ng-if=\"vm.data.sitPros[vm.index].choixAutreSituation.id == 'MOC'\"><cnaf-cct-situationpro-orgacomm autocompletion=vm.autocompletion data=vm.data orgacommform=vm.autresituationform errororgacomm=vm.errororgacomm controle=vm.controle index=vm.index></cnaf-cct-situationpro-orgacomm></div><div ng-if=\"vm.data.sitPros[vm.index].choixAutreSituation.id == 'DETENU'\"><cnaf-cct-situationpro-detention autocompletion=vm.autocompletion data=vm.data detentionform=vm.autresituationform errordetention=vm.errordetention controle=vm.controle index=vm.index></cnaf-cct-situationpro-detention></div><div ng-if=\"vm.data.sitPros[vm.index].choixAutreSituation.id == 'VOL'\"><cnaf-cct-situationpro-volontariat autocompletion=vm.autocompletion data=vm.data volontariatform=vm.autresituationform errorvolontariat=vm.errorvolontariat listechoixautresituationvolontariat=vm.listechoixautresituationvolontariat controle=vm.controle index=vm.index></cnaf-cct-situationpro-volontariat></div></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-choix-activite/cnaf-cct-situationpro-choix-activite.html","<div class=row ng-init=vm.init()><div class=col-sm-12><fieldset><legend ng-if=\"!vm.hidetitle && !vm.controle.libselectactivite\" class=label-form-cnaf>Préciser la situation</legend><legend ng-if=\"!vm.hidetitle && vm.controle.libselectactivite\" class=label-form-cnaf>{{vm.controle.libselectactivite}}</legend><div class=\"row form-group btn-group-lg-cnaf btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                    (vm.choixactiviteform.choixActivite.$invalid\n" +
    "                    && !vm.choixactiviteform.choixActivite.$pristine)\n" +
    "                }\"><div class=col-sm-6 ng-repeat=\"choixActi in vm.choixactivites\"><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixActivite title=\"Préciser la situation. Une sélection est obligatoire.\" uib-btn-radio=\"'{{choixActi.code}}'\" for=choixActivite{{choixActi.code}} ng-change=vm.deleteChoixActiviteSalariee() ng-class=\"{'align-middle-cnaf' : choixActi.libelle.length < 40}\"><span>{{choixActi.libelle}}</span> <input type=radio id=choixActivite{{choixActi.code}} name=choixActivite class=sr-only ng-model=vm.data.sitPros[vm.index].choixActivite value={{choixActi.code}} aria-describedby=\"choixActiviteErreurInputChoixActiviteRequired\n" +
    "                                            choixActiviteInfoInputChoixActiviteRequired\" required></label></div></div><p id=choixActiviteInfoInputChoixActiviteRequired class=sr-only>Vous devez obligatoirement choisir une situation parmi celles proposées.</p><cnaf-cct-erreur-input iderreur=choixActiviteErreurInputChoixActiviteRequired condition=\"{{vm.choixactiviteform.choixActivite.$error.required && !vm.choixactiviteform.choixActivite.$pristine}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></fieldset><div ng-if=\"vm.data.sitPros[vm.index].choixActivite == 'SAL'\"><cnaf-cct-situationpro-choix-activite-salariee autocompletion=vm.autocompletion data=vm.data situationprosalarieeform=vm.choixactiviteform errorchoixactivitesalariee=vm.errorchoixactivitesalariee controle=vm.controle index=vm.index></cnaf-cct-situationpro-choix-activite-salariee></div><div ng-if=\"vm.data.sitPros[vm.index].choixActivite == 'RET'\"><cnaf-cct-situationpro-retraite autocompletion=vm.autocompletion data=vm.data retraiteform=vm.choixactiviteform errorretraite=vm.errorretraite controle=vm.controle index=vm.index></cnaf-cct-situationpro-retraite></div><div ng-if=\"vm.data.sitPros[vm.index].choixActivite == 'PENS'\"><cnaf-cct-situationpro-invalidite autocompletion=vm.autocompletion data=vm.data invaliditeform=vm.choixactiviteform errorinvalidite=vm.errorinvalidite controle=vm.controle index=vm.index></cnaf-cct-situationpro-invalidite></div><div ng-if=\"vm.data.sitPros[vm.index].choixActivite == 'NSAL'\"><cnaf-cct-situationpro-non-salariee autocompletion=vm.autocompletion data=vm.data nonsalarieeform=vm.choixactiviteform errornonsalariee=vm.errornonsalariee controle=vm.controle index=vm.index></cnaf-cct-situationpro-non-salariee></div><div ng-if=\"vm.data.sitPros[vm.index].choixActivite == 'CHO'\"><cnaf-cct-situationpro-chomage autocompletion=vm.autocompletion data=vm.data chomageform=vm.choixactiviteform errorchomage=vm.errorchomage controle=vm.controle index=vm.index></cnaf-cct-situationpro-chomage></div><div ng-if=\"vm.data.sitPros[vm.index].choixActivite == 'CONG'\"><cnaf-cct-situationpro-conges-divers autocompletion=vm.autocompletion data=vm.data congesdiversform=vm.choixactiviteform errorcongesdivers=vm.errorcongesdivers controle=vm.controle index=vm.index></cnaf-cct-situationpro-conges-divers></div><div ng-if=\"vm.data.sitPros[vm.index].choixActivite == 'AUT'\"><cnaf-cct-situationpro-autre-situation autocompletion=vm.autocompletion data=vm.data autresituationform=vm.choixactiviteform errorautresituation=vm.errorautresituation controle=vm.controle index=vm.index></cnaf-cct-situationpro-autre-situation></div><div ng-if=\"vm.data.sitPros[vm.index].choixActivite == 'ETU'\"><cnaf-cct-situationpro-etudiant data=vm.data sitproetudiantform=vm.choixactiviteform errorsitproetudiant=vm.errorsitproetudiant controle=vm.controle index=vm.index></cnaf-cct-situationpro-etudiant></div><div ng-if=\"vm.data.sitPros[vm.index].choixActivite == 'APP'\"><cnaf-cct-situationpro-choix-activite-stagiaire autocompletion=vm.autocompletion data=vm.data situationprostagiaireform=vm.choixactiviteform errorchoixactivitestagiaire=vm.errorchoixactivitestagiaire controle=vm.controle index=vm.index></cnaf-cct-situationpro-choix-activite-stagiaire></div></div></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-choix-activite-salariee/cnaf-cct-situationpro-choix-activite-salariee.html","<div class=row ng-init=vm.init()><div class=col-sm-12><fieldset><legend class=label-form-cnaf>Préciser la situation</legend><div class=\"row form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                    (vm.situationprosalarieeform.choixActiviteSalariee.$invalid\n" +
    "                    && !vm.situationprosalarieeform.choixActiviteSalariee.$pristine)\n" +
    "                }\"><div class=\"col-sm-6 col-md-4\" ng-repeat=\"activite in vm.listeActivitesalariee\"><span class=pull-right ng-if=\"activite.code==='TSA'\"><cnaf-aide tabindex=0 data-toggle=popover data-id-content-cnaf=popover-tsa data-container=body data-trigger=manual></span><span class=pull-right ng-if=\"activite.code==='VDS'\"><cnaf-aide tabindex=0 data-toggle=popover data-id-content-cnaf=popover-vds data-container=body data-trigger=manual></span><span class=pull-right ng-if=\"activite.code==='VRP'\"><cnaf-aide tabindex=0 data-toggle=popover data-id-content-cnaf=popover-vrp data-container=body data-trigger=manual></span><span class=pull-right ng-if=\"activite.code==='ESAT'\"><cnaf-aide tabindex=0 data-toggle=popover data-id-content-cnaf=popover-esat data-container=body data-trigger=manual></span><span class=pull-right ng-if=\"activite.code==='SAS'\"><cnaf-aide tabindex=0 data-toggle=popover data-id-content-cnaf=popover-sas data-container=body data-trigger=manual></span><label ng-class=\"{'align-middle-cnaf' : acti.libelle.length < 38}\" class=\"btn btn-default cct-btn-block-probleme-hauteur-sal\" ng-model=vm.data.sitPros[vm.index].choixActiviteSalariee ng-change=\"vm.data.sitPros[vm.index].cotisEmployeur=undefined;\" uib-btn-radio=activite title=\"Préciser la situation salariée. Une sélection est obligatoire.\" for={{activite.code}}>{{activite.libelle}} <input type=radio name=choixActiviteSalariee class=sr-only id={{activite.code}} value={{activite.code}} ng-model=vm.data.sitPros[vm.index].choixActiviteSalariee aria-describedby=\"situationprosalarieeInfoInputChoixActiviteSal\n" +
    "                                                situationprosalarieeErreurInputChoixActiviteSalRequired\" required></label><div ng-if=\"activite.code==='TSA'\" class=hidden id=popover-tsa>Le travail saisonnier se caractérise par l'exécution de tâches normalement appelées à se répéter chaque année, à des dates à peu près fixes, en fonction du rythme des saisons (récolte, cueillette) ou des modes de vie collectifs (tourisme).<div class=popover-btn-close-cnaf></div></div><div ng-if=\"activite.code==='VDS'\" class=hidden id=popover-vds>Se caractérise par la vente des produits ou de services au moyen du démarchage direct auprès de particuliers et être salarié d'une entreprise ou indépendant mais non inscrit au RCS ou RSAC et donc relever du régime général de la sécurité sociale.<div class=popover-btn-close-cnaf></div></div><div ng-if=\"activite.code==='VRP'\" class=hidden id=popover-vrp>Voyageur Représentant Placier<div class=popover-btn-close-cnaf></div></div><div ng-if=\"activite.code==='ESAT'\" class=hidden id=popover-esat>Travailleur dans un établissement et service d'aide par le travail<div class=popover-btn-close-cnaf></div></div><div ng-if=\"activite.code==='SAS'\" class=hidden id=popover-sas>Président d'une Société par Actions Simplifiée<div class=popover-btn-close-cnaf></div></div></div></div><p id=situationprosalarieeInfoInputChoixActiviteSal class=sr-only>Vous devez choisir une situation parmi celles proposées.</p><cnaf-cct-erreur-input iderreur=situationprosalarieeErreurInputChoixActiviteSalRequired condition=\"{{vm.situationprosalarieeform.choixActiviteSalariee.$invalid\n" +
    "                                        && !vm.situationprosalarieeform.choixActiviteSalariee.$pristine}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></fieldset></div></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteSalariee && vm.controle.profilAvecAAH\"><cnaf-cct-situationpro-taux-activite-aah autocompletion=vm.autocompletion data=vm.data tauxactiviteaahform=vm.situationprosalarieeform errorctauxactiviteaah=vm.errortauxactiviteaah controle=vm.controle index=vm.index></cnaf-cct-situationpro-taux-activite-aah></div><div class=row ng-if=vm.data.sitPros[vm.index].choixActiviteSalariee><div class=col-sm-8><label class=\"label-form-cnaf control-label\" for=dateActiviteSalarie><span>Depuis le</span></label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                        ((vm.situationprosalarieeform.dateActiviteSalarie.$invalid\n" +
    "                                 && (!vm.situationprosalarieeform.dateActiviteSalarie.$pristine \n" +
    "                                    || vm.situationprosalarieeform.dateActiviteSalarie.$touched))\n" +
    "                            || ((vm.situationprosalarieeform.dateActiviteSalarie.$error.pattern\n" +
    "                                 || vm.situationprosalarieeform.dateActiviteSalarie.$error.controleSupDernJourMoisSuivDem\n" +
    "                                 || vm.situationprosalarieeform.dateActiviteSalarie.$error.controleInfDateNaissance\n" +
    "                                 ||  (vm.controle.contexte === 'arriveeRetourCjt' && vm.situationprosalarieeform.dateActiviteSalarie.$error.controleDateSitProSitfamCouple))\n" +
    "                                    && vm.data.sitPros[vm.index].dateActiviteSalarie\n" +
    "                                    && vm.data.sitPros[vm.index].dateActiviteSalarie.length == 10\n" +
    "                                    && vm.data.sitPros[vm.index].dateActiviteSalarie !== 'jj/mm/aaaa'))\n" +
    "                   }\"><div class=\"form-group input-group\" id=divDateActiviteSalarie><input id=dateActiviteSalarie name=dateActiviteSalarie title=\"Saisie de la date de début d'activité. Champ obligatoire. Au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010)\" placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActiviteSalarie ng-model-options=\"{ updateOn: 'change'}\" class=form-control inputname=vm.data.sitPros[vm.index].dateActiviteSalarie ui-validate=\"{  controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                        controleSupDernJourMoisSuivDem  : 'vm.controleSupDernJourMoisSuivDem($value, vm.controle.dernJourMoisSuivDem, vm.index)',\n" +
    "                                        controleDateSitProSitfamCouple  : 'vm.controleDateSitProSitfamCouple($value, vm.controle, vm.index)'\n" +
    "                                }\" aria-describedby=\"\n" +
    "                            situationprosalarieeInfoDateActiviteSalariee\n" +
    "                            situationprosalarieeErreurDateActiviteSalarieRequired\n" +
    "                            situationprosalarieeErreurDateActiviteSalariePattern\n" +
    "                            situationprosalarieeErreurControleInfDateNaissance\n" +
    "                            situationprosalarieeErreurControleSupDernJourMoisSuivDem\n" +
    "                            situationprosalarieeErreurControleDateSitProSitfamCouple\" required pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActiviteSalarie start-year=1980 pattern-cnaf=dd/MM/yyyy inputname=dateActiviteSalarie></cnaf-date-picker></div></div><p id=situationprosalarieeInfoDateActiviteSalariee class=sr-only>Champ Obligatoire</p><cnaf-cct-erreur-input iderreur=situationprosalarieeErreurDateActiviteSalarieeRequired condition=\"{{!vm.situationprosalarieeform.dateActiviteSalarie.$pristine && vm.situationprosalarieeform.dateActiviteSalarie.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprosalarieeErreurDateActiviteSalariePattern condition=\"{{vm.situationprosalarieeform.dateActiviteSalarie.$error.pattern \n" +
    "                                                && vm.data.sitPros[vm.index].dateActiviteSalarie\n" +
    "                                                && vm.data.sitPros[vm.index].dateActiviteSalarie.length === 10\n" +
    "                                                && vm.data.sitPros[vm.index].dateActiviteSalarie !== 'jj/mm/aaaa'}}\" message=\"Format de date invalide, la saisie doit contenir 10 caractères et être au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprosalarieeErreurControleInfDateNaissance condition=\"{{!vm.situationprosalarieeform.dateActiviteSalarie.$error.required\n" +
    "                                            && vm.data.sitPros[vm.index].dateActiviteSalarie !=='jj/mm/aaaa'\n" +
    "                                            && !vm.situationprosalarieeform.dateActiviteSalarie.$error.pattern \n" +
    "                                            && vm.situationprosalarieeform.dateActiviteSalarie.$error.controleInfDateNaissance}}\" message=\"La date saisie ne peut être inférieure à la date de naissance ({{vm.controle.datenaissance | date:'dd/MM/yyyy'}}).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprosalarieeErreurControleSupDernJourMoisSuivDem condition=\"{{!vm.situationprosalarieeform.dateActiviteSalarie.$error.required\n" +
    "                                    && vm.data.sitPros[vm.index].dateActiviteSalarie !=='jj/mm/aaaa'\n" +
    "                                    && !vm.situationprosalarieeform.dateActiviteSalarie.$error.pattern\n" +
    "                                    && vm.situationprosalarieeform.dateActiviteSalarie.$error.controleSupDernJourMoisSuivDem}}\" message=\"La date saisie ne peut être postérieure à la date du {{vm.controle.dernJourMoisSuivDem | date:'dd/MM/yyyy'}}\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprosalarieeErreurControleDateSitProSitfamCouple condition=\"{{!vm.situationprosalarieeform.dateActiviteSalarie.$error.required\n" +
    "                                    && vm.data.sitPros[vm.index].dateActiviteSalarie !=='jj/mm/aaaa'\n" +
    "                                    && !vm.situationprosalarieeform.dateActiviteSalarie.$error.pattern\n" +
    "                                    && vm.controle.contexte === 'arriveeRetourCjt'\n" +
    "                                    && vm.situationprosalarieeform.dateActiviteSalarie.$error.controleDateSitProSitfamCouple}}\" message=\"Vous devez saisir une date d'activité antérieure au {{vm.controle.dateSitfam | date:'dd/MM/yyyy'}}\"></cnaf-cct-erreur-input></div></div><div class=row ng-if=vm.afficheEmployeur(vm.index)><div class=col-sm-6><label ng-if=\"vm.data.sitPros[vm.index].choixActiviteSalariee.code == 'GERSAL'\" class=label-form-cnaf for=nomEmployeur>Nom de l'entreprise</label><label ng-if=\"vm.data.sitPros[vm.index].choixActiviteSalariee.code == 'ESAT'\" class=label-form-cnaf for=nomEmployeur>Nom de l'ESAT</label><label ng-if=\"vm.data.sitPros[vm.index].choixActiviteSalariee.code != 'GERSAL'\n" +
    "                && vm.data.sitPros[vm.index].choixActiviteSalariee.code != 'ESAT'\" class=label-form-cnaf for=nomEmployeur>Nom de l'employeur</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "               (vm.situationprosalarieeform.nomEmployeur.$invalid && !vm.situationprosalarieeform.nomEmployeur.$pristine)\n" +
    "                 || vm.situationprosalarieeform.nomEmployeur.$error.type8\n" +
    "                 }\"><input id=nomEmployeur maxlength=30 ng-model=vm.data.sitPros[vm.index].nomEmployeur ng-change=\"vm.data.sitPros[vm.index].nomEmployeur = vm.data.sitPros[vm.index].nomEmployeur.toUpperCase()\" ng-pattern=\"/^[0-9a-zA-Zà-ÿÀ-Ÿ '-]*$/\" ng-blur=\"vm.testType8(vm.data.sitPros[vm.index].nomEmployeur,vm.situationprosalarieeform,'nomEmployeur')\" ng-trim=false name=nomEmployeur class=form-control aria-describedby=\"\n" +
    "                                situationprosalarieeInfoNomEmployeur\n" +
    "                                situationprosalarieeErreurNomEmployeurRequired\n" +
    "                                situationprosalarieeErreurNomEmployeurPattern\n" +
    "                                situationprosalarieeErreurNomEmployeurType8\" required><p id=situationprosalarieeInfoNomEmployeur class=sr-only>Champ obligatoire</p><cnaf-cct-erreur-input iderreur=situationprosalarieeErreurNomEmployeurRequired condition=\"{{!vm.situationprosalarieeform.nomEmployeur.$pristine && vm.situationprosalarieeform.nomEmployeur.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprosalarieeErreurNomEmployeurPattern condition={{vm.situationprosalarieeform.nomEmployeur.$error.pattern}} message=\"La saisie comporte des caractères non autorisés\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprosalarieeErreurNomEmployeurType8 condition={{vm.situationprosalarieeform.nomEmployeur.$error.type8}} message={{vm.situationprosalarieeform.nomEmployeur.invalidmsg}}></cnaf-cct-erreur-input></div></div><div class=col-sm-6><label ng-if=\"vm.data.sitPros[vm.index].choixActiviteSalariee.code == 'GERSAL'\" class=label-form-cnaf for=paysEmployeur>Pays de l'entreprise</label><label ng-if=\"vm.data.sitPros[vm.index].choixActiviteSalariee.code != 'GERSAL'\n" +
    "            && vm.data.sitPros[vm.index].choixActiviteSalariee.code != 'ESAT'\" class=label-form-cnaf for=paysEmployeur>Pays de l'employeur</label><div class=form-group ng-if=\"vm.data.sitPros[vm.index].choixActiviteSalariee.code != 'ESAT'\" ng-class=\"{ 'has-error' :\n" +
    "                          (vm.situationprosalarieeform.paysEmployeur.$invalid\n" +
    "                          && !vm.situationprosalarieeform.paysEmployeur.$pristine)\n" +
    "                 }\"><input id=paysEmployeur ng-model=vm.data.sitPros[vm.index].paysEmployeur name=paysEmployeur class=form-control typeahead-min-length=2 uib-typeahead=\"pays as pays.libelleCaffr for pays in vm.getListePaysEmployeurProposes($viewValue) | filter:$viewValue | limitTo:8\" typeahead-editable=false typeahead-no-results=noPaysFound aria-describedby=\"\n" +
    "                                    situationprosalarieeInfoPaysEmployeur\n" +
    "                                    situationprosalarieeErreurPaysEmployeurRequired\n" +
    "                                    situationprosalarieeErreurPaysEmployeurNonTrouve\" required><p id=situationprosalarieeInfoPaysEmployeur class=sr-only>Champ obligatoire</p><cnaf-cct-erreur-input iderreur=situationprosalarieeErreurPaysEmployeurRequired condition=\"{{!vm.situationprosalarieeform.paysEmployeur.$pristine && vm.situationprosalarieeform.paysEmployeur.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprosalarieeErreurPaysEmployeurNonTrouve condition=\"{{!vm.situationprosalarieeform.paysEmployeur.$error.required && noPaysFound}}\" message=\"Pays non trouvé\"></cnaf-cct-erreur-input></div></div></div><div class=row ng-if=\"vm.afficheEmployeur(vm.index) && vm.afficheCodePostalVille(vm.index)\"><div class=col-sm-6><label ng-if=\"vm.data.sitPros[vm.index].choixActiviteSalariee.code == 'GERSAL'\" class=label-form-cnaf for=codePostalVilleEmployeur>Code postal / Commune de l'entreprise</label><label ng-if=\"vm.data.sitPros[vm.index].choixActiviteSalariee.code == 'ESAT'\" class=label-form-cnaf for=codePostalVilleEmployeur>Code postal / Commune de l'ESAT</label><label ng-if=\"vm.data.sitPros[vm.index].choixActiviteSalariee.code != 'GERSAL'\n" +
    "                && vm.data.sitPros[vm.index].choixActiviteSalariee.code != 'ESAT'\" class=label-form-cnaf for=codePostalVilleEmployeur>Code postal / Commune de l'employeur</label><div ng-switch on=vm.autocompletion><div ng-switch-when=on class=form-group ng-class=\"{ 'has-error' :\n" +
    "                              (vm.situationprosalarieeform.codePostalVilleEmployeur.$invalid\n" +
    "                              && !vm.situationprosalarieeform.codePostalVilleEmployeur.$pristine)\n" +
    "                        }\"><input id=codePostalVilleEmployeur ng-model=vm.data.sitPros[vm.index].codePostalVilleEmployeur name=codePostalVilleEmployeur class=form-control typeahead-min-length=2 uib-typeahead=\"result as result.lib for result in vm.codePostalVilles($viewValue)\" typeahead-editable=false aria-describedby=\"\n" +
    "                                situationprosalarieeInfoCodePostalVilleEmployeur\n" +
    "                                situationprosalarieeErreurCodePostalVilleEmployeurRequired\" required></div><div ng-switch-when=off class=form-group ng-class=\"{ 'has-error' :\n" +
    "                            (vm.situationprosalarieeform.codePostalVilleEmployeur.$invalid\n" +
    "                            && !vm.situationprosalarieeform.codePostalVilleEmployeur.$pristine)\n" +
    "                      }\"><input id=codePostalVilleEmployeur ng-model=vm.data.sitPros[vm.index].codePostalVilleEmployeur name=codePostalVilleEmployeur class=form-control ui-validate=\"{controleCodePostalFormat  : 'vm.controleCodePostalFormat($value)'}\" ng-trim=false aria-describedby=\"\n" +
    "                                situationprosalarieeInfoCodePostalVilleEmployeur\n" +
    "                                situationprosalarieeErreurCodePostalVilleEmployeurRequired\n" +
    "                                situationprosalarieeErreurCodePostalVilleEmployeurFormat\" required></div><p id=situationprosalarieeInfoCodePostalVilleEmployeur class=sr-only>Champ obligatoire</p><cnaf-cct-erreur-input iderreur=situationprosalarieeErreurCodePostalVilleEmployeurRequired condition=\"{{!vm.situationprosalarieeform.codePostalVilleEmployeur.$pristine && vm.situationprosalarieeform.codePostalVilleEmployeur.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprosalarieeErreurCodePostalVilleEmployeurFormat condition=\"{{!vm.situationprosalarieeform.codePostalVilleEmployeur.$error.required && vm.situationprosalarieeform.codePostalVilleEmployeur.$error.controleCodePostalFormat}}\" message=\"Code postal incorrect\"></cnaf-cct-erreur-input></div></div></div><div class=row ng-if=\"vm.afficheEmployeur(vm.index) &&\n" +
    "                        vm.data.sitPros[vm.index].paysEmployeur &&\n" +
    "                        vm.data.sitPros[vm.index].paysEmployeur.code !== 'FR'\n" +
    "                        && vm.data.sitPros[vm.index].paysEmployeur.code !== 'MC'\n" +
    "                        && vm.data.sitPros[vm.index].choixActiviteSalariee.code !== 'ESAT'\"><div class=col-sm-6><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteSalariee.code == 'GERSAL'\"><label class=label-form-cnaf for=villeEmployeur>Ville de l'entreprise</label></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteSalariee.code != 'GERSAL'\"><label class=label-form-cnaf for=villeEmployeur>Ville de l'employeur</label></div><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "              (!vm.situationprosalarieeform.villeEmployeur.$pristine && vm.situationprosalarieeform.villeEmployeur.$error.required)\n" +
    "              || vm.situationprosalarieeform.villeEmployeur.$error.type5\n" +
    "            }\"><input id=villeEmployeur ng-model=vm.data.sitPros[vm.index].villeEmployeur ng-model-options=\"{ updateOn: 'blur' }\" ng-change=\"vm.data.sitPros[vm.index].villeEmployeur = vm.data.sitPros[vm.index].villeEmployeur.toUpperCase()\" ui-validate=\"{type5  : 'vm.testType5($value,vm.situationprosalarieeform.villeEmployeur, {{vm.index}})'}\" ng-trim=false name=villeEmployeur maxlength=38 class=form-control aria-describedby=\"\n" +
    "                                situationprosalarieeInfoVilleEmployeur\n" +
    "                                situationprosalarieeErreurVilleEmployeurRequired\n" +
    "                                situationprosalarieeErreurVilleEmployeurPattern\n" +
    "                                situationprosalarieeErreurVilleEmployeurType5\" required ng-pattern=\"/^[a-zA-Z0-9à-ÿÀ-Ÿ -']*$/\"></div><p id=situationprosalarieeInfoVilleEmployeur class=sr-only>Champ obligatoire</p><cnaf-cct-erreur-input iderreur=situationprosalarieeErreurVilleEmployeurRequired condition=\"{{!vm.situationprosalarieeform.villeEmployeur.$pristine && vm.situationprosalarieeform.villeEmployeur.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprosalarieeErreurVilleEmployeurPattern condition=\"{{!vm.situationprosalarieeform.villeEmployeur.$error.required && vm.situationprosalarieeform.villeEmployeur.$error.pattern}}\" message=\"La saisie comporte des caractères non autorisés\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprosalarieeErreurVilleEmployeurType5 condition=\"{{!vm.situationprosalarieeform.villeEmployeur.$error.required && vm.situationprosalarieeform.villeEmployeur.$error.type5}}\" message={{vm.situationprosalarieeform.villeEmployeur.invalidmsg}}></cnaf-cct-erreur-input></div></div><cnaf-cct-situationpro-cotis-employeur data=vm.data cotisemployeurform=vm.situationprosalarieeform errorcotisemployeur=vm.errorcotisemployeur controle=vm.controle index=vm.index></cnaf-cct-situationpro-cotis-employeur>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-choix-activite-simultanee/cnaf-cct-situationpro-choix-activite-simultanee.html","<div ng-init=vm.init()><fieldset><legend class=label-form-cnaf>{{vm.controle.libellePersonneSimultanee}}</legend><div class=\"row form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                    (vm.choixactivitesimultaneeform.choixActiviteSimultanee.$invalid\n" +
    "                    && !vm.choixactivitesimultaneeform.choixActiviteSimultanee.$pristine) \n" +
    "                    \n" +
    "                        }\"><div class=col-sm-4 ng-repeat=\"choixActiSimultanee in vm.choixactivitessimultanee\"><label ng-class=\"{'align-middle-cnaf' : choixActiSimultanee.libelle.length < 40}\" class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixActiviteSimultanee uib-btn-radio={{choixActiSimultanee}} for=choixActiviteSimultanee{{choixActiSimultanee.code}} title=\"Préciser l'activité simultanée'. Une sélection est obligatoire.\">{{choixActiSimultanee.libelle}}</label><input type=radio id=choixActiviteSimultanee{{choixActiSimultanee.code}} name=choixActiviteSimultanee class=sr-only ng-model=vm.data.sitPros[vm.index].choixActiviteSimultanee ng-model-options=\"{ updateOn: 'blur'}\" value={{choixActiSimultanee.code}} aria-describedby=\"choixactivitesimultaneeInfoChoixActiSimultaneeRequired \n" +
    "                                        choixactivitesimultaneeErreurChoixActiSimultaneeRequired\" required></div></div><div id=choixactivitesimultaneeInfoChoixActiSimultaneeRequired class=sr-only><p>Vous devez obligatoirement choisir une situation parmi celles proposées.</p></div><cnaf-cct-erreur-input iderreur=choixactivitesimultaneeErreurChoixActiSimultaneeRequired condition=\"{{!vm.choixactivitesimultaneeform.choixActiviteSimultanee.$pristine && vm.choixactivitesimultaneeform.choixActiviteSimultanee.$error.required}}\" message=\"Vous devez obligatoirement choisir une situation parmi celles proposées.\"></cnaf-cct-erreur-input></fieldset></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-choix-activite-stagiaire/cnaf-cct-situationpro-choix-activite-stagiaire.html","<div ng-init=vm.init()><div class=row><div class=col-sm-12><fieldset><legend class=label-form-cnaf>Préciser la situation</legend><div class=\"row form-group btn-block btn-group-lg-cnaf\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                    (vm.situationprostagiaireform.choixStagiaire.$invalid\n" +
    "                        && !vm.situationprostagiaireform.choixStagiaire.$pristine)\n" +
    "                    }\"><div class=col-sm-4 ng-repeat=\"acti in vm.listeChoixStagiaire\"><label ng-class=\"{'align-middle-cnaf' : acti.libelle.length < 38}\" class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixStagiaire ng-change=\"vm.data.sitPros[vm.index].cotisEmployeur=undefined;vm.data.sitPros[vm.index].isEtu=undefined;\" uib-btn-radio=acti title=\"Préciser la situation. Une sélection est obligatoire.\" for={{acti.code}}><input type=radio name=choixStagiaire class=sr-only id={{acti.code}} ng-model=vm.data.sitPros[vm.index].choixStagiaire aria-describedby=\"situationprostagiaireInfoInputChoixStagiaire\n" +
    "                                                situationprostagiaireErreurInputChoixStagiaireRequired\" required> {{acti.libelle}}</label></div></div><p id=situationprostagiaireInfoInputChoixStagiaire class=sr-only>Vous devez choisir une situation parmi celles proposées.</p><cnaf-cct-erreur-input iderreur=situationprostagiaireErreurInputChoixStagiaireRequired condition=\"{{vm.situationprostagiaireform.choixStagiaire.$invalid\n" +
    "                                    && !vm.situationprostagiaireform.choixStagiaire.$pristine}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></fieldset></div></div><div ng-if=\"vm.data.sitPros[vm.index].choixStagiaire && vm.controle.profilAvecAAH\"><cnaf-cct-situationpro-taux-activite-aah autocompletion=vm.autocompletion data=vm.data tauxactiviteaahform=vm.situationprostagiaireform errorctauxactiviteaah=vm.errortauxactiviteaah controle=vm.controle index=vm.index></cnaf-cct-situationpro-taux-activite-aah></div><div class=row ng-if=\"vm.data.sitPros[vm.index].choixStagiaire && (vm.data.sitPros[vm.index].choixStagiaire.code == 'APP' || vm.data.sitPros[vm.index].choixStagiaire.code == 'CONTRAT')\"><div class=col-sm-8><label ng-if=\"vm.data.sitPros[vm.index].choixStagiaire.code == 'APP'\" class=label-form-cnaf for=dateActiviteApprenti>Date de début d'apprentissage</label><label ng-if=\"vm.data.sitPros[vm.index].choixStagiaire.code == 'CONTRAT'\" class=label-form-cnaf for=dateActiviteApprenti>Date de début de contrat</label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                         (vm.situationprostagiaireform.dateActiviteApprenti.$invalid\n" +
    "                            && !vm.situationprostagiaireform.dateActiviteApprenti.$pristine)\n" +
    "                       }\"><div class=\"form-group input-group\" id=divDateActiviteApprenti><input id=dateActiviteApprenti name=dateActiviteApprenti title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActiviteApprenti class=form-control ui-validate=\"{controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                            controleSupDernJourMoisSuivDem  : 'vm.controleSupDernJourMoisSuivDem($value, vm.controle.dernJourMoisSuivDem, vm.index)',\n" +
    "                                            controleDateSitProSitfamCouple  : 'vm.controleDateSitProSitfamCouple($value, vm.controle, vm.index)'\n" +
    "                                    }\" aria-describedby=\"\n" +
    "                                situationprostagiaireInfoDateActiviteApprenti\n" +
    "                                situationprostagiaireErreurDateActiviteApprentiRequired\n" +
    "                                situationprostagiaireErreurDateActiviteApprentiPattern\n" +
    "                                situationprostagiaireErreurControleInfDateNaissance\n" +
    "                                situationprostagiaireErreurControleSupDernJourMoisSuivDem\n" +
    "                                situationprostagiaireErreurControleDateSitProSitfamCouple\" ng-required=true pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActiviteApprenti start-year=1980 pattern-cnaf=dd/MM/yyyy inputname=dateActiviteApprenti></cnaf-date-picker></div></div><p id=situationprostagiaireInfoDateActiviteApprenti class=sr-only>Champ Obligatoire</p><cnaf-cct-erreur-input iderreur=situationprostagiaireErreurDateActiviteApprentiRequired condition=\"{{!vm.situationprostagiaireform.dateActiviteApprenti.$pristine && vm.situationprostagiaireform.dateActiviteApprenti.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprostagiaireErreurDateActiviteApprentiPattern condition=\"{{vm.situationprostagiaireform.dateActiviteApprenti.$error.pattern \n" +
    "                                                    && vm.data.sitPros[vm.index].dateActiviteApprenti\n" +
    "                                                    && vm.data.sitPros[vm.index].dateActiviteApprenti.length === 10\n" +
    "                                                    && vm.data.sitPros[vm.index].dateActiviteApprenti !== 'jj/mm/aaaa'}}\" message=\"Format de date invalide, la saisie doit contenir 10 caractères et être au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprostagiaireErreurControleInfDateNaissance condition=\"{{!vm.situationprostagiaireform.dateActiviteApprenti.$error.required\n" +
    "                                                && vm.data.sitPros[vm.index].dateActiviteApprenti !=='jj/mm/aaaa'\n" +
    "                                                && !vm.situationprostagiaireform.dateActiviteApprenti.$error.pattern \n" +
    "                                                && vm.situationprostagiaireform.dateActiviteApprenti.$error.controleInfDateNaissance}}\" message=\"La date saisie ne peut être inférieure à la date de naissance ({{vm.controle.datenaissance | date:'dd/MM/yyyy'}}).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprostagiaireErreurControleSupDernJourMoisSuivDem condition=\"{{!vm.situationprostagiaireform.dateActiviteApprenti.$error.required\n" +
    "                                        && vm.data.sitPros[vm.index].dateActiviteApprenti !=='jj/mm/aaaa'\n" +
    "                                        && !vm.situationprostagiaireform.dateActiviteApprenti.$error.pattern\n" +
    "                                        && vm.situationprostagiaireform.dateActiviteApprenti.$error.controleSupDernJourMoisSuivDem}}\" message=\"La date saisie ne peut être postérieure à la date du {{vm.controle.dernJourMoisSuivDem | date:'dd/MM/yyyy'}}\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprostagiaireErreurControleDateSitProSitfamCouple condition=\"{{!vm.situationprostagiaireform.dateActiviteApprenti.$error.required\n" +
    "                                        && vm.data.sitPros[vm.index].dateActiviteApprenti !=='jj/mm/aaaa'\n" +
    "                                        && !vm.situationprostagiaireform.dateActiviteApprenti.$error.pattern\n" +
    "                                        && vm.controle.contexte === 'arriveeRetourCjt'\n" +
    "                                        && vm.situationprostagiaireform.dateActiviteApprenti.$error.controleDateSitProSitfamCouple}}\" message=\"Vous devez saisir une date d'activité antérieure au {{vm.controle.dateSitfam | date:'dd/MM/yyyy'}}\"></cnaf-cct-erreur-input></div></div><div ng-if=\"vm.data.sitPros[vm.index].choixStagiaire && vm.data.sitPros[vm.index].choixStagiaire.code == 'STAGE'\"><div ng-if=\"(vm.controle.contexte == 'etudiant' || vm.controle.contexte == 'arriveeRetourCjt')\"><div class=row><div class=col-sm-12><fieldset><legend class=\"label-form-cnaf control-label\" for=orgInscription ng-if=!vm.controle.encouple>Vous êtes stagiaire dans le cadre de vos études ou en année de césure<cnaf-aide tabindex=0 data-toggle=popover data-content=\"L'année de césure est une période pendant laquelle un(e) étudiant(e), inscrit(e) dans une formation d'enseignement supérieur (université, école...), suspend temporairement ses études. Il s'agit donc d'un temps de pause dans le cursus de l'étudiant(e).\" data-container=body data-trigger=manual class=sitpro-aide></cnaf-aide></legend><legend class=\"label-form-cnaf control-label\" for=orgInscription ng-if=vm.controle.encouple>{{vm.controle.libPersonneEnCours}} est stagiaire dans le cadre de ses études ou en année de césure<cnaf-aide tabindex=0 data-toggle=popover data-content=\"L'année de césure est une période pendant laquelle un(e) étudiant(e), inscrit(e) dans une formation d'enseignement supérieur (université, école...), suspend temporairement ses études. Il s'agit donc d'un temps de pause dans le cursus de l'étudiant(e).\" data-container=body data-trigger=manual class=sitpro-aide></cnaf-aide></legend><div class=\"row form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                                            (vm.situationprostagiaireform.isEtu.$invalid\n" +
    "                                            && !vm.situationprostagiaireform.isEtu.$pristine)\n" +
    "                                        }\"><div class=col-sm-2><label ng-if=\"vm.controle.contexte == 'arriveeRetourCjt'\" class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].isEtu ng-change=\"vm.data.sitPros[vm.index].indemnise=undefined;\" uib-btn-radio=\"'Oui'\" for=isEtuOui><input type=radio name=isEtu class=sr-only id=isEtuOui ng-model=vm.data.sitPros[vm.index].isEtu value=oui aria-describedby=\"situationprostagiaireInfoInputIsEtu\n" +
    "                                            situationprostagiaireErreurInputIsEtuRequired\" required> Oui</label><button ng-if=\"vm.controle.contexte == 'etudiant'\" type=submit name=isEtu class=\"btn btn-default btn-block\" id=isEtuOui alt=\"je suis étudiant(e)\" ng-model=vm.data.sitPros[vm.index].isEtu value=oui uib-btn-radio=\"'Oui'\" aria-describedby=\"situationprostagiaireInfoInputIsEtu\n" +
    "                                        situationprostagiaireErreurInputIsEtuRequired\" required ng-click=vm.openStagiaire()>Oui</button></div><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].isEtu ng-change=\"vm.data.sitPros[vm.index].indemnise=undefined;\" uib-btn-radio=\"'Non'\" for=isEtuNon><input type=radio name=isEtu class=sr-only id=isEtuNon ng-model=vm.data.sitPros[vm.index].isEtu value=non aria-describedby=\"situationprostagiaireInfoInputIsEtu\n" +
    "                                            situationprostagiaireErreurInputIsEtuRequired\" required> Non</label></div></div><p id=situationprostagiaireInfoInputIsEtu class=sr-only>Vous devez choisir une réponse.</p><cnaf-cct-erreur-input iderreur=situationprostagiaireErreurInputIsEtuRequired condition=\"{{vm.situationprostagiaireform.isEtu.$invalid\n" +
    "                                                    && !vm.situationprostagiaireform.isEtu.$pristine}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></fieldset></div></div><div class=row ng-if=\"vm.controle.contexte == 'arriveeRetourCjt' && vm.data.sitPros[vm.index].isEtu === 'Oui'\"><div class=col-sm-8><label class=label-form-cnaf for=dateActiviteStagiaire>Depuis le</label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                                    (vm.situationprostagiaireform.dateActiviteStagiaire.$invalid\n" +
    "                                    && !vm.situationprostagiaireform.dateActiviteStagiaire.$pristine)\n" +
    "                                }\"><div class=\"form-group input-group\" id=divDateActiviteStagiaire><input id=dateActiviteStagiaire name=dateActiviteStagiaire title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActiviteStagiaire class=form-control ui-validate=\"{controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                                    controleSupDernJourMoisSuivDem  : 'vm.controleSupDernJourMoisSuivDem($value, vm.controle.dernJourMoisSuivDem, vm.index)',\n" +
    "                                                    controleDateSitProSitfamCouple  : 'vm.controleDateSitProSitfamCouple($value, vm.controle, vm.index)'\n" +
    "                                            }\" aria-describedby=\"\n" +
    "                                        situationprostagiaireInfoDateActiviteStagiaire\n" +
    "                                        situationprostagiaireErreurDateActiviteStagiaireRequired\n" +
    "                                        situationprostagiaireErreurDateActiviteStagiairePattern\n" +
    "                                        situationprostagiaireErreurControleInfDateNaissance\n" +
    "                                        situationprostagiaireErreurControleSupDernJourMoisSuivDem\n" +
    "                                        situationprostagiaireErreurControleDateSitProSitfamCouple\" ng-required=true pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActiviteStagiaire start-year=1980 pattern-cnaf=dd/MM/yyyy inputname=dateActiviteStagiaire></cnaf-date-picker></div></div><p id=situationprostagiaireInfoDateActiviteStagiaire class=sr-only>Champ Obligatoire</p><cnaf-cct-erreur-input iderreur=situationprostagiaireErreurDateActiviteStagiaireRequired condition=\"{{!vm.situationprostagiaireform.dateActiviteStagiaire.$pristine && vm.situationprostagiaireform.dateActiviteStagiaire.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprostagiaireErreurDateActiviteStagiairePattern condition=\"{{vm.situationprostagiaireform.dateActiviteStagiaire.$error.pattern \n" +
    "                                                            && vm.data.sitPros[vm.index].dateActiviteStagiaire\n" +
    "                                                            && vm.data.sitPros[vm.index].dateActiviteStagiaire.length === 10\n" +
    "                                                            && vm.data.sitPros[vm.index].dateActiviteStagiaire !== 'jj/mm/aaaa'}}\" message=\"Format de date invalide, la saisie doit contenir 10 caractères et être au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprostagiaireErreurControleInfDateNaissance condition=\"{{!vm.situationprostagiaireform.dateActiviteStagiaire.$error.required\n" +
    "                                                        && vm.data.sitPros[vm.index].dateActiviteStagiaire !=='jj/mm/aaaa'\n" +
    "                                                        && !vm.situationprostagiaireform.dateActiviteStagiaire.$error.pattern \n" +
    "                                                        && vm.situationprostagiaireform.dateActiviteStagiaire.$error.controleInfDateNaissance}}\" message=\"La date saisie ne peut être inférieure à la date de naissance ({{vm.controle.datenaissance | date:'dd/MM/yyyy'}}).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprostagiaireErreurControleSupDernJourMoisSuivDem condition=\"{{!vm.situationprostagiaireform.dateActiviteStagiaire.$error.required\n" +
    "                                                && vm.data.sitPros[vm.index].dateActiviteStagiaire !=='jj/mm/aaaa'\n" +
    "                                                && !vm.situationprostagiaireform.dateActiviteStagiaire.$error.pattern\n" +
    "                                                && vm.situationprostagiaireform.dateActiviteStagiaire.$error.controleSupDernJourMoisSuivDem}}\" message=\"La date saisie ne peut être postérieure à la date du {{vm.controle.dernJourMoisSuivDem | date:'dd/MM/yyyy'}}\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprostagiaireErreurControleDateSitProSitfamCouple condition=\"{{!vm.situationprostagiaireform.dateActiviteStagiaire.$error.required\n" +
    "                                        && vm.data.sitPros[vm.index].dateActiviteStagiaire !=='jj/mm/aaaa'\n" +
    "                                        && !vm.situationprostagiaireform.dateActiviteStagiaire.$error.pattern\n" +
    "                                        && vm.controle.contexte === 'arriveeRetourCjt'\n" +
    "                                        && vm.situationprostagiaireform.dateActiviteStagiaire.$error.controleDateSitProSitfamCouple}}\" message=\"Vous devez saisir une date d'activité antérieure au {{vm.controle.dateSitfam | date:'dd/MM/yyyy'}}\"></cnaf-cct-erreur-input></div><div class=col-sm-12 ng-if=!vm.controle.agesup29><div class=row><cnaf-cct-situationpro-etudiant-boursier autocompletion=vm.autocompletion data=vm.data sitproetudiantboursierform=vm.situationprostagiaireform errorsitproetudiantboursier=vm.errorsitproetudiantboursier controle=vm.controle index=vm.index></cnaf-cct-situationpro-etudiant-boursier></div></div><div class=col-sm-12 ng-if=\"!vm.controle.agesup29 && vm.data.sitPros[vm.index].boursier === 'Oui'\"><div class=row><cnaf-cct-situationpro-etudiant-boursier-organisme autocompletion=vm.autocompletion data=vm.data sitproetudiantboursierorganismeform=vm.situationprostagiaireform errorsitproetudiantboursierorganisme=vm.errorsitproetudiantboursierorganisme controle=vm.controle index=vm.index></cnaf-cct-situationpro-etudiant-boursier-organisme></div></div></div></div><div class=row ng-if=\"vm.controle.contexte === 'nonEtudiant' || (vm.controle.contexte === 'etudiant' && vm.data.sitPros[vm.index].isEtu === 'Non') || (vm.controle.contexte === 'arriveeRetourCjt' && vm.data.sitPros[vm.index].isEtu === 'Non')\"><div class=col-sm-8><label class=label-form-cnaf for=dateActiviteStagiaire>Depuis le</label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                                (vm.situationprostagiaireform.dateActiviteStagiaire.$invalid\n" +
    "                                && !vm.situationprostagiaireform.dateActiviteStagiaire.$pristine)\n" +
    "                            }\"><div class=\"form-group input-group\" id=divDateActiviteStagiaire><input id=dateActiviteStagiaire name=dateActiviteStagiaire title=jj/mm/aaaa placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActiviteStagiaire class=form-control ui-validate=\"{controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                                controleSupDernJourMoisSuivDem  : 'vm.controleSupDernJourMoisSuivDem($value, vm.controle.dernJourMoisSuivDem, vm.index)',\n" +
    "                                                controleDateSitProSitfamCouple  : 'vm.controleDateSitProSitfamCouple($value, vm.controle, vm.index)'\n" +
    "                                        }\" aria-describedby=\"\n" +
    "                                    situationprostagiaireInfoDateActiviteStagiaire\n" +
    "                                    situationprostagiaireErreurDateActiviteStagiaireRequired\n" +
    "                                    situationprostagiaireErreurDateActiviteStagiairePattern\n" +
    "                                    situationprostagiaireErreurControleInfDateNaissance\n" +
    "                                    situationprostagiaireErreurControleSupDernJourMoisSuivDem\n" +
    "                                    situationprostagiaireErreurControleDateSitProSitfamCouple\" ng-required=true pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActiviteStagiaire start-year=1980 pattern-cnaf=dd/MM/yyyy inputname=dateActiviteStagiaire></cnaf-date-picker></div></div><p id=situationprostagiaireInfoDateActiviteStagiaire class=sr-only>Champ Obligatoire</p><cnaf-cct-erreur-input iderreur=situationprostagiaireErreurDateActiviteStagiaireRequired condition=\"{{!vm.situationprostagiaireform.dateActiviteStagiaire.$pristine && vm.situationprostagiaireform.dateActiviteStagiaire.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprostagiaireErreurDateActiviteStagiairePattern condition=\"{{vm.situationprostagiaireform.dateActiviteStagiaire.$error.pattern \n" +
    "                                                        && vm.data.sitPros[vm.index].dateActiviteStagiaire\n" +
    "                                                        && vm.data.sitPros[vm.index].dateActiviteStagiaire.length === 10\n" +
    "                                                        && vm.data.sitPros[vm.index].dateActiviteStagiaire !== 'jj/mm/aaaa'}}\" message=\"Format de date invalide, la saisie doit contenir 10 caractères et être au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprostagiaireErreurControleInfDateNaissance condition=\"{{!vm.situationprostagiaireform.dateActiviteStagiaire.$error.required\n" +
    "                                                    && vm.data.sitPros[vm.index].dateActiviteStagiaire !=='jj/mm/aaaa'\n" +
    "                                                    && !vm.situationprostagiaireform.dateActiviteStagiaire.$error.pattern \n" +
    "                                                    && vm.situationprostagiaireform.dateActiviteStagiaire.$error.controleInfDateNaissance}}\" message=\"La date saisie ne peut être inférieure à la date de naissance ({{vm.controle.datenaissance | date:'dd/MM/yyyy'}}).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprostagiaireErreurControleSupDernJourMoisSuivDem condition=\"{{!vm.situationprostagiaireform.dateActiviteStagiaire.$error.required\n" +
    "                                            && vm.data.sitPros[vm.index].dateActiviteStagiaire !=='jj/mm/aaaa'\n" +
    "                                            && !vm.situationprostagiaireform.dateActiviteStagiaire.$error.pattern\n" +
    "                                            && vm.situationprostagiaireform.dateActiviteStagiaire.$error.controleSupDernJourMoisSuivDem}}\" message=\"La date saisie ne peut être postérieure à la date du {{vm.controle.dernJourMoisSuivDem | date:'dd/MM/yyyy'}}\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprostagiaireErreurControleDateSitProSitfamCouple condition=\"{{!vm.situationprostagiaireform.dateActiviteStagiaire.$error.required\n" +
    "                                            && vm.data.sitPros[vm.index].dateActiviteStagiaire !=='jj/mm/aaaa'\n" +
    "                                            && !vm.situationprostagiaireform.dateActiviteStagiaire.$error.pattern\n" +
    "                                            && vm.controle.contexte === 'arriveeRetourCjt'\n" +
    "                                            && vm.situationprostagiaireform.dateActiviteStagiaire.$error.controleDateSitProSitfamCouple}}\" message=\"Vous devez saisir une date d'activité antérieure au {{vm.controle.dateSitfam | date:'dd/MM/yyyy'}}\"></cnaf-cct-erreur-input></div><div class=col-sm-12><fieldset><legend class=label-form-cnaf for=indemnise>Le stage est indemnisé</legend><div class=\"row form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                                        (vm.situationprostagiaireform.indemnise.$invalid\n" +
    "                                        && !vm.situationprostagiaireform.indemnise.$pristine)\n" +
    "                                        }\"><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].indemnise ng-change=\"vm.data.sitPros[vm.index].regimeIndemnisation=undefined;\" uib-btn-radio=true for=indemniseOui{{vm.index}}><input type=radio name=indemnise class=sr-only id=indemniseOui ng-model=vm.data.sitPros[vm.index].indemnise aria-describedby=\"\n" +
    "                                        situationprostagiaireInfoInputIndemnise\n" +
    "                                        situationprostagiaireErreurInputIndemniseRequired\" value=oui required> <span>Oui</span></label></div><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].indemnise ng-change=\"vm.data.sitPros[vm.index].regimeIndemnisation=undefined;\" uib-btn-radio=false for=indemniseNon{{vm.index}}><input type=radio name=indemnise class=sr-only id=indemniseNon ng-model=vm.data.sitPros[vm.index].indemnise aria-describedby=\"\n" +
    "                                        situationprostagiaireInfoInputIndemnise\n" +
    "                                        situationprostagiaireErreurInputIndemniseRequired\" value=non required> <span>Non</span></label></div><div class=col-sm-12><p id=situationprostagiaireInfoInputIndemnise class=sr-only>Vous devez choisir une réponse.</p><cnaf-cct-erreur-input iderreur=situationprostagiaireErreurInputIndemniseRequired condition=\"{{vm.situationprostagiaireform.indemnise.$invalid\n" +
    "                                                        && !vm.situationprostagiaireform.indemnise.$pristine}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></div></div></fieldset></div><div class=row ng-if=vm.data.sitPros[vm.index].indemnise><div class=col-sm-12><fieldset><legend class=label-form-cnaf for=regimeIndemnisation>Indemnisé par</legend><div class=\"row form-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                                        (vm.situationprostagiaireform.regimeIndemnisation.$invalid\n" +
    "                                        && !vm.situationprostagiaireform.regimeIndemnisation.$pristine)\n" +
    "                                    }\"><div class=col-sm-4 ng-repeat=\"regimeInd in vm.listeRegimeIndemnisation\"><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].regimeIndemnisation title=\"Préciser le régime d'indemnisation. Une sélection est obligatoire.\" uib-btn-radio={{regimeInd}} for=pole><input type=radio name=regimeIndemnisation class=sr-only id=pole ng-model=vm.data.sitPros[vm.index].regimeIndemnisation aria-describedby=\"situationprostagiaireInfoInputRegimeIndemnisation\n" +
    "                                        situationprostagiaireErreurInputRegimeIndemnisationRequired\" required> <span>{{regimeInd.libelle}}</span></label></div></div><div class=col-sm-12><p id=situationprostagiaireInfoInputRegimeIndemnisation class=sr-only>Vous devez choisir une réponse.</p><cnaf-cct-erreur-input iderreur=situationprostagiaireErreurInputRegimeIndemnisationRequired condition=\"{{vm.situationprostagiaireform.regimeIndemnisation.$invalid\n" +
    "                                                        && !vm.situationprostagiaireform.regimeIndemnisation.$pristine}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></div></fieldset></div></div></div></div><div class=row><div class=col-sm-12><cnaf-cct-situationpro-cotis-employeur data=vm.data cotisemployeurform=vm.situationprostagiaireform errorcotisemployeur=vm.errorcotisemployeur controle=vm.controle index=vm.index></cnaf-cct-situationpro-cotis-employeur></div></div></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-chomage/cnaf-cct-situationpro-chomage.html","<div ng-init=vm.init()><div class=row><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateActiviteChomage>Depuis le</label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                            ((vm.chomageform.dateActiviteChomage.$invalid\n" +
    "                                 && (!vm.chomageform.dateActiviteChomage.$pristine \n" +
    "                                    || vm.chomageform.dateActiviteChomage.$touched))\n" +
    "                            || ((vm.chomageform.dateActiviteChomage.$error.pattern\n" +
    "                                 || vm.chomageform.dateActiviteChomage.$error.controleSupDernJourMoisSuivDem\n" +
    "                                 || vm.chomageform.dateActiviteChomage.$error.controleInfDateNaissance\n" +
    "                                 ||  (vm.controle.contexte === 'arriveeRetourCjt' && vm.chomageform.dateActiviteChomage.$error.controleDateSitProSitfamCouple))\n" +
    "                                    && vm.data.sitPros[vm.index].dateActiviteChomage\n" +
    "                                    && vm.data.sitPros[vm.index].dateActiviteChomage.length == 10\n" +
    "                                    && vm.data.sitPros[vm.index].dateActiviteChomage !== 'jj/mm/aaaa'))\n" +
    "                        }\"><div class=\"form-group input-group\" id=divdateActiviteChomage><input id=dateActiviteChomage name=dateActiviteChomage title=\"Saisie de la date de début de chômage. Champ obligatoire. Au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010)\" placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model-options=\"{ updateOn: 'change'}\" ng-model=vm.data.sitPros[vm.index].dateActiviteChomage ng-change=vm.initHeuresCPL() ng-blur=vm.initHeuresCPL() class=form-control ui-validate=\"{controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                            controleSupDernJourMoisSuivDem  : 'vm.controleSupDernJourMoisSuivDem($value, vm.controle.dernJourMoisSuivDem, vm.index)',\n" +
    "                                            controleDateSitProSitfamCouple  : 'vm.controleDateSitProSitfamCouple($value, vm.controle, vm.index)'\n" +
    "                                    }\" required aria-describedby=\"\n" +
    "                                    dateActiviteChomageInfoRequired\n" +
    "                                    dateActiviteChomageErreurRequired\n" +
    "                                    dateActiviteChomagePattern\n" +
    "                                    controleInfDateNaissance\n" +
    "                                    controleSupDernJourMoisSuivDem\n" +
    "                                    dateActiviteChomageErreurControleDateSitProSitfamCouple\" pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActiviteChomage ng-change=vm.initHeuresCPL() ng-blur=vm.initHeuresCPL() start-year=1980 pattern-cnaf=dd/MM/yyyy inputname=dateActiviteChomage></cnaf-date-picker></div></div></div></div><div id=dateActiviteChomageInfoRequired class=sr-only><p>Champ Obligatoire</p></div><cnaf-cct-erreur-input iderreur=dateActiviteChomageErreurRequired condition=\"{{(!vm.chomageform.dateActiviteChomage.$pristine || vm.chomageform.dateActiviteChomage.$touched) \n" +
    "                                                && vm.chomageform.dateActiviteChomage.$error.required}}\" message=\"Champ obligatoire.\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=dateActiviteChomagePattern condition=\"{{vm.chomageform.dateActiviteChomage.$error.pattern \n" +
    "                                            && vm.data.sitPros[vm.index].dateActiviteChomage\n" +
    "                                            && vm.data.sitPros[vm.index].dateActiviteChomage.length === 10\n" +
    "                                            && vm.data.sitPros[vm.index].dateActiviteChomage !== 'jj/mm/aaaa'}}\" message=\"Format de date invalide, la saisie doit contenir 10 caractères et être au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=controleInfDateNaissance condition=\"{{!vm.chomageform.dateActiviteChomage.$error.required\n" +
    "                                && vm.data.sitPros[vm.index].dateActiviteChomage !== 'jj/mm/aaaa'\n" +
    "                                && !vm.chomageform.dateActiviteChomage.$error.pattern && vm.chomageform.dateActiviteChomage.$error.controleInfDateNaissance}}\" message=\"La date saisie ne peut être inférieure à la date de naissance ({{vm.controle.datenaissance | date:'dd/MM/yyyy'}}).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=controleSupDernJourMoisSuivDem condition=\"{{!vm.chomageform.dateActiviteChomage.$error.required\n" +
    "                                && vm.data.sitPros[vm.index].dateActiviteChomage !== 'jj/mm/aaaa'\n" +
    "                                && !vm.chomageform.dateActiviteChomage.$error.pattern && vm.chomageform.dateActiviteChomage.$error.controleSupDernJourMoisSuivDem}}\" message=\"La date saisie ne peut être postérieure à la date du {{vm.controle.dernJourMoisSuivDem | date:'dd/MM/yyyy'}}\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=dateActiviteChomageErreurControleDateSitProSitfamCouple condition=\"{{!vm.chomageform.dateActiviteChomage.$error.required\n" +
    "                                && vm.data.sitPros[vm.index].dateActiviteChomage !== 'jj/mm/aaaa'\n" +
    "                                && !vm.chomageform.dateActiviteChomage.$error.pattern\n" +
    "                                && vm.controle.contexte === 'arriveeRetourCjt'\n" +
    "                                && vm.chomageform.dateActiviteChomage.$error.controleDateSitProSitfamCouple}}\" message=\"Vous devez saisir une date d'activité antérieure au {{vm.controle.dateSitfam | date:'dd/MM/yyyy'}}\"></cnaf-cct-erreur-input><fieldset><legend class=\"label-form-cnaf control-label\" for=chomagePartiel ng-if=!vm.controle.encouple>Vous êtes au chômage partiel</legend><legend class=\"label-form-cnaf control-label\" for=chomagePartiel ng-if=vm.controle.encouple>{{vm.controle.libPersonneEnCours}} est au chômage partiel</legend><div class=\"row form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' : vm.chomageform.chomagePartiel.$invalid \n" +
    "                                        && (!vm.chomageform.chomagePartiel.$pristine\n" +
    "                                            || vm.chomageform.chomagePartiel.$touched) }\"><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].chomagePartiel uib-btn-radio=true title=\"Indiquer si vous êtes au chômage partiel. Une sélection est obligatoire.\" for=chomagePartielOui{{vm.index}} ng-change=vm.initHeuresCPL()>Oui</label><input type=radio name=chomagePartiel class=sr-only id=chomagePartielOui{{vm.index}} ng-model=vm.data.sitPros[vm.index].chomagePartiel ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"\n" +
    "                            chomagePartielInfoRequired\n" +
    "                            chomagePartielErreurRequired\" value=true required></div><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].chomagePartiel uib-btn-radio=false title=\"Indiquer si vous êtes au chômage partiel. Une sélection est obligatoire.\" for=chomagePartielNon{{vm.index}} ng-change=vm.initHeuresCPL()>Non</label><input type=radio name=chomagePartiel class=sr-only id=chomagePartielNon{{vm.index}} ng-model=vm.data.sitPros[vm.index].chomagePartiel ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"\n" +
    "                            chomagePartielInfoRequired\n" +
    "                            chomagePartielErreurRequired\" value=false required></div></div><div id=chomagePartielInfoRequired class=sr-only><p>Vous devez obligatoirement indiquer si vous êtes au chômage partiel.</p></div><cnaf-cct-erreur-input iderreur=chomagePartielErreurRequired condition=\"{{(!vm.chomageform.chomagePartiel.$pristine || vm.chomageform.chomagePartiel.$touched)\n" +
    "                                                 && vm.chomageform.chomagePartiel.$error.required}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></fieldset><div ng-if=\"vm.data.sitPros[vm.index].chomagePartiel !== undefined && vm.data.sitPros[vm.index].chomagePartiel == false\"><div ng-if=vm.controle.isLogementAccession><cnaf-cct-situationpro-assurance-pret data=vm.data assurancepretform=chomageform vm.errorassurancepret=vm.errorassurancepret controle=vm.controle index=vm.index></cnaf-cct-situationpro-assurance-pret></div><label class=\"label-form-cnaf control-label\" for=orgInscription>{{vm.controle.libellePersonneChomage}}</label><div class=\"row form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                        vm.chomageform.orgInscription.$invalid\n" +
    "                        && (!vm.chomageform.orgInscription.$pristine\n" +
    "                            || vm.chomageform.orgInscription.$touched)\n" +
    "                \n" +
    "                }\"><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].orgInscription title=\"Indiquer l'organisme auprès duquel vous êtes inscrit. Une sélection est obligatoire.\" uib-btn-radio=vm.listeOrgInscription[0] for=poleemploi><input type=radio name=orgInscription class=sr-only id=poleemploi ng-model=vm.data.sitPros[vm.index].orgInscription ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"\n" +
    "                                orgInscriptionInfoRequired\n" +
    "                                orgInscriptionErreurRequired\" required> <span>{{vm.listeOrgInscription[0].libelle}}</span></label></div><div class=col-sm-4><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].orgInscription title=\"Indiquer l'organisme auprès duquel vous êtes inscrit. Une sélection est obligatoire.\" uib-btn-radio=vm.listeOrgInscription[1] for=autreorg><input type=radio name=orgInscription class=sr-only id=autreorg ng-model=vm.data.sitPros[vm.index].orgInscription ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"\n" +
    "                                orgInscriptionInfoRequired\n" +
    "                                orgInscriptionErreurRequired\" required> <span>{{vm.listeOrgInscription[1].libelle}}</span></label></div></div><div id=orgInscriptionInfoRequired class=sr-only><p>Vous devez obligatoirement indiquer l'organisme auprès duquel vous êtes inscrit.</p></div><cnaf-cct-erreur-input iderreur=orgInscriptionErreurRequired condition=\"{{(!vm.chomageform.orgInscription.$pristine || vm.chomageform.orgInscription.$touched)\n" +
    "                                    && vm.chomageform.orgInscription.$error.required}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input><div class=row ng-if=\"vm.data.sitPros[vm.index].orgInscription && vm.data.sitPros[vm.index].orgInscription.libelle == vm.listeOrgInscription[1].libelle\"><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=nomOrganisme>Nom de l'organisme</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                            vm.chomageform.nomOrganisme.$invalid \n" +
    "                                    && (!vm.chomageform.nomOrganisme.$pristine\n" +
    "                                        || vm.chomageform.nomOrganisme.$touched)\n" +
    "                        \n" +
    "                        }\"><input id=nomOrganisme maxlength=25 title=\"Saisisser le nom de l'organisme auprès duquel vous êtes inscrit. Champ obligatoire.\" ng-model=vm.data.sitPros[vm.index].nomOrganisme ng-change=\"vm.data.sitPros[vm.index].nomOrganisme = vm.data.sitPros[vm.index].nomOrganisme.toUpperCase()\" ng-pattern=\"/^[0-9a-zA-Zà-ÿÀ-Ÿ '-]*$/\" ng-blur=vm.testType8(vm.data.sitPros[vm.index].nomOrganisme,vm.chomageform.nomOrganisme) ng-trim=false name=nomOrganisme class=form-control aria-describedby=\"\n" +
    "                                    nomOrganismeInfoRequired\n" +
    "                                    nomOrganismeErreurRequired\n" +
    "                                    nomOrganismePattern\" required></div></div></div><div id=nomOrganismeInfoRequired class=sr-only><p>Vous devez obligatoirement saisir l'adresse' de l'organisme qui a accordé la bourse</p></div><cnaf-cct-erreur-input iderreur=nomOrganismeErreurRequired condition=\"{{(!vm.chomageform.nomOrganisme.$pristine || vm.chomageform.nomOrganisme.$touched)\n" +
    "                                                && vm.chomageform.nomOrganisme.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=nomOrganismePattern condition=\"{{vm.chomageform.nomOrganisme.$error.pattern || vm.chomageform.nomOrganisme.$error.type8}}\" message=\"La saisie comporte des caractères non autorisés\"></cnaf-cct-erreur-input></div><div ng-if=vm.data.sitPros[vm.index].chomagePartiel><p class=\"texte-info-cnaf text-primary\"><img alt=\"\" src=/icfstatiquesangularappli/dist/images/InformationsGris.png> <em>Les informations que vous allez déclarer seront contrôlées par votre Caf. Vérifiez à l’aide de vos bulletins de salaire qu’elles sont correctes.</em></p><div ng-repeat=\"heureCPL in vm.heuresCPL track by $index\"><label class=\"label-form-cnaf control-label\" for=heuresCPL{{$index}}>Nombre d'heures de chômage partiel en {{heureCPL.mois}}</label><div class=\"row form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                        vm.chomageform.heuresCPL{{$index}}.$invalid\n" +
    "                        && (!vm.chomageform.heuresCPL{{$index}}.$pristine\n" +
    "                            || vm.chomageform.heuresCPL{{$index}}.$touched)  \n" +
    "                        }\"><div class=col-sm-8><input id=heuresCPL{{$index}} name=heuresCPL{{$index}} title=\"Nombre en chiffres des heures de chômage partiel en {{heureCPL.mois}}\" ui-mask=9?9?9? placeholder=\"   \" ui-options={allowInvalidValue:false,clearOnBlur:false} model-view-value=false ng-model=vm.heuresCPL[$index].heures ng-blur=vm.blurHeuresCPL($index) class=form-control aria-describedby=\"\n" +
    "                                    heuresCPLInfoRequired{{$index}}\n" +
    "                                    heuresCPLErreurRequired{{$index}}\" required></div></div><div id=heuresCPLInfoRequired{{$index}} class=sr-only><p>Vous devez obligatoirement saisir un nombre d'heures</p></div><cnaf-cct-erreur-input iderreur=heuresCPLErreurRequired{{$index}} condition=\"{{(!vm.chomageform['heuresCPL'+$index].$pristine || vm.chomageform['heuresCPL'+$index].$touched)\n" +
    "                                        && vm.chomageform['heuresCPL'+$index].$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input></div><fieldset ng-if=vm.askForMoisEnCoursCPL()><legend class=\"label-form-cnaf control-label\" for=toujoursChomagePartiel><span ng-if=!vm.controle.encouple>Vous êtes ou avez été au chômage partiel ce mois</span> <span ng-if=vm.controle.encouple>{{vm.controle.libPersonneEnCours}} est ou a été au chômage partiel ce mois</span></legend><div class=\"row form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' : \n" +
    "                            vm.chomageform.toujoursChomagePartiel.$invalid \n" +
    "                            && (!vm.chomageform.toujoursChomagePartiel.$pristine\n" +
    "                                || vm.chomageform.toujoursChomagePartiel.$touched)\n" +
    "                            }\"><div class=col-sm-2><label class=\"btn btn-default btn-block\" title=\"Indiquer si vous êtes toujours au chômage partiel. Une sélection est obligatoire.\" ng-model=vm.data.sitPros[vm.index].toujoursChomagePartiel uib-btn-radio=true for=toujoursChomagePartielOui{{vm.index}}>Oui</label><input type=radio name=toujoursChomagePartiel class=sr-only id=toujoursChomagePartielOui{{vm.index}} ng-model=vm.data.sitPros[vm.index].toujoursChomagePartiel ng-model-options=\"{ updateOn: 'blur'}\" value=true aria-describedby=\"\n" +
    "                            toujoursChomagePartielInfoRequired\n" +
    "                            toujoursChomagePartielErreurRequired\" required></div><div class=col-sm-2><label class=\"btn btn-default btn-block\" title=\"Indiquer si vous êtes toujours au chômage partiel. Une sélection est obligatoire.\" ng-model=vm.data.sitPros[vm.index].toujoursChomagePartiel uib-btn-radio=false for=toujoursChomagePartielNon{{vm.index}}>Non</label><input type=radio name=toujoursChomagePartiel class=sr-only id=toujoursChomagePartielNon{{vm.index}} ng-model=vm.data.sitPros[vm.index].toujoursChomagePartiel ng-model-options=\"{ updateOn: 'blur'}\" value=false aria-describedby=\"\n" +
    "                            toujoursChomagePartielInfoRequired\n" +
    "                            toujoursChomagePartielErreurRequired\" required></div></div><div id=toujoursChomagePartielInfoRequired class=sr-only><p>Vous devez obligatoirement indiquer si vous êtes toujours au chômage partiel.</p></div><cnaf-cct-erreur-input iderreur=toujoursChomagePartielErreurRequired condition=\"{{(!vm.chomageform.toujoursChomagePartiel.$pristine || vm.chomageform.toujoursChomagePartiel.$touched)\n" +
    "                                        && vm.chomageform.toujoursChomagePartiel.$error.required}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></fieldset></div></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-conges-divers/cnaf-cct-situationpro-conges-divers.html","<div ng-init=vm.init()><fieldset><legend class=label-form-cnaf>Préciser le type de congé</legend><div class=\"row form-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                            vm.congesdiversform.choixCongesDivers.$invalid\n" +
    "                            && (!vm.congesdiversform.choixCongesDivers.$pristine\n" +
    "                                || vm.congesdiversform.choixCongesDivers.$touched)\n" +
    "                \n" +
    "                }\"><div class=col-sm-4 ng-repeat=\"conges in vm.listeChoixCongesDivers\"><label ng-class=\"{'align-middle-cnaf' : conges.libelle.length < 18}\" class=\"btn btn-default cct-btn-block-probleme-hauteur\" ng-model=vm.data.sitPros[vm.index].choixCongesDivers uib-btn-radio=conges title=\"Préciser le type de congé. Une sélection est obligatoire.\" for={{conges.code}}><input type=radio name=choixCongesDivers class=sr-only aria-describedby=\"\n" +
    "                                    congesdiversInfochoixCongesDiversRequired \n" +
    "                                    congesdiversErreurchoixCongesDiversRequired\" id={{conges.code}} value={{conges.code}} ng-model=vm.data.sitPros[vm.index].choixCongesDivers ng-model-options=\"{ updateOn: 'blur'}\" required> {{conges.libelle}}</label></div></div><div id=congesdiversInfochoixCongesDiversRequired class=sr-only><p>Vous devez obligatoirement choisir une situation parmi celles proposées.</p></div><cnaf-cct-erreur-input iderreur=congesdiversErreurchoixCongesDiversRequired condition=\"{{(!vm.congesdiversform.choixCongesDivers.$pristine || vm.congesdiversform.choixCongesDivers.$touched)\n" +
    "                                             && vm.congesdiversform.choixCongesDivers.$error.required}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></fieldset><div ng-if=vm.data.sitPros[vm.index].choixCongesDivers><fieldset><legend class=sr-only>Date de début et de fin de congés</legend><div class=row><div class=col-sm-4><label class=\"label-form-cnaf control-label\" for=dateActiviteConges>Date de début du congé</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                            ((vm.congesdiversform.dateActiviteConges.$invalid \n" +
    "                                && (!vm.congesdiversform.dateActiviteConges.$pristine\n" +
    "                                    || vm.congesdiversform.dateActiviteConges.$touched))\n" +
    "                            || ((vm.congesdiversform.dateActiviteConges.$error.pattern\n" +
    "                                || vm.congesdiversform.dateActiviteConges.$error.controleSupDernJourMoisSuivDem\n" +
    "                                || vm.congesdiversform.dateActiviteConges.$error.controleInfDateNaissance\n" +
    "                                ||  (vm.controle.contexte === 'arriveeRetourCjt' && vm.congesdiversform.dateActiviteConges.$error.controleDateSitProSitfamCouple))\n" +
    "                                && vm.data.sitPros[vm.index].dateActiviteConges\n" +
    "                                && vm.data.sitPros[vm.index].dateActiviteConges.length == 10\n" +
    "                                && vm.data.sitPros[vm.index].dateActiviteConges !== 'jj/mm/aaaa'))\n" +
    "                           }\"><div class=input-group><input id=dateActiviteConges name=dateActiviteConges title=\"Saisie de la date de début d'activité. Champ obligatoire. Au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010)\" placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActiviteConges ng-model-options=\"{ updateOn: 'change'}\" class=form-control ui-validate=\"{\n" +
    "                                        controleInfDateNaissance : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                        controleSupDernJourMoisSuivDem  : 'vm.controleSupDernJourMoisSuivDem($value, vm.controle.dernJourMoisSuivDem, vm.index)',\n" +
    "                                        controleDateSitProSitfamCouple  : 'vm.controleDateSitProSitfamCouple($value, vm.controle, vm.index)'\n" +
    "                                    }\" aria-describedby=\"\n" +
    "                                        congesdiversInfodateActiviteCongesRequired\n" +
    "                                        congesdiversErreurdateActiviteCongesRequired\n" +
    "                                        congesdiversErreurdateActiviteCongesPattern\n" +
    "                                        congesdiversErreurControleInfDateNaissance\n" +
    "                                        congesdiversErreurControleSupDernJourMoisSuivDem\n" +
    "                                        congesdiversErreurControleDateSitProSitfamCouple\" required pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActiviteConges start-year=1980 pattern-cnaf=dd/MM/yyyy inputname=dateActiviteConges></cnaf-date-picker></div></div><div id=congesdiversInfodateActiviteCongesRequired class=sr-only><p>Champ Obligatoire</p></div><cnaf-cct-erreur-input iderreur=congesdiversErreurdateActiviteCongesRequired condition=\"{{(!vm.congesdiversform.dateActiviteConges.$pristine || vm.congesdiversform.dateActiviteConges.$touched)\n" +
    "                                                             && vm.congesdiversform.dateActiviteConges.$error.required}}\" message=\"Champ obligatoire.\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=congesdiversErreurdateActiviteCongesPattern condition=\"{{vm.congesdiversform.dateActiviteConges.$error.pattern \n" +
    "                                                            && vm.data.sitPros[vm.index].dateActiviteConges\n" +
    "                                                            && vm.data.sitPros[vm.index].dateActiviteConges.length === 10\n" +
    "                                                            && vm.data.sitPros[vm.index].dateActiviteConges !== 'jj/mm/aaaa'}}\" message=\"Format de date invalide, la saisie doit contenir 10 caractères et être au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=congesdiversErreurControleInfDateNaissance condition=\"{{!vm.congesdiversform.dateActiviteConges.$error.required\n" +
    "                                                && vm.data.sitPros[vm.index].dateActiviteConges !== 'jj/mm/aaaa'\n" +
    "                                                && !vm.congesdiversform.dateActiviteConges.$error.pattern && vm.congesdiversform.dateActiviteConges.$error.controleInfDateNaissance}}\" message=\"La date saisie ne peut être inférieure à la date de naissance ({{vm.controle.datenaissance | date:'dd/MM/yyyy'}}).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=congesdiversErreurControleSupDernJourMoisSuivDem condition=\"{{!vm.congesdiversform.dateActiviteConges.$error.required\n" +
    "                                                && vm.data.sitPros[vm.index].dateActiviteConges !== 'jj/mm/aaaa'\n" +
    "                                                && !vm.congesdiversform.dateActiviteConges.$error.pattern && vm.congesdiversform.dateActiviteConges.$error.controleSupDernJourMoisSuivDem}}\" message=\"La date saisie ne peut être postérieure à la date du {{vm.controle.dernJourMoisSuivDem | date:'dd/MM/yyyy'}}\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=congesdiversErreurControleDateSitProSitfamCouple condition=\"{{!vm.congesdiversform.dateActiviteConges.$error.required\n" +
    "                                                && vm.data.sitPros[vm.index].dateActiviteConges !== 'jj/mm/aaaa'\n" +
    "                                                && !vm.congesdiversform.dateActiviteConges.$error.pattern \n" +
    "                                                && vm.controle.contexte === 'arriveeRetourCjt'\n" +
    "                                                && vm.congesdiversform.dateActiviteConges.$error.controleDateSitProSitfamCouple}}\" message=\"Vous devez saisir une date d'activité antérieure au {{vm.controle.dateSitfam | date:'dd/MM/yyyy'}}\"></cnaf-cct-erreur-input></div><div class=col-sm-4 ng-if=\"vm.data.sitPros[vm.index].choixCongesDivers.code !== 'SAB'\"><label class=\"label-form-cnaf control-label\" for=dateFinActiviteConges>Date de fin du congé</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                                ((vm.congesdiversform.dateFinActiviteConges.$invalid\n" +
    "                                    && (!vm.congesdiversform.dateFinActiviteConges.$pristine\n" +
    "                                            || vm.congesdiversform.dateFinActiviteConges.$touched))\n" +
    "                                    || ((vm.congesdiversform.dateFinActiviteConges.$error.pattern\n" +
    "                                    || vm.congesdiversform.dateFinActiviteConges.$error.controleDateSup)\n" +
    "                                        && vm.data.sitPros[vm.index].dateFinActiviteConges\n" +
    "                                        && vm.data.sitPros[vm.index].dateFinActiviteConges.length == 10\n" +
    "                                        && vm.data.sitPros[vm.index].dateFinActiviteConges !== 'jj/mm/aaaa'))}\"><div class=input-group><input id=dateFinActiviteConges name=dateFinActiviteConges title=\"Saisie de la date de fin du congé. Champ obligatoire. Au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010)\" placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateFinActiviteConges class=form-control ui-validate=\"{ \n" +
    "                                        controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                        controleSupDateDeb  : 'vm.controleSupDateDeb($value, vm.data.sitPros[vm.index].dateActiviteConges)'\n" +
    "                                            }\" ui-validate-watch=\"'vm.data.sitPros[vm.index].dateActiviteConges'\" aria-describedby=\"\n" +
    "                                        congesdiversInfodateFinActiviteCongesRequired\n" +
    "                                        congesdiversErreurdateFinActiviteCongesRequired\n" +
    "                                        congesdiversErreurdateFinActiviteCongesPattern\n" +
    "                                        congesdiversErreurControleDateSup\" required pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateFinActiviteConges start-year=1980 end-year={{vm.datePickerEndYear}} pattern-cnaf=dd/MM/yyyy inputname=dateFinActiviteConges></cnaf-date-picker></div></div><div id=congesdiversInfodateFinActiviteCongesRequired class=sr-only><p>Champ Obligatoire</p></div><cnaf-cct-erreur-input iderreur=congesdiversErreurdateFinActiviteCongesRequired condition=\"{{(!vm.congesdiversform.dateFinActiviteConges.$pristine || vm.congesdiversform.dateFinActiviteConges.$touched) \n" +
    "                                                            && vm.congesdiversform.dateFinActiviteConges.$error.required}}\" message=\"Champ obligatoire.\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=congesdiversErreurdateFinActiviteCongesPattern condition=\"{{vm.congesdiversform.dateFinActiviteConges.$error.pattern \n" +
    "                                                            && vm.data.sitPros[vm.index].dateFinActiviteConges\n" +
    "                                                            && vm.data.sitPros[vm.index].dateFinActiviteConges.length === 10\n" +
    "                                                            && vm.data.sitPros[vm.index].dateFinActiviteConges !== 'jj/mm/aaaa'}}\" message=\"Format de date invalide, la saisie doit contenir 10 caractères et être au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=congesdiversErreurControleDateSup condition=\"{{vm.data.sitPros[vm.index].dateActiviteConges !== undefined\n" +
    "                                                && vm.data.sitPros[vm.index].dateFinActiviteConges !== 'jj/mm/aaaa'\n" +
    "                                                && !vm.congesdiversform.dateFinActiviteConges.$error.pattern && vm.congesdiversform.dateFinActiviteConges.$error.controleDateSup}}\" message=\"La date de fin doit être postérieure à la date de début.\"></cnaf-cct-erreur-input></div></div></fieldset></div><cnaf-cct-situationpro-cotis-employeur data=vm.data cotisemployeurform=vm.congesdiversform errorcotisemployeur=vm.errorcotisemployeur controle=vm.controle index=vm.index></cnaf-cct-situationpro-cotis-employeur></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-cotis-employeur/cnaf-cct-situationpro-cotis-employeur.html","<div ng-init=vm.init()><fieldset><legend class=label-form-cnaf>{{vm.controle.libCotisEmployeur}}</legend><div class=\"row form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                        vm.cotisemployeurform.cotisEmployeur.$invalid\n" +
    "                            && (!vm.cotisemployeurform.cotisEmployeur.$pristine\n" +
    "                                    || vm.cotisemployeurform.cotisEmployeur.$touched)\n" +
    "                        }\"><div class=\"col-sm-6 col-md-3\" ng-repeat=\"choixCotis in vm.listeRegimeCotisation\"><span ng-if=\"choixCotis.code === 'GE' && vm.affichePopupGe(vm.index)\" class=pull-right><cnaf-aide tabindex=0 data-toggle=popover data-id-content-cnaf=popover-ge data-container=body data-trigger=manual></span><span ng-if=\"choixCotis.code === 'UI' && vm.affichePopupSsi(vm.index)\" class=pull-right><cnaf-aide tabindex=0 data-toggle=popover data-id-content-cnaf=popover-ssi data-container=body data-trigger=manual></span><span ng-if=\"choixCotis.code === 'AG' && vm.affichePopupMsa(vm.index)\" class=pull-right><cnaf-aide tabindex=0 data-toggle=popover data-id-content-cnaf=popover-msa data-container=body data-trigger=manual></span><span ng-if=\"choixCotis.code === 'CS'\" class=pull-right><cnaf-aide tabindex=0 data-toggle=popover data-id-content-cnaf=popover-cssm data-container=body data-trigger=manual></span><label ng-class=\"{'align-middle-cnaf' : choixCotis.libelle.length < 38}\" class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].cotisEmployeur ng-change=vm.deleteChoixCotisEmployeur() uib-btn-radio=choixCotis title=\"Préciser l'organisme. Une sélection est obligatoire.\" for={{choixCotis.code}}>{{choixCotis.libelle}}</label><input type=radio name=cotisEmployeur class=sr-only aria-describedby=\"\n" +
    "                            cotisemployeurInfochoixcotisEmployeurRequired \n" +
    "                            cotisemployeurErreurchoixcotisEmployeurRequired\" id={{choixCotis.code}} value={{choixCotis.code}} ng-model=vm.data.sitPros[vm.index].cotisEmployeur ng-model-options=\"{ updateOn: 'blur'}\" required><div ng-if=\"choixCotis.code === 'GE' && vm.affichePopupGe(vm.index)\" class=hidden id=popover-ge>Carsat (ex Cram), Caisse des dépôts, Sécurité sociale des indépendants, Cnro, Sncf<div class=popover-btn-close-cnaf></div></div><div ng-if=\"choixCotis.code === 'UI' && vm.affichePopupSsi(vm.index)\" class=hidden id=popover-ssi>Sécurité Sociale des Indépendants<div class=popover-btn-close-cnaf></div></div><div ng-if=\"choixCotis.code === 'AG' && vm.affichePopupMsa(vm.index)\" class=hidden id=popover-msa>Mutuelle Sociale Agricole<div class=popover-btn-close-cnaf></div></div><div ng-if=\"choixCotis.code === 'CS' \" class=hidden id=popover-cssm>Caisse de Sécurité Sociale de Mayotte<div class=popover-btn-close-cnaf></div></div></div></div><div id=cotisemployeurInfochoixcotisEmployeurRequired class=sr-only><p>Vous devez obligatoirement faire une sélection parmi celles proposées.</p></div><cnaf-cct-erreur-input iderreur=cotisemployeurErreurchoixcotisEmployeurRequired condition=\"{{(!vm.cotisemployeurform.cotisEmployeur.$pristine || vm.cotisemployeurform.cotisEmployeur.$touched)\n" +
    "                                                && vm.cotisemployeurform.cotisEmployeur.$error.required}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input><div ng-if=vm.afficheInfoMSA(vm.index)><p class=texte-info-cnaf><img alt=Informations src=/icfstatiquesangularappli/dist/images/InformationsGris.png> <em>Suite a votre déclaration, votre dossier va être transféré à la MSA</em></p></div></fieldset><div ng-if=vm.afficheAutreRegime(vm.index)><fieldset><legend class=label-form-cnaf>{{vm.controle.libAutreRegime}}</legend><div class=\"row form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                            vm.cotisemployeurform.choixAutRegSal.$invalid\n" +
    "                                && (!vm.cotisemployeurform.choixAutRegSal.$pristine\n" +
    "                                        || vm.cotisemployeurform.choixAutRegSal.$touched)\n" +
    "                        }\"><div class=col-md-6 ng-repeat=\"itAutRegSal in vm.listeChoixAutRegSal\"><label ng-class=\"{'align-middle-cnaf' : itAutRegSal.libelle.length < 40}\" class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixAutRegSal ng-change=\"vm.data.sitPros[vm.index].choixPosteFonct=null;\" uib-btn-radio=itAutRegSal title=\"Choisissez la situation correspondante. Une sélection est obligatoire.\" for={{itAutRegSal.code}}>{{itAutRegSal.libelle}}</label><input type=radio name=choixAutRegSal class=sr-only id={{itAutRegSal.code}} value={{itAutRegSal.code}} ng-model=vm.data.sitPros[vm.index].choixAutRegSal ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"cotisemployeurInfochoixAutRegSalRequired \n" +
    "                                                cotisemployeurErreurchoixAutRegSalRequired\" required></div></div><div id=cotisemployeurInfochoixAutRegSalRequired class=sr-only><p>Vous devez obligatoirement faire un choix parmi ceux proposés.</p></div><cnaf-cct-erreur-input iderreur=cotisemployeurErreurchoixAutRegSalRequired condition=\"{{(!vm.cotisemployeurform.choixAutRegSal.$pristine || vm.cotisemployeurform.choixAutRegSal.$touched)\n" +
    "                                                     && vm.cotisemployeurform.choixAutRegSal.$error.required}}\" message=\"Sélection obligatoire\"></cnaf-cct-erreur-input></fieldset><div ng-if=\"vm.data.sitPros[vm.index].choixAutRegSal.code === 'FO' && vm.controle.encouple\"><fieldset><legend class=label-form-cnaf for=choixPosteFonct>{{vm.controle.libPersonneEnCours}} est en poste</legend><div class=\"row form-group btn-block\" data-toggle=buttons ng-class=\"{ 'has-error' :\n" +
    "                            vm.cotisemployeurform.choixPosteFonct.$invalid\n" +
    "                            && (!vm.cotisemployeurform.choixPosteFonct.$pristine\n" +
    "                                    || vm.cotisemployeurform.choixPosteFonct.$touched)\n" +
    "                        }\"><div class=col-md-6 ng-repeat=\"itChoixPosteFonct in vm.listeChoixPosteFonct\"><label ng-class=\"{'align-middle-cnaf' : itChoixPosteFonct.libelle.length < 40}\" class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixPosteFonct uib-btn-radio=itChoixPosteFonct title=\"Choisissez l'endroit où {{vm.controle.libPersonneEnCours}} est en poste'. Une sélection est obligatoire.\" for={{itChoixPosteFonct.code}}>{{itChoixPosteFonct.libelle}}</label><input type=radio name=choixPosteFonct class=sr-only id={{itChoixPosteFonct.code}} value={{itChoixPosteFonct.code}} ng-model=vm.data.sitPros[vm.index].choixPosteFonct ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"cotisemployeurInfochoixPosteFonctRequired \n" +
    "                                                    cotisemployeurErreurchoixPosteFonctRequired\" required></div></div><div id=cotisemployeurInfochoixPosteFonctRequired class=sr-only><p>Vous devez obligatoirement effectuer une sélection parmi celles proposées.</p></div><cnaf-cct-erreur-input iderreur=cotisemployeurErreurchoixPosteFonctRequired condition=\"{{(!vm.cotisemployeurform.choixPosteFonct.$pristine  || vm.cotisemployeurform.choixPosteFonct.$touched)\n" +
    "                                                         && vm.cotisemployeurform.choixPosteFonct.$error.required}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></fieldset></div></div><div ng-if=vm.afficheNomOrganisme(vm.index)><label class=\"label-form-cnaf control-label\" for=nomOrganisme>Nom de l'organisme</label><div class=\"row form-group\" ng-class=\"{ 'has-error' :\n" +
    "                        vm.cotisemployeurform.nomOrganisme.$invalid \n" +
    "                            && (!vm.cotisemployeurform.nomOrganisme.$pristine\n" +
    "                                    || vm.cotisemployeurform.nomOrganisme.$touched)\n" +
    "                        }\"><div class=col-sm-4><input id=nomOrganisme maxlength=25 ng-model=vm.data.sitPros[vm.index].nomOrganisme ng-change=\"vm.data.sitPros[vm.index].nomOrganisme = vm.data.sitPros[vm.index].nomOrganisme.toUpperCase()\" ng-pattern=\"/^[0-9a-zA-Zà-ÿÀ-Ÿ '-]*$/\" ng-blur=\"vm.testType8(vm.data.sitPros[vm.index].nomOrganisme,vm.cotisemployeurform,'nomOrganisme')\" ng-trim=false name=nomOrganisme class=form-control ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"\n" +
    "                                    cotisemployeurInfonomOrganismeRequired\n" +
    "                                    cotisemployeurErreurnomOrganismeRequired\n" +
    "                                    cotisemployeurErreurnomOrganismePattern\" required></div></div><div id=cotisemployeurInfonomOrganismeRequired class=sr-only><p>Vous devez obligatoirement saisir l'adresse' de l'organisme qui a accordé la bourse</p></div><cnaf-cct-erreur-input iderreur=cotisemployeurErreurnomOrganismeRequired condition=\"{{(!vm.cotisemployeurform.nomOrganisme.$pristine || vm.cotisemployeurform.nomOrganisme.$touched)\n" +
    "                                                 && vm.cotisemployeurform.nomOrganisme.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=cotisemployeurErreurnomOrganismePattern condition=\"{{vm.cotisemployeurform.nomOrganisme.$error.pattern || vm.cotisemployeurform.nomOrganisme.$error.type8}}\" message=\"La saisie comporte des caractères non autorisés\"></cnaf-cct-erreur-input></div><div class=row ng-if=vm.affichePaysCotisation(vm.index)><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=paysCotisation>Pays de cotisation</label><div class=\"row form-group\" ng-class=\"{ 'has-error' :\n" +
    "                                vm.cotisemployeurform.paysCotisation.$invalid\n" +
    "                                && (!vm.cotisemployeurform.paysCotisation.$pristine\n" +
    "                                        || vm.cotisemployeurform.paysCotisation.$touched)\n" +
    "                                \n" +
    "                    }\"><div class=col-sm-12><input id=paysCotisation ng-model=vm.data.sitPros[vm.index].paysCotisation name=paysCotisation title=\"Indiquer le pays de cotisation. Champ obligatoire.\" class=form-control typeahead-min-length=2 uib-typeahead=\"pays as pays.libelleCaffr for pays in vm.getListePaysCotisationProposes($viewValue) | filter:$viewValue | limitTo:8\" typeahead-editable=false typeahead-no-results=noPaysFound aria-describedby=\"\n" +
    "                                    cotisemployeurInfopaysCotisationRequired\n" +
    "                                    cotisemployeurErreurpaysCotisationRequired\n" +
    "                                    cotisemployeurErreurpaysCotisationNotFound\" required></div></div><div id=cotisemployeurInfopaysCotisationRequired class=sr-only><p>Vous devez obligatoirement saisir le pays de cotisation</p></div><cnaf-cct-erreur-input iderreur=cotisemployeurErreurpaysCotisationRequired condition=\"{{vm.cotisemployeurform.paysCotisation.$error.required \n" +
    "                                                && (!vm.cotisemployeurform.paysCotisation.$pristine || vm.cotisemployeurform.paysCotisation.$touched)}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=cotisemployeurErreurpaysCotisationNotFound condition=\"{{noPaysFound && !vm.cotisemployeurform.paysCotisation.$error.required}}\" message=\"Pays non trouvé\"></cnaf-cct-erreur-input></div><div class=col-sm-6 ng-if=vm.afficheDetache(vm.index)><fieldset><legend class=\"label-form-cnaf control-label\" for=detacheFrance>{{vm.controle.libDetache}}</legend><div class=\"row form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                                        vm.cotisemployeurform.detacheFrance.$invalid\n" +
    "                                        && (!vm.cotisemployeurform.detacheFrance.$pristine\n" +
    "                                                || vm.cotisemployeurform.detacheFrance.$touched)\n" +
    "                            }\"><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].detacheFrance uib-btn-radio=\"'Oui'\" title=\"Indiquer si vous êtes détaché(e) en France. Une sélection est obligatoire.\" for=detacheFranceOui>Oui</label><input type=radio name=detacheFrance class=sr-only id=detacheFranceOui ng-model=vm.data.sitPros[vm.index].detacheFrance ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"\n" +
    "                                        cotisemployeurInfodetacheFranceRequired\n" +
    "                                        cotisemployeurErreurdetacheFranceRequired\" value=oui required></div><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].detacheFrance uib-btn-radio=\"'Non'\" title=\"Indiquer si vous êtes détaché(e) en France. Une sélection est obligatoire.\" for=detacheFranceNon>Non</label><input type=radio name=detacheFrance class=sr-only id=detacheFranceNon ng-model=vm.data.sitPros[vm.index].detacheFrance ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"\n" +
    "                                        cotisemployeurInfodetacheFranceRequired\n" +
    "                                        cotisemployeurErreurdetacheFranceRequired\" value=non required></div></div><div id=cotisemployeurInfodetacheFranceRequired class=sr-only><p>Vous devez obligatoirement indiquer si vous êtes détaché(e) en France.</p></div><cnaf-cct-erreur-input iderreur=cotisemployeurErreurdetacheFranceRequired condition=\"{{(!vm.cotisemployeurform.detacheFrance.$pristine || vm.cotisemployeurform.detacheFrance.$touched)\n" +
    "                                                         && vm.cotisemployeurform.detacheFrance.$error.required}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></fieldset></div></div></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-etudiant/cnaf-cct-situationpro-etudiant.html","<div ng-init=vm.init()><cnaf-cct-situationpro-etudiant-choix autocompletion=vm.autocompletion data=vm.data sitproetudiantchoixform=vm.sitproetudiantform errorsitproetudiantchoix=vm.errorsitproetudiantchoix listechoixetudiant=vm.listeChoixEtudiant controle=vm.controle index=vm.index></cnaf-cct-situationpro-etudiant-choix><div ng-if=vm.afficheDateActivite(vm.index)><label class=\"label-form-cnaf control-label\" for=dateActiviteEtudiant>{{vm.afficheDateActivite(vm.index)}}</label><div class=\"row form-group\" ng-class=\"{ 'has-error' :\n" +
    "                            (vm.sitproetudiantform.dateActiviteEtudiant.$invalid \n" +
    "                                && (!vm.sitproetudiantform.dateActiviteEtudiant.$pristine\n" +
    "                                        || vm.sitproetudiantform.dateActiviteEtudiant.$touched))\n" +
    "                            || ((vm.sitproetudiantform.dateActiviteEtudiant.$error.pattern\n" +
    "                                || vm.sitproetudiantform.dateActiviteEtudiant.$error.controleSupDernJourMoisSuivDem\n" +
    "                                || vm.sitproetudiantform.dateActiviteEtudiant.$error.controleInfDateNaissance\n" +
    "                                ||  (vm.controle.contexte === 'arriveeRetourCjt' && vm.sitproetudiantform.dateActiviteEtudiant.$error.controleDateSitProSitfamCouple))\n" +
    "                                && vm.data.sitPros[vm.index].dateActiviteEtudiant\n" +
    "                                && vm.data.sitPros[vm.index].dateActiviteEtudiant.length == 10\n" +
    "                                && vm.data.sitPros[vm.index].dateActiviteEtudiant !== 'jj/mm/aaaa')\n" +
    "                       }\"><div class=col-sm-4><div class=input-group><input id=dateActiviteEtudiant name=dateActiviteEtudiant title=\"Saisie de la date de début d'activité. Champ obligatoire. Au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010)\" placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActiviteEtudiant ng-model-options=\"{ updateOn: 'change'}\" class=form-control ui-validate=\"{\n" +
    "                                    controleInfDateNaissance : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                    controleSupDernJourMoisSuivDem  : 'vm.controleSupDernJourMoisSuivDem($value, vm.controle.dernJourMoisSuivDem, vm.index)',\n" +
    "                                    controleDateSitProSitfamCouple  : 'vm.controleDateSitProSitfamCouple($value, vm.controle, vm.index)'   \n" +
    "                                }\" aria-describedby=\"\n" +
    "                                    sitproetudiantInfodateActiviteEtudiantRequired\n" +
    "                                    sitproetudiantErreurdateActiviteEtudiantRequired\n" +
    "                                    sitproetudiantErreurdateActiviteEtudiantPattern\n" +
    "                                    sitproetudiantErreurControleInfDateNaissance\n" +
    "                                    sitproetudiantErreurControleSupDernJourMoisSuivDem\n" +
    "                                    sitproetudiantErreurControleDateSitProSitfamCouple\" required pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActiviteEtudiant start-year=1980 pattern-cnaf=dd/MM/yyyy inputname=dateActiviteEtudiant></cnaf-date-picker></div></div></div><div id=sitproetudiantInfodateActiviteEtudiantRequired class=sr-only><p>Champ Obligatoire</p></div><cnaf-cct-erreur-input iderreur=sitproetudiantErreurdateActiviteEtudiantRequired condition=\"{{(!vm.sitproetudiantform.dateActiviteEtudiant.$pristine || vm.sitproetudiantform.dateActiviteEtudiant.$touched)\n" +
    "                                                     && vm.sitproetudiantform.dateActiviteEtudiant.$error.required}}\" message=\"Champ obligatoire.\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=sitproetudiantErreurdateActiviteEtudiantPattern condition=\"{{vm.sitproetudiantform.dateActiviteEtudiant.$error.pattern \n" +
    "                                                    && vm.data.sitPros[vm.index].dateActiviteEtudiant\n" +
    "                                                    && vm.data.sitPros[vm.index].dateActiviteEtudiant.length === 10\n" +
    "                                                    && vm.data.sitPros[vm.index].dateActiviteEtudiant !== 'jj/mm/aaaa'}}\" message=\"Format de date invalide, la saisie doit contenir 10 caractères et être au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=sitproetudiantErreurControleInfDateNaissance condition=\"{{!vm.sitproetudiantform.dateActiviteEtudiant.$error.required\n" +
    "                                        && vm.data.sitPros[vm.index].dateActiviteEtudiant !== 'jj/mm/aaaa'\n" +
    "                                        && !vm.sitproetudiantform.dateActiviteEtudiant.$error.pattern \n" +
    "                                        && vm.sitproetudiantform.dateActiviteEtudiant.$error.controleInfDateNaissance}}\" message=\"La date saisie ne peut être inférieure à la date de naissance ({{vm.controle.datenaissance | date:'dd/MM/yyyy'}}).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=sitproetudiantErreurControleSupDernJourMoisSuivDem condition=\"{{!vm.sitproetudiantform.dateActiviteEtudiant.$error.required\n" +
    "                                        && vm.data.sitPros[vm.index].dateActiviteEtudiant !== 'jj/mm/aaaa'\n" +
    "                                        && !vm.sitproetudiantform.dateActiviteEtudiant.$error.pattern\n" +
    "                                        && vm.sitproetudiantform.dateActiviteEtudiant.$error.controleSupDernJourMoisSuivDem}}\" message=\"La date saisie ne peut être postérieure à la date du {{vm.controle.dernJourMoisSuivDem | date:'dd/MM/yyyy'}}\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=sitproetudiantErreurControleDateSitProSitfamCouple condition=\"{{!vm.sitproetudiantform.dateActiviteEtudiant.$error.required\n" +
    "                                        && vm.data.sitPros[vm.index].dateActiviteEtudiant !== 'jj/mm/aaaa'\n" +
    "                                        && !vm.sitproetudiantform.dateActiviteEtudiant.$error.pattern\n" +
    "                                        && vm.controle.contexte === 'arriveeRetourCjt'\n" +
    "                                        && vm.sitproetudiantform.dateActiviteEtudiant.$error.controleDateSitProSitfamCouple}}\" message=\"Vous devez saisir une date d'activité antérieure au {{vm.controle.dateSitfam | date:'dd/MM/yyyy'}}\"></cnaf-cct-erreur-input></div><div class=row ng-if=vm.afficheBoursier(vm.index)><cnaf-cct-situationpro-etudiant-boursier autocompletion=vm.autocompletion data=vm.data sitproetudiantboursierform=vm.sitproetudiantform errorsitproetudiantboursier=vm.errorsitproetudiantboursier controle=vm.controle class=col-sm-12 index=vm.index></cnaf-cct-situationpro-etudiant-boursier></div><div class=row ng-if=\"(vm.afficheBoursier(vm.index) && (vm.data.sitPros[vm.index].boursier === 'Oui')) || vm.data.sitPros[vm.index].sitproetu.code === 'EBO'\"><cnaf-cct-situationpro-etudiant-boursier-organisme autocompletion=vm.autocompletion data=vm.data sitproetudiantboursierorganismeform=vm.sitproetudiantform errorsitproetudiantboursierorganisme=vm.errorsitproetudiantboursierorganisme controle=vm.controle class=col-sm-12 index=vm.index></cnaf-cct-situationpro-etudiant-boursier-organisme></div></div><div class=visible-xs-inline><span ng-init=vm.initClassXs()></span></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-etudiant-boursier/cnaf-cct-situationpro-etudiant-boursier.html","<div class=row ng-init=vm.init()><div class=col-sm-12><fieldset><legend class=label-form-cnaf>{{vm.controle.libelleEbo}}<cnaf-aide styleclass=pull-right id=test data-id-content-cnaf=popover-ebo data-container=body data-trigger=manual tabindex=0></legend><div class=\"row form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' : \n" +
    "                                vm.sitproetudiantboursierform.boursier.$invalid\n" +
    "                                && (!vm.sitproetudiantboursierform.boursier.$pristine\n" +
    "                                        || vm.sitproetudiantboursierform.boursier.$touched)\n" +
    "                                \n" +
    "                            }\"><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].boursier title=\"Indiquer si vous bénéficiez d'une bourse sur critères sociaux. Une sélection est obligatoire.\" uib-btn-radio=\"'Oui'\" for=boursierOui{{vm.index}}><input type=radio name=boursier class=sr-only id=boursierOui{{vm.index}} ng-model=vm.data.sitPros[vm.index].boursier ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"\n" +
    "                                    sitproetudianBoursierInfoRequired\n" +
    "                                    sitproetudianBoursierErreurRequired\" value=oui required> Oui</label></div><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].boursier title=\"Indiquer si vous bénéficiez d'une bourse sur critères sociaux. Une sélection est obligatoire.\" uib-btn-radio=\"'Non'\" for=boursierNon{{vm.index}}><input type=radio name=boursier class=sr-only id=boursierNon{{vm.index}} ng-model=vm.data.sitPros[vm.index].boursier ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"\n" +
    "                                    sitproetudianBoursierInfoRequired\n" +
    "                                    sitproetudianBoursierErreurRequired\" value=non required> Non</label></div></div><div id=sitproetudianBoursierInfoRequired class=sr-only><p>Vous devez obligatoirement indiquer si vous bénéficiez d'une bourse sur critères sociaux.</p></div><cnaf-cct-erreur-input iderreur=sitproetudianBoursierErreurRequired condition=\"{{(!vm.sitproetudiantboursierform.boursier.$pristine || vm.sitproetudiantboursierform.boursier.$touched)\n" +
    "                                                     && vm.sitproetudiantboursierform.boursier.$error.required}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input><cnaf-cct-situationpro-texte-ebo ng-if=\"vm.data.sitPros[vm.index].boursier === 'Oui'\"></cnaf-cct-situationpro-texte-ebo><div id=popover-ebo class=hidden><div class=popover-btn-close-cnaf></div><span>Vous êtes considéré étudiant(e) boursier(ère) si vous percevez une bourse sur critères sociaux.</span> <span>Les bourses attribuées dans le cadre de :</span><ul><li>recherche, de stage (CNRS, CNE...)</li><li>ou d'échanges européens (Erasmus, Socrates...)</li><li>ou bourses d'excellence</li></ul><span>ne permettent pas le statut d'étudiant(e) boursier(ère).</span></div></fieldset></div></div><div class=visible-xs-inline><span ng-init=vm.initClassXs()></span></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-etudiant-boursier-organisme/cnaf-cct-situationpro-etudiant-boursier-organisme.html","<fieldset><legend class=sr-only>Coordonnées de l'organisme vous versant la bourse</legend><div class=row><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=orgaBourse>Nom de l'organisme qui a accordé la bourse</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                            vm.sitproetudiantboursierorganismeform.orgaBourse.$invalid \n" +
    "                                && (!vm.sitproetudiantboursierorganismeform.orgaBourse.$pristine\n" +
    "                                        || vm.sitproetudiantboursierorganismeform.orgaBourse.$touched)\n" +
    "                         \n" +
    "                        }\"><input id=orgaBourse{{vm.index}} maxlength=60 ng-model=vm.data.sitPros[vm.index].orgaBourse ng-change=\"vm.data.sitPros[vm.index].orgaBourse = vm.data.sitPros[vm.index].orgaBourse.toUpperCase()\" ng-model-options=\"{ updateOn: 'blur'}\" ng-blur=\"vm.testType8(vm.data.sitPros[vm.index].orgaBourse,vm.sitproetudiantboursierorganismeform,'orgaBourse')\" ng-pattern=\"/^[0-9a-zA-Zà-ÿÀ-Ÿ '-]*$/\" name=orgaBourse title=\"Indiquer le nom de l'organisme qui a accordé la bourse. Champ obligatoire.\" class=form-control aria-describedby=\"\n" +
    "                            sitproetudiantboursierorganismeInfoorgaBourseRequired\n" +
    "                            sitproetudiantboursierorganismeErreurorgaBourseRequired\n" +
    "                            sitproetudiantboursierorganismeErreurorgaBoursePattern\" required></div><div id=sitproetudiantboursierorganismeInfoorgaBourseRequired class=sr-only><p>Vous devez obligatoirement saisir l'adresse' de l'organisme qui a accordé la bourse</p></div><cnaf-cct-erreur-input iderreur=sitproetudiantboursierorganismeErreurorgaBourseRequired condition=\"{{(!vm.sitproetudiantboursierorganismeform.orgaBourse.$pristine  || vm.sitproetudiantboursierorganismeform.orgaBourse.$touched)\n" +
    "                                                         && vm.sitproetudiantboursierorganismeform.orgaBourse.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=sitproetudiantboursierorganismeErreurorgaBoursePattern condition=\"{{vm.sitproetudiantboursierorganismeform.orgaBourse.$error.pattern || vm.sitproetudiantboursierorganismeform.orgaBourse.$error.type8}}\" message=\"La saisie comporte des caractères non autorisés\"></cnaf-cct-erreur-input></div><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=orgaPays>Pays de l'organisme</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                             vm.sitproetudiantboursierorganismeform.orgaPays.$invalid\n" +
    "                                && (!vm.sitproetudiantboursierorganismeform.orgaPays.$pristine\n" +
    "                                        || vm.sitproetudiantboursierorganismeform.orgaPays.$touched)\n" +
    "                        \n" +
    "                   }\"><input id=orgaPays ng-model=vm.data.sitPros[vm.index].orgaPays name=orgaPays title=\"Indiquer le pays de l'organisme qui a accordé la bourse. Champ obligatoire.\" class=form-control typeahead-min-length=2 uib-typeahead=\"pays as pays.libelleCaffr for pays in vm.getListePaysBourseProposes($viewValue) | filter:$viewValue | limitTo:8\" typeahead-editable=false typeahead-no-results=noPaysFound aria-describedby=\"\n" +
    "                                sitproetudiantboursierorganismeInfoorgaPaysRequired\n" +
    "                                sitproetudiantboursierorganismeErreurorgaPaysRequired\n" +
    "                                sitproetudiantboursierorganismeErreurorgaPaysNotFound\" required></div><div id=sitproetudiantboursierorganismeInfoorgaPaysRequired class=sr-only><p>Vous devez obligatoirement saisir le pays de l'organisme qui a accordé la bourse</p></div><cnaf-cct-erreur-input iderreur=sitproetudiantboursierorganismeErreurorgaPaysRequired condition=\"{{(!vm.sitproetudiantboursierorganismeform.orgaPays.$pristine || vm.sitproetudiantboursierorganismeform.orgaPays.$touched)\n" +
    "                                                     && vm.sitproetudiantboursierorganismeform.orgaPays.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=sitproetudiantboursierorganismeErreurorgaPaysNotFound condition=\"{{noPaysFound && !vm.sitproetudiantboursierorganismeform.orgaPays.$error.required}}\" message=\"Pays non trouvé\"></cnaf-cct-erreur-input></div></div><div class=row><div class=col-sm-6><label class=\"label-form-cnaf control-label\" for=orgaAdresse>Adresse de l'organisme</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                        vm.sitproetudiantboursierorganismeform.orgaAdresse.$invalid\n" +
    "                            && (!vm.sitproetudiantboursierorganismeform.orgaAdresse.$pristine\n" +
    "                                    || vm.sitproetudiantboursierorganismeform.orgaAdresse.$touched)\n" +
    "                            \n" +
    "                    }\"><textarea id=orgaAdresse ng-model=vm.data.sitPros[vm.index].orgaAdresse name=orgaAdresse title=\"Indiquer l'adresse de l'organisme qui a accordé la bourse. Champ obligatoire.\" class=form-control aria-describedby=\"\n" +
    "                                sitproetudiantboursierorganismeInfoorgaAdresseRequired\n" +
    "                                sitproetudiantboursierorganismeErreurorgaAdresseRequired\" rows=3 maxlength=100 required>\n" +
    "                </textarea></div><div id=sitproetudiantboursierorganismeInfoorgaAdresseRequired class=sr-only><p>Vous devez obligatoirement saisir l'adresse de l'organisme qui a accordé la bourse</p></div><cnaf-cct-erreur-input iderreur=sitproetudiantboursierorganismeErreurorgaAdresseRequired condition=\"{{(!vm.sitproetudiantboursierorganismeform.orgaAdresse.$pristine || vm.sitproetudiantboursierorganismeform.orgaAdresse.$touched)\n" +
    "                                                     && vm.sitproetudiantboursierorganismeform.orgaAdresse.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input></div></div></fieldset><div class=visible-xs-inline><span ng-init=vm.initClassXs()></span></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-etudiant-choix/cnaf-cct-situationpro-etudiant-choix.html","<fieldset><legend class=label-form-cnaf>{{vm.controle.libellePersonne}}</legend><p id=sitproetuLabelChoixEtudiant class=sr-only>Préciser la situation étudiante qui correspond le mieux.</p><div class=\"row form-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                    vm.sitproetudiantchoixform.sitproetu.$invalid\n" +
    "                    && (!vm.sitproetudiantchoixform.sitproetu.$pristine\n" +
    "                            || vm.sitproetudiantchoixform.sitproetu.$touched)\n" +
    "                    \n" +
    "                    }\"><div class=col-sm-4 ng-repeat=\"acti in vm.listechoixetudiant\"><span class=pull-right ng-if=\"acti.code==='HOSP'\"><cnaf-aide tabindex=0 data-toggle=popover data-id-content-cnaf=popover-hosp data-container=body data-trigger=manual></span><label ng-class=\"{'align-middle-cnaf' : acti.libelle.length < 20}\" class=\"btn btn-default cct-btn-block-probleme-hauteur\" ng-model=vm.data.sitPros[vm.index].sitproetu uib-btn-radio=acti title=\"Préciser la situation étudiante. Une sélection est obligatoire.\" for={{acti.code}}><input type=radio name=sitproetu class=sr-only aria-labelledby=sitproetuLabelChoixEtudiant aria-describedby=\"sitproetuInfoChoixEtudiantRequired \n" +
    "                                        sitproetuErreurChoixEtudiantRequired\" id={{acti.code}} value={{acti.code}} ng-model=vm.data.sitPros[vm.index].sitproetu ng-model-options=\"{ updateOn: 'blur'}\" required> {{acti.libelle}}</label><div ng-if=\"acti.code==='HOSP'\" class=hidden id=popover-hosp><div class=popover-btn-close-cnaf></div><span>Il s'agit d'un statut attribué à des étudiant(e)s qui participent à l'activité hospitalière :</span><ul><li>étudiant(e) en médecine à partir de la 1ère année du 2ème cycle.</li><li>étudiant(e) en pharmacie à partir de la 5ème année des études pharmaceutiques.</li><li>étudiant(e) en odontologie à partir de la 2ème année du 2ème cycle.</li><li>étudiant(e) en maïeutique à partir de la 4ème année.</li></ul></div></div></div><div id=sitproetuInfoChoixEtudiantRequired class=sr-only><p>Vous devez obligatoirement choisir une situation parmi celles proposées.</p></div><cnaf-cct-erreur-input iderreur=sitproetuErreurChoixEtudiantRequired condition=\"{{(!vm.sitproetudiantchoixform.sitproetu.$pristine || vm.sitproetudiantchoixform.sitproetu.$touched)\n" +
    "                                                && vm.sitproetudiantchoixform.sitproetu.$error.required}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></fieldset>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-invalidite/cnaf-cct-situationpro-invalidite.html","<div ng-init=vm.init()><div class=row><div class=col-sm-12><fieldset><legend class=label-form-cnaf>{{vm.controle.libellePersonneInva}} &nbsp;(si perception des deux, sélectionner la plus ancienne)</legend><div class=\"row form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                                    vm.invaliditeform.invalRente.$invalid\n" +
    "                                    && (!vm.invaliditeform.invalRente.$pristine\n" +
    "                                            || vm.invaliditeform.invalRente.$touched)\n" +
    "                                    \n" +
    "                                }\"><div class=col-sm-4><label class=\"btn btn-default cct-btn-block-probleme-hauteur\" ng-model=vm.data.sitPros[vm.index].invalRente ng-change=\"vm.data.sitPros[vm.index].cesseActProPens = undefined\" title=\"Indiquer si vous percevez une pension d'invalidité ou une rente d'accident du travail. Une sélection est obligatoire.\" uib-btn-radio=\"'inval'\" for=inval><input type=radio name=invalRente class=sr-only id=invalr ng-model=vm.data.sitPros[vm.index].invalRente ng-model-options=\"{ updateOn: 'change'}\" aria-describedby=\"\n" +
    "                                    invaliditeInfoinvalRenteRequired\n" +
    "                                    invaliditeErreurinvalRenteRequired\" value=inval required> Pension d'invalidité</label></div><div class=col-sm-4><label class=\"btn btn-default cct-btn-block-probleme-hauteur\" ng-model=vm.data.sitPros[vm.index].invalRente ng-change=\"vm.data.sitPros[vm.index].cesseActProPens = undefined\" title=\"Indiquer si vous percevez une pension d'invalidité ou une rente d'accident du travail. Une sélection est obligatoire.\" uib-btn-radio=\"'rente'\" for=rente><input type=radio name=invalRente class=sr-only id=rente ng-model=vm.data.sitPros[vm.index].invalRente ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"\n" +
    "                                    invaliditeInfoinvalRenteRequired\n" +
    "                                    invaliditeErreurinvalRenteRequired\" value=rente required> Rente accident du travail</label></div></div><div id=invaliditeInfoinvalRenteRequired class=sr-only><p>Vous devez obligatoirement indiquer si vous percevez une pension d'invalidité ou une rente d'accident du travail.</p></div><cnaf-cct-erreur-input iderreur=invaliditeErreurinvalRenteRequired condition=\"{{(!vm.invaliditeform.invalRente.$pristine || vm.invaliditeform.invalRente.$touched)\n" +
    "                                                         && vm.invaliditeform.invalRente.$error.required}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></fieldset></div></div><div class=row><div class=col-sm-8><label class=\"label-form-cnaf control-label\" for=dateActiviteInvalide>Depuis le</label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                        ((vm.invaliditeform.dateActiviteInvalide.$invalid\n" +
    "                            && (!vm.invaliditeform.dateActiviteInvalide.$pristine\n" +
    "                                    || vm.invaliditeform.dateActiviteInvalide.$touched))\n" +
    "                        || (((vm.invaliditeform.dateActiviteInvalide.$error.pattern)\n" +
    "                            || (vm.invaliditeform.dateActiviteInvalide.$error.controleSupDernJourMoisSuivDem)\n" +
    "                            || (vm.invaliditeform.dateActiviteInvalide.$error.controleInfDateNaissance)\n" +
    "                            ||  (vm.controle.contexte === 'arriveeRetourCjt' && vm.invaliditeform.dateActiviteInvalide.$error.controleDateSitProSitfamCouple))\n" +
    "                            && vm.data.sitPros[vm.index].dateActiviteInvalide\n" +
    "                            && vm.data.sitPros[vm.index].dateActiviteInvalide.length == 10\n" +
    "                            && vm.data.sitPros[vm.index].dateActiviteInvalide !== 'jj/mm/aaaa'))\n" +
    "                        \n" +
    "                        }\"><div class=\"form-group input-group\" id=divdateActiviteInvalide><input id=dateActiviteInvalide name=dateActiviteInvalide title=\"Saisie de la date de début d'invalidité'. Champ obligatoire. Au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010)\" placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActiviteInvalide class=form-control ui-validate=\"{controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                            controleSupDernJourMoisSuivDem  : 'vm.controleSupDernJourMoisSuivDem($value, vm.controle.dernJourMoisSuivDem, vm.index)',\n" +
    "                                            controleDateSitProSitfamCouple  : 'vm.controleDateSitProSitfamCouple($value, vm.controle, vm.index)'\n" +
    "                                    }\" required aria-describedby=\"\n" +
    "                                invaliditeInfodateActiviteInvalideRequired\n" +
    "                                invaliditeErreurdateActiviteInvalideRequired\n" +
    "                                invaliditeErreurdateActiviteInvalidePattern\n" +
    "                                invaliditeErreurControleInfDateNaissance\n" +
    "                                invaliditeErreurControleSupDernJourMoisSuivDem\n" +
    "                                invaliditeErreurControleDateSitProSitfamCouple\" pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActiviteInvalide start-year=1980 pattern-cnaf=dd/MM/yyyy inputname=dateActiviteInvalide></cnaf-date-picker></div></div></div></div><div id=invaliditeInfodateActiviteInvalideRequired class=sr-only><p>Champ Obligatoire</p></div><cnaf-cct-erreur-input iderreur=invaliditeErreurdateActiviteInvalideRequired condition=\"{{ (!vm.invaliditeform.dateActiviteInvalide.$pristine || vm.invaliditeform.dateActiviteInvalide.$touched)\n" +
    "                                             && vm.invaliditeform.dateActiviteInvalide.$error.required}}\" message=\"Champ obligatoire.\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=invaliditeErreurdateActiviteInvalidePattern condition=\"{{vm.invaliditeform.dateActiviteInvalide.$error.pattern \n" +
    "                                            && vm.data.sitPros[vm.index].dateActiviteInvalide\n" +
    "                                            && vm.data.sitPros[vm.index].dateActiviteInvalide.length === 10\n" +
    "                                            && vm.data.sitPros[vm.index].dateActiviteInvalide !== 'jj/mm/aaaa'}}\" message=\"Format de date invalide, la saisie doit contenir 10 caractères et être au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=invaliditeErreurControleInfDateNaissance condition=\"{{!vm.invaliditeform.dateActiviteInvalide.$error.required\n" +
    "                                && vm.data.sitPros[vm.index].dateActiviteInvalide !== 'jj/mm/aaaa'\n" +
    "                                && !vm.invaliditeform.dateActiviteInvalide.$error.pattern\n" +
    "                                && vm.invaliditeform.dateActiviteInvalide.$error.controleInfDateNaissance}}\" message=\"La date saisie ne peut être inférieure à la date de naissance ({{vm.controle.datenaissance | date:'dd/MM/yyyy'}}).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=invaliditeErreurControleSupDernJourMoisSuivDem condition=\"{{!vm.invaliditeform.dateActiviteInvalide.$error.required\n" +
    "                                && vm.data.sitPros[vm.index].dateActiviteInvalide !== 'jj/mm/aaaa'\n" +
    "                                && !vm.invaliditeform.dateActiviteInvalide.$error.pattern\n" +
    "                                && vm.invaliditeform.dateActiviteInvalide.$error.controleSupDernJourMoisSuivDem}}\" message=\"La date saisie ne peut être postérieure à la date du {{vm.controle.dernJourMoisSuivDem | date:'dd/MM/yyyy'}}\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=invaliditeErreurControleDateSitProSitfamCouple condition=\"{{!vm.invaliditeform.dateActiviteInvalide.$error.required\n" +
    "                                && vm.data.sitPros[vm.index].dateActiviteInvalide !== 'jj/mm/aaaa'\n" +
    "                                && !vm.invaliditeform.dateActiviteInvalide.$error.pattern\n" +
    "                                && vm.controle.contexte === 'arriveeRetourCjt'\n" +
    "                                && vm.invaliditeform.dateActiviteInvalide.$error.controleDateSitProSitfamCouple}}\" message=\"Vous devez saisir une date d'activité antérieure au {{vm.controle.dateSitfam | date:'dd/MM/yyyy'}}\"></cnaf-cct-erreur-input><div ng-if=vm.controle.isLogementAccession><cnaf-cct-situationpro-assurance-pret data=vm.data assurancepretform=vm.invaliditeform errorassurancepret=vm.errorassurancepret controle=vm.controle index=vm.index></cnaf-cct-situationpro-assurance-pret></div><div class=row><div class=col-sm-12 ng-if=\"vm.controle.isSalOuNonSal && vm.data.cumul == 'cumulN'\"><fieldset><legend class=label-form-cnaf>{{vm.controle.libellePersonneCesseActProPens}}</legend><div class=\"row form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                                    vm.invaliditeform.cesseActProPens.$invalid\n" +
    "                                        && (!vm.invaliditeform.cesseActProPens.$pristine\n" +
    "                                                || vm.invaliditeform.cesseActProPens.$touched)\n" +
    "                                    \n" +
    "                            }\"><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].cesseActProPens uib-btn-radio=\"'Oui'\" title=\"Indiquer si l'activité professionnelle a totalement cessée. Une sélection est obligatoire.\" for=cesseActProPensOui><input type=radio name=cesseActProPens class=sr-only id=cesseActProPensOui ng-model=vm.data.sitPros[vm.index].cesseActProPens ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"\n" +
    "                                        invaliditeInfocesseActProPensRequired\n" +
    "                                        invaliditeErreurcesseActProPensRequired\" value=oui required> Oui</label></div><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].cesseActProPens uib-btn-radio=\"'Non'\" title=\"Indiquer si l'activité professionnelle a totalement cessée. Une sélection est obligatoire.\" for=cesseActProPensNon><input type=radio name=cesseActProPens class=sr-only id=cesseActProPensNon ng-model=vm.data.sitPros[vm.index].cesseActProPens ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"\n" +
    "                                        invaliditeInfocesseActProPensRequired\n" +
    "                                        invaliditeErreurcesseActProPensRequired\" value=non required> Non</label></div></div><div id=invaliditeInfocesseActProPensRequired class=sr-only><p>Vous devez obligatoirement indiquer si l'activité professionnelle a totalement cessée.</p></div><cnaf-cct-erreur-input iderreur=invaliditeErreurcesseActProPensRequired condition=\"{{(!vm.invaliditeform.cesseActProPens.$pristine || vm.invaliditeform.cesseActProPens.$touched)\n" +
    "                                                         && vm.invaliditeform.cesseActProPens.$error.required}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></fieldset></div></div><div ng-if=\"(vm.data.sitPros[vm.index].cesseActProPens === 'Oui' || !vm.controle.isSalOuNonSal)\"><cnaf-cct-situationpro-cotis-employeur data=vm.data cotisemployeurform=vm.invaliditeform errorcotisemployeur=vm.errorcotisemployeur controle=vm.controle index=vm.index></cnaf-cct-situationpro-cotis-employeur></div></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-non-salariee/cnaf-cct-situationpro-non-salariee.html","<div class=row ng-init=vm.init()><div class=col-sm-12><fieldset><legend class=label-form-cnaf>Préciser la situation</legend><div class=\"row form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                        (vm.nonsalarieeform.choixActiviteNonSalariee.$invalid\n" +
    "                        && !vm.nonsalarieeform.choixActiviteNonSalariee.$pristine)\n" +
    "                        }\"><div class=col-sm-6 ng-repeat=\"activite in vm.listeActivitenonsalariee\"><label ng-class=\"{'align-middle-cnaf' : acti.libelle.length < 38}\" class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixActiviteNonSalariee ng-change=\"vm.data.sitPros[vm.index].cotisEmployeur=undefined;\" uib-btn-radio=activite title=\"Préciser la situation non salariée. Une sélection est obligatoire.\" for={{activite.code}}>{{activite.libelle}} <input type=radio name=choixActiviteNonSalariee class=sr-only id={{activite.code}} value={{activite.code}} ng-model=vm.data.sitPros[vm.index].choixActiviteNonSalariee aria-describedby=\"sitproNonSalInfoInputChoixActiviteNonSal\n" +
    "                                                sitproNonSalErreurInputChoixActiviteNonSalRequired\" required></label></div></div><p id=sitproNonSalInfoInputChoixActiviteNonSal class=sr-only>Vous devez obligatoirement choisir une situation parmi celles proposées.</p><cnaf-cct-erreur-input iderreur=sitproNonSalErreurInputChoixActiviteNonSalRequired condition=\"{{vm.nonsalarieeform.choixActiviteNonSalariee.$error.required\n" +
    "                                            && !vm.nonsalarieeform.choixActiviteNonSalariee.$pristine}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></fieldset></div></div><div ng-if=\"vm.data.sitPros[vm.index].choixActiviteNonSalariee && vm.controle.profilAvecAAH\"><cnaf-cct-situationpro-taux-activite-aah autocompletion=vm.autocompletion data=vm.data tauxactiviteaahform=vm.nonsalarieeform errorctauxactiviteaah=vm.errortauxactiviteaah controle=vm.controle index=vm.index></cnaf-cct-situationpro-taux-activite-aah></div><div class=row ng-if=vm.data.sitPros[vm.index].choixActiviteNonSalariee><div class=col-sm-8><label ng-if=\"vm.data.sitPros[vm.index].choixActiviteNonSalariee.code == 'INDEP'\" class=\"label-form-cnaf control-label\" for=dateActiviteNonSalarie><span>Vous êtes affilié(e) à la sécurité sociale des indépendants (SSI) depuis le</span></label><label ng-if=\"vm.data.sitPros[vm.index].choixActiviteNonSalariee.code != 'INDEP'\" class=\"label-form-cnaf control-label\" for=dateActiviteNonSalarie><span>Depuis le</span></label><div class=\"form-group input-group\" ng-class=\"{ 'has-error' :\n" +
    "                       ((vm.nonsalarieeform.dateActiviteNonSalarie.$invalid\n" +
    "                        && (!vm.nonsalarieeform.dateActiviteNonSalarie.$pristine \n" +
    "                           || vm.nonsalarieeform.dateActiviteNonSalarie.$touched))\n" +
    "                   || ((vm.nonsalarieeform.dateActiviteNonSalarie.$error.pattern\n" +
    "                        || vm.nonsalarieeform.dateActiviteNonSalarie.$error.controleSupDernJourMoisSuivDem\n" +
    "                        || vm.nonsalarieeform.dateActiviteNonSalarie.$error.controleInfDateNaissance\n" +
    "                        ||  (vm.controle.contexte === 'arriveeRetourCjt' && vm.nonsalarieeform.dateActiviteNonSalarie.$error.controleDateSitProSitfamCouple))\n" +
    "                           && vm.data.sitPros[vm.index].dateActiviteNonSalarie\n" +
    "                           && vm.data.sitPros[vm.index].dateActiviteNonSalarie.length == 10\n" +
    "                           && vm.data.sitPros[vm.index].dateActiviteNonSalarie !== 'jj/mm/aaaa'))\n" +
    "                    }\"><div class=\"form-group input-group\" id=divdateActiviteNonSalarie><input id=dateActiviteNonSalarie name=dateActiviteNonSalarie title=\"Saisie de la date de début d'activité. Champ obligatoire. Au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010)\" placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActiviteNonSalarie ng-model-options=\"{ updateOn: 'change'}\" class=form-control inputname=vm.data.sitPros[vm.index].dateActiviteNonSalarie ui-validate=\"{  controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                        controleSupDernJourMoisSuivDem  : 'vm.controleSupDernJourMoisSuivDem($value, vm.controle.dernJourMoisSuivDem, vm.index)',\n" +
    "                                        controleDateSitProSitfamCouple  : 'vm.controleDateSitProSitfamCouple($value, vm.controle, vm.index)'\n" +
    "                                }\" aria-describedby=\"\n" +
    "                            situationprononsalarieeInfodateActiviteNonSalariee\n" +
    "                            situationprononsalarieeErreurdateActiviteNonSalarieRequired\n" +
    "                            situationprononsalarieeErreurdateActiviteNonSalariePattern\n" +
    "                            situationprononsalarieeErreurControleInfDateNaissance\n" +
    "                            situationprononsalarieeErreurControleSupDernJourMoisSuivDem\n" +
    "                            situationprononsalarieeErreurControleDateSitProSitfamCouple\" required pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActiviteNonSalarie start-year=1980 pattern-cnaf=dd/MM/yyyy inputname=dateActiviteNonSalarie></cnaf-date-picker></div></div><p id=situationprononsalarieeInfodateActiviteNonSalariee class=sr-only>Champ Obligatoire</p><cnaf-cct-erreur-input iderreur=situationprononsalarieeErreurdateActiviteNonSalarieeRequired condition=\"{{!vm.nonsalarieeform.dateActiviteNonSalarie.$pristine && vm.nonsalarieeform.dateActiviteNonSalarie.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprononsalarieeErreurdateActiviteNonSalariePattern condition=\"{{vm.nonsalarieeform.dateActiviteNonSalarie.$error.pattern \n" +
    "                                                && vm.data.sitPros[vm.index].dateActiviteNonSalarie\n" +
    "                                                && vm.data.sitPros[vm.index].dateActiviteNonSalarie.length === 10\n" +
    "                                                && vm.data.sitPros[vm.index].dateActiviteNonSalarie !== 'jj/mm/aaaa'}}\" message=\"Format de date invalide, la saisie doit contenir 10 caractères et être au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprononsalarieeErreurControleInfDateNaissance condition=\"{{!vm.nonsalarieeform.dateActiviteNonSalarie.$error.required\n" +
    "                                            && vm.data.sitPros[vm.index].dateActiviteNonSalarie !=='jj/mm/aaaa'\n" +
    "                                            && !vm.nonsalarieeform.dateActiviteNonSalarie.$error.pattern \n" +
    "                                            && vm.nonsalarieeform.dateActiviteNonSalarie.$error.controleInfDateNaissance}}\" message=\"La date saisie ne peut être inférieure à la date de naissance ({{vm.controle.datenaissance | date:'dd/MM/yyyy'}}).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprononsalarieeErreurControleSupDernJourMoisSuivDem condition=\"{{!vm.nonsalarieeform.dateActiviteNonSalarie.$error.required\n" +
    "                                    && vm.data.sitPros[vm.index].dateActiviteNonSalarie !=='jj/mm/aaaa'\n" +
    "                                    && !vm.nonsalarieeform.dateActiviteNonSalarie.$error.pattern\n" +
    "                                    && vm.nonsalarieeform.dateActiviteNonSalarie.$error.controleSupDernJourMoisSuivDem}}\" message=\"La date saisie ne peut être postérieure à la date du {{vm.controle.dernJourMoisSuivDem | date:'dd/MM/yyyy'}}\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=situationprononsalarieeErreurControleDateSitProSitfamCouple condition=\"{{!vm.nonsalarieeform.dateActiviteNonSalarie.$error.required\n" +
    "                                    && vm.data.sitPros[vm.index].dateActiviteNonSalarie !=='jj/mm/aaaa'\n" +
    "                                    && !vm.nonsalarieeform.dateActiviteNonSalarie.$error.pattern\n" +
    "                                    && vm.controle.contexte === 'arriveeRetourCjt'\n" +
    "                                    && vm.nonsalarieeform.dateActiviteNonSalarie.$error.controleDateSitProSitfamCouple}}\" message=\"Vous devez saisir une date d'activité antérieure au {{vm.controle.dateSitfam | date:'dd/MM/yyyy'}}\"></cnaf-cct-erreur-input></div></div><div class=row ng-if=\"vm.data.sitPros[vm.index].choixActiviteNonSalariee && vm.data.sitPros[vm.index].choixActiviteNonSalariee.code == 'INDEP'\"><div class=col-sm-12><fieldset><legend class=label-form-cnaf>Vous êtes</legend><div class=\"row form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                    (vm.nonsalarieeform.rGerant.$invalid\n" +
    "                    && !vm.nonsalarieeform.rGerant.$pristine)\n" +
    "                }\"><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].rGerant uib-btn-radio=vm.listeRegimeGerant[0] for=vm.listeRegimeGerant[0].code><input type=radio name=rGerant class=sr-only id=vm.listeRegimeGerant[0].code ng-model=vm.data.sitPros[vm.index].rGerant required> <span>{{vm.listeRegimeGerant[0].libelle}}</span></label></div><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].rGerant uib-btn-radio=vm.listeRegimeGerant[1] for=vm.listeRegimeGerant[1].code><input type=radio name=rGerant class=sr-only id=vm.listeRegimeGerant[1].code ng-model=vm.data.sitPros[vm.index].rGerant aria-describedby=\"\n" +
    "                            situationprononsalarieeInfoRGerantRequired\n" +
    "                            situationprononsalarieeErreurRGerantRequired\" required> <span>{{vm.listeRegimeGerant[1].libelle}}</span></label></div></div><p id=situationprononsalarieeInfoRGerantRequired class=sr-only>Vous devez choisir une situation parmi celles proposées.</p><cnaf-cct-erreur-input iderreur=situationprononsalarieeErreurRGerantRequired condition=\"{{!vm.nonsalarieeform.rGerant.$pristine && vm.nonsalarieeform.rGerant.$error.required}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></fieldset></div></div><cnaf-cct-situationpro-cotis-employeur data=vm.data cotisemployeurform=vm.nonsalarieeform errorcotisemployeur=vm.errorcotisemployeur controle=vm.controle index=vm.index></cnaf-cct-situationpro-cotis-employeur><div class=row ng-if=vm.afficheRegimeImposition(vm.index)><div class=col-sm-12><fieldset><legend class=label-form-cnaf>Le régime d'imposition de vos revenus</legend><div class=\"row form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                    (vm.nonsalarieeform.regImpos.$invalid\n" +
    "                    && !vm.nonsalarieeform.regImpos.$pristine)\n" +
    "                }\"><div class=col-sm-4><label class=\"btn btn-default btn-block\" title=\"Préciser le régime d'imposition. Une sélection est obligatoire.\" ng-model=vm.data.sitPros[vm.index].regImpos uib-btn-radio=vm.listeRegimeImposition[0] for=vm.listeRegimeImposition[0].code><input type=radio name=regImpos class=sr-only id=vm.listeRegimeImposition[0].code ng-model=vm.data.sitPros[vm.index].regImpos aria-describedby=\"sitproNonSalInfoInputChoixActiviteNonSal\n" +
    "                                            sitproNonSalErreurInputChoixActiviteNonSalRequired\" required> {{vm.listeRegimeImposition[0].libelle}}</label></div><div class=col-sm-4 ng-if=\"vm.data.sitPros[vm.index].choixActiviteNonSalariee && vm.data.sitPros[vm.index].choixActiviteNonSalariee.code == 'VDINS'\"><label class=\"btn btn-default btn-block\" title=\"Préciser le régime d'imposition. Une sélection est obligatoire.\" ng-model=vm.data.sitPros[vm.index].regImpos uib-btn-radio=vm.listeRegimeImposition[1] for=vm.listeRegimeImposition[1].code><input type=radio name=regImpos class=sr-only id=vm.listeRegimeImposition[1].code ng-model=vm.data.sitPros[vm.index].regImpos aria-describedby=\"sitproNonSalInfoInputChoixActiviteNonSal\n" +
    "                                            sitproNonSalErreurInputChoixActiviteNonSalRequired\" required> {{vm.listeRegimeImposition[1].libelle}}</label></div><div class=col-sm-4 ng-if=\"vm.data.sitPros[vm.index].choixActiviteNonSalariee && vm.data.sitPros[vm.index].choixActiviteNonSalariee.code == 'VDINS'\"><label class=\"btn btn-default btn-block\" title=\"Préciser le régime d'imposition. Une sélection est obligatoire.\" ng-model=vm.data.sitPros[vm.index].regImpos uib-btn-radio=vm.listeRegimeImposition[2] for=vm.listeRegimeImposition[2].code><input type=radio name=regImpos class=sr-only id=vm.listeRegimeImposition[2].code ng-model=vm.data.sitPros[vm.index].regImpos aria-describedby=\"sitproNonSalInfoInputChoixActiviteNonSal\n" +
    "                                                sitproNonSalErreurInputChoixActiviteNonSalRequired\" required> {{vm.listeRegimeImposition[2].libelle}}</label></div><div class=col-sm-4 ng-if=\"vm.data.sitPros[vm.index].choixActiviteNonSalariee && vm.data.sitPros[vm.index].choixActiviteNonSalariee.code == 'ARTIST'\"><label class=\"btn btn-default btn-block\" title=\"Préciser le régime d'imposition. Une sélection est obligatoire.\" ng-model=vm.data.sitPros[vm.index].regImpos uib-btn-radio=vm.listeRegimeImposition[3] for=vm.listeRegimeImposition[3].code><input type=radio name=regImpos class=sr-only id=vm.listeRegimeImposition[3].code ng-model=vm.data.sitPros[vm.index].regImpos aria-describedby=\"sitproNonSalInfoInputChoixActiviteNonSal\n" +
    "                                            sitproNonSalErreurInputChoixActiviteNonSalRequired\" required> {{vm.listeRegimeImposition[3].libelle}}</label></div><div class=col-sm-4 ng-if=\"vm.data.sitPros[vm.index].choixActiviteNonSalariee && vm.data.sitPros[vm.index].choixActiviteNonSalariee.code == 'ARTIST'\"><label class=\"btn btn-default btn-block\" title=\"Préciser le régime d'imposition. Une sélection est obligatoire.\" ng-model=vm.data.sitPros[vm.index].regImpos uib-btn-radio=vm.listeRegimeImposition[4] for=vm.listeRegimeImposition[4].code><input type=radio name=regImpos class=sr-only id=vm.listeRegimeImposition[4].code ng-model=vm.data.sitPros[vm.index].regImpos aria-describedby=\"sitproNonSalInfoInputChoixActiviteNonSal\n" +
    "                                            sitproNonSalErreurInputChoixActiviteNonSalRequired\" required> {{vm.listeRegimeImposition[4].libelle}}</label></div><p id=nonsalarieeInfoRegImpos class=sr-only>Vous devez choisir une situation parmi celles proposées.</p><div class=col-sm-12><cnaf-cct-erreur-input iderreur=nonsalarieeErreurRegImposRequired condition=\"{{!vm.nonsalarieeform.regImpos.$pristine && vm.nonsalarieeform.regImpos.$error.required}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></div></div></fieldset></div></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-recap/cnaf-cct-situationpro-recap.html","<div class=col-sm-12 tabindex=0 ng-if=\"vm.data.sitPros[0].choixActivite == 'SAL'\"><cnaf-cct-situationpro-recap-choix-activite-salariee data=vm.data.sitPros[0] cumul=vm.data.cumul issalounonsal=vm.data.isSalOuNonSal personneencours=vm.data.libPersonneEnCours index=vm.$index recapform=vm.recapform></cnaf-cct-situationpro-recap-choix-activite-salariee></div><div class=col-sm-12 tabindex=0 ng-if=\"vm.data.sitPros[0].sitproetu\n" +
    "                  && vm.data.sitPros[0].choixActiviteComplementInvalidite != 'ETU'\n" +
    "                  && vm.data.sitPros[0].choixActiviteComplementRetraite != 'ETU'\"><cnaf-cct-situationpro-recap-etudiant data=vm.data.sitPros[0] personneencours=vm.data.libPersonneEnCours index=vm.$index recapform=vm.recapform></cnaf-cct-situationpro-recap-etudiant></div><div class=col-sm-12 tabindex=0 ng-if=\"vm.data.sitPros[0].choixActivite == 'CONG'\"><cnaf-cct-situationpro-recap-conges-divers data=vm.data.sitPros[0] personneencours=vm.data.libPersonneEnCours index=vm.$index recapform=vm.recapform></cnaf-cct-situationpro-recap-conges-divers></div><div class=col-sm-12 tabindex=0 ng-if=\"vm.data.sitPros[0].choixActivite == 'AUT'\"><cnaf-cct-situationpro-recap-autre-situation data=vm.data.sitPros[0] personneencours=vm.data.libPersonneEnCours index=vm.$index recapform=vm.recapform></cnaf-cct-situationpro-recap-autre-situation></div><div class=col-sm-12 tabindex=0 ng-if=\"vm.data.sitPros[0].choixActivite == 'CHO'\"><cnaf-cct-situationpro-recap-chomage data=vm.data.sitPros[0] personneencours=vm.data.libPersonneEnCours index=vm.$index recapform=vm.recapform></cnaf-cct-situationpro-recap-chomage></div><div class=col-sm-12 tabindex=0 ng-if=\"vm.data.sitPros[0].choixActivite == 'PENS'\"><cnaf-cct-situationpro-recap-invalidite data=vm.data.sitPros[0] personneencours=vm.data.libPersonneEnCours index=vm.$index recapform=vm.recapform></cnaf-cct-situationpro-recap-invalidite></div><div class=col-sm-12 tabindex=0 ng-if=\"vm.data.sitPros[0].choixActivite == 'NSAL'\"><cnaf-cct-situationpro-recap-non-salariee data=vm.data.sitPros[0] cumul=vm.data.cumul issalounonsal=vm.data.isSalOuNonSal personneencours=vm.data.libPersonneEnCours index=vm.$index recapform=vm.recapform></cnaf-cct-situationpro-recap-non-salariee></div><div class=col-sm-12 tabindex=0 ng-if=\"vm.data.sitPros[0].choixActivite == 'RET'\"><cnaf-cct-situationpro-recap-retraite data=vm.data.sitPros[0] personneencours=vm.data.libPersonneEnCours index=vm.$index recapform=vm.recapform></cnaf-cct-situationpro-recap-retraite></div><div class=col-sm-12 tabindex=0 ng-if=\"vm.data.sitPros[0].choixActivite == 'APP'\"><cnaf-cct-situationpro-recap-choix-activite-stagiaire data=vm.data.sitPros[0] personneencours=vm.data.libPersonneEnCours index=vm.$index recapform=vm.recapform></cnaf-cct-situationpro-recap-choix-activite-stagiaire></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-recap-autre-situation/cnaf-cct-situationpro-recap-autre-situation.html","<div ng-init=vm.init()><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.cumul === undefined || vm.data.cumul === 'cumulN'\">{{vm.personneencours}} <span class=text-primary ng-if=\"vm.data.choixAutreSituation.id == 'SSA'\">est sans activité. </span><span class=text-primary ng-if=\"vm.data.choixAutreSituation.id == 'MAL'\">est en arrêt maladie. </span><span ng-if=\"vm.data.choixAutreSituation.id == 'MOC'\"><span class=text-primary ng-if=!vm.data.profilAvecAAH>est membre d'une organisation communautaire. </span><span class=text-primary ng-if=\"vm.data.profilAvecAAH && vm.data.activitePartielAah\">est membre d'une organisation communautaire à temps partiel. </span><span class=text-primary ng-if=\"vm.data.profilAvecAAH && !vm.data.activitePartielAah\">est membre d'une organisation communautaire à temps complet. </span></span><span class=text-primary ng-if=\"vm.data.choixAutreSituation.id == 'DETENU'\">est en détention. </span><span class=text-primary ng-if=\"vm.data.choixAutreSituation.id == 'AIDANT'\">est aidant(e) familial(e) percevant un dédommagement. </span><span class=text-primary ng-if=\"vm.data.choixAutreSituation.id == 'JEUNE'\">est bénéficiaire de la garantie jeune. </span><span ng-if=\"vm.data.choixAutreSituation.id == 'VOL'\"><span class=text-primary ng-if=\"vm.data.choixAutreSituationVolontariat.id == 'CIVIC'\">est en service civique. </span><span class=text-primary ng-if=\"vm.data.choixAutreSituationVolontariat.id == 'SAPEUR'\">est sapeur-pompier volontaire. </span><span class=text-primary ng-if=\"vm.data.choixAutreSituationVolontariat.id == 'ARMEE'\">est volontaire dans les armées. </span><span class=text-primary ng-if=\"vm.data.choixAutreSituationVolontariat.id == 'VINTER'\">est volontaire international. </span><span class=text-primary ng-if=\"vm.data.choixAutreSituationVolontariat.id == 'VINSER'\">est volontaire pour insertion. </span><span class=text-primary ng-if=\"vm.data.choixAutreSituationVolontariat.id == 'VCIVIL'\">est volontaire civil. </span><span class=text-primary ng-if=\"vm.data.choixAutreSituationVolontariat.id == 'SMADAP'\">est en service militaire adapté.</span></span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.profilAvecAAH && vm.data.activitePartielAah && vm.data.choixActiviteSalariee.code == 'MOC'\">Le taux d'activité est de <span class=text-primary>{{vm.data.tauxPartielAah}} %.</span></div><div class=\"row col-sm-12\" ng-if=!vm.data.isChevauchement><span class=texte-clair-cnaf ng-if=\"vm.data.choixAutreSituation.id == 'SSA'\n" +
    "                    || vm.data.choixAutreSituation.id == 'MAL'\n" +
    "                    || vm.data.choixAutreSituation.id == 'MOC'\n" +
    "                    || vm.data.choixAutreSituation.id == 'AIDANT'\n" +
    "                    || vm.data.choixAutreSituation.id == 'JEUNE'\">Date de début de la situation : </span><span class=texte-clair-cnaf ng-if=\"vm.data.choixAutreSituation.id == 'DETENU'\">Date de début de la détention : </span><span class=texte-clair-cnaf ng-if=\"vm.data.choixAutreSituation.id == 'VOL'\">Date de début du volontariat : </span><span class=text-primary>{{vm.data.dateActiviteAutreSitu}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=vm.data.isChevauchement>{{vm.personneencours}} a confirmé que sa situation avait changé le <span class=text-primary>{{vm.data.dateActiviteAutreSitu}}</span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.choixAutreSituation.id == 'DETENU'\n" +
    "                            && vm.data.dateFinActiviteAutreSitu && vm.data.dateFinActiviteAutreSitu !== 'jj/mm/aaaa'\">Date de fin de la détention : <span class=text-primary>{{vm.data.dateFinActiviteAutreSitu}}</span></span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.choixAutreSituation.id == 'SSA'\">{{vm.personneencours}} <span ng-if=\"vm.data.poleEmploi == 'Oui'\"><span class=text-primary>est inscrit(e) à France Travail</span>. </span><span ng-if=\"vm.data.poleEmploi == 'Non'\"><span class=text-primary>n'est pas inscrit(e) à France Travail</span>.</span></span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.choixAutreSituation.id == 'MAL'\"><span class=texte-clair-cnaf ng-if=\"vm.data.affectionLongueDuree === 'Oui'\"><span class=text-primary>Il s’agit d’une affection longue durée.</span><div>Date de prise en compte de cette affection par l’organisme d’assurance maladie : <span class=text-primary>{{vm.data.datePriseEnCompteAffection}}</span></div></span><span class=text-primary ng-if=\"vm.data.affectionLongueDuree === 'Non'\">Il ne s’agit pas d’une affection longue durée.</span></span></div><div class=\"row col-sm-12\"><p class=texte-clair-cnaf ng-if=\"vm.data.choixAutreSituation.id == 'MOC'\">Nom de l’organisation communautaire : <span class=text-primary>{{vm.data.nomEtablissement}}</span><br><span class=texte-clair-cnaf>Pays de l’organisation communautaire : </span><span class=text-primary>{{vm.data.paysActivite.libelleCaffr}}</span><br><span class=texte-clair-cnaf ng-if=\"vm.data.paysActivite.code === 'FR'\">Code postal/Commune de l’organisation communautaire : <span class=text-primary ng-if=vm.data.codePostalZoneActivite.lib>{{vm.data.codePostalZoneActivite.lib}} </span><span class=text-primary ng-if=!vm.data.codePostalZoneActivite.lib>{{vm.data.codePostalZoneActivite}} </span></span><span class=texte-clair-cnaf ng-if=\"vm.data.paysActivite.code !== 'FR' && vm.data.paysActivite.code !== 'MC'\">Ville de l’organisation communautaire : <span class=text-primary>{{vm.data.villeEtablissement}}</span></span><br><span class=texte-clair-cnaf ng-if=vm.data.exerceActPro>{{vm.personneencours}} <span class=text-primary>{{vm.data.libelleexerceActPro}}</span></span></p></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.choixAutreSituation.id == 'DETENU'\">Nom de l’établissement pénitentiaire : <span class=text-primary>{{vm.data.nomEtablissement}}</span><div><span class=texte-clair-cnaf>Pays de l’établissement pénitentiaire : </span><span class=text-primary>{{vm.data.paysActivite.libelleCaffr}}</span></div><span class=texte-clair-cnaf ng-if=\"vm.data.paysActivite.code === 'FR'\">Code postal/Commune de l’établissement pénitentiaire : <span class=text-primary ng-if=vm.data.codePostalZoneActivite.lib>{{vm.data.codePostalZoneActivite.lib}} </span><span class=text-primary ng-if=!vm.data.codePostalZoneActivite.lib>{{vm.data.codePostalZoneActivite}} </span></span><span ng-if=\"vm.data.paysActivite.code !== 'FR' && vm.data.paysActivite.code !== 'MC'\">Ville de l’établissement pénitentiaire : <span class=text-primary>{{vm.data.villeEtablissement}}</span></span></span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.choixAutreSituation.id == 'VOL'\n" +
    "                    && vm.data.choixAutreSituationVolontariat.id == 'VINTER'\">Pays où se déroule le volontariat : <span class=text-primary>{{vm.data.paysActivite.libelleCaffr}}</span></span></div></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-recap-choix-activite-salariee/cnaf-cct-situationpro-recap-choix-activite-salariee.html","<div ng-init=vm.init()><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.cumul === undefined || vm.data.cumul === 'cumulN'\">{{vm.personneencours}} <span class=text-primary>{{vm.data.libelleActPro}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.profilAvecAAH && vm.data.activitePartielAah\">Le taux d'activité est de <span class=text-primary>{{vm.data.tauxPartielAah}} %.</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=!vm.data.isChevauchement>Date de début de l’activité : <span class=text-primary>{{vm.data.dateActiviteSalarie}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=vm.data.isChevauchement>{{vm.personneencours}} a confirmé que sa situation professionnelle avait changé le <span class=text-primary>{{vm.data.dateActiviteSalarie}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.dateFinActivite != undefined\">Date de fin de l’activité : <span class=text-primary>{{vm.data.dateFinActivite}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.nomEmployeur != undefined\"><span ng-if=\"vm.data.choixActiviteSalariee.code !== 'GERSAL' && vm.data.choixActiviteSalariee.code !== 'ESAT'\">Nom de l’employeur : </span><span ng-if=\"vm.data.choixActiviteSalariee.code === 'GERSAL'\">Nom de l’entreprise : </span><span ng-if=\"vm.data.choixActiviteSalariee.code === 'ESAT'\">Nom de l'ESAT : </span><span class=text-primary ng-if=\"vm.data.nomEmployeur != undefined\">{{vm.data.nomEmployeur}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\"><span ng-if=\"vm.data.choixActiviteSalariee.code == 'SAL'\n" +
    "                    || vm.data.choixActiviteSalariee.code == 'INT'\n" +
    "                    || vm.data.choixActiviteSalariee.code == 'VDS'\n" +
    "                    || vm.data.choixActiviteSalariee.code == 'VRP'\n" +
    "                    || vm.data.choixActiviteSalariee.code == 'INTER'\n" +
    "                    || vm.data.choixActiviteSalariee.code == 'EMMAUS'\n" +
    "                    || vm.data.choixActiviteSalariee.code == 'SAS'\">Pays de l’employeur : </span><span ng-if=\"vm.data.choixActiviteSalariee.code == 'GERSAL'\">Pays de l’entreprise : </span><span class=text-primary>{{vm.data.paysEmployeur.libelleCaffr}}</span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.paysEmployeur.code === 'FR' || vm.data.choixActiviteSalariee.code === 'ESAT'\"><span ng-if=\"vm.data.choixActiviteSalariee.code !== 'GERSAL' && vm.data.choixActiviteSalariee.code !== 'ESAT'\">Code postal/Commune de l’employeur : </span><span ng-if=\"vm.data.choixActiviteSalariee.code === 'GERSAL'\">Code postal/Commune de l’entreprise : </span><span ng-if=\"vm.data.choixActiviteSalariee.code === 'ESAT'\">Code postal/Commune de l'ESAT : </span><span class=text-primary>{{vm.data.codePostalVilleEmployeur.lib}} </span></span><span class=texte-clair-cnaf ng-if=\"vm.data.paysEmployeur.code !== 'FR'\"><span ng-if=\"vm.data.choixActiviteSalariee.code != 'GERSAL'\n" +
    "                                            && vm.data.villeEmployeur != undefined\">Ville de l’employeur : </span><span ng-if=\"vm.data.choixActiviteSalariee.code === 'GERSAL'\n" +
    "                                            && vm.data.villeEmployeur\">Ville de l’entreprise : </span><span class=text-primary>{{vm.data.villeEmployeur}}</span></span></div><div class=\"row col-sm-12 texte-clair-cnaf\"><span ng-if=\"vm.data.choixActiviteSalariee.code !== 'GERSAL'\n" +
    "                && vm.data.choixActiviteSalariee.code !== 'TSA'\n" +
    "                && vm.data.choixActiviteSalariee.code !== 'ASSMAT'\n" +
    "                && vm.data.choixActiviteSalariee.code !== 'SPEC'\n" +
    "                && vm.data.choixActiviteSalariee.code !== 'ESAT'\n" +
    "                && vm.data.choixActiviteSalariee.code !== 'EMMAUS'\n" +
    "                && vm.data.choixActiviteSalariee.code !== 'INTER'\n" +
    "                && vm.data.choixActiviteSalariee.code !== 'ASSFAM'\">L’employeur cotise </span><span ng-if=\"vm.data.choixActiviteSalariee.code == 'GERSAL'\">{{vm.personneencours}} cotise </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'UR'\">à l’Urssaf. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'AG'\">à la MSA. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'CG'\">à la CGSS. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'CS'\">à la CSSM. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'AR'\">à un autre régime.<div ng-if=\"vm.data.choixActiviteSalariee.code === 'SAL'\"><span class=texte-clair-cnaf ng-if=\"(vm.data.choixAutRegSal.code === 'MO' ||\n" +
    "                            vm.data.choixAutRegSal.code === 'FO' ||\n" +
    "                            vm.data.choixAutRegSal.code === 'AL')\">{{vm.personneencours}} </span><span class=text-primary ng-if=\"vm.data.choixAutRegSal.code === 'MO'\">est membre d’une organisation internationale. </span><span class=text-primary ng-if=\"vm.data.choixAutRegSal.code === 'FO'\">est fonctionnaire.<div class=texte-clair-cnaf ng-if=vm.data.choixPosteFonct>{{vm.personneencours}} <span class=text-primary ng-if=\"vm.data.choixPosteFonct.code === 'GE'\">est en poste en France. </span><span class=text-primary ng-if=\"vm.data.choixPosteFonct.code == 'AE'\">est en poste à l’étranger.</span></div></span><span class=text-primary ng-if=\"vm.data.choixAutRegSal.code === 'AL'\">est membre du Parlement.</span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.nomOrganisme != undefined\">Nom de l'organisme : <span class=text-primary>{{vm.data.nomOrganisme}}</span></span></div></span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'RE'\">à un régime étranger.<div class=\"row col-sm-12 texte-clair-cnaf\"><span ng-if=\"vm.data.paysCotisation != undefined\">Pays de cotisation : <span class=text-primary>{{vm.data.paysCotisation.libelleCaffr}}</span></span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.detacheFrance != undefined\">{{vm.personneencours}} <span class=text-primary ng-if=\"vm.data.detacheFrance == 'Oui'\">est détaché(e) en France. </span><span class=text-primary ng-if=\"vm.data.detacheFrance == 'Non'\">n’est pas détaché(e) en France.</span></div></span></div></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-recap-choix-activite-stagiaire/cnaf-cct-situationpro-recap-choix-activite-stagiaire.html","<div ng-init=vm.init()><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"(vm.data.cumul === undefined || vm.data.cumul === 'cumulN') && (vm.data.isEtu === undefined || vm.data.isEtu === 'Non')\">{{vm.personneencours}} <span class=text-primary>{{vm.data.libelleActPro}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.profilAvecAAH && vm.data.activitePartielAah\">Le taux d'activité est de <span class=text-primary>{{vm.data.tauxPartielAah}} %.</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.isEtu == 'Non'\">{{vm.personneencours}} <span class=text-primary>n'est pas stagiaire dans le cadre de ses études ni en année de césure.</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.isEtu == 'Oui' && vm.data.contexte == 'arriveeRetourCjt'\">{{vm.personneencours}} <span class=text-primary>est stagiaire dans le cadre de ses études ou en année de césure.</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=!vm.data.isChevauchement><span ng-if=\"vm.data.choixStagiaire.code == 'STAGE'\">Date de début de l’activité : <span class=text-primary>{{vm.data.dateActiviteStagiaire}} </span></span><span ng-if=\"vm.data.choixStagiaire.code == 'APP'\">Date de début de l’apprentissage : <span class=text-primary>{{vm.data.dateActiviteApprenti}} </span></span><span ng-if=\"vm.data.choixStagiaire.code == 'CONTRAT'\">Date de début du contrat : <span class=text-primary>{{vm.data.dateActiviteApprenti}}</span></span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=vm.data.isChevauchement>{{vm.personneencours}} a confirmé que sa situation professionnelle avait changé le <span class=text-primary ng-if=\"vm.data.choixStagiaire.code == 'APP' || vm.data.choixStagiaire.code == 'CONTRAT'\">{{vm.data.dateActiviteApprenti}} </span><span class=text-primary ng-if=\"vm.data.choixStagiaire.code == 'STAGE'\">{{vm.data.dateActiviteStagiaire}}</span></div><span ng-if=\"vm.data.choixStagiaire.code == 'STAGE' && vm.data.contexte == 'arriveeRetourCjt' && vm.data.isEtu === 'Oui' && vm.data.boursier\"><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.boursier === 'Non'\">{{vm.personneencours}} <span class=text-primary>n’est pas étudiant(e) boursier(ère).</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.boursier === 'Oui'\">{{vm.personneencours}} <span class=text-primary>est étudiant(e) boursier(ère).</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.boursier === 'Oui'\"><div>Nom de l’organisme qui a accordé la bourse : <span class=text-primary>{{vm.data.orgaBourse}}</span></div><div>Pays de l’organisme : <span class=text-primary>{{vm.data.orgaPays.libelleCaffr}}</span></div><div>Adresse de l’organisme : <span class=text-primary>{{vm.data.orgaAdresse}}</span></div></div></span><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.choixStagiaire.code === 'STAGE'\"><span ng-if=\"vm.data.indemnise == true\">Le stage <span class=text-primary>est indemnisé</span> par <span class=text-primary ng-if=\"vm.data.regimeIndemnisation.code === 'PE'\">France Travail. </span><span class=text-primary ng-if=\"vm.data.regimeIndemnisation.code === 'FP'\">la fonction publique. </span><span class=text-primary ng-if=\"vm.data.regimeIndemnisation.code === 'AO'\">l’employeur ou par un autre organisme. </span></span><span class=text-primary ng-if=\"vm.data.indemnise == false\">Le stage n’est pas indemnisé.</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.choixStagiaire.code === 'APP'\n" +
    "                    || vm.data.choixStagiaire.code === 'CONTRAT'\">L’employeur cotise <span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'GE'\">au régime général. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'AG'\">à la MSA. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'CG'\">à la CGSS. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'CS'\">à la CSSM. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'AR'\">à un autre régime.<div class=\"col-sm-12 row texte-clair-cnaf\">Nom de l’organisme : <span class=text-primary>{{vm.data.nomOrganisme}}</span></div></span></div></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-recap-chomage/cnaf-cct-situationpro-recap-chomage.html","<div ng-init=vm.init()><div class=\"row col-sm-12\" ng-if=\"vm.data.cumul === undefined || vm.data.cumul === 'cumulN'\"><span class=texte-clair-cnaf>{{vm.personneencours}} <span class=text-primary>est au chômage<span ng-if=vm.data.chomagePartiel> partiel</span>.</span></span></div><div class=\"row col-sm-12\" ng-if=!vm.data.isChevauchement><span class=texte-clair-cnaf>Date de début de la situation : </span><span class=text-primary>{{vm.data.dateActiviteChomage}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=vm.data.isChevauchement>{{vm.personneencours}} a confirmé que sa situation avait changé le <span class=text-primary>{{vm.data.dateActiviteChomage}}</span></div><div class=\"row col-sm-12\" ng-if=vm.data.orgInscription.code><span class=texte-clair-cnaf>{{vm.personneencours}} <span ng-if=\"vm.data.orgInscription.code == 'PE'\">est inscrit(e) auprès de <span class=text-primary>France Travail</span>. </span><span ng-if=\"vm.data.orgInscription.code == 'AO'\">est inscrit(e) auprès de : <span class=text-primary>{{vm.data.nomOrganisme}}.</span></span></span></div><div class=\"row col-sm-12\" ng-if=vm.data.pretavecassurance><span class=texte-clair-cnaf ng-if=\"vm.data.pretavecassurance == 'Oui'\">Un ou plusieurs prêts sont pris en charge par une assurance </span><span class=texte-clair-cnaf ng-if=\"vm.data.pretavecassurance=='Non'\">Aucun prêt n’est pris en charge par une assurance</span></div><div class=\"row col-sm-12\" ng-repeat=\"heureCPL in vm.heuresCPL\"><span class=texte-clair-cnaf>Nombre d'heures de chômage partiel en {{heureCPL.mois}} : </span><span class=text-primary>{{heureCPL.heures}} heure<span ng-if=\"heureCPL.heures>1\">s</span>.</span></div><div class=\"row col-sm-12\" ng-if=\"vm.data.chomagePartiel && vm.data.toujoursChomagePartiel != undefined\"><span class=texte-clair-cnaf>{{vm.personneencours}} </span><span class=text-primary ng-if=vm.data.toujoursChomagePartiel>est ou a été au chômage partiel en {{vm.moisEnCoursCPL}}. </span><span class=text-primary ng-if=!vm.data.toujoursChomagePartiel>n'est pas au chômage partiel au mois de {{vm.moisEnCoursCPL}}.</span></div></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-recap-conges-divers/cnaf-cct-situationpro-recap-conges-divers.html","<div class=\"row col-sm-12\" ng-if=\"vm.data.cumul === undefined || vm.data.cumul === 'cumulN'\"><span class=texte-clair-cnaf>{{vm.personneencours}} <span class=text-primary ng-if=\"vm.data.choixCongesDivers.code == 'MAT'\">est en congé maternité. </span><span class=text-primary ng-if=\"vm.data.choixCongesDivers.code == 'DIVERS'\">est en congé conventionnel. </span><span class=text-primary ng-if=\"vm.data.choixCongesDivers.code == 'PARENT'\">est en congé parental ou d’adoption. </span><span class=text-primary ng-if=\"vm.data.choixCongesDivers.code == 'SSOLDE'\">est en congé sans solde. </span><span class=text-primary ng-if=\"vm.data.choixCongesDivers.code == 'SAB'\">est en congé sabbatique.</span></span></div><div class=\"row col-sm-12\" ng-if=!vm.data.isChevauchement><span class=texte-clair-cnaf>Date de début de congé : <span class=text-primary>{{vm.data.dateActiviteConges}}</span></span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=vm.data.isChevauchement>{{vm.personneencours}} a confirmé que sa situation avait changé le <span class=text-primary>{{vm.data.dateActiviteConges}}</span></div><div class=\"row col-sm-12\" ng-if=\"vm.data.choixCongesDivers.code !== 'SAB'\"><span class=texte-clair-cnaf>Date de fin de congé : <span class=text-primary>{{vm.data.dateFinActiviteConges}}</span></span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.choixCongesDivers.code == 'MAT'\"><span>L’organisme qui verse les indemnités cotise </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'GE'\">au régime général. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'AG'\">à la MSA. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'CP'\">à la CPAM. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'AR' || vm.data.cotisEmployeur.code === 'AU'\">à un autre régime. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'CS'\">à la CSSM.</span></span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.nomOrganisme != undefined\">Nom de l'organisme : <span class=text-primary>{{vm.data.nomOrganisme}}</span></span></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-recap-etudiant/cnaf-cct-situationpro-recap-etudiant.html","<div ng-init=vm.init()><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"!(vm.data.sitproetu.code === 'ETU' && vm.data.boursier) && (vm.data.cumul === undefined || vm.data.cumul === 'cumulN')\">{{vm.personneencours}} <span class=text-primary ng-if=\"vm.data.sitproetu.code === 'ETS'\">est étudiant(e) et a une activité salariée. </span><span class=text-primary ng-if=\"vm.data.sitproetu.code === 'ETU'\">est étudiant(e). </span><span class=text-primary ng-if=\"vm.data.sitproetu.code === 'ETUNS'\">est étudiant(e) et a une activité non salariée. </span><span class=text-primary ng-if=\"vm.data.sitproetu.code === 'HOSP'\">est étudiant(e) hospitalier(ère).</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.dateActiviteEtudiant && !vm.data.isChevauchement &&\n" +
    "    ( vm.data.sitproetu.code === 'EBO' || vm.data.sitproetu.code === 'ETU' || vm.data.sitproetu.code === 'HOSP' )\">Date de début de la situation : <span class=text-primary>{{vm.data.dateActiviteEtudiant}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=vm.data.isChevauchement>{{vm.personneencours}} a confirmé que sa situation professionnelle avait changé le <span class=text-primary>{{vm.data.dateActiviteEtudiant}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.dateActiviteEtudiant && !vm.data.isChevauchement && vm.data.sitproetu.code === 'ETS'\">Date de début de contrat : <span class=text-primary>{{vm.data.dateActiviteEtudiant}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.dateActiviteEtudiant && !vm.data.isChevauchement && vm.data.sitproetu.code === 'ETUNS'\">Date de début de l'activité non salariée : <span class=text-primary>{{vm.data.dateActiviteEtudiant}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=vm.data.dateFinActiviteEtudiant>Date de fin de la situation : <span class=text-primary>{{vm.data.dateFinActiviteEtudiant}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=vm.data.boursier>{{vm.personneencours}} <span class=text-primary>{{vm.data.libelleBoursier}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.boursier === 'Oui' || vm.data.sitproetu.code === 'EBO'\"><div>Nom de l’organisme qui a accordé la bourse : <span class=text-primary>{{vm.data.orgaBourse}}</span></div><div>Pays de l’organisme : <span class=text-primary>{{vm.data.orgaPays.libelleCaffr}}</span></div><div>Adresse de l’organisme : <span class=text-primary>{{vm.data.orgaAdresse}}</span></div></div></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-recap-invalidite/cnaf-cct-situationpro-recap-invalidite.html","<div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.cumul === undefined || vm.data.cumul === 'cumulN'\">{{vm.personneencours}} <span class=text-primary ng-if=\"vm.data.invalRente == 'inval'\">perçoit une pension d’invalidité. </span><span class=text-primary ng-if=\"vm.data.invalRente == 'rente'\">perçoit une rente accident du travail.</span></div><div class=\"row col-sm-12\" ng-if=vm.data.pretAvecAssurance><span class=texte-clair-cnaf ng-if=\"vm.data.pretAvecAssurance == 'Oui'\">Un ou plusieurs prêts sont pris en charge par une assurance </span><span class=texte-clair-cnaf ng-if=\"vm.data.pretAvecAssurance=='Non'\">Aucun prêt n’est pris en charge par une assurance</span></div><div class=\"row col-sm-12\" ng-if=!vm.data.isChevauchement><span class=texte-clair-cnaf>Date de début de la situation : </span><span class=text-primary>{{vm.data.dateActiviteInvalide}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=vm.data.isChevauchement>{{vm.personneencours}} a confirmé que sa situation avait changé le <span class=text-primary>{{vm.data.dateActiviteInvalide}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=vm.data.cesseActProPens>{{vm.personneencours}} <span class=text-primary ng-if=\"vm.data.cesseActProPens === 'Non'\">n’a pas cessé totalement son activité professionnelle. </span><span class=text-primary ng-if=\"vm.data.cesseActProPens === 'Oui'\">a cessé totalement son activité professionnelle.</span><div class=\"row col-sm-12\" ng-if=\"vm.data.cesseActProPens === 'Non' && vm.data.contexte === 'arriveeRetourCjt'\">{{vm.personneencours}} est aussi <span class=text-primary>{{vm.data.autreActiviteNom.libelleVisible | lowercase}}.</span></div></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=vm.data.cotisEmployeur>L’organisme qui verse la pension ou la rente la plus élevée <span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'GE'\">relève du régime général. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'AG'\">cotise à la MSA. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'CG'\">cotise à la CGSS. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'CS'\">cotise à la CSSM. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'AU' || vm.data.cotisEmployeur.code === 'AR'\">cotise à un autre régime.<div class=\"row col-sm-12 texte-clair-cnaf\">Nom de l’organisme : <span class=text-primary>{{vm.data.nomOrganisme}}</span></div></span></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-recap-non-salariee/cnaf-cct-situationpro-recap-non-salariee.html","<div ng-init=vm.init()><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.cumul === undefined || vm.data.cumul === 'cumulN'\">{{vm.personneencours}} <span class=text-primary>{{vm.data.libelleActPro}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.profilAvecAAH && vm.data.activitePartielAah\">Le taux d'activité est de <span class=text-primary>{{vm.data.tauxPartielAah}} %.</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"!vm.data.isChevauchement && vm.data.choixActiviteNonSalariee.code == 'INDEP'\">Vous êtes affilié(e) à la sécurité sociale des indépendants (SSI) depuis le : <span class=text-primary>{{vm.data.dateActiviteNonSalarie}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"!vm.data.isChevauchement && vm.data.choixActiviteNonSalariee.code != 'INDEP'\">Depuis le <span class=text-primary>{{vm.data.dateActiviteNonSalarie}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=vm.data.isChevauchement>{{vm.personneencours}} a confirmé que sa situation professionnelle avait changé le <span class=text-primary>{{vm.data.dateActiviteNonSalarie}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.dateFinActiviteNonSalarie != undefined\">Date de fin de l’activité : <span class=text-primary>{{vm.data.dateFinActiviteNonSalarie}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.choixActiviteNonSalariee.code !== 'COTIS' && vm.data.choixActiviteNonSalariee.code !== 'INDEP'\">{{vm.personneencours}} cotise à <span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'UI'\">la SSI. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'AG'\">la MSA. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'CG'\">la CGSS. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'CS'\">la CSSM. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'AR'\">un autre régime.<div class=\"row col-sm-12\"><span class=texte-clair-cnaf ng-if=\"vm.data.nomOrganisme != undefined\">Nom de l'organisme : <span class=text-primary>{{vm.data.nomOrganisme}}</span></span></div></span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'AA'\">la maison des artistes / AGESSA. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'TM'\">l'ENIM. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'RE'\">un régime étranger.<div class=\"row col-sm-12 texte-clair-cnaf\"><span ng-if=\"vm.data.paysCotisation != undefined\">Pays de cotisation : <span class=text-primary>{{vm.data.paysCotisation.libelleCaffr}}</span></span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.detacheFrance != undefined\">{{vm.personneencours}} <span class=text-primary ng-if=\"vm.data.detacheFrance == 'Oui'\">est détaché(e) en France. </span><span class=text-primary ng-if=\"vm.data.detacheFrance == 'Non'\">n’est pas détaché(e) en France.</span></div></span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.choixActiviteNonSalariee.code == 'INDEP'\"><span>Vous êtes <span class=text-primary>{{vm.data.rGerant.libelle}}</span>.</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=\"vm.data.choixActiviteNonSalariee.code == 'ARTIST' || vm.data.choixActiviteNonSalariee.code == 'VDINS'\"><span>Le régime d’imposition de vos revenus est <span class=text-primary>{{vm.data.regImpos.libelle}}</span>.</span></div></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-recap-retraite/cnaf-cct-situationpro-recap-retraite.html","<div class=\"row col-sm-12 texte-clair-cnaf\">{{vm.personneencours}} <span class=text-primary>est en retraite ou en pré-retraite</span> <span ng-if=\"vm.data.cesseActProRet === 'Non'\">mais <span class=text-primary>n’a pas cessé totalement son activité professionnelle.</span> </span><span ng-if=\"vm.data.cesseActProRet === 'Oui'\">et <span class=text-primary>a cessé totalement son activité professionnelle.</span></span><div class=\"row col-sm-12\" ng-if=\"vm.data.cesseActProRet === 'Non'\">{{vm.personneencours}} est aussi <span class=text-primary>{{vm.data.autreActiviteNom.libelleVisible | lowercase}}.</span></div></div><div class=\"row col-sm-12\" ng-if=!vm.data.isChevauchement><span class=texte-clair-cnaf>Date de début de la situation : </span><span class=text-primary>{{vm.data.dateActiviteRetraite}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=vm.data.isChevauchement>{{vm.personneencours}} a confirmé que sa situation avait changé le <span class=text-primary>{{vm.data.dateActiviteRetraite}}</span></div><div class=\"row col-sm-12 texte-clair-cnaf\" ng-if=vm.data.cotisEmployeur>L’organisme qui verse la pension ou la rente la plus élevée <span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'GE'\">relève du régime général. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'AG'\">cotise à la MSA. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'CG'\">cotise à la CGSS. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'CS'\">cotise à la CSSM. </span><span class=text-primary ng-if=\"vm.data.cotisEmployeur.code === 'AR'\">cotise à un autre régime.<div class=\"row col-sm-12 texte-clair-cnaf\">Nom de l’organisme : <span class=text-primary>{{vm.data.nomOrganisme}}</span></div></span></div><div class=\"row col-sm-12\" ng-if=vm.data.typePensionEtat><span class=\"text-primary texte-clair-cnaf\" ng-if=\"vm.data.typePensionEtat === 'Oui'\">Il s'agit d'une pension d'état </span><span class=\"text-primary texte-clair-cnaf\" ng-if=\"vm.data.typePensionEtat === 'Non'\">Il ne s'agit pas d'une pension d'état</span></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-recapprolong/cnaf-cct-situationpro-recapprolong.html","<div class=col-sm-12 tabindex=0 ng-if=\"vm.data.codeActivite == 'CSS'\"><div class=\"row col-sm-12 texte-clair-cnaf\">{{vm.data.libPersonneEnCours}} <span class=text-primary>est en congé sans solde.</span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf>Date de début de congé : <span class=text-primary>{{vm.data.dateDebActivite}}</span></span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf>Date de fin de congé : <span class=text-primary>{{vm.data.dateFinActivite}}</span></span></div></div><div class=col-sm-12 tabindex=0 ng-if=\"vm.data.codeActivite == 'CAC'\"><div class=\"row col-sm-12 texte-clair-cnaf\">{{vm.data.libPersonneEnCours}} <span class=text-primary>est sans activité.</span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf>Date de début de la situation : </span><span class=text-primary>{{vm.data.dateDebActivite}}</span></div></div><div class=col-sm-12 tabindex=0 ng-if=\"vm.data.codeActivite == 'MAL'\"><div class=\"row col-sm-12 texte-clair-cnaf\">{{vm.data.libPersonneEnCours}} <span class=text-primary>est en arrêt maladie.</span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf>Date de début de la situation : </span><span class=text-primary>{{vm.data.dateDebActivite}}</span></div></div><div class=col-sm-12 tabindex=0 ng-if=\"vm.data.codeActivite == 'CHO' \n" +
    "            || vm.data.codeActivite == 'CPL'\n" +
    "            || vm.data.codeActivite == 'FDA' \n" +
    "            || vm.data.codeActivite == 'FDN'\"><div class=\"row col-sm-12 texte-clair-cnaf\">{{vm.data.libPersonneEnCours}} <span class=text-primary>est au chômage <span ng-if=\"vm.data.codeActivite == 'CPL'\">partiel</span>.</span></div><div class=\"row col-sm-12\"><span class=texte-clair-cnaf>Date de début de la situation : </span><span class=text-primary>{{vm.data.dateDebActivite}}</span></div></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-retraite/cnaf-cct-situationpro-retraite.html","<div ng-init=vm.init()><label class=\"label-form-cnaf control-label\" for=dateActiviteRetraite>Depuis le</label><div class=\"row form-group\" ng-class=\"{ 'has-error' :\n" +
    "                    ((vm.retraiteform.dateActiviteRetraite.$invalid\n" +
    "                        && (!vm.retraiteform.dateActiviteRetraite.$pristine\n" +
    "                                || vm.retraiteform.dateActiviteRetraite.$touched))\n" +
    "                    || (((vm.retraiteform.dateActiviteRetraite.$error.pattern)\n" +
    "                    || (vm.retraiteform.dateActiviteRetraite.$error.controleSupDernJourMoisSuivDem)\n" +
    "                    || (vm.retraiteform.dateActiviteRetraite.$error.controleInfDateNaissance)\n" +
    "                    ||  (vm.controle.contexte === 'arriveeRetourCjt' && vm.retraiteform.dateActiviteRetraite.$error.controleDateSitProSitfamCouple))\n" +
    "                    && vm.data.sitPros[vm.index].dateActiviteRetraite\n" +
    "                    && vm.data.sitPros[vm.index].dateActiviteRetraite.length == 10\n" +
    "                    && vm.data.sitPros[vm.index].dateActiviteRetraite !== 'jj/mm/aaaa'))\n" +
    "                    \n" +
    "                }\"><div class=col-sm-3><div class=input-group id=divDateActiviteRetraite><input id=dateActiviteRetraite name=dateActiviteRetraite title=\"Saisie de la date de début d'activité. Champ obligatoire. Au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010)\" placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActiviteRetraite ng-model-options=\"{ updateOn: 'change'}\" class=form-control ui-validate=\"{controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                                  controleSupDernJourMoisSuivDem  : 'vm.controleSupDernJourMoisSuivDem($value, vm.controle.dernJourMoisSuivDem, vm.index)',\n" +
    "                                  controleDateSitProSitfamCouple  : 'vm.controleDateSitProSitfamCouple($value, vm.controle, vm.index)'\n" +
    "                                }\" aria-describedby=\"\n" +
    "                            retraiteInfodateActiviteRetraiteRequired\n" +
    "                            retraiteErreurdateActiviteRetraiteRequired\n" +
    "                            retraiteErreurdateActiviteRetraitePattern\n" +
    "                            retraiteErreurControleInfDateNaissance\n" +
    "                            retraiteErreurControleSupDernJourMoisSuivDem\n" +
    "                            retraiteErreurControleDateSitProSitfamCouple\" required pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActiviteRetraite start-year=1980 pattern-cnaf=dd/MM/yyyy inputname=dateActiviteRetraite></cnaf-date-picker></div></div></div><div id=retraiteInfodateActiviteRetraiteRequired class=sr-only><p>Champ Obligatoire</p></div><cnaf-cct-erreur-input iderreur=retraiteErreurdateActiviteRetraiteRequired condition=\"{{(!vm.retraiteform.dateActiviteRetraite.$pristine || vm.retraiteform.dateActiviteRetraite.$touched)\n" +
    "                                                 && vm.retraiteform.dateActiviteRetraite.$error.required}}\" message=\"Champ obligatoire.\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=retraiteErreurdateActiviteRetraitePattern condition=\"{{vm.retraiteform.dateActiviteRetraite.$error.pattern \n" +
    "                                            && vm.data.sitPros[vm.index].dateActiviteRetraite\n" +
    "                                            && vm.data.sitPros[vm.index].dateActiviteRetraite.length === 10\n" +
    "                                            && vm.data.sitPros[vm.index].dateActiviteRetraite !== 'jj/mm/aaaa'}}\" message=\"Format de date invalide, la saisie doit contenir 10 caractères et être au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=retraiteErreurControleInfDateNaissance condition=\"{{!vm.retraiteform.dateActiviteRetraite.$error.required\n" +
    "                                && vm.data.sitPros[vm.index].dateActiviteRetraite !== 'jj/mm/aaaa'\n" +
    "                                && !vm.retraiteform.dateActiviteRetraite.$error.pattern \n" +
    "                                && vm.retraiteform.dateActiviteRetraite.$error.controleInfDateNaissance}}\" message=\"La date saisie ne peut être inférieure à la date de naissance ({{vm.controle.datenaissance | date:'dd/MM/yyyy'}}).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=retraiteErreurControleSupDernJourMoisSuivDem condition=\"{{!vm.retraiteform.dateActiviteRetraite.$error.required\n" +
    "                                && vm.data.sitPros[vm.index].dateActiviteRetraite !== 'jj/mm/aaaa'\n" +
    "                                && !vm.retraiteform.dateActiviteRetraite.$error.pattern\n" +
    "                                && vm.retraiteform.dateActiviteRetraite.$error.controleSupDernJourMoisSuivDem}}\" message=\"La date saisie ne peut être postérieure à la date du {{vm.controle.dernJourMoisSuivDem | date:'dd/MM/yyyy'}}\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=retraiteErreurControleDateSitProSitfamCouple condition=\"{{!vm.retraiteform.dateActiviteRetraite.$error.required\n" +
    "                                && vm.data.sitPros[vm.index].dateActiviteRetraite !== 'jj/mm/aaaa'\n" +
    "                                && !vm.retraiteform.dateActiviteRetraite.$error.pattern\n" +
    "                                && vm.controle.contexte === 'arriveeRetourCjt'\n" +
    "                                && vm.retraiteform.dateActiviteRetraite.$error.controleDateSitProSitfamCouple}}\" message=\"Vous devez saisir une date d'activité antérieure au {{vm.controle.dateSitfam | date:'dd/MM/yyyy'}}\"></cnaf-cct-erreur-input><div class=row><div class=col-sm-12 ng-if=\"vm.controle.isSalOuNonSal && vm.data.cumul == 'cumulN'\"><fieldset><legend class=label-form-cnaf>{{vm.controle.libellePersonneCesseActProRet}}</legend><div class=\"row form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                                    vm.retraiteform.cesseActProRet.$invalid\n" +
    "                                        && (!vm.retraiteform.cesseActProRet.$pristine\n" +
    "                                                || vm.retraiteform.cesseActProRet.$touched)\n" +
    "                                    \n" +
    "                            }\"><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].cesseActProRet uib-btn-radio=\"'Oui'\" title=\"Indiquer si l'activité professionnelle a totalement cessée. Une sélection est obligatoire.\" for=cesseActProRetOui><input type=radio name=cesseActProRet class=sr-only id=cesseActProRetOui ng-model=vm.data.sitPros[vm.index].cesseActProRet ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"\n" +
    "                                        retraiteInfocesseActProRetRequired\n" +
    "                                        retraiteErreurcesseActProRetRequired\" value=oui required> Oui</label></div><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].cesseActProRet uib-btn-radio=\"'Non'\" title=\"Indiquer si l'activité professionnelle a totalement cessée. Une sélection est obligatoire.\" for=cesseActProRetNon><input type=radio name=cesseActProRet class=sr-only id=cesseActProRetNon ng-model=vm.data.sitPros[vm.index].cesseActProRet ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"\n" +
    "                                        retraiteInfocesseActProRetRequired\n" +
    "                                        retraiteErreurcesseActProRetRequired\" value=non required> Non</label></div></div><div id=retraiteInfocesseActProRetRequired class=sr-only><p>Vous devez obligatoirement indiquer si l'activité professionnelle a totalement cessée.</p></div><cnaf-cct-erreur-input iderreur=retraiteErreurcesseActProRetRequired condition=\"{{(!vm.retraiteform.cesseActProRet.$pristine || vm.retraiteform.cesseActProRet.$touched)\n" +
    "                                                         && vm.retraiteform.cesseActProRet.$error.required}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></fieldset></div></div><div ng-if=\"vm.data.sitPros[vm.index].cesseActProRet === 'Oui' || !vm.controle.isSalOuNonSal\"><cnaf-cct-situationpro-cotis-employeur data=vm.data cotisemployeurform=vm.retraiteform errorcotisemployeur=vm.errorcotisemployeur controle=vm.controle index=vm.index></cnaf-cct-situationpro-cotis-employeur></div><div class=row><div class=col-sm-12 ng-if=\"vm.afficheMayotte(vm.index) && vm.data.sitPros[vm.index].cesseActProRet === 'Oui'\"><fieldset><legend class=label-form-cnaf>Il s'agit d'une pension d'état</legend><div class=\"row form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                                    vm.retraiteform.typePensionEtat.$invalid\n" +
    "                                        && (!vm.retraiteform.typePensionEtat.$pristine\n" +
    "                                                || vm.retraiteform.typePensionEtat.$touched)\n" +
    "                                    \n" +
    "                            }\"><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].typePensionEtat uib-btn-radio=\"'Oui'\" title=\"Indiquer s'il s'agit d'une pension d'état. Une sélection est obligatoire.\" for=typePensionEtatOui><input type=radio name=typePensionEtat class=sr-only id=typePensionEtatOui ng-model=vm.data.sitPros[vm.index].typePensionEtat ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"\n" +
    "                                        retraiteInfotypePensionEtatRequired\n" +
    "                                        retraiteErreurtypePensionEtatRequired\" value=oui required> Oui</label></div><div class=col-sm-2><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].typePensionEtat uib-btn-radio=\"'Non'\" title=\"Indiquer s'il s'agit d'une pension d'état. Une sélection est obligatoire.\" for=typePensionEtatNon><input type=radio name=typePensionEtat class=sr-only id=typePensionEtatNon ng-model=vm.data.sitPros[vm.index].typePensionEtat ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"\n" +
    "                                        retraiteInfotypePensionEtatRequired\n" +
    "                                        retraiteErreurtypePensionEtatRequired\" value=non required> Non</label></div></div><div id=retraiteInfotypePensionEtatRequired class=sr-only><p>Vous devez obligatoirement indiquer s'il s'agit d'une pension d'état.</p></div><cnaf-cct-erreur-input iderreur=retraiteErreurtypePensionEtatRequired condition=\"{{(!vm.retraiteform.typePensionEtat.$pristine || vm.retraiteform.typePensionEtat.$touched)\n" +
    "                                                         && vm.retraiteform.typePensionEtat.$error.required}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></fieldset></div></div></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-taux-activite-aah/cnaf-cct-situationpro-taux-activite-aah.html","<div ng-init=vm.init()><fieldset><legend class=\"label-form-cnaf control-label\" for=activitePartielAah><span ng-if=!vm.controle.encouple>Vous exercez cette activité à temps partiel</span> <span ng-if=vm.controle.encouple>{{vm.controle.libPersonneEnCours}} exerce cette activité à temps partiel</span></legend><div class=\"row form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' : \n" +
    "                        vm.tauxactiviteaahform.activitePartielAah.$invalid \n" +
    "                        && (!vm.tauxactiviteaahform.activitePartielAah.$pristine\n" +
    "                            || vm.tauxactiviteaahform.activitePartielAah.$touched)\n" +
    "                        }\"><div class=col-sm-2><label class=\"btn btn-default btn-block\" title=\"Indiquer si vous exercez cette activité à temps partiel. Une sélection est obligatoire.\" ng-model=vm.data.activitePartielAah uib-btn-radio=true for=activitePartielAahOui>Oui</label><input type=radio name=activitePartielAah class=sr-only id=activitePartielAahOui ng-model=vm.data.activitePartielAah ng-model-options=\"{ updateOn: 'blur'}\" value=true aria-describedby=\"\n" +
    "                            activitePartielAahInfoRequired\n" +
    "                            activitePartielAahErreurRequired\" required></div><div class=col-sm-2><label class=\"btn btn-default btn-block\" title=\"Indiquer si vous exercez cette activité à temps partiel. Une sélection est obligatoire.\" ng-model=vm.data.activitePartielAah uib-btn-radio=false for=activitePartielAahNon>Non</label><input type=radio name=activitePartielAah class=sr-only id=activitePartielAahNon ng-model=vm.data.activitePartielAah ng-model-options=\"{ updateOn: 'blur'}\" value=false aria-describedby=\"\n" +
    "                            activitePartielAahInfoRequired\n" +
    "                            activitePartielAahErreurRequired\" required></div></div><div id=activitePartielAahInfoRequired class=sr-only><p>Vous devez obligatoirement indiquer si vous exercez une activité à temps partiel.</p></div><cnaf-cct-erreur-input iderreur=activitePartielAahErreurRequired condition=\"{{(!vm.tauxactiviteaahform.activitePartielAah.$pristine || vm.tauxactiviteaahform.activitePartielAah.$touched)\n" +
    "                                    && vm.tauxactiviteaahform.activitePartielAah.$error.required}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></fieldset><div class=row ng-if=vm.data.activitePartielAah><div class=col-sm-4><div><label class=\"label-form-cnaf control-label\" for=tauxPartielAah>Préciser le taux d'activité</label></div><div><div class=\"col-sm-10 form-group input-group has-feedback\" ng-class=\"{'has-error' : (\n" +
    "                             vm.tauxactiviteaahform.tauxPartielAah.$invalid && \n" +
    "                                !vm.tauxactiviteaahform.tauxPartielAah.$pristine &&\n" +
    "                             vm.tauxactiviteaahform.tauxPartielAah.$error.pattern)}\"><input id=tauxPartielAah ng-model=vm.data.tauxPartielAah title=\"Indiquer le % d'activité figurant sur votre contrat de travail ou son avenant (exemple 50). Une sélection est obligatoire.\" name=tauxPartielAah class=form-control pattern=(^(0?[1-9]|[1-9][0-9])$) maxlength=2 placeholder=\"Exemple : 50\" ng-required=true aria-describedby=\"\n" +
    "                                tauxPartielAahRequired \n" +
    "                                tauxPartielAahPattern\"> <span class=input-group-btn><span class=\"picto cct-picto-poucentage-cnaf form-control-feedback\"></span><cnaf-aide styleclass=pull-right data-id-content-cnaf=content-popover-tauxPartielAah data-container=body data-trigger=manual tabindex=0></span><div class=hidden id=content-popover-tauxPartielAah><div class=popover-btn-close-cnaf></div>Indiquer le % d'activité figurant sur votre contrat de travail ou son avenant (inutile de saisir les chiffres après la virgule).</div></div><div><cnaf-cct-erreur-input iderreur=tauxPartielAahRequired condition=\"{{(vm.tauxactiviteaahform.tauxPartielAah.$invalid \n" +
    "                                        && !vm.tauxactiviteaahform.tauxPartielAah.$pristine)\n" +
    "                                    && vm.tauxactiviteaahform.tauxPartielAah.$error.required}}\" message=\"Champ obligatoire.\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=tauxPartielAahPattern condition=\"{{(vm.tauxactiviteaahform.tauxPartielAah.$invalid \n" +
    "                                        && !vm.tauxactiviteaahform.tauxPartielAah.$pristine)\n" +
    "                                    && vm.tauxactiviteaahform.tauxPartielAah.$error.pattern\n" +
    "                                    && !vm.tauxactiviteaahform.tauxPartielAah.$error.required}}\" message=\"Le taux d'activité doit être compris entre 1 et 99 sans décimale.\"></cnaf-cct-erreur-input></div></div></div></div></div><div class=visible-xs-inline><span ng-init=vm.initClassXs()></span></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-texte-ebo/cnaf-cct-situationpro-texte-ebo.html","<div class=row><div class=col-sm-12><p class=texte-info-cnaf><img alt=\"\" src=/icfstatiquesangularappli/dist/images/InformationsGris.png> Les bourses attribuées dans le cadre de recherche, de stage (CNRS, CNE...) ou d’échanges européens (Erasmus, Socrates...) ou bourses d'excellence ne permettent pas le statut d'étudiant boursier</p></div></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-autre-situation/datedeb-activite/cnaf-cct-situationpro-datedeb-activite.html","<label class=\"label-form-cnaf control-label\" for=dateActiviteAutreSitu>{{vm.intitulelabel}}</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "            (vm.datedebform.dateActiviteAutreSitu.$invalid\n" +
    "            && (!vm.datedebform.dateActiviteAutreSitu.$pristine\n" +
    "                    || vm.datedebform.dateActiviteAutreSitu.$touched)   )\n" +
    "            || ((vm.datedebform.dateActiviteAutreSitu.$error.pattern\n" +
    "                || vm.datedebform.dateActiviteAutreSitu.$error.controleSupDernJourMoisSuivDem\n" +
    "                || vm.datedebform.dateActiviteAutreSitu.$error.controleInfDateNaissance\n" +
    "                ||  (vm.controle.contexte === 'arriveeRetourCjt' && vm.datedebform.dateActiviteAutreSitu.$error.controleDateSitProSitfamCouple))\n" +
    "                && vm.data.sitPros[vm.index].dateActiviteAutreSitu\n" +
    "                && vm.data.sitPros[vm.index].dateActiviteAutreSitu.length == 10\n" +
    "                && vm.data.sitPros[vm.index].dateActiviteAutreSitu !== 'jj/mm/aaaa')\n" +
    "          }\"><div class=input-group><input id=dateActiviteAutreSitu name=dateActiviteAutreSitu title=\"Saisie de la date de début d'activité. Champ obligatoire. Au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010)\" placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateActiviteAutreSitu class=form-control ui-validate=\"{controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                            controleSupDernJourMoisSuivDem  : 'vm.controleSupDernJourMoisSuivDem($value, vm.controle.dernJourMoisSuivDem, vm.index)',\n" +
    "                            controleDateSitProSitfamCouple  : 'vm.controleDateSitProSitfamCouple($value, vm.controle, vm.index)'\n" +
    "                        }\" aria-describedby=\"\n" +
    "                  datedebInfodateActiviteAutreSituRequired\n" +
    "                  datedebErreurdateActiviteAutreSituRequired\n" +
    "                  datedebErreurdateActiviteAutreSituPattern\n" +
    "                  datedebErreurControleInfDateNaissance\n" +
    "                  datedebErreurControleSupDernJourMoisSuivDem\n" +
    "                  datedebErreurControleDateSitProSitfamCouple\" required pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateActiviteAutreSitu start-year=1980 pattern-cnaf=dd/MM/yyyy inputname=dateActiviteAutreSitu></cnaf-date-picker></div></div><div id=datedebInfodateActiviteAutreSituRequired class=sr-only><p>Champ Obligatoire</p></div><cnaf-cct-erreur-input iderreur=datedebErreurdateActiviteAutreSituRequired condition=\"{{(!vm.datedebform.dateActiviteAutreSitu.$pristine || vm.datedebform.dateActiviteAutreSitu.$touched) \n" +
    "                                          && vm.datedebform.dateActiviteAutreSitu.$error.required}}\" message=\"Champ obligatoire.\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=datedebErreurdateActiviteAutreSituPattern condition=\"{{vm.datedebform.dateActiviteAutreSitu.$error.pattern \n" +
    "                                        && vm.data.sitPros[vm.index].dateActiviteAutreSitu\n" +
    "                                        && vm.data.sitPros[vm.index].dateActiviteAutreSitu.length === 10\n" +
    "                                        && vm.data.sitPros[vm.index].dateActiviteAutreSitu !== 'jj/mm/aaaa'}}\" message=\"Format de date invalide, la saisie doit contenir 10 caractères et être au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=datedebErreurControleInfDateNaissance condition=\"{{!vm.datedebform.dateActiviteAutreSitu.$error.required\n" +
    "                            && vm.data.sitPros[vm.index].dateActiviteAutreSitu !== 'jj/mm/aaaa'\n" +
    "                            && !vm.datedebform.dateActiviteAutreSitu.$error.pattern\n" +
    "                            && vm.datedebform.dateActiviteAutreSitu.$error.controleInfDateNaissance}}\" message=\"La date saisie ne peut être inférieure à la date de naissance ({{vm.controle.datenaissance | date:'dd/MM/yyyy'}}).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=datedebErreurControleSupDernJourMoisSuivDem condition=\"{{!vm.datedebform.dateActiviteAutreSitu.$error.required\n" +
    "                            && vm.data.sitPros[vm.index].dateActiviteAutreSitu !== 'jj/mm/aaaa'\n" +
    "                            && !vm.datedebform.dateActiviteAutreSitu.$error.pattern\n" +
    "                            && vm.datedebform.dateActiviteAutreSitu.$error.controleSupDernJourMoisSuivDem}}\" message=\"La date saisie ne peut être postérieure à la date du {{vm.controle.dernJourMoisSuivDem | date:'dd/MM/yyyy'}}\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=datedebErreurControleDateSitProSitfamCouple condition=\"{{!vm.datedebform.dateActiviteAutreSitu.$error.required\n" +
    "                            && vm.data.sitPros[vm.index].dateActiviteAutreSitu !== 'jj/mm/aaaa'\n" +
    "                            && !vm.datedebform.dateActiviteAutreSitu.$error.pattern\n" +
    "                            && vm.controle.contexte === 'arriveeRetourCjt'\n" +
    "                            && vm.datedebform.dateActiviteAutreSitu.$error.controleDateSitProSitfamCouple}}\" message=\"Vous devez saisir une date d'activité antérieure au {{vm.controle.dateSitfam | date:'dd/MM/yyyy'}}\"></cnaf-cct-erreur-input>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-autre-situation/datefin-activite/cnaf-cct-situationpro-datefin-activite.html","<label class=\"label-form-cnaf control-label\" for=dateFinActiviteAutreSitu>{{vm.intitulelabel}}</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "              (vm.datefinform.dateFinActiviteAutreSitu.$invalid\n" +
    "                && !vm.datefinform.dateFinActiviteAutreSitu.$pristine)\n" +
    "                 || ( (!vm.datefinform.dateFinActiviteAutreSitu.$pristine|| vm.datefinform.dateFinActiviteAutreSitu.$touched)\n" +
    "                     && (vm.data.sitPros[vm.index].dateFinActiviteAutreSitu == undefined \n" +
    "                        || vm.data.sitPros[vm.index].dateFinActiviteAutreSitu == 'jj/mm/aaaa')\n" +
    "                            &&  vm.obligatoire==='Oui')\n" +
    "                 ||  ( (vm.data.sitPros[vm.index].dateFinActiviteAutreSitu\n" +
    "                        && vm.data.sitPros[vm.index].dateFinActiviteAutreSitu == 10\n" +
    "                        && vm.data.sitPros[vm.index].dateFinActiviteAutreSitu !== 'jj/mm/aaaa')\n" +
    "                        && (vm.datefinform.dateFinActiviteAutreSitu.$error.pattern\n" +
    "                            || vm.datefinform.dateFinActiviteAutreSitu.$error.controleInfDateNaissance\n" +
    "                            || vm.datefinform.dateFinActiviteAutreSitu.$error.controleDateSup) )          \n" +
    "            }\"><div class=input-group><input id=dateFinActiviteAutreSitu name=dateFinActiviteAutreSitu title=\"Saisie de la date de fin d'activité. Au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010)\" placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].dateFinActiviteAutreSitu class=form-control ng-required=\"vm.obligatoire==='Oui'\" ui-validate=\"{\n" +
    "                    controleInfDateNaissance  : 'vm.controleInfDateNaissance($value, vm.controle.datenaissance)',\n" +
    "                    controleDateSup  : 'vm.controleDateSup(vm.data.sitPros[vm.index].dateActiviteAutreSitu, $value)'\n" +
    "                 }\" ui-validate-watch=\"'vm.data.sitPros[vm.index].dateActiviteAutreSitu'\" aria-describedby=\"\n" +
    "                  datefinInfodateFinActiviteAutreSituRequired\n" +
    "                  datefinErreurdateFinActiviteAutreSituRequired\n" +
    "                  datefinErreurdateFinActiviteAutreSituPattern\n" +
    "                  datefinErreurControleInfDateNaissance\n" +
    "                  datefinErreurControleDateSup\" pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].dateFinActiviteAutreSitu start-year=1980 end-year={{vm.datePickerEndYear}} pattern-cnaf=dd/MM/yyyy inputname=dateFinActiviteAutreSitu></cnaf-date-picker></div></div><div ng-if=\"vm.obligatoire==='Oui'\" id=datefinInfodateFinActiviteAutreSituRequired class=sr-only><p>Champ Obligatoire</p></div><cnaf-cct-erreur-input iderreur=datefinErreurdateFinActiviteAutreSituRequired condition=\"{{( (!vm.datefinform.dateFinActiviteAutreSitu.$pristine|| vm.datefinform.dateFinActiviteAutreSitu.$touched)\n" +
    "                                        && (vm.data.sitPros[vm.index].dateFinActiviteAutreSitu == undefined \n" +
    "                                        || vm.data.sitPros[vm.index].dateFinActiviteAutreSitu == 'jj/mm/aaaa')\n" +
    "                                        &&  vm.obligatoire==='Oui')}}\" message=\"Champ obligatoire.\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=datefinErreurdateFinActiviteAutreSituPattern condition=\"{{vm.datefinform.dateFinActiviteAutreSitu.$error.pattern \n" +
    "                                        && vm.data.sitPros[vm.index].dateFinActiviteAutreSitu\n" +
    "                                        && vm.data.sitPros[vm.index].dateFinActiviteAutreSitu.length === 10\n" +
    "                                        && vm.data.sitPros[vm.index].dateFinActiviteAutreSitu !== 'jj/mm/aaaa'}}\" message=\"Format de date invalide, la saisie doit contenir 10 caractères et être au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=datefinErreurControleInfDateNaissance condition=\"{{vm.data.sitPros[vm.index].dateFinActiviteAutreSitu !== undefined\n" +
    "                            && vm.data.sitPros[vm.index].dateFinActiviteAutreSitu !== 'jj/mm/aaaa'\n" +
    "                            && !vm.datefinform.dateFinActiviteAutreSitu.$error.pattern\n" +
    "                            && vm.datefinform.dateFinActiviteAutreSitu.$error.controleInfDateNaissance}}\" message=\"La date saisie ne peut être inférieure à la date de naissance ({{vm.controle.datenaissance | date:'dd/MM/yyyy'}}).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=datefinErreurControleDateSup condition=\"{{vm.data.sitPros[vm.index].dateFinActiviteAutreSitu !== undefined\n" +
    "                            && vm.data.sitPros[vm.index].dateFinActiviteAutreSitu !== 'jj/mm/aaaa'\n" +
    "                            && !vm.datefinform.dateFinActiviteAutreSitu.$error.pattern\n" +
    "                            && vm.datefinform.dateFinActiviteAutreSitu.$error.controleDateSup}}\" message=\"La date de fin doit être postérieure à la date de début.\"></cnaf-cct-erreur-input>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-autre-situation/detention/cnaf-cct-situationpro-detention.html","<div class=row><div class=col-sm-4><cnaf-cct-situationpro-datedeb autocompletion=vm.autocompletion data=vm.data datedebform=vm.detentionform errordatedeb=vm.errordatedeb intitulelabel=\"'Date de début de détention'\" controle=vm.controle index=vm.index></cnaf-cct-situationpro-datedeb></div><div class=col-sm-4><cnaf-cct-situationpro-datefin autocompletion=vm.autocompletion data=vm.data datefinform=vm.detentionform errordatefin=vm.errordatefin intitulelabel=\"'Date de fin de détention'\" obligatoire=\"'Non'\" controle=vm.controle index=vm.index></cnaf-cct-situationpro-datefin></div></div><cnaf-cct-situationpro-etablissement autocompletion=vm.autocompletion data=vm.data etablissementform=vm.detentionform erroretablissement=vm.erroretablissement controle=vm.controle intituleetablissement=\"'établissement pénitentiaire'\" index=vm.index></cnaf-cct-situationpro-etablissement>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-autre-situation/etablissement/cnaf-cct-situationpro-etablissement.html","<fieldset><legend class=sr-only>Coordonnées de l’{{vm.intituleetablissement}}</legend><div class=row><div class=col-sm-6><label class=label-form-cnaf for=nomEtablissement>Nom de l’{{vm.intituleetablissement}}</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                    vm.etablissementform.nomEtablissement.$invalid \n" +
    "                            && (!vm.etablissementform.nomEtablissement.$pristine\n" +
    "                                 || vm.etablissementform.nomEtablissement.$touched)\n" +
    "                }\"><input id=nomEtablissement maxlength=30 ng-model=vm.data.sitPros[vm.index].nomEtablissement ng-change=\"vm.data.sitPros[vm.index].nomEtablissement = vm.data.sitPros[vm.index].nomEtablissement.toUpperCase()\" ng-pattern=\"/^[0-9a-zA-Zà-ÿÀ-Ÿ '-]*$/\" ng-blur=\"vm.testType8(vm.data.sitPros[vm.index].nomEtablissement,vm.etablissementform,'nomEtablissement')\" ng-trim=false name=nomEtablissement title=\"Indiquer le nom de l’{{vm.intituleetablissement}}. Champ obligatoire.\" class=form-control aria-describedby=\"\n" +
    "                            etablissementInfonomEtablissementRequired\n" +
    "                            etablissementErreurnomEtablissementRequired\n" +
    "                            etablissementErreurnomEtablissementPattern\" required></div><div id=etablissementInfonomEtablissementRequired class=sr-only><p>Champ obligatoire</p></div><cnaf-cct-erreur-input iderreur=etablissementErreurnomEtablissementRequired condition=\"{{(!vm.etablissementform.nomEtablissement.$pristine\n" +
    "                                        || vm.etablissementform.nomEtablissement.$touched) && vm.etablissementform.nomEtablissement.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=etablissementErreurnomEtablissementPattern condition=\"{{vm.etablissementform.nomEtablissement.$error.pattern || vm.etablissementform.nomEtablissement.$error.type8}}\" message=\"La saisie comporte des caractères non autorisés\"></cnaf-cct-erreur-input></div><div class=col-sm-6><label class=label-form-cnaf for=paysActivite>Pays de l'{{vm.intituleetablissement}}</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                                vm.etablissementform.paysActivite.$invalid\n" +
    "                                && (!vm.etablissementform.paysActivite.$pristine\n" +
    "                                        || vm.etablissementform.paysActivite.$touched)\n" +
    "                                \n" +
    "                    }\"><input id=paysActivite ng-model=vm.data.sitPros[vm.index].paysActivite name=paysActivite title=\"Indiquer le pays de l'{{vm.intituleetablissement}}. Champ obligatoire.\" class=form-control typeahead-min-length=2 uib-typeahead=\"pays as pays.libelleCaffr for pays in vm.getListePaysEmployeurProposes($viewValue) | filter:$viewValue | limitTo:8\" typeahead-editable=false typeahead-no-results=noPaysFound aria-describedby=\"\n" +
    "                                etablissementInfopaysActiviteRequired\n" +
    "                                etablissementErreurpaysActiviteRequired\n" +
    "                                etablissementErreurpaysActiviteNotFound\" required></div><div id=etablissementInfopaysActiviteRequired class=sr-only><p>Vous devez obligatoirement saisir le pays de l'{{vm.intituleetablissement}}</p></div><cnaf-cct-erreur-input iderreur=etablissementErreurpaysActiviteRequired condition=\"{{(!vm.etablissementform.paysActivite.$pristine\n" +
    "                                        || vm.etablissementform.paysActivite.$touched) && vm.etablissementform.paysActivite.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=etablissementErreurpaysActiviteNotFound condition=\"{{noPaysFound && !vm.etablissementform.paysActivite.$error.required}}\" message=\"Pays non trouvé\"></cnaf-cct-erreur-input></div></div><div class=row ng-if=vm.afficheVilleEtranger(vm.index)><div class=col-sm-6><label class=label-form-cnaf for=villeEtablissement>Ville de l’{{vm.intituleetablissement}}</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                        vm.etablissementform.villeEtablissement.$invalid \n" +
    "                            && (!vm.etablissementform.villeEtablissement.$pristine\n" +
    "                                || vm.etablissementform.villeEtablissement.$touched)\n" +
    "                          \n" +
    "                    }\"><input id=villeEtablissement ng-model=vm.data.sitPros[vm.index].villeEtablissement ng-model-options=\"{ updateOn: 'blur' }\" ng-change=\"vm.data.sitPros[vm.index].villeEtablissement = vm.data.sitPros[vm.index].villeEtablissement.toUpperCase()\" ui-validate=\"{type5  : 'vm.testType5($value,vm.etablissementform)'}\" ng-trim=false name=villeEtablissement maxlength=38 class=form-control title=\"Indiquer la ville de l'{{vm.intituleetablissement}}. Champ obligatoire.\" aria-describedby=\"\n" +
    "                        etablissementInfovilleEtablissementRequired\n" +
    "                        etablissementErreurvilleEtablissementRequired\n" +
    "                        etablissementErreurvilleEtablissementPattern\" required ng-pattern=\"/^[a-zA-Z0-9à-ÿÀ-Ÿ -']*$/\"></div><div id=etablissementInfovilleEtablissementRequired class=sr-only><p>Champ obligatoire</p></div><cnaf-cct-erreur-input iderreur=etablissementErreurvilleEtablissementRequired condition=\"{{(!vm.etablissementform.villeEtablissement.$pristine || vm.etablissementform.villeEtablissement.$touched) \n" +
    "                                                    && vm.etablissementform.villeEtablissement.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=etablissementErreurvilleEtablissementPattern condition=\"{{(vm.adresseform.etrangerVille.$invalid \n" +
    "                                                    && !vm.adresseform.etrangerVille.$pristine\n" +
    "                                                    && !vm.etablissementform.villeEtablissement.$error.required)\n" +
    "                                                  && (vm.etablissementform.villeEtablissement.$error.pattern \n" +
    "                                                        || vm.etablissementform.villeEtablissement.$error.type5)}}\" message=\"La saisie comporte des caractères non autorisés\"></cnaf-cct-erreur-input></div></div><div class=row ng-if=vm.afficheCodePostalVille(vm.index)><div class=col-sm-6><label class=label-form-cnaf for=codePostalZoneActivite>Code postal / Commune de l'{{vm.intituleetablissement}}</label><div ng-switch on=vm.autocompletion><div ng-switch-when=on class=form-group ng-class=\"{ 'has-error' :\n" +
    "                            vm.etablissementform.codePostalZoneActivite.$invalid\n" +
    "                                && (!vm.etablissementform.codePostalZoneActivite.$pristine\n" +
    "                                       || vm.etablissementform.codePostalZoneActivite.$touched)\n" +
    "                                \n" +
    "                    }\"><input id=codePostalZoneActivite ng-model=vm.data.sitPros[vm.index].codePostalZoneActivite name=codePostalZoneActivite title=\"Indiquer le code postal et la commune de l'{{vm.intituleetablissement}}. Champ obligatoire.\" class=form-control typeahead-min-length=2 uib-typeahead=\"result as result.lib for result in vm.codePostalVilles($viewValue)\" typeahead-editable=false aria-describedby=\"\n" +
    "                            etablissementInfocodePostalZoneActiviteRequired\n" +
    "                            etablissementErreurcodePostalZoneActiviteRequired\" required></div><div ng-switch-when=off class=form-group ng-class=\"{ 'has-error' :\n" +
    "                        vm.etablissementform.codePostalZoneActivite.$invalid\n" +
    "                            && (!vm.etablissementform.codePostalZoneActivite.$pristine\n" +
    "                                       || vm.etablissementform.codePostalZoneActivite.$touched)\n" +
    "                        \n" +
    "                    }\"><input id=codePostalZoneActivite ng-model=vm.data.sitPros[vm.index].codePostalZoneActivite name=codePostalZoneActivite title=\"Indiquer le code postal et la commune de l'{{vm.intituleetablissement}}. Champ obligatoire.\" class=form-control ui-validate=\"{controleCodePostalFormat  : 'vm.controleCodePostalFormat($value)'}\" ng-trim=false aria-describedby=\"\n" +
    "                                etablissementInfocodePostalZoneActiviteRequired\n" +
    "                                etablissementErreurcodePostalZoneActiviteRequired\n" +
    "                                etablissementErreurcodePostalZoneActiviteFormat\" required></div><div id=etablissementInfocodePostalZoneActiviteRequired class=sr-only><p>Champ obligatoire</p></div><cnaf-cct-erreur-input iderreur=etablissementInfocodePostalZoneActiviteRequired condition=\"{{(!vm.etablissementform.codePostalZoneActivite.$pristine\n" +
    "                                            || vm.etablissementform.codePostalZoneActivite.$touched) && vm.etablissementform.codePostalZoneActivite.$error.required}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=etablissementErreurcodePostalZoneActiviteFormat condition={{vm.etablissementform.villeEtablissement.$error.controleCodePostalFormat}} message=\"Code postal incorrect. La saisie doit comporter 5 chiffres consécutifs et les 2 permiers doivent être compris entre 01 et 98\"></cnaf-cct-erreur-input></div></div></div></fieldset>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-autre-situation/maladie/cnaf-cct-situationpro-maladie.html","<div class=row><div class=col-sm-4><cnaf-cct-situationpro-datedeb autocompletion=vm.autocompletion data=vm.data datedebform=vm.maladieform errordatedeb=vm.errordatedeb intitulelabel=\"'Date de début de la maladie'\" controle=vm.controle index=vm.index></cnaf-cct-situationpro-datedeb></div></div><fieldset><legend class=label-form-cnaf>Il s'agit d'une affection longue durée</legend><div class=row><div class=col-sm-4><div class=\"row form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                            vm.maladieform.affectionLongueDuree.$invalid\n" +
    "                                && (!vm.maladieform.affectionLongueDuree.$pristine\n" +
    "                                     || vm.maladieform.affectionLongueDuree.$touched)\n" +
    "                                \n" +
    "                                }\"><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].affectionLongueDuree uib-btn-radio=\"'Oui'\" title=\"Indiquer s'il s'agit d'une affection longue durée. Une sélection est obligatoire.\" for=affectionLongueDureeOui><input type=radio name=affectionLongueDuree class=sr-only id=affectionLongueDureeOui ng-model=vm.data.sitPros[vm.index].affectionLongueDuree ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"\n" +
    "                                    maladieInfoaffectionLongueDureeRequired\n" +
    "                                    maladieErreuraffectionLongueDureeRequired\" value=oui required> Oui</label></div><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].affectionLongueDuree uib-btn-radio=\"'Non'\" title=\"Indiquer s'il s'agit d'une affection longue durée. Une sélection est obligatoire.\" for=affectionLongueDureeNon><input type=radio name=affectionLongueDuree class=sr-only id=affectionLongueDureeNon ng-model=vm.data.sitPros[vm.index].affectionLongueDuree ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"\n" +
    "                                    maladieInfoaffectionLongueDureeRequired\n" +
    "                                    maladieErreuraffectionLongueDureeRequired\" value=non required> Non</label></div></div></div></div><div id=maladieInfoaffectionLongueDureeRequired class=sr-only><p>Vous devez obligatoirement indiquer s'il s'agit d'une affection longue durée.</p></div><cnaf-cct-erreur-input iderreur=maladieErreuraffectionLongueDureeRequired condition=\"{{(!vm.maladieform.affectionLongueDuree.$pristine || vm.maladieform.affectionLongueDuree.$touched) \n" +
    "                                                && vm.maladieform.affectionLongueDuree.$error.required}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></fieldset><div class=row ng-if=\"vm.data.sitPros[vm.index].affectionLongueDuree == 'Oui'\"><div class=col-sm-12><label class=\"label-form-cnaf control-label\" for=datePriseEnCompteAffection>Date de prise en compte de cette affection par l'organisme d'assurance maladie</label><div class=\"row form-group\" ng-class=\"{ 'has-error' :\n" +
    "                    vm.maladieform.datePriseEnCompteAffection.$invalid\n" +
    "                    && (!vm.maladieform.datePriseEnCompteAffection.$pristine\n" +
    "                          || vm.maladieform.datePriseEnCompteAffection.$touched)\n" +
    "                }\"><div class=col-sm-4><div class=input-group id=divdatePriseEnCompteAffection><input id=datePriseEnCompteAffection name=datePriseEnCompteAffection title=\"Saisie de la date de prise en compte de l'affection longue durée. Champ obligatoire. Au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010)\" placeholder=jj/mm/aaaa ui-mask=99/99/9999 ui-options={allowInvalidValue:true,clearOnBlur:false} model-view-value=true ng-model=vm.data.sitPros[vm.index].datePriseEnCompteAffection class=form-control ng-required=true ui-validate=\"{\n" +
    "                                    controleDateSupOuEgale  : 'vm.controleDateSupOuEgale(vm.data.sitPros[vm.index].dateActiviteAutreSitu, $value)'\n" +
    "                                }\" aria-describedby=\"\n" +
    "                                maladieInfodatePriseEnCompteAffectionRequired\n" +
    "                                maladieErreurdatePriseEnCompteAffectionRequired\n" +
    "                                maladieErreurdatePriseEnCompteAffectionPattern\n" +
    "                                maladieErreurControleDateSupOuEgale\" pattern=^(?:(?:31(\\/|-)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$><cnaf-date-picker ng-model=vm.data.sitPros[vm.index].datePriseEnCompteAffection start-year=1910 pattern-cnaf=dd/MM/yyyy inputname=datePriseEnCompteAffection></cnaf-date-picker></div><div id=maladieInfodatePriseEnCompteAffectionRequired class=sr-only><p>Champ Obligatoire</p></div><cnaf-cct-erreur-input iderreur=maladieErreurdatePriseEnCompteAffectionRequired condition=\"{{(!vm.maladieform.datePriseEnCompteAffection.$pristine || vm.maladieform.datePriseEnCompteAffection.$touched) \n" +
    "                                                            && vm.maladieform.datePriseEnCompteAffection.$error.required}}\" message=\"Champ obligatoire.\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=maladieErreurdatePriseEnCompteAffectionPattern condition=\"{{vm.maladieform.datePriseEnCompteAffection.$error.pattern \n" +
    "                                                        && vm.data.sitPros[vm.index].datePriseEnCompteAffection\n" +
    "                                                        && vm.data.sitPros[vm.index].datePriseEnCompteAffection.length === 10\n" +
    "                                                        && vm.data.sitPros[vm.index].datePriseEnCompteAffection !== 'jj/mm/aaaa'}}\" message=\"Format de date invalide, la saisie doit contenir 10 caractères et être au format jj/mm/aaaa (exemple 01/01/2010 pour le 1er janvier 2010).\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=maladieErreurControleDateSupOuEgale condition=\"{{!vm.maladieform.datePriseEnCompteAffection.$error.required\n" +
    "                                            && vm.data.sitPros[vm.index].datePriseEnCompteAffection !== 'jj/mm/aaaa'\n" +
    "                                            && !vm.maladieform.datePriseEnCompteAffection.$error.pattern\n" +
    "                                            && vm.maladieform.datePriseEnCompteAffection.$error.controleDateSupOuEgale}}\" message=\"La date de prise en compte de la maladie doit être postérieure ou égale à la date de début de maladie.\"></cnaf-cct-erreur-input></div></div></div></div>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-autre-situation/orgacomm/cnaf-cct-situationpro-orgacomm.html","<div ng-if=vm.controle.profilAvecAAH><cnaf-cct-situationpro-taux-activite-aah autocompletion=vm.autocompletion data=vm.data tauxactiviteaahform=vm.orgacommform errorctauxactiviteaah=vm.errortauxactiviteaah controle=vm.controle index=vm.index></cnaf-cct-situationpro-taux-activite-aah></div><div class=row><div class=col-sm-4><cnaf-cct-situationpro-datedeb autocompletion=vm.autocompletion data=vm.data datedebform=vm.orgacommform errordatedeb=vm.errordatedeb intitulelabel=\"'Depuis le'\" controle=vm.controle index=vm.index></cnaf-cct-situationpro-datedeb></div></div><cnaf-cct-situationpro-etablissement autocompletion=vm.autocompletion data=vm.data etablissementform=vm.orgacommform erroretablissement=vm.erroretablissement controle=vm.controle intituleetablissement=\"'organisation communautaire'\" index=vm.index></cnaf-cct-situationpro-etablissement><fieldset><legend class=label-form-cnaf>Vous exercez une activité professionnelle</legend><div class=\"row form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                        vm.orgacommform.exerceActPro.$invalid\n" +
    "                            && (!vm.orgacommform.exerceActPro.$pristine\n" +
    "                                || vm.orgacommform.exerceActPro.$touched)\n" +
    "                        \n" +
    "                        }\"><div class=col-sm-3><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].exerceActPro uib-btn-radio=\"'Oui'\" title=\"Indiquer si vous exercez une activité professionnelle. Une sélection est obligatoire.\" for=exerceActProOui><input type=radio name=exerceActPro class=sr-only id=exerceActProOui ng-model=vm.data.sitPros[vm.index].exerceActPro ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"\n" +
    "                                orgacommInfoexerceActProRequired\n" +
    "                                orgacommErreurexerceActProRequired\" value=oui required> Oui</label></div><div class=col-sm-3><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].exerceActPro uib-btn-radio=\"'Non'\" title=\"Indiquer si vous exercez une activité professionnelle. Une sélection est obligatoire.\" for=exerceActProNon><input type=radio name=exerceActPro class=sr-only id=exerceActProNon ng-model=vm.data.sitPros[vm.index].exerceActPro ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"\n" +
    "                                orgacommInfoexerceActProRequired\n" +
    "                                orgacommErreurexerceActProRequired\" value=non required> Non</label></div></div><div id=orgacommInfoexerceActProRequired class=sr-only><p>Vous devez obligatoirement indiquer si vous exercez une activité professionnelle.</p></div><cnaf-cct-erreur-input iderreur=orgacommErreurexerceActProRequired condition=\"{{(!vm.orgacommform.exerceActPro.$pristine || vm.orgacommform.exerceActPro.$touched) \n" +
    "                                                && vm.orgacommform.exerceActPro.$error.required}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></fieldset>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-autre-situation/sansactivite/cnaf-cct-situationpro-sansactivite.html","<div class=row><div class=col-sm-3><cnaf-cct-situationpro-datedeb autocompletion=vm.autocompletion data=vm.data datedebform=vm.sansactiviteform errordatedeb=vm.errordatedeb intitulelabel=\"'Depuis le'\" controle=vm.controle index=vm.index></cnaf-cct-situationpro-datedeb></div></div><fieldset><legend class=\"label-form-cnaf control-label\">{{vm.controle.libPersonneSansActi}}</legend><div class=row><div class=col-sm-6><div class=\"row form-group btn-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                            vm.sansactiviteform.poleEmploi.$invalid\n" +
    "                                && (!vm.sansactiviteform.poleEmploi.$pristine\n" +
    "                                    || vm.sansactiviteform.poleEmploi.$touched)\n" +
    "                            \n" +
    "                            }\"><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].poleEmploi title=\"Indiquer si vous êtes inscrit à France Travail. Une sélection est obligatoire.\" uib-btn-radio=\"'Oui'\" for=poleEmploiOui><input type=radio name=poleEmploi class=sr-only id=poleEmploiOui ng-model=vm.data.sitPros[vm.index].poleEmploi ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"\n" +
    "                                    sansactiviteInfopoleEmploiRequired\n" +
    "                                    sansactiviteErreurpoleEmploiRequired\" value=oui required> Oui</label></div><div class=col-sm-6><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].poleEmploi title=\"Indiquer si vous êtes inscrit à France Travail. Une sélection est obligatoire.\" uib-btn-radio=\"'Non'\" for=poleEmploiNon><input type=radio name=poleEmploi class=sr-only id=poleEmploiNon ng-model=vm.data.sitPros[vm.index].poleEmploi ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"\n" +
    "                                    sansactiviteInfopoleEmploiRequired\n" +
    "                                    sansactiviteErreurpoleEmploiRequired\" value=non required> Non</label></div></div></div><div class=row ng-if=\"vm.data.sitPros[vm.index].poleEmploi === 'Non'\"><div class=col-sm-12><p class=texte-info-cnaf><img alt=\"\" src=/icfstatiquesangularappli/dist/images/InformationsGris.png> <em>Si vous vous inscrivez à France Travail, pensez à mettre à jour votre profil sur le caf.fr > espace mon compte > situation professionnelle</em></p></div></div></div><div id=sansactiviteInfopoleEmploiRequired class=sr-only><p>Vous devez obligatoirement indiquer si vous êtes inscrit à France Travail.</p></div><cnaf-cct-erreur-input iderreur=sansactiviteErreurpoleEmploiRequired condition=\"{{(!vm.sansactiviteform.poleEmploi.$pristine || vm.sansactiviteform.poleEmploi.$touched) \n" +
    "                                            && vm.sansactiviteform.poleEmploi.$error.required}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></fieldset>")

$templateCache.put("components/cnaf-cct-situationpro/cnaf-cct-situationpro-autre-situation/volontariat/cnaf-cct-situationpro-volontariat.html","<fieldset><legend class=label-form-cnaf>Préciser la situation</legend><div class=\"row form-group btn-block\" data-toggle=buttons role=radiogroup ng-class=\"{ 'has-error' :\n" +
    "                    vm.volontariatform.choixAutreSituationVolontariat.$invalid\n" +
    "                        && (!vm.volontariatform.choixAutreSituationVolontariat.$pristine\n" +
    "                              || vm.volontariatform.choixAutreSituationVolontariat.$touched)    \n" +
    "                    }\"><div class=col-sm-6 ng-repeat=\"volontariat in vm.listechoixautresituationvolontariat\"><label class=\"btn btn-default btn-block\" ng-model=vm.data.sitPros[vm.index].choixAutreSituationVolontariat uib-btn-radio=volontariat title=\"Préciser la situation de volontariat. Une sélection est obligatoire.\" for={{volontariat.id}}><input type=radio name=choixAutreSituationVolontariat class=sr-only id={{volontariat.id}} ng-model=vm.data.sitPros[vm.index].choixAutreSituationVolontariat ng-model-options=\"{ updateOn: 'blur'}\" aria-describedby=\"volontariatInfoChoixVolontariatRequired \n" +
    "                                          volontariatErreurChoixVolontariatRequired\" required> {{volontariat.libelle}}</label></div></div><div id=volontariatInfoChoixVolontariatRequired class=sr-only><p>Vous devez obligatoirement choisir une situation parmi celles proposées.</p></div><cnaf-cct-erreur-input iderreur=volontariatErreurChoixVolontariatRequired condition=\"{{(!vm.volontariatform.choixAutreSituationVolontariat.$pristine\n" +
    "                                || vm.volontariatform.choixAutreSituationVolontariat.$touched) && vm.volontariatform.choixAutreSituationVolontariat.$error.required}}\" message=\"Sélection obligatoire.\"></cnaf-cct-erreur-input></fieldset><div class=row><div class=col-sm-4><cnaf-cct-situationpro-datedeb autocompletion=vm.autocompletion data=vm.data datedebform=vm.volontariatform errordatedeb=vm.errordatedeb intitulelabel=\"'Depuis le'\" controle=vm.controle index=vm.index></cnaf-cct-situationpro-datedeb></div></div><div class=row ng-if=\"vm.data.sitPros[vm.index].choixAutreSituationVolontariat.id && vm.data.sitPros[vm.index].choixAutreSituationVolontariat.id == 'VINTER'\"><div class=col-sm-6><label class=label-form-cnaf for=paysActivite>Pays où se déroule le volontariat</label><div class=form-group ng-class=\"{ 'has-error' :\n" +
    "                            (vm.volontariatform.paysActivite.$invalid\n" +
    "                            && !vm.volontariatform.paysActivite.$pristine)\n" +
    "                       }\"><input id=paysActivite ng-model=vm.data.sitPros[vm.index].paysActivite name=paysActivite title=\"Indiquer le pays où se déroule le volontariat. Champ obligatoire.\" class=form-control typeahead-min-length=2 uib-typeahead=\"pays as pays.libelleCaffr for pays in vm.getListePaysEmployeurProposes($viewValue) | filter:$viewValue | limitTo:8\" typeahead-editable=false typeahead-no-results=noPaysFound aria-describedby=\"\n" +
    "                            volontariatInfopaysActiviteRequired\n" +
    "                            volontariatErreurpaysActiviteRequired\n" +
    "                            volontariatErreurpaysActiviteNotFound\" required></div><div id=volontariatInfopaysActiviteRequired class=sr-only><p>Vous devez obligatoirement saisir le pays où se déroule le volontariat</p></div><cnaf-cct-erreur-input iderreur=volontariatErreurpaysActiviteRequired condition=\"{{vm.volontariatform.paysActivite.$error.required && !vm.volontariatform.paysActivite.$pristine}}\" message=\"Champ obligatoire\"></cnaf-cct-erreur-input><cnaf-cct-erreur-input iderreur=volontariatErreurpaysActiviteNotFound condition=\"{{noPaysFound && !vm.volontariatform.paysActivite.$error.required}}\" message=\"Pays non trouvé\"></cnaf-cct-erreur-input></div></div>")

$templateCache.put("directives/cnaf-cct-modal-sitFamCouple/cnaf-cct-modal-sitFamCouple-web.html","<div id=modalSitFamCouple><div class=modal-body><p>Vous n'êtes pas le responsable des démarches vis à vis de la caf. Merci de demander à votre conjoint d'effectuer cette déclaration.</p><br><br><div style=\"text-align: center\"><button ng-click=vm.cancel() type=button name=BCQuitter alt=Quitter class=\"btn btn-default btn-majeur-cnaf\" style=\"pointer-events: all; cursor: pointer\"><span>Quitter</span></button></div></div></div>")

$templateCache.put("directives/cnaf-cct-modal-telepro-debut/cnaf-cct-modal-telepro-debut.html","<div id=modal-telepro-debut tabindex=-1 role=dialog aria-modal=true aria-labelledby=modal-title-telepro-debut><div class=modal-header><button type=button class=close-cnaf data-dismiss=modal aria-label=\"Fermer la popup\" ng-click=modalTeleproDebutVm.fermer()></button><div role=heading aria-level=1 class=\"texte-medium text-primary\" id=modal-title-telepro-debut>A savoir avant de commencer</div></div><div class=modal-body id=modal-body-telepro-debut><p ng-if=modalTeleproDebutVm.dataModal.isWeb class=\"pic-modal-cnaf pic-temps-cnaf\">Chaque changement de situation comprend 3 étapes et dure en moyenne 2 minutes</p><p ng-if=\"modalTeleproDebutVm.dataModal.isWeb === undefined || !modalTeleproDebutVm.dataModal.isWeb\" class=\"pic-modal-cnaf pic-temps-cnaf\">Votre démarche comprend {{modalTeleproDebutVm.dataModal.nbetapes}} étapes, sa durée est estimée entre {{modalTeleproDebutVm.dataModal.tmin}} et {{modalTeleproDebutVm.dataModal.tmax}} minutes.</p><p class=\"pic-modal-cnaf pic-aide-bleu-grd-cnaf\">Des bulles d'aide s'affichent pour vous expliquer les informations à saisir. Cliquez sur le point d'interrogation pour y accéder.</p><p class=text-center style=\"padding-top: 1em;padding-bottom: 1em\"><button ng-if=modalTeleproDebutVm.dataModal.actionClick ng-click=modalTeleproDebutVm.dataModal.actionClick() type=button title=Commencer class=\"btn btn-form-cnaf btn-majeur-cnaf unset-width\" style=\"pointer-events: all; cursor: pointer\">Commencer</button> <a ng-if=!modalTeleproDebutVm.dataModal.actionClick ng-href={{modalTeleproDebutVm.dataModal.href}} class=\"btn btn-default btn-majeur-cnaf align-middle-cnaf\" title=Commencer>Commencer</a></p><figure ng-if=modalTeleproDebutVm.dataModal.numcerfa class=text-center><a target=_blank rel=\"noopener noreferrer\">title='Nouvelle fenêtre : Critères de qualité \"Cerfa Numérique\" de cette démarche en ligne. Ouverture dans un nouvel onglet.' ng-href=\"https://cerfa.numerique.gouv.fr/demarche/{{modalTeleproDebutVm.dataModal.numcerfa}}\"> <img alt='Nouvelle fenêtre : Critères de qualité \"Cerfa Numérique\" de cette démarche en ligne.' src=/cnafcomponentsteleprocappli/dist/img/CERFA.png style=height:5rem;width:5rem></a><figcaption>Cette&nbsp;démarche a&nbsp;reçu le&nbsp;label Cerfa&nbsp;Numérique</figcaption></figure></div></div>")

$templateCache.put("directives/cnaf-cct-modal-telepro-fin/cnaf-cct-modal-telepro-fin.html","<div class=modal-header><button type=button class=close-cnaf data-dismiss=modal aria-label=\"Fermer la popup\" ng-click=modalTeleproFinVm.fermer()></button><div role=heading aria-level=1 class=\"texte-medium text-primary\" id=modal-title-telepro-fin>Mon profil</div></div><div class=modal-body id=modal-body-telepro-fin><div><span>Vous venez d'effectuer {{modalTeleproFinVm.dataModal.typechangement}}. Avez-vous d'autres changements à effectuer ?</span></div></div><div class=modal-footer><a type=button class=\"btn btn-default pull-left\" ng-href={{modalTeleproFinVm.dataModal.href}} role=button alt=Non>Non </a><a type=button class=\"btn btn-default pull-right\" href=\"/redirect/s/Redirect?page=applimobileMonCompteMonProfil\" role=button alt=Oui>Oui</a></div>")
}]);
})();
(function() {
    'use strict';

    CnafCctAdresseSocleController.$inject = ['CnafCctAdresseSocleService','CnafCctGestionTypeService','CnafCctConstantMsgTypes'];

    function CnafCctAdresseSocleController(CnafCctAdresseSocleService,CnafCctGestionTypeService,CnafCctConstantMsgTypes) {
        var vm = this;
        vm.listePays = null;
        vm.isObligatoire = true;

        /* ------------------- */
        /*       SERVICE       */
        /* ------------------- */
        //AMABIS :
        vm.numEtAdresse = CnafCctAdresseSocleService.numEtAdresse;
        vm.codePostalVilles = CnafCctAdresseSocleService.codePostalVilles;
        vm.controleCodePostalFormat = CnafCctAdresseSocleService.controleCodePostalFormat;

        vm.testType5 = function(donnee,form){
          if (donnee === undefined || donnee.length === 0){
              form.$setValidity('type5', true);
          }
          else {
            var retourControles = CnafCctGestionTypeService.appelControleType5(donnee, form);
            if (retourControles !== null)
            {
                vm.data.etrangerVille=retourControles;
            }
          }
        };

        vm.testType7 = function(donnee,form,nomDonnee){
          if (donnee === undefined || donnee.length === 0){
              form.$setValidity('type7', true);
          }
          else {
            var retourControles = CnafCctGestionTypeService.appelControleType7(donnee, form);
            if (retourControles !== null)
            {
              vm.data[nomDonnee]=retourControles;
            }
          }
        };

        vm.testType12 = function(donnee,form){
          if (donnee === undefined || donnee.length === 0){
              form.$setValidity('type12', true);
          }
          else {
            var retourControles = CnafCctGestionTypeService.appelControleType12(donnee, form);
            if (retourControles !== null)
            {
                vm.data.codePostalVille=retourControles;
            }
          }
        };


        /* ------------------------------------------------------------------------------------------------------------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */

        vm.init = function() {
          CnafCctAdresseSocleService.getEtatAmabis().get()
              .$promise.then(
                  function successCallback(result) {
                      vm.autocompletion = "on";
                  },
                  function errorCallback(error) {
                      vm.autocompletion = "off";
                  });

          // Champs obligatoires ?
          if (vm.saisieobligatoire !== undefined)
          {
            vm.isObligatoire = vm.saisieobligatoire;
          }
          //Dans l'écran d'adresse, le champ code postal/commune est pré-renseigné
          //et n'est plus modifiable.
          //(pour garantir qu'on est bien sur le même code organisme que celui défini au niveau du test d'accès)
          vm.verrouillerCP = false;
          if (vm.controle && vm.controle.dateLogementAcces !== undefined)
          {
            vm.verrouillerCP = true;
          }
          vm.titlePays = vm.determineTitlePays();
          vm.titleNumEtAdresse = vm.determineTitleNumAdresse();
          vm.titleCPVille = vm.determineTitleCPVille();
          vm.titleVilleEtranger = vm.determineTitleVilleEtranger();
          vm.titleAdresseEtranger = vm.determineTitleAdresseEtranger();
        };

        //AUTO-COMPLETION

        vm.numEtAdresse = function(prefix) {
            //On ne fait la recherche que si on a une cleGeo ( que si une recherche a été effectué avec le cp et commune)
            if (vm.data.codePostalVille && vm.data.codePostalVille.cleGeo && vm.data.codePostalVille.cleGeoAgg) {
                return CnafCctAdresseSocleService.voies(vm.data.codePostalVille.cleGeo, vm.data.codePostalVille.cleGeoAgg, prefix).get()
                    .$promise.then(function(result) {
                        return result.listRechVoie;
                    });
            }
        };
        vm.codePostalVilles = function(prefix) {
            return CnafCctAdresseSocleService.localites(prefix, CnafCctAdresseSocleService.transformCodePays(vm.data.pays.code)).get()
                .$promise.then(function(result) {
                    return result.listRechLoc;
                });
        };

        /** Cette fonction reinitialise les erreurs sur la validation de l'adresse,
         * cela permet de relancer la validation de l'adresse en cas de modification d'un des champs de l'adresse
         */
        vm.reinitErreurAdresse = function(){
            vm.erroradresse = false;
        };

        vm.determineTitlePays = function() {
          var titlePays = "Pays de résidence.";

          if (vm.isObligatoire)
          {
            titlePays += " Champ obligatoire."
          }
          titlePays += " Exemple : FRANCE."

          return titlePays;
        };

        vm.determineTitleNumAdresse = function() {
          var titleVoie = "Saisie du numéro et de la voie/du lieu-dit de résidence.";

          if (vm.isObligatoire)
          {
              titleVoie += " Champ obligatoire."
          }
          titleVoie += " Exemple : 15 rue des Alouettes."

          return titleVoie;
        };

        vm.determineTitleCPVille = function() {
          var titleCP = "Saisie du code postal et/ou de la commune de résidence.";

          if (vm.isObligatoire)
          {
              titleCP += " Champ obligatoire."
          }

          titleCP += " Exemple : 80000 AMIENS."

          return titleCP;
        }; 
        
        vm.determineTitleVilleEtranger = function() {
          var titleVille = "Saisie de la ville étrangère de résidence.";

          if (vm.isObligatoire)
          {
            titleVille += " Champ obligatoire."
          }

          titleVille += " Exemple : BARCELONE."

          return titleVille;
        };   
        
        vm.determineTitleAdresseEtranger = function() {
          var titleAdrEtanger = "Saisie de l'adresse à l'étranger.";

          if (vm.isObligatoire)
          {
            titleAdrEtanger += " Champ obligatoire."
          }

          titleAdrEtanger += " Exemple : 221B Baker Street."

          return titleAdrEtanger;
        }; 
               
        /* ------------------------------------------------------------------------------------------------------------------------- */
    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctAdresseSocle
     *
     * @description
     * cnafCctAdresseSocle affiche les champs de saisie minimum pour une adresse
     *
     * @restrict E
     *
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     * @param {Object} data data
     * @param {Object} adresseform formulaire
     * @param {Object} erroradresse erreurs
     * @param {Object} listepays liste des Pays
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */
    angular.module('cnafComponentsTeleprocApp').component('cnafCctAdresseSocle', {
        templateUrl: 'components/cnaf-cct-adresse-socle/cnaf-cct-adresse-socle.html',
        bindings: {
            data: '=',
            adresseform: "=",
            erroradresse: "=",
            listepays: "=",
            autocompletion: "=",
            controle: "=",
            saisieobligatoire: "="
        },
        controllerAs: 'vm',
        controller: CnafCctAdresseSocleController
    });
})();

(function() {
    'use strict';

    CnafCctConditionsUtilisationController.$inject = [];

    function CnafCctConditionsUtilisationController() {
        var vm = this;

        /**
         * Init component
         */
        this.$onInit = function() {
            vm.cuCollapsed = true;
            vm.blocCollapsed=false;
            vm.expandBlocCollapse = function() {
                vm.blocCollapsed = !vm.blocCollapsed;
            };
            vm.expandDeclarerCollapse = function() {
                vm.cuCollapsed = !vm.cuCollapsed;
            };
        };   

    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctConditionsUtilisation
     *
     * @description
     * cnafCctConditionsUtilisation affiche les conditions d'utilisation
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} recapform formulaire
     * @param {Object} errorconditionsutilisation erreurs
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctConditionsUtilisation', {
        templateUrl: 'components/cnaf-cct-conditions-utilisation/cnaf-cct-conditions-utilisation.html',
        bindings: {
            data: '=',
            conditionsutilisationform: "=",
            champsobligatoire: "="
        },
        controllerAs: 'vm',
        controller: CnafCctConditionsUtilisationController
    });
})();

(function() {
    'use strict';
    //Stockage de constantes pour les valeurs 'varImpot' et 'varApprenti' par anneeReference...
    angular.module('cnafComponentsTeleprocApp').constant("CnafComponentsTeleprocConstantes",
    {
            // Variables Utiles aux Aides/Ressources
            // Infos à renseigner chaque année : de l'année la plus récente à la moins récente...
            'varTabImpotApprenti' : [
              { anneeReference: '2019', varImpot: '4 564 €', varApprenti: '18 255 €'},
              { anneeReference: '2018', varImpot: '4 495 €', varApprenti: '17 982 €'},
              { anneeReference: '2017', varImpot: '4 441 €', varApprenti: '17 763 €'},
              { anneeReference: '2016', varImpot: '4 400 €', varApprenti: '17 599 €'},
              { anneeReference: '2015', varImpot: '4 373 €', varApprenti: '17 490 €'},
              { anneeReference: '2014', varImpot: '4 336 €', varApprenti: '17 345 €'}
            ],
            // references ressources
            'ref1' : '001',
            'ref10' : '010',
            'ref2' : '002',
            'ref26' : '026',
            'ref12' : '012',
            'ref30' : '030',
            'ref34': '034',
            'ref62': '062',
            'ref22': '022',
            'ref21': '021',
            'ref40': '040',
            'ref63': '063',
            'ref23': '023',
            'ref41': '041',
            'ref60': '060',
            'ref64': '064',
            'ref65': '065',
            'deficitsFinancierBase': 15300,
            'tauxPensionDecisionJusticeJanvier2006': 1.25
      }
  );
})();

(function() {
    'use strict';

    CnafCctCoordBancController.$inject = ['$scope', 'CnafCctControleIbanService', 'CnafCctIbanService'];

    function CnafCctCoordBancController($scope, CnafCctControleIbanService, CnafCctIbanService) {
        var vm = this;

        /**
         * Init component
         */
        this.$onInit = function() {
            if (vm.choixtituribs.length === 1) {
                // 1 seul occurence dans la liste titurib on force la séléction
                vm.data.choixTituRib = vm.choixtituribs[0].cle;
            } else if (vm.choixtituribs.length > 2) {
                if (vm.choixtituribs[2].libelle.length > 50) {
                    vm.data.libelleLong = true;
                }
            }
            vm.data.ibanmask = 'AA';
        };

        /**
         * Watcher afin d'apdater le mask iban en fonction du pays
         */
        $scope.$watch('vm.data.iban', function(ibanNewValue) {
            if (ibanNewValue !== undefined && ibanNewValue.length > 1) {
                if (vm.controlerIbanSepa(ibanNewValue)) {
                    vm.data.ibanmask = CnafCctIbanService.getMaskType(ibanNewValue.toUpperCase());
                    if (CnafCctIbanService.isValidLengthIban(ibanNewValue.toUpperCase())) {
                        vm.coordbancform.iban.$setValidity('ibanvalid', true);
                        vm.coordbancform.iban.invalidmsg = '';
                    }
                } else {
                    // iban ko
                    vm.data.ibanmask = 'AA';
                }
            } else {
                // iban de longueur 1
                vm.data.ibanmask = 'AA';
            }
            if (ibanNewValue !== undefined && ibanNewValue.length == 0) {
                // iban vide
                vm.data.ibanmask = '';
                vm.coordbancform.iban.maskmsg = '';
                // marquer le champ en rouge
                vm.coordbancform.iban.$invalid = true;
            }

            //  Si l'erreur etait propre au iban et bic on enleve l'erreur sur le bic
            if (vm.coordbancform.bic.errorcode == 3 || vm.coordbancform.bic.errorcode == 8) {
                vm.coordbancform.bic.$setValidity('bicvalid', true);
                vm.coordbancform.bic.invalidmsg = '';
            }
        });

        /**
         * Controler l'iban en sortie de champ
         */
        vm.controlerIbanOnBlur = function() {
            var ibanValue = vm.coordbancform.iban.$modelValue;
            //vm.controle.submitted = false;
            if (ibanValue !== undefined && ibanValue != '') {
                vm.coordbancform.iban.maskmsg = '';
                if (vm.coordbancform && !vm.coordbancform.iban.$pristine && vm.coordbancform.iban.$invalid) {
                    var ibanObj = CnafCctIbanService.getIbanObj(ibanValue.toUpperCase());
                    if (ibanObj && ibanObj.length !== ibanValue.length) {
                        vm.coordbancform.iban.maskmsg = "Le nombre de caractères saisi est incorrect. " +
                        "Format attendu pour un IBAN commençant par " + ibanObj.code + " : " + ibanObj.length + " caractères";
                        return false;
                    } else {
                        vm.coordbancform.iban.maskmsg = "";
                    }
                } else {
                    vm.coordbancform.iban.maskmsg = "";
                }
            }
            vm.coordbancform.iban.maskmsg = "";
        };

        /**
         * Controle l'IBAN (Zone SEPA)
         */
        vm.controlerIbanSepa = function(ibanValue) {
            //vm.controle.submitted = false;
            if (ibanValue.length > 1) {
                // controler SEPA :
                var isOk = CnafCctControleIbanService.controleCid6867RegleA(ibanValue);
                if (isOk !== 'OK') {
                    vm.coordbancform.iban.invalidmsgsepa = isOk;
                    vm.coordbancform.$setValidity('iban', false);
                    // marquer le champ en rouge
                    vm.coordbancform.iban.$invalid = true;
                    vm.coordbancform.iban.$setValidity('ibansepa', false);
                    vm.coordbancform.iban.maskmsg = '';
                    return false;
                } else {
                    vm.coordbancform.$setValidity('iban', true);
                    vm.coordbancform.iban.$invalid = false;
                    vm.coordbancform.iban.$setValidity('ibansepa', true);
                    return true;
                }
            } else {
                vm.coordbancform.$setValidity('iban', true);
                vm.coordbancform.iban.$invalid = false;
                vm.coordbancform.iban.$setValidity('ibansepa', true);
                return true;
            }
        };

        /**
         * Watcher afin d'apdater les messages d'erreurs au contexte
         */
        $scope.$watch('vm.data.bic', function() {

            vm.coordbancform.bic.$setValidity('bicvalid', true);
            vm.coordbancform.bic.invalidmsg = '';

            //  Si l'erreur etait propre au iban et bic on enleve l'erreur sur le iban
            if (vm.coordbancform.bic.errorcode == 3 || vm.coordbancform.bic.errorcode == 8) {
                vm.coordbancform.iban.$setValidity('ibanvalid', true);
                vm.coordbancform.iban.invalidmsg = '';
            }
        });

        /**
         * Controler la longueur du bic en sortie de champ
         */
        vm.controlerBicOnBlur = function(bic) {
            if (bic) {
                vm.coordbancform.bic.lengthmsg = '';
                if (bic != undefined && bic.length > 0 && bic.length !== 8 && bic.length !== 11) {
                    return false;
                } else {
                    return true;
                }
            }
            return true;
        };
    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctCoordbancSocle
     *
     * @description
     * cnafCctCoordbancSocle affiche les champs de saisie des coordonnées bancaires
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} coordbancform formulaire
     * @param {Object} choixtituribs titulaire du compte
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    //Component
    angular.module('cnafComponentsTeleprocApp').component('cnafCctCoordbancSocle', {
        templateUrl: 'components/cnaf-cct-coordbanc-socle/cnaf-cct-coordbanc-socle.html',
        bindings: {
            data: '=',
            coordbancform: '=',
            choixtituribs: '=',
            controle: '='
        },
        controller: CnafCctCoordBancController,
        controllerAs: 'vm'
    });
})();

(function () {
    'use strict';

    CnafCctCourrielController.$inject = ['CnafCctGestionTypeService', 'CnafCctConstantMsgTypes'];

    function CnafCctCourrielController(CnafCctGestionTypeService, CnafCctConstantMsgTypes) {
        var vm = this;

        //Contrôle
        vm.supprimeConfirmation = function (donnee, nomDonneeConf) {
            if (!(donnee && donnee !== ""))
            {               
                vm.data[nomDonneeConf] = "";                
            }
        };

        vm.testType1 = function (donnee, form, index, nomDonnee) {

            var nomForm= form[nomDonnee];
 
            if (index !== undefined)
            {
                nomForm= form[nomDonnee + index];
            }

            if (donnee === undefined || donnee == null || donnee.length === 0) {
                nomForm.$setValidity('type1', true);
            }
            else {
                var retourControles = CnafCctGestionTypeService.appelControleType1(donnee, nomForm);
                if (retourControles !== null) {
                    vm.data[nomDonnee] = retourControles;
                }
            }
        };

        // Associe le message d'invalidité au champ en question via l'index
        vm.returnMessage = function(form, index, nomDonnee){

            var nomForm= form[nomDonnee];
            if (index !== undefined)
            {
                nomForm= form[nomDonnee + index];
            }

            return nomForm.invalidmsg;
        };  

        vm.controleMailidentique = function (email2, email) {
            if ( (email2 && (email === undefined || email.length === 0)) ||
              (email && email2 && email !== email2) ) {
                return false;
            }
            return true;
        };

        // Suite au controle effectué lors de la saisie du bouton validé on positionne la variable vm.errorcourriel
         vm.reInitChampObli = function (email2, email) {
            var email2NonOblig = true;
            if (email && email.length > 0) {
                if ( (email2 && email2.length > 0))  {
                    // si l'email2 est renseigné alors on désactive le message champ obligatoire
                    //vm.courrielform.email2.$setValidity('obligatoire', true);
                    vm.errorcourriel = false;
                }
                else {
                    // si email2 non saisi et errorCourriel positionné alors affichage email2 obligatoire
                    if (vm.errorcourriel){
                        email2NonOblig = false;
                    }
                }
            }
            else {
                // désactivation du message champ obligatoire si email vide
                vm.errorcourriel = false;
            }
            return email2NonOblig;
        };

        // Retourne le message d'invalidité au champ en question via l'index
        vm.returnError = function(form, champ, index, typeErreur){

            var nomForm= form[champ];
            if (index !== undefined)
            {
                nomForm= form[champ + index];
            }

            return nomForm.$error[typeErreur];
        };

    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctCourriel
     *
     * @description
     * cnafCctCourriel affiche les champs de saisie pour le courriel
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} courrielform formulaire
     * @param {Object} errorcourriel erreurs
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */


    angular.module('cnafComponentsTeleprocApp').component('cnafCctCourriel', {
        templateUrl: 'components/cnaf-cct-courriel/cnaf-cct-courriel.html',
        bindings: {
            data: '=',
            courrielform: "=",
            errorcourriel: "=",
            index:'=',            
            controle:'='
        },
        controllerAs: 'vm',
        controller: CnafCctCourrielController
    });

})();

(function() {
    'use strict';

    CnafCctDateDepartController.$inject = ['CnafCctDateService'];

    function CnafCctDateDepartController(CnafCctDateService){

        var vm = this;

        //La date de départ doit être <= au dernier jour du mois qui suit le mois de la démarche
        //sinon on affiche le message « La date de départ doit être antérieure ou égale au [DernierJourMois+1Demarche] »
        vm.controleDernierJourMoisPlus1Demarche = function(sDateDepart, dernierJourMoisSuivant){
            var dateDebutATester = Date.parseExact(sDateDepart, "d/M/yyyy");
            if(dateDebutATester > dernierJourMoisSuivant){
                return false;
            }else{
                return true;
            }

        };

        //La date de départ doit être >= à la date de début de présence sur le dossier
        //sinon on affiche le message « La date de départ doit être postérieure ou égale au [DateDebutPresenceDossier] »
        vm.controleDateDebutPresenceDossier = function(sDateDepart, dateDebPresenceDossier) {
          var controleDate = false;
          vm.controle.dateDebPresenceDos = CnafCctDateService.getDateFormatCristalToFormatEcran(dateDebPresenceDossier);
          if (sDateDepart !== undefined && sDateDepart.length >= 10)
          {
            controleDate = (CnafCctDateService.isDateStrictementInferieure(vm.controle.dateDebPresenceDos, sDateDepart));
          }
          return controleDate;
        };
    }


    /**
     * @ngdoc directive
     * @name SitEnfAppli.component:cnafCctDateDepart
     *
     * @description
     * cnafCctDateDepart affiche les champs de saisie de la date de début situation enfant
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} datedepartform formulaire
     * @param {Object} controle controle
     *
    */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctDateDepart', {
        templateUrl: 'components/cnaf-cct-date-depart/cnaf-cct-date-depart.html',
        bindings: {
            data: '=',
            datedepartform: "=",
            controle: "="
        },
        controllerAs: 'vm',
        controller: CnafCctDateDepartController
    });
})();

(function() {
    'use strict';

    CnafCctDateentreefranceController.$inject = ['CnafCctAdresseSocleService', 'CnafCctDateService', '$filter'];

    function CnafCctDateentreefranceController(CnafCctAdresseSocleService, CnafCctDateService, $filter) {
        var vm = this;

        vm.init = function() {
            vm.httpRechListePays();
        };

        //Recherche liste pays
        vm.httpRechListePays = function() {
            CnafCctAdresseSocleService.rechListePays()
                .get()
                .$promise.then(
                    function successCallback(response0) {
                        vm.listePays = response0.listePays;
                    },
                    function errorCallback(error) {
                        vm.etat = 'error';
                    }
                );
        };

        //AUTO-COMPLETION
        //Pays :
        vm.getListePaysProposes = function(prefix) {
            return vm.listePays;
        };

        /**
         *  Controle si date d'arrive est supérieure ou égale à la date de naissance.
         */
        vm.controleDateSuperieurDateNaiss = function(dateSaisie, dateNaissance) {
            // Date d'arrivé supérieur ou égale a la date de naissance
            if (Date.parseExact(dateSaisie, 'd/M/yyyy') != null && Date.parseExact(dateNaissance, 'd/M/yyyy') != null) {
                return !CnafCctDateService.isDateStrictementInferieure(dateSaisie, dateNaissance);
            } else {
                return true;
            }
        };

        /**
         *  Controle si date d'arrive est inférieur ou égale à la date du jourl
         */
        vm.controleDateInferieureDateJour = function(dateSaisie, dateJour) {
            // Date d'arrivé supérieur ou égale a la date de naissance
            if (Date.parseExact(dateSaisie, 'd/M/yyyy') != null && dateJour != null) {
                var dateJourStr = $filter('date')(dateJour,'dd/MM/yyyy');
                return CnafCctDateService.isDateStrictementInferieure(dateSaisie, dateJourStr);
            } else {
                return true;
            }
        };
    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctDateentreefrance
     *
     * @description
     * cnafCctDateentreefrance affiche les champs de saisie pour savoir si la personne arrive de l'étranger et,
     * si oui, la date d'entrée en France
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} dateentreefranceform formulaire
     * @param {Object} errordateentreefrance erreurs
     * @param {boolean} conjoint indique si on traite l'état civil du conjoint
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctDateentreefrance', {
        templateUrl: 'components/cnaf-cct-dateentreefrance/cnaf-cct-dateentreefrance.html',
        bindings: {
            data: '=',
            dateentreefranceform: '=',
            errordateentreefrance: '=',
            controle: '=',
            conjoint: '=',
            today: "="
        },
        controllerAs: 'vm',
        controller: CnafCctDateentreefranceController
    });
})();

(function () {
    'use strict';

    CnafCctCourrielOuTelController.$inject = ['CnafCctGestionTypeService', 'CnafCctConstantMsgTypes'];

    function CnafCctCourrielOuTelController(CnafCctGestionTypeService, CnafCctConstantMsgTypes) {
        var vm = this;

        vm.isEmail = false;

        //Contrôle
        vm.testType1 = function (donnee, form, nomDonnee) {
            if (donnee === undefined || donnee.length === 0) {
                form.$setValidity('type1', true);
            }
            else {
                var retourControles = CnafCctGestionTypeService.appelControleType1(donnee, form);
                if (retourControles !== null) {
                    vm.data[nomDonnee] = retourControles;
                }
            }
        };

        vm.checkCourrielOuTelephonePortable = function(courrielOuTel){

            vm.courrieloutelform.emailOuTel.$setValidity('controletel', true);
            vm.courrieloutelform.$setValidity('type1', true);
            delete vm.courrieloutelform.emailOuTel.$error.type1;

            if(courrielOuTel != null){
                vm.data.emailOuTel = vm.data.emailOuTel.trim();
                if(courrielOuTel.indexOf('@') === -1 &&
                    (courrielOuTel.substring(0, 2) == "06" || courrielOuTel.substring(0, 2) == "07")){
                    vm.data.emailOuTel = vm.data.emailOuTel.replace(/  /g,' ');
                    vm.controleTel(courrielOuTel);
                    vm.isEmail = false;
                }else{

                    vm.data.emailOuTel = vm.data.emailOuTel.toLowerCase();
                    vm.isEmail = true;
                    // INC0623692 L2012- Caf.fr- DAL Primo - 
                    // Bouton " Continuer" inactif si erreur puis rectification du numéro téléphone
                    //vm.testType1(vm.data.emailOuTel,vm.courrieloutelform.emailOuTel,'email');
                    vm.testType1(vm.data.emailOuTel,vm.courrieloutelform,'email');
                }
            }
        };

        vm.controleChampsIdentique = function (champ2, champ1) {
            if(vm.data.emailOuTel2){
                vm.data.emailOuTel2 = vm.data.emailOuTel2.trim();
                vm.data.emailOuTel2 = vm.data.emailOuTel2.replace(/  /g,' ');
            }
            if(champ1 != undefined && champ2 != undefined){
                if ( (champ2 && (champ1 == undefined || champ1.length === 0)) ||
                    (champ1 && champ2 && champ1 !== champ2) ) {
                    return false;
                }
            }
            return true;
        };

        vm.controleTel = function(courrielOuTel){
            var controleOk = true;
            var tel = courrielOuTel.trim();
            tel = tel.replace(/  /g,' ');
            if(tel.charAt(0) == 0){
                if(tel.length ==  14){
                    tel = tel.replace(/ /g,'');
                    if(tel.match(/[0][0-9]{9}/)){
                        controleOk = true;
                    }else{
                        vm.courrieloutelform.emailOuTel.$setValidity('controletel', false);
                        controleOk = false;
                    }
                }else if (tel.length == 10){
                    if(tel.match(/[0][0-9]{9}/)){
                        controleOk = true;
                    }else{
                        vm.courrieloutelform.emailOuTel.$setValidity('controletel', false);
                        controleOk = false;
                    }
                } else{
                    vm.courrieloutelform.emailOuTel.$setValidity('controletel', false);
                    controleOk = false;
                }
            } else {
                vm.courrieloutelform.emailOuTel.$setValidity('controletel', false);
                vm.courrieloutelform.emailOuTel.invalidmsg = "Le numéro de portable doit commencer par '06' ou '07";
            }

            if(controleOk){
                vm.courrieloutelform.emailOuTel.$setValidity('controletel', true);
            }else {
                vm.courrieloutelform.emailOuTel.$setValidity('controletel', false);
                vm.courrieloutelform.emailOuTel.invalidmsg = "Le numéro de portable doit comporter 10 chiffres";
            }
        };

        // Suite au controle effectué lors de la saisie du bouton validé on positionne la variable vm.errorcourrieloutel
        vm.reInitChampObli = function (champ2, champ1) {
            var champ2NonOblig = true;
            if (champ1 && champ1.length > 0) {
                if ( (champ2 && champ2.length > 0))  {
                    // si l'email2 est renseigné alors on désactive le message champ obligatoire
                    //vm.courrieloutelform.email2.$setValidity('obligatoire', true);
                    vm.errorcourrieloutel = false;
                    champ2NonOblig = true;
                }
                else {
                    // si email2 non saisi et errorCourriel positionné alors affichage email2 obligatoire
                    if (vm.errorcourrieloutel){
                        champ2NonOblig = false;
                    }
                    else{
                        champ2NonOblig = true;
                    }
                }
            }
            else {
                // désactivation du message champ obligatoire si email vide
                vm.errorcourrieloutel = false;
                champ2NonOblig = true;
            }
            return champ2NonOblig;
        };


    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctCourriel
     *
     * @description
     * cnafCctCourriel affiche les champs de saisie pour le courriel
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} courrieloutelform formulaire
     * @param {Object} errorcourrieloutel erreurs
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */


    angular.module('cnafComponentsTeleprocApp').component('cnafCctCourrielOuTel', {
        templateUrl: 'components/cnaf-cct-courriel-ou-tel/cnaf-cct-courriel-ou-tel.html',
        bindings: {
            data: '=',
            courrieloutelform: "=",
            errorcourrieloutel: "=",
            controle: "="
        },
        controllerAs: 'vm',
        controller: CnafCctCourrielOuTelController
    });

})();

(function() {
    'use strict';

    CnafCctEnteteRecapController.$inject = ['$rootScope',
                                            '$timeout'];

    function CnafCctEnteteRecapController($rootScope, 
        $timeout) {

        this.$onInit = function() {
            $timeout(function() {
                $rootScope.$broadcast('focusPage');
            });
        }
    }

    /**
     * @ngdoc directive
     * @name cnafCctEnteteRecapController.component:cnafCctEnteteRecapController
     *
     * @description
     * cnafCctEnteteRecapController affiche l'entête de la page Récap'
     *
     *
     * @restrict E
     *
     * @param {Object} modeenchainement modeEnchainementApplis
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctEnteteRecap', {
        templateUrl: 'components/cnaf-cct-entete-recap/cnaf-cct-entete-recap.html',
        bindings: {
            modeenchainement: "="
        },
        controllerAs: 'vm',
        controller: CnafCctEnteteRecapController
    });
})();

(function() {
    'use strict';

    cnafCctErreurInputController.$inject = [];

    function cnafCctErreurInputController() {
        var vm = this;    

        vm.show = function(){
          if(!vm.condition || vm.condition==="false")return false;
          return true;
        }
    }
    /* -------------------------------------------------------------------------------------------- */    
    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctErreurInput
     *
     * @description
     * cnafCctErreurInput gère de manière accessible l'affichage d'un message d'erreur suite à une saisie invalide sur un input
     *
     * Attention : Ne pas gérer le bloc cnaf-cct-erreur-input avec une directive ng-if ! 
     * NgIf créé et détruit le noeud en mémoire contrairement à NgShow qui ne fait qu'appliquer une classe CSS
     * Or, pour être accessible, un input doit être relié à tout moment aux blocs des messages d'erreurs.
     *
     * @restrict E
     *
     * @param {String} idErreur id du noeud HTML pour l'affichage de l'erreur
     * @param {boolean} condition la condition d'affichage du message d'erreur
     * @param {String} message le message d'erreur a afficher si la condition d'affichage est realisée
     *
     * @example
     *
     *
     * <input id="inputTest" aria-describedby="blocErreurMinLength blocErreurPattern" minlength="3" pattern="^[0-9]" ... />
     * <cnaf-cct-erreur-input 
           idErreur="blocErreurMinLength" 
           condition="monform.inputTest.$error.minlength" 
           message="Le champ doit contenir 3 caractères minimum."
       </cnaf-cct-erreur-input>
     * <cnaf-cct-erreur-input 
           idErreur="blocErreurPattern" 
           condition="monform.inputTest.$error.pattern" 
           message="La saisie doit commencer par un chiffre."
       </cnaf-cct-erreur-input>
     *
     *

     * Voir showcase : http://localhost:9000/
    */
    angular.module('cnafComponentsTeleprocApp').component('cnafCctErreurInput', {
        templateUrl: 'components/cnaf-cct-erreur-input/cnaf-cct-erreur-input.html',
        bindings: {
          iderreur: '@',
          condition: '@',
          message: '@',
          messagesronly: '@'
        },
        controllerAs: 'vm',
        controller: cnafCctErreurInputController
    });
})();

(function() {
    'use strict';

    CnafCctEtatcivilSocleController.$inject = [
        'CnafCctControleDateNaissanceService',
        'CnafCctGestionTypeService',
        'CnafCctConstantMsgTypes',
        'CnafCctWsrnbService',
        'CnafCctControleRnbService',
        'CnafCctAngularUtilsService'];

    function CnafCctEtatcivilSocleController(
        CnafCctControleDateNaissanceService,
        CnafCctGestionTypeService,
        CnafCctConstantMsgTypes,
        CnafCctWsrnbService,
        CnafCctControleRnbService,
        CnafCctAngularUtilsService){

        var vm = this;

        vm.$onInit = function(){
            CnafCctAngularUtilsService.broadcastEvent('showNavBar');
            if (vm.data !== undefined) {
                if (vm.data.isAffichageEtatCivilMinimum === undefined)
                {
                    vm.data.isAffichageEtatCivilMinimum = false;
                }
                if (vm.data.isAffichageEtatCivilSimple === undefined)
                {
                    vm.data.isAffichageEtatCivilSimple = false;
                }
            }
        };


        vm.controleDateNaissance = CnafCctControleDateNaissanceService.controleDateNaissance;

        // Envoi d'un evenement pour ajouter un controle sur la date de naissance à partir d'un parent qui utilise le module
        // le libelle du message d'erreur sera spécifié dans la donnée libellemessagedatenaissancespecifique et sera positionné
        // uniquement si le message doit-être affiché.
        // vm.controleDateNaissanceSpecifique = function (dateNaissance, dateDuJour){
        // CnafCctAngularUtilsService.broadcastEventControle('controleDateNaissanceSpecifique',dateNaissance,dateDuJour);
        // // si présence d'un libellé de message d'erreur alors controle OK --> false
        // var isControleOk;
        // console.log("Dans le component vm.libellemessagedatenaissancespecifique : "+vm.libellemessagedatenaissancespecifique);
        // setTimeout(function(){
        //   isControleOk = (vm.libellemessagedatenaissancespecifique === undefined);
        //   console.log("iscontrolOk: "+isControleOk);
        //   console.log("Dans le component vm.libellemessagedatenaissancespecifique : "+vm.libellemessagedatenaissancespecifique);
        //   return isControleOk;
        //   }, 0);
        //}
        // Ne fonctionne pas pb le $broadcast est assynchrone et dans certains cas on récupère la donnée  vm.libellemessagedatenaissancespecifique
        // avant l'exécution du contrôle effectué par l'application appelante

        vm.controleDateNaissanceSpecifique = function(dateNaissance, dateDuJour){
          if (vm.controlespecifique && vm.controlespecifique === 'controleDateNaissanceSpecifique'){
            vm.libelleMessageDateNaissanceSpecifique = CnafCctControleDateNaissanceService.controleDateNaissanceMoins6(dateNaissance, dateDuJour);
          }
          return vm.libelleMessageDateNaissanceSpecifique === undefined;
        };

        vm.testType3 = function(donnee,form,nomDonnee){
            if (donnee === undefined || donnee.length === 0){
              form.$setValidity('type3', true);
            }
            else {
                var retourControles = CnafCctGestionTypeService.appelControleType3(donnee, form);
                if (retourControles !== null)
                {
                  vm.data[nomDonnee]=retourControles;
                }
            }
        };

        vm.testType13 = function(donnee,form){
          ///var donnee = event.currentTarget.value;
          if (donnee === undefined || donnee.length === 0){
              form.$setValidity('type13', true);
          }
          else {
            var retourControles = CnafCctGestionTypeService.appelControleType13(donnee, form);
            if (retourControles !== null)
            {
              vm.data.prenom = retourControles;
            }
          }
        };
    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctEtatcivilSocle
     *
     * @description
     * cnafCctEtatcivilSocle affiche les champs de saisie de l'état civil
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} etatcivilform formulaire
     * @param {Object} erroretatcivil erreurs
     * @param {Date} today date de la démarche
     * @param {Object} controlespecifique indique le type de contrôle a appliquer (ex:controleDateNaissanceSpecifique)
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctEtatcivilSocle', {
        templateUrl: 'components/cnaf-cct-etatcivil-socle/cnaf-cct-etatcivil-socle.html',
        bindings: {
            data: '=',
            etatcivilform: "=",
            erroretatcivil: "=",
            errordatenaissance: "=",
            today: "=",
            controle: "=",
            controlespecifique: "="
        },
        controllerAs: 'vm',
        controller: CnafCctEtatcivilSocleController
    });
})();

(function() {
    'use strict';

    CnafCctEtatcivilDateArriveeController.$inject = [
        'CnafCctDateService',
        'CnafCctControleDateNaissanceService'];

    function CnafCctEtatcivilDateArriveeController(
        CnafCctDateService,
        CnafCctControleDateNaissanceService){

        var vm = this;
        vm.controleDateArrivee = CnafCctDateService.isDateStrictementSuperieure;
        vm.controleDateArriveeDateDuJour = CnafCctControleDateNaissanceService.controleDateNaissance;

    }

    /**
     * @ngdoc directive
     * @name SitEnfAppli.component:cnafEtatcivilDateArrivee
     *
     * @description
     * cnafEtatcivilDateArrivee affiche les champs de saisie de la date d'arrivée
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} datearriveeform formulaire
     * @param {Object} controle controle
     *
    */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctEtatcivilDateArrivee', {
        templateUrl: 'components/cnaf-cct-etatcivil-enfant/cnaf-cct-etatcivil-date-arrivee.html',
        bindings: {
            data: '=',
            datearriveeform: "=",
            controle: "="
        },
        controllerAs: 'vm',
        controller: CnafCctEtatcivilDateArriveeController
    });
})();

(function() {
    'use strict';

    CnafCctEtatcivilEnfantController.$inject = [
        'CnafCctControleDateNaissanceService',
        'CnafCctGestionTypeService',
        'CnafCctDateService'];

    function CnafCctEtatcivilEnfantController(
        CnafCctControleDateNaissanceService,
        CnafCctGestionTypeService,
        CnafCctDateService){

        var vm = this;
        vm.controleDateArrivee = CnafCctDateService.isDateStrictementSuperieure;
        vm.controleDateNaissance = CnafCctControleDateNaissanceService.controleDateNaissance;
        vm.controleDateNaissanceInf1880 = CnafCctControleDateNaissanceService.controleDateNaissanceInf1880;

        vm.testType3 = function(donnee,form,nomDonnee){
            if (donnee === undefined || donnee.length === 0){
              form.$setValidity('type3', true);
            }
            else {
                var retourControles = CnafCctGestionTypeService.appelControleType3(donnee, form);
                if (retourControles !== null)
                {
                  vm.data[nomDonnee]=retourControles;
                }
            }
        };

        vm.testType13 = function(donnee,form){
          ///var donnee = event.currentTarget.value;
          if (donnee === undefined || donnee.length === 0){
              form.$setValidity('type13', true);
          }
          else {
            var retourControles = CnafCctGestionTypeService.appelControleType13(donnee, form);
            if (retourControles !== null)
            {
              vm.data.prenom = retourControles;
            }
          }
        };


    }

    /**
     * @ngdoc directive
     * @name SitEnfAppli.component:cnafEtatcivilEnfant
     *
     * @description
     * cnafEtatcivilEnfant affiche les champs de saisie de l'état civil
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} etatcivilform formulaire
     * @param {Object} erroretatcivil erreurs
     *
    */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctEtatcivilEnfant', {
        templateUrl: 'components/cnaf-cct-etatcivil-enfant/cnaf-cct-etatcivil-enfant.html',
        bindings: {
            data: '=',
            etatcivilform: "=",
            controle: "="
        },
        controllerAs: 'vm',
        controller: CnafCctEtatcivilEnfantController
    });
})();

(function() {
    'use strict';

    CnafCctEtatcivilNirController.$inject = [];

    function CnafCctEtatcivilNirController(){

    }

    /**
     * @ngdoc directive
     * @name SitEnfAppli.component:cnafCctEtatcivilNir
     *
     * @description
     * cnafCctEtatcivilNir affiche les champs de saisie de l'état civil : nir
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} nirform formulaire
     *
    */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctEtatcivilNir', {
        templateUrl: 'components/cnaf-cct-etatcivil-enfant/cnaf-cct-etatcivil-nir.html',
        bindings: {
            data: '=',
            nirform: "="
        },
        controllerAs: 'vm',
        controller: CnafCctEtatcivilNirController
    });
})();

(function() {
    'use strict';
    
    CnafCctGestionpdfsfinController.$inject = ['CnafCctPdfsService',
                                               'CnafCctSaveChangementSessionService',
                                               '$sce',
                                               'CnafCctConstants',
                                               '$timeout',
                                               '$rootScope',
                                               'CnafTokenService', 
                                               'CnafUserService'
                                            ];

    function CnafCctGestionpdfsfinController(CnafCctPdfsService,
                                             CnafCctSaveChangementSessionService,
                                             $sce,
                                             CnafCctConstants,
                                             $timeout,
                                             $rootScope,
                                             CnafTokenService,
                                             CnafUserService) {

        var vm = this;
        vm.trustAsHtml = function(html) {
            return $sce.trustAsHtml(html);
        };


        this.$onInit = function()  {

            $timeout(function() {
                $rootScope.$broadcast('focusPage');
            });
            // Récupération du role de la personne connectée présent dans le jeton
            var token = CnafUserService.tokenJWT;
            var decodedToken = CnafTokenService.decodeToken(token);
            var isExiste = false;
            vm.isSitFamSeparation = false;
            vm.isRoleResponsableDossier = false;
            vm.forceBoutonRetourMonCompteSeparation = false;

            if (decodedToken) {                   
                 vm.isRoleResponsableDossier = (decodedToken.roles[0] === "responsableDossier");
            }
            
            // Gestion des liens présents 'en dur' dans le component
            if(vm.redirectmoncomptemobile){
                vm.lienVersMonCompteMesDemarches = "/redirect/s/Redirect?page=applimobileMonCompteMesDemarches";
                vm.lienVersMonCompteMonProfil = "/redirect/s/Redirect?page=applimobileMonCompteMonProfil";
                vm.lienVersContacterMaCaf = "/redirect/s/Redirect?page=applimobileMonCompteContacterMaCaf";
            }else{
                vm.lienVersMonCompteMesDemarches = "/redirect/s/Redirect?page=monCompteMesDemarches";
                vm.lienVersMonCompteMonProfil = "/redirect/s/Redirect?page=monCompteMonProfil";
                vm.lienVersContacterMaCaf = "/redirect/s/Redirect?page=monCompteContactCaf";
            }



            // Construction progressive : on s'assure que tous les composants de l'objet
            // sont initialisés sans remplacer ce qui est injecté.
            if (!vm.infosrecapfin){
                vm.infosrecapfin={};
                //On force maintenant le titre a false pour mettre une valeur par défaut plus tard, si rien d'autre n'a été trouvé
                vm.infosrecapfin.titre = false;
            }
            if(!vm.infosrecapfin.listeMessAvert){
                vm.infosrecapfin.listeMessAvert=[];
            }
            if(!vm.infosrecapfin.listeMessReassur){
                vm.infosrecapfin.listeMessReassur=[];
            }
            if(!vm.infosrecapfin.listePdfs){
                vm.infosrecapfin.listePdfs=[];
            }
            if(!vm.infosrecapfin.listeLiens){
                vm.infosrecapfin.listeLiens=[];
            }
            if(!vm.infosrecapfin.listeLiensPdf){
                vm.infosrecapfin.listeLiensPdf=[];
            }
            if(!vm.infosrecapfin.listePjsAllModules){
                vm.infosrecapfin.listePjsAllModules=[];
            }
            if(!vm.infosrecapfin.listeMessTypeChgmtSF){
                vm.infosrecapfin.listeMessTypeChgmtSF=[];
            }            

            //Récuperation des changements effectuées pour alimenter l'écran de fin'
            vm.listeChangements = CnafCctSaveChangementSessionService.getListChangementSession();

            // Suppression de l'ensemble des changements enregistrés dans la session
            CnafCctSaveChangementSessionService.cleanAll();
            
            vm.isPrimoSuiteSeparation = false;

            if (!vm.contexteaiguillage && vm.listeChangements && vm.listeChangements['sf']){
                // Vérification qu'il ne s'agit pas d'un cas de primodemandeur suite à une séparation 
                // Dans ce cas récupération du contexte aiguillage éventuellement à partir de urlEnchainement                
                if (!vm.isRoleResponsableDossier) {
                    vm.isPrimoSuiteSeparation = true;
                }

                for (var cleChangement in vm.listeChangements) {

                    if (vm.listeChangements[cleChangement] && vm.listeChangements[cleChangement].etat === "T") {

                        // Recupération de url en cas de DAL, DTRRSAPA ..
                        if (vm.listeChangements[cleChangement].urlEnchainement) {
                            var urlEnchainement = vm.listeChangements[cleChangement].urlEnchainement;
                        }
                    }
                }

                if (urlEnchainement) {
                    var re = new RegExp(".*contexteAiguillage=\([^&]*\)[&$].*");
                    vm.contexteaiguillage = urlEnchainement.replace(re, "$1");

                    var regex = new RegExp(".*codePrestation=\([^&]*\)[&$].*");
                    vm.codePrestation = urlEnchainement.replace(regex, "$1"); 

                }
            }

            switch (vm.contexteaiguillage) {

                case 'demandeAl' :
                    vm.libelleDemarche = "demande d'aide au logement";
                    vm.isDemandePrestation = true;
                    break;

                case 'demandeCmgPaje' :
                    vm.libelleDemarche = "demande de Complément de libre choix du mode de garde";
                    vm.isDemandePrestation = true;
                    break;

                case 'demandeAsf' :
                    vm.libelleDemarche = "demande de prestation";
                    vm.isDemandePrestation = true;
                    break;

                case 'declarationAvantageVieillesse' :
                    vm.libelleDemarche = "déclaration d'avantages vieillesse ou invalidité";
                    vm.isDemandePrestation = true;
                    break; 

                case 'declarationMensuelleAjpp' :
                    vm.libelleDemarche = "déclaration mensuelle d’allocation journalière de présence parentale";
                    vm.isDemandePrestation = true;
                    break;

                case 'demandeAjpa' :
                    vm.libelleDemarche = "demande d'allocation journalière du proche aidant";
                    vm.isDemandePrestation = true;
                    break;

                case 'dtRsaPa' :
                    var isAllocDTRSA = CnafUserService.isInGroup(CnafUserService.GROUP_ALLOCATAIRES_DTRSA)

                    vm.libelleDemarche = "déclaration trimestrielle RSA/PA";
                    vm.isDemandePrestation = true;
                    
                    if (vm.isPrimoSuiteSeparation) {
                        vm.infosrecapfin.titre = "Votre séparation a bien été prise en compte.<br>";
                        if (isAllocDTRSA)
                        {
                            vm.infosrecapfin.titre += "La Caf va étudier votre droit au RSA et vous recontactera pour votre déclaration de ressources.";
                        }
                        else{
                            vm.infosrecapfin.titre += "Vous n’avez plus à répondre à la demande qui vous a été faite.";   
                        }
                       
                        vm.forceBoutonRetourMonCompteSeparation = true;
                    }
                    else {
                        vm.infosrecapfin.titre = "Votre Profil a bien été mis à jour.<br>"
                        + "Cliquer sur Continuer pour faire votre " + vm.libelleDemarche+"."; // (FIN_RUB_04)
                    }                    

                    break;


                case 'demandePrimeNaissance' :
                    vm.libelleDemarche = "demande de prime à la naissance";
                    vm.isDemandePrestation = true;
                    break;


                case 'demandeRsa' :
                    vm.libelleDemarche = "demande de RSA";
                    vm.isDemandePrestation = true;
                    vm.infosrecapfin.titre = "Votre Profil a bien été mis à jour.<br>";
                    if (vm.isPrimoSuiteSeparation) {
                        vm.infosrecapfin.titre = "Votre séparation a bien été prise en compte.<br>";                       
                    }

                    vm.infosrecapfin.titre += "Cliquer sur Continuer pour faire votre " + vm.libelleDemarche+"."; // (FIN_RUB_05)
                    
                    break;


                case 'demandePa' :
                    vm.libelleDemarche = "demande de prime d'activité";
                    vm.isDemandePrestation = true;
                    break;


                case 'evafor' :
                    vm.libelleDemarche = "déclaration de salaire";
                    vm.isDemandePrestation = true;
                    break;
                    
                case 'maintienLieux' :
                        vm.libelleDemarche = "déclaration";
                        vm.isDemandePrestation = true;
                        break;

                case 'DPD' :
                        vm.libelleDemarche = "demande de prime de déménagement";
                        vm.isDemandePrestation = true;
                        break;                        

                case 'dr' : // Ressources Annuelles
                case 'ressources' : // Ressources Trimestrielles
                    var isAlerteDR = CnafUserService.isInGroup(CnafUserService.GROUP_ALLOCATAIRES_DR)
                    vm.libelleDemarche = "déclaration de ressources";
                    vm.isDemandePrestation = true;
                    if (vm.isPrimoSuiteSeparation) {
                        vm.infosrecapfin.titre = "Votre séparation a bien été prise en compte.<br>";
                        if (isAlerteDR) {
                            vm.infosrecapfin.titre += "Vous n’avez plus à répondre à la demande qui vous a été faite.";
                            vm.forceBoutonRetourMonCompteSeparation = true; 
                        }
                        else{
                            vm.infosrecapfin.titre += "Cliquer sur Continuer pour faire votre " + vm.libelleDemarche+".";   
                        }
                    }                     
                    break;


                case CnafCctConstants.ACTUALISATION_POUR_PRESTATION :
                    vm.libelleDemarche = "demande de prestation"
                    vm.isDemandePrestation = true;
                   
                    break;     

                case CnafCctConstants.ACTUALISATION_POUR_PRESTATION_SANS_FORMULAIRE :
                    vm.libelleDemarche = "demande de prestation"
                    vm.isDemandePrestation = true;                    
                    if ((vm.codePrestation === CnafCctConstants.DEM_ALL_FAMILIALE ||
                            vm.codePrestation === CnafCctConstants.DEM_PRIME_ADOPTION ||
                            vm.codePrestation === CnafCctConstants.DEM_ALL_RENTREE_SCO)
                        && (vm.isPrimoSuiteSeparation)) {
                            vm.infosrecapfin.titre = "Votre séparation a bien été prise en compte.<br>";
                            vm.infosrecapfin.titre += "Vous n’avez plus à répondre à la demande qui vous a été faite.";
                            vm.forceBoutonRetourMonCompteSeparation = true; 
                        }

                    break;

                case CnafCctConstants.ACTUALISATION_POUR_PRESTATION_AVEC_FORMULAIRE :
                    vm.libelleDemarche = "télécharger le formulaire";
                    vm.infosrecapfin.titre = "Votre Profil a bien été mis à jour.<br>";
                    if (vm.isPrimoSuiteSeparation) {
                        vm.infosrecapfin.titre = "Votre séparation a bien été prise en compte.<br>";
                    }
                    vm.infosrecapfin.titre += "Cliquer sur Continuer pour télécharger le formulaire."; // (FIN_RUB_06)
                    vm.isDemandePrestation = true;
                    break;
                
                case 'demandeArs' :
                    vm.libelleDemarche = "démarche";
                    vm.isDemandePrestation = true;
                    break;
    
                case 'dtAah' :
                    vm.libelleDemarche = "déclaration de ressources trimestrielles AAH";
                    vm.isDemandePrestation = true;
                    break;

                default :             
                    vm.isDemandePrestation = false;
                    break;
            }



            // Récupération du paramétre en session 'eligibleAvisChgtCaf'
            vm.eligibleAvisChgtCaf = sessionStorage.getItem("eligibleAvisChgtCaf");
            if (vm.eligibleAvisChgtCaf === "true")
            {
                vm.libelleDemarche = "confirmer l'ensemble de votre profil.";
                vm.infosrecapfin.titre = "Votre Profil a bien été mis à jour.<br>";
                vm.infosrecapfin.titre += "Cliquer sur Continuer pour confirmer l'ensemble de votre profil."; // (FIN_RUB_08)

                if (vm.isPrimoSuiteSeparation) {
                    vm.infosrecapfin.titre = "Votre séparation a bien été prise en compte.<br>";
                    vm.infosrecapfin.titre += "Vous n’avez plus à répondre à la demande qui vous a été faite.";
                    vm.forceBoutonRetourMonCompteSeparation = true;                     
                }

            }


            // Affichage dans l'ordre de saisis des  informations ??
            if (vm.listeChangements) {

                var changement;
                vm.nbChangement = 0;
                for (var cle in vm.listeChangements) {

                    changement = vm.listeChangements[cle];

                    if (changement && changement.etat === "T") {

                        ++vm.nbChangement;
                        vm.titreDuDernierChangement = changement.titre;

                        if(!vm.infosrecapfin.codeOrga) {
                            vm.infosrecapfin.codeOrga = changement.codeOrga;
                        }

                        // Gestion du débranchement via un bouton vers la DAL ou DTRRSAPA
                        if (changement.urlEnchainement) {
                            vm.urlEnchainement = changement.urlEnchainement;
                        }

                        //var pdf = {"libelle":"Récapitulatif de votre changement de coordonnées bancaires", "identifiantNDWEB": changement.pdf.idFluxElecNDWEB};
                        // Attention en cas de demande de prestation (ex DAL) on n'affiche pas le pdf dans l'écran de fin
                        if ((!vm.isDemandePrestation || vm.forceBoutonRetourMonCompteSeparation) && changement.pdf) {
                            vm.infosrecapfin.listePdfs.push(changement.pdf);
                        }

                        if (changement.listePjs) {
                            vm.infosrecapfin.listePjsAllModules.push(changement.listePjs);
                        }



                        // Depuis US115 - Coord Bancaires (Modif édito écran), on peut enregistrer plusieurs consignes...
                        // Comme dans le DAF, on parle désormais de messages d'Avertissement (attendus dans la listeMessAvert)
                        // ou de messages de Réassurance (attendus dans la listeMessReassur)
                        // Listes implémentées ou non dans 'listesMessages' lors de l'appel à .addChangement()

                        //Ajout des messages d'Avertissement du changement en cours à la liste des messages de Récap
                        if (changement.listesMessages && changement.listesMessages.listeMessAvert) {
                            for (var iAvert = 0; iAvert < changement.listesMessages.listeMessAvert.length; iAvert++) {
                                isExiste = false;
                                for (var jAvert = 0; jAvert < vm.infosrecapfin.listeMessAvert.length && !isExiste; jAvert++) {
                                    isExiste = (changement.listesMessages.listeMessAvert[iAvert].mess===vm.infosrecapfin.listeMessAvert[jAvert].mess);

                                }
                                if (!isExiste) {
                                    vm.infosrecapfin.listeMessAvert.push(changement.listesMessages.listeMessAvert[iAvert]);
                                }
                            }
                        }


                        //Ajout des messages de Réassurance du changement en cours à la liste des messages de Récap
                        if (changement.listesMessages && changement.listesMessages.listeMessReassur) {
                            for (var iReassur = 0; iReassur < changement.listesMessages.listeMessReassur.length; iReassur++) {
                                isExiste = false;
                                for (var jReassur = 0; jReassur < vm.infosrecapfin.listeMessReassur.length && !isExiste; jReassur++) {
                                    isExiste = (changement.listesMessages.listeMessReassur[iReassur].mess===vm.infosrecapfin.listeMessReassur[jReassur].mess);
                                }
                                if (!isExiste) {
                                    vm.infosrecapfin.listeMessReassur.push(changement.listesMessages.listeMessReassur[iReassur]);
                                }
                            }
                        }


                        // Ajout des liens du chgt en cours à la liste des liens vers doc papier format PDF
                        if (changement.listesMessages && changement.listesMessages.listeMessTypeChgmtSF) {
                            for (var iTypeChgSF = 0; iTypeChgSF < changement.listesMessages.listeMessTypeChgmtSF.length; iTypeChgSF++) {
                                isExiste = false;
                                for (var jTypeChgSF = 0; jTypeChgSF < vm.infosrecapfin.listeMessTypeChgmtSF.length && !isExiste; jTypeChgSF++) {
                                    isExiste = (changement.listesMessages.listeMessTypeChgmtSF[jTypeChgSF].mess===vm.infosrecapfin.listeMessTypeChgmtSF[jTypeChgSF].mess);
                                }
                                if (!isExiste) {
                                    if (changement.listesMessages.listeMessTypeChgmtSF[iTypeChgSF].mess === 'separation') {
                                        vm.isSitFamSeparation = true;
                                    }
                                    vm.infosrecapfin.listeMessTypeChgmtSF.push(changement.listesMessages.listeMessTypeChgmtSF[iTypeChgSF]);
                                }
                            }
                        }                          

                        // Ajout des liens à la liste des liens de Récap les liens du changement en cours
                        if ((!vm.isDemandePrestation || vm.forceBoutonRetourMonCompteSeparation || vm.isSitFamSeparation) && changement.listeLiens){

                            for (var iLiens = 0; iLiens < changement.listeLiens.length; iLiens++) {
                                isExiste = false;
                                for (var jLiens = 0; jLiens < vm.infosrecapfin.listeLiens.length && !isExiste; jLiens++) {
                                    isExiste =  (changement.listeLiens[iLiens].prestation===vm.infosrecapfin.listeLiens[jLiens].prestation);
                                }
                                if (!isExiste) {
                                    vm.infosrecapfin.listeLiens.push(changement.listeLiens[iLiens]);
                                }
                            }
                        }

                        // Ajout des liens du chgt en cours à la liste des liens vers doc papier format PDF
                        if (changement.listeLiensPdf) {
                            for (var iPdf = 0; iPdf < changement.listeLiensPdf.length; iPdf++) {
                                isExiste = false;
                                for (var jPdf = 0; jPdf < vm.infosrecapfin.listeLiensPdf.length && !isExiste; jPdf++) {
                                    isExiste = (changement.listeLiensPdf[iPdf].prestation===vm.infosrecapfin.listeLiensPdf[jPdf].prestation);
                                }
                                if (!isExiste) {
                                    vm.infosrecapfin.listeLiensPdf.push(changement.listeLiensPdf[iPdf]);
                                }
                            }
                        }                      
                    }
                }
            }

            // initialisation du code situation dossier utilisé pour afficher le PDF, seulement si on en a besoin
            if (vm.infosrecapfin.listeLiensPdf.length > 0) {
                vm.infosrecapfin.codeSituationDossier = CnafCctPdfsService.getCodeSituationDossier();
            }


            // FIN_PAGE_01 Maj du chemin de fer CAS CHANGEMENT UNITAIRE
            // On considère ce cas par defaut, il est susceptible d'être modifié selon les cas.
            $('#theme-contenu-content-cnaf .container .titre-page-cnaf').html("CHANGEMENT DE SITUATION");
            $('#theme-contenu-filariane-cnaf .container .row .breadcrumb li:last').html('Changement de situation');
            $('#theme-header-content-cnaf .container .row .titre-cnaf .sous-titre-cnaf').html('Changement de situation');



            // -------  GESTION DES TITRES  ---------

            // Si le titre n'a pas été défini plus haut
            if (!vm.infosrecapfin.titre) {

                if (!vm.isDemandePrestation) { // En dehors du contexte de demande/déclaration de prestation

                    if (vm.listeChangements) { // Cas des teleprocedures simples

                        if (vm.nbChangement == 0) { // Liste de changement initialisée MAIS pas de changement dans la liste

                            // Cas inconnu

                        } else if (vm.nbChangement == 1) { // Cas de changement unitaire
                            if (vm.isPrimoSuiteSeparation) {
                                vm.infosrecapfin.titre = "Votre séparation a bien été prise en compte.<br>";
                            }
                            else if (vm.titreDuDernierChangement) {

                                vm.infosrecapfin.titre = vm.titreDuDernierChangement; // FIN_RUB_01

                            } else {

                                vm.infosrecapfin.titre = "Votre déclaration a bien été enregistrée.";

                            }

                        } else { // Cas où on a plusieurs changements en même temps
                            // NE DOIT PLUS ETRE POSSIBLE !!!
                            vm.infosrecapfin.titre = "Votre déclaration a bien été enregistrée."; // FIN_RUB_02

                            // FIN_PAGE_01 Maj du chemin de fer CAS PLUSIEURS CHANGEMENTS
                            $('#theme-contenu-content-cnaf .container .titre-page-cnaf').html("CHANGEMENT DE SITUATIONS");
                            $('#theme-contenu-filariane-cnaf .container .row .breadcrumb li:last').html('Changement de situations');
                            $('#theme-header-content-cnaf .container .row .titre-cnaf .sous-titre-cnaf').html('Changement de situations');

                        }


                        if (vm.urlEnchainement) {

                            if (vm.libelleDemarche) {

                                vm.infosrecapfin.titre += "<br>Cliquer sur Continuer pour faire votre " + vm.libelleDemarche+".";

                            } else {

                                vm.infosrecapfin.titre += "<br>Cliquer sur Continuer pour faire votre démarche.";

                            }

                        }

                    } else { // On arrive sur la page de fin en dehors d'une demande de prestation ET sans liste de changement ! (confirmation ?)

                        if (vm.libelleDemarche) {

                            vm.infosrecapfin.titre = "Votre "+ vm.libelleDemarche +" a bien été enregistrée.";
                            
                            if (vm.isPrimoSuiteSeparation) {
                                vm.infosrecapfin.titre = "Votre séparation a bien été prise en compte.<br>";
                                vm.infosrecapfin.titre += "Vous n’avez plus à répondre à la demande qui vous a été faite.";
                                vm.forceBoutonRetourMonCompteSeparation = true;
                            }                            

                        } else {

                            // Cas inconnu

                        }

                    }

                } else { // Contexte demande de prestation

                    if (vm.urlEnchainement) { // La demande de prestation pas encore finie

                        if (vm.libelleDemarche) { // On connait la démarche en cours

                            vm.infosrecapfin.titre = "Votre Profil a bien été mis à jour.<br>";
                            if (vm.isPrimoSuiteSeparation) {
                                vm.infosrecapfin.titre = "Votre séparation a bien été prise en compte.<br>";
                            }
                            vm.infosrecapfin.titre += "Cliquer sur Continuer pour faire votre " + vm.libelleDemarche+".";

                        } else {

                            vm.infosrecapfin.titre = "Votre Profil a bien été mis à jour.<br>";
                            if (vm.isPrimoSuiteSeparation) {
                                vm.infosrecapfin.titre = "Votre séparation a bien été prise en compte.<br>";
                            }                            
                            vm.infosrecapfin.titre += "Cliquer sur Continuer pour faire votre démarche.";

                        }

                    } else { // Derniere etape de la demande de prestation

                        if (vm.libelleDemarche) { // On connait la démarche en cours

                            vm.infosrecapfin.titre = "Votre "+ vm.libelleDemarche +" a bien été enregistrée.";

                        } else { // On ne connait pas la démarche en cours (ce qui ne devrait pas arriver !)

                            vm.infosrecapfin.titre = "Votre démarche a bien été enregistrée.";
                            if (vm.isPrimoSuiteSeparation) {
                                vm.infosrecapfin.titre = "Votre séparation a bien été prise en compte.<br>";
                            }                            
                        }

                    }

                }

            }

            // Finalement, si aucun titre n'est trouvé plus haut, on impose celui-ci, pour couvrir les cas inconnus
            // Autrement dit, si vous voyez ce titre (ce qui ne devrait pas arriver !), c'est que votre cas n'est pas géré.
            // Il faut alors mettre le DAF et/ou le code à jour.
            if (!vm.infosrecapfin.titre) {

                vm.infosrecapfin.titre = "Votre démarche est terminée.";

            }

            // ------- FIN GESTION DES TITRES  ---------



            // CALP : Avec le nouveau Profil (crayon) comme on n'a plus la possibilité d'enchainer des changements sur la page de fin on redirige systématiquement sur le Profil
            // Bouton 'Revenir à Mon Profil'
            if(vm.redirectmoncomptemobile){
                if (vm.isRoleResponsableDossier) {
                    if (vm.isDemandePrestation
                    && vm.urlEnchainement
                    && (vm.contexteaiguillage === 'demandeArs'
                        || vm.contexteaiguillage === 'dtAah'
                        || vm.contexteaiguillage === 'evafor'
                        || vm.contexteaiguillage === 'maintienLieux'
                        || vm.contexteaiguillage === 'DPD'
                        || vm.contexteaiguillage === 'declarationAvantageVieillesse')) {
                        // Affichage de la page de fin light en mode mobile également  pour alerte ARS et dtraah
                        // Prise en compte de l'appli mobile
                        vm.urlEnchainement = vm.urlEnchainement.replace('monCompteMonProfil','applimobileMonCompteMonProfil');
                        vm.texteduBoutonRevenirAMonProfil = "Continuer";
                        vm.titreduBoutonRevenirAMonProfil = "Cliquer pour poursuivre votre "+vm.libelleDemarche;
                        vm.lienduBoutonRevenirAMonProfil = vm.urlEnchainement;
                    }
                    else {
                        vm.texteduBoutonRevenirAMonProfil = "Revenir à Mon Profil";
                        vm.titreduBoutonRevenirAMonProfil = "Cliquer pour revenir à Mon Profil";
                        vm.lienduBoutonRevenirAMonProfil = "/redirect/s/Redirect?page=applimobileMonCompteMonProfil";    
                    }
                } else {
                    vm.texteduBoutonRevenirAMonProfil = "Revenir à Mon Compte";
                    vm.titreduBoutonRevenirAMonProfil = "Cliquer pour revenir à Mon Compte";
                    vm.lienduBoutonRevenirAMonProfil = "/redirect/s/Redirect?page=applimobileMonCompte";                    
                }
            }else{
                // Si role <> de responsableDossier alors retour sur espace MonCompte
                if (!vm.isRoleResponsableDossier) {
                    if (vm.isDemandePrestation && !vm.forceBoutonRetourMonCompteSeparation) {
                    // Cas ou la personne devient primo-demandeur suite à une séparation et est venu faire une demande de presta 
                    // --> on débranche dans ce cas vers la demande primo correspondante pour 4 demandes particulières
        
                        if (vm.contexteaiguillage === 'demandeAl'
                        || vm.contexteaiguillage === 'demandePa'
                        || vm.contexteaiguillage === 'demandeRsa'
                        || vm.contexteaiguillage === 'demandePrimeNaissance') {
                            vm.texteduBoutonRevenirAMonProfil = "Continuer";
                            vm.titreduBoutonRevenirAMonProfil = "Cliquer pour poursuivre votre "+vm.libelleDemarche;
                            vm.lienduBoutonRevenirAMonProfil = '/redirect/s/Redirect?page='+vm.contexteaiguillage;
                        } else {
                            vm.texteduBoutonRevenirAMonProfil = "Continuer";
                            vm.titreduBoutonRevenirAMonProfil = "Cliquer pour poursuivre votre démarche";
                            vm.lienduBoutonRevenirAMonProfil = "/redirect/s/Redirect?page=monCompteFormulaires";                              
                        }
                    
                    } else {
                        vm.texteduBoutonRevenirAMonProfil = "Revenir à Mon Compte";
                        vm.titreduBoutonRevenirAMonProfil = "Cliquer pour revenir à Mon Compte";
                        vm.lienduBoutonRevenirAMonProfil = "/redirect/s/Redirect?page=monCompte"; 
                    }
                }        
                else if (vm.urlEnchainement){
                    vm.texteduBoutonRevenirAMonProfil = "Continuer";
                    vm.titreduBoutonRevenirAMonProfil = "Cliquer pour poursuivre votre "+vm.libelleDemarche;
                    vm.lienduBoutonRevenirAMonProfil = vm.urlEnchainement;
                }
                else if (vm.eligibleAvisChgtCaf === "true"){
                    vm.texteduBoutonRevenirAMonProfil = "Continuer";
                    vm.titreduBoutonRevenirAMonProfil = "Cliquer pour "+ vm.libelleDemarche;
                    vm.lienduBoutonRevenirAMonProfil = '/redirect/s/Redirect?page=monCompteMonProfil';
                }                 
                else{
                    vm.texteduBoutonRevenirAMonProfil = "Revenir à Mon Profil";
                    vm.titreduBoutonRevenirAMonProfil = "Cliquer pour revenir à Mon Profil";
                    vm.lienduBoutonRevenirAMonProfil = "/redirect/s/Redirect?page=monCompteMonProfil";
                }
            }
            vm.revenirAMonProfil = function(){
                CnafCctSaveChangementSessionService.clearData('matricule');
                window.location=vm.lienduBoutonRevenirAMonProfil;
            };

            /* 
                Gestion Demarches Iconiques / Mon avis numérique

                Affichage du bloc si et seulement si vm.demarcheiconique (en particulier vm.demarcheiconique.lienVersMonAvisNumerique) existe.
                La variable vm.demarcheiconique est renseigné soit :
                    - à l'appel du composant gestion-pdfs-fin en passant vm.demarcheiconique en paramètre (c'est le cas pour ressourcesannuellesappli)
                    - ici, pour les démarches unitaires classiques

                Une variable définie par l'appli appellante est prioritaire sur ce traitement.
                Dans tous les cas, si presence urlEnchainement => Pas de demarche iconique (page de fin light).
            */
            if (!vm.demarcheiconique // La variable n'est pas définie directement par l'appli appellante
                && !vm.urlEnchainement){ //Pas d'enchainement : page de fin complête (avec les liens)
                vm.demarcheiconique = 
                {
                    lienVersMonAvisNumerique : "https://monavis.numerique.gouv.fr/Demarches/1081?&view-mode=formulaire-avis&nd_mode=en-ligne-enti%C3%A8rement&nd_source=button&key=97e55a35d07d64d4d57977b71f97d450",
                    titleDuLien : "Je donne mon avis sur cette démarche."
                };
            }
            if(vm.urlEnchainement){ // Enchainement : page de fin light (sans les liens)
                vm.demarcheiconique = false; //Reset de la variable (si prealablement definie dans l'appli appellante)
            }

            vm.etat = "loaded";

        };



        //Gestion du bloc 'Oups / Droit à l'erreur'
        vm.oupsCollapsed = true;
        vm.toggleOupsCollapse = function() {
            vm.oupsCollapsed = !vm.oupsCollapsed;
        };
        vm.imgSrcOupsButtonCollapsable = function() {
            if(vm.oupsCollapsed) return "/icfstatiquesangularappli/dist/images/chevron-bas-menu.png";
            else return "/icfstatiquesangularappli/dist/images/usager/chevron-haut-menu.png";
        };
        vm.titleOupsButtonCollapsable = function() {
            if(vm.oupsCollapsed) return "En savoir plus";
            else return "Replier le volet";
        };


        vm.getNDWeb = function(codeOrga, identifiantNDWEB) {
            return CnafCctPdfsService.getPdfNDWEB(codeOrga, identifiantNDWEB).getPdf().$promise;
            // Appel d'un Pdf déjà créé
            //return CnafCoordBancService.httpGetPdfNDWEB('457', vm.idFluxElecNDWEB);
        };
        
        vm.pdfOnSuccess = function() {
            //rien
        };

        vm.pdfOnError = function() {
            vm.etat = "error";
        };
        vm.getCompositionPromise = function(params) {
            var demandePrestations = CnafCctPdfsService.demandePrestations();
            return demandePrestations.postPdf({
              code_prestation: params.codePrestation,
              situation: params.situation,
              code_organisme: params.codeOrga,
              ressources_presentes_n1: params.ressources_presentes_n1,
              ressources_presentes_n2: params.ressources_presentes_n2,
              liste_cab: params.liste_cab
            }).$promise;
        };

        vm.pdfPromise = function (prestation, situationDossier) {
            return vm.getCompositionPromise(
                {
                    codePrestation: prestation,
                    situation: situationDossier,
                    codeOrga: (vm.infosrecapfin.codeOrga),
                    ressources_presentes_n1: true,
                    ressources_presentes_n2: true
                }
            );
        };
        vm.pdfOnSuccess = function (codePrestation, data) {
        };
        vm.pdfOnError = function (codePrestation, error) {
        };

        vm.afficheBlocLeSaviezVous = function () {
            return ((!vm.isDemandePrestation || vm.isSitFamSeparation) &&
                        (vm.infosrecapfin.listeLiensPdf.length > 0 
                            || vm.infosrecapfin.listeLiens.length > 0));
        };
    }


     /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctGestionpdfsfin
     *
     * @description
     * cnafCctGestionpdfsfin affiche la liste des pdfs et l'alerte eventuelle en cas de pj
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} gestionpdfsfinform formulaire
     * @param {Object} errorgestionpdfsfin erreurs
     * @param {Object} infosrecapfin informations nécessaires à l'affichage de la liste
     * @param {Object} contexteaiguillage si appel dans le cadre d'une demande de prestation ou déclaration

     * @param {Object} demarcheiconique - facultatif - si besoin de faire afficher un bloc vers "Mon Avis Numerique"
     *  ex : {'lienVersMonAvisNumerique' : 'https://monavis.numerique.gouv.fr/...',
     *        'titleDuLien' : 'Je donne mon avis sur cette démarche "Déclaration de ..."'}
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */
    angular.module('cnafComponentsTeleprocApp').component('cnafCctGestionpdfsfin', {
        templateUrl: 'components/cnaf-cct-gestion-pdfs-fin/cnaf-cct-gestion-pdfs-fin.html',
        bindings: {
            data: '=',
            gestionpdfsfinform: "=",
            errorgestionpdfsfin: "=",
            infosrecapfin: "=",
            redirectmoncomptemobile: "=?",
            typechangement: "@?",
            contexteaiguillage: "=?",
            demarcheiconique: "<?"
        },
        controllerAs: 'vm',
        controller: CnafCctGestionpdfsfinController
    });
})();

(function() {
    'use strict';

    CnafCctGrossesseController.$inject = ['CnafCctGrossesseControleDateService','CnafCctGestionTypeService','CnafCctConstantMsgTypes'];

    function CnafCctGrossesseController(CnafCctGrossesseControleDateService, CnafCctGestionTypeService,CnafCctConstantMsgTypes) {
        var vm = this;

        vm.controleExamPreNatalDateSuperieur = CnafCctGrossesseControleDateService.controleExamPreNatalDateSuperieur;
        vm.controleDateDebGro = CnafCctGrossesseControleDateService.controleDateDebGro;
        vm.controleDateExamPreNat = CnafCctGrossesseControleDateService.controleDateExamPreNat;
        vm.controleDateDernierEnfant = CnafCctGrossesseControleDateService.controleDateDernierEnfant;

        vm.testType8 = function(donnee,form){
          if (donnee === undefined || donnee.length === 0){
              form.$setValidity('type8', true);
          }
          else {
            var retourControles = CnafCctGestionTypeService.appelControleType8(donnee, form);
            if (retourControles !== null)
            {
              vm.data.nomMedecin = retourControles;
            }
          }
        };

        //Contrôle Téléphone
        vm.testType2 = function (donnee, form, nomDonnee) {
            if (donnee === undefined || donnee.length === 0) {
                form.$setValidity('type2', true);
            }
            else {
                var retourControles = CnafCctGestionTypeService.appelControleType2(donnee, form);
                if (retourControles !== null) {
                    vm.data[nomDonnee] = retourControles;
                }
            }
        };

        //********************************************************/
        //*     Gestion Nouveau Bouton BtnPlus (sorti d'ICF)     */
        //* ******************************************************/
        vm.btnMoins = function(){
            if(vm.data.nbEnf>1)
            vm.data.nbEnf--;
        };
        vm.btnPlus = function(){
            if(vm.data.nbEnf<=8)
            vm.data.nbEnf++;
        };

    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctGrossesse
     *
     * @description
     * cnafCctGrossesse affiche les champs de saisie pour une déclaration de grossesse
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} etatcivilform formulaire
     * @param {Object} erroretatcivil erreurs
     * @param {Date} today date de la démarche
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctGrossesse', {
        templateUrl: 'components/cnaf-cct-grossesse/cnaf-cct-grossesse.html',
        bindings: {
            data: '=',
            grossesseform: "=",
            errorgrossesse: "=",
            controle: "=",
            today: "="
        },
        controllerAs: 'vm',
        controller: CnafCctGrossesseController
    });
})();

(function() {
    'use strict';

    CnafCctHospitalisationController.$inject = ['CnafCctAdresseSocleService','$filter','CnafCctGestionTypeService','CnafCctConstantMsgTypes','CnafCctDateService'];

    function CnafCctHospitalisationController(CnafCctAdresseSocleService,$filter,CnafCctGestionTypeService,CnafCctConstantMsgTypes,CnafCctDateService) {
        var vm = this;

        /* ------------------------------------------------------------------------------------------------------------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {

            //AMABIS :
            CnafCctAdresseSocleService.getEtatAmabis().get()
                .$promise.then(
                function successCallback(result) {
                    vm.autocompletion = "on";
                },
                function errorCallback(error) {
                    vm.autocompletion = "off";
                });

            vm.controleCodePostalFormat = CnafCctAdresseSocleService.controleCodePostalFormat;

            vm.httpRechListePaysEtabHosp();

            vm.datedemarche = vm.controle.datedemarche;
        };

        //Recherche liste pays
        vm.httpRechListePaysEtabHosp = function() {
            CnafCctAdresseSocleService.rechListePays().get().$promise.then(
                function successCallback (response0) {
                    vm.listePaysEtabHosp = response0.listePays;
                },
                function errorCallback(error) {
                    vm.etat = "error";
                });
        };

        //AUTO-COMPLETION
        //Pays :
        vm.getListePaysEtabHospProposes = function(prefix) {
            return vm.listePaysEtabHosp;
        };

        vm.controleSupDateDeb = function(dateFin,dateDebut){
            var valueControle = true;
            if (dateDebut && dateDebut.length >= 10 && dateFin && dateFin.length >= 10 ){
                var dateDebATester = Date.parseExact(dateDebut, "d/M/yyyy");
                var dateFinATester = Date.parseExact(dateFin, "d/M/yyyy");
                if (dateFinATester && 'Invalid Date' != dateFinATester && dateDebATester && 'Invalid Date' != dateDebATester) {
                    if (dateFinATester < dateDebATester) {
                        valueControle = false;
                    }
                }
            }
            return valueControle;
        };

        vm.controleDateDemarcheDateHosp = function(dateDebut){
            var dateDebutATester = Date.parseExact(dateDebut, "d/M/yyyy");
            //La date de début Hospitalisation doit être inférieure au dernier jour du mois suivant le mois de démarche...
            var date = new Date(vm.datedemarche.getFullYear(), vm.datedemarche.getMonth() + 2, 0);
            vm.dernierJourMoisSuivant = date;
            if(dateDebutATester > vm.dernierJourMoisSuivant){
                return false;
            }else{
                return true;
            }

        };

        vm.controleSupDateOd = function (date, dernjourodal) {
            var valueControle = true;
            if (date && date.length >= 10 ){
                var dateATester = Date.parseExact(date, "d/M/yyyy");
                if (dateATester && 'Invalid Date' != dateATester) {
                    if (dateATester > dernjourodal) {
                        valueControle = false;
                    }
                }
            }
            return valueControle;
        };

        vm.afficheCodePostalVille = function () {
            if (vm.data.paysEtabHosp){
                if (vm.data.paysEtabHosp.libelleCaffr == 'FRANCE' || vm.data.paysEtabHosp.libelleCaffr == 'PRINCIPAUTE DE MONACO'){
                    return (true);
                } else
                {
                    return (false);
                }
            }
        };

        vm.codePostalVilles = function(prefix) {
            return CnafCctAdresseSocleService.localitesSansLD(prefix, CnafCctAdresseSocleService.transformCodePays(vm.data.codePostalVille)).get()
                .$promise.then(function(result){
                    return $filter('limitTo')(result.listRechLoc, 10);
                });
        };

        vm.testType5 = function(donnee,form){
            if (donnee === undefined || donnee.length === 0){
                form.$setValidity('type5', true);
            }
            else {
                var retourControles = CnafCctGestionTypeService.appelControleType5(donnee, form);
                if (retourControles !== null)
                {
                    vm.data.villeEtabHosp=retourControles;
                    return true;
                }
            }
        };

        vm.testType8 = function(donnee,form,nomDonnee){
            if (donnee === undefined || donnee.length === 0){
                form.$setValidity('type8', true);
            }
            else {
                var retourControles = CnafCctGestionTypeService.appelControleType8(donnee, form);
                if (retourControles !== null)
                {
                    vm.data[nomDonnee]=retourControles;
                }
            }
        };

    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctSitproChoixActiviteSalariee
     *
     * @description
     * cnafCctSitproChoixActiviteSalariee affiche les champs de saisie pour choisir son activité de type "salarié"
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} choixactivitesalarieeform formulaire
     * @param {Object} errorchoixactivitesalariee erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     * @param {Date} dernier jour du mois d'ouverture de droit à l'AL
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctHospitalisation', {
        templateUrl: 'components/cnaf-cct-hospitalisation/cnaf-cct-hospitalisation.html',
        bindings: {
            data: '=',
            hospitalisationform: "=",
            errorhospitalisation: "=",
            autocompletion: '=',
            controle: '='
        },
        controllerAs: 'vm',
        controller: CnafCctHospitalisationController
    });
})();

(function() {
    'use strict';

    CnafCctLienparenteController.$inject = ['CnafCctDateService'];

    function CnafCctLienparenteController(CnafCctDateService) {
        var vm = this;

        vm.controleDatesNaissance = function(lienParente) {
            var isDateNaisssanceCjtSup = true;
            if (lienParente) {
                var codeLienParente = lienParente.code;
                if (codeLienParente === 'ENF' || codeLienParente === 'ADO' || codeLienParente === 'DES') {
                    if (vm.infoslienparente.dateNaissance && vm.controle.dateNaissance) {
                        var stringDateNaissanceRespOuCjt = CnafCctDateService.getDateFormatCristalToFormatEcran(vm.infoslienparente.dateNaissance);
                        isDateNaisssanceCjtSup = !CnafCctDateService.isDateStrictementSuperieure(
                            stringDateNaissanceRespOuCjt,
                            vm.controle.dateNaissance
                        );
                    }
                }
            }

            return isDateNaisssanceCjtSup;
        };

        vm.controleONCASC = function() {
            var isAgeSup26 = CnafCctDateService.isAgeSupAXX(26, vm.controle.dateNaissance, CnafCctDateService.getDateToday());

            var isCombinaisonInterdite = false;
            if (vm.data.infosLiensParente[1]) {
                var codeLienParente1 = vm.data.infosLiensParente[1].lienParente.code;
                var codeLienParente0 = vm.data.infosLiensParente[0].lienParente.code;
                if (
                    (codeLienParente1 === 'ONC' || codeLienParente1 === 'ASC') &&
                    (codeLienParente0 === 'ENF' ||
                        codeLienParente0 === 'ADO' ||
                        codeLienParente0 === 'DES' ||
                        (codeLienParente0 === 'FRE' && !isAgeSup26) ||
                        (codeLienParente0 === 'NEV' && !isAgeSup26))
                ) {
                    isCombinaisonInterdite = true;
                }
                if (
                    (codeLienParente0 === 'ONC' || codeLienParente0 === 'ASC') &&
                    (codeLienParente1 === 'ENF' ||
                        codeLienParente1 === 'ADO' ||
                        codeLienParente1 === 'DES' ||
                        (codeLienParente1 === 'FRE' && !isAgeSup26) ||
                        (codeLienParente1 === 'NEV' && !isAgeSup26))
                ) {
                    isCombinaisonInterdite = true;
                }
            }
            vm.lienparenteform.controleONCASC = isCombinaisonInterdite;
            return !isCombinaisonInterdite;
        };
    }

    angular.module('cnafComponentsTeleprocApp').component('cnafCctLienparente', {
        templateUrl: 'components/cnaf-cct-lienparente/cnaf-cct-lienparente.html',
        bindings: {
            data: '=',
            controle: '=',
            lienparenteform: '=',
            errorlienparente: '=',
            infoslienparente: '=',
            indice: '='
        },
        controllerAs: 'vm',
        controller: CnafCctLienparenteController
    });
})();

(function() {
    'use strict';

    CnafCctLieunaissanceController.$inject = ['CnafCctAdresseSocleService', '$filter', 'CnafCctGestionTypeService', 'CnafCctConstantMsgTypes'];

    function CnafCctLieunaissanceController(CnafCctAdresseSocleService, $filter, CnafCctGestionTypeService, CnafCctConstantMsgTypes) {
        var vm = this;
        vm.listePaysNaissance = null;

        /* ------------------- */
        /*       SERVICE       */
        /* ------------------- */
        //AMABIS:
        vm.controleCodePostalFormat = CnafCctAdresseSocleService.controleCodePostalFormat;

        vm.testType5 = function(donnee, form) {
            if (donnee === undefined || donnee.length === 0) {
                form.$setValidity('type5', true);
            } else {
                var retourControles = CnafCctGestionTypeService.appelControleType5(donnee, form);
                if (retourControles !== null) {
                    vm.data.villeNaiss = retourControles;
                }
            }
        };

        vm.testType12 = function(donnee, form) {
            if (donnee === undefined || donnee.length === 0) {
                form.$setValidity('type12', true);
            } else {
                var retourControles = CnafCctGestionTypeService.appelControleType12(donnee, form);
                if (retourControles !== null) {
                    vm.data.codePostalVille = retourControles;
                }
            }
        };

        /* ------------------------------------------------------------------------------------------------------------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {

            // INC0548969 : mauvaise gestion code commune COM
            /*vm.listeComNaissance = [
                { code: 'SPM', libelle: 'Saint-Pierre-et-Miquelon' },
                { code: 'SB', libelle: 'Saint-Barthélémy' },
                { code: 'SM', libelle: 'Saint-Martin' },
                { code: 'WF', libelle: 'Wallis et Futuna' },
                { code: 'PF', libelle: 'Polynésie Française' },
                { code: 'NC', libelle: 'Nouvelle Calédonie' }
            ];*/
            vm.listeComNaissance = [
                { code: '975', libelle: 'Saint-Pierre-et-Miquelon' },
                { code: '977', libelle: 'Saint-Barthélémy' },
                { code: '978', libelle: 'Saint-Martin' },
                { code: '986', libelle: 'Wallis et Futuna' },
                { code: '987', libelle: 'Polynésie Française' },
                { code: '988', libelle: 'Nouvelle Calédonie' }
            ];


            CnafCctAdresseSocleService.getEtatAmabis()
                .get()
                .$promise.then(
                    function successCallback(result) {
                        vm.autocompletion = 'on';
                    },
                    function errorCallback(error) {
                        vm.autocompletion = 'off';
                    }
                );
        };

        //Recherche liste pays
        vm.httpRechListePaysNaissance = function() {
            CnafCctAdresseSocleService.rechListePays()
                .get()
                .$promise.then(
                    function successCallback(response0) {
                        vm.listePaysNaissance = response0.listePays;
                    },
                    function errorCallback(error) {
                        vm.etat = 'error';
                    }
                );
        };

        // Exclusion de la france lorsque Etranger est coché
        vm.exclusionFrance = function(pays) {
            return pays.code !== "FR";
        };

        //AUTO-COMPLETION
        //Pays :
        vm.getListePaysNaissanceProposes = function(prefix) {
            return vm.listePaysNaissance;
        };

        vm.codePostalVilles = function(prefix) {
            return CnafCctAdresseSocleService.localitesSansLD(prefix, CnafCctAdresseSocleService.transformCodePays(vm.data.codePostalVille))
                .get()
                .$promise.then(function(result) {
                    return $filter('limitTo')(result.listRechLoc, 10);
                });
        };

        /* --------------------------- */
        /*             INIT            */
        /* --------------------------- */
        //Alimentation de la liste des pays
        vm.httpRechListePaysNaissance();
    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctLieunaissance
     *
     * @description
     * cnafCctLieunaissance affiche les champs de saisie pour le lieu de naissance
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} lieunaissanceform formulaire
     * @param {Object} errorlieunaissance erreurs
     * @param {Object} listepays liste des Pays
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */
    angular.module('cnafComponentsTeleprocApp').component('cnafCctLieunaissance', {
        templateUrl: 'components/cnaf-cct-lieunaissance/cnaf-cct-lieunaissance.html',
        bindings: {
            data: '=',
            lieunaissanceform: '=',
            errorlieunaissance: '=',
            listepays: '=',
            controle: '=',
            autocompletion: '='
        },
        controllerAs: 'vm',
        controller: CnafCctLieunaissanceController
    });
})();

(function() {
    'use strict';

    CnafCctMessageChampsObligatoiresController.$inject = [];

    function CnafCctMessageChampsObligatoiresController() {
 

    }

    /**
     * @ngdoc directive
     * @name cnafCctMessageChampsObligatoiresController.component:cnafCctMessageChampsObligatoiresController
     *
     * @description
     *
     *
     * @restrict E
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctMessageChampsObligatoires', {
        templateUrl: 'components/cnaf-cct-message-champs-obligatoires/cnaf-cct-message-champs-obligatoires.html',
        controllerAs: 'vm',
        controller: CnafCctMessageChampsObligatoiresController
    });
})();
(function() {
    'use strict';

    CnafCctNationaliteController.$inject = ['CnafCctGestionTypeService'];

    function CnafCctNationaliteController(CnafCctGestionTypeService) {
        var vm = this;

        vm.testType3 = function(donnee,form,nomDonnee){
            if (donnee === undefined || donnee.length === 0){
              form.$setValidity('type3', true);
            }
            else {
                var retourControles = CnafCctGestionTypeService.appelControleType3(donnee, form);
                if (retourControles !== null)
                {
                    vm.data[nomDonnee]=retourControles;
                }
            }
        };

    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctNationalite
     *
     * @description
     * cnafCctNationalite affiche les champs de saisie pour déclarer la nationalité
     * (avec saisie des nom/prénom des parents pour nationalité autre que Française)
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} etatcivilform formulaire
     * @param {Object} erroretatcivil erreurs
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */
    angular.module('cnafComponentsTeleprocApp').component('cnafCctNationalite', {
        templateUrl: 'components/cnaf-cct-nationalite/cnaf-cct-nationalite.html',
        bindings: {
            data: '=',
            nationaliteform: "=",
            controle: "=",
            errornationalite: "=",
        },
        controllerAs: 'vm',
        controller: CnafCctNationaliteController
    });
})();

(function() {
    'use strict';

    CnafCctNationaliteSimpleController.$inject = [];

    function CnafCctNationaliteSimpleController() {
        var vm = this;
        vm.listeNationalite = [
            { 
                code: "F", 
                libelle: "Française"
            },
            //RFC0009269-Brexit{ code: 'C', libelle: 'Européenne ou Suisse'},
            { 
                code: "C", 
                libelle: "UE, EEE ou Suisse",
                popover1: "Les pays de l'Union Européenne (UE) et de l'Espace Economique Européen (EEE) : ",
                popover2: "Allemagne - Autriche - Belgique - Bulgarie - Chypre - Croatie - Danemark - Espagne - Estonie - Finlande - France - Grèce - Hongrie - Irlande - Islande - Italie - Lettonie - Liechtenstein - Lituanie - Luxembourg - Malte - Norvège - Pays Bas - Pologne - Portugal - République Tchèque - Roumanie - Slovaquie - Slovénie - Suède"
            },
            { 
                code: "A", 
                libelle: "Autre"
            }
          ];
    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctNationaliteSimple
     *
     * @description
     * cnafCctNationaliteSimple affiche les champs de saisie pour déclarer la nationalité
     * (sans saisie des nom/prénom des parents pour nationalité autre que Française)
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} etatcivilform formulaire
     * @param {Object} erroretatcivil erreurs
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctNationaliteSimple', {
        templateUrl: 'components/cnaf-cct-nationalitesimple/cnaf-cct-nationalitesimple.html',
        bindings: {
            data: '=',
            nationaliteform: "=",
            controle: "=",
            errornationalite: "=",
        },
        controllerAs: 'vm',
        controller: CnafCctNationaliteSimpleController
    });
})();

(function() {
    'use strict';

    CnafCctNomsparentsController.$inject = ['CnafCctGestionTypeService'];

    function CnafCctNomsparentsController(CnafCctGestionTypeService) {
        var vm = this;

        vm.testType3 = function(donnee,form,nomDonnee){
            if (donnee === undefined || donnee.length === 0){
              form.$setValidity('type3', true);
            }
            else {
                var retourControles = CnafCctGestionTypeService.appelControleType3(donnee, form);
                if (retourControles !== null)
                {
                    vm.data[nomDonnee]=retourControles;
                }
            }
        };

    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctNomsparents
     *
     * @description
     * cnafCctNomsparents affiche les champs de saisie pour déclarer
     * les nom/prénom des parents pour nationalité autre que Française
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} etatcivilform formulaire
     * @param {Object} erroretatcivil erreurs
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */
    angular.module('cnafComponentsTeleprocApp').component('cnafCctNomsparents', {
        templateUrl: 'components/cnaf-cct-nomsparents/cnaf-cct-nomsparents.html',
        bindings: {
            data: '=',
            nomsparentsform: "=",
            controle: "=",
            errornomsparents: "=",
        },
        controllerAs: 'vm',
        controller: CnafCctNomsparentsController
    });
})();

(function() {
    'use strict';

    CnafCctPrestationspercuesSitenfController.$inject = ['CnafCctAdresseSocleService', 'CnafCctDateService', 'CnafCctGestionTypeService'];

    function CnafCctPrestationspercuesSitenfController(CnafCctAdresseSocleService, CnafCctDateService, CnafCctGestionTypeService) {
        var vm = this;

        /* ------------------- */
        /*       SERVICE       */
        /* ------------------- */

        // cette date doit être inférieure à la date du jour
        vm.controleDateFinPerception = CnafCctDateService.controleDateJour;

        vm.testType8 = function(donnee, form, nomDonnee) {
            if (donnee === undefined || donnee.length === 0) {
                form.$setValidity('type8', true);
            } else {
                var retourControles = CnafCctGestionTypeService.appelControleType8(donnee, form);
                if (retourControles !== null) {
                    vm.data[nomDonnee] = retourControles;
                }
            }
        };

        vm.testType10 = function(donnee, form, nomDonnee) {
            if (donnee === undefined || donnee.length === 0) {
                form.$setValidity('type10', true);
            } else {
                var retourControles = CnafCctGestionTypeService.appelControleType10(donnee, form);
                if (retourControles !== null) {
                    vm.data[nomDonnee] = retourControles;
                }
            }
        };

        /* ------------------------------------------------------------------------------------------------------------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
            vm.httpRechListePaysPresta();
            vm.httpRechListeDepartements();
        };

        //Recherche liste pays pour établissement boursier
        vm.httpRechListePaysPresta = function() {
            CnafCctAdresseSocleService.rechListePays()
                .get()
                .$promise.then(
                    function successCallback(response0) {
                        vm.listePays = response0.listePays;
                    },
                    function errorCallback(error) {
                        vm.etat = 'error';
                    }
                );
        };

        //Recherche liste pays pour établissement boursier
        vm.httpRechListeDepartements = function() {
            CnafCctAdresseSocleService.rechListeDepartements()
                .get()
                .$promise.then(
                    function successCallback(response0) {
                        vm.listeDepartements = response0.listeDepartements;
                    },
                    function errorCallback(error) {
                        vm.etat = 'error';
                    }
                );
        };

        //AUTO-COMPLETION
        //Pays :
        vm.getListePays = function(prefix) {
            return vm.listePays;
        };
        //Pays :
        vm.getListeDepartements = function(prefix) {
            return vm.listeDepartements;
        };

        vm.reinitErreurAdresse = function() {
            vm.erroradresse = false;
        };
    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctPrestationspercuesSitenf
     *
     * @description
     * cnafCctPrestationspercuesSitenf affiche les champs de saisie pour les prestations preçues
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} prestationspercuesform formulaire
     * @param {Object} errorprestationspercues erreurs
     * @param {boolean} agesup25 indique si la personne a plus de 25 ans
     * @param {boolean} conjoint indique si on traite le conjoint
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */
    angular.module('cnafComponentsTeleprocApp').component('cnafCctPrestationspercuesSitenf', {
        templateUrl: 'components/cnaf-cct-prestationspercues-sitenf/cnaf-cct-prestationspercues-sitenf.html',
        bindings: {
            data: '=',
            prestationspercuesform: '=',
            errorprestationspercues: '=',
            controle: '='
        },
        controllerAs: 'vm',
        controller: CnafCctPrestationspercuesSitenfController
    });
})();

(function() {
    'use strict';

    CnafCctPrestationspercuesSocleController.$inject = ['CnafCctAdresseSocleService','CnafCctGestionTypeService','CnafCctConstantMsgTypes'];

    function CnafCctPrestationspercuesSocleController(CnafCctAdresseSocleService,CnafCctGestionTypeService,CnafCctConstantMsgTypes) {
        var vm = this;

        /* ------------------- */
        /*       SERVICE       */
        /* ------------------- */
        //AMABIS :
        vm.numEtAdresse = CnafCctAdresseSocleService.numEtAdresse;
        vm.codePostalVilles = CnafCctAdresseSocleService.codePostalVilles;
        vm.controleCodePostalFormat = CnafCctAdresseSocleService.controleCodePostalFormat;

        vm.testType3 = function(donnee,form,nomDonnee){
            if (donnee === undefined || donnee.length === 0){
              form.$setValidity('type3', true);
            }
            else {
                var retourControles = CnafCctGestionTypeService.appelControleType3(donnee, form);
                if (retourControles !== null)
                {
                  vm.data[nomDonnee]=retourControles;
                }
            }
        };

        vm.testType5 = function(donnee,form){
            if (donnee === undefined || donnee.length === 0){
                form.$setValidity('type5', true);
                return true;
            }
            else {
                var retourControles = CnafCctGestionTypeService.appelControleType5(donnee, form);
                if (retourControles !== null)
                {
                    vm.data.ville=retourControles;
                    return true;
                }
            }
        };

        vm.testType5Adresse = function(donnee,form){
            if (donnee === undefined || donnee.length === 0){
                form.$setValidity('type5', true);
            }
            else {
                var retourControles = CnafCctGestionTypeService.appelControleType5(donnee, form);
                if (retourControles !== null)
                {
                    vm.data.numEtAdresse=retourControles;
                    return true;
                }
            }
        };

        vm.testType7 = function(donnee,form){
          if (donnee === undefined || donnee.length === 0){
              form.$setValidity('type7', true);
          }
          else {
            var retourControles = CnafCctGestionTypeService.appelControleType7(donnee, form);
            if (retourControles !== null)
            {
              vm.data.numEtAdresse = retourControles;
            }
          }
        };

        vm.testType8 = function(donnee,form,nomDonnee){
          if (donnee === undefined || donnee.length === 0){
              form.$setValidity('type8', true);
          }
          else {
            var retourControles = CnafCctGestionTypeService.appelControleType8(donnee, form);
            if (retourControles !== null)
            {
                vm.data[nomDonnee]=retourControles;
            }
          }
        };

        vm.testType10 = function(donnee,form,nomDonnee){
          if (donnee === undefined || donnee.length === 0){
              form.$setValidity('type10', true);
          }
          else {
            var retourControles = CnafCctGestionTypeService.appelControleType10(donnee, form);
            if (retourControles !== null)
            {
                vm.data[nomDonnee]=retourControles;
            }
          }
        };

        vm.testType12 = function(donnee,form){
          if (donnee === undefined || donnee.length === 0){
              form.$setValidity('type12', true);
          }
          else {
            var retourControles = CnafCctGestionTypeService.appelControleType12(donnee, form);
            if (retourControles !== null)
            {
                vm.data.codePostalVille=retourControles;
            }
          }
        };

        /* ------------------------------------------------------------------------------------------------------------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
          CnafCctAdresseSocleService.getEtatAmabis().get()
              .$promise.then(
                  function successCallback(result) {

                      vm.autocompletion = "on";
                  },
                  function errorCallback(error) {

                      vm.autocompletion = "off";
                  });
            vm.httpRechListePaysPresta();
        };
        //Recherche liste pays pour établissement boursier
        vm.httpRechListePaysPresta = function() {
            CnafCctAdresseSocleService.rechListePays().get().$promise.then(
                function successCallback (response0) {
                    vm.listePays = response0.listePays;
                },
                function errorCallback(error) {
                    vm.etat = "error";
                });
        };

        //AUTO-COMPLETION
        //Pays :
        vm.getListePays = function(prefix) {
            return vm.listePays;
        };

        //AUTO-COMPLETION
        vm.codePostalVilles = function(prefix) {
            return CnafCctAdresseSocleService.localites(prefix, CnafCctAdresseSocleService.transformCodePays(vm.data.codePostalVille)).get()
                .$promise.then(function(result) {
                    return result.listRechLoc;
                });
        };

        vm.numEtAdresse = function(prefix) {
            //On ne fait la recherche que si on a une cleGeo ( que si une recherche a été effectué avec le cp et commune)
            if (vm.data.codePostalVille && vm.data.codePostalVille.cleGeo && vm.data.codePostalVille.cleGeoAgg) {
                return CnafCctAdresseSocleService.voies(vm.data.codePostalVille.cleGeo, vm.data.codePostalVille.cleGeoAgg, prefix).get()
                    .$promise.then(function(result) {
                        return result.listRechVoie;
                    });
            }
        };

        vm.initAdresseEtranger = function(){
            if(vm.data.numEtAdresse){
                if(vm.data.numEtAdresse == '[object Object]'){
                    vm.data.numEtAdresse = "";
                }
            }
        };

        vm.reinitErreurAdresse = function(){
            vm.erroradresse = false;
        };

    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctPrestationspercuesSocle
     *
     * @description
     * cnafCctPrestationspercuesSocle affiche les champs de saisie pour les prestations preçues
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} prestationspercuesform formulaire
     * @param {Object} errorprestationspercues erreurs
     * @param {boolean} agesup25 indique si la personne a plus de 25 ans
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     * @param {boolean} conjoint indique si on traite le conjoint
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */
    angular.module('cnafComponentsTeleprocApp').component('cnafCctPrestationspercuesSocle', {
        templateUrl: 'components/cnaf-cct-prestationspercues-socle/cnaf-cct-prestationspercues-socle.html',
        bindings: {
            data: '=',
            prestationspercuesform: "=",
            errorprestationspercues: "=",
            autocompletion: '=',
            controle: "="
        },
        controllerAs: 'vm',
        controller: CnafCctPrestationspercuesSocleController
    });
})();

(function () {
    'use strict';

    CnafCctQuestionSecreteController.$inject = ['CnafCctGestionTypeService', 'CnafCctConstantMsgTypes'];

    function CnafCctQuestionSecreteController(CnafCctGestionTypeService, CnafCctConstantMsgTypes) {
        var vm = this;

        vm.listequestions = [
            {code: 'meilleurami', libelle:'Nom de votre meilleur ami d\'enfance'},
            {code: 'filmprefere', libelle:'Votre film préféré'},
            {code: 'heroenfance', libelle:'Votre héros d\'enfance'},
            {code: 'nomanimal', libelle:'Nom de votre animal'},
            {code: 'nomecole', libelle:'Nom de votre école'},
            {code: 'nomjeunemere', libelle:'Nom de jeune fille de votre mère'}
        ];



        //Contrôle
        vm.testType10 = function (donnee, form, nomDonnee) {
            if (donnee === undefined || donnee.length === 0) {
                form.$setValidity('type10', true);
            }
            else {
                var retourControles = CnafCctGestionTypeService.appelControleType10(donnee, form);
                if (retourControles !== null) {
                    vm.data[nomDonnee] = retourControles;
                }
            }
        };
    }

    /**
     *
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctQuestionSecrete
     *
     * @description
     * cnafCctQuestionSecrete affiche les champs de choix de la question secrete
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} questionsecreteform formulaire
     * @param {Object} errorquestionsecrete erreurs
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */


    angular.module('cnafComponentsTeleprocApp').component('cnafCctQuestionSecrete', {
        templateUrl: 'components/cnaf-cct-question-secrete/cnaf-cct-question-secrete.html',
        bindings: {
            data: '=',
            questionsecreteform: "=",
            errorquestionsecrete: "=",
            controle: "="
        },
        controllerAs: 'vm',
        controller: CnafCctQuestionSecreteController
    });

})();

(function() {
    'use strict';

    CnafCctResidenceEnfantController.$inject = ['CnafCctAdresseSocleService'];

    function CnafCctResidenceEnfantController(CnafCctAdresseSocleService) {
        var vm = this;

        /* ------------------------------------------------------------------------------------------------------------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
            /* --------------------------- */
            /*             INIT            */
            /* --------------------------- */
            //Alimentation de la liste des pays
            vm.httpRechListePaysResidence();
        };

        //Recherche liste pays
        vm.httpRechListePaysResidence = function() {
            CnafCctAdresseSocleService.rechListePays()
                .get()
                .$promise.then(
                    function successCallback(response0) {
                        vm.listePaysResidence = response0.listePays;
                        vm.listePaysCeeResidence = [];
                        var j = 0;
                        for (var index = 0; index < vm.listePaysResidence.length; index++) {
                            var element = vm.listePaysResidence[index];
                            if (element.donneeAdditionnelle1 === 'CEE' || element.donneeAdditionnelle1 === 'ACE') {
                                vm.listePaysCeeResidence[j] = element;
                                j++;
                            }
                        }
                        vm.listePaysAutreResidence = [];
                        var j = 0;
                        for (var index = 0; index < vm.listePaysResidence.length; index++) {
                            var element = vm.listePaysResidence[index];
                            //Voir avec Claire le cas de PRINCIPAUTE de MONACO  ...|| element.donneeAdditionnelle1 === 'CNV') {
                            if (element.donneeAdditionnelle1 === 'AUT' || element.donneeAdditionnelle1 === 'CNV') {
                                vm.listePaysAutreResidence[j] = element;
                                j++;
                            }
                        }
                    },
                    function errorCallback(error) {
                        vm.etat = 'error';
                    }
                );
        };

        //AUTO-COMPLETION
        //Pays Cee et Suisse
        vm.getListePaysCeeResidenceProposes = function(prefix) {
            return vm.listePaysCeeResidence;
        };

        //AUTO-COMPLETION
        //Pays AUTRE
        vm.getListePaysAutreResidenceProposes = function(prefix) {
            return vm.listePaysAutreResidence;
        };

        //AUTO-COMPLETION
        //Pays :
        vm.getListePaysResidenceProposes = function(prefix) {
            return vm.listePaysResidence;
        };
    }

    /**
     * @ngdoc directive
     * @name SitEnfAppli.component:cnafCctResidenceEnfant
     *
     * @description
     * cnafCctResidenceEnfant affiche les boutons pour définir la résidence de l'enfant
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} residenceform formulaire
     *
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctResidenceEnfant', {
        templateUrl: 'components/cnaf-cct-residence-enfant/cnaf-cct-residence-enfant.html',
        bindings: {
            data: '=',
            residenceform: '=',
            controle: '='
        },
        controllerAs: 'vm',
        controller: CnafCctResidenceEnfantController
    });
})();

(function() {
    'use strict';

    CnafCctSitfamController.$inject = ['$scope', 'CnafCctDateService', '$uibModal', 'CnafCctTokenService'];

    function CnafCctSitfamController($scope, CnafCctDateService, $uibModal, CnafCctTokenService) {


        var vm = this;
        vm.init = function() {
           // console.log("CnafCctSitfamController init");
              vm.role = CnafCctTokenService.getDecodeToken();

            //console.log("vm.controle.sitfamConnue = "+vm.controle.sitfamConnue);
            vm.isSituationConnueCouple = true;
            switch (vm.controle.sitfamConnue) {
                // Pacsé(e)
                case 'PAC':
                // Reprise de PACS
                case 'RPA':
                    vm.listeSitfam = [{ code: 'ISO', libelle: 'Séparé(e)' }, { code: 'MAR', libelle: 'Marié(e)' }];
                    break;
                // vie maritale
                case 'VIM':
                // reprise de vie maritale
                case 'RVC':
                    vm.listeSitfam = [
                        { code: 'ISO', libelle: 'Séparé(e)' },
                        { code: 'MAR', libelle: 'Marié(e)' },
                        { code: 'PAC', libelle: 'Pacsé(e)' }
                    ];
                    break;

                // Célibataire,...
                case 'CEL':
                case 'DIV':
                case 'VEU':
                case 'ISO':
                case 'ABA':
                    vm.isSituationConnueCouple = false;
                    vm.listeSitfam = [
                        { code: 'MAR', libelle: 'Marié(e)' },
                        { code: 'PAC', libelle: 'Pacsé(e)' },
                        { code: 'VIM', libelle: 'En union libre' }
                    ];
                    break;
                case 'SEL':
                case 'SEF':
                    vm.isSituationConnueCouple = false;
                    vm.listeSitfam = [
                        { code: 'DIV', libelle: 'Divorcé(e)' },
                        { code: 'RVM', libelle: 'Reprise de vie maritale' },
                        { code: 'VIM', libelle: 'En union libre' }
                    ];
                    break;
                default:
                    break;
            }
            vm.dateMinimum = vm.controle.dateSitfamConnue;
            var dateMoins2Ans = CnafCctDateService.getDateMoinsNmois(vm.today, 24);
            // Dans le cas d'une sitfam isolée la date saisie doit être postérieure à la plus récente des dates entre date sitfam connue et date du jour moins 2 ans
            if (!vm.isSituationConnueCouple && dateMoins2Ans > vm.controle.dateSitfamConnue) {
                vm.dateMinimum = dateMoins2Ans;
            }
        };


        // foonction appelé lors du clique sur l'un des boutons radio
        // Vérifie le role et la situation à déclarer 
        vm.controleChoixSitFam = function(data) {
            const listeSitfamCouple = ['MAR', 'PAC', 'VIM'];

            // si le déclarant est un conjoint en couple, il ne peut pas déclarer un mariage ou pacse
            if ((listeSitfamCouple.indexOf(vm.controle.sitfamConnue) > -1)
               && vm.role === 'conjoint'
               && (listeSitfamCouple.indexOf(data)  > -1)
               ){
                //réinitialiser choixSitfam
               vm.data.choixSitfam = undefined;
                //ouvrir une popup
                vm.openModalsitFamCouple();
            }    
        }



        /* ------------------------------ */
        /*   modal sitFamPourCouple       */
        /* ------------------------------ */
        vm.openModalsitFamCouple = function() {
            $(':focus').blur();

            //Instanciation et ouverture de la modale
            var modalAbandon = $uibModal.open({
                component: 'cnafModalSitFamCouple',
                backdrop: 'static',
                keyboard: false
            });

            //Fonction appelée lors de la fermeture de la modal
            modalAbandon.result.then(
                function() {
                    $(':focus').blur();
                },
                function() {
                    // Cancel
                }
            );
        };


        //Contrôle si la date de début d'activité est postérieure à la date connue de situaton
        vm.controleInfDateSitfamConnue = function(date, dateMinimum) {
            var valueControle = true;
            if (date && date.length >= 10) {
                //console.log("controleInfDateSitfamConnue avec date = "+date+" dateConnue = "+dateConnue);
                var dateATester = Date.parseExact(date, 'd/M/yyyy');

                if (dateATester && 'Invalid Date' != dateATester) {
                    if (dateATester <= dateMinimum) {
                        valueControle = false;
                    }
                }
            }
            return valueControle;
        };

        vm.controleDateSitfam = CnafCctDateService.controleDateJour;

    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctSitfam
     *
     * @description
     * cnafCctSitfam affiche les champs de saisie pour une situation familiale
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} sitfamform formulaire
     * @param {Object} errorsitfam erreurs
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */
    angular.module('cnafComponentsTeleprocApp').component('cnafCctSitfam', {
        templateUrl: 'components/cnaf-cct-sitfam/cnaf-cct-sitfam.component.html',
        bindings: {
            data: '=',
            sitfamform: '=',
            errorsitfam: '=',
            today: '=',
            controle: '='
        },
        controllerAs: 'vm',
        controller: CnafCctSitfamController
    });
})();

(function() {
    'use strict';

    CnafCctSitfamIsolementController.$inject = ['$scope'];

    function CnafCctSitfamIsolementController($scope) {
        var vm = this;
        vm.listeTypeIsolement  = [
            { code: 'CEL', libelle: 'Célibataire'},
            { code: 'DIV', libelle: 'Divorcé(e)'},
            { code: 'ISO', libelle: 'Séparé(e) après vie commune ou PACS'},
            { code: 'SEF', libelle: 'Séparé(e) de fait'},
            { code: 'SEL', libelle: 'Séparé(e) légalement'},
            { code: 'VEU', libelle: 'Veuf(ve)'}
        ];
    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctSitfamIsolement
     *
     * @description
     * cnafCctSitfamIsolement affiche les champs de saisie pour une situation familiale d'isolé
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} sitfamisolementform formulaire
     * @param {Object} errorsitfamisolement erreurs
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */
    angular.module('cnafComponentsTeleprocApp').component('cnafCctSitfamIsolement', {
        templateUrl: 'components/cnaf-cct-sitfam-isolement/cnaf-cct-sitfam-isolement.component.html',
        bindings: {
            data: '=',
            sitfamisolementform: "=",
            controle: "=",
            errorsitfamisolement: "="
        },
        controllerAs: 'vm',
        controller: CnafCctSitfamIsolementController
    });
})();

(function() {
    'use strict';

    CnafCctSitfamSituationcoupleController.$inject = ['$scope'];

    function CnafCctSitfamSituationcoupleController($scope) {
        var vm = this;
        vm.listeSituationsCouple  = [
            { code: 'MAR', libelle: 'Marié(e)'},
            { code: 'PAC', libelle: 'Pacsé(e)'},
            { code: 'VIM', libelle: 'En union libre'}
        ];
    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctSitfamSituationcouple
     *
     * @description
     * cnafCctSitfamSituationcouple affiche les champs de saisie pour une situation familiale de couple
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} sitfamsituationcoupleform formulaire
     * @param {Object} errorsitfamsituationcouple erreurs
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSitfamSituationcouple', {
        templateUrl: 'components/cnaf-cct-sitfam-situationcouple/cnaf-cct-sitfam-situationcouple.component.html',
        bindings: {
            data: '=',
            sitfamsituationcoupleform: "=",
            controle: "=",
            errorsitfamsituationcouple: "="
        },
        controllerAs: 'vm',
        controller: CnafCctSitfamSituationcoupleController
    });
})();

(function() {
    'use strict';

    CnafCctSitproTauxActiviteController.$inject = ['$scope','CnafCctDateService'];

    function CnafCctSitproTauxActiviteController($scope,CnafCctDateService) {
        var vm = this;
        //$scope.percentageRegex = /(^100(\.0{1,2})?$)|(^([1-9]([0-9])?|0)(\.[0-9]{1,2})?$)/;

        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */

        vm.init = function() {
           console.log("vm.dataCCT",vm.data);
           console.log("vm.controleCCT",vm.controle);
           vm.data.tauxActivite = "";
           vm.data.dateChgmtTauxAct= "";
           vm.dateSitProMin = "";
           vm.data.sitPros = {
               0: {}
           };
           vm.data.sitPros[0].choixActivite = vm.controle.personneEnCoursCodeAct;

           if(vm.controle && vm.controle.personneEnCours && vm.controle.personneEnCours.situationProfessionnelle){
               vm.sitProActuelle = vm.controle.personneEnCours.situationProfessionnelle;
               vm.dateSitProMin = Date.parseExact(vm.sitProActuelle.dateDebutSituationProfessionnnelle, 'yyyyMMdd');
           }       
        }

         /**
          * Contrôle si la date de début d'activité est postérieure à la date connue de situaton pro
          * */
        vm.controleInfDateProConnue = function(date) {
            var valueControle = true;
            if (date && date.length >= 10) {
                var dateATester = Date.parseExact(date, 'd/M/yyyy');

                if (dateATester && 'Invalid Date' != dateATester && vm.dateSitProMin && 'Invalid Date' != vm.dateSitProMin) {
                    if (dateATester <= vm.dateSitProMin ) {
                        valueControle = false;
                    }
                }
            }
            return valueControle;      
        };
        
        vm.controleDateChgmtTauxAct = CnafCctDateService.controleDateJour;
    }

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSitproTauxActivite', {
        templateUrl: 'components/cnaf-cct-sitpro-taux-activite/cnaf-cct-sitpro-taux-activite.html',
        bindings: {
            data: '=',
            tauxactiviteform: "=",
            errorctauxactivite: "=",
            controle: '=',
            today: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafCctSitproTauxActiviteController
    });
})();
(function () {
    'use strict';

    CnafCctTelcourrielController.$inject = ['CnafCctGestionTypeService', 'CnafCctConstantMsgTypes'];

    function CnafCctTelcourrielController(CnafCctGestionTypeService, CnafCctConstantMsgTypes) {
        var vm = this;

        //Contrôle Téléphone
        vm.testType2 = function (donnee, form, nomDonnee) {
            if (donnee === undefined || donnee.length === 0) {
                form.$setValidity('type2', true);
            }
            else {
                // On remet le formulaire sans erreur
                form.$setValidity('zeroSixSept', true);
                form.$setValidity('invalide', true);
                var retourControles = CnafCctGestionTypeService.appelControleType2(donnee, form);
                if (retourControles !== null) {
                    vm.data[nomDonnee] = retourControles;
                }
            }
        };
    }

    angular.module('cnafComponentsTeleprocApp').component('cnafCctTelcourriel', {
        templateUrl: 'components/cnaf-cct-telcourriel/cnaf-cct-telcourriel.html',
        bindings: {
            data: '=',
            telcourrielform: "=",
            controle: "=",
            errortelcourriel: "="
        },
        controllerAs: 'vm',
        controller: CnafCctTelcourrielController
    });

})();

(function () {
    'use strict';

    CnafCctTelcourrielCoupleController.$inject = ['CnafCctGestionTypeService', 'CnafCctConstantMsgTypes'];

    function CnafCctTelcourrielCoupleController(CnafCctGestionTypeService, CnafCctConstantMsgTypes) {
        var vm = this;

        //Contrôle Téléphone
        vm.testType2 = function (donnee, form, nomDonnee) {
            if (donnee === undefined || donnee.length === 0) {
                form.$setValidity('type2', true);
            }
            else {
                // On remet le formulaire sans erreur
                form.$setValidity('zeroSixSept', true);
                form.$setValidity('invalide', true);
                var retourControles = CnafCctGestionTypeService.appelControleType2(donnee, form);
                if (retourControles !== null) {
                    vm.data[nomDonnee] = retourControles;
                }
            }
        };
    }

    angular.module('cnafComponentsTeleprocApp').component('cnafCctTelcourrielCouple', {
        templateUrl: 'components/cnaf-cct-telcourriel-couple/cnaf-cct-telcourriel-couple.html',
        bindings: {
            data: '=',
            telcourrielform: "=",
            controle: "=",
            errortelcourriel: "="
        },
        controllerAs: 'vm',
        controller: CnafCctTelcourrielCoupleController
    });

})();

(function () {
    'use strict';

    CnafCctTelephonesController.$inject = ['CnafCctGestionTypeService', 'CnafCctConstantMsgTypes'];

    function CnafCctTelephonesController(CnafCctGestionTypeService, CnafCctConstantMsgTypes) {
        var vm = this;

        //Contrôle Téléphone
        vm.testType2 = function (donnee, form, nomDonnee) {
            if (!donnee) {
                form.$setValidity('type2', true);
            }
            else {
                var retourControles = CnafCctGestionTypeService.appelControleType2(donnee, form);
                if (retourControles !== null) {
                    vm.data[nomDonnee] = retourControles;
                }
            }
        };

        vm.controleTelephones = function (tel1, tel2, form) {
            form.$setValidity('zeroSixSept', true); 
            form.$setValidity('doublons', true);           
            if (form.$valid && tel1 && tel1.length > 0 && !vm.isTelPortable(tel1))
            {
                form.$setValidity('zeroSixSept', false); 
            }                       

        };

        vm.controleTelephoneFixe = function (tel2, form) { 
            form.$setValidity('fixe', true);           
            if (form.$valid && tel2 && tel2.length > 0 && (vm.isTelPortable(tel2) || tel2.startsWith('08')))
            {
                form.$setValidity('fixe', false); 
            }                        
        };        

        vm.isTelPortable = function(telephone) {
            return (telephone != null && 
                (telephone.startsWith('06') || telephone.startsWith('07')));
        };

        // Suite au controle effectué lors de la saisie du bouton validé on laisse les champs et le message en rouge
        // ng-blur="vm.testType2(vm.data.telephone1,vm.telephonesform.telephone1,'telephone1');
        // vm.controleTelephones(vm.data.telephone1,vm.data.telephone2,vm.telephonesform.telephone1);vm.reInitPortableObligatoire(vm.data.telephone1);"
        // vm.reInitPortableObligatoire = function (tel) {
        //     if ( vm.errortelephones && tel && tel.length > 0 && tel.substring(0, 2) === "06" || tel.substring(0, 2) === "07")  {
        //         // si un numéro de portable est renseigné alors on désactive le champs en rouge et le message portable obligatoire
        //          vm.errortelephones = false;
        //     }
        // };
    }

    angular.module('cnafComponentsTeleprocApp').component('cnafCctTelephones', {
        templateUrl: 'components/cnaf-cct-telephones/cnaf-cct-telephones.html',
        bindings: {
            data: '=',
            telephonesform: "=",
            errortelephones: "="
        },
        controllerAs: 'vm',
        controller: CnafCctTelephonesController
    });

})();

(function () {
    'use strict';

    CnafCctTelephoneSeulController.$inject = ['CnafCctGestionTypeService', 'CnafCctConstantMsgTypes'];

    function CnafCctTelephoneSeulController(CnafCctGestionTypeService, CnafCctConstantMsgTypes) {
        var vm = this;

        //Contrôle Téléphone
        vm.testType2 = function (donnee, form, nomDonnee) {
            if (!donnee) {
                form.$setValidity('type2', true);
            }
            else {
              // On remet le formulaire sans erreur
              form.$setValidity('zeroSixSept', true);
              form.$setValidity('invalide', true);
                var retourControles = CnafCctGestionTypeService.appelControleType2(donnee, form);
                if (retourControles !== null) {
                    vm.data[nomDonnee] = retourControles;
                }
            }
        };

    }

    angular.module('cnafComponentsTeleprocApp').component('cnafCctTelephoneSeul', {
        templateUrl: 'components/cnaf-cct-telephoneseul/cnaf-cct-telephoneseul.html',
        bindings: {
            data: '=',
            telephoneseulform: "=",
            errortelephoneseul: "="
        },
        controllerAs: 'vm',
        controller: CnafCctTelephoneSeulController
    });

})();

(function() {
    'use strict';
  
    var app = angular.module('cnafComponentsTeleprocApp');

    app.service('CnafCctFormFocusToFirstInvalidService', CnafCctFormFocusToFirstInvalidService);
    CnafCctFormFocusToFirstInvalidService.$inject = ['$timeout'];
    function CnafCctFormFocusToFirstInvalidService($timeout) {


      /**
         * Permet de mettre le focus sur le premier input invalid du form
         * @param form: formualire
         * @param offsetscrollY: number - Permet un décalage lors du scroll, par exemple quand il y a la barre d'étape
         * @param element: ElementRef
         */
        this.focusToFirstElementInvalid = function(form, offsetscrollY, element) {
          $timeout(function () {
            if ((form && !form.valid)) {
              offsetscrollY = offsetscrollY ? offsetscrollY : 0;
              var formInvalid = angular.element(
                document.querySelector('input.ng-invalid, select.ng-invalid, textarea.ng-invalid, button.ng-invalid'));

              if (formInvalid) {

                return focusToElement(formInvalid, offsetscrollY);
              } else {
                // The first element is the global form and here we are looking for the first nested form
                var formGroupInvalid = angular.element(
                  document.querySelectorAll('form.ng-invalid'));

                if (formGroupInvalid && formGroupInvalid.length) {
                  return focusToElement(formGroupInvalid[0], offsetscrollY);
                }
              }

              return focusToElement(element, offsetscrollY);
            }
          });
        };

        /**
         * Place le focus sur l'élement HTML placé en paramètre
         * @param element HTMLElement
         * @param offsetscrollY number
         */
        function focusToElement(element, offsetscrollY) {
          if (element[0]) {
            var distance = window.pageYOffset - Math.abs(element[0].getBoundingClientRect().top);

            window.scroll({
              behavior: 'smooth',
              left: 0,
              top: element[0].getBoundingClientRect().top - offsetscrollY + window.scrollY - 150
            });

            $timeout(function () {
              element[0].focus();
              element[0].blur(); // Trigger error messages
              element[0].focus();
            }, distance);
          }
        };
    }

    app.directive('cnafCctFormFocusToFirstInvalid', CnafCctFormFocusToFirstInvalidDirective);

    CnafCctFormFocusToFirstInvalidDirective.$inject = ['CnafCctFormFocusToFirstInvalidService'];
    function CnafCctFormFocusToFirstInvalidDirective(CnafCctFormFocusToFirstInvalidService) {
      
      var directive = {
        restrict: 'A',
        scope: {
          offsetscrollY: "@offsetscrollY",
          form: "=form"
        },
        link: linkFunc
      };
      return directive;

      function linkFunc(scope, element, attrs) {
        element.on('submit', {
            scope: scope,
            element: element,
            attrs: attrs
        }, submit);

        function submit(event){
          event.preventDefault();
          CnafCctFormFocusToFirstInvalidService.focusToFirstElementInvalid(scope.form, scope.offsetscrollY, element);
        }

        
      }
  
    }


    
  })();

  
(function() {
    'use strict';
    angular
        .module('cnafComponentsTeleprocApp')
        .component('cnafModalSitFamCouple', {
            templateUrl: 'directives/cnaf-cct-modal-sitFamCouple/cnaf-cct-modal-sitFamCouple-web.html',
            bindToController: true,
            controllerAs: 'vm',
            controller: CnafModalSitFamCoupleController,
            bindings: {
                dismiss: '&'
            }
        });

    CnafModalSitFamCoupleController.$inject = [];


    function CnafModalSitFamCoupleController() {
        var vm = this;
        //Fermeture de la modal
        vm.cancel = function() {
            vm.dismiss();
        };
    }

})();

(function() {
  'use strict';
  angular.module('cnafComponentsTeleprocApp').directive('cnafCctModalTeleproDebut', CnafCctModalTeleproDebutDirective);
  CnafCctModalTeleproDebutDirective.$inject = ['$uibModal', '$document'];
  function CnafCctModalTeleproDebutDirective($uibModal, $document) {
	  var directive = {
	      restrict: 'A',
        link: linkFunc
	    };
	    return directive;

      function linkFunc(scope, element, attrs) {

        element.on('click', {
            scope: scope,
            element: element,
            attrs: attrs
        }, click);

        function click(event){
          event.preventDefault();
            $uibModal.open({
              animation: true,
              ariaLabelledBy: 'modal-title-telepro-debut',
              ariaDescribedBy: 'modal-body-telepro-debut',
              templateUrl: 'directives/cnaf-cct-modal-telepro-debut/cnaf-cct-modal-telepro-debut.html',
              backdrop: 'static',
              controller: 'CnafCctModalTeleproDebutController',
              controllerAs: 'modalTeleproDebutVm',
              appendTo: angular.element($document[0].querySelector('body')),
              resolve: {
                  paramsModal: [function() {
                      return {
                          dataModal: event.data.attrs
                      };
                  }]
              }
            });
          }
      }
  }

  angular.module('cnafComponentsTeleprocApp').controller('CnafCctModalTeleproDebutController', CnafCctModalTeleproDebutController);
  CnafCctModalTeleproDebutController.$inject = ['$uibModalInstance', 'paramsModal','CnafTokenService','CnafUserService', 'CnafCctCoordContactNSIService'];
  function CnafCctModalTeleproDebutController($uibModalInstance, paramsModal, CnafTokenService, CnafUserService, CnafCctCoordContactNSIService) {
    var vm = this;
    // SLT le 26/11/2021 - Suite pb faille SSO appel de gestionCoordcontactMiddle pour transmettre les infos du caf.fr au connect.caf.fr car
    // pas de matricule au niveau du connect donc impossible de supprimer le cache (changement de jeton sur connect.caf.fr)
    var isAllocAFC = false;
    var isAllocNeoPrimo = false;
    vm.dataModal = paramsModal.dataModal;
    if (vm.dataModal.cas == 'contact') {
      var token = CnafUserService.tokenJWT;
      var decodedToken = CnafTokenService.decodeToken(token);
      if (decodedToken) {
        var codeOrga = decodedToken.codeOrga;
        var matricule = decodedToken.matricule;
        var jti = decodedToken.jti;
        isAllocAFC = CnafUserService.isInGroup(CnafUserService.GROUP_ALLOCATAIRES_ENCOURS_AFFILIATION);
        isAllocNeoPrimo = CnafUserService.isInGroup(CnafUserService.GROUP_ALLOCATAIRES_NEO_PRIMO);
        var infoCache = {};
        infoCache.codeOrga = codeOrga;
        infoCache.matricule = matricule;
        infoCache.afc = isAllocAFC;
        infoCache.neoPrimo = isAllocNeoPrimo;
        CnafCctCoordContactNSIService.setInfoCacheCoherence().update(infoCache);
      }
    }

    vm.fermer = function() {
      $uibModalInstance.close(false);
    };
  }

})();

(function() {
  'use strict';
  angular.module('cnafComponentsTeleprocApp').directive('cnafCctModalTeleproFin', CnafCctModalTeleproFinDirective);
  CnafCctModalTeleproFinDirective.$inject = ['$uibModal', '$document'];
  function CnafCctModalTeleproFinDirective($uibModal, $document) {
	  var directive = {
	      restrict: 'A',
        link: linkFunc
	    };
	    return directive;

      function linkFunc(scope, element, attrs) {

        element.on('click', {
            scope: scope,
            element: element,
            attrs: attrs
        }, click);

        function click(event){
          event.preventDefault();
            $uibModal.open({
              animation: true,
              ariaLabelledBy: 'modal-title-telepro-fin',
              ariaDescribedBy: 'modal-body-telepro-fin',
              templateUrl: 'directives/cnaf-cct-modal-telepro-fin/cnaf-cct-modal-telepro-fin.html',
              backdrop: 'static',
              controller: 'CnafCctModalTeleproFinController',
              controllerAs: 'modalTeleproFinVm',
              appendTo: angular.element($document[0].querySelector('body')),
              resolve: {
                  paramsModal: [function() {
                      return {
                          dataModal: event.data.attrs
                      };
                  }]
              }
            });
          }
      }
  }

  angular.module('cnafComponentsTeleprocApp').controller('CnafCctModalTeleproFinController', CnafCctModalTeleproFinController);
  CnafCctModalTeleproFinController.$inject = ['$uibModalInstance', 'paramsModal'];
  function CnafCctModalTeleproFinController($uibModalInstance, paramsModal) {
    var vm = this;
    vm.dataModal = paramsModal.dataModal;
    vm.fermer = function() {
      $uibModalInstance.close(false);
    };
  }

})();

(function () {
    'use strict';

    /**
     * Directive qui permet de modifier le model sans supprimer la valeur affichée d'un input
     * Utile sur le champ email2 qui sert à la confirmation de l'email
     * Désactive également le copier-coller
     */
    angular.module('cnafComponentsTeleprocApp').directive('resetOnClick', ResetOnClickDirective);
    ResetOnClickDirective.$inject = [];
    function ResetOnClickDirective() {
        var directive = {
            restrict: 'A',
            require: 'ngModel',
            link: linkFunc
        };
        return directive;

        function linkFunc(scope, element, attrs, ngModel) {
          //INC0399062 : Suppression du code car pb sous firefox lors de la
          // suppression du mail de confirmation
            /*element.bind('click', function () {
                debugger;
                var oldViewValue = ngModel.$viewValue;
                //Modification du model
                scope.$apply(ngModel.$modelValue = "");
                //Modification de la valeur affichée
                scope.$apply(function () {
                    try{
                        ngModel.$setViewValue(oldViewValue);
                    } finally
                    {
                        ngModel.$render();
                    }
                });
            });*/

            //Désactivation du copier-coller
            element.on('cut copy paste', function (event) {
                event.preventDefault();
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('cnafComponentsTeleprocApp')
        .service('CnafCctAdresseSocleService', CnafCctAdresseSocleService);

    CnafCctAdresseSocleService.$inject = ['CNAFCOMMONSAPP_CONFIG', '$resource'];

    function CnafCctAdresseSocleService(CNAFCOMMONSAPP_CONFIG, $resource) {
        var resourceActions = angular.extend({}, CNAFCOMMONSAPP_CONFIG.resourceActions);
        var localitesUrl = "/api/amabisfront/v1/localites";
        var localitesSansLDUrl = "/api/amabisfront/v1/localites_sansLD";
        var voieUrl = "/api/amabisfront/v1/voies";
        var adresseValidationUrl = "/api/amabisfront/v1/adresse_valide";
        var adressePropositionsUrl = "/api/amabisfront/v1/adresse_propositions";
        var rechListePaysUrl = "/api/cnafcompteleprocfront/v1/listepays";
        var rechListeDepartementsUrl = "/api/cnafcompteleprocfront/v1/departements";


        this.localites = function(codePostalVille, codePays) {
            return $resource(localitesUrl, {
                codePostalVille: codePostalVille,
                codePays: codePays
            }, resourceActions);
        };

        this.localitesSansLD = function(codePostalVille, codePays) {
            return $resource(localitesSansLDUrl, {
                codePostalVille: codePostalVille,
                codePays: codePays
            }, resourceActions);
        };

        this.voies = function(cleGeo, cleGeoAgg, libVoie) {
            return $resource(voieUrl, {
                cleGeo: cleGeo,
                cleGeoAgg: cleGeoAgg,
                libVoie: libVoie
            }, resourceActions);
        };

        this.adressePropositions = function(numTypeNomVoie, codePostalCommune, pays) {
            return $resource(adressePropositionsUrl, {
                numTypeNomVoie: numTypeNomVoie,
                codePostalCommune: codePostalCommune,
                pays: pays
            }, resourceActions);
        };

        this.adresseValidation = function(numTypeNomVoie, codePostalCommune, pays) {
            return $resource(adresseValidationUrl, {
                numTypeNomVoie: numTypeNomVoie,
                codePostalCommune: codePostalCommune,
                pays: pays
            }, resourceActions);
        };

        //Transformation du code pays pour AMABIS
        this.transformCodePays = function(code) {
            var transformCodePays = "";
            if (code === 'FR')
                transformCodePays = "FRA";
            else if (code === 'MC')
                transformCodePays = "MCO";
            return transformCodePays;
        };

        this.rechListePays = function() {
            return $resource(rechListePaysUrl, null, resourceActions);
            //return $http({
            //    method: "GET",
            //    url: '/api/cnafcompteleprocfront/v1/listepays'
            //});
            //MOCK JSON - Ne pas mettre en prod
            /*return $http({
                url: 'services/listepays.json',
            });*/
        };

        this.rechListeDepartements = function() {
            return $resource(rechListeDepartementsUrl, null, resourceActions);
        };

        this.getEtatAmabis = function() {
            var codePostalVille = "35000 Rennes";
            var numTypeNomVoie = "1 rue Nationale";
            //var paysCode = "FR";
            var payslibelleCaffr = "FRANCE";
            return this.adresseValidation(numTypeNomVoie, codePostalVille, payslibelleCaffr);
        };

        // Controle sur le format du code postal
        // Dans le cas d’une saisie libre, à la sortie du champ « Code postal / commune »,
        // on vérifie qu’au moins 5 chiffres consécutifs ont été saisis et que
        // les 2 premiers chiffres sont compris entre 01 et 98.
        // Si ce n’est pas le cas, on affiche le message « Code postal incorrect ».
        this.controleCodePostalFormat = function (codePostalCommune) {
          var valueControle = true;
          if (codePostalCommune !== undefined && codePostalCommune !== '') {
            valueControle = false;
            if (codePostalCommune.length >= 5){
              var cp = codePostalCommune.substring(0, 5);
              if (parseInt(cp) && cp >= 1 && cp <= 98999) {
                valueControle = true;
              }
            }
          }
          return valueControle;
        };
    }
})();

(function () {
  'use strict';

  angular
    .module('cnafComponentsTeleprocApp')
    .service('CnafCctControleAccesService', CnafCctControleAccesService);
  /* Services */

  CnafCctControleAccesService.$inject = ['CnafTokenService', 'CnafUserService'];

  function CnafCctControleAccesService(CnafTokenService, CnafUserService) {
      
      /**
       * @ngdoc method
       * @name accesApplicationAutorise
       * @methodOf cnafComponentsTeleprocApp.service:CnafCctControleAccesService
       * @param {liste} listeRolesAutorises données de la page concernant les ressources des personnes éligibles
       * --> liste des valeurs possibles : responsableDossier, conjoint, enfantAutrePersonne et usagerPrimo
       * @param {boolean} bBloqueRadie données de la page concernant les ressources des personnes éligibles
       * @param {boolean} bBloqueTutelle données de la page concernant les ressources des personnes éligibles
       * @description
       * Fonction autorisant l'accès à l'application en fonction du rôle utilisé
       * + contrôle Dossier radié
       * + contrôle Dossier sous tutelle 4 ou 8
       */      
      this.accesApplicationAutorise = function (listeRolesAutorises, bBloqueRadie, bBloqueTutelle) {

        // Bloquer l'accès aux allocataires radiés ?
        var bAllocatairesRadies = (bBloqueRadie && CnafUserService.isInGroup(CnafUserService.GROUP_ALLOCATAIRES_RADIES));
        // Bloquer l'accès aux allocataires sous tutelles 4 ou 8  et tuteur physique en tutelle autres que 4?
        // SLT le 04/12/2023 - RFC0016801 - Ajout acces tuteur moral
        if(CnafUserService.isInGroup("tuteurphysique") || CnafUserService.isInGroup("tuteurmoral")){
        var bTutelle48OuTuteurSansTutelle4 = (bBloqueTutelle && CnafUserService.isInGroup("allocatairesautrestutelles")  );
      }else{
        var bTutelle48OuTuteurSansTutelle4 = (bBloqueTutelle && CnafUserService.isInGroup(CnafUserService.GROUP_ALLOCATAIRES_TUTELLE48)  );
      }
        var  bDroitAcces = false;
        var token = CnafUserService.tokenJWT;
        if ((!localStorage.getItem('modeDev')) || (localStorage.getItem('modeDev') == "false")) {
          if (!bAllocatairesRadies && !bTutelle48OuTuteurSansTutelle4 && token)
          {
            var decodedToken = CnafTokenService.decodeToken(token);

            if (decodedToken) {          
              for (var sRoleCherche in listeRolesAutorises) {
                if (!bDroitAcces)
                {
                  bDroitAcces = (decodedToken.roles[0] === listeRolesAutorises[sRoleCherche]);
                }                
              }
            }
          }
        }
        else {
          // Pas de contrôle si on est en mode 'Developpement'
          bDroitAcces = true;
        }
        
        return bDroitAcces;
      }

      /**
       * @ngdoc method
       * @name redirectVersMonCompte
       * @methodOf cnafComponentsTeleprocApp.service:CnafCctControleAccesService
       * @description
       * Fonction permettant de retourner vers monCompte si accès non autorisé       
       * */ 
      this.redirectVersMonCompte = function () {
        var sUrlMonCompte = '/redirect/s/Redirect?page=monCompte';
        
        if (this.isModeMobile())
        {
          sUrlMonCompte = '/redirect/s/Redirect?page=applimobileMonCompte';
        }

        window.location.assign(sUrlMonCompte);
      }

      this.isModeMobile = function () {
        var fromMobile = false;
        var requestOriginNode = document.getElementById('requestOrigin');
        if (requestOriginNode && requestOriginNode.value === "mob") {
            fromMobile = true;
        }  

        return fromMobile;
      }
    
  }
})();

(function() {
    'use strict';

    angular
        .module('cnafComponentsTeleprocApp')
        .service('CnafCctCoordContactNSIService', CnafCctCoordContactNSIService);

        CnafCctCoordContactNSIService.$inject = ['CNAFCOMMONSAPP_CONFIG', '$resource'];

    function CnafCctCoordContactNSIService(CNAFCOMMONSAPP_CONFIG, $resource) {
        var resourceActions = angular.extend({}, CNAFCOMMONSAPP_CONFIG.resourceActions);
        var urlEnregInfoCache = '/api/gestioncoordcontactmiddle/v1/enregistrer_info_cache_coherence';
        this.setInfoCacheCoherence = function() {
            return $resource(urlEnregInfoCache, {} , resourceActions);
        };
    }
})();

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name cnafComponentsTeleprocApp.service:CnafCctDateService
     *
     * @description
     * Service de manipulation de dates
     *
     */
    angular.module('cnafComponentsTeleprocApp').service('CnafCctDateService', CnafCctDateService);

    CnafCctDateService.$inject = ['CnafUserService'];

    function CnafCctDateService(CnafUserService) {
        /**
         * @ngdoc method
         * @name getLastDay
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctDateService
         * @param {date} date TODO
         * @return {Date} TODO
         * @description
         * Récupère le dernier jour du mois, prends le mois suivant et récupère le jour "0" qui
         * correspond au jour précédant le mois suivant, on est donc sur le dernier jour du mois
         */
        this.getLastDay = function (date) {
            if (date) {
                date = this.parseDate(date);
                if (date instanceof Date) {
                    date = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                    date.setDate(date.getDate() + 1);
                    return date.getUTCDate();
                }
            }
        };

        /**
         * @ngdoc method
         * @name getCurrentDay
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctDateService
         * @param {date} date TODO
         * @return {Date} TODO
         * @description
         * Récupère le jour actuel
         */
        this.getCurrentDay = function (date) {
            if (date) {
                date = new Date(this.parseDate(date));
                if (date instanceof Date) {
                    date.setDate(date.getDate() + 1);
                    return date.getUTCDate();
                }
            }
        };

        /**
         * @ngdoc method
         * @name getLitteralMonth
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctDateService
         * @param {date} date Date
         * @return {string} Libellé du mois
         * @description
         * Récupère le libellé du mois en français
         */
        this.getLitteralMonth = function (date) {
            var litteralMonth;
            if (date) {
                var monthNames = [
                    'janvier',
                    'février',
                    'mars',
                    'avril',
                    'mai',
                    'juin',
                    'juillet',
                    'août',
                    'septembre',
                    'octobre',
                    'novembre',
                    'décembre'
                ];
                litteralMonth = monthNames[date.getMonth()];
            }
            return litteralMonth;
        };

        /**
         * @ngdoc method
         * @name ddmmyyyy
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctDateService
         * @param {date} date Date
         * @return {string} Date au format dd/jj/aaaa
         * @description
         * Permet de convertir une date de type Date au format dd/jj/aaaa
         */
        this.ddmmyyyy = function (date) {
            var mm = date.getMonth() + 1;
            var dd = date.getDate();
            dd = dd < 10 ? '0' + dd : dd;
            mm = mm < 10 ? '0' + mm : mm;
            return [dd, mm, date.getFullYear()].join('/');
        };

        this.yyyymmddsansslash = function (date) {
            var mm = date.getMonth() + 1;
            var dd = date.getDate();
            dd = dd < 10 ? '0' + dd : dd;
            mm = mm < 10 ? '0' + mm : mm;
            var aaaa = date.getFullYear();
            var dateconcat = aaaa + '' + mm + '' + dd;
            return dateconcat;
        };

        /**
         * @ngdoc method
         * @name parseDate
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctDateService
         * @param {String} dateString Date au format dd/jj/aaaa
         * @return {Date} Date de type Date
         * @description
         * Permet de convertir une date jj/mm/aaaa au format de type Date
         * @deprecated
         * a remplacer par la fonction Date.parseExact(date, "d/M/yyyy") de Datejs
         */
        this.parseDate = function (dateString) {
            //console.log("parseDate avec dateString = " + dateString);
            if (dateString && dateString.length >= 8) {
                var dateTime = dateString.split('/');
                if (dateTime.length === 3) {
                    var jour = dateTime[0];
                    var mois = dateTime[1];
                    var annee = dateTime[2];
                    var temp = mois + '/' + jour + '/' + annee;
                    return new Date(temp);
                }
            }
        };

        /**
         * @ngdoc method
         * @name getDateFormatCristalToFormatEcran
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctDateService
         * @param {String} dateString Date au format AAAAMMJJ
         * @return {String} Date au format JJ/MM/AAAA
         * @description
         * Permet de convertir une date jj/mm/aaaa au format de type Date
         */
        this.getDateFormatCristalToFormatEcran = function (dateString) {
            if (dateString && dateString.length === 8) {
                var annee = dateString.substring(0, 4);
                var mois = dateString.substring(4, 6);
                var jour = dateString.substring(6, 8);

                var temp = jour + '/' + mois + '/' + annee;
                return temp;
            }
        };

        // Créer une date au format string aaaammjj partir d'un string jj/mm/aaaa
        this.getDateFormatAAAAMMJJ = function (dateString) {
            if (dateString && dateString.length === 10) {
                var annee = dateString.substring(6, 10);
                var mois = dateString.substring(3, 5);
                var jour = dateString.substring(0, 2);

                var temp = annee + mois + jour;
                return temp;
            }
        }

        /**
         * @ngdoc method
         * @name getDatePlusNmois
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctDateService
         * @param {date} date date de départ
         * @param {int} nbMois nombre de mois à ajouter à la date de départ
         * @return {Date} date plus N mois (attention au cas du type "ajout d'un mois au 31/05/2017" -> renvoie "30/06/2017")
         * @description
         * Ajoute N mois à la date passée en parametre
         * @deprecated
         * a remplacer par la fonction date.addMonths(nbMois) de Datejs
         */
        this.getDatePlusNmois = function (date, nbMois) {
            if (date) {
                if (date instanceof Date) {
                    // calcul de la date en ajoutant N mois
                    var datePlusNMois = new Date(date.getFullYear(), date.getMonth() + nbMois, date.getDate());
                    // si le jour de la date calculé est différent de celui de la date en entrée de la fonction
                    // c'est que l'ajout de N mois ne donne pas à une date valide
                    if (datePlusNMois.getDate() != date.getDate()) {
                        // on génère une date au dernier jour du mois correspondant
                        datePlusNMois = new Date(date.getFullYear(), date.getMonth() + nbMois, 1);
                        // on recherche le dernier jour de ce mois
                        var jourMaxMoisRecherche = this.getLastDay(this.ddmmyyyy(datePlusNMois));
                        // on positionne la date en sortie sur ce dernier jour du mois
                        datePlusNMois.setDate(jourMaxMoisRecherche);
                    }
                    // sinon on positionne la date au jour de la date en entrée
                    else {
                        datePlusNMois.setDate(date.getDate());
                    }
                    return datePlusNMois;
                }
            }
        };

        /**
         * @ngdoc method
         * @name getDateMoinsNmois
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctDateService
         * @param {date} date date de départ
         * @param {int} nbMois nombre de mois à retirer à la date de départ
         * @return {Date} dateMoinsNmois date plus N mois (attention au cas du type "retrait d'un mois au 31/05/2017" -> renvoie "30/04/2017")
         * @description
         * Enleve N mois à la date passée en parametre
         * @deprecated
         * a remplacer par la fonction date.addMonths(-nbMois) de Datejs
         */
        this.getDateMoinsNmois = function (date, nbMois) {
            if (date) {
                if (date instanceof Date) {
                    // calcul de la date en enlevant N mois
                    var dateMoinsNMois = new Date(date.getFullYear(), date.getMonth() - nbMois, date.getDate());
                    // si le jour de la date calculé est différent de celui de la date en entrée de la fonction
                    // c'est que le retrait de N mois ne donne pas à une date valide
                    if (dateMoinsNMois.getDate() != date.getDate()) {
                        // on génère une date au dernier jour du mois correspondant
                        dateMoinsNMois = new Date(date.getFullYear(), date.getMonth() - nbMois, 1);
                        // on recherche le dernier jour de ce mois
                        var jourMaxMoisRecherche = this.getLastDay(this.ddmmyyyy(dateMoinsNMois));
                        // on positionne la date en sortie sur ce dernier jour du mois
                        dateMoinsNMois.setDate(jourMaxMoisRecherche);
                    }
                    // sinon on positionne la date au jour de la date en entrée
                    else {
                        dateMoinsNMois.setDate(date.getDate());
                    }
                    return dateMoinsNMois;
                }
            }
        };

        /**
         * @ngdoc method
         * @name getDateMoinsNAnnees
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctDateService
         * @param {date} date date de départ
         * @param {int} nbMois nombre d'années à retirer à la date de départ
         * @return {Date} date moins N années
         * @description
         * Enleve N année à la date passée en parametre
         * @deprecated
         * a remplacer par la fonction date.addYears(-nbAnnee) de Datejs
         */
        this.getDateMoinsNAnnees = function (date, nbAnnee) {
            if (date) {
                if (date instanceof Date) {
                    date = new Date(date.getFullYear() - nbAnnee, date.getMonth(), date.getDate());
                    date.setDate(date.getDate());
                    //console.log("getDateMoinsNAnnees avec date = " + date);
                    return date;
                }
            }
        };

        /**
         * @ngdoc method
         * @name getMoisOuvertureDroitAL
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctDateService
         * @param {date} dateLogement date d'entrée dans le logement
         * @param {date} today date du jour
         * @return {Date} date au 1er jour du mois d'ouverture de droit
         * @description
            * calcul du mois d'ouverture de droit (jour forcé à 01)

            *  Si le mois de la date d’entrée dans le logement est inférieur au mois de la date de référence
            *(date du jour ou date de 1ère manifestation)
            *alors le mois de l’ouverture de droit est le mois de la date de référence.
            *Ex : Entrée en Juin 2017 / Demande en Aout 2017 => OD = Aout 2017

            *Si le mois de la date d’entrée dans le logement est égal au mois de la date de référence
            *(date du jour ou date de 1ère manifestation)
            *alors le mois de l’ouverture de droit est le mois suivant le mois de la date de référence.
            *Ex : Entrée en Aout 2017 / Demande en Aout 2017 => OD = Septembre 2017

            *Si le mois de la date d’entrée dans le logement est supérieur au mois de la date de référence
            *(date du jour ou date de 1ère manifestation)
            *alors le mois de l’ouverture de droit est le mois suivant le mois de la date d’entrée dans les lieux.
            *Ex : Entrée en Septembre 2017 / Demande en Aout 2017 => OD = Octobre 2017
         */

        this.getMoisOuvertureDroitAL = function (dateLogement, today) {
            if (dateLogement) {
                if (dateLogement instanceof Date) {
                    //console.log("getMoisOuvertureDroitAL avec dateLogement = " + dateLogement+" / today = "+today);
                    var dateLogementATester = new Date(dateLogement);
                    var dateDemATester = new Date(today);
                    dateLogementATester.setDate(1);
                    dateDemATester.setDate(1);
                    var dateOd;
                    //Si le mois de la date d’entrée dans le logement est inférieur
                    //au mois de la date de la démarche
                    //alors le mois de l’ouverture de droit est
                    //      le mois de la date de la démarche.
                    if (dateLogementATester < dateDemATester) {
                        return dateDemATester;
                    }
                    //Si le mois de la date d’entrée dans le logement est égal
                    //au mois de la date de la démarche
                    //alors le mois de l’ouverture de droit est
                    //      le mois suivant le mois de la date de la démarche.
                    else if (dateLogementATester == dateDemATester) {
                        dateOd = new Date(dateDemATester);
                        //Si le mois de la date d’entrée dans le logement est supérieur
                        //au mois de la date de la démarche
                        //alors le mois de l’ouverture de droit est
                        //      le mois suivant le mois de la date d’entrée dans les lieux.
                    } else {
                        dateOd = new Date(dateLogementATester);
                    }
                    return dateOd.addMonths(1);
                }
            }
        };

        /**
         * @ngdoc method
         * @name controleDateJour
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctDateService
         * @param {string} date à comparer au format AAAA/MM/JJ
         * @param {Date} date de déclaration
         * @return {boolean} true si date <= date du jour, false sinon
         * @description
         * date à comparer doit être <= à la date de déclaration
         */
        this.controleDateJour = function (date, today) {
            var valueControle = true;
            if (date !== undefined && date.length >= 10) {
                var dateParse = Date.parseExact(date, 'd/M/yyyy');
                var dateToday = new Date(today);
                if (dateParse && 'Invalid Date' != dateParse) {
                    if (dateParse > dateToday) {
                        valueControle = false;
                    }
                }
            }
            return valueControle;
        };

        /**
         * @ngdoc method
         * @name isDateDifferente
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctDateService
         * @param {String} date1 date à comparer (format aaaa/mm/jj)
         * @param {Date} date2 date à comparer (format date)
         * @return {boolean} true si date1 != date2 false sinon
         * @description
         * date à comparer 1 doit être différente de la date à comparer 2
         */
        this.isDateDifferente = function (date1, date2) {
            var valueControle = true;
            if (date1 !== undefined && date1.length >= 10) {
                var dateParse = Date.parseExact(date1, 'd/M/yyyy');
                var date3 = new Date(date2);
                if (dateParse && 'Invalid Date' != dateParse) {
                    if (dateParse == date3) {
                        valueControle = false;
                    }
                }
            }
            return valueControle;
        };

        /**
         * @ngdoc method
         * @name isDateStrictementSuperieure
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctDateService
         * @param {String} date1 date à comparer (format JJ/MM/AAAA)
         * @param {String} date2 date à comparer (format JJ/MM/AAAA)
         * @return {boolean} true si date1 > date2 false sinon
         * @description
         * date à comparer 1 doit être différente de la date à comparer 2
         */
        this.isDateStrictementSuperieure = function (date1, date2) {
            var valueControle = true;
            if (date1 !== undefined && date1.length >= 10 && date2 !== undefined && date2.length >= 10) {
                var dateParse1 = Date.parseExact(date1, 'd/M/yyyy');
                var dateParse2 = Date.parseExact(date2, 'd/M/yyyy');
                if (dateParse1 && 'Invalid Date' != dateParse1) {
                    if (dateParse1 <= dateParse2) {
                        valueControle = false;
                    }
                }
            }
            return valueControle;
        };

        /**
         * @ngdoc method
         * @name isDateStrictementSuperieure
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctDateService
         * @param {String} date1 date à comparer (format JJ/MM/AAAA)
         * @param {String} date2 date à comparer (format JJ/MM/AAAA)
         * @return {boolean} true si date1 < date2 false sinon
         * @description
         * date à comparer 1 doit être différente de la date à comparer 2
         */
        this.isDateStrictementInferieure = function (date1, date2) {
            var valueControle = true;
            if (date1 !== undefined && date1.length >= 10 &&
                date2 !== undefined && date2.length >= 10) {
                var dateParse1 = Date.parseExact(date1, "d/M/yyyy");
                var dateParse2 = Date.parseExact(date2, "d/M/yyyy");
                if (dateParse1 && 'Invalid Date' != dateParse1) {
                    if (dateParse1 >= dateParse2) {
                        valueControle = false;
                    }
                }
            }
            return valueControle;
        };

        /**
         * @ngdoc method
         * @name isDatePlusNAnneeSupAXX
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctDateService
         * @param {date} date1 date à comparer (format date)
         * @param {String} date2 date à comparer (format JJ/MM/AAAA)
         * @param {String} nbAnnees nombre année à ajouter
         * @return {boolean} true si date1 > date2 false sinon
         * @description
         * date à comparer 1 doit être différente de la date à comparer 2
         */
        this.isDatePlusNAnneeSupAXX = function (date1, date2, nbAnnees) {
            if (date2 !== undefined) {
                var date2PlusNannees = Date.parseExact(date2, 'd/M/yyyy');
                date2PlusNannees.add({ years: nbAnnees });
                if (date1 > date2PlusNannees) {
                    return true;
                } else {
                    return false;
                }
            }
        };

        /**
         * @ngdoc method
         * @name isDatePlusNAnneeSupOuEgaleAXX
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctDateService
         * @param {date} date1 date à comparer (format date)
         * @param {String} date2 date à comparer (format JJ/MM/AAAA)
         * @param {String} nbAnnees nombre année à ajouter
         * @return {boolean} true si date1 >= date2 false sinon
         * @description
         * date à comparer 1 doit être différente de la date à comparer 2
         */
        this.isDatePlusNAnneeSupOuEgaleAXX = function (date1, date2, nbAnnees) {
            if (date2 !== undefined) {
                var date2PlusNannees = Date.parseExact(date2, 'd/M/yyyy');
                date2PlusNannees.add({ years: nbAnnees });
                if (date1 >= date2PlusNannees) {
                    return true;
                } else {
                    return false;
                }
            }
        };

        /**
         * @ngdoc method
         * @name getAgePartiel
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctDateService
         * @param {string} stringNaissance date au format jj/mm/aaaa
         * @param {int} calcul date au format jj/mm/aaaa
         * @return {int} age
         * @description
         * calcul l age de la personne en ne prenant en compte que le mois et l'année de naissance
         */
        this.getAgePartiel = function (stringNaissance, calcul) {
            var age;
            if (stringNaissance && calcul) {
                var dateNaissance = Date.parseExact(stringNaissance, 'd/M/yyyy');
                var dateCalcul = Date.parseExact(calcul, 'd/M/yyyy');
                if (dateNaissance && dateCalcul) {
                    var premierJourMoisNaissance = dateNaissance.moveToFirstDayOfMonth();
                    var ageDifMs = dateCalcul.getTime() - premierJourMoisNaissance.getTime();
                    var ageDate = new Date(ageDifMs); // miliseconds from epoch
                    age = Math.abs(ageDate.getUTCFullYear() - 1970);
                }
            }
            return age;
        };

        /**
         * @ngdoc method
         * @name getAge
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctDateService
         * @param {string} stringNaissance date au format jj/mm/aaaa
         * @param {int} calcul date au format jj/mm/aaaa
         * @return {int} age
         * @description
         * calcul l age de la personne en prenant en compte le jour le mois et l'année
         */
        this.getAge = function (stringNaissance, calcul) {
            var age;
            if (stringNaissance && calcul) {
                var dateNaissance = Date.parseExact(stringNaissance, 'd/M/yyyy');
                var dateCalcul = Date.parseExact(calcul, 'd/M/yyyy');
                if (dateNaissance && dateCalcul) {
                    var ageDifMs = dateCalcul.getTime() - dateNaissance.getTime();
                    var ageDate = new Date(ageDifMs); // miliseconds from epoch
                    age = Math.abs(ageDate.getUTCFullYear() - 1970);
                }
            }
            return age;
        };

        /**
         * @ngdoc method
         * @name getDatePlusNAnnees
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctDateService
         * @param {string} date date au format jj/mm/aaaa
         * @param {int} nbAnnees nombre d'années à ajouter à la date
         * @return {Date} date plus N années
         * @description
         * ajoute  N année à la date au format string passée en parametre
         */
        this.getDatePlusNAnnees = function (sDate, nbAnnee) {
            var dateCalculee;
            if (sDate) {
                var dateCalcul = Date.parseExact(sDate, 'd/M/yyyy');
                dateCalculee = dateCalcul.add({ years: nbAnnee });
            }
            return dateCalculee;
        };


        /**
         * @ngdoc method
         * @name isAgeSupAXX
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctDateService
         * @param {int} age age
         * @param {string} dateNaissance date au format jj/mm/aaaa
         * @param {string} dateDemarche date au format jj/mm/aaaa
         * @return {boolean} true si dateDemarche > dateNaissance + age false sinon
         * @description
         * Indique si age est bien strictement supérieur à dateDemarche - dateNaissance
         */
        this.isAgeSupAXX = function (age, dateNaissance, dateDemarche) {
            if (dateNaissance !== undefined) {
                var dateNaisPlusXX = Date.parseExact(dateNaissance, 'dd/MM/yyyy');
                dateNaisPlusXX.add({ years: age });
                return dateDemarche > dateNaisPlusXX;
            }
        };


        /**
         * @ngdoc method
         * @name getDateToday
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctDateService
         * @return {Date} date paramétrée dans l'environnement
         * @description
         * Permet de récupérer la date de l'environnement.
         */
        this.getDateToday = function () {
            var today;
            var dateEnv = CnafUserService.dateEnvCaffr();

            if (dateEnv !== "" && dateEnv.length === 8) {
                today = new Date(parseInt(dateEnv.substring(0, 4)), (parseInt(dateEnv.substring(4, 6)) - 1), parseInt(dateEnv.substring(6, 8)));
            } else {
                throw new Error('Une erreur est survenue : Problème avec dateEnvCaffr : ' + dateEnv);
            }

            return today;
        };

        // Créer une date à partir d'un string aaaammjj
        this.createDate = function (dateStr) {
            var date = new Date(dateStr.substring(0, 4), dateStr.substring(4, 6), dateStr.substring(6, 8));
            date.setMonth(date.getMonth() - 1);
            //console.log('createDate : '+date);
            return date;
        }
   }
})();

(function() {
    'use strict';

    /**
     * @ngdoc service
     * @name cnafComponentsTeleprocApp.service:CnafCctEligibilteRessourcesService
     *
     * @description
     * Service permettant de définir l'éligibilité aux ressources annuelles
     *
     */

    angular.module('cnafComponentsTeleprocApp').service('CnafCctEligibiliteRessourcesService', CnafCctEligibiliteRessourcesService);

    CnafCctEligibiliteRessourcesService.$inject = ['CNAFCOMMONSAPP_CONFIG', '$resource', 'CnafCctSaveRessourcesSessionService', 'CnafCctDateService'];    

    function CnafCctEligibiliteRessourcesService(CNAFCOMMONSAPP_CONFIG, $resource, CnafCctSaveRessourcesSessionService, CnafCctDateService) {
        var resourceActions = angular.extend({}, CNAFCOMMONSAPP_CONFIG.resourceActions);
        var eligibiliteRessourcesURL = '/api/ressourcesannuellesfront/v1/eligibiliteRessources';

        /**
         * @ngdoc method
         * @name remplitDonneesRessourcesEnSession
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctEligibiliteRessourcesService
         * @param {Object} data données de la page concernant les ressources des personnes éligibles
         * @description
         * Remplit en session les données pour le module Ressources par personne éligibile
         */
        this.remplitDonneesRessourcesEnSession = function(data) {
            var numPers = 0;

            var dateSitfam = CnafCctDateService.getDateFormatAAAAMMJJ(data.sitfam.data.dateSitfam);
            // Allocataire
            if (data.accesModuleRessourcesAlloc) {
              var alloc = data.listPersonneCle[numPers];
              this.sauvegardeBeanRessources(alloc, data.anneeMoins1Alloc, data.anneeMoins2Alloc, dateSitfam);
              numPers++;
            }

            // Conjoint
            if (data.accesModuleRessourcesCjt) {
              var cjt = data.listPersonneCle[numPers];
              this.sauvegardeBeanRessources(cjt, data.anneeMoins1Cjt, data.anneeMoins2Cjt, dateSitfam);
              numPers++;
            }

            // Enfants / Autres Personnes
            for (var n = 0; n < data.nbEnfAutModuleRessources; n++) {
                var unEligibiliteEnfAut = data.listEligibiliteEnfAut[n];

                var trouve = false;
                for (var j = 0; j < data.listPersonneCle.length && !trouve; j++) {
                    var unePersonneCleDTO = data.listPersonneCle[j];
                    // Vérification que la personne correspond bien !
                    if (
                        unePersonneCleDTO.nomFamille == unEligibiliteEnfAut.nom &&
                        unePersonneCleDTO.prenom == unEligibiliteEnfAut.prenom &&
                        unePersonneCleDTO.dateNaissance == unEligibiliteEnfAut.dateNaissance) {

                        trouve = true;

                        this.sauvegardeBeanRessources(unePersonneCleDTO, unEligibiliteEnfAut.anneeMoins1, unEligibiliteEnfAut.anneeMoins2, null);

                        numPers++;
                    }
                }
            }

            this.verificationAlerteRessourcesAlloc(data);
        };


        /**
         * @ngdoc method
         * @name verificationAlerteRessourcesAlloc
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctEligibiliteRessourcesService
         * @param {Object} data données de la page concernant les ressources des personnes éligibles
         * @description
         * Vérification qu'il faut ajouter l'année de ressources à déclarer de l'allocataire pour chaque personne éligible
         */
        this.verificationAlerteRessourcesAlloc = function(data) {
            var sAnneeMoins1Alloc = null;
            var sAnneeMoins2Alloc = null;
            var numConjoint = 0;

            // Recherche dun nficpn de l'allocataire :
            if (data.sitfam && data.sitfam.data && data.sitfam.data.resp)
            {
                var responsable = data.sitfam.data.resp;

                // Recherche des infos de l'allocataire dans la liste des ressources en session
                if (responsable.idPers)
                {
                    var rechIndexAlloc = CnafCctSaveRessourcesSessionService.getIndexFromListRessourcesSessionByIDPers(responsable.idPers);

                    // Récupération des années à déclarer pour l'allocataire :
                    if (rechIndexAlloc)
                    {
                        var enregAlloc = CnafCctSaveRessourcesSessionService.getEnregFromListRessourcesSessionByID(rechIndexAlloc);

                        sAnneeMoins1Alloc = enregAlloc.annees[0];  
                        sAnneeMoins2Alloc = enregAlloc.annees[1];                     
                    }
                }
            }

            // S'il y a au moins une année de ressources à déclarer pour l'allocataire :
            if (sAnneeMoins1Alloc || sAnneeMoins2Alloc)
            {
                // Conjoint
                if (data.accesModuleRessourcesCjt && !(data.anneeMoins1Cjt && data.anneeMoins2Cjt)) {
                    var conjoint = data.listPersonneCle[numConjoint];
                    this.miseAJourRessourcesPersonnesVsAlloc(conjoint.idPers, sAnneeMoins1Alloc, sAnneeMoins2Alloc);
                }


                // Enfants / Autres Personnes
                for (var n = 0; n < data.nbEnfAutModuleRessources; n++) {
                    var unEligibiliteEnfAut = data.listEligibiliteEnfAut[n];                
                    if (!(unEligibiliteEnfAut.anneeMoins1 && unEligibiliteEnfAut.anneeMoins2))
                    {
                        for (var j = 1; j < data.listPersonneCle.length; j++) {
                            var unePersonne = data.listPersonneCle[j];
                            this.miseAJourRessourcesPersonnesVsAlloc(unePersonne.idPers, sAnneeMoins1Alloc, sAnneeMoins2Alloc);
                        }
                    }
                }
              
            }
        };


        /**
         * @ngdoc method
         * @name miseAJourRessourcesPersonnesVsAlloc
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctEligibiliteRessourcesService
         * @param {String} idPers identifiant de la personne traitée
         * @param {String} anneeMoins1Alloc année N-1 des ressources à déclarer pour l'allocataire
         * @param {String} anneeMoins2Alloc année N-2 des ressources à déclarer pour l'allocataire
         * @description
         * Mise à jour de la date des ressources de l'allocataire dans celles des autres personnes éligibles
         */
        this.miseAJourRessourcesPersonnesVsAlloc = function(idPers, anneeMoins1Alloc, anneeMoins2Alloc) {
            var rechIndexPersonne = CnafCctSaveRessourcesSessionService.getIndexFromListRessourcesSessionByIDPers(idPers);
      
            if (rechIndexPersonne)
            {
                var enregPesonne = CnafCctSaveRessourcesSessionService.getEnregFromListRessourcesSessionByID(rechIndexPersonne);

                var nbAnneesPers = enregPesonne.annees.length;

                // Si les 2 années de ressources sont déjà renseignées pour la personne, ne rien faire !
                if (nbAnneesPers < 2)
                {

                    // Quelle année faut-il ajouter ?
                    var anneeAAjouterAlloc = anneeMoins1Alloc;
                    var intAnnee1 = parseInt(anneeMoins1Alloc);
                    var intAnnee2 = parseInt(anneeMoins2Alloc);                    
                    // On prend la plus grande des 2 années
                    if (intAnnee2 > intAnnee1)
                    {
                        anneeAAjouterAlloc = anneeMoins2Alloc;
                    }                

                    var intAnnee1Pers = parseInt(enregPesonne.annees[0]);
                    if (enregPesonne.annees[1])
                    {
                        intAnnee1Pers = parseInt(enregPesonne.annees[1]); 
                    }

                    var intAnneeAjout = parseInt(anneeAAjouterAlloc); 
                  
                    if (intAnnee1Pers < intAnneeAjout)
                    {
                        // Ajout de l'année demandée en plus pour l'allocataire
                        enregPesonne.annees[1] = anneeAAjouterAlloc;

                        // Actualisation de la liste des ressources en session :
                        CnafCctSaveRessourcesSessionService.modifEnregListRessources(rechIndexPersonne, enregPesonne);                        
                    }
 
                }
            }
        };


        /**
         * @ngdoc method
         * @name sauvegardeBeanRessources
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctEligibiliteRessourcesService
         * @param {Object} personne données concernant la personne à traiter
         * @param {String} anneeMoins1 année N moins 1 à traiter
         * @param {String} anneeMoins2 année N moins 2 à traiter
         * @param {String} dateSitfam date de début de situation familliale
         * @description
         * Sauvegarde du bean pour le module Ressources (déclaration dans CnafComponentsTeleproc)
         * "idPers": idPers,
         * "typePersonne": typePersonne,
         * "nom": nom,
         * "prenom": prenom,
         * "dateNaissance": dateNaissance,
         * "codeEtat": codeEtat,
         * "liqAuto": liqAuto,
         * "annees": listAnnees,
         * "dateSitfam": dateSitfam
         */
        this.sauvegardeBeanRessources = function(personne, anneeMoins1, anneeMoins2, dateSitfam) {
            var anneesATraiter = []

            if (anneeMoins1 && anneeMoins2)
            {
                // ordre des années du + au - vieux :
                anneesATraiter = [anneeMoins2, anneeMoins1]
            }
            else if (anneeMoins1)
            {
                anneesATraiter = [anneeMoins1]
            }
            else if (anneeMoins2)
            {
                anneesATraiter = [anneeMoins2]
            }


            CnafCctSaveRessourcesSessionService.addListRessources(
                personne.idPers,
                personne.typePersonne,
                personne.nomFamille,
                personne.prenom,
                personne.dateNaissance,
                personne.codeEtat,
                personne.liqAuto,
                anneesATraiter,
                dateSitfam
            );
        };

        /**
         * @ngdoc method
         * @name eligibiliteRessources
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctEligibiliteRessourcesService
         * @return {String}
         * @description
         * Retourne url d'appel au traitement d'éligibilité des ressources.
         */
        this.eligibiliteRessources = function() {
            return $resource(eligibiliteRessourcesURL, null, resourceActions);
        };
    }
})();

(function() {
    'use strict';

    angular.module('cnafComponentsTeleprocApp').service('CnafCctEnchainementsService', CnafCctEnchainementsService);

    CnafCctEnchainementsService.$inject = [];

    function CnafCctEnchainementsService() {

        // Listing des choix sélectionnés pour les passer en paramètres lors de l'appel à WTI
        this.ajoutParamsPrestaUrl = function(stringUrl, paramsUrl, bSortieConfirmationSitu, identFluxElecNDWEB)  {
            var sNewUrl = stringUrl;
            var sStringEvent = '';
            var sStringOrigine = '';
            var sStringPrestation = '';
            var sStringTypeActu = '';
            var sStringIdentRetour = '';
            var sStringContexteAiguillage = '';
            var sStringContexte = '';
            var sStringRedirectSortie = '';
            var sStringIdentNDWEB = '';
            var sStringClepieceRecall = '';
            var sStringNumInterneEnfant = '';

            if (paramsUrl) {

                // Param eventName
                if (paramsUrl.eventName) {
                    sStringEvent = 'eventName=' + paramsUrl.eventName;
                    sNewUrl += (sNewUrl.indexOf('?') === -1 ? '?' : '&') + sStringEvent;
                }

                // Param Origine Demande
                if (paramsUrl.origineDemande) {
                    sStringOrigine = 'origineDemande=' + paramsUrl.origineDemande;
                    sNewUrl += (sNewUrl.indexOf('?') === -1 ? '?' : '&') + sStringOrigine;
                }

                // Param code prestation
                if (paramsUrl.codePrestation) {
                    sStringPrestation = 'codePrestation=' + paramsUrl.codePrestation;
                    sNewUrl += (sNewUrl.indexOf('?') === -1 ? '?' : '&') + sStringPrestation;
                }

                // Param Type Actualisation
                if (paramsUrl.typeActualisation) {
                    sStringTypeActu = 'typeActualisation=' + paramsUrl.typeActualisation;
                    sNewUrl += (sNewUrl.indexOf('?') === -1 ? '?' : '&') + sStringTypeActu;
                }

                // Param Identifiant Retour
                if (paramsUrl.identifiantRetour) {
                    sStringIdentRetour = 'identifiantRetour=' + paramsUrl.identifiantRetour;
                    sNewUrl += (sNewUrl.indexOf('?') === -1 ? '?' : '&') + sStringIdentRetour;
                }
                // Param clepieceRecall potentiellement utilisé par les applications suivantes
                if (paramsUrl.clepieceRecall) {
                    sStringClepieceRecall = 'clepieceRecall=' + paramsUrl.clepieceRecall;
                    sNewUrl += (sNewUrl.indexOf('?') === -1 ? '?' : '&') + sStringClepieceRecall;
                }
                // Param numInterneEnfant potentiellement utilisé par les applications suivantes
                if (paramsUrl.numInterneEnfant) {
                    sStringNumInterneEnfant = 'numInterneEnfant=' + paramsUrl.numInterneEnfant;
                    sNewUrl += (sNewUrl.indexOf('?') === -1 ? '?' : '&') + sStringNumInterneEnfant;
                }
                // Param Contexte Aiguillage - DAL2019
                if (paramsUrl.contexteAiguillage) {
                    sStringContexteAiguillage = 'contexteAiguillage=' + paramsUrl.contexteAiguillage;
                    sNewUrl += (sNewUrl.indexOf('?') === -1 ? '?' : '&') + sStringContexteAiguillage;
                }
                // Param Contexte Aiguillage - DAL
                if (paramsUrl.contexte) {
                    sStringContexte = 'contexte=' + paramsUrl.contexte;
                    sNewUrl += (sNewUrl.indexOf('?') === -1 ? '?' : '&') + sStringContexte;
                }

                // Param Redirect Sortie - DAL2019
                if (paramsUrl.redirectSortie && !bSortieConfirmationSitu) {
                    sStringRedirectSortie = 'redirectSortie=' + paramsUrl.redirectSortie;
                    sNewUrl += (sNewUrl.indexOf('?') === -1 ? '?' : '&') + sStringRedirectSortie;
                }

                // Identifiant NDWEB
                if (identFluxElecNDWEB) {
                    sStringIdentNDWEB = 'identifiantDSIT=' + identFluxElecNDWEB;
                    sNewUrl += (sNewUrl.indexOf('?') === -1 ? '?' : '&') + sStringIdentNDWEB;
                }
            }

            return sNewUrl;
        };

        // Définition du prochain module à afficher dans l'enchainement en fonction de la liste de changements sélectionnés
        this.definirProchainURL = function(listChgt, isAccesModuleRessources) {
            var sUrlMonProfil = '/redirect/s/Redirect?page=monCompteMonProfil';
            var sUrlSitPro = "/redirect/s/Redirect?page=monCompteChangementSituationProfessionnelle";
            var sUrlSitEnf = "/redirect/s/Redirect?page=monCompteChangementSituationEnfants";
            var sUrlNais = "/redirect/s/Redirect?page=monCompteDeclarationNaissance";
            var sUrlGro   = "/redirect/s/Redirect?page=monCompteDeclarationGrossesse";
            var sUrlAdr = "/redirect/s/Redirect?page=monCompteChangementAdresse";
            var sUrlCC = "/redirect/s/Redirect?page=monCompteChangementCoordonneesContact";
            var sUrlCB = '/redirect/s/Redirect?page=monCompteChangementCoordonneesBancaires';
            var sUrlRessources = '/redirect/s/Redirect?page=monCompteDeclarationRessourcesAnnuelles';

            var sNewUrl = sUrlMonProfil;
            sNewUrl += (sNewUrl.indexOf('?') === -1 ? '?' : '&') + 'affichageProfil=true';

            if (isAccesModuleRessources) {
                sNewUrl = sUrlRessources;
            } else if (listChgt) {
                if (~listChgt.indexOf('sp')) {
                  sNewUrl = sUrlSitPro;
                } else if (~listChgt.indexOf('se')) {
                  sNewUrl = sUrlSitEnf;
                } else if (~listChgt.indexOf('nais')) {
                  sNewUrl = sUrlNais;
                } else if (~listChgt.indexOf('gro')) {
                    sNewUrl = sUrlGro;
                } else if (~listChgt.indexOf('adr')) {
                  sNewUrl = sUrlAdr;
                } else if (~listChgt.indexOf('cc')) {
                  sNewUrl = sUrlCC;
                } else if (~listChgt.indexOf('cb')) {
                  sNewUrl = sUrlCB;
                }
            }

            return sNewUrl;
        }

        // Définition de l'url complète afin d'accèder au prochain module.
        this.definirEnchainementURL = function(sChangementEnCours, paramsUrl, isAccesModuleRessources) {
            var sNewUrl = '';
            var sNewListChgt = '';
            var sUrlRessources = '/redirect/s/Redirect?page=monCompteDeclarationRessourcesAnnuelles';

            var requestOriginNode = document.getElementById('requestOrigin');
            if (requestOriginNode && requestOriginNode.value === "mob") {
                sUrlRessources = '/redirect/s/Redirect?page=applimobileMonCompteDeclarationRessourcesAnnuellesAcces';
            }

            if (paramsUrl) {

                // Révision de liste des changements à effectuer
                if (paramsUrl.listChgt) {
                    var sCodeChangement = sChangementEnCours.toLowerCase();
                    // Suppression de l'adresse dans la Liste
                    // car on vient de le faire
                    // Test pour savoir si dans la liste des changement il y a la chaine cc- ==> si test ok suppression de la chaine 'cc-'
                    if (~paramsUrl.listChgt.indexOf(sCodeChangement+'-')) {
                        sNewListChgt = paramsUrl.listChgt.replace(sCodeChangement+'-', '');
                    } else {
                        sNewListChgt = paramsUrl.listChgt.replace(sCodeChangement, '');
                    }
                }

                // Définition du prochain url avec la nouvelle liste des changements
                sNewUrl = this.definirProchainURL(sNewListChgt, isAccesModuleRessources);

                // Ajout des paramètres de prestation s'ils existent
                sNewUrl = this.ajoutParamsPrestaUrl(sNewUrl, paramsUrl, false);

                // Si présence d'autres changements :
                // ajout de la nouvelle liste de changements
                if (sNewListChgt) {
                    sNewUrl += '&listChgt=' + sNewListChgt;
                }
            } else if (isAccesModuleRessources) {
                sNewUrl = sUrlRessources;
            }

            return sNewUrl;
            
        };
    }
})();

(function() {
    'use strict';

    /**
  	 * @ngdoc service
  	 * @name cnafComponentsTeleprocApp.service:CnafCctErreurService
  	 *
  	 * @description
  	 * Service de controles si erreur sur le composant désigné par l'id renseigné
  	 *
  	 */

    angular
        .module('cnafComponentsTeleprocApp')
        .service('CnafCctErreurService', CnafCctErreurService);

    function CnafCctErreurService() {


         /**
     		 * @ngdoc method
     		 * @name checkErrorsHtmlById
     		 * @methodOf cnafComponentsTeleprocApp.service:CnafCctErreurService
     		 * @param {string} idComposant TODO
     		 * @return {boolean} TODO
     		 * @description
         * Retourne true s'il y a des erreurs sur le composant
         * ou toute partie de code désignée par l'id renseigné
         * Vérification sur la class ng-invalid
     		 */
        this.checkErrorsHtmlById = function (idComposant) {
            var htmlComposant = window.document.getElementById(idComposant);
            if(htmlComposant){
                var listErrors = htmlComposant.getElementsByClassName("ng-invalid");
                for(var i =0; i < htmlComposant.childElementCount; i++){
                    listErrors += htmlComposant.children[i].getElementsByClassName("ng-invalid");
                }
                return listErrors.length > 0 ? true : false;
            }
            // Affichage des formulaires parfois conditionnel donc pas dans le DOM
            // donc si pas pas affiché => pas d'erreurs a vérifier.
            return false;
        };

        // CONTROLES AVANCES
        /**
        * @ngdoc method
        * @name checkErrorsHtmlByIdAndForm
        * @methodOf cnafComponentsTeleprocApp.service:CnafCctErreurService
        * @param {string} idComposant TODO
        * @param {form} form TODO
        * @param {index} index index de la sit pro en cours de saisie
        * @return {boolean} TODO
        * @description
        * Retourne true s'il y a des erreurs sur le composant
        * ou toute partie de code désignée par l'id renseigné
        * Verifie si l'on a le champs dans la partie du html par rapport aux errors dans le form
        * Si oui return true et ne pas collapse sinon true: collapse
        */
         this.checkErrorsHtmlByIdAndForm = function (idComposant, form, index) {
            var isError = false;
            var htmlComposant = window.document.getElementById(idComposant);
            var tabErrors = [];

            if(form.$error){
                if(form.$error.invalide){
                    for(var i=0;i<form.$error.invalide.length;i++){
                        tabErrors.push(form.$error.invalide[i].$name);
                    }
                }
                if(form.$error.obligatoire){
                    for(var i=0;i<form.$error.obligatoire.length;i++){
                        tabErrors.push(form.$error.obligatoire[i].$name);
                    }
                }

                //Si un index est passé à l'appel de cette méthode...
                if (index >= 0 && form.$error.required)
                {
                    //On vérifie si l'une des données en erreur concerne ce bloc indexé (Ex : Sitpros Actuelle/Antérieure(s))
                    for(var x=0;x<form.$error.required.length;x++){
                        var name = form.$error.required[x].$name;
                        if (name[name.length-1] == index)
                        {
                            // si nom/donnée suffixée par l'index  => TRUE
                            return true;
                        }
                    }
                }
            }

            if(htmlComposant){
                var listErrors = htmlComposant.getElementsByClassName("ng-invalid");
                if(listErrors && listErrors.length > 0){
                    //Si liste erreurs significative => TRUE
                    return true;
                } else{
                    isError = false;
                }
                for(var i =0; i < tabErrors.length; i++){
                    for(var j =0; j < htmlComposant.childElementCount; j++){
                        // nodelist
                        var childElem = htmlComposant.children[j];
                        for(var k=0;k < childElem.querySelectorAll("input").length;k++){
                            if(childElem.querySelectorAll("input")[k].outerHTML.indexOf("ng-invalid") !== -1){
                                return true;
                            }
                        }
                        for(var k=0;k < childElem.querySelectorAll("button").length;k++){
                            if(childElem.querySelectorAll("button")[k].outerHTML.indexOf("ng-invalid") !== -1){
                                return true;
                            }
                        }
                    }
                    // si nom == formerror => TRUE
                }
                return isError;
            }
            // Affichage des formulaires parfois conditionnel donc pas dans le DOM
            // donc si pas pas affiché => pas d'erreurs a vérifier.
            return isError;
        };
    }
})();

(function() {
    'use strict';

    /**
     * @ngdoc service
     * @name cnafComponentsTeleprocApp.service:CnafCctGrcService
     *
     * @description
     * Service permettant d'envoyer une interaction pour la GRC
     *
     */

    angular.module('cnafComponentsTeleprocApp').service('CnafCctGrcService', CnafCctGrcService);

    CnafCctGrcService.$inject = ['CNAFCOMMONSAPP_CONFIG', '$resource'];
    // RFC0012385 - envoi interaction pour tracerune interaction dans GRC
    function CnafCctGrcService(CNAFCOMMONSAPP_CONFIG, $resource) {
        var resourceActions = angular.extend({}, CNAFCOMMONSAPP_CONFIG.resourceActions);
        var interactionGrcURL = '/api/cnafcompteleprocfront/v1/interaction_grc';

         /**
         * @ngdoc method
         * @name envoiInteractionGrc
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctGrcService
         * @return {String}
         * @description
         * Retourne url d'appel au permettant d'envoyer une interaction pour la GRC
         */
        this.envoiInteractionGrc = function(motif,statut) {
            return $resource(interactionGrcURL,{
                motif: motif,
                statut: statut
            }, resourceActions);
        };
    }
})();

(function() {
    'use strict';
    /**
     * @ngdoc service
     * @name cnafComponentsTeleprocApp.service:CnafCctControleNirService
     *
     * @description
     * Service de controle du nir
     *
     */
    angular.module('cnafComponentsTeleprocApp').service('CnafCctControleNirService', CnafCctControleNirService);

    CnafCctControleNirService.$inject = ['CnafCctConstantMsgNir', 'CnafCctNirService'];

    function CnafCctControleNirService(CnafCctConstantMsgNir, CnafCctNirService) {
        /**
         * @ngdoc method
         * @name isValidNirNumber15
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctControleNirService
         * @param {string} nir nir sur 15 caractères
         * @return {string} OK ou message d'erreur
         * @description
         * Retourne "OK" si nir (avec la clé) ne contient que des caractères autorisés
         * sinon retoune le message d'erreur "Le numéro saisi est invalide ou ne correspond pas à votre état civil."
         */
        this.isValidNirNumber15 = function(input) {
            //(cf. DEC_ECV_01 / Daf SITFAM et ENF_ECV_19 / Daf SITENF)
            var nir = String(input)
                    .toUpperCase()
                    .replace(/[^A-Z0-9]/g, ''), // garde les char alphanumérique
                code = nir.match(/^([0-9]{1})([0-9]{2})([0-9]{2})([A-Za-z0-9]{2})([0-9]{3})([0-9]{3})([0-9]{2})$/); // verifie les differents char

            // check syntax and length
            if (!code) {
                return CnafCctConstantMsgNir.NIR_KO;
            }
            return CnafCctConstantMsgNir.NIR_OK;
        };

        /**
         * @ngdoc method
         * @name isValidNirNumber13
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctControleNirService
         * @param {string} nir nir sur 13 caractères
         * @return {string} OK ou message d'erreur
         * @description
         * Retourne "OK" si nir (sans la clé) ne contient que des caractères autorisés
         * sinon retoune le message d'erreur "Le numéro saisi est invalide ou ne correspond pas à votre état civil."
         */
        this.isValidNirNumber13 = function(input) {
            //(cf. DEC_ECV_01 / Daf SITFAM et ENF_ECV_19 / Daf SITENF)
            var nir = String(input)
                    .toUpperCase()
                    .replace(/[^A-Z0-9]/g, ''), // garde les char alphanumérique
                code = nir.match(/^([0-9]{1})([0-9]{2})([0-9]{2})([A-Za-z0-9]{2})([0-9]{3})([0-9]{3})$/); // verifie les differents char
            // check syntax and length
            if (!code) {
                return CnafCctConstantMsgNir.NIR_KO;
            }
            return CnafCctConstantMsgNir.NIR_OK;
        };

        /**
         * @ngdoc method
         * @name isValidNirNumber10
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctControleNirService
         * @param {string} nir nir sur 10 caractères
         * @return {string} OK ou message d'erreur
         * @description
         * Retourne "OK" si nir (partiel) ne contient que des caractères autorisés
         * sinon retoune le message d'erreur "Le numéro saisi est invalide ou ne correspond pas à votre état civil."
         */
        this.isValidNirNumber10 = function(input) {
            //(cf. DEC_ECV_01 / Daf SITFAM et ENF_ECV_19 / Daf SITENF)
            var nir = String(input)
                    .toUpperCase()
                    .replace(/[^A-Z0-9]/g, ''), // garde les char alphanumérique
                code = nir.match(/^([0-9]{1})([0-9]{2})([0-9]{2})([A-Za-z0-9]{2})([0-9]{3})$/); // verifie les differents char
            // check syntax and length
            if (!code) {
                return CnafCctConstantMsgNir.NIR_KO;
            }
            return CnafCctConstantMsgNir.NIR_OK;
        };

        /**
         * @ngdoc method
         * @name genererNir
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctControleNirService
         * @param {string} sexe Masculin ou Fénimin
         * @param {date} dateNaisssance au format jj/mm/aaaa
         * @return {string} nir sur 5 caractères
         * @description
         * Génère les 5 premiers caractères du NIR (sexe,an,mois)
         */
        this.genererNir = function(sexe, dateNaissance) {
            //(cf. DEC_ECV_07 / Daf SITFAM)
            var nir = '';
            var date = Date.parseExact(dateNaissance, 'd/M/yyyy');
            var mm = date.getMonth() + 1;
            mm = mm.toString();
            if (mm.length === 1) {
                mm = '0' + mm;
            }
            var aa = date.getFullYear();
            aa = aa.toString().substr(-2);
            if (sexe === 'Masculin') {
                nir = '1';
            } else {
                nir = '2';
            }
            nir = nir + aa + mm;
            return nir;
        };

        /**
         * @ngdoc method
         * @name controlerElementsNir
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctControleNirService
         * @param viewModel binding scope 
         * @param {string} nir nir sur x caractères
         * @param {date} dateNaisssance au format jj/mm/aaaa
         * @return {string} OK ou message d'erreur
         * @description
         * Découpe le nir en différents éléments et vérifie la validité de ces éléments
         * Retourne "OK" si ces éléments sont valides
         * sinon retoune le message d'erreur "Le numéro saisi est invalide ou ne correspond pas à votre état civil."
         */
        this.controlerElementsNir = function(viewModel, nir, dateNaissance) {
            var ret = CnafCctConstantMsgNir.NIR_OK;
            viewModel.nirDecoupe = CnafCctNirService.decouperNir(nir);
            viewModel.nirSexe = viewModel.nirDecoupe.sexe;
            viewModel.nirAn = viewModel.nirDecoupe.an;
            viewModel.nirMois = viewModel.nirDecoupe.mois;
            viewModel.nirDepartement = viewModel.nirDecoupe.departement;
            viewModel.nirCommune = viewModel.nirDecoupe.commune;
            viewModel.nirRang = viewModel.nirDecoupe.rang;
            
            //Pour éviter l'affichage multiple de ce message, les cid suivants ne seront appelés que si pas d'erreur déjà détectée
            if (viewModel.nirAn != undefined) {
                ret = this.controlerDonneesSaufSexeDepartement(viewModel.nirAn, viewModel.nirMois, dateNaissance);
            }
            //Le code sexe et le 1er caractère du numéro de sécurité sociale doivent être cohérent,
            //sinon on affiche le message : « Votre saisie est incorrecte, merci de vérifier les données saisies ».
            //(Il n' y a plus d'affichage de la pop up)
            if (ret === CnafCctConstantMsgNir.NIR_OK) {
                ret = this.controleNirSexe(viewModel.data.sexe, viewModel.nirSexe);
            }
            if (ret === CnafCctConstantMsgNir.NIR_OK && viewModel.nirDepartement != undefined) {
                ret = this.controleNirDepartement2(viewModel.departement, viewModel.nirDepartement);
            }
            if (ret === CnafCctConstantMsgNir.NIR_OK && viewModel.nirDepartement) {
                ret = this.controleNirNouveauxDepartements(dateNaissance, viewModel.nirDepartement, viewModel.departement);
            }
            return ret;
        };


        /**
         * @ngdoc method
         * @name controlerLongueurEtElementsNir
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctControleNirService
         * @param viewModel binding scope 
         * @param {string} nir nir sur x caractères
         * @param {date} dateNaisssance au format jj/mm/aaaa
         * @return {string} OK ou message d'erreur
         * @description
         * Vérifie les différentes tailles possibles du NIR
         * Retourne "OK" si longueur valide et poursuit les contrôles des éléments du NIR
         * sinon retoune le message d'erreur "Le numéro saisi est invalide ou ne correspond pas à votre état civil."
         */
        this.controlerLongueurEtElementsNir = function(viewModel, nir, dateNaissance) {
            var ret = CnafCctConstantMsgNir.NIR_OK;
            if (nir !== undefined && nir.length > 0) {
                //Contrôles liés au NIR dans sa longueur
                if (nir.length >= 10) {
                    if (nir.length === 10) {
                        ret = this.isValidNirNumber10(nir);
                    }
                    else if (nir.length === 13) {
                        ret = this.isValidNirNumber13(nir);
                    }
                    else if (nir.length === 15) {
                        var cle = nir.substring(13, 15);
                        var nir13 = nir.substring(0, 13);
                        var nirDepartement = nir.substring(5, 7);
                        ret = this.controleCleNir(nir13, cle, nirDepartement);
                        if (ret === CnafCctConstantMsgNir.NIR_OK) {
                            ret = this.isValidNirNumber15(nir);
                        }
                    }
                }
                if (nir.length === 2 ||
                    nir.length === 4 ||
                    nir.length === 6 ||
                    nir.length === 8 ||
                    nir.length === 9 ||
                    nir.length === 11 ||
                    nir.length === 12 ||
                    nir.length === 14) {
                    //année ou mois ou département ou .... incomplet
                    ret = CnafCctConstantMsgNir.NIR_KO;
                }

                //Si Ok, on peut poursuivre par les contrôles des éléments du NIR...
                //Contrôles liés aux éléments du NIR (Validité des codes sexe/annee naissance/mois naissance/département naissance...)
                if (ret === CnafCctConstantMsgNir.NIR_OK) {
                    ret = this.controlerElementsNir(viewModel, nir, dateNaissance);
                }
            }
            return ret;
        };



        /**************************
         * Controle le n° de sécu. (cf Daf SITENF et SITFAM pour description fonctionnelle des différents contrôles)
         ***************************/
        this.controlerDonneesNir = function(viewModel, nir, dateNaissance, sexe, lieunaissance, codePostalVille, COMnaissance) {
            var retourControles = CnafCctConstantMsgNir.NIR_OK;
            viewModel.departement = '';
            viewModel.departement3 = '';
            //Implémentation du Code Département de naissance 
            //+ si nécessaire, 3 premières positions du code postal (pour la Corse par ex.)
            if (lieunaissance === 'FranceDOM') {
                if (viewModel.autocompletion === 'on') {
                    viewModel.departement = codePostalVille.lib.substring(0, 2);
                    viewModel.departement3 = codePostalVille.lib.substring(0, 3);
                } else {
                    viewModel.departement = codePostalVille.substring(0, 2);
                    viewModel.departement3 = codePostalVille.substring(0, 3);
                }
                if (viewModel.departement === '20') {
                    if (viewModel.departement3 === '200' || viewModel.departement3 === '201') {
                        viewModel.departement = '2A';
                    }
                    else {
                        viewModel.departement = '2B';
                    }
                }
            } else {
                if (lieunaissance === 'COM') { 
                    if (COMnaissance.libelle == 'Saint-Pierre-et-Miquelon' || COMnaissance.libelle == 'Saint-Barthélémy' || COMnaissance.libelle == 'Saint-Martin') {
                        viewModel.departement = '97';
                    } else {
                        viewModel.departement = '98';
                    }
                } else {
                    if (lieunaissance === 'Etranger') {
                        viewModel.departement = '99';
                    }
                }
            }

            if (nir !== undefined && lieunaissance === 'FranceDOM' && viewModel.departement != '97' && viewModel.departement3 != '988') {
                //(cf. DEC_ECV_02 / Daf SITFAM)
                if (nir.length < 13 || nir.length === 14) {
                    retourControles = CnafCctConstantMsgNir.NIR_KO;
                }
            }

            if (retourControles === CnafCctConstantMsgNir.NIR_OK) {
                //Si OK, on enchaîne sur les contrôles de la longueur et des éléments du NIR
                retourControles = this.controlerLongueurEtElementsNir(viewModel, nir, dateNaissance, sexe, lieunaissance, codePostalVille, COMnaissance);
            }


            if (nir === undefined || nir.length === 0) {
                //(cf. DEC_ECV_02 / Daf SITFAM)
                if (lieunaissance === 'FranceDOM' && viewModel.departement != '97' && viewModel.departement3 != '988') {
                    retourControles = 'Champs obligatoires';
                } else {
                    //(cf. DEC_ECV_07 / Daf SITFAM)
                    viewModel.nir = this.genererNir(sexe, dateNaissance);
                }
            } else {
                if (retourControles === CnafCctConstantMsgNir.NIR_OK) {
                    //(cf. DEC_ECV_07 / Daf SITFAM)
                    if ((lieunaissance === 'FranceDOM' && (viewModel.departement === '97' || viewModel.departement3 === '988')) || lieunaissance !== 'FranceDOM') {
                        viewModel.nir = this.genererNir(sexe, dateNaissance);
                    } else {
                        viewModel.nir = nir;
                    }
                }
            }
            return retourControles;
        };

        /**
         * @ngdoc method
         * @name controlerDonneesSaufSexeDepartement
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctControleNirService
         * @param {string} nirAn année de naissance du nir
         * @param {string} nirMois mois de naissance du nir
         * @param {date} dateNaisssance au format jj/mm/aaaa
         * @return {string} OK ou message d'erreur
         * @description
         * Méthode d'appel des différents contrôles associés au nir
         * Retourne "OK" si nir valide
         * sinon retoune le message d'erreur "Le numéro saisi est invalide ou ne correspond pas à votre état civil."
         */
        this.controlerDonneesSaufSexeDepartement = function(nirAn, nirMois, dateNaissance) {
            var retourControles = CnafCctConstantMsgNir.NIR_OK;
            var date = Date.parseExact(dateNaissance, 'd/M/yyyy');
            var mm = date.getMonth() + 1;
            mm = mm.toString();
            if (mm.length === 1) {
                mm = '0' + mm;
            }
            var aa = date.getFullYear();
            aa = aa.toString().substr(-2);
            //Tous les contrôles/NIR suivants générant le même message (Le numéro saisi est invalide ou ne correspond pas à votre état civil)...
            //Pour éviter l'affichage multiple de ce message, les cid suivants ne seront appelés que si pas d'erreur déjà détectée
            if (retourControles === CnafCctConstantMsgNir.NIR_OK) {
                retourControles = this.controleNirAn(aa, nirAn);
            }
            if (retourControles === CnafCctConstantMsgNir.NIR_OK && nirMois != undefined) {
                retourControles = this.controleNirMois(mm, nirMois);
            }

            return retourControles;
        };

        /**
         * @ngdoc method
         * @name controleNirSexe
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctControleNirService
         * @param {string} sexe Masculin ou Fénimin
         * @param {string} nirSexe code sexe du nir
         * @return {string} OK ou message d'erreur
         * @description
         * Vérifie que le code sexe du nir correspond bien au sexe de la personne
         * Retourne "OK" si sexe valide
         * sinon retoune le message d'erreur "Le numéro saisi est invalide ou ne correspond pas à votre état civil."
         */
        this.controleNirSexe = function(sexe, nirSexe) {
            //(cf. DEC_ECV_03 / Daf SITFAM et ENF_ECV_20 / Daf SITENF)
            // Si sexe = masculin, 1er caractère du nir = 1
            // Si sexe = feminin, 1er caractère du nir = 2
            // ==============================================
            var ret = CnafCctConstantMsgNir.NIR_OK;
            if (sexe === 'Masculin' && nirSexe !== '1') {
                return CnafCctConstantMsgNir.NIR_KO;
            } else if (sexe === 'Féminin' && nirSexe !== '2') {
                return CnafCctConstantMsgNir.NIR_KO;
            }
            return ret;
        };

        /**
         * @ngdoc method
         * @name controleNirAn
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctControleNirService
         * @param {string} aa 2 dernier caractères de l'année de la date de naissance
         * @param {string} nirAn année de naissance du nir
         * @return {string} OK ou message d'erreur
         * @description
         * Vérifie que l'année saisie dans le nir correspond bien au 2 dernier caractères de l'année de la date naissance
         * Retourne "OK" si année valide
         * sinon retoune le message d'erreur "Le numéro saisi est invalide ou ne correspond pas à votre état civil."
         */
        this.controleNirAn = function(aa, nirAn) {
            //(cf. DEC_ECV_03 / Daf SITFAM et ENF_ECV_20 / Daf SITENF)
            // les 2eme et 3eme caractères du NIR doivent correspondre à l'année de naissance
            // ================================================================================
            var ret = CnafCctConstantMsgNir.NIR_OK;
            if (aa !== nirAn) {
                return CnafCctConstantMsgNir.NIR_KO;
            }
            return ret;
        };

        /**
         * @ngdoc method
         * @name controleNirNouveauxDepartements
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctControleNirService
         * @param {string} dateNaissance date de naissance de la personne contolée
         * @param {string} nirDepartement département de naissance contenu dans le nir saisi
         * @param {string} codePostal paostal de naissance
         * @return {string} OK ou message d'erreur
         * @description
         * Si la personne est née en 1963 ou après et que la position 6-7 du NIR est 91, 92, 93 ou 94 et que le CP du
         * lieu de naissance ne correspond pas alors on affiche un message bloquant "Votre saisie est incorrecte,
         * merci de vérifier les données saisies "
         * Si la personne est née en 1964 ou après et que la position 6-7 du NIR est 95 ou 96 et que le CP du
         * lieu de naissance ne correspond pas alors on affiche un message bloquant "Votre saisie est incorrecte,
         * merci de vérifier les données saisies "
         * sinon retoune OK
         */
        this.controleNirNouveauxDepartements = function(dateNaissance, nirDepartement, cpDepartement) {

            //(cf. DEC_ECV_04 / Daf SITFAM et ENF_ECV_21 / Daf SITENF)
            var date = Date.parseExact(dateNaissance, 'd/M/yyyy');
            var year = date.getFullYear();
            var ret = CnafCctConstantMsgNir.NIR_OK;

            if (year >= 1963) {
                if (nirDepartement === '91' || nirDepartement === '92' || nirDepartement === '93' || nirDepartement === '94') {
                    if (cpDepartement !==  nirDepartement) {
                        ret = CnafCctConstantMsgNir.NIR_SAISIE_INCORRECTE;
                    }
                }
            }

            if (year >= 1964) {
                if (nirDepartement === '95' || nirDepartement === '96') {
                    if (cpDepartement !==  nirDepartement) {
                        ret = CnafCctConstantMsgNir.NIR_SAISIE_INCORRECTE;
                    }
                }
            }

            return ret;
        };

        /**
         * @ngdoc method
         * @name controleNirMois
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctControleNirService
         * @param {string} mm mois de la date de naissance
         * @param {string} nirMois mois de naissance du nir
         * @return {string} OK ou message d'erreur
         * @description
         * Vérifie que le mois saisi dans le nir correspond bien au mois de la date de naissance
         * Retourne "OK" si année valide
         * sinon retoune le message d'erreur "Le numéro saisi est invalide ou ne correspond pas à votre état civil."
         */
        this.controleNirMois = function(mm, nirMois) {
            //(cf. DEC_ECV_03 / Daf SITFAM et ENF_ECV_20 / Daf SITENF)
            // les 4eme et 5eme caractères du NIR doivent correspondre au mois de naissance
            // =============================================================================
            var ret = CnafCctConstantMsgNir.NIR_OK;
            if (mm !== nirMois) {
                return CnafCctConstantMsgNir.NIR_KO;
            }
            return ret;
        };

        /**
         * @ngdoc method
         * @name controleNirDepartement
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctControleNirService
         * @param {string} departement département de naissance
         * @param {string} nirDepartement département du nir
         * @return {string} OK ou message d'erreur
         * @description
         * Vérifie que le département saisi dans le nir correspond bien au département du lieu de naissance
         * Retourne "OK" si année valide
         * sinon retoune le message d'erreur "Le numéro saisi est invalide ou ne correspond pas à votre état civil."
         */
        this.controleNirDepartement = function(departement, nirDepartement) {
            //La pop up de confirmation du numéro de Sécurité sociale doit s'afficher *uniquement* si
            //- les positions 6-7 du nir sont égales à 75 et si le département est égal à 91, 92, 93, 94 ou 95
            //- les positions 6-7 du nir sont égales à 20 et si le département est égal à 2A, 2B
            //- les positions 6-7 du nir sont égales à 98, 91, 92, 93, 94, 95, 96
            //Dans les autres cas de différence sur ces positions 6 ou 7, on sera dans un cas d'incohérence et donc on bloque l'utilisateur.
            //(cf. DEC_ECV_04 / Daf SITFAM et ENF_ECV_21 / Daf SITENF)
            var ret = CnafCctConstantMsgNir.NIR_OK;
            if (
                (nirDepartement == '75' &&
                    (departement == '91' || departement == '92' || departement == '93' || departement == '94' || departement == '95')) ||
                (nirDepartement == '20' && (departement == '2A' || departement == '2B')) ||
                (nirDepartement == '98' ||
                    nirDepartement == '91' ||
                    nirDepartement == '92' ||
                    nirDepartement == '93' ||
                    nirDepartement == '94' ||
                    nirDepartement == '95' ||
                    nirDepartement == '96')
            ) {
                //Affichage POPUP
                return CnafCctConstantMsgNir.NIR_KO;
            }
            return ret;
        };

        this.controleNirDepartement2 = function(departement, nirDepartement) {
            //La pop up de confirmation du numéro de Sécurité sociale doit s'afficher *uniquement* si
            //- les positions 6-7 du nir sont égales à 75 et si le département est égal à 91, 92, 93, 94 ou 95
            //- les positions 6-7 du nir sont égales à 20 et si le département est égal à 2A, 2B
            //- les positions 6-7 du nir sont égales à 98, 91, 92, 93, 94, 95, 96
            //Dans les autres cas de différence sur ces positions 6 ou 7, on sera dans un cas d'incohérence et donc on bloque l'utilisateur.
            var ret = CnafCctConstantMsgNir.NIR_OK;
            if (departement !== nirDepartement && this.controleNirDepartement(departement, nirDepartement) == CnafCctConstantMsgNir.NIR_OK) {
                //Affichage message bloquant
                return CnafCctConstantMsgNir.NIR_KO;
            }
            return ret;
        };

        /**
         * @ngdoc method
         * @name controleCleNir
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctControleNirService
         * @param {string} nir13 nir sur 13 caractères
         * @param {string} cleNir clé du nir
         * @param {string} nirDepartement département du nir
         * @return {string} OK ou message d'erreur
         * @description
         * Calcule la clé du nir et vérifie que celles saisie est valide
         * Retourne "OK" si clé valide
         * sinon retoune le message d'erreur "Le numéro saisi est invalide ou ne correspond pas à votre état civil."
         */
        this.controleCleNir = function(nir13, cleNir, nirDepartement) {
            //(cf. DEC_ECV_08 / Daf SITFAM et ENF_ECV_32 / Daf SITENF)
            //console.log("fonction controleCleNir : entrée, avec nir13 = " + nir13 + "cleNir = "+cleNir+ "nirDepartement = "+nirDepartement);
            // calcul de la clé du nir et contrôle avec celle saisie
            // ======================================================
            var ret = CnafCctConstantMsgNir.NIR_OK;
            var nir = '';
            // cas particulier de la Corse - 2A et 2B dans le département du Nir
            if (nirDepartement === '2A') {
                nir = nir13.substring(0, 5) + '19' + nir13.substring(7, 13);
            } else if (nirDepartement === '2B') {
                nir = nir13.substring(0, 5) + '18' + nir13.substring(7, 13);
            } else {
                nir = nir13;
            }
            //console.log(nir);
            var numNir = parseInt(nir, 10);
            var cle = 97 - (numNir % 97);
            //console.log("cle = "+cle+" cleNir ="+cleNir);
            if (cle !== parseInt(cleNir, 10)) {
                return CnafCctConstantMsgNir.NIR_KO;
            }
            return ret;
        };
    }
})();

(function() {
    'use strict';
    //Définition de constantes pour les msg d'erreur
    angular.module('cnafComponentsTeleprocApp').constant("CnafCctConstantMsgNir",
      {
        'NIR_OK':'OK',
        'NIR_KO':'Le numéro saisi est invalide ou ne correspond pas à votre état civil.',
        'NIR_SAISIE_INCORRECTE':'Votre saisie est incorrecte, merci de vérifier les données saisies'
      }
    );
})();

(function() {
    'use strict';
    /**
     * @ngdoc service
     * @name cnafComponentsTeleprocApp.service:CnafCctNirService
     *
     * @description
     * Service de manipulation du Nir
     *
     */
    angular
        .module('cnafComponentsTeleprocApp')
        .service('CnafCctNirService', CnafCctNirService);

    function CnafCctNirService() {

        /**
         * @ngdoc method
         * @name decouperNir
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctNirService
         * @param {string} nir nir sans espaces
         * @return {string}  nirDecoupe qui contient les zones sexe,an,mois,departement,commune,rang et clé
         * @description
         * Découpe le nir afin de récupérer les diiférentes zones pour les controles
         * (sexe,an,mois,departement,commune,rang et clé)
         */
        this.decouperNir = function(nir) {
            var nirDecoupe = {};
            if (nir !== null) {
              if (nir.length >= 1){
                nirDecoupe.sexe = nir.substring(0, 1);
              }
              if (nir.length >= 3){
                nirDecoupe.an = nir.substring(1, 3);
              }
              if (nir.length >= 5){
                nirDecoupe.mois = nir.substring(3, 5);
              }
              if (nir.length >= 7){
                nirDecoupe.departement = nir.substring(5, 7);
              }
              if (nir.length >= 10){
                nirDecoupe.commune = nir.substring(7, 10);
              }
              if (nir.length >= 13){
                nirDecoupe.rang = nir.substring(10,13);
              }
              if (nir.length >= 15){
                nirDecoupe.cle = nir.substring(13,15);
              }
            }
            return nirDecoupe;
        };

        /**
         * @ngdoc method
         * @name affichageNirAvecBlanc
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctNirService
         * @param {string} nir nir sans espaces
         * @return {string} nirAvecBlanc nir avec des espaces entre chaque zone
         * @description
         * Ajoute des blancs entre les différentes zones du nir
         */
        this.affichageNirAvecBlanc = function(nir) {
            var nirAvecBlanc = "";
            if (nir && nir !== "")
            {
                for(var i=0; i<nir.length; i++)
                {
                  if (i=='1' || i=='3' || i=='5' || i=='7' || i=='10' || i=='13')
                    nirAvecBlanc += " "+nir.substr(i,1);
                  else
                    nirAvecBlanc += nir.substr(i,1);
                }
            }
            return nirAvecBlanc;
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('cnafComponentsTeleprocApp')
        .service('CnafCctPdfsService', CnafCctPdfsService);

        CnafCctPdfsService.$inject = ['CNAFCOMMONSAPP_CONFIG',
                                      '$resource',
                                      'CnafUserService',
                                      'CnafCctConstants',
                                      'CnafCctSaveChangementSessionService'];



    function CnafCctPdfsService(CNAFCOMMONSAPP_CONFIG,
                                $resource,
                                CnafUserService,
                                CnafCctConstants,
                                CnafCctSaveChangementSessionService) {


        var resourceActions = angular.extend({}, CNAFCOMMONSAPP_CONFIG.resourceActions);
        var pdfNDWEBUrl = "/api/cnafcompteleprocfront/v1/pdf_ndweb";
        var demandePrestationsUrl = "/api/demandeprestationfront/v1/mon_compte/demande_prestation/composition";

        var matricule = CnafCctSaveChangementSessionService.getData('matricule');

        this.getPdfNDWEB = function(codeOrga, idDocument) {
            return $resource(pdfNDWEBUrl, {
                codeOrga: codeOrga,
                idDocument: idDocument,
                matricule: matricule
                }, resourceActions);
            //MOCK JSON - Ne pas mettre en prod
            /*return $http({
                url: 'services/url_ndweb.json',
            });*/
        };
        // Demande de Formulaire
        this.demandePrestations = function () {
            return $resource(demandePrestationsUrl, null, resourceActions);
        };

            // Définition de la situation du dossier en fonction du groupe allocataire
        this.getCodeSituationDossier = function() {
            var situation = "PRIMO";
            if (CnafUserService.isInGroup(CnafUserService.GROUP_ALLOCATAIRES_NEO_PRIMO) || CnafUserService.isInGroup(CnafUserService.GROUP_ALLOCATAIRES_ENCOURS_AFFILIATION)) {
                situation = "AFC";
            } else if (CnafUserService.isInGroup(CnafUserService.GROUP_ALLOCATAIRES_RADIES) || CnafUserService.isInGroup(CnafUserService.GROUP_ALLOCATAIRES_DSIT_BLOQUEE)) {
                situation = "RADIE";
            } else if (CnafUserService.isInGroup(CnafUserService.GROUP_ALLOCATAIRES_TUTELLE48)) {
                situation = "TUTELLE";
            } else if (CnafUserService.isInGroup(CnafUserService.GROUP_ALLOCATAIRES_MAYOTTE)) {
                situation = "MAYOTTE";
            } else if (CnafUserService.isInGroup(CnafUserService.GROUP_ALLOCATAIRES_AFFILIES)) {
                situation = "AFF";
            } else if (CnafUserService.matricule() !== null && CnafUserService.matricule() !== undefined && CnafUserService.matricule().length > 0) {
                // allocataire authentifié mais dans aucun groupes gérés
                situation = "AFC";
            }
            return situation;
        };

        this.getMessageReassurance = function(codePrestation) {

            var messageReassurance = "";
            if (codePrestation == CnafCctConstants.DEM_PRIME_ADOPTION)
            {
                messageReassurance = "Le calcul de vos droits à la prime d’adoption et à l’allocation de base sera automatique.";                
            }
            else if (codePrestation == CnafCctConstants.DEM_ALL_FAMILIALE)
            {
                messageReassurance = "Le calcul de vos droits aux allocations familiales ou du complément familial sera automatique.";
            }
            else if (codePrestation == CnafCctConstants.DEM_ALL_RENTREE_SCO) 
            {
                messageReassurance = "Le calcul de vos droits à l'allocation de rentrée scolaire sera automatique.";
            }
            
            return messageReassurance;
        };
    }

})();

(function() {
    'use strict';

    /**
     * @ngdoc service
     * @name cnafComponentsTeleprocApp.service:CnafCctRessourcesService
     *
     * @description
     * Service de controles si code nature ressource déjà saisi
     *
     */

    angular
        .module('cnafComponentsTeleprocApp')
        .service('CnafCctRessourcesService', CnafCctRessourcesService);

    CnafCctRessourcesService.$inject = ['$rootScope'];

    function CnafCctRessourcesService($rootScope) {
      /**
      * @ngdoc method
      * @name ressourceDejaExistante
      * @methodOf cnafComponentsTeleprocApp.service:CnafCctRessourcesService
      * @param {Object} dataReferences liste des natures ressources saisie
      * @param {Object} referenceRessource nature ressource à controler
      * @return {boolean} TODO
      * @description
      * Retourne true si le code nature ressource a déjà été saisi
      * sinon retourne false
      */
        this.ressourceDejaExistante = function(dataReferences, referenceRessource){
            if(dataReferences){
                return dataReferences.get(referenceRessource) === undefined ? false : true;
            }else {
                return false;
            }
        };
    }
})();

(function() {
    'use strict';

    /* Service qui permet d'enregistrer la saisie de l'utilisateur */
    angular
        .module('commonsServices')
        .service('CnafCctSaveChangementSessionService', CnafCctSaveChangementSessionService);

    function CnafCctSaveChangementSessionService() {

        //Contient la liste des changements selectionnées ( attention si retour arrière, sur profilComplet la liste sera éventuellement enrichie)
        var listChangementSession = [];
        //Contient la liste de toutes les objets , même s'il y a eu un retour arrière
         /* Méthode permettant d'accéder au sessionStorage*/
        this.getListChangementSession = function() {
            return angular.fromJson(sessionStorage.getItem("listChangementSession"));
        };
        this.setListChangementSession = function(list) {
            return sessionStorage.setItem("listChangementSession", angular.toJson(list));
        };

        /**
         * @ngdoc method
         * @name addChangement
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctSaveSessionService
         * @param {string} id id du changement -> doit être unique
         * @param {string} etat etat indique l'état du changement (S sélectionné, T traité, F forcé)
         * @param {string} codeOrga codeOrga code organisme du matricule authentifié
         * @param {string} titre titre résument l'ensemble des chgts effectués affiché dans l'écran de fin
         * @param {object} listesMessages Objet messages (portant les listes listeMessAvert ou listeMessReassur) affichés dans l'écran de fin
         * @param {object} pdf pdf informations liées au pdf du changement saisi
         * @param {string} listePjs liste des pjs pour le changement effectué
         * @param {object} listeLiens listeLiens liste de liens à afficher
         * @param {object} listeLiensPdf listeLiensPdf liste des liens vers une demande au format papier (pdf)
         * @param {string} urlEnchainement url permettant via un bouton d'enchainer vers une DAL, DTRRRSAPA ...
         * @description
         * Ajout d'un changement dans la liste des changements enregistrés dans la session
         */
        this.addChangement = function(id, etat, codeOrga, titre , listesMessages, pdf, listePjs, listeLiens, listeLiensPdf,urlEnchainement) {
            //Création objet Page
            var changement = {
                "id": id,
                "etat": etat,
                "codeOrga": codeOrga,
                "titre": titre,
                "listesMessages": listesMessages,
                "pdf": pdf,
                "listePjs": listePjs,
                "listeLiens": listeLiens,
                "listeLiensPdf": listeLiensPdf,
                "urlEnchainement": urlEnchainement
            };

            listChangementSession = this.getListChangementSession();
            if (listChangementSession === null || listChangementSession === "") {
                listChangementSession = {};
            }
            //Historique des changements on écrase l'enregistrement précédent avec la nouvelle sauvegarde
            listChangementSession[id] = changement;
            //Stockage
            this.setListChangementSession(listChangementSession);
        };

        /* Retourne un changement  dans la listChangementSession */
        this.getPageFromListChangementSessionByID = function(id) {
            if (this.getListChangementSession() !== null)
                return this.getListChangementSession()[id];
            else
                return null;
        };

        // methode permettant de récupérer une donnée en fonction d'un libellé
        this.getData = function(libelleData) {
            return angular.fromJson(sessionStorage.getItem(libelleData));
        };

        // methode permettant de stocker une donnée avec un libellé donnée
        this.setData = function(libelleData, data) {
            return sessionStorage.setItem(libelleData, angular.toJson(data));
        };


        //Nettoie une data 
        this.clearData= function(libelleData){
        sessionStorage.removeItem(libelleData);
        }
        
        /* Nettoie toutes les listes */
        this.cleanAll = function() {
          sessionStorage.removeItem("listChangementSession");
        };

    }
})();

(function() {
    'use strict';

    /* Service qui permet d'enregistrer la liste des ressources à renseigner */
    angular
        .module('commonsServices')
        .service('CnafCctSaveRessourcesSessionService', CnafCctSaveRessourcesSessionService);

    function CnafCctSaveRessourcesSessionService() {

        //Contient la liste des changements selectionnées ( attention si retour arrière, sur profilComplet la liste sera éventuellement enrichie)

        //Contient la liste de toutes les objets , même s'il y a eu un retour arrière
         /* Méthode permettant d'accéder au sessionStorage*/
        this.getListRessourcesSession = function() {
            return angular.fromJson(sessionStorage.getItem("listRessourcesSession"));
        };

        this.setListRessourcesSession = function(list) {
            return sessionStorage.setItem("listRessourcesSession", angular.toJson(list));
        };

        /**
         * @ngdoc method
         * @name addListRessources
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctSaveRessourcesSessionService
         * @param {string} idPers idPers de la personne
         * @param {string} typePersonne typePersonne (MON, MME, ENF, AUT)
         * @param {string} nom nom
         * @param {string} prenom prenom
         * @param {string} dateNaissance dateNaissance (format dd/jj/aaaa)
         * @param {string} codeEtat code état de la pièce associée à la personne (pour trt fin)
         * @param {string} liqAuto indique si la démarche est en liquidation auto ou injection (pour trt fin)
         * @param {object} listAnnees listAnnees liste des années à demander pour la personne
         *
         * @description
         * Ajout d'une personne dans la liste des personnes pour le module RessourcesAnnuelles enregistrées dans la session
         */
        this.addListRessources = function(idPers, typePersonne, nom, prenom, dateNaissance, codeEtat, liqAuto, listAnnees, dateSitfam) {
            //Création objet Page
            var listRessources = {
                "idPers": idPers,
                "typePersonne": typePersonne,
                "nom": nom,
                "prenom": prenom,
                "dateNaissance": dateNaissance,
                "codeEtat": codeEtat,
                "liqAuto": liqAuto,
                "annees": listAnnees,
                "dateSitfam": dateSitfam,
            };
            var listRessourcesSession = this.getListRessourcesSession();
            if (listRessourcesSession === null || listRessourcesSession === "") {
                listRessourcesSession = [];
            }
            //Historique des changements on écrase l'enregistrement précédent avec la nouvelle sauvegarde
            listRessourcesSession.push(listRessources);
            //Stockage
            this.setListRessourcesSession(listRessourcesSession);
        };

        /**
         * @ngdoc method
         * @name modifEnregListRessources
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctSaveRessourcesSessionService
         * @param {int} index index de l'enregistrement à mettre à jour dans la liste
         * @param {object} enreg nouvelles données de l'enregistrement
         *
         * @description
         * Modificaiton d'un enregistrement pour le module RessourcesAnnuelles enregistrées dans la session
         */
        this.modifEnregListRessources = function(index, enreg) {
            var listRessourcesSession = this.getListRessourcesSession();
            listRessourcesSession[index] = enreg;
            //Stockage
            this.setListRessourcesSession(listRessourcesSession);
        };
        
        
        /* Retourne un changement  dans la listChangementSession */
        this.getEnregFromListRessourcesSessionByID = function(id) {
            if (this.getListRessourcesSession() !== null)
            {
                return this.getListRessourcesSession()[id];
            }
            else {return null;}
        };
        
       /* Retourne un changement  dans la listChangementSession */
       this.getIndexFromListRessourcesSessionByIDPers = function(idPers) {
            var listRessourcesSession = this.getListRessourcesSession();

            if (listRessourcesSession)
            {
                for (var index in listRessourcesSession) {

                    if (listRessourcesSession[index].idPers === idPers)
                    {
                        return index;
                    }
                } 
            }           
            else
            {
                return null;
            }
       };

        /* Nettoie toutes les listes */
        this.cleanAllRessourcesSession = function() {
          sessionStorage.removeItem("listRessourcesSession");
        };

        /* Contrôle l'état des données en session */
        this.controleRessourcesSessionOk = function(listRessourcesSession) {

            var bListeCorrecte = true;
            // On vérifie que chaque élément de la liste a :
            //      - un identifiant de personne
            //      - au moins une année de ressources à déclarer
            for (var index in listRessourcesSession) {
                var ressourcePers = listRessourcesSession[index];
                var idPersEnCours = ressourcePers.idPers;
                var listeAnnees = ressourcePers.annees;
                var annee;
                
                if (listeAnnees)
                {
                    annee = listeAnnees[0];
                }

                /*console.log(
                        'vm.idPersEnCours = ' +
                        idPersEnCours +
                        ' -- vm.listeAnnees = ',
                        listeAnnees
                );*/
                
                if (!idPersEnCours || !listeAnnees || !annee)
                {
                    // Erreur lors de la création de la liste :
                    bListeCorrecte = false;
                }
            }

            return bListeCorrecte;           
          };        

    }
})();

(function() {
    'use strict';

    angular.module('cnafComponentsTeleprocApp').service('CnafCctSitEnfService', CnafCctSitEnfService);

    CnafCctSitEnfService.$inject = ['CnafCctDateService'];

    function CnafCctSitEnfService(CnafCctDateService) {



        this.getDateMaxAutoriseeEnfant1 = function(stringDateNaissance, situationEnfant1) {
            var dateMaxiAutorisee;

            if (situationEnfant1 ==='SCO') {
                dateMaxiAutorisee = this.getDateMaxAutorisee(stringDateNaissance, 5);
            }

            return dateMaxiAutorisee;
        };


        this.getDateMaxAutoriseeEnfant2 = function(stringDateNaissance, situationEnfant2) {
            var dateMaxiAutorisee;

            if (situationEnfant2 === 'SCO' || situationEnfant2  === 'IAD' || situationEnfant2  === 'INF') {
                dateMaxiAutorisee = this.getDateMaxAutorisee(stringDateNaissance, 6);
            }

            return dateMaxiAutorisee;
        };

        this.getDateMaxAutoriseeAdo1 = function(stringDateNaissance, situationAdo1) {
            var dateMaxiAutorisee;

            if (situationAdo1 === 'SCO' || situationAdo1 === 'IAD' || situationAdo1 === 'INF') {
                dateMaxiAutorisee = this.getDateMaxAutorisee(stringDateNaissance, 6);
            }
            else if (situationAdo1  === 'CPRO') {
                dateMaxiAutorisee = this.getDateMaxAutoriseeMoisAnnee(stringDateNaissance, 15, 9);
            }
            else if (situationAdo1  === 'APP') {
                dateMaxiAutorisee = this.getDateMaxAutorisee(stringDateNaissance, 14);
            }

            return dateMaxiAutorisee;
        };

        this.getDateMaxAutoriseeAdo2 = function(stringDateNaissance, situationAdo2, situationAdo2StagAppAlt,
            situationAdo2AutreSituation) {

            var dateMaxiAutorisee;

            if (situationAdo2 === 'IAD') {
                dateMaxiAutorisee = this.getDateMaxAutorisee(stringDateNaissance, 6);
            }
            else if (situationAdo2StagAppAlt === 'APP') {
                dateMaxiAutorisee = this.getDateMaxAutorisee(stringDateNaissance, 14);
            }
            else if (situationAdo2StagAppAlt === 'CPRO') {
                dateMaxiAutorisee = this.getDateMaxAutoriseeMoisAnnee(stringDateNaissance, 15, 9);
            }
            else if (situationAdo2  === 'SCO' || situationAdo2 === 'ETS'  || situationAdo2StagAppAlt  === 'SFP') {
                dateMaxiAutorisee = this.getDateMaxAutorisee(stringDateNaissance, 16);
            }
            else if (situationAdo2AutreSituation  === 'SAL' || situationAdo2AutreSituation  === 'volontaire' || situationAdo2AutreSituation  === 'CHR') {
                dateMaxiAutorisee = this.getDateMaxAutorisee(stringDateNaissance, 16);
            }
            else if (situationAdo2AutreSituation  === 'CNI' || situationAdo2AutreSituation  === 'SSA') {
                dateMaxiAutorisee = this.getDateMaxAutorisee(stringDateNaissance, 16);
            }
            else if (situationAdo2AutreSituation  === 'ETI') {
                dateMaxiAutorisee = this.getDateMaxAutorisee(stringDateNaissance, 18);
            }

            return dateMaxiAutorisee;
        };

        this.getDateMaxAutoriseeAdulte = function(stringDateNaissance, situationAdulte, situationAdulteEtuStagAppAlt) {

            var dateMaxiAutorisee;

            if (situationAdulteEtuStagAppAlt === 'APP') {
                dateMaxiAutorisee = this.getDateMaxAutorisee(stringDateNaissance, 14);
            }
            else if (situationAdulteEtuStagAppAlt === 'CPRO') {
                dateMaxiAutorisee = this.getDateMaxAutoriseeMoisAnnee(stringDateNaissance, 15, 9);
            }
            else if (situationAdulteEtuStagAppAlt === 'ETS' || situationAdulteEtuStagAppAlt === 'SFP' || situationAdulte === 'CHR' || situationAdulte  === 'volontaire') {
                dateMaxiAutorisee = this.getDateMaxAutorisee(stringDateNaissance, 16);
            }
            else if (situationAdulte === 'CHR' || situationAdulte === 'CNI' || situationAdulte === 'SSA' || situationAdulte === 'SAL') {
                dateMaxiAutorisee = this.getDateMaxAutorisee(stringDateNaissance, 16);
            }
            else if (situationAdulte === 'ETI') {
                dateMaxiAutorisee = this.getDateMaxAutorisee(stringDateNaissance, 18);
            }
            else if (situationAdulte  === 'HAN' ) {
                dateMaxiAutorisee = this.getDateMaxAutorisee(stringDateNaissance, 22);
            }
            else if (situationAdulte  === 'RET') {
                dateMaxiAutorisee = this.getDateMaxAutorisee(stringDateNaissance, 40);
            }

            return dateMaxiAutorisee;
        };

        // Ajoute des mois pour les cas particulies 15 ans et 9 mois
        // puis appelle de la méthode ajoutant les années
        this.getDateMaxAutoriseeMoisAnnee = function(stringDateNaissance, anneesAjoutees, moisAjoutes) {
            var dateMaxiAutorisee = CnafCctDateService.parseDate(stringDateNaissance);
            dateMaxiAutorisee = dateMaxiAutorisee.add({ months: moisAjoutes });
            return this.getDateMaxAutorisee(CnafCctDateService.ddmmyyyy(dateMaxiAutorisee), anneesAjoutees);
        };

        // Ajoute des années et permet de déterminer la date max pour laquelle il peut déclarer la situation
        this.getDateMaxAutorisee = function(stringDateNaissance, anneesAjoutees) {
            var dateMaxiAutorisee = CnafCctDateService.getDatePlusNAnnees(stringDateNaissance, anneesAjoutees);
            return dateMaxiAutorisee.moveToFirstDayOfMonth();
        };

    }
})();

(function() {
    'use strict';

    angular.module('cnafComponentsTeleprocApp').service('CnafCctLogementService', CnafCctLogementService);

    CnafCctLogementService.$inject = ['CNAFCOMMONSAPP_CONFIG', '$resource'];

    function CnafCctLogementService(CNAFCOMMONSAPP_CONFIG, $resource) {
        var resourceActions = angular.extend({}, CNAFCOMMONSAPP_CONFIG.resourceActions);
        var accessionLocationUrl = '/api/logementfront/v1/accession_location';
        this.rechAccessionLocation = function() {
            return $resource(accessionLocationUrl, null, resourceActions);
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('cnafComponentsTeleprocApp')
        .service('CnafCctSitproDonneesGenereesCumulService', CnafCctSitproDonneesGenereesCumulService);

        CnafCctSitproDonneesGenereesCumulService.$inject = [
        'CnafCctSituationproService', 'CnafCctSitproDonneesGenereesService', 'CnafCctDateService'];

    function CnafCctSitproDonneesGenereesCumulService(
        CnafCctSituationproService, CnafCctSitproDonneesGenereesService, CnafCctDateService) {

        /**
         * Fonction permettant de générer les données liées au sitpro (saisie d'activité)
         *
         */
        this.donneesSitproCumul = function (data, index, controle) {

            var donneesGenereesSitpro = {};
            var codeActiviteConnue = "";
            controle.annuleControleDateCarCumulSpecif = false;
            
            //console.log("-------****------- données sitpro générées -------****-------");
            //console.log(data);
            //console.log("controle.personneEnCours : ",controle.personneEnCours);
            donneesGenereesSitpro.injectionConsigneSitPro32 = false;

            if (CnafCctSituationproService.activiteSalariee(controle.personneEnCours.codeAct))
            {
                codeActiviteConnue = 'SAL';
            }
            else if (CnafCctSituationproService.professionNonSalariee(controle.personneEnCours.codeAct))
            {
                codeActiviteConnue = 'NSAL';
            }
            else if (CnafCctSituationproService.chomage(controle.personneEnCours.codeAct))
            {
                codeActiviteConnue = 'CHO';
            }
            else
            {
                codeActiviteConnue = controle.personneEnCours.codeAct; 
            }

            // Selon la première activité connue
            switch (codeActiviteConnue) {
                case ('SAL'):
                    this.donneesSitproSALCumul(data, controle, donneesGenereesSitpro);
                    break;

                case ('NSAL'):
                    this.donneesSitproNSALCumul(data, controle, donneesGenereesSitpro);
                    break;

                case ('CHO'):
                    this.donneesSitproCHOCumul(data, controle, donneesGenereesSitpro);
                    break;  

                case ('RET'):
                    this.donneesSitproRETCumul(data, controle, donneesGenereesSitpro);
                    break;

                case ('PRE'):
                    this.donneesSitproPRECumul(data, controle, donneesGenereesSitpro);
                    break;

                case ('INV'):
                case ('RAT'):
                    this.donneesSitproPENSCumul(data, controle, donneesGenereesSitpro);
                    break;  

                default:
                    break;
            }

            //console.log ("donneesSitproCumul - donneesGenereesSitpro = ");
            //console.log (donneesGenereesSitpro);
            //console.log("-------****------- fin données sitpro générées -------****-------");
            
            return donneesGenereesSitpro;

        };

        //Génération Données Activité 'SAL'
        this.donneesSitproSALCumul = function (data, controle, donneesGenereesSitpro) {
            //console.log("****** Première activité : salarié *******");

            // ********************************************************
            // *** Code activité cumulée                            ***
            // ********************************************************
            switch (data.choixActivite) {
                case ('SAL'):
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproSAL(data, controle, donneesGenereesSitpro);
                    break; 

                case ('NSAL'):
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproNSAL(data, controle, donneesGenereesSitpro);
                    break;

                case ('CHO'):
                    // Avec les données de la nouvelle activité
                    // CHGT0000531 - Chomage Partiel - CPL
                    CnafCctSitproDonneesGenereesService.donneesSitproCHO(data, donneesGenereesSitpro, controle);
                    break; 
                    
                case ('CONG'):
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproCONG(data, controle, donneesGenereesSitpro);
                    break;  

                case ('ETU'):
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproETU(data, controle, donneesGenereesSitpro);
                    break; 

                case ('APP'):                                      
                case ('RET'):
                case ('PENS'):
                    // Avec les données de l'activité connue : SAL
                    this.donneesSitproActiviteConnue(controle, donneesGenereesSitpro);
                    break;                     
                  
                case ('AUT'):
                    // Injection + consigne SitPro32
                    donneesGenereesSitpro.injectionConsigneSitPro32 = true;
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproAUT(data, controle, donneesGenereesSitpro);                    
                    break;

                default:
                    //console.log("ERROR data.choixActivite, code inconnu :" + data.choixActivite);
                    break;
            }
        };

        //Génération Données Activité 'NSAL'
        this.donneesSitproNSALCumul = function (data, controle, donneesGenereesSitpro) {
            //console.log("****** Première activité : non salarié *******");

            // ********************************************************
            // *** Code activité cumulée                            ***
            // ********************************************************
            switch (data.choixActivite) {

                case ('NSAL'):
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproNSAL(data, controle, donneesGenereesSitpro);
                    break;

                case ('SAL'):                    
                case ('APP'):
                case ('RET'):
                case ('PENS'):                    
                    // Avec les données de l'activité connue NSAL
                    this.donneesSitproActiviteConnue(controle, donneesGenereesSitpro);
                    break;  

                case ('ETU'):
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproETU(data, controle, donneesGenereesSitpro);
                    break;                     

                case ('CHO'):
                    // Avec les données de la nouvelle activité
                    // CHGT0000531 - Chomage Partiel - CPL
                    CnafCctSitproDonneesGenereesService.donneesSitproCHO(data, donneesGenereesSitpro, controle);
                    if (donneesGenereesSitpro.codeActivite === "CPL"){
                        donneesGenereesSitpro.injectionConsigneSitPro32 = true;
                    }
                    break;                    
                     
                case ('CONG'):
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproCONG(data, controle, donneesGenereesSitpro);
                    break; 

                case ('AUT'):
                    // Injection + consigne SitPro32
                    donneesGenereesSitpro.injectionConsigneSitPro32 = true;
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproAUT(data, controle, donneesGenereesSitpro);                    
                    break;

                default:
                    //console.log("ERROR data.choixActivite, code inconnu :" + data.choixActivite);
                    break;
            }            
        };

        //Génération Données Activité 'CHO'
        this.donneesSitproCHOCumul = function (data, controle, donneesGenereesSitpro) {
            //console.log("****** Première activité : Chômage indemnisé ou non *******");
           
            // ********************************************************
            // *** Code activité cumulée                            ***
            // ********************************************************
            switch (data.choixActivite) {
                case ('CHO'):
                    // Avec les données de la nouvelle activité
                    // CHGT0000531 - Chomage Partiel - CPL
                    CnafCctSitproDonneesGenereesService.donneesSitproCHO(data, donneesGenereesSitpro, controle);
                    if (donneesGenereesSitpro.codeActivite === "CPL"){
                        donneesGenereesSitpro.injectionConsigneSitPro32 = true;
                    }
                    break;  
                // INC0604925 - APN le 04/01/2021 - génération code CHO avec dd = date saisie
                /*case ('SAL'):
                case ('NSAL'):               
                case ('APP'):                                     
                case ('RET'):                   
                case ('PENS'):                     
                case ('CONG'):*/
                    // Avec les données de l'activité connue CHO
                   ///this.donneesSitproActiviteConnue(controle, donneesGenereesSitpro);
                case ('SAL'):   
                    this.donneesSitproCHO(data.dateActiviteSalarie, controle, donneesGenereesSitpro);
                    break;
                    
                case ('NSAL'):   
                    this.donneesSitproCHO(data.dateActiviteNonSalarie, controle, donneesGenereesSitpro);
                    break;   
                    
                case ('APP'):  
                    // date activité
                    if (data.choixStagiaire.code === 'STAGE')
                    {
                        this.donneesSitproCHO(data.dateActiviteStagiaire, controle, donneesGenereesSitpro);
                    }
                    else {
                        this.donneesSitproCHO(data.dateActiviteApprenti, controle, donneesGenereesSitpro);
                    } 
                    break;    

                case ('RET'):   
                    this.donneesSitproCHO(data.dateActiviteRetraite, controle, donneesGenereesSitpro);
                    break;   

                case ('PENS'):   
                    this.donneesSitproCHO(data.dateActiviteInvalide, controle, donneesGenereesSitpro);
                    break;

                case ('CONG'):   
                    this.donneesSitproCHO(data.dateActiviteConges, controle, donneesGenereesSitpro);
                    break;
                
                case ('ETU'):
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproETU(data, controle, donneesGenereesSitpro);
                    break;    

                case ('AUT'):
                    // Injection + consigne SitPro32
                    donneesGenereesSitpro.injectionConsigneSitPro32 = true;
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproAUT(data, controle, donneesGenereesSitpro);                    
                    break;

                default:
                    //console.log("ERROR data.choixActivite, code inconnu :" + data.choixActivite);
                    break;
            }
        };

        //Génération Données Activité 'RET'
        this.donneesSitproRETCumul = function (data, controle, donneesGenereesSitpro) {
            //console.log("****** Première activité : Retraité *******");

            // ********************************************************
            // *** Code activité cumulée                            ***
            // ********************************************************
            switch (data.choixActivite) {
                case ('SAL'):
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproSAL(data, controle, donneesGenereesSitpro);
                    break;

                case ('NSAL'):
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproNSAL(data, controle, donneesGenereesSitpro);
                    break; 

                case ('RET'):
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproRET(data, controle, donneesGenereesSitpro);                    
                    break; 

                case ('APP'): 
                    // Injection + consigne SitPro32
                    donneesGenereesSitpro.injectionConsigneSitPro32 = true;
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproAPP(data, donneesGenereesSitpro);                    
                    break;  

                case ('CHO'):  
                    // Injection + consigne SitPro32
                    donneesGenereesSitpro.injectionConsigneSitPro32 = true;
                    // Avec les données de la nouvelle activité
                    // CHGT0000531 - Chomage Partiel - CPL
                    CnafCctSitproDonneesGenereesService.donneesSitproCHO(data, donneesGenereesSitpro, controle);                   
                    break;  

                case ('PENS'):
                    // Injection + consigne SitPro32
                    donneesGenereesSitpro.injectionConsigneSitPro32 = true;
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproPENS(data, controle, donneesGenereesSitpro);                    
                    break;   

                case ('CONG'):
                    // Injection + consigne SitPro32
                    donneesGenereesSitpro.injectionConsigneSitPro32 = true;
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproCONG(data, controle, donneesGenereesSitpro);                    
                    break;

                case ('ETU'):
                case ('AUT'):
                    // Avec les données de l'activité connue RET
                    this.donneesSitproActiviteConnue(controle, donneesGenereesSitpro);
                    break;

                default:
                    //console.log("ERROR data.choixActivite, code inconnu :" + data.choixActivite);
                    break;
            }
        };

        //Génération Données Activité 'PRE'
        this.donneesSitproPRECumul = function (data, controle, donneesGenereesSitpro) {
            //console.log("****** Première activité : Pré-Retraité *******");

            // ********************************************************
            // *** Code activité cumulée                            ***
            // ********************************************************
            switch (data.choixActivite) {
                case ('SAL'):
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproSAL(data, controle, donneesGenereesSitpro);
                    break;

                case ('NSAL'):
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproNSAL(data, controle, donneesGenereesSitpro);
                    break; 

                case ('RET'):
                    // Injection + consigne SitPro32
                    donneesGenereesSitpro.injectionConsigneSitPro32 = true;
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproRET(data, controle, donneesGenereesSitpro);                    
                    break; 

                case ('APP'): 
                    // Injection + consigne SitPro32
                    donneesGenereesSitpro.injectionConsigneSitPro32 = true;
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproAPP(data, donneesGenereesSitpro);                    
                    break;  

                case ('CHO'):  
                    // Injection + consigne SitPro32
                    donneesGenereesSitpro.injectionConsigneSitPro32 = true;
                    // Avec les données de la nouvelle activité
                    // CHGT0000531 - Chomage Partiel - CPL
                    CnafCctSitproDonneesGenereesService.donneesSitproCHO(data, donneesGenereesSitpro, controle);                    
                    break;  

                case ('PENS'):
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproPENS(data, controle, donneesGenereesSitpro);                    
                    break;   

                case ('CONG'):
                    // Injection + consigne SitPro32
                    donneesGenereesSitpro.injectionConsigneSitPro32 = true;
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproCONG(data, controle, donneesGenereesSitpro);                    
                    break;

                case ('ETU'):
                    // Avec les données de l'activité connue PRE
                    this.donneesSitproActiviteConnue(controle, donneesGenereesSitpro);                   
                    break;                    

                case ('AUT'):                    
                    // Injection + consigne SitPro32
                    donneesGenereesSitpro.injectionConsigneSitPro32 = true;
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproAUT(data, controle, donneesGenereesSitpro); 
                    break;

                default:
                    //console.log("ERROR data.choixActivite, code inconnu :" + data.choixActivite);
                    break;
            }            
        };

        //Génération Données Activité 'RAT' ou 'INV'
        this.donneesSitproPENSCumul = function (data, controle, donneesGenereesSitpro) {
            //console.log("****** Première activité : Retraité *******");

            // ********************************************************
            // *** Code activité cumulée                            ***
            // ********************************************************
            switch (data.choixActivite) {
                case ('SAL'):
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproSAL(data, controle, donneesGenereesSitpro);
                    break;

                case ('NSAL'):
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproNSAL(data, controle, donneesGenereesSitpro);
                    break; 

                case ('RET'):
                    // Injection + consigne SitPro32
                    donneesGenereesSitpro.injectionConsigneSitPro32 = true;
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproRET(data, controle, donneesGenereesSitpro);                    
                    break; 

                case ('APP'): 
                    // Injection + consigne SitPro32
                    donneesGenereesSitpro.injectionConsigneSitPro32 = true;
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproAPP(data, donneesGenereesSitpro);                    
                    break;  

                case ('CHO'):  
                    // Injection + consigne SitPro32
                    donneesGenereesSitpro.injectionConsigneSitPro32 = true;
                    // Avec les données de la nouvelle activité
                    // CHGT0000531 - Chomage Partiel - CPL
                    CnafCctSitproDonneesGenereesService.donneesSitproCHO(data, donneesGenereesSitpro, controle);                   
                    break;  

                case ('PENS'):
                    // Injection + consigne SitPro32
                    donneesGenereesSitpro.injectionConsigneSitPro32 = true;
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproPENS(data, controle, donneesGenereesSitpro);                    
                    break;   

                case ('CONG'):
                    // Injection + consigne SitPro32
                    donneesGenereesSitpro.injectionConsigneSitPro32 = true;
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproCONG(data, controle, donneesGenereesSitpro);                    
                    break;

                case ('ETU'):
                    // Selon l'âge < 29 ans
                    if (controle.agesup29 === false)
                    {
                        // Avec les données de la nouvelle activité
                        CnafCctSitproDonneesGenereesService.donneesSitproETU(data, controle, donneesGenereesSitpro);
                    }
                    else
                    {
                        // Avec les données de l'activité connue RAT ou INV
                        this.donneesSitproActiviteConnue(controle, donneesGenereesSitpro); 
                    }
                    break;                    

                case ('AUT'):                    
                    // Injection + consigne SitPro32
                    donneesGenereesSitpro.injectionConsigneSitPro32 = true;
                    // Avec les données de la nouvelle activité
                    CnafCctSitproDonneesGenereesService.donneesSitproAUT(data, controle, donneesGenereesSitpro); 
                    break;

                default:
                    //console.log("ERROR data.choixActivite, code inconnu :" + data.choixActivite);
                    break;
            }             
        };   
        

        this.donneesSitproActiviteConnue = function (controle, donneesGenereesSitpro) {
            var activiteConnue = controle.personneEnCours.situationProfessionnelle;

            if (null !== activiteConnue)
            {
                donneesGenereesSitpro.codeActivite = activiteConnue.codeSituationProfessionnnelle; 
                donneesGenereesSitpro.caracteristiqueActivite = activiteConnue.codeCaracteristiqueActivite;
                // INC573324 : SITPRO cumul d'activité - si on garde activité CRISTAL, génération codePays et zonePays KO
                //  !!!!!!! subtibilité !!!!!!!!!!!!
                // lors de la saisie du SITPRO ces données ont été inversées, l'ordre est rétabli lors de l'appel à MBC
                //donneesGenereesSitpro.codePaysActivite = activiteConnue.codePaysActiviteCee;
                //donneesGenereesSitpro.zonePaysActivite = activiteConnue.paysActivite;   
                donneesGenereesSitpro.codePaysActivite = activiteConnue.paysActivite;
                donneesGenereesSitpro.zonePaysActivite = activiteConnue.codePaysActiviteCee;                      
                donneesGenereesSitpro.regimeCotisation =  activiteConnue.codeRegime;
                donneesGenereesSitpro.jusactdom = activiteConnue.codeJustificationActiviteDOM;
                donneesGenereesSitpro.dateDebActivite = CnafCctDateService.getDateFormatCristalToFormatEcran(activiteConnue.dateDebutSituationProfessionnnelle);
                controle.annuleControleDateCarCumulSpecif = true;
            }
        };

        // INC0604925 - APN le 04/01/2021 - génération code CHO avec dd = date saisie
         this.donneesSitproCHO = function (dateDebut, controle, donneesGenereesSitpro) {
            console.log ("CnafCctSitproDonneesGenereesCumulService - donneesSitproCHO avec dateDebut = " +dateDebut);
            donneesGenereesSitpro.codeActivite = "CHO"; 
            donneesGenereesSitpro.dateDebActivite = dateDebut;
            donneesGenereesSitpro.regimeCotisation = "GE";
            donneesGenereesSitpro.codePaysActivite = "FRA";
            donneesGenereesSitpro.zonePaysActivite = "FR";
            controle.annuleControleDateCarCumulSpecif = true;
           
        };

    }
})();

(function () {
    'use strict';

    angular
        .module('cnafComponentsTeleprocApp')
        .service('CnafCctSitproDonneesGenereesService', CnafCctSitproDonneesGenereesService);

        CnafCctSitproDonneesGenereesService.$inject = ['CctPaysCotisation',
                                                       'CnafCctSituationproService',
                                                       'CnafCctDateService'];

    function CnafCctSitproDonneesGenereesService(CctPaysCotisation,
                                                 CnafCctSituationproService,
                                                 CnafCctDateService) {

       /**
         * Fonction permettant de générer les données liées au sitpro en tenant compte
         * de la spécificité si venu via l'alerte
         */
        this.accueilDonneesSitpro = function (data, index, controle) {
            if (controle.autresalertes){
                // on vient de l'alerte, traitement spécifique si prolongation
                // uniquement pour CSS (congé sans solde), CAC (sans activité), MAL (maladie)
                if ((controle.personneEnCoursCodeAct === 'CSS' ||
                     controle.personneEnCoursCodeAct === 'CAC' ||
                     controle.personneEnCoursCodeAct === 'MAL' ||
                     controle.personneEnCoursCodeAct === 'CHO' ||
                     controle.personneEnCoursCodeAct === 'FDA' ||
                     controle.personneEnCoursCodeAct === 'FDN') &&
                     data.continueractivite == 'continueractiviteO'){
                    return this.donneesProlongSitpro(data, controle);
                } else {
                    return this.donneesSitpro(data, index, controle); 
                }
            } else {
                // saisie classique d'activité
                return this.donneesSitpro(data, index, controle);
            }
        };

        /**
         * Fonction permettant de générer les données liées au sitpro (prologation d'activité)
         * (contexte alerte)
         * uniquement pour CSS (congé sans solde), CAC (sans activité), MAL (maladie)
         * CHO, FDA et FDN (chômage)
         */
        this.donneesProlongSitpro = function (data, controle) {
            var donneesGenereesSitpro = {};
            //console.log("-------****------- données prolong sitpro générées -------****-------");
            //console.log("**code activité : "+ controle.personneEnCoursCodeAct);
            donneesGenereesSitpro.codePaysActivite = "FRA";
            donneesGenereesSitpro.zonePaysActivite = "FR";
            //console.log("codePaysActivite = " + donneesGenereesSitpro.codePaysActivite);
            //console.log("zonePaysActivite = " + donneesGenereesSitpro.zonePaysActivite);
        
            donneesGenereesSitpro.codeActivite = controle.personneEnCoursCodeAct;
            //console.log("codeActivite = " + donneesGenereesSitpro.codeActivite);
            
            // date activité
            donneesGenereesSitpro.dateDebActivite = controle.personneEnCoursDateSitproConnue;
            //console.log("dateDebActivite = " + donneesGenereesSitpro.dateDebActivite);

            if (controle.personneEnCoursCodeAct === 'CSS'){
                // date fin congé sans solde
                donneesGenereesSitpro.dateFinActivite = data.dateFinProlongConge;
                //console.log("dateFinActivite = " + donneesGenereesSitpro.dateFinActivite);
                data.dateFinActivite = donneesGenereesSitpro.dateFinActivite;
            }
            return donneesGenereesSitpro;

        };


        /**
         * Fonction permettant de générer les données liées au sitpro (saisie d'activité)
         *
         */
        this.donneesSitpro = function (data, index, controle) {

            var donneesGenereesSitpro = {};
            console.log("-------****------- données sitpro générées -------****-------");
            console.log("data.choixActivite : " + data.choixActivite);
            console.log("controle.typePers : " + controle.typePers);
            
            switch (data.choixActivite) {
                case ('SAL'):
                    this.donneesSitproSAL(data, controle, donneesGenereesSitpro);
                    break;
                case ('NSAL'):
                    this.donneesSitproNSAL(data, controle, donneesGenereesSitpro);
                    break;
                case ('ETU'):
                    this.donneesSitproETU(data, controle, donneesGenereesSitpro);
                    break;
                case ('RET'):
                    this.donneesSitproRET(data, controle, donneesGenereesSitpro);
                    break;
                case ('PENS'):
                    this.donneesSitproPENS(data, controle, donneesGenereesSitpro);
                    break;
                case ('CHO'):
                    // CHGT0000531 - Chomage Partiel - CPL
                    this.donneesSitproCHO(data, donneesGenereesSitpro, controle);
                    break;
                case ('CONG'):
                    this.donneesSitproCONG(data, controle, donneesGenereesSitpro);
                    break;
                case ('APP'):
                    this.donneesSitproAPP(data, donneesGenereesSitpro);
                    break;
                case ('AUT'):
                    this.donneesSitproAUT(data, controle, donneesGenereesSitpro);
                    break;

                default:
                    break;
            }

            //console.log ("donneesGenereesSitpro = ");
            //console.log (donneesGenereesSitpro);
            //console.log("-------****------- fin données sitpro générées -------****-------");
            
            return donneesGenereesSitpro;

        };

        //Génération Données Activité 'SAL'
        this.donneesSitproSAL = function (data, controle, donneesGenereesSitpro) {
            console.log("******En activité salariée*******");
            console.log(data);

            // ********************************************************
            // *** Code activité                                    ***
            // ********************************************************
            switch (data.choixActiviteSalariee.code) {
                case ('SAL'):
                case ('INT'):
                case ('VDS'):
                case ('INTER'):
                case ('SPEC'):
                case ('SAS'):
                case ('GERSAL'):
                case ('ASSFAM'):
                    donneesGenereesSitpro.codeActivite = 'SAL';
                    break;
                case ('ASSMAT'):
                    donneesGenereesSitpro.codeActivite = 'AMA';
                    break;
                case ('TSA'):
                    donneesGenereesSitpro.codeActivite = 'TSA';
                    break;
                case ('VRP'):
                    donneesGenereesSitpro.codeActivite = 'VRP';
                    break;
                case ('ESAT'):
                    donneesGenereesSitpro.codeActivite = 'CAT';
                    break;
                case ('EMMAUS'):
                    donneesGenereesSitpro.codeActivite = 'DNL';
                    break;
                default:
                    //console.log("ERROR data.choixActiviteSalariee.code inconnue code :" + data.choixActiviteSalariee.code);
                    break;
            }
            console.log("codeActivite = " + donneesGenereesSitpro.codeActivite);

            //Caractéristique activité
            //console.log("choixActiviteSalariee = " + data.choixActiviteSalariee.libelle);
            // Ajout assistant familial
            if (data.choixActiviteSalariee.code === 'INT') {
                donneesGenereesSitpro.caracteristiqueActivite = data.choixActiviteSalariee.code;
            } else if (data.choixActiviteSalariee.code === 'ASSFAM') {
                donneesGenereesSitpro.caracteristiqueActivite = 'AFL';
            }
            else {
                if (data.detacheFrance && data.detacheFrance === "Oui") {
                    donneesGenereesSitpro.caracteristiqueActivite = "DET";
                }
                else {
                    donneesGenereesSitpro.caracteristiqueActivite = "";
                }
            }
            console.log("caracteristiqueActivite = " + donneesGenereesSitpro.caracteristiqueActivite);

            // ********************************************************
            // *** Régime de cotisation                             ***
            // ********************************************************
            if (data.choixActiviteSalariee.code === 'SPEC' ||
            data.choixActiviteSalariee.code === 'ASSMAT' ||
            data.choixActiviteSalariee.code === 'TSA'){
                donneesGenereesSitpro.regimeCotisation = 'GE';
                // Pas de génération de code régime pour les codes ESAT, EMMAUS et INTER
            }
            if (data.cotisEmployeur){
                //RFC0018874 : Mayotte - sitpro régime cotisation CSSM
                if (data.cotisEmployeur.code === "UR" 
                || data.cotisEmployeur.code === "CS"){
                    donneesGenereesSitpro.regimeCotisation = "GE";
                }
                else if (data.cotisEmployeur.code === "AG"){
                    
                    donneesGenereesSitpro.regimeCotisation = "AG";
                    //COVID-19 : INC0570978 - RSL P5 CDS - Limitation nombre de mutation vers la MSA
                    // si la personne a choisi MSA alors
                    //     - si responsable dossier --> régimeCotisation = GE
                    //     - sinon --> régimeCotisation = AG
                    // INC0600571 - retour arrière OVID-19 : INC0570978 - RSL P5 CDS - Limitation nombre de mutation vers la MSA
                    /*if (controle.typePers === "RESP"){
                        donneesGenereesSitpro.regimeCotisation = "GE";
                    } else {
                        donneesGenereesSitpro.regimeCotisation = "AG";
                    }*/
                }

                // Activité salarié
                if  (!donneesGenereesSitpro.regimeCotisation
                && data.choixActiviteSalariee.code === 'SAL'
                && data.choixAutRegSal){
                    if (data.choixPosteFonct && data.choixPosteFonct !== 'AE') {
                        // On prend la donnée positionnée dans choixPosteFonct qui est égale à FP si DOM et GE sinon Métropole
                        donneesGenereesSitpro.regimeCotisation = data.choixPosteFonct.code;
//                        console.log("regimeCotisation -choixPosteFonct- = " + donneesGenereesSitpro.regimeCotisation);
                    }
                    else if (data.choixAutRegSal.code === 'AL') {
                        donneesGenereesSitpro.regimeCotisation = "AL";
                    }
                    else {
                        //US3.25-Autres Régimes
                        //"Si la personne est seule, on n’affiche rien de plus et on la considère comme étant en poste en France."
                        //Comme on ne pose pas la question sur la localisation du poste de Fonctionnaire (France/Etranger) pour une personne isolée,
                        //===> on la génère ici (comme si la personne était en poste en France)...
                        if (data.choixAutRegSal.code === 'FO' && !controle.encouple) {
                            if (controle.codepostal.substring(0, 3) === "971" || controle.codepostal.substring(0, 3) === "972" ||
                                controle.codepostal.substring(0, 3) === "973" || controle.codepostal.substring(0, 3) === "974" ||
                                controle.codepostal.substring(0, 3) === "976" || controle.grpAllocatairesMayotte) {
                                donneesGenereesSitpro.regimeCotisation = "FP";
                            }
                            else {
                                donneesGenereesSitpro.regimeCotisation = "GE";
                            }
//                          console.log("regimeCotisation -choixPosteFonct- isolé = " + donneesGenereesSitpro.regimeCotisation);
                        }
                    }
                }

                // Activité GERSAL
                if  (!donneesGenereesSitpro.regimeCotisation
                && data.choixActiviteSalariee.code === 'GERSAL'
                && data.cotisEmployeur.code === 'AR'){
                    donneesGenereesSitpro.regimeCotisation = "GE";
                }
//                console.log("regimeCotisation -cotisEmployeur- = "+donneesGenereesSitpro.regimeCotisation);

            }
            console.log("codeRegimeCotisationGenere  = " + donneesGenereesSitpro.regimeCotisation);

            // date activité
            donneesGenereesSitpro.dateDebActivite = data.dateActiviteSalarie;
//            console.log("dateDebActivite = " + donneesGenereesSitpro.dateDebActivite);

             // ********************************************************
            // *** Pays d'activité                                   ***
            // *********************************************************
            if (donneesGenereesSitpro.caracteristiqueActivite === "DET")
            {
              // code pays activité
              donneesGenereesSitpro.codePaysActivite = "FRA";
              // zone pays activité
              donneesGenereesSitpro.zonePaysActivite = "FR";

            } else if (data.choixActiviteSalariee.code === 'SAL'){
                if (data.paysCotisation) {
                    // Si un pays de cotisation est saisi, on récupère les données correspondantes dans le tableau
                    var trouve = false;
                    // initialisation par défaut
                    donneesGenereesSitpro.codePaysActivite = "AUT";
                    donneesGenereesSitpro.zonePaysActivite = "";
                    for (var i = 0; (i < CctPaysCotisation.PAYSCOTIS.length && !trouve); i++) {
                        var unPays = CctPaysCotisation.PAYSCOTIS[i];
                        //console.log("unPays.code = "+CctPaysCotisation.PAYSCOTIS[i].libelle);
                        //console.log("data.paysCotisation.libelle = "+data.paysCotisation.libelleCaffr);
                        if (unPays.libelle === data.paysCotisation.libelleCaffr) {
                            trouve = true;
                            donneesGenereesSitpro.codePaysActivite = unPays.pays;
                            donneesGenereesSitpro.zonePaysActivite = unPays.zoneActi;
                        }
                    }
                } else {
                    // code pays activité
                    donneesGenereesSitpro.codePaysActivite = "FRA";
                    // zone pays activité
                    donneesGenereesSitpro.zonePaysActivite = "FR";
                }
            } else {
              this.determinationZoneActivPaysCotis(data,donneesGenereesSitpro);
            }
            console.log("codePaysActivite = " + donneesGenereesSitpro.codePaysActivite);
            console.log("zonePaysActivite = " + donneesGenereesSitpro.zonePaysActivite);
        };

        //Génération Données Activité 'NSAL'
        this.donneesSitproNSAL = function (data, controle, donneesGenereesSitpro) {
            //console.log("******En activité non salariée*******");
            // ********************************************************
            // *** Code activité                                    ***
            // ********************************************************
            donneesGenereesSitpro.codeActivite = data.choixActiviteNonSalariee.code;
            // Travailleur indépendant :
            if (data.choixActiviteNonSalariee.code === 'INDEP'){
                if (data.rGerant.code === 'IR'){
                    donneesGenereesSitpro.codeActivite = 'ETI';
                } else { // IS
                    donneesGenereesSitpro.codeActivite = 'GSA';
                }
                
            }

            // Auto entrepreneur :
            if (data.choixActiviteNonSalariee.code === 'AUTOEN' ||
            // VDI non salarié :
            data.choixActiviteNonSalariee.code === 'VDINS' ||
            // Artiste :
            data.choixActiviteNonSalariee.code === 'ARTIST') {
                donneesGenereesSitpro.codeActivite = 'ETI';
            }

            if ( data.choixActiviteNonSalariee.code === 'ARTIST' ||
                  data.choixActiviteNonSalariee.code === 'VDINS')
            {
                //console.log(" activité VDI ou ARTIST : régime imposition (code) = " +data.regImpos.code);
            }



            // Artiste auteur imposé salaires :
            // VDI imposé salaires :
            if ( (data.choixActiviteNonSalariee.code === 'ARTIST' ||
                  data.choixActiviteNonSalariee.code === 'VDINS') &&
                    data.regImpos.code == 'T')
            {
              donneesGenereesSitpro.codeActivite = 'SAL';
            }


            // Exploitant Agricole et Mayotte :
            if (data.choixActiviteNonSalariee.code === 'EXP'
                && (controle.codepostal.substring(0, 3) === "976" || controle.grpAllocatairesMayotte)) {
                donneesGenereesSitpro.codeActivite = "ETI";
            }

            //COVID-19 : INC0570978 - RSL P5 CDS - Limitation nombre de mutation vers la MSA
            // si la personne a choisi MSA alors
            //     - si responsable dossier 
            //          si EXP avec droit RSA/PPA --> régimeCotisation = AG
            //          sinon  --> régimeCotisation = GE
            
            //COVID-19 : INC0572694: SITPRO EXP avec régime GE interdit, modifier de code EXP en ETI
            // INC0600571 - retour arriere COVID-19 : INC0570978 - RSL P5 CDS - Limitation nombre de mutation vers la MSA
            /*if (data.choixActiviteNonSalariee.code === 'EXP'
                && data.cotisEmployeur.code === "AG"
                && controle.typePers === "RESP" 
                && !controle.droitPPAEnCours 
                && !controle.droitRSAEnCours)
            {
                donneesGenereesSitpro.codeActivite = "ETI";
            }*/
            
            // Conjoint collaborateur :
            if (data.choixActiviteNonSalariee.code === 'CONJOIN') {
                // Spécif Mayotte :
                if (controle.codepostal.substring(0, 3) === "976" || controle.grpAllocatairesMayotte) {
                    donneesGenereesSitpro.codeActivite = 'ETI';
                // Spécif DOM hors Mayotte :
                } else if (controle.codepostal.substring(0, 3) === "971" || controle.codepostal.substring(0, 3) === "972" ||
                    controle.codepostal.substring(0, 3) === "973" || controle.codepostal.substring(0, 3) === "974" ) {
                    donneesGenereesSitpro.codeActivite = 'EXS';
                // Métropole :
                } else {
                    donneesGenereesSitpro.codeActivite = 'CJT';
                }
            }
            // INC0537508 - APN le 22/10/2019 - cotisant solidaire, suppression regime affiliation
            /*if (data.choixActiviteNonSalariee.code === 'COTIS') {
                if (data.regAffil.code === 'RG') {
                    donneesGenereesSitpro.codeActivite = "ETI";
                }
                else if (data.regAffil.code === 'RA') {
                    donneesGenereesSitpro.codeActivite = "GSA";
                }
            }*/
            if (data.choixActiviteNonSalariee.code === 'COTIS') {
                donneesGenereesSitpro.codeActivite = "ETI";
            }
            // Aide familiale agricole et Mayotte :
            if (data.choixActiviteNonSalariee.code === 'AFA'
                && (controle.codepostal.substring(0, 3) === "976" || controle.grpAllocatairesMayotte)) {
                donneesGenereesSitpro.codeActivite = "SAL";
            }

            //console.log("codeActivite = " + donneesGenereesSitpro.codeActivite);

            // ********************************************************
            // *** Régime de cotisation                             ***
            // ********************************************************
            if (data.choixActiviteNonSalariee.code !== 'INDEP') {
                 
                // Activité ETI et Mayotte :
                if (donneesGenereesSitpro.codeActivite === 'ETI'
                        && (controle.codepostal.substring(0, 3) === "976" || controle.grpAllocatairesMayotte)){
                    // SLT le 26/04/2019 - SAXO INC0498572 : pour Mayotte ne pas alimenter le code regime
                    donneesGenereesSitpro.regimeCotisation = "";
                }
                // Activité ETI et non Mayotte :
                else if (donneesGenereesSitpro.codeActivite === 'ETI'){
                    donneesGenereesSitpro.regimeCotisation = "GE";
                } else {
                    if (data.cotisEmployeur) {
                        donneesGenereesSitpro.regimeCotisation = data.cotisEmployeur.code;
                    }
                }
                
                // INC0537508 - APN le 22/10/2019 - cotisant solidaire, suppression regime affiliation 
                //if (data.cotisEmployeur.code === 'CG') { 
                if (data.choixActiviteNonSalariee.code !== 'COTIS' 
                    && (data.cotisEmployeur.code === 'CG' || data.cotisEmployeur.code === 'CS')){ 
                    // SLT le 26/04/2019 - SAXO INC0498572 : le code regime doit être à GE (ici on ne l'alimente pas il sera généré par MBC)
                    // Exploitant agricole ou Aide familial Agricole
                    if ((data.choixActiviteNonSalariee.code === 'EXP') ||
                        (data.choixActiviteNonSalariee.code === 'AFA')) {
                        donneesGenereesSitpro.regimeCotisation = "";
                    } else if (data.choixActiviteNonSalariee.code === 'ARTIST') {
                        donneesGenereesSitpro.regimeCotisation = "AA";
                    } else {
                        donneesGenereesSitpro.regimeCotisation = "GE";
                    }
                // Artiste :
                } else if (data.choixActiviteNonSalariee.code === 'ARTIST') {
                    donneesGenereesSitpro.regimeCotisation = "AA";
                }
                //RFC0018874 : Mayotte - sitpro régime cotisation CSSM

                // SLT le 18/11/2019 - SAXO INC0541690 Spécif DOM hors Mayotte - Alimentation du code regime à AG si activite AFA
                if ((data.choixActiviteNonSalariee.code === 'AFA') &&
                    (controle.codepostal.substring(0, 3) === "971" || controle.codepostal.substring(0, 3) === "972" ||
                        controle.codepostal.substring(0, 3) === "973" || controle.codepostal.substring(0, 3) === "974" ||
                        controle.grpAllocatairesDom))
                {
                    donneesGenereesSitpro.regimeCotisation = 'AG';
                }

                // Conjoint collaborateur :
                if (data.choixActiviteNonSalariee.code === 'CONJOIN') {
                    // Spécif DOM hors Mayotte :
                    if (controle.codepostal.substring(0, 3) === "971" || controle.codepostal.substring(0, 3) === "972" ||
                        controle.codepostal.substring(0, 3) === "973" || controle.codepostal.substring(0, 3) === "974") {
                        donneesGenereesSitpro.regimeCotisation = 'GE';
                    } 
                }

                if (donneesGenereesSitpro.regimeCotisation) {
                    donneesGenereesSitpro.regimeCotisation = this.generationCodeRegimeCotisationCristal(donneesGenereesSitpro.regimeCotisation);
                    
                }
                console.log("coderegimeCotisationCristal = " + donneesGenereesSitpro.regimeCotisation);
            }    
            
            

            // ********************************************************
            // *** Justificatif                                     ***
            // ********************************************************
            if (controle.codepostal.substring(0, 3) === "971" || controle.codepostal.substring(0, 3) === "972" ||
                controle.codepostal.substring(0, 3) === "973" || controle.codepostal.substring(0, 3) === "974" ||
                controle.codepostal.substring(0, 3) === "976" || controle.grpAllocatairesMayotte) {
//                console.log("data.choixActiviteNonSalariee.libelle = " + data.choixActiviteNonSalariee.libelle);

                if ((data.choixActiviteNonSalariee.code === 'EXP') ||
                    (data.choixActiviteNonSalariee.code === 'MAR') ||
                    (data.choixActiviteNonSalariee.code === 'AFA')) {
                    donneesGenereesSitpro.jusactdom = "J";
//                    console.log("jusactdom = " + donneesGenereesSitpro.jusactdom);
                }
            }

            // ********************************************************
            // *** Code caractéristique activité                    ***
            // ********************************************************

            // Auto entrepreneur :
            if (data.choixActiviteNonSalariee.code === 'AUTOEN') {
                donneesGenereesSitpro.caracteristiqueActivite = "AEN";
            }
            else {
                // VDI non salarié :
                if (data.choixActiviteNonSalariee.code === 'VDINS') {
                    if (data.regImpos.code === 'bicbnc') {
                        donneesGenereesSitpro.caracteristiqueActivite = "VDI";
                    }
                    else if (data.regImpos.code === 'microBIC') {
                        donneesGenereesSitpro.caracteristiqueActivite = "AEN";
                    }
                    else{
                        donneesGenereesSitpro.caracteristiqueActivite = "";
                    }
                }
                else {
                    // Artiste :
                    if (data.choixActiviteNonSalariee.code === 'ARTIST') {
                        if (data.regImpos.code === 'microBNC') {
                            donneesGenereesSitpro.caracteristiqueActivite = "AEN";
                        } else {
                            donneesGenereesSitpro.caracteristiqueActivite = "";
                        }
                    }
                    else {
                        // marin pêcheur :
                        if (data.choixActiviteNonSalariee.code === 'MAR') {
                            if (data.detacheFrance && data.detacheFrance === "Oui") {
                                donneesGenereesSitpro.caracteristiqueActivite = "DET";
                            }
                            else {
                                donneesGenereesSitpro.caracteristiqueActivite = "";
                            }
                        }
                    }       
                }
            }
            if (donneesGenereesSitpro.caracteristiqueActivite) {
               //console.log("caracteristiqueActivite = " + donneesGenereesSitpro.caracteristiqueActivite);
            }

            if (donneesGenereesSitpro.codeActivite === "ETI"
                  || donneesGenereesSitpro.codeActivite === "GSA"
               // || donneesGenereesSitpro.codeActivite === "MAR" INC0534012
                  || donneesGenereesSitpro.codeActivite === "CJT"
                  || donneesGenereesSitpro.codeActivite === "EXP"
                  //|| donneesGenereesSitpro.codeActivite === "AFA") INC0537274
                  || donneesGenereesSitpro.codeActivite === "AFA" 
                  || donneesGenereesSitpro.caracteristiqueActivite === "DET") 
           {
                // code pays activité
                donneesGenereesSitpro.codePaysActivite = "FRA";
                console.log("codePaysActivite = " + donneesGenereesSitpro.codePaysActivite);

                // zone pays activité
                donneesGenereesSitpro.zonePaysActivite = "FR";
                console.log("zonePaysActivite = " + donneesGenereesSitpro.zonePaysActivite);
           } else {
                this.determinationZoneActivPaysCotis(data, donneesGenereesSitpro);
           }

           // date activité
            donneesGenereesSitpro.dateDebActivite = data.dateActiviteNonSalarie;
            console.log("dateDebActivite = " + donneesGenereesSitpro.dateDebActivite);
        };


        //Génération Données Activité 'ETU'
        this.donneesSitproETU = function (data, controle, donneesGenereesSitpro) {
            //console.log("******Etudiant*******");
            // APN 22/07/2022 - RFC0014971 - L2211 possibilité étudiant hospitalier boursier
            if (data.boursier === 'Oui' & 
                (data.sitproetu.code === 'ETUNS' || data.sitproetu.code === 'ETS' || data.sitproetu.code === 'HOSP'))
            {
                donneesGenereesSitpro.caracteristiqueActivite = "BOU";
                console.log("caracteristiqueActivite = " + donneesGenereesSitpro.caracteristiqueActivite);
            }
            switch (data.sitproetu.code) {
                // Etudiant        
                case ('ETU'):
                    if (controle.agesup29) {
                        donneesGenereesSitpro.codeActivite = "ETU";
                    } else {
                        if (data.boursier === 'Oui') {
                            donneesGenereesSitpro.codeActivite = "EBO";
                        } else {
                            donneesGenereesSitpro.codeActivite = "ETU";
                        }
                    }
                    donneesGenereesSitpro.codePaysActivite = "FRA";
                    donneesGenereesSitpro.zonePaysActivite = "FR";

                    break;
                // Etudiant boursier
                case ('EBO'):
                    donneesGenereesSitpro.codeActivite = "EBO";
                    donneesGenereesSitpro.codePaysActivite = "FRA";
                    donneesGenereesSitpro.zonePaysActivite = "FR";

                    break;
                // Etudiant et activité non salariée
                case ('ETUNS'):
                    donneesGenereesSitpro.codeActivite = "ETS";
                    donneesGenereesSitpro.codePaysActivite = "FRA";
                    donneesGenereesSitpro.zonePaysActivite = "FR";

                    break;
                // Etudiant et activité salariée
                case ('ETS'):
                    donneesGenereesSitpro.codeActivite = "ETS";
                    this.determinationZoneActivPaysCotis(data, donneesGenereesSitpro);
                    break;
                // Etudiant hospitalier
                case ('HOSP'):
                    donneesGenereesSitpro.codeActivite = "ETS";
                    donneesGenereesSitpro.regimeCotisation = "GE";
                    console.log("codeActivite = " + donneesGenereesSitpro.codeActivite);
                    this.determinationZoneActivPaysCotis(data, donneesGenereesSitpro);
                    break;

                default:
                    break;
            }

            // date activité
            donneesGenereesSitpro.dateDebActivite = data.dateActiviteEtudiant;
//            console.log("dateDebActivite = " + donneesGenereesSitpro.dateDebActivite);
        };

        //Génération Données Activité 'RET'
        this.donneesSitproRET = function (data, controle, donneesGenereesSitpro) {
            //console.log("******En activité retraite*******");
            if (data.cesseActProRet === 'Oui') {
                donneesGenereesSitpro.codeActivite = "RET";
            } else {
                if (CnafCctSituationproService.activiteSalariee(controle.personneEnCoursCodeAct) ||
                    CnafCctSituationproService.professionNonSalariee(controle.personneEnCoursCodeAct)) {
                    donneesGenereesSitpro.codeActivite = controle.personneEnCoursCodeAct;
                } else {
                    donneesGenereesSitpro.codeActivite = "RET";
                }
            }

            // 12/2019 : INC0529257 - SitPro RET
            // Si moins de 62 ans, code activité = RSA
            if (controle.agesup62 == false && donneesGenereesSitpro.codeActivite === "RET") {
                donneesGenereesSitpro.codeActivite = "RSA";   
            }
            
//            console.log("codeActivite = " + donneesGenereesSitpro.codeActivite);
            if (data.cotisEmployeur) {
                //RFC0018874 : Mayotte - sitpro régime cotisation CSSM
                if (data.cotisEmployeur.code === 'CS'){
                    if (data.typePensionEtat === 'Oui'){
                        donneesGenereesSitpro.regimeCotisation = "FP";
                    } else {
                        donneesGenereesSitpro.regimeCotisation = "GE";
                    }
                    
                } else {
                    donneesGenereesSitpro.regimeCotisation = data.cotisEmployeur.code;
                    // console.log("regimeCotisation = " + donneesGenereesSitpro.regimeCotisation);
                    if (donneesGenereesSitpro.regimeCotisation) {
                        donneesGenereesSitpro.regimeCotisation = this.generationCodeRegimeCotisationCristal(donneesGenereesSitpro.regimeCotisation);
                    // console.log("coderegimeCotisationCristal = " + donneesGenereesSitpro.regimeCotisation);
                    }
                }
                
            }

            // code pays activité
            donneesGenereesSitpro.codePaysActivite = "FRA";
//            console.log("codePaysActivite = " + donneesGenereesSitpro.codePaysActivite);

            // zone pays activité
            donneesGenereesSitpro.zonePaysActivite = "FR";
//            console.log("zonePaysActivite = " + donneesGenereesSitpro.zonePaysActivite);

            // date activité
            donneesGenereesSitpro.dateDebActivite = data.dateActiviteRetraite;
//            console.log("dateDebActivite = " + donneesGenereesSitpro.dateDebActivite);
        };

        //Génération Données Activité 'PENS'
        this.donneesSitproPENS = function (data, controle, donneesGenereesSitpro) {
          //console.log("******En activité invalidité*******");
          if (data.cesseActProPens === 'Oui'){
              if (data.invalRente === 'inval')
              {
                  donneesGenereesSitpro.codeActivite = "INV"; //Pension d’invalidité
              }
              else {
                  donneesGenereesSitpro.codeActivite = "RAT"; //Rente accident du travail
              }
           } else {
               if (CnafCctSituationproService.activiteSalariee(controle.personneEnCoursCodeAct) ||
                  CnafCctSituationproService.professionNonSalariee(controle.personneEnCoursCodeAct) ){
                    donneesGenereesSitpro.codeActivite = controle.personneEnCoursCodeAct;
              } else {
                  if (data.invalRente === 'inval')
                  {
                      donneesGenereesSitpro.codeActivite = "INV"; //Pension d’invalidité
                  }
                  else {
                      donneesGenereesSitpro.codeActivite = "RAT"; //Rente accident du travail
                  }
              }
          }


//        console.log("codeActivite = " + donneesGenereesSitpro.codeActivite);

        if (data.cotisEmployeur) {
            // RFC0018874
            if (data.cotisEmployeur.code === 'CS' && data.cesseActProPens === 'Oui' ){
                if (data.typePensionEtat === 'Oui'){
                    donneesGenereesSitpro.regimeCotisation = "FP";
                } else {
                    donneesGenereesSitpro.regimeCotisation = "GE";
                }
               
            } else {
                donneesGenereesSitpro.regimeCotisation = data.cotisEmployeur.code;
            //  console.log("regimeCotisation = " + donneesGenereesSitpro.regimeCotisation);
                if (donneesGenereesSitpro.regimeCotisation) {
                    donneesGenereesSitpro.regimeCotisation = this.generationCodeRegimeCotisationCristal(donneesGenereesSitpro.regimeCotisation);
            //      console.log("coderegimeCotisationCristal = " + donneesGenereesSitpro.regimeCotisation);
                }
            }
            
        }

        donneesGenereesSitpro.codePaysActivite = "FRA";
//        console.log("codePaysActivite = " + donneesGenereesSitpro.codePaysActivite);

        donneesGenereesSitpro.zonePaysActivite = "FR";
//        console.log("zonePaysActivite = " + donneesGenereesSitpro.zonePaysActivite);

        // date activité
        donneesGenereesSitpro.dateDebActivite = data.dateActiviteInvalide;
//        console.log("dateDebActivite = " + donneesGenereesSitpro.dateDebActivite);
    };


    //Génération Données Activité 'CHO'
    // CHGT0000531 - Chomage Partiel - CPL
    this.donneesSitproCHO = function (data, donneesGenereesSitpro, controle) {
        console.log("******Chômage indemnisé ou non*******");
        var dateDemarche = controle.datedemarche
        console.log("datedemarche = "+CnafCctDateService.ddmmyyyy(dateDemarche));
        console.log("data.chomagePartiel = "+data.chomagePartiel);
        
        // CHGT0000531 - Chomage Partiel - CPL
        //Sélection activité chômage partiel
        donneesGenereesSitpro.sortieCPL = null;
        if (data.chomagePartiel){

            var dernierJourMMoins3 = new Date(dateDemarche);
            dernierJourMMoins3.addMonths(-3); 
            var dernierJour = CnafCctDateService.getLastDay(CnafCctDateService.ddmmyyyy(dernierJourMMoins3));
            dernierJourMMoins3.setDate(dernierJour);
            console.log("dernierJourMMoins3 = "+CnafCctDateService.ddmmyyyy(dernierJourMMoins3));

            var dernierJourMMoins2 = new Date(dateDemarche);
            dernierJourMMoins2.addMonths(-2); 
            dernierJour = CnafCctDateService.getLastDay(CnafCctDateService.ddmmyyyy(dernierJourMMoins2));
            dernierJourMMoins2.setDate(dernierJour);
            console.log("dernierJourMMoins2 = "+CnafCctDateService.ddmmyyyy(dernierJourMMoins2));

            console.log("debutActivite = "+data.dateActiviteChomage);

            // code activité
            donneesGenereesSitpro.codeActivite = "CPL";
            // date activité
            donneesGenereesSitpro.dateDebActivite = data.dateActiviteChomage;
            // moisEnCours (pour Trafic)
            donneesGenereesSitpro.moisEnCoursChomagePartiel = CnafCctDateService.getLitteralMonth(dateDemarche);
            console.log("moisEnCoursChomagePartiel = "+ donneesGenereesSitpro.moisEnCoursChomagePartiel);

            // RFC000775 - CPL sitpro AMA et CAT rendent ineligible au cpl
            if (controle.personneEnCoursCodeAct === "AMA" || controle.personneEnCoursCodeAct === "CAT") {
                 //  --> sortie avec message "Votre situation ne permet pas de déclarer cette situation"  
                   donneesGenereesSitpro.sortieCPL = "CPL_INELIGIBLE_PAR_SITUATION";


            // Si date début > dernierJourM-3
            } else if (CnafCctDateService.isDateStrictementSuperieure(data.dateActiviteChomage, CnafCctDateService.ddmmyyyy(dernierJourMMoins3))){
                // si  date début > dernierJourM-2
                if (CnafCctDateService.isDateStrictementSuperieure(data.dateActiviteChomage, CnafCctDateService.ddmmyyyy(dernierJourMMoins2))){
                    //  --> sortie avec message "Vous devez attendre au moins deux mois avant de déclarer votre situation de chômage partiel à la Caf.
                   //  Merci de revenir ultérieurement si vous êtes toujours dans cette situation."  
                   donneesGenereesSitpro.sortieCPL = "DECLARATIONANTICIPEE";
                   console.log("--> déclaration anticipée");
                } else {
                    // date début <= dernierJourM-2
                    //  Si le cumul heures M-2+M-1 < à 40 ou un mois saisi à zéro
                    var heureMMois1 = parseInt(data.heuresCPL[0].heures);
                    var heureMMois2 = parseInt(data.heuresCPL[1].heures);
                    console.log("heureMMois1 = "+heureMMois1);
                    console.log("heureMMois2 = "+heureMMois2);
                    var cumul = heureMMois1 + heureMMois2;
                    console.log("cumul = "+cumul);
                    if (cumul < 40 || heureMMois1 < 1 || heureMMois2 < 1){
                        // --> sortie avec message "Les heures déclarées ne sont pas suffisantes pour 
                        // que la Caf prenne en compte votre situation.
                        // Merci de revenir ultérieurement pour faire votre déclaration si vous êtes toujours au chômage partiel le mois prochain." 
                        donneesGenereesSitpro.sortieCPL = "HEURESINSUFFISANTES";
                        console.log("--> cumul d'heures insuffisant ou mois saisi à zéro");
                     } else {
                        console.log("data.toujoursChomagePartiel = "+data.toujoursChomagePartiel);
                         //  Si Oui répondu à la question "êtes vous toujours au chômage partiel ce mois ?" 
                         if (data.toujoursChomagePartiel){
                             // date de fin = dernierJourM
                             var dernierJourM = new Date(dateDemarche);
                             dernierJour = CnafCctDateService.getLastDay(CnafCctDateService.ddmmyyyy(dernierJourM));
                             dernierJourM.setDate(dernierJour);
                             donneesGenereesSitpro.dateFinActivite = CnafCctDateService.ddmmyyyy(dernierJourM);
                            
                         } else {
                             // date de fin  = dernierJourM-1
                             var dernierJourMMoins1 = new Date(dateDemarche);
                             dernierJourMMoins1.addMonths(-1); 
                             dernierJour = CnafCctDateService.getLastDay(CnafCctDateService.ddmmyyyy(dernierJourMMoins1));
                             dernierJourMMoins1.setDate(dernierJour);
                             donneesGenereesSitpro.dateFinActivite = CnafCctDateService.ddmmyyyy(dernierJourMMoins1);
                         }
                         console.log("dateFinActivite = " + donneesGenereesSitpro.dateFinActivite); 
                     }
                }

            } else {
                // Bon de travail  
                // code activité
                donneesGenereesSitpro.codeActivite = "CPL";
                // date activité
                donneesGenereesSitpro.dateDebActivite = data.dateActiviteChomage;
            }

        }
        else {
            // code activité
            donneesGenereesSitpro.codeActivite = "CHO";
            // date activité
            donneesGenereesSitpro.dateDebActivite = data.dateActiviteChomage;
            
        }
        donneesGenereesSitpro.regimeCotisation = "GE";
        donneesGenereesSitpro.codePaysActivite = "FRA";
        donneesGenereesSitpro.zonePaysActivite = "FR";
        console.log("codeActivite = " + donneesGenereesSitpro.codeActivite);
        console.log("dateDebActivite = " + donneesGenereesSitpro.dateDebActivite);
        console.log("regimeCotisation = " + donneesGenereesSitpro.regimeCotisation);
        console.log("codePaysActivite = " + donneesGenereesSitpro.codePaysActivite);
        console.log("zonePaysActivite = " + donneesGenereesSitpro.zonePaysActivite);
       
    };

    //Génération Données Activité 'CONG'
    this.donneesSitproCONG = function (data, controle, donneesGenereesSitpro) {
        //console.log("******Congés Divers*******");

        if (data.choixCongesDivers.code === 'MAT') {
            donneesGenereesSitpro.codeActivite = "MAT";
        }
        else if (data.choixCongesDivers.code === 'DIVERS') {
            donneesGenereesSitpro.codeActivite = "CCV";
        }
        else if (data.choixCongesDivers.code === 'PARENT' ||
            data.choixCongesDivers.code === 'SSOLDE') {
            donneesGenereesSitpro.codeActivite = "CSS";
        }
        else if (data.choixCongesDivers.code === 'SAB') {
            donneesGenereesSitpro.codeActivite = "SAB";
        }
//        console.log("codeActivite = " + donneesGenereesSitpro.codeActivite);

        // Si code différent de MAT
        // on va chercher le code régime de l'activité actuelle.
        if (data.choixCongesDivers.code === 'MAT') {
          donneesGenereesSitpro.regimeCotisation = data.cotisEmployeur.code;
        }

//        console.log("regimeCotisation = " + donneesGenereesSitpro.regimeCotisation);
        if (data.cotisEmployeur.code === 'CS'){
            donneesGenereesSitpro.regimeCotisation = "GE";
        } else if (donneesGenereesSitpro.regimeCotisation) {
            donneesGenereesSitpro.regimeCotisation = this.generationCodeRegimeCotisationCristal(donneesGenereesSitpro.regimeCotisation);
//            console.log("coderegimeCotisationCristal = " + donneesGenereesSitpro.regimeCotisation);
        }

        donneesGenereesSitpro.codePaysActivite = "FRA";
//        console.log("codePaysActivite = " + donneesGenereesSitpro.codePaysActivite);

        donneesGenereesSitpro.zonePaysActivite = "FR";
//        console.log("zonePaysActivite = " + donneesGenereesSitpro.zonePaysActivite);

        // date activité
        donneesGenereesSitpro.dateDebActivite = data.dateActiviteConges;
//        console.log("dateDebActivite = " + donneesGenereesSitpro.dateDebActivite);
    };

    //Génération Données Activité 'APP'
    this.donneesSitproAPP = function (data, donneesGenereesSitpro) {
        console.log("******En activité Stagiaire - Apprenti - En alternance*******");
        //console.log(data);
        switch (data.choixStagiaire.code) {
            case ('STAGE'):
                donneesGenereesSitpro.regimeCotisation = "GE";
//               console.log("regimeCotisation = " + donneesGenereesSitpro.regimeCotisation);
                //console.log("isEtu = " +data.isEtu+"-boursier = " +data.boursier);
                if (data.isEtu && data.isEtu === 'Oui'){
                    if (data.boursier && data.boursier === 'Oui') {
                        donneesGenereesSitpro.codeActivite = "EBO";
                    } else {
                        donneesGenereesSitpro.codeActivite = "ETU";
                    }
                } else if (data.indemnise) {
                    if (data.regimeIndemnisation.code === 'PE'){
                      donneesGenereesSitpro.codeActivite = "CHO";
                    } else { // employeur ou autre
                        donneesGenereesSitpro.codeActivite = "SFP";
                    }
//                    console.log("codeActivite = " + donneesGenereesSitpro.codeActivite);
                } else {
                    donneesGenereesSitpro.codeActivite = "SNR";
//                    console.log("codeActivite = " + donneesGenereesSitpro.codeActivite);
                }
                //console.log("codeActivite = " + donneesGenereesSitpro.codeActivite);
                break;
            case ('APP'):
                donneesGenereesSitpro.codeActivite = "APP";
//                console.log("codeActivite = " + donneesGenereesSitpro.codeActivite);
                if (data.cotisEmployeur.code === 'CS'){
                    donneesGenereesSitpro.regimeCotisation = "GE"
                } else {    
                    donneesGenereesSitpro.regimeCotisation = data.cotisEmployeur.code;
                }
//                console.log("regimeCotisation = " + donneesGenereesSitpro.regimeCotisation);
                break;
            case ('CONTRAT'):
                donneesGenereesSitpro.codeActivite = "SAL";
//                console.log("codeActivite = " + donneesGenereesSitpro.codeActivite);
                if (data.cotisEmployeur.code === 'CS'){
                    donneesGenereesSitpro.regimeCotisation = "GE"
                } else {    
                    donneesGenereesSitpro.regimeCotisation = data.cotisEmployeur.code;
                }
//                console.log("regimeCotisation = " + donneesGenereesSitpro.regimeCotisation);
                break;

            default:
                break;
        }
        // COVID-19 : INC0570978 - RSL P5 CDS - Limitation nombre de mutation vers la MSA
        // si la personne a choisi MSA alors
        //     - si responsable dossier --> régimeCotisation = GE
        //     - sinon --> régimeCotisation = AG
        // INC0600571 - retour arriere COVID-19 : INC0570978 - RSL P5 CDS - Limitation nombre de mutation vers la MSA
       if (donneesGenereesSitpro.regimeCotisation) {
            donneesGenereesSitpro.regimeCotisation = this.generationCodeRegimeCotisationCristal(donneesGenereesSitpro.regimeCotisation);
          //  console.log("coderegimeCotisationCristal = " + donneesGenereesSitpro.regimeCotisation);
              
        }
        //INC0581006 : IT sur sitpro stagiaire suite evos pour limitation mutation
        //if (data.cotisEmployeur.code === "AG"){
        /*if (data.cotisEmployeur && data.cotisEmployeur.code === "AG"){  
            if (controle.typePers === "RESP"){
                donneesGenereesSitpro.regimeCotisation = "GE";
            } else {
                donneesGenereesSitpro.regimeCotisation = "AG";
        } else {
            if (donneesGenereesSitpro.regimeCotisation) {
                donneesGenereesSitpro.regimeCotisation = this.generationCodeRegimeCotisationCristal(donneesGenereesSitpro.regimeCotisation);
                //console.log("coderegimeCotisationCristal = " + donneesGenereesSitpro.regimeCotisation);
                  
             }
        }*/
       
        

        if (donneesGenereesSitpro.codeActivite === "APP"
              || donneesGenereesSitpro.codeActivite === "SAL"
              || donneesGenereesSitpro.codeActivite === "SNR"
              || donneesGenereesSitpro.codeActivite === "SFP"
              || donneesGenereesSitpro.codeActivite === "CHO")
       {
            // code pays activité
            donneesGenereesSitpro.codePaysActivite = "FRA";
//            console.log("codePaysActivite = " + donneesGenereesSitpro.codePaysActivite);

            // zone pays activité
            donneesGenereesSitpro.zonePaysActivite = "FR";
//            console.log("zonePaysActivite = " + donneesGenereesSitpro.zonePaysActivite);
       } else {
            this.determinationZoneActivPaysCotis(data, donneesGenereesSitpro);
       }

        // date activité
        if (data.choixStagiaire.code === 'STAGE')
        {
          donneesGenereesSitpro.dateDebActivite = data.dateActiviteStagiaire;
        }
        else {
          donneesGenereesSitpro.dateDebActivite = data.dateActiviteApprenti;
        }
//        console.log("dateDebActivite = " + donneesGenereesSitpro.dateDebActivite);
    };

    //Génération Données Activité 'AUT'
    this.donneesSitproAUT = function (data, controle, donneesGenereesSitpro) {
        //console.log("******Autre situation*******");
        donneesGenereesSitpro.codePaysActivite = "FRA";
        donneesGenereesSitpro.zonePaysActivite = "FR";
//        console.log("codePaysActivite = " + donneesGenereesSitpro.codePaysActivite);
//        console.log("zonePaysActivite = " + donneesGenereesSitpro.zonePaysActivite);

        //console.log("choixAutreSituation = " + data.choixAutreSituation.id);
        switch (data.choixAutreSituation.id) {
            // sans activité
            case ('SSA'):
                if (data.poleEmploi === 'Non') {
                    if (CnafCctSituationproService.presenceDroitUniqueAAHEnCours(data)) {
                        donneesGenereesSitpro.codeActivite = "SAC";
                    } else {
                        if (CnafCctSituationproService.presenceEnfAutMoinsTroisAnsDateActi(controle.personnes, data.dateActiviteAutreSitu)) {
                            donneesGenereesSitpro.codeActivite = "CAC";
                        } else {
                            donneesGenereesSitpro.codeActivite = "SSA";
                        }
                    }
                } else {
                    if (data.droitAAHEnCours) {
                        donneesGenereesSitpro.codeActivite = "HAN";
                    } else {
                        donneesGenereesSitpro.codeActivite = "CHO";
                    }
                }
//                console.log("codeActivite = " + donneesGenereesSitpro.codeActivite);
                break;
            // Arret Maladie
            case ('MAL'):
                if (data.affectionLongueDuree === 'Oui') {
                    donneesGenereesSitpro.codeActivite = "MLD";
                }
                else {
                    donneesGenereesSitpro.codeActivite = "MAL";
                }
//                console.log("codeActivite = " + donneesGenereesSitpro.codeActivite);
                break;
            //  membre organisation communautaire
            case ('MOC'):
                // INC0538952 : ajout d'une question "exerce une activité professionnelle"
                // en fonction le code activité n'est pas le même !
                if (data.exerceActPro === 'Oui') {
                    donneesGenereesSitpro.codeActivite = "MOA";
                }
                else {
                    donneesGenereesSitpro.codeActivite = "MOC";
                }                

//                console.log("codeActivite = " + donneesGenereesSitpro.codeActivite);
                break;
            // détention
            case ('DETENU'):
                donneesGenereesSitpro.codeActivite = "ABS";
//                console.log("codeActivite = " + donneesGenereesSitpro.codeActivite);
                break;
            // Volontariat
            case ('VOL'):
//                console.log("choixAutreSituationVolontariat = " + data.choixAutreSituationVolontariat.id);
                switch (data.choixAutreSituationVolontariat.id) {
                    // service civique
                    case ('CIVIC'):
                        donneesGenereesSitpro.codeActivite = "SSA";
                        break;
                    //  volontaire dans les armées
                    case ('ARMEE'):
                        donneesGenereesSitpro.codeActivite = "SAL";
                        donneesGenereesSitpro.regimeCotisation = "GE";
//                        console.log("regimeCotisation = " + donneesGenereesSitpro.regimeCotisation);
                        break;
                    // sapeur pompier volontaire
                    case ('SAPEUR'):
                        donneesGenereesSitpro.codeActivite = "SNR";
                        break;
                    // volontariat international
                    case ('VINTER'):
                        donneesGenereesSitpro.codeActivite = "SNR";
                        break;
                    // volontaire pour insersion
                    case ('VINSER'):
                        donneesGenereesSitpro.codeActivite = "SNR";
                        break;
                    // volontaire civil
                    case ('VCIVIL'):
                        donneesGenereesSitpro.codeActivite = "SNR";
                        break;
                    // service militaire adapté
                    case ('SMADAP'):
                        donneesGenereesSitpro.codeActivite = "SNR";
                        break;
                }
//                console.log("codeActivite = " + donneesGenereesSitpro.codeActivite);
                break;
            // aidant familial percevant un dédomagement
            case ('AIDANT'):
                if (CnafCctSituationproService.presenceEnfAutMoinsTroisAnsDateActi(controle.personnes, data.dateActiviteAutreSitu)) {
                    donneesGenereesSitpro.codeActivite = "CAC";
                } else {
                    donneesGenereesSitpro.codeActivite = "SSA";
                }
//                console.log("codeActivite = " + donneesGenereesSitpro.codeActivite);
                break;
            // bénéficiaire de la garantie jeune
            case ('JEUNE'):
                donneesGenereesSitpro.codeActivite = "SSA";
//                console.log("codeActivite = " + donneesGenereesSitpro.codeActivite);
                break;
            default:
                break;
        }

        if (donneesGenereesSitpro.codeActivite === "ABS"
              || donneesGenereesSitpro.codeActivite === "MOA"
              || donneesGenereesSitpro.codeActivite === "MAL"
              || donneesGenereesSitpro.codeActivite === "MLD"
              || donneesGenereesSitpro.codeActivite === "SA")
       {
            // code pays activité
            donneesGenereesSitpro.codePaysActivite = "FRA";
//            console.log("codePaysActivite = " + donneesGenereesSitpro.codePaysActivite);

            // zone pays activité
            donneesGenereesSitpro.zonePaysActivite = "FR";
//            console.log("zonePaysActivite = " + donneesGenereesSitpro.zonePaysActivite);
       } else {
            this.determinationZoneActivPaysCotis(data, donneesGenereesSitpro);
       }

        // date activité
        donneesGenereesSitpro.dateDebActivite = data.dateActiviteAutreSitu;
//        console.log("dateDebActivite = " + donneesGenereesSitpro.dateDebActivite);
    };



    // détermination zone activité/pays cotisation
    this.determinationZoneActivPaysCotis = function (data, donneesGenereesSitpro) {
        // Si le régime de cotisation est Urssaf, MSA, Cgss ou autre régime
        // Si le régime de cotisation n’est pas demandé (cas des assistants maternels et des intérimaires)
        // alors on définit les 2 données suivantes :
        //-	La donnée [code pays d’activité] à enregistrer dans le SI est « FRA »
        //-	La donnée [code zone d’activité] à enregistrer dans le SI est « FR ».
        if ((data.cotisEmployeur && data.cotisEmployeur.code !== 'RE') || !data.cotisEmployeur) {
            donneesGenereesSitpro.codePaysActivite = "FRA";
            donneesGenereesSitpro.zonePaysActivite = "FR";
        } else {
            // Si un pays de cotisation est saisi, on récupère les données correspondantes dans le tableau
            var trouve = false;
            // initialisation par défaut
            donneesGenereesSitpro.codePaysActivite = "AUT";
            donneesGenereesSitpro.zonePaysActivite = "";
            for (var i = 0; (i < CctPaysCotisation.PAYSCOTIS.length && !trouve); i++) {
                var unPays = CctPaysCotisation.PAYSCOTIS[i];
//                console.log("unPays.code = "+CctPaysCotisation.PAYSCOTIS[i].libelle);
//                console.log("data.paysCotisation.libelle = "+data.paysCotisation.libelleCaffr);
                if (unPays.libelle === data.paysCotisation.libelleCaffr) {
                    trouve = true;
                    donneesGenereesSitpro.codePaysActivite = unPays.pays;
                    donneesGenereesSitpro.zonePaysActivite = unPays.zoneActi;
                }
            }
        }
//        console.log("codePaysActivite = " + donneesGenereesSitpro.codePaysActivite);
//        console.log("zonePaysActivite = " + donneesGenereesSitpro.zonePaysActivite);
    };

    // détermination zone activité/pays cotisation
    this.generationCodeRegimeCotisationCristal = function (codeRegimeSaisi) {
        var codeRegimeCristal = codeRegimeSaisi;
        // Les codes suivants correspondent au Régime général définit dans Cristal (GE)
        if (codeRegimeCristal === 'CP'      // CPAM
            || codeRegimeCristal === 'CG'   // CGSS
            || codeRegimeCristal === 'UR'   // URSSAF
            || codeRegimeCristal === 'UI'   // URSSAF / SSI
        ) {

            codeRegimeCristal = 'GE';
        }
        // Les codes suivants ne sont pas référencés dans Cristal
        else if (codeRegimeCristal === 'AR'      // Autre Regime
            || codeRegimeCristal === 'RE'   // Regime Etranger
            || codeRegimeCristal === 'AU'   // Autre
        ) {

            codeRegimeCristal = '';
        }
        return codeRegimeCristal;
    };
}
})();

(function() {
    'use strict';

    angular.module('cnafComponentsTeleprocApp').service('CnafCctSituationproControleDateService', CnafCctSituationproControleDateService);

    CnafCctSituationproControleDateService.$inject = ['CnafCctSituationproDateService'];

    function CnafCctSituationproControleDateService(CnafCctSituationproDateService) {
        //Fonction de contrôle
        //Contrôle si la date de début d'activité est postérieure à la date de naissance
        this.controleInfDateNaissance = function(date, dateNaissance) {
            var valueControle = true;
            if (date && date.length >= 10) {
                //console.log("controleInfDateNaissance avec date = "+date+" dateNaissance = "+dateNaissance);
                var dateATester = Date.parseExact(date, 'd/M/yyyy');
                var dateNaiss = Date.parseExact(dateNaissance, 'd/M/yyyy');
                if (dateATester && 'Invalid Date' != dateATester) {
                    if (dateATester < dateNaiss) {
                        valueControle = false;
                    }
                }
            }
            return valueControle;
        };

        //US3.24-Méthode controleSupDateOd conservée ici seulement pour 'Etudiant' (Révision prévue dans une future US)
        //===> Méthode à supprimer ensuite...
        //-------------------------------------------------------------------------------------------------------------
        //Contrôle si la date de début d'activité est postérieure au dernier jour du mois d'od
        this.controleSupDateOd = function(date, dernjourodal, index) {
            var valueControle = true;
            if (index === 0 && date && date.length >= 10) {
                //console.log('controleSupDateOd avec date = ' + date + ' dernjourodal = ' + dernjourodal);
                var dateATester = Date.parseExact(date, 'd/M/yyyy');
                if (dateATester && 'Invalid Date' != dateATester) {
                    if (dateATester > dernjourodal) {
                        valueControle = false;
                    }
                }
            }
            return valueControle;
        };
        //--------------------------------------------------------------------------------------------------------------

        this.controleSupDernJourMoisSuivDem = function(date, dernJourMoisSuivDem, index) {
            var valueControle = true;
            if (index === 0 && date && date.length >= 10) {
                //console.log('controleSupDernJourMoisSuivDem avec date saisie = ' + date + ' et dernJourMoisSuivDem = ' + dernJourMoisSuivDem);
                var dateATester = Date.parseExact(date, 'd/M/yyyy');
                if (dateATester && 'Invalid Date' != dateATester) {
                    if (dateATester > dernJourMoisSuivDem) {
                        valueControle = false;
                    }
                }
            }
            return valueControle;
        };

        //US3.24-Nouveau Contrôle sur la date de début d'activité <= date activité connue
        this.controlerDateSitPro = function(date, index, dateSitproConnue) {
            var valueControle = true;
            if (index === 0 && date && date.length >= 10) {
                console.log('controlerDateSitPro avec date saisie = ' + date + ' et dateSitproConnue = ' + dateSitproConnue);
                var dateATester = Date.parseExact(date, 'd/M/yyyy');
                if (dateATester && 'Invalid Date' != dateATester) {
                    if (dateATester <= dateSitproConnue) {
                        valueControle = false;
                    }
                }
            }
            return valueControle;
        };

        this.controleDateSup = function(dateDebut, dateFin) {
            var bValeur = true;

            if (dateDebut && dateFin) {
                if (CnafCctSituationproDateService.parseDate(dateFin).getTime() <= CnafCctSituationproDateService.parseDate(dateDebut).getTime()) {
                    bValeur =  false;
                } 
            }
            return bValeur;
        };

        this.controleDateSupOuEgale = function(date1, date2) {
            var bValeur = true;

            if (date1 && date2) {
                if (CnafCctSituationproDateService.parseDate(date2).getTime() < CnafCctSituationproDateService.parseDate(date1).getTime()) {
                    bValeur =  false;
                }
            }
            return bValeur;
        };

        //INC0723285 : Contexte arrivée de conjoint - Ajout controle entre date début sitpro qui doit être < date Sitfam couple
        this.controleDateSitProSitfamCouple = function(date, controle, index) {
            var valueControle = true;
            console.log('controlerDateSitProSitfamCouple avec Contexte saisie = ' + controle.contexte);
            if ( controle.contexte === 'arriveeRetourCjt'
                    &&  (index === 0 && date && date.length >= 10) ) {
                console.log('controlerDateSitProSitfamCouple avec date sitpro saisie = ' + date + ' et dateSitfam = ' + controle.dateSitfam);
                var dateSitpro = Date.parseExact(date, 'd/M/yyyy');
                var dateSitfam = Date.parseExact(controle.dateSitfam, 'd/M/yyyy');
                if (dateSitpro && 'Invalid Date' != dateSitpro) {
                    console.log('controlerDateSitProSitfamCouple 1er test');
                    if (dateSitfam <= dateSitpro) {
                        console.log('controlerDateSitProSitfamCouple avec valueControle à false');
                        valueControle = false;
                    }
                }
            }
            console.log('controlerDateSitProSitfamCouple avec valueControle = ' + valueControle);
            return valueControle;
        };


    }
})();

(function() {
    'use strict';

    angular.module('cnafComponentsTeleprocApp').service('CnafCctSituationproDateService', CnafCctSituationproDateService);

    CnafCctSituationproDateService.$inject = [];

    function CnafCctSituationproDateService() {
        //Récupère le dernier jour du mois, prends le mois suivant et récupère le jour "0" qui
        //correspond au jour précédant le mois suivant, on est donc sur le dernier jour du mois
        this.getLastDay = function(date) {
            if (date) {
                date = this.parseDate(date);
                if (date instanceof Date) {
                    date = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                    date.setDate(date.getDate() + 1);
                    return date.getUTCDate();
                }
            }
        };

        //Récupère le jour actuel
        this.getCurrentDay = function(date) {
            if (date) {
                date = new Date(this.parseDate(date));
                if (date instanceof Date) {
                    date.setDate(date.getDate() + 1);
                    return date.getUTCDate();
                }
            }
        };

        this.parseDate = function(dateString) {
            if (dateString && dateString.length >= 8) {
                var dateTime = dateString.split('/');
                if (dateTime.length === 3) {
                    var jour = dateTime[0];
                    var mois = dateTime[1];
                    var annee = dateTime[2];
                    var temp = mois + '/' + jour + '/' + annee;
                    return new Date(temp);
                }
            }
        };

        this.getLitteralMonth = function(date) {
            var litteralMonth;
            if (date) {
                var monthNames = [
                    'janvier',
                    'février',
                    'mars',
                    'avril',
                    'mai',
                    'juin',
                    'juillet',
                    'août',
                    'septembre',
                    'octobre',
                    'novembre',
                    'décembre'
                ];
                litteralMonth = monthNames[date.getMonth()];
            }
            return litteralMonth;
        };

        /* Permet de formatter la date dans le html */
        this.ddmmyyyy = function(date) {
            var mm = date.getMonth() + 1;
            var dd = date.getDate();
            dd = dd < 10 ? '0' + dd : dd;
            mm = mm < 10 ? '0' + mm : mm;
            return [dd, mm, date.getFullYear()].join('/');
        };

        /**
         * Indique si age est bien strictement supérieur à dateDemarche - dateNaissance
         * @deprecated utiliser la méthode dans CnafCctDateService
         */
        this.isAgeSupAXX = function(age, dateNaissance, dateDemarche) {
            if (dateNaissance !== undefined) {
                var dateNaisPlusXX =  Date.parseExact(dateNaissance, "dd/MM/yyyy");
                dateNaisPlusXX.add({years:age});
                //console.log ("dateNaisPlusXX = "+dateNaisPlusXX+" dateDemarche = "+dateDemarche);
                return dateDemarche > dateNaisPlusXX;
            }
        };

        //INC0723285 : Contexte arrivée de conjoint - Ajout controle entre date début sitpro qui doit être < date Sitfam couple
        this.controleDateSitProSitfamCouple = function(date, controle, index) {
            var valueControle = true;
            console.log('controlerDateSitProSitfamCouple avec Ccontexte saisie = ' + controle.contexte);
            if ( controle.contexte === 'arriveeRetourCjt'
                    &&  (index === 0 && date && date.length >= 10) ) {
                console.log('controlerDateSitProSitfamCouple avec date sitpro saisie = ' + date + ' et dateSitfam = ' + controle.dateSitfam);
                var dateATester = Date.parseExact(date, 'd/M/yyyy');
                if (dateATester && 'Invalid Date' != dateATester) {
                    if (dateATester >= controle.dateSitfam) {
                        valueControle = false;
                    }
                }
            }
            return valueControle;
        };

    }
})();

(function() {
    'use strict';

    angular.module('cnafComponentsTeleprocApp').service('CnafCctSituationproService', CnafCctSituationproService);

    CnafCctSituationproService.$inject = ['CNAFCOMMONSAPP_CONFIG', '$resource', '$filter','CnafUserService','CnafCctSituationproDateService'];

    function CnafCctSituationproService(CNAFCOMMONSAPP_CONFIG, $resource, $filter,CnafUserService,CnafCctSituationproDateService) {
        var resourceActions = angular.extend({}, CNAFCOMMONSAPP_CONFIG.resourceActions);
        var infosDossierUrl = '/api/sitprofront/v1/infosDossier';
        var rechDroitsEnCoursUrl = '/api/sitprofront/v1/listedroitsencours';
        var changementSitproUrl = '/api/sitprofront/v1/changement_sitpro/';

        this.infosDossier = function() {
            return $resource(infosDossierUrl, null, resourceActions);
        };

        this.rechDroitsEnCours = function() {
            return $resource(rechDroitsEnCoursUrl, null, resourceActions);
        };

        this.changementSitpro = function() {
            return $resource(changementSitproUrl, null, resourceActions);
        };

        this.afficheBouton = function(pers) {
            var bAffiche = false;
            var codeActivite = pers.codeAct;
            //console.log('afficheBouton : code activite = ' + codeActivite);
            if (
                this.activiteSalariee(codeActivite) ||
                this.professionNonSalariee(codeActivite) ||
                this.chomage(codeActivite) ||
                codeActivite === 'PRE' ||
                codeActivite === 'RET' ||
                codeActivite === 'INV' ||
                codeActivite === 'RAT'
            ) {
                bAffiche = true;
            }

            //console.log('afficheBouton = ' + bAffiche);
            return bAffiche;
        };

        this.afficheBoutonContinuerActivite = function(pers) {
            var bAffiche = false;
            var codeActivite = pers.codeAct;
            //console.log('afficheBoutonContinuerActivite : code activite = ' + codeActivite);
            if (
                codeActivite === 'CSS' ||
                codeActivite === 'CAC' ||
                codeActivite === 'MAL' ||
                codeActivite === 'CHO' ||
                codeActivite === 'FDA' ||
                codeActivite === 'FDN'
            ) {
                bAffiche = true; 
            }

            //console.log('afficheBoutonContinuerActivite = ' + bAffiche);
            return bAffiche;
        };

        this.presenceDateFin = function(dateFin) {
            var bPresence = false;
            if (dateFin !== undefined && dateFin !== null
            ) {
                var dateTravail = CnafCctSituationproDateService.ddmmyyyy(new Date(dateFin));
                //console.log('presenceDateFin : date fin activite = ' + dateTravail);
                if (dateTravail !== "31/12/9999") {
                    bPresence = true;
                }
                
            }

            //console.log('presenceDateFin = ' + bPresence);
            return bPresence;
        };


        this.activiteSalariee = function(act) {
            var activiteSalariee = false;
            if (
                act === 'SAL' ||
                act === 'CAT' ||
                act === 'DNL' ||
                act === 'RAC' ||
                act === 'CGP' ||
                act === 'AMA' ||
                act === 'VRP' ||
                act === 'TSA' ||
                act === 'INT' ||
                act === 'CIA' ||
                act === 'CIS' ||
                act === 'RMA'
            ) {
                activiteSalariee = true;
            }
            //console.log('activiteSalariee ' + activiteSalariee);
            return activiteSalariee;
        };

        this.professionNonSalariee = function(act) {
            var professionNonSalariee = false;
            if (act === 'CJT' || act === 'ETI' || act === 'GRS' || act === 'AFA' || act === 'EXP' || act === 'MAR' || act === 'EXS' || act === 'GSA') {
                professionNonSalariee = true;
            }
            //console.log('professionNonSalariee ' + professionNonSalariee);
            return professionNonSalariee;
        };

        this.sansActivite = function(act) {
            var sansActivite = false;
            if (act === 'CSS' || act === 'SAB' || act === 'CCV' || act === 'CAC' || act === 'HAN' || act === 'SAC' || act === 'SAV' || act === 'SSA') {
                sansActivite = true;
            }
            //console.log('sansActivite ' + sansActivite);
            return sansActivite;
        };

        // INC0604925 - APN le 04/01/2021 - ajout codes activités pour situation de type chomage
        // si situation connue synonyme de chômage (ADA,CDA, FDA, ADN, AFC, AIN, ASP, ASS, CAR, CHO, FDN)
        this.chomage = function(act) {
            var chomage = false;
            //if (act === 'ADA' || act === 'ADN' || act === 'AIN' || act === 'ASS' || act === 'CAR' || act === 'CHO') {
            if (act === 'ADA' || act === 'CDA' ||  act === 'FDA' || act === 'ADN' || act === 'AFC' || act === 'AIN' 
                || act === 'ASP' ||  act === 'ASS' || act === 'CAR' || act === 'CHO' || act === 'FDN' ) {    
                chomage = true;
            }
            //console.log('chomage ' + chomage);
            return chomage;
        };

        this.etudiant = function(act) {
            var etudiant = false;
            if (act === 'ETU' || act === 'ETS' || act === 'EBO') {
                etudiant = true;
            }
            //console.log('etudiant ' + etudiant);
            return etudiant;
        };

        // absence enfant ?
        this.presenceEnfant = function(personnes) {
            if (personnes !== undefined) {
                return $filter('filter')(personnes, { type: 'ENF' }, true).length > 0;
            } else {
                return false;
            }
        };

        // absence autre personne ?
        this.presenceAutrePers = function(personnes) {
            if (personnes !== undefined) {
                return $filter('filter')(personnes, { type: 'AUT' }, true).length > 0;
            } else {
                return false;
            }
        };

        this.presenceEnfAutMoinsTroisAnsDateActi = function(personnes, dateActi) {

            var isPresenceEnfAutMoinsTroisAnsDateActi = false;
            var indice = 0;
            var enfants;
            if (this.presenceEnfant(personnes)) {
                enfants = $filter('filter')(personnes, {
                    type: 'ENF'
                });
                while (indice < enfants.length && !isPresenceEnfAutMoinsTroisAnsDateActi) {
                    //console.log('enfants[indice].dateNaissance = ' + enfants[indice].dateNaissance);
                    if (this.isAgeInfAXX(3, enfants[indice].dateNaissance, dateActi)) {
                        isPresenceEnfAutMoinsTroisAnsDateActi = true;
                    }
                    indice++;
                }
            }
            if (!isPresenceEnfAutMoinsTroisAnsDateActi) {
                var aut;
                if (this.presenceAutrePers(personnes)) {
                    aut = $filter('filter')(personnes, {
                        type: 'AUT'
                    });
                    while (indice < aut.length && !isPresenceEnfAutMoinsTroisAnsDateActi) {
                        if (this.isAgeInfAXX(3, aut[indice].dateNaissance, dateActi)) {
                            isPresenceEnfAutMoinsTroisAnsDateActi = true;
                        }
                        indice++;
                    }
                }
            }
            //console.log('isPresenceEnfAutMoinsTroisAnsDateActi = ' + isPresenceEnfAutMoinsTroisAnsDateActi);
            return isPresenceEnfAutMoinsTroisAnsDateActi;
        };

        this.isAgeInfAXX = function(age, dateNaissance, dateActi) {
            if (dateNaissance != undefined) {
                var dateNaisPlusXX = new Date(dateNaissance);
                var dateDebutActivite = new Date(dateActi);
                dateNaisPlusXX.add({ years: age });
                if (dateDebutActivite < dateNaisPlusXX) {
                    //console.log('isAgeInfAXX = true');
                    return true;
                } else {
                    //console.log('isAgeInfAXX = false');
                    return false;
                }
            }
        };

        this.presenceDroitUniqueAAHEnCours = function(data) {
            var isPresenceDroitUniqueAAHEnCours = false;
            if (
                data.droitAAHEnCours &&
                !data.droitALEnCours &&
                !data.droitPFEnCours &&
                !data.droitPPAEnCours &&
                !data.droitRSAEnCours &&
                !data.droitCMGEnCours
            ) {
                isPresenceDroitUniqueAAHEnCours = true;
            }
            //console.log('isPresenceDroitUniqueAAHEnCours = ' + isPresenceDroitUniqueAAHEnCours);
            return isPresenceDroitUniqueAAHEnCours;
        };

        this.libelleActiCumul = function(data) {
            var libelle = '';
            var debutLibelle = 'est en plus ';
            switch (data.choixActivite) {
            case 'SAL':
                libelle = debutLibelle + data.choixActiviteSalariee.libelle.toLowerCase();

                if (data.choixActiviteSalariee && data.choixActiviteSalariee.code === 'VRP') {
                    libelle = debutLibelle + data.choixActiviteSalariee.libelle + ' (Voyageur Représentant Placier)';
                }

                break;

            case 'NSAL':
                libelle = debutLibelle + data.choixActiviteNonSalariee.libelle.toLowerCase() ;
                break;

            case 'ETU':
                libelle = debutLibelle + data.sitproetu.libelle.toLowerCase();
                break;

            case 'APP':
                libelle = debutLibelle + data.choixStagiaire.libelle.toLowerCase();
                break;

            case 'CHO':
                libelle = debutLibelle + 'au chômage'+(data.chomagePartiel ? ' partiel' : '');//CHGT0000531 - Chomage Partiel - CPL
                break;

            case 'RET':
                libelle = debutLibelle + 'en retraite ou en pré-retraite';
                break;

            case 'PENS':
                if (data.invalRente === 'inval') {
                    libelle = "perçoit en plus une pension d'invalidité";
                } else {
                    libelle = 'perçoit en plus une rente accident du travail';
                }
                break;

            case 'CONG':
                libelle = debutLibelle + 'en ' + data.choixCongesDivers.libelle.toLowerCase() ;
                break;

            case 'AUT':
                libelle = debutLibelle + data.choixAutreSituation.libelle.toLowerCase();
                // Cas volontariat
                if ('VOL' === data.choixAutreSituation.code) {
                    libelle = debutLibelle + data.choixAutreSituationVolontariat.libelle.toLowerCase();
                }
                break;

            default:
                break;
            }
            // RFC0015737 : profil AAH - taux activité
            if (data.profilAvecAAH){
                if (data.activitePartielAah){
                    libelle = libelle + ' à temps partiel.';
                }else {
                    libelle = libelle + ' à temps complet.';
                }
                
            } else {
                libelle = libelle + '.';
            }
            return libelle;
        };

        this.changementSituation = function(dataSaisieSitPro) {
            return $resource(changementSitproUrl, null, resourceActions);
        };

        this.afficheLibelleMutationMSA = function (dataSitpro) {
            var bValeur =  false;

            // Attention les caf DOM gère les exp
            if (dataSitpro.droitPPAEnCours &&
                this.isMetropole(CnafUserService.codeOrga()) &&
                dataSitpro.sitPros[0].choixActiviteNonSalariee &&
                dataSitpro.sitPros[0].choixActiviteNonSalariee.code == 'EXP' &&
                dataSitpro.sitPros[0].cotisEmployeur.code == 'AG') {
                bValeur = true;
            } 

            return bValeur;
        };

        //COVID-19 : INC0570978 - RSL P5 CDS - Limitation nombre de mutation vers la MSA
        // INC0600571 - retour arrière COVID-19 : INC0570978 - RSL P5 CDS - Limitation nombre de mutation vers la MSA
        /*this.afficheLibelleSuspensionMutationMSA = function (dataSitpro) {
            console.log("-*-*-*-afficheLibelleSuspensionMutationMSA");
            console.log(dataSitpro);
            if (dataSitpro.typePers === "RESP" &&
                dataSitpro.sitPros[0].cotisEmployeur &&
                dataSitpro.sitPros[0].cotisEmployeur.code === "AG" && 
                dataSitpro.regimeCotisation === "GE") {
                return true;
            } else {
                return false;
            }
        };*/


        // Indique suivant le code organisme si la caf actuelle est en métropole ou non
        this.isMetropole = function (codeOrga) {
            var isMetropole = true;
            //on prend le code organise
            var sCodeATester = codeOrga;

            // Si le code  ne commence pas par 971, 972, 973, 974 ou 976
            // alors on applique les règles de la métropole
            if (
                sCodeATester &&
                (sCodeATester.substring(0, 3) === "971" ||
                    sCodeATester.substring(0, 3) === "972" ||
                    sCodeATester.substring(0, 3) === "973" ||
                    sCodeATester.substring(0, 3) === "974" ||
                    sCodeATester.substring(0, 3) === "976")
            ) {
                isMetropole = false;
            }

            return isMetropole;
            
        };

        //RFC0018874 : Mayotte - sitpro régime cotisation CSSM
        // Indique suivant le code organisme si la caf actuelle est Mayotte
        this.isMayotte = function (codeOrga) {
            var isMayotte = false;
            //on prend le code organise
            var sCodeATester = codeOrga;

            // Si le code  ne commence pas par 971, 972, 973, 974 ou 976
            // alors on applique les règles de la métropole
            if (
                sCodeATester &&
                   sCodeATester.substring(0, 3) === "976"
            ) {
                isMayotte = true;
            }
            console.log("isMayotte = "+isMayotte)
            return isMayotte;
            
        };

        // CHGT0000531 - Chomage Partiel - CPL
        // alimentation des nombre d'heures/mois saisis pour le chômage partiel
        this.donneesSitproCPLPourDTO = function(dataSaisieSitpro) {
            var retour = [];
            var n = dataSaisieSitpro.heuresCPL.length;
    
            for(var i=0; i<n;++i){
                var heuresMois = dataSaisieSitpro.heuresCPL[i];
                var infos = {};
                infos.moisCPL = heuresMois.mois
                infos.nbHeuresCPL = heuresMois.heures;
                retour.push(infos);
            }
            
            return retour;
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('cnafComponentsTeleprocApp')
        .service('CnafCctTelephoneService', CnafCctTelephoneService);

        CnafCctTelephoneService.$inject = [];



    function CnafCctTelephoneService() {


        this.affichageTelephoneAvecBlanc = function(telephone) {
            var telephoneAvecBlanc = "";
            if (telephone && telephone!=="")
            {
                  // Décomposition du téléphopne
                  var regExp = new RegExp("^([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2}).*$", "g");

                  if (regExp.test(telephone))
                  {
                      telephoneAvecBlanc = RegExp.$1+" "+RegExp.$2+" "+RegExp.$3+" "+RegExp.$4+" "+RegExp.$5;                 }
            }
            return telephoneAvecBlanc;
        };
    }
})();

(function () {
  'use strict';

  angular
    .module('cnafComponentsTeleprocApp')
    .service('CnafCctTokenService', CnafCctTokenService);
  /* Services */

  CnafCctTokenService.$inject = ['CnafTokenService', 'CnafUserService'];

  function CnafCctTokenService(CnafTokenService, CnafUserService) {
    
    /**
     * récupérer les role à partir du token
     */
    this.getDecodeToken = function () {

      var token = CnafUserService.tokenJWT;
      if (token) {
        var decodedToken = CnafTokenService.decodeToken(token);
        if(decodedToken) {
          return decodedToken.roles[0];
        }
        return null;
      }


    }
  }
})();

(function () {
	'use strict';

	/**
	 * @ngdoc service
	 * @name cnafComponentsTeleprocApp.service:CnafCctGestionTypeService
	 *
	 * @description
	 * Service de controles des différentes typologie de données (idem WTI)
	 *
	 */

	angular
		.module('cnafComponentsTeleprocApp')
		.service('CnafCctGestionTypeService', CnafCctGestionTypeService);

	CnafCctGestionTypeService.$inject = ['CnafCctConstantMsgTypes', 'CnafCctUtilsTypesService'];

	function CnafCctGestionTypeService(CnafCctConstantMsgTypes, CnafCctUtilsTypesService) {

		/**
		 * @ngdoc method
		 * @name appelControleType1
		 * @methodOf cnafComponentsTeleprocApp.service:CnafCctGestionTypeService
		 * @param {string} donnee mèl
		  * @param {string} formDonnee nom de la donnée dans le formulaire
		 * @return {string} mèl ou null si erreur
		 * @description
		 * Méthode d'appel des contrôles de format du mèl et l'absence de caractères non autorisés
		 * si erreur, positionne le message d'erreur, l'attribut $setValidity à false et renvoie null
		 * sinon, positionne l'attribut $setValidity à true et renvoie le mèl
		 */
		this.appelControleType1 = function (donnee, formDonnee) {
			//console.log("appelcontroleType1 avec " + donnee + " form " + formDonnee);
			var retourControlesTypes = this.controleType1(donnee);
			if (retourControlesTypes === CnafCctConstantMsgTypes.MESSAGE_TYPE1_CID_BLQ_ME01 || retourControlesTypes === CnafCctConstantMsgTypes.MESSAGE_TYPE1_CID_BLQ_ME02) {
				formDonnee.invalidmsg = retourControlesTypes;
				formDonnee.$setValidity('type1', false);
				return null;
			} else if (null !== retourControlesTypes) {
				formDonnee.$setValidity('type1', true);
				return retourControlesTypes;
			}
		};

		/**
		 * @ngdoc method
		 * @name controleType1
		 * @methodOf cnafComponentsTeleprocApp.service:CnafCctGestionTypeService
		 * @param {string} donnee mèl
		 * @return {string} mèl ou message d'erreur
		 * @description
		 * Vérifie le format du mèl et l'absence de caractères non autorisés
		 * Retourne mèl ou message d'erreur
		 */
		this.controleType1 = function (donnee) {
			if (donnee !== null && donnee !== undefined) {
				if (CnafCctUtilsTypesService.isType1FormatRespecte(donnee)) {
					// Format respecté
					if (!CnafCctUtilsTypesService.isType1AbsenceCaracteresNonAutorises(donnee)) {
						// Présence de caractères non autorisés
						// Message : L’adresse courriel contient des caractères non autorisés."
						return CnafCctConstantMsgTypes.MESSAGE_TYPE1_CID_BLQ_ME02;
					}
				}
				else {
					// Format non respecté
					// Message : "Le format de l'adresse courriel n'est pas valide."
					return CnafCctConstantMsgTypes.MESSAGE_TYPE1_CID_BLQ_ME01;
				}
			}
			return donnee;
		};


		/**
		 * @ngdoc method
		 * @name appelControleType2
		 * @methodOf cnafComponentsTeleprocApp.service:CnafCctGestionTypeService
		 * @param {string} donnee téléphone
		 * @param {string} formDonnee nom de la donnée dans le formulaire
		 * @return {string} téléphone ou null si erreur
		 * @description
		 * Méthode d'appel des contrôles de format du téléphone
		 * si erreur, positionne le message d'erreur, l'attribut $setValidity à false et renvoie null
		 * sinon, positionne l'attribut $setValidity à true et renvoie le mèl
		 */
		this.appelControleType2 = function (donnee, formDonnee) {
			//console.log("appelcontroleType2 avec " + donnee + " form " + formDonnee);
			var retourControlesTypes = this.controleType2(donnee);
			if (retourControlesTypes === CnafCctConstantMsgTypes.MESSAGE_TYPE1_CID_BLQ_ME03) {
				formDonnee.invalidmsg = retourControlesTypes;
				formDonnee.$setValidity('type2', false);
				return null;
			} else if (null !== retourControlesTypes) {
				formDonnee.$setValidity('type2', true);
				return retourControlesTypes;
			}
		};

		/**
		 * @ngdoc method
		 * @name controleType2
		 * @methodOf cnafComponentsTeleprocApp.service:CnafCctGestionTypeService
		 * @param {string} donnee téléphone
		 * @return {string} téléphone ou message d'erreur
		 * @description
		 * Vérifie le format du télphone
		 * Retourne téléphone ou message d'erreur
		 */
		this.controleType2 = function (donnee) {
			if (donnee !== null && donnee !== undefined) {
				if (!CnafCctUtilsTypesService.isType2FormatTelValide(donnee)) {
					// Format non respecté
					// Message : "Le numéro de téléphone est incorrect."
					return CnafCctConstantMsgTypes.MESSAGE_TYPE1_CID_BLQ_ME03;
				}
			}
			return donnee;
		};


		/**
		 * @ngdoc method
		 * @name appelControleType3
		 * @methodOf cnafComponentsTeleprocApp.service:CnafCctGestionTypeService
		 * @param {string} donnee noms de personnes, prénom père, mère, pays
			* @param {string} formDonnee nom de la donnée dans le formulaire
		 * @return {string} donnée modifiée ou null si erreur
		 * @description
		 * Méthode d'appel des contrôles de format des noms de personnes, prénom père, mère, pays
		 * si erreur, positionne le message d'erreur, l'attribut $setValidity à false et renvoie null
		 * sinon, positionne l'attribut $setValidity à true et renvoie la donnée modifiée
		 */
		this.appelControleType3 = function (donnee, formDonnee) {
			//console.log("appelcontroleType3 avec " + donnee + " form " + formDonnee);
			var retourControlesTypes = this.controleType3(donnee);
			if (retourControlesTypes === CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_CAR_NON_AUTORISE_ME04 ||
			   retourControlesTypes === CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_SAISIE_INCORRECTE_ME05) {
				formDonnee.invalidmsg = retourControlesTypes;
				formDonnee.$setValidity('type3', false);
				return null;
			} else if (null !== retourControlesTypes) {
				formDonnee.$setValidity('type3', true);
				return retourControlesTypes;
			}
		};

		/**
		 * @ngdoc method
		 * @name controleType3
		 * @methodOf cnafComponentsTeleprocApp.service:CnafCctGestionTypeService
		 * @param {string} donnee noms de personnes, prénom père, mère, pays
		 * @return {string} donnée modifiée ou message d'erreur
		 * @description
		 * Vérifie le format des noms de personnes, prénom père, mère, pays, l'absence de caractères non autorisés
		 * et fait la conversion en majuscules non accentuées
		 * Retourne donnée modifiée ou message d'erreur
		 */
		this.controleType3 = function (donnee) {
			//console.log("controleType3 avec " + donnee);
			if (donnee !== null && donnee !== undefined) {
				if (CnafCctUtilsTypesService.isType3AbsenceCaracteresNonAutorises(donnee)) {
					var donneeModifie = CnafCctUtilsTypesService.convertirType3SupprimeBlanc(donnee);

					if (CnafCctUtilsTypesService.isType3ControleOK(donneeModifie)) {
						// Contrôle OK
						donneeModifie = CnafCctUtilsTypesService.convertirType3EnMajusculeSansAccent(donneeModifie);
						// Sauvegarde de la donnée modifiée
						return donneeModifie;
					}
					else {
						// Contrôle KO
						return CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_SAISIE_INCORRECTE_ME05;
					}

				}
				else {
					// Présence de caractères non autorisés
					return CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_CAR_NON_AUTORISE_ME04;
				}
			}
			return null;
		};


		/**
		 * @ngdoc method
		 * @name appelControleType4
		 * @methodOf cnafComponentsTeleprocApp.service:CnafCctGestionTypeService
		 * @param {string} donnee prénoms allocataire, conjoint, enfants
			* @param {string} formDonnee nom de la donnée dans le formulaire
		 * @return {string} donnée modifiée ou null si erreur
		 * @description
		 * Méthode d'appel des contrôles de format des prénoms allocataire, conjoint, enfants
		 * si erreur, positionne le message d'erreur, l'attribut $setValidity à false et renvoie null
		 * sinon, positionne l'attribut $setValidity à true et renvoie la donnée modifiée
		 */
		this.appelControleType4 = function (donnee, formDonnee) {
			//console.log("appelcontroleType4 avec " + donnee + " form " + formDonnee);
			var retourControlesTypes = this.controleType4(donnee);
			if (retourControlesTypes === CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_CAR_NON_AUTORISE_ME04 ||
			   retourControlesTypes === CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_SAISIE_INCORRECTE_ME05) {
				formDonnee.invalidmsg = retourControlesTypes;
				formDonnee.$setValidity('type4', false);
				return null;
			} else if (null !== retourControlesTypes) {
				formDonnee.$setValidity('type4', true);
				return retourControlesTypes;
			}
		};

		/**
		 * @ngdoc method
		 * @name controleType4
		 * @methodOf cnafComponentsTeleprocApp.service:CnafCctGestionTypeService
		 * @param {string} donnee prénoms allocataire, conjoint, enfants
		 * @return {string} donnée modifiée ou message d'erreur
		 * @description
		 * Vérifie le format des prénoms allocataire, conjoint, enfants, l'absence de caractères non autorisés
		 * et fait la conversion en majuscules non accentuées
		 * Retourne donnée modifiée ou message d'erreur
		 */
		this.controleType4 = function (donnee) {
			if (donnee !== null && donnee !== undefined) {
				if (CnafCctUtilsTypesService.isType4AbsenceCaracteresNonAutorises(donnee)) {
					var tabDonneeModifie = [];
					tabDonneeModifie = CnafCctUtilsTypesService.convertirType4EnTableauAvecSuppressionBlanc(donnee);

					if (CnafCctUtilsTypesService.isType4ControleOK(tabDonneeModifie)) {
						// Contrôle OK
						var donneeModifie = CnafCctUtilsTypesService.convertirType4EnMajusculeSansAccentAvecConcatenation(tabDonneeModifie);
						// Sauvegarde de la donnée modifiée
						return donneeModifie;
					}
					else {
						// Contrôle KO
						return CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_SAISIE_INCORRECTE_ME05;
					}

				}
				else {
					// Présence de caractères non autorisés
					return CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_CAR_NON_AUTORISE_ME04;
				}
			}
			return null;
		};


		/**
		 * @ngdoc method
		 * @name appelControleType5
		 * @methodOf cnafComponentsTeleprocApp.service:CnafCctGestionTypeService
		 * @param {string} donnee localité, ville
			* @param {string} formDonnee nom de la donnée dans le formulaire
		 * @return {string} donnée modifiée ou null si erreur
		 * @description
		 * Méthode d'appel des contrôles de format de la localité, ville
		 * si erreur, positionne le message d'erreur, l'attribut $setValidity à false et renvoie null
		 * sinon, positionne l'attribut $setValidity à true et renvoie la donnée modifiée
		 */
		this.appelControleType5 = function (donnee, formDonnee) {
			//console.log("appelcontroleType5 avec " + donnee + " form " + formDonnee);
			var retourControlesTypes = this.controleType5(donnee);
			if (retourControlesTypes === CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_CAR_NON_AUTORISE_ME04 ||
			   retourControlesTypes === CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_SAISIE_INCORRECTE_ME05) {
				formDonnee.invalidmsg = retourControlesTypes;
				formDonnee.$setValidity('type5', false);
				return null;
			} else if (null !== retourControlesTypes) {
				formDonnee.$setValidity('type5', true);
				return retourControlesTypes;
			}
		};

		/**
		 * @ngdoc method
		 * @name controleType5
		 * @methodOf cnafComponentsTeleprocApp.service:CnafCctGestionTypeService
		 * @param {string} donnee localité, ville
		 * @return {string} donnée modifiée ou message d'erreur
		 * @description
		 * Vérifie le format de la localité, ville, l'absence de caractères non autorisés
		 * et fait la conversion en majuscules non accentuées
		 * Retourne donnée modifiée ou message d'erreur
		 */
		this.controleType5 = function (donnee) {
			if (donnee !== null && donnee !== undefined) {
				if (CnafCctUtilsTypesService.isType5AbsenceCaracteresNonAutorises(donnee)) {
					var donneeModifie = CnafCctUtilsTypesService.convertirType5SupprimeBlanc(donnee);

					if (CnafCctUtilsTypesService.isType5ControleOK(donneeModifie, false)) {
						// Contrôle OK
						donneeModifie = CnafCctUtilsTypesService.convertirType5EnMajusculeSansAccent(donneeModifie);
						// Sauvegarde de la donnée modifiée
						return donneeModifie;
					}
					else {
						// Contrôle KO
						return CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_SAISIE_INCORRECTE_ME05;
					}
				}
				else {
					// Présence de caractères non autorisés
					return CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_CAR_NON_AUTORISE_ME04;
				}
			}
			return null;
		};

		/**
		 * @ngdoc method
		 * @name controleType6
		 * @methodOf cnafComponentsTeleprocApp.service:CnafCctGestionTypeService
		 * @param {string} donnee code postal
		 * @return {string} donnée modifiée ou message d'erreur
		 * @description
		 * Vérifie le format du code postal
		 * Retourne null ou message d'erreur
		 */
		this.controleType6 = function (donnee) {
			var rmType6 = null;
			if (donnee !== null && donnee !== undefined) {
				if (!CnafCctUtilsTypesService.isType6FormatCodePostalValide(donnee)) {
					// Format non respecté
					return CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_SAISIE_INCORRECTE_ME05;
				}
			}

			return rmType6;
		};


		/**
		 * @ngdoc method
		 * @name appelControleType7
		 * @methodOf cnafComponentsTeleprocApp.service:CnafCctGestionTypeService
		 * @param {string} donnee éléments d'adresse
			* @param {string} formDonnee nom de la donnée dans le formulaire
		 * @return {string} donnée modifiée ou null si erreur
		 * @description
		 * Méthode d'appel des contrôles de format des éléments de l'adresse
		 * si erreur, positionne le message d'erreur, l'attribut $setValidity à false et renvoie null
		 * sinon, positionne l'attribut $setValidity à true et renvoie la donnée modifiée
		 */
		this.appelControleType7 = function (donnee, formDonnee) {
			//console.log("appelcontroleType7 avec " + donnee + " form " + formDonnee);
			var retourControlesTypes = this.controleType7(donnee);
			if (retourControlesTypes === CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_CAR_NON_AUTORISE_ME04 ||
			   retourControlesTypes === CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_SAISIE_INCORRECTE_ME05) {
				formDonnee.invalidmsg = retourControlesTypes;
				formDonnee.$setValidity('type7', false);
				return null;
			} else if (null !== retourControlesTypes) {
				formDonnee.$setValidity('type7', true);
				return retourControlesTypes;
			}
		};

		/**
		 * @ngdoc method
		 * @name controleType7
		 * @methodOf cnafComponentsTeleprocApp.service:CnafCctGestionTypeService
		 * @param {string} donnee éléments d'adresse
		 * @return {string} donnée modifiée ou message d'erreur
		 * @description
		 * Vérifie le format des éléments de l'adresse, l'absence de caractères non autorisés
		 * et fait la conversion en majuscules non accentuées
		 * Retourne donnée modifiée ou message d'erreur
		 */
		this.controleType7 = function (donnee) {
			if (donnee !== null && donnee !== undefined) {
				if (CnafCctUtilsTypesService.isType7AbsenceCaracteresNonAutorises(donnee)) {
					var donneeModifie = CnafCctUtilsTypesService.convertirType7SupprimeBlanc(donnee);

					if (CnafCctUtilsTypesService.isType7ControleOK(donneeModifie)) {
						// Contrôle OK
						donneeModifie = CnafCctUtilsTypesService.convertirType7EnMajusculeSansAccent(donneeModifie);
						// Sauvegarde de la donnée modifiée
						return donneeModifie;
					}
					else {
						// Contrôle KO
						return CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_SAISIE_INCORRECTE_ME05;
					}
				}
				else {
					// Présence de caractères non autorisés
					return CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_CAR_NON_AUTORISE_ME04;
				}
			}
			return null;
		};


		/**
		 * @ngdoc method
		 * @name appelControleType8
		 * @methodOf cnafComponentsTeleprocApp.service:CnafCctGestionTypeService
		 * @param {string} donnee nom d'organisme ou libellé
			* @param {string} formDonnee nom de la donnée dans le formulaire
		 * @return {string} donnée modifiée ou null si erreur
		 * @description
		 * Méthode d'appel des contrôles de format du nom d'organisme ou libellé
		 * si erreur, positionne le message d'erreur, l'attribut $setValidity à false et renvoie null
		 * sinon, positionne l'attribut $setValidity à true et renvoie la donnée modifiée
		 */
		this.appelControleType8 = function (donnee, formDonnee) {
			//console.log("appelcontroleType8 avec " + donnee + " form " + formDonnee);
			var retourControlesTypes = this.controleType8(donnee);
			if (retourControlesTypes === CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_CAR_NON_AUTORISE_ME04 ||
				retourControlesTypes === CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_SAISIE_INCORRECTE_ME05) {
				formDonnee.invalidmsg = retourControlesTypes;
				formDonnee.$setValidity('type8', false);
				return null;
			} else if (null !== retourControlesTypes) {
				formDonnee.$setValidity('type8', true);
				return retourControlesTypes;
			}
		};

		/**
		 * @ngdoc method
		 * @name controleType8
		 * @methodOf cnafComponentsTeleprocApp.service:CnafCctGestionTypeService
		 * @param {string} donnee nom d'organisme ou libellé
		 * @return {string} donnée modifiée ou message d'erreur
		 * @description
		 * Vérifie le format du nom d'organisme ou libellé, l'absence de caractères non autorisés
		 * et fait la conversion en majuscules non accentuées
		 * Retourne donnée modifiée ou message d'erreur
		 */
		this.controleType8 = function (donnee) {
			if (donnee !== null && donnee !== undefined) {
				if (CnafCctUtilsTypesService.isType8AbsenceCaracteresNonAutorises(donnee)) {
					var donneeModifie = CnafCctUtilsTypesService.convertirType8SupprimeBlanc(donnee);

					if (CnafCctUtilsTypesService.isType8ControleOK(donneeModifie)) {
						// Contrôle OK
						donneeModifie = CnafCctUtilsTypesService.convertirType8EnMajusculeSansAccent(donneeModifie);
						// Sauvegarde de la donnée modifiée
						return donneeModifie;
					}
					else {
						// Contrôle KO
						return CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_SAISIE_INCORRECTE_ME05;
					}
				}
				else {
					// Présence de caractères non autorisés
					return CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_CAR_NON_AUTORISE_ME04;
				}
			}
			return null;
		};

		/**
		 * @ngdoc method
		 * @name controleType9
		 * @methodOf cnafComponentsTeleprocApp.service:CnafCctGestionTypeService
		 * @param {string} donnee domiciliation
		 * @return {string} donnée modifiée ou message d'erreur
		 * @description
		 * Vérifie le format de la domiciliation, l'absence de caractères non autorisés
		 * et fait la conversion en majuscules non accentuées
		 * Retourne donnée modifiée ou message d'erreur
		 */
		this.controleType9 = function (donnee) {
			if (donnee !== null && donnee !== undefined) {
				if (CnafCctUtilsTypesService.isType9AbsenceCaracteresNonAutorises(donnee)) {
					if (CnafCctUtilsTypesService.isType9ControleOK(donnee)) {
						// Contrôle OK
						var donneeModifie = CnafCctUtilsTypesService.convertirType9EnMajusculeSansAccentSuppressionCarInutile(donnee);

						// Sauvegarde de la donnée modifiée
						return donneeModifie;
					}
					else {
						// Contrôle KO
						return CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_SAISIE_INCORRECTE_ME05;
					}
				}
				else {
					// Présence de caractères non autorisés
					return CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_CAR_NON_AUTORISE_ME04;
				}
			}
			return null;
		};


		/**
		 * @ngdoc method
		 * @name appelControleType10
		 * @methodOf cnafComponentsTeleprocApp.service:CnafCctGestionTypeService
		 * @param {string} donnee numéro de voie ou de dossier
			* @param {string} formDonnee nom de la donnée dans le formulaire
		 * @return {string} donnée modifiée ou null si erreur
		 * @description
		 * Méthode d'appel des contrôles du numéro de voie ou de dossier
		 * si erreur, positionne le message d'erreur, l'attribut $setValidity à false et renvoie null
		 * sinon, positionne l'attribut $setValidity à true et renvoie la donnée modifiée
		 */
		this.appelControleType10 = function (donnee, formDonnee) {
			//console.log("appelcontroleType10 avec " + donnee + " form " + formDonnee);
			var retourControlesTypes = this.controleType10(donnee);
			if (retourControlesTypes === CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_CAR_NON_AUTORISE_ME04 ||
				retourControlesTypes === CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_SAISIE_INCORRECTE_ME05) {
				formDonnee.invalidmsg = retourControlesTypes;
				formDonnee.$setValidity('type10', false);
				return null;
			} else if (null !== retourControlesTypes) {
				formDonnee.$setValidity('type10', true);
				return retourControlesTypes;
			}
		};

		/**
		 * @ngdoc method
		 * @name controleType10
		 * @methodOf cnafComponentsTeleprocApp.service:CnafCctGestionTypeService
		 * @param {string} donnee numéro de voie ou de dossier
		 * @return {string} donnée modifiée ou message d'erreur
		 * @description
		 * Vérifie le format du numéro de voie ou de dossier, l'absence de caractères non autorisés
		 * et fait la conversion en majuscules non accentuées
		 * Retourne donnée modifiée ou message d'erreur
		 */
		this.controleType10 = function (donnee) {
			if (donnee !== null && donnee !== undefined) {
				if (CnafCctUtilsTypesService.isType10AbsenceCaracteresNonAutorises(donnee)) {
					var donneeModifie = CnafCctUtilsTypesService.convertirType10SupprimeBlanc(donnee);

					if (CnafCctUtilsTypesService.isType10ControleOK(donneeModifie)) {
						// Contrôle OK
						donneeModifie = CnafCctUtilsTypesService.convertirType10EnMajusculeSansAccent(donneeModifie);
						// Sauvegarde de la donnée modifiée
						return donneeModifie;
					}
					else {
						// Contrôle KO
						return CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_SAISIE_INCORRECTE_ME05;
					}
				}
				else {
					// Présence de caractères non autorisés
					return CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_CAR_NON_AUTORISE_ME04;
				}
			}
			return null;
		};


		/**
		 * @ngdoc method
		 * @name controleType11
		 * @methodOf cnafComponentsTeleprocApp.service:CnafCctGestionTypeService
		 * @param {string} donnee composants iban ou bic
		 * @return {string} donnée modifiée ou message d'erreur
		 * @description
		 * Vérifie le format du numéro des composants iban ou bic, l'absence de caractères non autorisés
		 * et fait la conversion en majuscules
		 * Retourne donnée modifiée ou message d'erreur
		 */
		this.controleType11 = function (donnee) {
			if (donnee !== null && donnee !== undefined) {
				if (CnafCctUtilsTypesService.isType11AbsenceCaracteresNonAutorises(donnee)) {
					var donneeModifie = CnafCctUtilsTypesService.convertirType11EnMajuscule(donnee);
					// Sauvegarde de la donnée modifiée
					return donneeModifie;
				}
				else {
					// Présence de caractères non autorisés
					return CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_CAR_NON_AUTORISE_ME04;
				}
			}
			return null;
		};

		/**
		 * @ngdoc method
		 * @name appelControleType12
		 * @methodOf cnafComponentsTeleprocApp.service:CnafCctGestionTypeService
		 * @param {string} donnee code potal/ville
			* @param {string} formDonnee nom de la donnée dans le formulaire
		 * @return {string} donnée modifiée ou null si erreur
		 * @description
		 * Méthode d'appel des contrôles code potal/ville
		 * si erreur, positionne le message d'erreur, l'attribut $setValidity à false et renvoie null
		 * sinon, positionne l'attribut $setValidity à true et renvoie la donnée modifiée
		 */
		this.appelControleType12 = function (donnee, formDonnee) {
			//console.log("appelcontroleType12 avec " + donnee + " form " + formDonnee);
			var retourControlesTypes = this.controleType12(donnee);
			if (retourControlesTypes === CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_CAR_NON_AUTORISE_ME04 ||
			   retourControlesTypes === CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_SAISIE_INCORRECTE_ME05) {
				formDonnee.invalidmsg = retourControlesTypes;
				formDonnee.$setValidity('type12', false);
				return null;
			} else if (null !== retourControlesTypes) {
				formDonnee.$setValidity('type12', true);
				return retourControlesTypes;
			}
		};

		/**
		 * @ngdoc method
		 * @name controleType12
		 * @methodOf cnafComponentsTeleprocApp.service:CnafCctGestionTypeService
		 * @param {string} donnee code potal/ville
		 * @return {string} donnée modifiée ou message d'erreur
		 * @description
		 * Vérifie le format du code potal/ville, l'absence de caractères non autorisés
		 * et fait la conversion en majuscules non accentuées
		 * Retourne donnée modifiée ou message d'erreur
		 */
		this.controleType12 = function (donnee) {
			if (donnee !== null && donnee !== undefined) {
				if (CnafCctUtilsTypesService.isType12AbsenceCaracteresNonAutorises(donnee)) {
					var donneeModifie = CnafCctUtilsTypesService.convertirType12SupprimeBlanc(donnee);

					if (CnafCctUtilsTypesService.isType12ControleOK(donneeModifie)) {
						// Contrôle OK
						donneeModifie = CnafCctUtilsTypesService.convertirType12EnMajusculeSansAccent(donneeModifie);
						// Sauvegarde de la donnée modifiée
						return donneeModifie;
					}
					else {
						// Contrôle KO
						return CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_SAISIE_INCORRECTE_ME05;
					}

				}
				else {
					// Présence de caractères non autorisés
					return CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_CAR_NON_AUTORISE_ME04;
				}
			}
			return null;

		};


		/**
		 * @ngdoc method
		 * @name appelControleType13
		 * @methodOf cnafComponentsTeleprocApp.service:CnafCctGestionTypeService
		 * @param {string} donnee TODO
		 * @param {string} formDonnee nom de la donnée dans le formulaire
		 * @return {string} donnée modifiée ou null si erreur
		 * @description
		 * Méthode d'appel des contrôles
		 * si erreur, positionne le message d'erreur, l'attribut $setValidity à false et renvoie null
		 * sinon, positionne l'attribut $setValidity à true et renvoie la donnée modifiée
		 */
		this.appelControleType13 = function (donnee, formDonnee) {
			//console.log("appelcontroleType13 avec " + donnee + " form " + formDonnee);
			var retourControlesTypes = this.controleType13(donnee);
			if (retourControlesTypes === CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_CAR_NON_AUTORISE_ME04 ||
				retourControlesTypes === CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_SAISIE_INCORRECTE_ME05) {
				formDonnee.invalidmsg = retourControlesTypes;
				formDonnee.$setValidity('type13', false);
				return null;
			} else if (null !== retourControlesTypes) {
				formDonnee.$setValidity('type13', true);
				return retourControlesTypes;
			}
		};
		/**
		 * @ngdoc method
		 * @name controleType13
		 * @methodOf cnafComponentsTeleprocApp.service:CnafCctGestionTypeService
		 * @param {string} donnee TODO
		 * @return {string} donnée modifiée ou message d'erreur
		 * @description
		 * Vérifie le format, l'absence de caractères non autorisés
		 * et fait la conversion en majuscules non accentuées
		 * Retourne donnée modifiée ou message d'erreur
		 */
		this.controleType13 = function (donnee) {
			//console.log("controleType13 avec " + donnee);
			if (donnee !== null && donnee !== undefined) {
				if (CnafCctUtilsTypesService.isType13AbsenceCaracteresNonAutorises(donnee)) {
					var donneeModifie = CnafCctUtilsTypesService.convertirType13SupprimeBlanc(donnee);

					if (CnafCctUtilsTypesService.isType13ControleOK(donneeModifie)) {
						// Contrôle OK
						donneeModifie = CnafCctUtilsTypesService.convertirType13EnMajusculeSansAccent(donneeModifie);
						// Sauvegarde de la donnée modifiée
						return donneeModifie;
					}
					else {
						// Contrôle KO
						return CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_SAISIE_INCORRECTE_ME05;
					}

				}
				else {
					// Présence de caractères non autorisés
					return CnafCctConstantMsgTypes.MESSAGE_TYPE_CID_BLQ_CAR_NON_AUTORISE_ME04;
				}
			}
			return null;
		};

	}

})();

(function() {
    'use strict';
    //Définition de constantes pour les msg d'erreur
    angular.module('cnafComponentsTeleprocApp').constant("CnafCctConstantMsgTypes",
      {
        'MESSAGE_TYPE1_CID_BLQ_ME01':"Le format de l'adresse courriel n'est pas valide. Exemple de format attendu : exemple@adressemail.com",
        'MESSAGE_TYPE1_CID_BLQ_ME02':"L’adresse courriel contient des caractères non autorisés",
        'MESSAGE_TYPE1_CID_BLQ_ME03':"Le numéro de téléphone est incorrect. Exemple de format attendu : 04 12 34 56 78",
        'MESSAGE_TYPE_CID_BLQ_CAR_NON_AUTORISE_ME04':"La saisie comporte des caractères non autorisés",
        'MESSAGE_TYPE_CID_BLQ_SAISIE_INCORRECTE_ME05':"Saisie incorrecte"
      }
    );
})();

(function() {
    'use strict';

    angular
        .module('cnafComponentsTeleprocApp')
        .service('CnafCctUtilsTypesService', CnafCctUtilsTypesService);

    function CnafCctUtilsTypesService() {

        var CHARS_NAME = "!#$%&'*+-/=?^_`{|}~.0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
        var CHARS_SUB_DOMAIN = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-.";
	      var CHARS_DOMAIN_EXTENSION = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

	      var CHARS_ALPHA = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZàâäçèéêëîïôöùîûüÿÀÂÄÇÈÉÊËÎÏÔÖÙÛÜŸ";
	      var CHARS_NUM = "0123456789";
        // tableau accents
		    var ACCENT = "ÀÂÄÇÈÉÊËÎÏÔÖÙÛÜŸ";
 		     // tableau sans accents
		    var REPLACE_ACCENT = "AAACEEEEIIOOUUUY";

        var CHARS_TYPE3 = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZàâäçèéêëîïôöùîûüÿÀÂÄÇÈÉÊËÎÏÔÖÙÛÜŸ -'";
		  var CHARS_TYPE4 = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZàâäçèéêëîïôöùîûüÿÀÂÄÇÈÉÊËÎÏÔÖÙÛÜŸ -',";
		  var CHARS_TYPE13 = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZàâäçèéêëîïôöùîûüÿÀÂÄÇÈÉÊËÎÏÔÖÙÛÜŸ -'";
	      var CHARS_TYPE7 = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZàâäçèéêëîïôöùîûüÿÀÂÄÇÈÉÊËÎÏÔÖÙÛÜŸ '0123456789";
	      var CHARS_TYPE5_8 = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZàâäçèéêëîïôöùîûüÿÀÂÄÇÈÉÊËÎÏÔÖÙÛÜŸ -'0123456789";

	      var CHARS_TYPE9 = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZàâäçèéêëîïôöùîûüÿÀÂÄÇÈÉÊËÎÏÔÖÙÛÜŸ -'.";
	      var CHARS_TYPE10 = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZàâäçèéêëîïôöùîûüÿÀÂÄÇÈÉÊËÎÏÔÖÙÛÜŸ -0123456789";
	      var CHARS_TYPE12 = "()";

	      var PATTERN_TEL = "^0[0-9]{9}$";

        var PATTERN_CODE_POSTAL = "^[0-9]{5}$";

	      var PATTERN_IBAN_BIC = "^[a-zA-Z0-9]*$";

	      var SEP_TYPE4 = ",";

      	/**
      	 * Contrôle que la syntaxe nom@domaine.extension est respectée.</BR>
      	 * Inclut absence de @ ou présence de plusieurs @.</BR>
      	 * Inclut présence du point après le @.</BR>
      	 * Inclut vérification des longeurs 50 pour 'nom' et 27 pour 'domaine.extension'</BR>
      	 *
      	 *
      	 * @param mel : Mél : String
      	 * @return
      	 * 		true : Si Mél valide</br>
      	 * 		false : Si Mél ne respecte pas le format</br>
      	 */
      	this.isType1FormatRespecte = function(melAControler){
      	   var isFormatRespecte = true;

      		 if (melAControler!==null && melAControler !==undefined)
      		 {
              var mel = melAControler.toString();
              var indexOfArobase = mel.indexOf('@');

        			if (indexOfArobase===-1)
        			{
        				// Absence d'arobase
        				isFormatRespecte = false;
        			}
        			else
        			{
          				var indexOfArobase2 = mel.indexOf('@',indexOfArobase+1);

          				if (indexOfArobase2!==-1)
          				{
          					// Présence de plusieurs Arobase
          					isFormatRespecte = false;
          				}
          				else
          				{
            					var indexOfPoint = mel.indexOf('.',indexOfArobase+1);

            					if (indexOfPoint===-1)
            					{
            						// Absence du point
            						isFormatRespecte = false;
            					}
            					else
            					{
              						// Nom supérieur à 50 caractères ou égal à 0
              						if ((indexOfArobase===0) || (indexOfArobase>50))
              						{
              							isFormatRespecte = false;
              						}
              						else
              						{
                							var lgDomExt = mel.length - indexOfArobase-1;
                							// Domaine + Extension supérieure à 27 caractères ou égal à 0
                							if ((lgDomExt===0) || (lgDomExt>27))
                							{
                								isFormatRespecte = false;
                							}
                							else
                							{
                  								var lgExt = mel.length - indexOfPoint -1;

                  								if ((lgDomExt-lgExt-1===0) || (lgExt===0))
                  								{
                  									// Extension vide
                  									isFormatRespecte = false;
                  								}

                							}
              						}
            					}
          				}
        			}

      		}
      		else
      		{
      			isFormatRespecte = false;
      		}

      		return isFormatRespecte;
      	};

      	/**
      	 * Contrôle que le mél ne contient que les caractères autorisés</br>
      	 * pour chacune de ces parties (nom, domaine, extension).</br>
      	 *
      	 *
      	 * @param mel : String
      	 * @return
      	 * 		true : Si Mél ne contient pas de caractère non autorisé</br>
      	 * 		false : Si Mél contient des caractères non autorisés</br>
      	 */
      	this.isType1AbsenceCaracteresNonAutorises = function(melAControler)
      	{
      	   var isAbsenceCaracteresNonAutorises = true;
           if (melAControler!==null && melAControler !==undefined)
      		 {
              var mel = melAControler.toString();
        			var indexOfArobase = mel.indexOf('@');

        			if (indexOfArobase!==-1)
        			{
          				var nom = mel.substring(0, indexOfArobase);

          				// Teste la validité des caractères sur le nom
          				isAbsenceCaracteresNonAutorises =  this.areCharactersValid(nom,CHARS_NAME);

          				if (isAbsenceCaracteresNonAutorises)
          				{
            					if (nom.startsWith(".") || nom.endsWith("."))
            					{
            						// Le caractère "." est interdit en début ou fin du nom
            						isAbsenceCaracteresNonAutorises = false;
            					}
            					else
            					{
                          var indexOfDoublePoint = nom.indexOf('..');
                          if (indexOfDoublePoint !==-1)
                          {
                            isAbsenceCaracteresNonAutorises = false;
                          }
              						else
              						{
                							var domaine = mel.substring(indexOfArobase+1, mel.length);

                							var indexOfLastDot = domaine.lastIndexOf('.');

                							if (indexOfLastDot!=-1)
                							{
                  								var domaineSansExtension = domaine.substring(0,indexOfLastDot);
                  								var extension = domaine.substring(indexOfLastDot+1,domaine.length);

                  								if (domaineSansExtension.startsWith(".") || domaineSansExtension.endsWith("."))
                  								{
                  									isAbsenceCaracteresNonAutorises = false;
                  								}
                  								else
                  								{
                    									var tabSousDomaine = domaineSansExtension.split("\\.");
                    									for (var i=0;(i<tabSousDomaine.length && isAbsenceCaracteresNonAutorises);i++)
                    									{
                      										var sousDomaine = tabSousDomaine[i];

                      										if (sousDomaine.length===0)
                      										{
                      											isAbsenceCaracteresNonAutorises = false;
                      										}
                      										else if (sousDomaine.startsWith("-") || sousDomaine.endsWith("-"))
                      										{
                      											isAbsenceCaracteresNonAutorises = false;
                      										}
                      										else if (!this.areCharactersValid(sousDomaine, CHARS_SUB_DOMAIN))
                      										{
                      											isAbsenceCaracteresNonAutorises = false;
                      										}
                    									}
                    									if (isAbsenceCaracteresNonAutorises)
                    									{
                      										if (extension.length < 2)
                      										{
                      											isAbsenceCaracteresNonAutorises = false;
                      										}
                      										else if (!this.areCharactersValid(extension, CHARS_DOMAIN_EXTENSION))
                      										{
                      											isAbsenceCaracteresNonAutorises = false;
                      										}
                    									}

                  								}

                							}
              						}
            					}
          				}
        			}
        	}

      	  return isAbsenceCaracteresNonAutorises;

      	};


      	/**
      	 * Contrôle que le téléphone est composé uniquement de numéro,</br>
      	 * qu'il commence par 0 et qu'il est composé exactement de 10 caractères.</br>
      	 *
      	 * @param tel : String
      	 * @return
      	 * 		true : Si Tel a format valide</br>
      	 * 		false : Si Tel a un format invalide</br>
      	 */
      	this.isType2FormatTelValide = function(tel)
      	{
            var type2FormatTelValide = true;
            if (tel!==null && tel!==undefined)
        		{
        			// Composé uniquement de numéros, de longeur 10 et commence par 0
        			var type2Match = tel.match(PATTERN_TEL);
              if (type2Match === null)
              {
                type2FormatTelValide = false;
              }
        		}
        		else
        		{
        			type2FormatTelValide = false;
        		}

        		return type2FormatTelValide;
        };

      	/**
      	 * Contrôle que la donnée sType3 ne contient que des données autorisées pour son type
      	 *
      	 * @param sType3: String
      	 * @return
      	 * 		true : Si sType3 ne contient que des caractères autorisés</br>
      	 * 		false : Si sType3 contient des caractères non autorisés</br>
      	 */
      	this.isType3AbsenceCaracteresNonAutorises = function(sType3){
        		var isType3AbsenceCaracteresNonAutorises = true;

        		if (sType3!==null && sType3!==undefined)
        		{
              isType3AbsenceCaracteresNonAutorises = this.areCharactersValid(sType3,CHARS_TYPE3);
        		}

        		return isType3AbsenceCaracteresNonAutorises;
      	};

      	/**
      	 * Applique la suppression des blancs spécifiques au type 3 sur la chaîne sType3.</br>
      	 * Supprime les espaces en double.</br>
      	 * Supprime les blancs au début et à la fin.</br>
      	 * Supprime les blancs qui précèdent ou qui suivent un tiret ou un apostrophe.</br>
      	 *
      	 * @param sType3 : String
      	 * @return
      	 * 	String Chaîne convertie
      	 */
      	this.convertirType3SupprimeBlanc = function(sType3){
        	  var sType3Conv = null;
        		if (sType3!==null && sType3!==undefined)
        		{
        			sType3Conv = this.supprimerBlancsInutiles(sType3.toString());

        		}

        		return sType3Conv;
      	};

      	/**
      	 *
      	 *  Contrôle que la donnée sType3 respecte le format type3.</br>
      	 *  Avant l'appel à cette méthode, la donnée aura dû être transformé par la méthode convertirType3SupprimeBlanc</br>
      	 *
      	 * @param sType3 : String donnée à tester
      	 * @return
      	 * 		true : Si sType3 respecte le format du type3 attendu</br>
      	 * 		false : Si sType3 ne respecte pas le format du type3 attendu</br>
      	 *
      	 * @see #convertirType3SupprimeBlanc
      	 *
      	 */
      	this.isType3ControleOK = function(sType3){
      		var isType3ControleOK = this.isTypeControlesCommunOK(sType3.toString(),true);

      		return isType3ControleOK;
      	};

      	/**
      	 *
      	 * Conversion en majuscule et transformation des caractères français accentués.
      	 *
      	 * @param sType3 : String
      	 * @return
      	 * 		StringChaîne convertie
      	 */
      	this.convertirType3EnMajusculeSansAccent = function(sType3){
        		var sType3Conv = null;
        		if (sType3!==null && sType3!==undefined)
        		{
	             sType3Conv = sType3.toString();
              // Passage en majuscule
        			sType3Conv = sType3Conv.toUpperCase();
        			// Transforme l'ensemble des lettres accentuées sans accent
              sType3Conv = this.convertirSansAccent(sType3Conv);

        		}

        		return sType3Conv;
      	};


      	/**
      	 * Contrôle que la donnée sType4 ne contient que des données autorisées pour son type
      	 *
      	 * @param sType4: String
      	 * @return
      	 * 		true : Si sType4 ne contient que des caractères autorisés</br>
      	 * 		false : Si sType4 contient des caractères non autorisés</br>
      	 */
      	this.isType4AbsenceCaracteresNonAutorises = function(sType4){
        		var isType4AbsenceCaracteresNonAutorises = true;

        		if (sType4!==null && sType4!==undefined)
        		{
        			isType4AbsenceCaracteresNonAutorises = this.areCharactersValid(sType4,CHARS_TYPE4);
        		}

        		return isType4AbsenceCaracteresNonAutorises;
      	};


      	/**
      	 * Retourne un Tableau de N+ prénoms N étant le nombre de virgules.</br>
      	 * Pour chaque occurence de prénom :</br>
      	 * Supprime les espaces en double.</br>
      	 * Supprime les blancs au début et à la fin.</br>
      	 * Supprime les blancs qui précèdent ou qui suivent un tiret ou un apostrophe.</br>
      	 *
      	 * @param sType4 : String
      	 * @return
      	 * 	String[] Tableau de prénom convertie convertie
      	 */
      	this.convertirType4EnTableauAvecSuppressionBlanc = function(sType4){
      		var tabPrenoms = null;

      		if (sType4!==null && sType4!==undefined)
      		{
              sType4 = sType4.toString();
              tabPrenoms = sType4.split(",",-1);

        			for (var i = 0; i < tabPrenoms.length; i++)
        			{
        				    tabPrenoms[i] = this.supprimerBlancsInutiles(tabPrenoms[i]);
        			}
      		}

      		return tabPrenoms;

      	};


      	/**
      	 *
      	 *  Contrôle que la donnée aType4 respecte le format type4.</br>
      	 *  Avant l'appel à cette méthode, la donnée aura dû être transformé par la méthode convertirType4EnTableauAvecSuppressionBlanc</br>
      	 *
      	 * @param aType4 : String[]
      	 * @return
      	 * 		true : Si aType4 respecte le format du type4 attendu</br>
      	 * 		false : Si aType4 ne respecte pas le format du type4 attendu</br>
      	 *
      	 * @see #convertirType4EnTableauAvecSuppressionBlanc
      	 *
      	 */
      	this.isType4ControleOK = function(aType4){
      		var isType4ControleOK = true;

      		for (var i=0;((i<aType4.length) && isType4ControleOK);i++)
      		{
      			var sType4 = aType4[i];
            sType4 = sType4.toString();
      			isType4ControleOK = this.isTypeControlesCommunOK(sType4, false);

      		}

      		return isType4ControleOK;

      	};


      	/**
      	 *
      	 * Conversion en majuscule et transformation des caractères français accentués.</br>
      	 * Concaténation en insérant une virgule suivie d'un blanc comme séparateur.
      	 *
      	 * @param aType4 : String[] liste de chaîne de caractère de type4
      	 * @return
      	 * 		StringChaîne convertie
      	 */
      	this.convertirType4EnMajusculeSansAccentAvecConcatenation = function(aType4){
        	 var sType4Conv = null;
        		if (aType4 !== null && aType4 !== undefined)
        		{
        			for (var i=0;i<aType4.length;i++)
        			{
        				var sType4 = aType4[i];
                sType4 = sType4.toString();
        				// Passage en majuscule
        				sType4 = sType4.toUpperCase();
        				// Transforme l'ensemble des lettres accentuées sans accent
                sType4 = this.convertirSansAccent(sType4);

        				if (i===0)
        				{
        					sType4Conv = sType4;
        				}
        				else
        				{
        					sType4Conv = sType4Conv + SEP_TYPE4 + sType4;
        				}
        			}


        		}

        		return sType4Conv;
      	};


      	/**
      	 * Contrôle que la donnée sType5 ne contient que des données autorisées pour son type
      	 *
      	 * @param sType5: String
      	 * @return
      	 * 		true : Si sType5 ne contient que des caractères autorisés</br>
      	 * 		false : Si sType5 contient des caractères non autorisés</br>
      	 */
      	this.isType5AbsenceCaracteresNonAutorises = function(sType5){
        		var isType5AbsenceCaracteresNonAutorises = true;

        		if (sType5 !== null && sType5 !== undefined)
        		{
        			isType5AbsenceCaracteresNonAutorises = this.areCharactersValid(sType5,CHARS_TYPE5_8);
        		}

        		return isType5AbsenceCaracteresNonAutorises;
      	};

      	/**
      	 * Applique la suppression des blancs spécifiques au type 5 sur la chaîne sType5.</br>
      	 * Supprime les espaces en double.</br>
      	 * Supprime les blancs au début et à la fin.</br>
      	 * Supprime les blancs qui précèdent ou qui suivent un tiret ou un apostrophe.</br>
      	 *
      	 * @param sType5 : String
      	 * @return
      	 * 	String Chaîne convertie
      	 */
      	this.convertirType5SupprimeBlanc = function(sType5){
      	var sType5Conv = null;
      		if (sType5 !== null && sType5 !== undefined)
      		{
      			sType5Conv = this.supprimerBlancsInutiles(sType5.toString());

      		}

      		return sType5Conv;
      	};


      	/**
      	 *
      	 *  Contrôle que la donnée sType5 respecte le format type5.</br>
      	 *  Avant l'appel à cette méthode, la donnée aura dû être transformé par la méthode convertirType5SupprimeBlanc</br>
      	 *
      	 * @param sType5 : String donnée à tester
      	 * @param isControleNumeriqueADesactiver : boolean si true le contrôle sur les numériques n'est pas fait
      	 * @return
      	 * 		true : Si sType5 respecte le format du type5 attendu</br>
      	 * 		false : Si sType5 ne respecte pas le format du type5 attendu</br>
      	 *
      	 * @see #convertirType5SupprimeBlanc
      	 *
      	 */
         this.isType5ControleOK = function(sType5,isControleNumeriqueADesactiver){
      		var isType5ControleOK = this.isTypeControlesCommunOK(sType5, false);

      		if (isType5ControleOK && !isControleNumeriqueADesactiver)
      		{
             var pattern = /[0-9]+/g;
             var matcher;
             var nbNombre = 0;
             while (isType5ControleOK && (matcher = pattern.exec(sType5.toString())) !== null)
         		 {
                nbNombre = nbNombre + 1;
                if (nbNombre===2)
         				{
         					// Présence de plus de 1 nombre dans la chaîne
         					isType5ControleOK = false;
         				}
         				else if ((matcher.index === 0) || (sType5.charAt(matcher.index-1)!==' '))
         				{
         					// Pas de blanc avant le chiffre
         					isType5ControleOK = false;
         				}
         				else if (matcher.toString().length > 2)
         				{
         					// Le chiffre ne doit pas dépasser 2 caractères
                	isType5ControleOK = false;
         				}
         				else {
         					 var arrondissement = parseInt(matcher,10);
                   if ((arrondissement<1) || (arrondissement>20))
         					 {
         						 // La valeur trouvée doit être comprise entre 1 et 20
         						 isType5ControleOK = false;
         					 }
         			  }
     			   }
    		  }

      		return isType5ControleOK;
      	};


      	/**
      	 *
      	 * Conversion en majuscule et transformation des caractères français accentués.
      	 *
      	 * @param sType5 : String
      	 * @return
      	 * 		StringChaîne convertie
      	 */
      	this.convertirType5EnMajusculeSansAccent = function(sType5){
        		var sType5Conv = null;
        		if (sType5 !== null && sType5 !== undefined)
        		{
              sType5 = sType5.toString();
              // Passage en majuscule
        			sType5Conv = sType5.toUpperCase();
        			// Transforme l'ensemble des lettres accentuées sans accent
              sType5Conv = this.convertirSansAccent(sType5Conv);

        		}

        		return sType5Conv;
      	};


      	/**
      	 * Contrôle que le codePostal est composé de 5 chiffres</br>
      	 *
      	 * @param codePostal : String
      	 * @return
      	 * 		true : Si codePostal a format valide</br>
      	 * 		false : Si codePostal a un format invalide</br>
      	 */
      	this.isType6FormatCodePostalValide = function(codePostal){
        		var isType6FormatCodePostalValide = true;

        		if (codePostal !== null && codePostal !== undefined)
        		{
                codePostal = codePostal.toString();
                // Composé uniquement de numéros, de longeur 5
          			var type6FormatCodePostalValide = codePostal.match(PATTERN_CODE_POSTAL);
                if (type6FormatCodePostalValide === null)
                {
                  isType6FormatCodePostalValide = false;
                }
        		}
        		else
        		{
          			isType6FormatCodePostalValide = false;
        		}

        		return isType6FormatCodePostalValide;
      	};


      	/**
      	 * Contrôle que la donnée sType7 ne contient que des données autorisées pour son type
      	 *
      	 * @param sType7: String
      	 * @return
      	 * 		true : Si sType7 ne contient que des caractères autorisés</br>
      	 * 		false : Si sType7 contient des caractères non autorisés</br>
      	 */
      	this.isType7AbsenceCaracteresNonAutorises = function(sType7){
        		var isType7AbsenceCaracteresNonAutorises = true;

        		if (sType7 !== null && sType7 !== undefined)
        		{
        			 isType7AbsenceCaracteresNonAutorises = this.areCharactersValid(sType7.toString(),CHARS_TYPE7);
        		}
        		return isType7AbsenceCaracteresNonAutorises;
      	};

      	/**
      	 * Applique la suppression des blancs spécifiques au type 7 sur la chaîne sType7.</br>
      	 * Supprime les espaces en double.</br>
      	 * Supprime les blancs au début et à la fin.</br>
      	 * Supprime les blancs qui précèdent ou qui suivent un tiret ou un apostrophe.</br>
      	 *
      	 * @param sType7 : String
      	 * @return
      	 * 	String Chaîne convertie
      	 */
      	this.convertirType7SupprimeBlanc = function(sType7){
      		var sType7Conv = null;
      		if (sType7 !== null && sType7 !== undefined)
      		{
      			sType7Conv = this.supprimerBlancsInutiles(sType7.toString());

      		}

      		return sType7Conv;
      	};



      	/**
      	 *
      	 *  Contrôle que la donnée sType7 respecte le format type7.</br>
      	 *  Avant l'appel à cette méthode, la donnée aura dû être transformé par la méthode convertirType7SupprimeBlanc</br>
      	 *
      	 * @param sType7 : String donnée à tester
      	 * @return
      	 * 		true : Si sType7 respecte le format du type7 attendu</br>
      	 * 		false : Si sType7 ne respecte pas le format du type7 attendu</br>
      	 *
      	 * @see #convertirType7SupprimeBlanc
      	 *
      	 */
      	this.isType7ControleOK = function(sType7){
      		var isType7ControleOK = this.isTypeControlesCommunOK(sType7.toString(), false);

      		return isType7ControleOK;
      	};


      	/**
      	 *
      	 * Conversion en majuscule et transformation des caractères français accentués.
      	 *
      	 * @param sType7 : String
      	 * @return
      	 * 		StringChaîne convertie
      	 */
      	this.convertirType7EnMajusculeSansAccent = function(sType7){
        		var sType7Conv = null;
        		if (sType7 !== null && sType7 !== undefined)
        		{
              sType7 = sType7.toString();
            	// Passage en majuscule
        			sType7Conv = sType7.toUpperCase();
        			// Transforme l'ensemble des lettres accentuées sans accent
              sType7Conv = this.convertirSansAccent(sType7Conv);

        		}

        		return sType7Conv;
      	};



      	/**
      	 * Contrôle que la donnée sType8 ne contient que des données autorisées pour son type
      	 *
      	 * @param sType8: String
      	 * @return
      	 * 		true : Si sType8 ne contient que des caractères autorisés</br>
      	 * 		false : Si sType8 contient des caractères non autorisés</br>
      	 */
      	this.isType8AbsenceCaracteresNonAutorises = function(sType8)
      	{
      		var isType8AbsenceCaracteresNonAutorises = true;

      		if (sType8 !== null && sType8 !== undefined)
      		{
      			isType8AbsenceCaracteresNonAutorises = this.areCharactersValid(sType8.toString(),CHARS_TYPE5_8 + "\r\n" );
      		}


      		return isType8AbsenceCaracteresNonAutorises;
      	};

      	/**
      	 * Applique la suppression des blancs spécifiques au type 8 sur la chaîne sType8.</br>
      	 * Supprime les espaces en double.</br>
      	 * Supprime les blancs au début et à la fin.</br>
      	 * Supprime les blancs qui précèdent ou qui suivent un tiret ou un apostrophe.</br>
      	 *
      	 * @param sType8 : String
      	 * @return
      	 * 	String Chaîne convertie
      	 */
      	this.convertirType8SupprimeBlanc = function(sType8){
          var sType8Conv = null;
      		if (sType8 !== null && sType8 !== undefined)
      		{
      			sType8Conv = this.supprimerBlancsInutiles(sType8.toString());

      		}
          return sType8Conv;
      	};

      	/**
      	 *
      	 *  Contrôle que la donnée sType8 respecte le format type8.</br>
      	 *  Avant l'appel à cette méthode, la donnée aura dû être transformé par la méthode convertirType8SupprimeBlanc</br>
      	 *
      	 * @param sType8 : String donnée à tester
      	 * @return
      	 * 		true : Si sType8 respecte le format du type8 attendu</br>
      	 * 		false : Si sType8 ne respecte pas le format du type8 attendu</br>
      	 *
      	 * @see #convertirType8SupprimeBlanc
      	 *
      	 */
      	this.isType8ControleOK = function(sType8){
			var isType8ControleOK = true;
			// Au moins un caractère alphabétique
			if (sType8 !== null && sType8 !== undefined)
      	    {
				isType8ControleOK = this.isComporteAuMoinsCarAlpha(sType8.toString());
				
				//Controle présence max 4 retour chariot
				if(isType8ControleOK)
				{
					if(this.compterOccurence(sType8.toString(),/\n/g) > 4)
					{
						isType8ControleOK=false;
					}
				}
			}  
      		return isType8ControleOK;
      	};

      	/**
      	 *
      	 * Conversion en majuscule et transformation des caractères français accentués.
      	 *
      	 * @param sType8 : String
      	 * @return
      	 * 		StringChaîne convertie
      	 */
      	this.convertirType8EnMajusculeSansAccent = function(sType8){
      		var sType8Conv = null;
      		if (sType8 !== null && sType8 !== undefined)
      		{
            sType8 = sType8.toString();
          // Passage en majuscule
      			sType8Conv = sType8.toUpperCase();
      			// Transforme l'ensemble des lettres accentuées sans accent
            sType8Conv = this.convertirSansAccent(sType8Conv);
      		}

      		return sType8Conv;
      	};

      	/**
      	 * Contrôle que la donnée sType9 ne contient que des données autorisées pour son type
      	 *
      	 * @param sType9: String
      	 * @return
      	 * 		true : Si sType9 ne contient que des caractères autorisés</br>
      	 * 		false : Si sType9 contient des caractères non autorisés</br>
      	 */
      	this.isType9AbsenceCaracteresNonAutorises = function(sType9)
      	{
      		var isType9AbsenceCaracteresNonAutorises = true;

      		if (sType9 !== null && sType9 !== undefined)
      		{
      			isType9AbsenceCaracteresNonAutorises = this.areCharactersValid(sType9.toString(),CHARS_TYPE9);
      		}

      		return isType9AbsenceCaracteresNonAutorises;
      	};


      	/**
      	 *
      	 *  Contrôle que la donnée sType9 respecte le format type9.</br>
      	 *
      	 * @param sType9 : String donnée à tester
      	 * @return
      	 * 		true : Si sType9 respecte le format du type9 attendu</br>
      	 * 		false : Si sType9 ne respecte pas le format du type9 attendu</br>
      	 *
      	 *
      	 */
      	this.isType9ControleOK = function(sType9)
      	{
      		// Au moins un caractère alphabétique
          var isType9ControleOK = true;

      		if (sType9 !== null && sType9 !== undefined)
      		{
      			isType9ControleOK = this.isComporteAuMoinsCarAlpha(sType9.toString());
      		}

      		return isType9ControleOK;
      	};


      	/**
      	 *
      	 * Remplace les tirets, point et apostrophes par des blancs
      	 * Supprime les espaces en double
      	 * Conversion en majuscule et transformation des caractères français accentués.
      	 *
      	 *
      	 * @param sType9 : String
      	 * @return
      	 * 		StringChaîne convertie
      	 */
      	this.convertirType9EnMajusculeSansAccentSuppressionCarInutile = function(sType9){
      		var sType9Conv = null;
      		if (sType9 !== null && sType9 !== undefined)
      		{
            sType9 = sType9.toString();
            // Remplace les tirets, les points et apostrophes par des blancs
      			sType9Conv = sType9.replace("-"," ");
      			sType9Conv = sType9Conv.replace("\\."," ");
      			sType9Conv = sType9Conv.replace("'"," ");

      			// Supprime les espaces en double
      			sType9Conv = sType9Conv.replace(/[\s]{2,}/g," ");

      			// Suppression des blancs au début et à la fin
      			sType9Conv = sType9Conv.trim();

      			// Passage en majuscule
      			sType9Conv = sType9Conv.toUpperCase();
      			// Transforme l'ensemble des lettres accentuées sans accent
      			sType9Conv = this.convertirSansAccent(sType9Conv);
      		}

      		return sType9Conv;
      	};


      	/**
      	 * Contrôle que la donnée sType10 ne contient que des données autorisées pour son type
      	 *
      	 * @param sType10: String
      	 * @return
      	 * 		true : Si sType10 ne contient que des caractères autorisés</br>
      	 * 		false : Si sType10 contient des caractères non autorisés</br>
      	 */
      	this.isType10AbsenceCaracteresNonAutorises = function(sType10){
      	var isType10AbsenceCaracteresNonAutorises = true;

      		if (sType10 !== null && sType10 !== undefined)
      		{
      			isType10AbsenceCaracteresNonAutorises = this.areCharactersValid(sType10.toString(),CHARS_TYPE10);
      		}

      		return isType10AbsenceCaracteresNonAutorises;
      	};

      	/**
      	 * Applique la suppression des blancs spécifiques au type 10 sur la chaîne sType10.</br>
      	 * Supprime les espaces en double.</br>
      	 * Supprime les blancs au début et à la fin.</br>
      	 * Supprime les blancs qui précèdent ou qui suivent un tiret ou un apostrophe.</br>
      	 *
      	 * @param sType10 : String
      	 * @return
      	 * 	String Chaîne convertie
      	 */
      	this.convertirType10SupprimeBlanc = function(sType10){
      		var sType10Conv = null;
      		if (sType10 !== null && sType10 !== undefined)
      		{
            sType10 = sType10.toString();
            // Suppression des blancs au début et à la fin
      			sType10Conv = sType10.trim();

      			// Supprime les espaces en double
      			sType10Conv = sType10Conv.replace(/[\s]{2,}/g," ");

      		}

      		return sType10Conv;
      	};


      	/**
      	 *
      	 *  Contrôle que la donnée sType10 respecte le format type10.</br>
      	 *  Avant l'appel à cette méthode, la donnée aura dû être transformé par la méthode convertirType10SupprimeBlanc</br>
      	 *
      	 * @param sType10 : String donnée à tester
      	 * @return
      	 * 		true : Si sType10 respecte le format du type10 attendu</br>
      	 * 		false : Si sType10 ne respecte pas le format du type10 attendu</br>
      	 *
      	 * @see #convertirType10SupprimeBlanc
      	 *
      	 */
      	this.isType10ControleOK = function(sType10){
      	   var isType10ControleOK = true;
           sType10 = sType10.toString();
      		// Au moins un caractère alphabétique
      		if (sType10 !== null && sType10 !== undefined && (this.isComporteAuMoinsCarAlpha(sType10) || this.isComporteAuMoinsCarNum(sType10)))
      		{
      			var indDoubleTiret = sType10.indexOf("--");
      			if (indDoubleTiret!=-1)
      			{
      				// Contrôle la présence de double tiret (aucun autorisé)
      				isType10ControleOK = false;
      			}
      			else
      			{
      				if (sType10.charAt(0)=='-')
      				{
      					// Premier caractère doit être différent du tiret
      					isType10ControleOK = false;
      				}
      				else
      				{
      					if (sType10.charAt(sType10.length-1)=='-')
      					{
      						// Le tiret en dernier caractère n'est pas autorisé - Maj du DAF attendu
      						isType10ControleOK = false;
      					}
      				}
      			}

      		}
      		else
      		{
      			// sType10 ne contient pas au moins un caractère alphabétique
      			isType10ControleOK = false;
      		}

      		return isType10ControleOK;
      	};


      	/**
      	 *
      	 * Conversion en majuscule et transformation des caractères français accentués.
      	 *
      	 * @param sType10 : String
      	 * @return
      	 * 		StringChaîne convertie
      	 */
      	this.convertirType10EnMajusculeSansAccent = function(sType10){
      		var sType10Conv = null;
      		if (sType10 !== null && sType10 !== undefined)
      		{
            sType10 = sType10.toString();
            // Passage en majuscule
      			sType10Conv = sType10.toUpperCase();
      			// Transforme l'ensemble des lettres accentuées sans accent
            sType10Conv = this.convertirSansAccent(sType10Conv);

      		}

      		return sType10Conv;
      	};


      	/**
      	 * Contrôle que la donnée sType11 ne contient que des données autorisées pour son type
      	 *
      	 * @param sType11: String
      	 * @return
      	 * 		true : Si sType11 ne contient que des caractères autorisés</br>
      	 * 		false : Si sType11 contient des caractères non autorisés</br>
      	 */
      	this.isType11AbsenceCaracteresNonAutorises = function(sType11){
      		var isType11AbsenceCaracteresNonAutorises = true;

      		if (sType11 !== null && sType11 !== undefined)
      		{
            sType11 = sType11.toString();
            var type11AbsenceCaracteresNonAutorises = sType11.match(PATTERN_IBAN_BIC);
            if (type11AbsenceCaracteresNonAutorises === null){
              isType11AbsenceCaracteresNonAutorises = false;
            }
      		}

      		return isType11AbsenceCaracteresNonAutorises;
      	};

      	/**
      	 *
      	 * Conversion en majuscule.
      	 *
      	 * @param sType11 : String
      	 * @return
      	 * 		StringChaîne convertie
      	 */
      	this.convertirType11EnMajuscule = function(sType11){
      		var sType11Conv = null;
      		if (sType11 !== null && sType11 !== undefined)
      		{
            sType11 = sType11.toString();
          	// Passage en majuscule
      			sType11Conv = sType11.toUpperCase();
      		}

      		return sType11Conv;
      	};

      	/**
      	 * Contrôle que la donnée sType12 ne contient que des données autorisées pour son type
      	 *
      	 * @param sType12: String
      	 * @return
      	 * 		true : Si sType12 ne contient que des caractères autorisés</br>
      	 * 		false : Si sType12 contient des caractères non autorisés</br>
      	 */
      	this.isType12AbsenceCaracteresNonAutorises = function(sType12)
      	{
      		var isType12AbsenceCaracteresNonAutorises = true;
          if (sType12 !== null && sType12 !== undefined)
      		{
      			isType12AbsenceCaracteresNonAutorises = this.areCharactersValid(sType12.toString(),CHARS_TYPE5_8 + CHARS_TYPE12);
      		}

      		return isType12AbsenceCaracteresNonAutorises;
      	};

      	/**
      	 *
      	 *  Contrôle que la donnée sType12 respecte le format type12.</br>
      	 *  Avant l'appel à cette méthode, la donnée aura dû être transformé par la méthode convertirType12SupprimeBlanc</br>
      	 *
      	 * @param sType12 : String donnée à tester
      	 * @return
      	 * 		true : Si sType12 respecte le format du type12 attendu</br>
      	 * 		false : Si sType12 ne respecte pas le format du type12 attendu</br>
      	 *
      	 * @see #convertirType12SupprimeBlanc
      	 *
      	 */
      	this.isType12ControleOK = function(sType12)
      	{
      		var isType12ControleOK = this.isTypeControlesCommunOK(sType12.toString(), false);

      		return isType12ControleOK;
      	};

      	/**
      	 *
      	 * Conversion en majuscule et transformation des caractères français accentués.
      	 *
      	 * @param sType12 : String
      	 * @return
      	 * 		StringChaîne convertie
      	 */
      	this.convertirType12EnMajusculeSansAccent = function(sType12){
      		var sType12Conv = null;
      		if (sType12 !== null && sType12 !== undefined)
      		{
            sType12 = sType12.toString();
            // Passage en majuscule
      			sType12Conv = sType12.toUpperCase();
      			// Transforme l'ensemble des lettres accentuées sans accent
            sType12Conv = this.convertirSansAccent(sType12Conv);

      		}

      		return sType12Conv;
      	};

      	/**
      	 * Applique la suppression des blancs spécifiques au type 12 sur la chaîne sType12.</br>
      	 * Supprime les espaces en double.</br>
      	 * Supprime les blancs au début et à la fin.</br>
      	 * Supprime les blancs qui précèdent ou qui suivent un tiret ou un apostrophe.</br>
      	 *
      	 * @param sType12 : String
      	 * @return
      	 * 	String Chaîne convertie
      	 */
      	this.convertirType12SupprimeBlanc = function(sType12)
      	{
      		var sType12Conv = null;
      		if (sType12 !== null && sType12 !== undefined)
      		{
      			sType12Conv = this.supprimerBlancsInutiles(sType12.toString());

      		}

      		return sType12Conv;
      	};


     	/**
      	 * Applique la suppression des blancs spécifiques au type 13 sur la chaîne sType13.</br>
      	 * Supprime les espaces en double.</br>
      	 * Supprime les blancs au début et à la fin.</br>
      	 * Supprime les blancs qui précèdent ou qui suivent un tiret ou un apostrophe.</br>
      	 *
      	 * @param sType13 : String
      	 * @return
      	 * 	String Chaîne convertie
      	 */
      	this.convertirType13SupprimeBlanc = function(sType13){
			var sType13Conv = null;
			  if (sType13!==null && sType13!==undefined)
			  {
				  sType13Conv = this.supprimerBlancsInutiles(sType13.toString());

			  }

			  return sType13Conv;
		};

      	/**
      	 * Contrôle que la donnée sType13 ne contient que des données autorisées pour son type
      	 *
      	 * @param sType13: String
      	 * @return
      	 * 		true : Si sType13 ne contient que des caractères autorisés</br>
      	 * 		false : Si sType13contient des caractères non autorisés</br>
      	 */
      	this.isType13AbsenceCaracteresNonAutorises = function(sType13){
			var isType13AbsenceCaracteresNonAutorises = true;

			if (sType13!==null && sType13!==undefined)
			{
				isType13AbsenceCaracteresNonAutorises = this.areCharactersValid(sType13,CHARS_TYPE13);
			}

			return isType13AbsenceCaracteresNonAutorises;
		};

		/**
      	 *
      	 * Conversion en majuscule et transformation des caractères français accentués.
      	 *
      	 * @param sType13 : String
      	 * @return
      	 * 		StringChaîne convertie
      	 */
		this.convertirType13EnMajusculeSansAccent = function(sType13){
			var sType13Conv = null;
			if (sType13 !== null && sType13 !== undefined)
			{
		  sType13 = sType13.toString();
		  // Passage en majuscule
				sType13Conv = sType13.toUpperCase();
				// Transforme l'ensemble des lettres accentuées sans accent
		  sType13Conv = this.convertirSansAccent(sType13Conv);

			}

			return sType13Conv;
		};

     	/**
      	 *
      	 *  Contrôle que la donnée sType13 respecte le format type13.</br>
      	 *  Avant l'appel à cette méthode, la donnée aura dû être transformé par la méthode convertirType13SupprimeBlanc</br>
      	 *
      	 * @param sType13 : String donnée à tester
      	 * @return
      	 * 		true : Si sType13 respecte le format du type13 attendu</br>
      	 * 		false : Si sType13 ne respecte pas le format du type13 attendu</br>
      	 *
      	 * @see #convertirType13SupprimeBlanc
      	 *
      	 */
      	this.isType13ControleOK = function(sType13){
			var isType13ControleOK = this.isTypeControlesCommunOK(sType13.toString(),false);

			return isType13ControleOK;
		};


      	/**
      	 * Teste si chaineTester ne contient que des caractères listés dans listeDeCaracteres
      	 *
      	 *
      	 * @param chaineTester String : Chaîne à tester
      	 * @param listeDeCaracteres String : liste des caractères autorisés
      	 * @return
      	 * 	True : Si chaineTester ne contient que des caractères listés dans listeDeCaracteres</br>
      	 * 	False sinon
      	 */
      	this.areCharactersValid = function(chaineTester, listeDeCaracteres)
      	{
          //console.log ("chaineTester = "+chaineTester+" listeDeCaracteres = "+listeDeCaracteres);
          if (chaineTester !== null && chaineTester !== undefined)
      		{
            chaineTester = chaineTester.toString();
            listeDeCaracteres = listeDeCaracteres.toString();
            var arrChar = chaineTester.split("");

        		for (var i = 0; i < arrChar.length; i++)
        		{
        			if (listeDeCaracteres.indexOf(arrChar[i]) === -1)
        			{
        				return false;
        			}
        		}
          }
        	return true;
      	};


      	/**
      	 * Teste si chaineTester comporte au moins un caractère alphabétique
      	 *
      	 *
      	 * @param chaineTester String : Chaîne à tester
      	 * @return
      	 * 	True : Si chaineTester comporte au moins un caractère alphabétique</br>
      	 * 	False sinon
      	 *
      	 * @see #CHARS_ALPHA
      	 */
      	this.isComporteAuMoinsCarAlpha = function(chaineTester){
          if (chaineTester !== null && chaineTester !== undefined)
      		{
            chaineTester = chaineTester.toString();
            var arrChar = chaineTester.split("");

        		for (var i = 0; i < arrChar.length; i++)
        		{
        			if (CHARS_ALPHA.indexOf(arrChar[i]) !== -1)
        			{
        				return true;
        			}
        		}
        		return false;
          }
          return true;
      	};

      	/**
      	 * Teste si chaineTester comporte au moins un caractère numérique
      	 *
      	 *
      	 * @param chaineTester String : Chaîne à tester
      	 * @return
      	 * 	True : Si chaineTester comporte au moins un caractère numérique</br>
      	 * 	False sinon
      	 *
      	 * @see #CHARS_NUM
      	 */
      	this.isComporteAuMoinsCarNum = function(chaineTester)
      	{
          if (chaineTester !== null && chaineTester !== undefined)
      		{
            chaineTester = chaineTester.toString();
            var arrChar = chaineTester.split("");

        		for (var i = 0; i < arrChar.length; i++)
        		{
        			if (CHARS_NUM.indexOf(arrChar[i]) !== -1)
        			{
        				return true;
        			}
        		}
        		return false;
          }
          return true;
      	};

      	/**
      	 * Supprime les espaces en double.</br>
      	 * Supprime les blancs au début et à la fin.</br>
      	 * Supprime les blancs qui précèdent ou qui suivent un tiret ou un apostrophe.</br>
      	 *
      	 * @param sType : String
      	 * @return
      	 * 	String Chaîne convertie
      	 */
      	this.supprimerBlancsInutiles = function(sType)
      	{
      		var sTypeConv;
          if (sType !== null && sType !== undefined)
      		{
            sType = sType.toString();
            // Suppression des blancs au début et à la fin
        		sTypeConv = sType.trim();
            // Supprime les espaces en double
        		sTypeConv = sTypeConv.replace(/[\s]{2,}/g," ");
        		// Supprime les blancs qui précèdent ou qui suivent un tiret ou une apostrophe;
        		sTypeConv = sTypeConv.replace(" '", "'");
        		sTypeConv = sTypeConv.replace(" -", "-");
        		sTypeConv = sTypeConv.replace("' ", "'");
        		sTypeConv = sTypeConv.replace("- ", "-");
          }
        	return sTypeConv;
        };

      	/**
      	 * Au moins un caractère alphabétique</br>
      	 * Double Tiret (1 autorisé si unDoubleTiretAutorise est à true,aucun autorisé si unDoubleTiretAutorise est à false)</br>
      	 * Contrôle la présence de double apostrophe (aucun autorisé)</br>
      	 * Premier caractère doit être différent du tiret et de l'aopstrophe</br>
      	 * Le tiret en dernier caractère n'est pas autorisé</br>
      	 * L'apostrophe ne peut suivre le tiret, ni le double tiret. Par contre, il peut les précéder</br>
      	 *
      	 * @param sType String : Chaîne à tester
      	 * @param unDoubleTiretAutorise : boolean (true si un seul double tiret autorisé, false si aucun autorisé)
      	 * @return
      	 * 		true : Si sType respecte le format des contrôles communs</br>
      	 * 		false : Si sType ne respecte pas le format des contrôles communs</br>
      	 *
      	 */
      	this.isTypeControlesCommunOK = function(sType, unDoubleTiretAutorise){
      		var isTypeControlesCommunOK = true;
          sType = sType.toString();
      		// Au moins un caractère alphabétique
      		if (sType !== null && sType !== undefined && (this.isComporteAuMoinsCarAlpha(sType)))
      		{
      			var indPremierDoubleTiret = sType.indexOf("--");
      			var indDernierDoubleTiret = sType.lastIndexOf("--");
      			if ((indPremierDoubleTiret!=-1) && ((!unDoubleTiretAutorise) || (indPremierDoubleTiret!=indDernierDoubleTiret)))
      			{
      				// Contrôle la présence de double tiret (aucun autorisé) si unDoubleTiretAutorise est à false
      				// 1 seul autorisé si unDoubleTiretAutorise est à true
      				isTypeControlesCommunOK = false;
      			}
      			else
      			{
      				var indDoubleApostrophe = sType.indexOf("''");

      				if (indDoubleApostrophe!==-1)
      				{
      					// Contrôle la présence de double apostrophe (aucun autorisé)
      					isTypeControlesCommunOK = false;
      				}
      				else
      				{
      					if ((sType.charAt(0)==='-') || (sType.charAt(0)==='\''))
      					{
      						// Premier caractère doit être différent du tiret et de l'apostrophe
      						isTypeControlesCommunOK = false;
      					}
      					else
      					{
      						if (sType.charAt(sType.length-1)==='-')
      						{
      							// Le tiret en dernier caractère n'est pas autorisé - Maj du DAF attendu
      							isTypeControlesCommunOK = false;
      						}
      						else
      						{
      							if (sType.indexOf("-'")!==-1)
      							{
      								// L'apostrophe ne peut suivre le tiret, ni le double tiret. Par contre, il peut les précéder
      								isTypeControlesCommunOK = false;
      							}
      						}
      					}
      				}
      			}

      		}
      		else
      		{
      			// sType ne contient pas au moins un caractère alphabétique
      			isTypeControlesCommunOK = false;
      		}


      		return isTypeControlesCommunOK;

      	};

        /**
      	 * Retourne le nombre d'occurence de l'élément à chercher dans la chaine
      	 * @param chaine Chaine
      	 * @param elementAChercher Element à chercher
      	 * @return nombre d'occurence
      	 */
      	this.compterOccurence = function(chaine,elementAChercher){
          var hit=0;
          var matcher;
          //console.log ("pattern = "+pattern);
      		while((matcher = elementAChercher.exec(chaine)) !== null)
          //while((matcher = pattern.exec(chaine)) !== null)
      		{
      			hit=hit+1;
      		}
          return hit;

      	};

        /**
      	 *
      	 * Transformation des caractères français accentués.
      	 *
      	 * @param sType12 : String
      	 * @return
      	 * 		StringChaîne convertie
      	 */
      	this.convertirSansAccent = function(sType){
      		var sTypeConv = null;
      		if (sType !== null && sType !== undefined)
      		{
				sTypeConv = sType.toString();
				//sType = sType.split();
				//pour chaque caractere si accentué le remplacer par un non accentué
				for(var i = 0;i < ACCENT.length; i++)
				{
					// si on trouve un accent dans la chaine on le remplace par le caractere non accentué correspondant
					var pos = sType.indexOf(ACCENT[i]);
					var count = 0;
					while ( pos !== -1 ) {
					   count++;
					   pos = sType.indexOf( ACCENT[i],pos + 1 );
					   sTypeConv = sTypeConv.replace(ACCENT[i],REPLACE_ACCENT[i]);
					}
				}

      		}
      		return sTypeConv;
		};

    }
})();

(function() {
    'use strict';

    angular
        .module('cnafComponentsTeleprocApp')
        .service('CnafCctAngularUtilsService', CnafCctAngularUtilsService);

    CnafCctAngularUtilsService.$inject = ['$rootScope'];

    function CnafCctAngularUtilsService($rootScope) {

        this.broadcastEvent = function (nomMethodeFils) {
            $rootScope.$broadcast (nomMethodeFils);
        };

        this.broadcastEventControle = function (nomMethodeFils,donneeControlee,dateDuJour) {
            //$rootScope.myEventControle = false;
            // Retourne false si le controle est ko (true si pas de controle au niveau du client ou controle OK)
            //$rootScope.$broadcast (nomMethodeFils,donneeControlee);
            $rootScope.$broadcast (nomMethodeFils,donneeControlee,dateDuJour);
        };

        this.getModelsOnPageAndReCreateData = function(form){
            // ici faire une premiere liste des model de la page
            var data = {};
            angular.forEach(form, function (input) {
                if (typeof input === 'object' && input.hasOwnProperty('$modelValue')) {
                    if(input.$modelValue !== undefined){
                        data[input.$name]= input.$modelValue;
                    }
                }
            });
            return data;
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('cnafComponentsTeleprocApp')
        .service('CnafCctCenterRadioButtonsService', CnafCctCenterRadioButtonsService);

    CnafCctCenterRadioButtonsService.$inject = ['$rootScope'];

    function CnafCctCenterRadioButtonsService($rootScope) {

        // Calcul la marge nécéssaire au span pour etre centré dans son label
        // la hauteur des elements est pure (sans marge, padding)
         this.calculateRadioButtonsMarging = function (labelHeight, spanHeight) {
             return ((labelHeight - spanHeight) / 2)+"px";
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('cnafComponentsTeleprocApp')
        .service('CnafCctPrimoDateService', CnafCctPrimoDateService);

    CnafCctPrimoDateService.$inject = ['CnafUserService'];

    function CnafCctPrimoDateService(CnafUserService) {

        /**
         * Permet de récupérer la date de l'environnement.
         *
         * @returns date du jour ou date paramétrée dans l'environnement
         */
        this.getDateToday = function() {
            var today;
            var dateEnv = CnafUserService.dateEnvCaffr();

            if (dateEnv !== "" && dateEnv.length == 8) {
                today = new Date(parseInt(dateEnv.substring(0,4)), (parseInt(dateEnv.substring(4,6)) - 1), parseInt(dateEnv.substring(6,8)));
            } else {
                throw new Error('Une erreur est survenue : Problème avec dateEnvCaffr : ' + dateEnv);
            }

            return today;
        };

        /**
         * la méthode renvoie la date du jour (date de l'environnement)
         *
         * @returns date
         */
        this.getDateDemarche = function() {
            return this.getDateToday();
        };

        /**
         * @deprecated utiliser la méthode dans CnafCctDateService
         */
        this.isAgeSupAXX = function (age, datenaissance, datedemarche) {
            if (datenaissance !== undefined) {
                var dateNaisPlusXX =  Date.parseExact(datenaissance, "d/M/yyyy");
                dateNaisPlusXX.add({years:age});
                if (datedemarche > dateNaisPlusXX) {
                    return (true);
                } else {
                    return (false);
                }
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('cnafComponentsTeleprocApp')
        .service('CnafCctWsBicIbanService', CnafCctWsBicIbanService);

    CnafCctWsBicIbanService.$inject = ['$http'];

    function CnafCctWsBicIbanService($http) {

        /**
         * Permet de valider via un WS le bic et l iban saisis.
         *
         * @param {any} bic
         * @param {any} iban
         * @returns code retour
         */
        this.httpVerifierBicIbanApprofondi = function(bic, iban) {
            return $http({
                method: "GET",
                url: '/api/cnafcompteleprocfront/v1/appelwscontrolebicibanapprofondi',
                params: {
                    "bic": bic,
                    "iban": iban
                }
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('cnafComponentsTeleprocApp')
        .service('CnafCctControleDateNaissanceService', CnafCctControleDateNaissanceService);

    CnafCctControleDateNaissanceService.$inject = [];

    function CnafCctControleDateNaissanceService() {

        // Controle sur la date de naissance
        // cette date doit être inférieure à la date du jour
        this.controleDateNaissance = function (dateNaissance, today) {
          var valueControle = true;
          if (dateNaissance !== undefined && dateNaissance.length >= 10){
            var dateNaisParse = Date.parseExact(dateNaissance, "d/M/yyyy");
            var dateToday = new Date(today);
            if (dateNaisParse && 'Invalid Date' != dateNaisParse) {
                if (dateNaisParse > dateToday) {
                  valueControle = false;
                }
            }
          }
          return valueControle;
        };

        // Controle sur la date de naissance
        // cette date doit être supérieure à une date antérieure à 6 mois par rapport à la date du jour
        // retourne le contenue du message d'erreur à afficher en cas de controle KO
        this.controleDateNaissanceMoins6 = function (dateNaissance, dateDuJour) {
            var dateMois6 = new Date(dateDuJour);
            dateMois6.addMonths(-6);
            var libelleMessageDateNaissanceSpecifique = undefined;
            if (dateNaissance && dateNaissance.length >= 10) {
                var dateNaisParse = Date.parseExact(dateNaissance, "d/M/yyyy");
                if (dateNaisParse && 'Invalid Date' != dateNaisParse) {
                    if (dateNaisParse < dateMois6) {
                        libelleMessageDateNaissanceSpecifique = 'La date de naissance doit être postérieure au ' + dateMois6.toString('dd/MM/yyyy');
                    }
                }
            }
            return libelleMessageDateNaissanceSpecifique;
        };

        this.controleDateNaissanceInf1880 = function(dateNaissance) {

            var valueControle = true;
            var date1880 = Date.parseExact("01/01/1880", "d/M/yyyy");
            if (dateNaissance && dateNaissance.length >= 10) {
                var dateNaissanceParse = Date.parseExact(dateNaissance, "d/M/yyyy");
                if (dateNaissanceParse && 'Invalid Date' != dateNaissanceParse) {
                    if (dateNaissanceParse < date1880) {
                        valueControle = false;
                    }
                }
            }

            return valueControle;
        };


    }
})();

(function() {
    'use strict';

    angular
        .module('cnafComponentsTeleprocApp')
        .service('CnafCctWsrnbService', CnafCctWsrnbService);

    CnafCctWsrnbService.$inject = ['$http'];

    function CnafCctWsrnbService($http) {

        /**
         * Permet de rechercher via un WS RNB une personne.
         *
         * @param {any} COMnaissance
         * @param {any} codePostalVille
         * @param {any} dateNaissance
         * @param {any} lieuNaissance
         * @param {any} nir
         * @param {any} nom
         * @param {any} paysNaissance
         * @param {any} prenom
         * @param {any} sexe
         * @returns RechercherCriteresRnbIdentPers
         */
        //this.httpRechercherRnbIdentPers = function(COMnaissance, codePostalVille, dateNaissance, lieuNaissance, nir, nom, paysNaissance, prenom, sexe) {
        this.httpRechercherRnbIdentPers = function(dataTOAPI) {
            return $http({
                method: "GET",
                url: '/api/cnafcompteleprocfront/v1/recherchernbrncps',
                params: {
                    "COMnaissance": dataTOAPI.COMnaissance,
                    "codePostalVille": dataTOAPI.codePostalVille,
                    "dateNaissance": dataTOAPI.dateNaissance,
                    "lieuNaissance": dataTOAPI.lieunaissance,
                    "nir": dataTOAPI.nir,
                    "nom": dataTOAPI.nom,
                    "paysNaissance": dataTOAPI.paysNaissance,
                    "prenom": dataTOAPI.prenom,
                    "sexe": dataTOAPI.sexe,
                    "datedemarche": dataTOAPI.datedemarche,
                    "situationAcces": dataTOAPI.situationAcces,
                    "codeOrga": dataTOAPI.codeOrga
                }
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('cnafComponentsTeleprocApp')
        .service('CnafCctGrossesseControleDateService', CnafCctGrossesseControleDateService);

    CnafCctGrossesseControleDateService.$inject = [];

    function CnafCctGrossesseControleDateService() {

        //Fonction de contrôle
        //Contrôle si la date de début de grossesse est postérieure ou égal à la date du
        //1er examen prénatal ou si date exam supérieure à date deb gro + 9 mois
        this.controleExamPreNatalDateSuperieur = function (examPreNatal, debutGrossesse) {
            //console.log("controleExamPreNatalDateSuperieur avec examPreNatal = "+examPreNatal+" debutGrossesse = "+debutGrossesse);
            var valueControle = true;
            if (examPreNatal !== undefined &&
                debutGrossesse !== undefined &&
                examPreNatal.length >= 10 && debutGrossesse.length >= 10){
              var dateDebutGrossesse = Date.parseExact(debutGrossesse, "d/M/yyyy");
              var dateDebGrossessePlus9mois = Date.parseExact(debutGrossesse, "d/M/yyyy");
              var dateExamPreNat = Date.parseExact(examPreNatal, "d/M/yyyy");
              //  console.log("controleExamPreNatalDateSuperieur avec examPreNatal = "+dateExamPreNat+" debutGrossesse = "+dateDebutGrossesse);
              //  console.log("controleExamPreNatalDateSuperieur avec dateDebGrossessePlus9mois = "+dateDebGrossessePlus9mois);
              if (dateDebutGrossesse && 'Invalid Date' != dateDebutGrossesse && dateExamPreNat && 'Invalid Date' != dateExamPreNat) {
                  dateDebGrossessePlus9mois.add({months:9});
                  if (dateDebutGrossesse >= dateExamPreNat) {
                    valueControle = false;
                  //  console.log ("false : "+dateDebutGrossesse+" > "+dateExamPreNat);
                  }
                  else if (dateExamPreNat > dateDebGrossessePlus9mois) {
                    valueControle = false;
                    //console.log ("false : "+dateExamPreNat+" > "+dateDebGrossessePlus9mois);
                  }
              }
            }
            return valueControle;
        };


        // Controle sur la date de premier examen pre natal
        // cette date doit être inférieure à la date du jour
        this.controleDateExamPreNat = function (examPreNatal, today) {
          var valueControle = true;
          if (examPreNatal !== undefined && examPreNatal.length >= 10){
            var dateExamPreNat = Date.parseExact(examPreNatal, "d/M/yyyy");
            var dateToday = new Date(today);
            if (dateExamPreNat && 'Invalid Date' != dateExamPreNat) {
                if (dateExamPreNat > dateToday) {
                  valueControle = false;
                }
            }
          }
          return valueControle;
        };

        // Controle sur la date debut grossesse
        // il faut que la date de debut grossesse soit inférieure ou égale
        // à la date du jour et que la date de debut de grossesse soit
        // soit supérieure à la date du jour moins 9 mois
        this.controleDateDebGro = function (debutGrossesse, today) {
          var valueControle = true;
          //console.log("controleDateDebGro avec today = "+today+" debutGrossesse = "+debutGrossesse);
          if (debutGrossesse !== undefined && debutGrossesse.length >= 10){
              var dateDebutGrossesse = Date.parseExact(debutGrossesse, "d/M/yyyy");
              var dateToday = new Date(today);
              var dateTodayMoins9mois = new Date(today);
              dateTodayMoins9mois.add({months:-9});
              //console.log("controleDateDebGro avec today = "+dateToday+" debutGrossesse = "+dateDebutGrossesse);
              //console.log("controleDateDebGro avec dateTodayMoins9mois = "+dateTodayMoins9mois);
              if (dateDebutGrossesse && 'Invalid Date' != dateDebutGrossesse) {
                  if (dateDebutGrossesse > dateToday) {
                    valueControle = false;
                    //console.log ("false : "+dateDebutGrossesse+" > "+dateToday);
                  }
                  else if (dateDebutGrossesse <= dateTodayMoins9mois)
                  {
                    valueControle = false;
                    //console.log ("false : "+dateDebutGrossesse+" <= "+dateTodayMoins9mois);
                  }
              }
          }
          return valueControle;
        };

        // Si l’allocataire saisit une date de début de grossesse <=date de naissance
        // de son dernier enfant  alors à la sortie du champ on doit voir apparaître le message :
        // « Vérifier la date de début de grossesse »
        this.controleDateDernierEnfant = function (debutGrossesse, dernierEnfant) {
          var dateDebutGrossesse = Date.parseExact(debutGrossesse, "d/M/yyyy");
          if (dernierEnfant && dateDebutGrossesse && 'Invalid Date' != dateDebutGrossesse)
          {
              //console.log("controleDateDernierEnfant avec dernierEnfant = "+dernierEnfant+" debutGrossesse = "+debutGrossesse+", résultat : " + (dernierEnfant < dateDebutGrossesse));
              return dernierEnfant < dateDebutGrossesse;
          }
          return true;
        };
    }
})();

(function () {
    'use strict';

    CnafCctRecapAccesController.$inject = [];

    function CnafCctRecapAccesController() {
    }



    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctRecapAcces
     *
     * @description
     * cnafCctRecapAcces affiche le bloc RECAP du test d'acces
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */


    angular.module('cnafComponentsTeleprocApp').component('cnafCctRecapAcces', {
        templateUrl: 'components/cnaf-cct-recap/cnaf-cct-recap-acces/cnaf-cct-recap-acces.html',
        bindings: {
            data: '='
        },
        controllerAs: 'vm',
        controller: CnafCctRecapAccesController
    });

})();

(function () {
    'use strict';

    CnafCctRecapAdresseController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes', 'CnafCctDateService'];

    function CnafCctRecapAdresseController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes, CnafCctDateService) {
        var vm = this;

        //définition des fonctions
        // Elles servent dans la page html !
        vm.litteralMonth = CnafCctDateService.getLitteralMonth;
        vm.parseDate = CnafCctDateService.parseDate;
    }



    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctRecapAdresse
     *
     * @description
     * cnafCctRecapAdresse affiche le bloc RECAP des champs de saisie pour l'etat civil
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */


    angular.module('cnafComponentsTeleprocApp').component('cnafCctRecapAdresse', {
        templateUrl: 'components/cnaf-cct-recap/cnaf-cct-recap-adresse/cnaf-cct-recap-adresse.html',
        bindings: {
            data: '=',
            recapform: '=',
            projet: '='
        },
        controllerAs: 'vm',
        controller: CnafCctRecapAdresseController
    });

})();

(function () {
    'use strict';

    CnafCctRecapCoordbancController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes', 'CnafCctIbanService'];

    function CnafCctRecapCoordbancController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes, CnafCctIbanService) {
        var vm = this;

        vm.affichageIbanAvecBlanc = CnafCctIbanService.affichageIbanAvecBlanc;
    }


    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctRecapCoordbanc
     *
     * @description
     * cnafCctRecapCoordbanc affiche le bloc RECAP des champs de saisie pour l'etat civil
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */


    angular.module('cnafComponentsTeleprocApp').component('cnafCctRecapCoordbanc', {
        templateUrl: 'components/cnaf-cct-recap/cnaf-cct-recap-coordbanc/cnaf-cct-recap-coordbanc.html',
        bindings: {
            data: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafCctRecapCoordbancController
    });

})();

(function () {
    'use strict';

    CnafCctRecapCourrielController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafCctRecapCourrielController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {

    }



    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctRecapCourriel
     *
     * @description
     * cnafCctRecapCourriel affiche le bloc RECAP des champs de saisie pour l'etat civil
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */


    angular.module('cnafComponentsTeleprocApp').component('cnafCctRecapCourriel', {
        templateUrl: 'components/cnaf-cct-recap/cnaf-cct-recap-courriel/cnaf-cct-recap-courriel.html',
        bindings: {
            data: '=',
            donneecommune: '=',
            recapform: '=',
            projet: '='
        },
        controllerAs: 'vm',
        controller: CnafCctRecapCourrielController
    });

})();

(function () {
    'use strict';

    CnafCctRecapEtatcivilController.$inject = ['CnafCctNirService'];

    function CnafCctRecapEtatcivilController(CnafCctNirService) {
        var vm = this;

        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        
        /**
        * Affiche le Nir avec des blancs
        */
        vm.afficherNirAvecBlanc = function(nir)
        {
            return CnafCctNirService.affichageNirAvecBlanc(nir);
        };

    }


    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctRecapEtatcivil
     *
     * @description
     * cnafCctRecapEtatcivil affiche le bloc RECAP des champs de saisie pour l'etat civil
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */


    angular.module('cnafComponentsTeleprocApp').component('cnafCctRecapEtatcivil', {
        templateUrl: 'components/cnaf-cct-recap/cnaf-cct-recap-etatcivil/cnaf-cct-recap-etatcivil.html',
        bindings: {
            data: '=',
            recapform: '=' ,
            conjoint: '='
        },
        controllerAs: 'vm',
        controller: CnafCctRecapEtatcivilController
    });

})();

(function () {
    'use strict';

    CnafCctRecapGrossesseController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafCctRecapGrossesseController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {
        var vm = this;

        vm.affichageTelephoneAvecBlanc = function(telephone) {
            var telephoneAvecBlanc = "";
            if (telephone && telephone!=="")
            {
                  // Décomposition du téléphopne
                  var regExp = new RegExp("^([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2}).*$", "g");

                  if (regExp.test(telephone))
                  {
                      telephoneAvecBlanc = RegExp.$1+" "+RegExp.$2+" "+RegExp.$3+" "+RegExp.$4+" "+RegExp.$5;                 }
            }
            return telephoneAvecBlanc;
        };


    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctRecapGrossesse
     *
     * @description
     * cnafCctRecapGrossesse affiche le bloc RECAP des champs de saisie pour la grossesse
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */


    angular.module('cnafComponentsTeleprocApp').component('cnafCctRecapGrossesse', {
        templateUrl: 'components/cnaf-cct-recap/cnaf-cct-recap-grossesse/cnaf-cct-recap-grossesse.html',
        bindings: {
            data: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafCctRecapGrossesseController
    });

})();

(function () {
    'use strict';

    CnafCctRecapHospitalisationController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafCctRecapHospitalisationController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {
    }



    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctRecapHospitalisation
     *
     * @description
     * cnafCctRecapHospitalisation affiche le bloc RECAP des champs de saisie pour l'etat civil
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */


    angular.module('cnafComponentsTeleprocApp').component('cnafCctRecapHospitalisation', {
        templateUrl: 'components/cnaf-cct-recap/cnaf-cct-recap-hospitalisation/cnaf-cct-recap-hospitalisation.html',
        bindings: {
            data: '=',
            donneecommune: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafCctRecapHospitalisationController
    });

})();

(function () {
    'use strict';

    CnafCctRecapPrestationspercuesController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafCctRecapPrestationspercuesController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {
    }



    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctRecapPrestationspercues
     *
     * @description
     * cnafCctRecapPrestationspercues affiche le bloc RECAP des champs de saisie pour l'etat civil
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */


    angular.module('cnafComponentsTeleprocApp').component('cnafCctRecapPrestationspercues', {
        templateUrl: 'components/cnaf-cct-recap/cnaf-cct-recap-prestationspercues/cnaf-cct-recap-prestationspercues.html',
        bindings: {
            data: '=',
            donneecommune: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafCctRecapPrestationspercuesController
    });

})();

(function () {
    'use strict';

    CnafCctRecapRessourcesController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafCctRecapRessourcesController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {
        var vm = this;

        vm.affichageTelephoneAvecBlanc = function(telephone) {
            var telephoneAvecBlanc = "";
            if (telephone && telephone!=="")
            {
                  // Décomposition du téléphopne
                  var regExp = new RegExp("^([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2}).*$", "g");

                  if (regExp.test(telephone))
                  {
                      telephoneAvecBlanc = RegExp.$1+" "+RegExp.$2+" "+RegExp.$3+" "+RegExp.$4+" "+RegExp.$5;                 }
            }
            return telephoneAvecBlanc;
        };


    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctRecapRessources
     *
     * @description
     * cnafCctRecapRessources affiche le bloc RECAP des champs de saisie pour les ressources
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */


    angular.module('cnafComponentsTeleprocApp').component('cnafCctRecapRessources', {
        templateUrl: 'components/cnaf-cct-recap/cnaf-cct-recap-ressources/cnaf-cct-recap-ressources.html',
        bindings: {
            data: '=',
            donneecommune: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafCctRecapRessourcesController
    });

})();

(function () {
    'use strict';

    CnafCctRecapSitproController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafCctRecapSitproController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {
    }


    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctRecapSitpro
     *
     * @description
     * cnafCctRecapSitpro affiche le bloc RECAP des champs de saisie pour l'etat civil
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */



    // !!!!!!!!!!!!!!!!!!!!      A T T E N T I O N        !!!!!!!!!!!!!!!
    //   Composant Recap Sitpro réservé à l'Etudiant Isolé sans enfant
    // !!!!!!!!!!!!!!!!!!!!      A T T E N T I O N        !!!!!!!!!!!!!!!


    angular.module('cnafComponentsTeleprocApp').component('cnafCctRecapSitpro', {
        templateUrl: 'components/cnaf-cct-recap/cnaf-cct-recap-sitpro/cnaf-cct-recap-sitpro.html',
        bindings: {
            data: '=',
            donneecommune: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafCctRecapSitproController
    });

})();

(function () {
    'use strict';

    CnafCctRecapChoixactiviteautresituationController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafCctRecapChoixactiviteautresituationController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {
    }



    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctRecapChoixactiviteautresituation
     *
     * @description
     * cnafCctRecapChoixactiviteautresituation affiche le bloc RECAP des champs de saisie pour l'etat civil
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */


    angular.module('cnafComponentsTeleprocApp').component('cnafCctRecapChoixactiviteautresituation', {
        templateUrl: 'components/cnaf-cct-recap/cnaf-cct-recap-sitpro-choixactiviteautresituation/cnaf-cct-sitpro-recap-choixactiviteautresituation.html',
        bindings: {
            data: '=',
            donneecommune: '=',
            index: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafCctRecapChoixactiviteautresituationController
    });

})();

(function () {
    'use strict';

    CnafCctRecapChoixactivitechomageController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafCctRecapChoixactivitechomageController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {
    }





    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctRecapChoixactivitechomage
     *
     * @description
     * cnafCctRecapChoixactivitechomage affiche le bloc RECAP des champs de saisie pour l'etat civil
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */


    angular.module('cnafComponentsTeleprocApp').component('cnafCctRecapChoixactivitechomage', {
        templateUrl: 'components/cnaf-cct-recap/cnaf-cct-recap-sitpro-choixactivitechomage/cnaf-cct-sitpro-recap-choixactivitechomage.html',
        bindings: {
            data: '=',
            donneecommune: '=',
            index: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafCctRecapChoixactivitechomageController
    });

})();

(function () {
    'use strict';

    CnafCctRecapChoixactivitecongesdiversController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafCctRecapChoixactivitecongesdiversController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {
    }



    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctRecapChoixactivitecongesdivers
     *
     * @description
     * cnafCctRecapChoixactivitecongesdivers affiche le bloc RECAP des champs de saisie pour l'etat civil
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */


    angular.module('cnafComponentsTeleprocApp').component('cnafCctRecapChoixactivitecongesdivers', {
        templateUrl: 'components/cnaf-cct-recap/cnaf-cct-recap-sitpro-choixactivitecongesdivers/cnaf-cct-sitpro-recap-choixactivitecongesdivers.html',
        bindings: {
            data: '=',
            donneecommune: '=',
            index: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafCctRecapChoixactivitecongesdiversController
    });

})();

(function () {
    'use strict';

    CnafCctRecapSitproChoixactiviteetudiantController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafCctRecapSitproChoixactiviteetudiantController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {
    }


    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctRecapSitproChoixactiviteetudiant
     *
     * @description
     * cnafCctRecapSitproChoixactiviteetudiant affiche le bloc RECAP des champs de saisie pour l'activité ETUDIANT
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */


    angular.module('cnafComponentsTeleprocApp').component('cnafCctRecapSitproChoixactiviteetudiant', {
        templateUrl: 'components/cnaf-cct-recap/cnaf-cct-recap-sitpro-choixactiviteetudiant/cnaf-cct-recap-sitpro-choixactiviteetudiant.html',
        bindings: {
            data: '=',
            donneecommune: '=',
            index: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafCctRecapSitproChoixactiviteetudiantController
    });

})();

(function () {
    'use strict';

    CnafCctRecapChoixactiviteinvaliditeController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafCctRecapChoixactiviteinvaliditeController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {
    }



    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctRecapChoixactiviteinvalidite
     *
     * @description
     * cnafCctRecapChoixactiviteinvalidite affiche le bloc RECAP des champs de saisie pour l'etat civil
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */


    angular.module('cnafComponentsTeleprocApp').component('cnafCctRecapChoixactiviteinvalidite', {
        templateUrl: 'components/cnaf-cct-recap/cnaf-cct-recap-sitpro-choixactiviteinvalidite/cnaf-cct-sitpro-recap-choixactiviteinvalidite.html',
        bindings: {
            data: '=',
            donneecommune: '=',
            index: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafCctRecapChoixactiviteinvaliditeController
    });

})();

(function () {
    'use strict';

    CnafCctRecapChoixactivitenonsalarieeController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafCctRecapChoixactivitenonsalarieeController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {
    }



    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctRecapChoixactivitenonsalariee
     *
     * @description
     * cnafCctRecapChoixactivitenonsalariee affiche le bloc RECAP des champs de saisie pour l'etat civil
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */


    angular.module('cnafComponentsTeleprocApp').component('cnafCctRecapChoixactivitenonsalariee', {
        templateUrl: 'components/cnaf-cct-recap/cnaf-cct-recap-sitpro-choixactivitenonsalariee/cnaf-cct-sitpro-recap-choixactivitenonsalariee.html',
        bindings: {
            data: '=',
            donneecommune: '=',
            index: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafCctRecapChoixactivitenonsalarieeController
    });

})();

(function () {
    'use strict';

    CnafCctRecapChoixactiviteretraiteController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafCctRecapChoixactiviteretraiteController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {
    }



    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctRecapChoixactiviteretraite
     *
     * @description
     * cnafCctRecapChoixactiviteretraite affiche le bloc RECAP des champs de saisie pour l'etat civil
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */


    angular.module('cnafComponentsTeleprocApp').component('cnafCctRecapChoixactiviteretraite', {
        templateUrl: 'components/cnaf-cct-recap/cnaf-cct-recap-sitpro-choixactiviteretraite/cnaf-cct-sitpro-recap-choixactiviteretraite.html',
        bindings: {
            data: '=',
            donneecommune: '=',
            index: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafCctRecapChoixactiviteretraiteController
    });

})();

(function () {
    'use strict';

    CnafCctRecapChoixactivitesalarieeController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafCctRecapChoixactivitesalarieeController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {
    }



    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctRecapChoixactivitesalariee
     *
     * @description
     * cnafCctRecapChoixactivitesalariee affiche le bloc RECAP des champs de saisie pour l'etat civil
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */


    angular.module('cnafComponentsTeleprocApp').component('cnafCctRecapChoixactivitesalariee', {
        templateUrl: 'components/cnaf-cct-recap/cnaf-cct-recap-sitpro-choixactivitesalariee/cnaf-cct-sitpro-recap-choixactivitesalariee.html',
        bindings: {
            data: '=',
            donneecommune: '=',
            index: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafCctRecapChoixactivitesalarieeController
    });

})();

(function () {
    'use strict';

    CnafCctRecapChoixactivitestagiaireController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafCctRecapChoixactivitestagiaireController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {
    }



    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctRecapChoixactivitestagiaire
     *
     * @description
     * cnafCctRecapChoixactivitestagiaire affiche le bloc RECAP des champs de saisie pour l'etat civil
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */


    angular.module('cnafComponentsTeleprocApp').component('cnafCctRecapChoixactivitestagiaire', {
        templateUrl: 'components/cnaf-cct-recap/cnaf-cct-recap-sitpro-choixactivitestagiaire/cnaf-cct-sitpro-recap-choixactivitestagiaire.html',
        bindings: {
            data: '=',
            donneecommune: '=',
            index: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafCctRecapChoixactivitestagiaireController
    });

})();

(function () {
    'use strict';

    CnafCctRecapTelcourrielController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafCctRecapTelcourrielController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {
        var vm = this;

        vm.affichageTelephoneAvecBlanc = function(telephone) {
            var telephoneAvecBlanc = "";
            if (telephone && telephone!=="")
            {
                  // Décomposition du téléphopne
                  var regExp = new RegExp("^([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2}).*$", "g");

                  if (regExp.test(telephone))
                  {
                      telephoneAvecBlanc = RegExp.$1+" "+RegExp.$2+" "+RegExp.$3+" "+RegExp.$4+" "+RegExp.$5;                 }
            }
            return telephoneAvecBlanc;
        };

    }



    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctRecapTelcourriel
     *
     * @description
     * cnafCctRecapTelcourriel affiche le bloc RECAP des champs de saisie pour l'etat civil
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */


    angular.module('cnafComponentsTeleprocApp').component('cnafCctRecapTelcourriel', {
        templateUrl: 'components/cnaf-cct-recap/cnaf-cct-recap-telcourriel/cnaf-cct-recap-telcourriel.html',
        bindings: {
            data: '=',
            donneecommune: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafCctRecapTelcourrielController
    });

})();

(function () {
    'use strict';

    CnafCctRecapTelephonesController.$inject = ['CnafCctTelephoneService'];

    function CnafCctRecapTelephonesController(CnafCctTelephoneService) {
        var vm = this;

        vm.numTelAvecBlanc = function(telephone) {
            return CnafCctTelephoneService.affichageTelephoneAvecBlanc(telephone);
        };

    }



    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctRecapTelephones
     *
     * @description
     * cnafCctRecapTelephones affiche le bloc RECAP des téléphones (Coordonnées de contact)
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */


    angular.module('cnafComponentsTeleprocApp').component('cnafCctRecapTelephones', {
        templateUrl: 'components/cnaf-cct-recap/cnaf-cct-recap-telephones/cnaf-cct-recap-telephones.html',
        bindings: {
            data: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafCctRecapTelephonesController
    });

})();

(function() {
    'use strict';

    CnafCctAucunRevenuController.$inject = ['$scope'];

    function CnafCctAucunRevenuController($scope) {
        var vm = this;

        // Retourne true si rubrique cochee et remplie
        vm.controleDecochage = function() {
            return vm.data.controle.aucunrevenuChckBx;
        };

        $scope.$on('controleAucunRevenuComponent', function(e) {
            vm.data.controle.controleAucunRevenu = vm.controleDecochage();
        });

        $scope.$on('clearAucunRevenuComponent', function(e) {
            vm.data.controle.aucunrevenuChckBx = false;
            vm.data.controle.controleAucunRevenu = false;
        });
    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctAucunRevenu
     *
     * @description
     * cnafCctAucunRevenu affiche la case à cocher si aucuns revenus
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} aucunrevenuform formulaire
     * @param {Object} erroraucunrevenu erreurs
     * @param {boolean} desactive permet de désactiver/activer la case à cocher
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */
    angular.module('cnafComponentsTeleprocApp').component('cnafCctAucunRevenu', {
        templateUrl: 'components/cnaf-cct-ressources/cnaf-cct-aucun-revenu/cnaf-cct-aucun-revenu.component.html',
        bindings: {
            data: '=',
            aucunrevenuform: "=",
            erroraucunrevenu: "=",
            desactive: "<"
        },
        controllerAs: 'vm',
        controller: CnafCctAucunRevenuController
    });
})();

(function() {
    'use strict';

    CnafCctAutresRevenusController.$inject = ['$scope',
        'CnafComponentsTeleprocConstantes',
        'CnafCctRessourcesService'];

    function CnafCctAutresRevenusController($scope,
        CnafComponentsTeleprocConstantes,
        CnafCctRessourcesService) {
        var vm = this;

        // Retourne true si rubrique cochee et remplie
        vm.controleDecochage = function() {
            if (vm.data.controle.autresrevenusChckBx) {
                if( (vm.data.ressources.epargneHandicap && vm.data.ressources.epargneHandicap > 0) || (vm.data.ressources.revenusAutres && vm.data.ressources.revenusAutres > 0) ) {
                    return true;
                }else {
                    return false;
                }
            }
            return false;
        };

        $scope.$on('controleAutresRevenusComponent', function(e) {
            vm.data.controle.controleAutresRevenus = vm.controleDecochage();
        });

        $scope.$on('clearAutresRevenusComponent', function(e) {
            vm.data.controle.autresrevenusChckBx = false;
            vm.data.controle.controleAutresRevenus = false;
        });

        $scope.$on('collectDataAutresRevenusComponent', function(e) {
            if(vm.data.ressources){
                if(vm.data.ressources.epargneHandicap){
                    if(!CnafCctRessourcesService.ressourceDejaExistante(vm.data.ressources.references, CnafComponentsTeleprocConstantes.ref23)){
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref23, Number(vm.data.ressources.epargneHandicap));
                    } else {
                        var valeurExistante = vm.data.ressources.references.get(CnafComponentsTeleprocConstantes.ref23);
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref23, (Number(valeurExistante) + Number(vm.data.ressources.epargneHandicap)));
                    }
                }
                if(vm.data.ressources.revenusAutres){
                    if(!CnafCctRessourcesService.ressourceDejaExistante(vm.data.ressources.references, CnafComponentsTeleprocConstantes.ref41)){
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref41, Number(vm.data.ressources.revenusAutres));
                    } else {
                        var valeurExistante = vm.data.ressources.references.get(CnafComponentsTeleprocConstantes.ref41);
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref41, (Number(valeurExistante) + Number(vm.data.ressources.revenusAutres)));
                    }
                }
            }
        });

        vm.champsVideOuZero = function() {
            if(vm.data.controle.autresrevenusChckBx) {
                if(vm.data.ressources.epargneHandicap > 0 || vm.data.ressources.revenusAutres > 0){
                    return true;
                }else {
                    return false;
                }
            }
            return false;
        };
    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctAutresRevenus
     *
     * @description
     * cnafCctAutresRevenus affiche les zones pour la saisie des autres revenus
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} autresrevenusform formulaire
     * @param {Object} errorautresrevenus erreurs
     * @param {boolean} desactive permet de désactiver/activer la saisie des autres revenus
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */
    angular.module('cnafComponentsTeleprocApp').component('cnafCctAutresRevenus', {
        templateUrl: 'components/cnaf-cct-ressources/cnaf-cct-autres-revenus/cnaf-cct-autres-revenus.component.html',
        bindings: {
            data: '=',
            autresrevenusform: "=",
            errorautresrevenus: "=",
            desactive: "<"
        },
        controllerAs: 'vm',
        controller: CnafCctAutresRevenusController
    });
})();

(function() {
    'use strict';

    CnafCctChargesDeductiblesController.$inject = ['$scope',
        'CnafComponentsTeleprocConstantes',
        'CnafCctRessourcesService'];

    function CnafCctChargesDeductiblesController($scope,
        CnafComponentsTeleprocConstantes,
        CnafCctRessourcesService) {
        var vm = this;

        // Retourne true si rubrique cochee et remplie
        vm.controleDecochage = function() {
            if (vm.data.controle.chargesdeductiblesChckBx) {
                if( (vm.data.ressources.pensionsAlimVersees && vm.data.ressources.pensionsAlimVersees > 0) ||
                    (vm.data.ressources.csgDeductibles && vm.data.ressources.csgDeductibles > 0) ||
                    (vm.data.ressources.epargneRetraite && vm.data.ressources.epargneRetraite > 0) ) {
                    return true;
                }else {
                    return false;
                }
            }
            return false;
        };

        $scope.$on('controleChargesDeductiblesComponent', function(e) {
            vm.data.controle.controleChargesDeductibles = vm.controleDecochage();
        });

        $scope.$on('clearChargesDeductiblesComponent', function(e) {
            vm.data.controle.chargesdeductiblesChckBx = false;
            vm.data.controle.controleChargesDeductibles = false;
        });

        $scope.$on('collectDataChargesDeductiblesComponent', function(e) {
            if(vm.data.ressources){
                if(vm.data.ressources.pensionsAlimVersees){
                    if(!CnafCctRessourcesService.ressourceDejaExistante(vm.data.ressources.references, CnafComponentsTeleprocConstantes.ref60)){
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref60, Number(vm.data.ressources.pensionsAlimVerseesRevalorisees));
                    } else {
                        var valeurExistante = vm.data.ressources.references.get(CnafComponentsTeleprocConstantes.ref60);
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref60, (Number(valeurExistante) + Number(vm.data.ressources.pensionsAlimVerseesRevalorisees)));
                    }
                }
                if(vm.data.ressources.csgDeductibles){
                    if(!CnafCctRessourcesService.ressourceDejaExistante(vm.data.ressources.references, CnafComponentsTeleprocConstantes.ref64)){
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref64, Number(vm.data.ressources.csgDeductibles));
                    } else {
                        var valeurExistante = vm.data.ressources.references.get(CnafComponentsTeleprocConstantes.ref64);
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref64, (Number(valeurExistante) + Number(vm.data.ressources.csgDeductibles)));
                    }
                }
                if(vm.data.ressources.epargneRetraite){
                    if(!CnafCctRessourcesService.ressourceDejaExistante(vm.data.ressources.references, CnafComponentsTeleprocConstantes.ref65)){
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref65, Number(vm.data.ressources.epargneRetraite));
                    } else {
                        var valeurExistante = vm.data.ressources.references.get(CnafComponentsTeleprocConstantes.ref65);
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref65, (Number(valeurExistante) + Number(vm.data.ressources.epargneRetraite)));
                    }
                }
            }
        });

        vm.champsVideOuZero = function() {
            if(vm.data.controle.chargesdeductiblesChckBx) {
                if( (vm.data.ressources.pensionsAlimVersees && vm.data.ressources.pensionsAlimVersees > 0) ||
                    (vm.data.ressources.csgDeductibles && vm.data.ressources.csgDeductibles > 0) ||
                    (vm.data.ressources.epargneRetraite && vm.data.ressources.epargneRetraite > 0) ) {
                    return true;
                }else {
                    return false;
                }
            }
            return false;
        };
    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctChargesDeductibles
     *
     * @description
     * cnafCctChargesDeductibles affiche les zones pour la saisie des charges déductibles
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} chargesdeductiblesform formulaire
     * @param {Object} errorchargesdeductibles erreurs
     * @param {boolean} desactive permet de désactiver/activer la saisie des charges déductibles
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */
    angular.module('cnafComponentsTeleprocApp').component('cnafCctChargesDeductibles', {
        templateUrl: 'components/cnaf-cct-ressources/cnaf-cct-charges-deductibles/cnaf-cct-charges-deductibles.component.html',
        bindings: {
            data: '=',
            chargesdeductiblesform: "=",
            errorchargesdeductibles: "=",
            controle: "=",
            desactive: "<"
        },
        controllerAs: 'vm',
        controller: CnafCctChargesDeductiblesController
    });
})();

(function() {
    'use strict';

    CnafCctIndemnitesSecuController.$inject = ['$scope',
        'CnafComponentsTeleprocConstantes',
        'CnafCctRessourcesService'];

    function CnafCctIndemnitesSecuController($scope,
        CnafComponentsTeleprocConstantes,
        CnafCctRessourcesService) {
        var vm = this;

        // Retourne true si rubrique cochee et remplie
        vm.controleDecochage = function() {
            if (vm.data.controle.indemnitesSecuChckBx) {
                if( (vm.data.ressources.indemnitesJournaFracImpos && vm.data.ressources.indemnitesJournaFracImpos > 0) ||
                    (vm.data.ressources.indemnitesJournaFracNonImpos && vm.data.ressources.indemnitesJournaFracNonImpos > 0)) {
                    return true;
                }else {
                    return false;
                }
            }
            return false;
        };

        $scope.$on('controleIndemnitesSecuComponent', function(e) {
            vm.data.controle.controleIndemnitesSecu = vm.controleDecochage();
        });

        $scope.$on('clearIndemnitesSecuComponent', function(e) {
            vm.data.controle.indemnitesSecuChckBx = false;
            vm.data.controle.controleChargesDeductibles = false;
        });

        $scope.$on('collectDataIndemnitesSecuComponent', function(e) {
            if(vm.data.ressources){
                if(vm.data.ressources.indemnitesJournaFracImpos){
                    if(!CnafCctRessourcesService.ressourceDejaExistante(vm.data.ressources.references, CnafComponentsTeleprocConstantes.ref1)){
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref1, Number(vm.data.ressources.indemnitesJournaFracImpos));
                    } else {
                        var valeurExistante = vm.data.ressources.references.get(CnafComponentsTeleprocConstantes.ref1);
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref1, (Number(valeurExistante) + Number(vm.data.ressources.indemnitesJournaFracImpos)));
                    }
                }
                if(vm.data.ressources.indemnitesJournaFracNonImpos){
                    if(!CnafCctRessourcesService.ressourceDejaExistante(vm.data.ressources.references, CnafComponentsTeleprocConstantes.ref12)){
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref12, Number(vm.data.ressources.indemnitesJournaFracNonImpos));
                    } else {
                        var valeurExistante = vm.data.ressources.references.get(CnafComponentsTeleprocConstantes.ref12);
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref12, (Number(valeurExistante) + Number(vm.data.ressources.indemnitesJournaFracNonImpos)));
                    }
                }
            }
        });

        vm.champsVideOuZero = function() {
            if(vm.data.controle.indemnitesSecuChckBx) {
                if(vm.data.ressources.indemnitesJournaFracImpos > 0 || vm.data.ressources.indemnitesJournaFracNonImpos > 0){
                    return true;
                }else {
                    return false;
                }
            }
            return false;
        };
    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctIndemnitesSecu
     *
     * @description
     * cnafCctIndemnitesSecu affiche les zones pour la saisie des indemnités de sécurité sociales
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} indemnitessecuform formulaire
     * @param {Object} errorindemnitessecu erreurs
     * @param {boolean} desactive permet de désactiver/activer la saisie des indemnités de sécurité sociales
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */
    angular.module('cnafComponentsTeleprocApp').component('cnafCctIndemnitesSecu', {
        templateUrl: 'components/cnaf-cct-ressources/cnaf-cct-indemnites-secu/cnaf-cct-indemnites-secu.component.html',
        bindings: {
            data: '=',
            indemnitessecuform: "=",
            errorindemnitessecu: "=",
            desactive: "<"
        },
        controllerAs: 'vm',
        controller: CnafCctIndemnitesSecuController
    });
})();

(function() {
    'use strict';

    CnafCctPensionsAlimentairesController.$inject = ['$scope',
        'CnafComponentsTeleprocConstantes',
        'CnafCctRessourcesService'];

    function CnafCctPensionsAlimentairesController($scope,
        CnafComponentsTeleprocConstantes,
        CnafCctRessourcesService) {
        var vm = this;

        // Retourne true si rubrique cochee et remplie
        vm.controleDecochage = function() {
            if (vm.data.controle.pensionsalimentairesChckBx) {
                if( (vm.data.ressources.pensionsAlimentaires && vm.data.ressources.pensionsAlimentaires > 0)) {
                    return true;
                }else {
                    return false;
                }
            }
            return false;
        };

        $scope.$on('controlePensionsAlimentairesComponent', function(e) {
            vm.data.controle.controlePensionsAlimentaires = vm.controleDecochage();
        });

        $scope.$on('clearPensionsAlimentairesComponent', function(e) {
            vm.data.controle.pensionsalimentairesChckBx = false;
            vm.data.controle.controlePensionsAlimentaires = false;
        });

        $scope.$on('collectDataIndemnitesSecuComponent', function(e) {
            if(vm.data.ressources){
                if(vm.data.ressources.pensionsAlimentaires){
                    if(!CnafCctRessourcesService.ressourceDejaExistante(vm.data.ressources.references, CnafComponentsTeleprocConstantes.ref26)){
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref26, Number(vm.data.ressources.pensionsAlimentaires));
                    } else {
                        var valeurExistante = vm.data.ressources.references.get(CnafComponentsTeleprocConstantes.ref26);
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref26, (Number(valeurExistante) + Number(vm.data.ressources.pensionsAlimentaires)));
                    }
                }
            }
        });

        vm.champsVideOuZero = function() {
            if(vm.data.controle.pensionsalimentairesChckBx) {
                if(vm.data.ressources.pensionsAlimentaires > 0){
                    return true;
                }else {
                    return false;
                }
            }
            return false;
        };
    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctPensionsAlimentaires
     *
     * @description
     * cnafCctPensionsAlimentaires affiche les zones pour la saisie des pensions alimentaires
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} pensionsalimentairesform formulaire
     * @param {Object} errorpensionsalimentaires erreurs
     * @param {boolean} desactive permet de désactiver/activer la saisie des pensions alimentaires
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */
    angular.module('cnafComponentsTeleprocApp').component('cnafCctPensionsAlimentaires', {
        templateUrl: 'components/cnaf-cct-ressources/cnaf-cct-pensions-alimentaires/cnaf-cct-pensions-alimentaires.component.html',
        bindings: {
            data: '=',
            pensionsalimentairesform: "=",
            errorpensionsalimentaires: "=",
            desactive: "<"
        },
        controllerAs: 'vm',
        controller: CnafCctPensionsAlimentairesController
    });
})();

(function() {
    'use strict';

    CnafCctPensionsRetraitesRentesController.$inject = ['$scope',
        'CnafComponentsTeleprocConstantes',
        'CnafCctRessourcesService'];

    function CnafCctPensionsRetraitesRentesController($scope,
        CnafComponentsTeleprocConstantes,
        CnafCctRessourcesService) {
        var vm = this;

        // Retourne true si rubrique cochee et remplie
        vm.controleDecochage = function() {
            if (vm.data.controle.pensionsretraitesrentesChckBx) {
                if( (vm.data.ressources.pensionsRetraitesRentesImposables && vm.data.ressources.pensionsRetraitesRentesImposables > 0) ||
                    (vm.data.ressources.pensionInvalidite && vm.data.ressources.pensionInvalidite > 0)) {
                    return true;
                }else {
                    return false;
                }
            }
            return false;
        };

        $scope.$on('controlePensionsRetraitesRentesComponent', function(e) {
            vm.data.controle.controlePensionsRetraitesRentes = vm.controleDecochage();
        });

        $scope.$on('clearPensionsRetraitesRentesComponent', function(e) {
            vm.data.controle.pensionsretraitesrentesChckBx = false;
            vm.data.controle.controlePensionsRetraitesRentes = false;
        });

        $scope.$on('collectDataPensionsRetraitesRentesComponent', function(e) {
            if(vm.data.ressources){
                if(vm.data.ressources.pensionsRetraitesRentesImposables){
                    if(!CnafCctRessourcesService.ressourceDejaExistante(vm.data.ressources.references, CnafComponentsTeleprocConstantes.ref22)){
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref22, Number(vm.data.ressources.pensionsRetraitesRentesImposables));
                    } else {
                        var valeurExistante = vm.data.ressources.references.get(CnafComponentsTeleprocConstantes.ref22);
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref22, (Number(valeurExistante) + Number(vm.data.ressources.pensionsRetraitesRentesImposables)));
                    }
                }
                if(vm.data.ressources.pensionInvalidite){
                    if(!CnafCctRessourcesService.ressourceDejaExistante(vm.data.ressources.references, CnafComponentsTeleprocConstantes.ref22)){
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref22, Number(vm.data.ressources.pensionInvalidite));
                    } else {
                        var valeurExistante = vm.data.ressources.references.get(CnafComponentsTeleprocConstantes.ref22);
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref22, (Number(valeurExistante) + Number(vm.data.ressources.pensionInvalidite)));
                    }
                }
            }
        });

        vm.champsVideOuZero = function() {
            if(vm.data.controle.pensionsretraitesrentesChckBx) {
                if( (vm.data.ressources.pensionsRetraitesRentesImposables && vm.data.ressources.pensionsRetraitesRentesImposables > 0) ||
                    (vm.data.ressources.pensionInvalidite && vm.data.ressources.pensionInvalidite > 0)) {
                    return true;
                }else {
                    return false;
                }
            }
            return false;
        };
    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctPensionsRetraitesRentes
     *
     * @description
     * cnafCctPensionsRetraitesRentes affiche les zones pour la saisie des pensions, retraites, rentes
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} pensionsretraitesrentesform formulaire
     * @param {Object} errorpensionsretraitesrentes erreurs
     * @param {boolean} desactive permet de désactiver/activer la saisie des pensions, retraites, rentes
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */
    angular.module('cnafComponentsTeleprocApp').component('cnafCctPensionsRetraitesRentes', {
        templateUrl: 'components/cnaf-cct-ressources/cnaf-cct-pensions-retraites-rentes/cnaf-cct-pensions-retraites-rentes.component.html',
        bindings: {
            data: '=',
            pensionsretraitesrentesform: "=",
            errorpensionsretraitesrentes: "=",
            desactive: "<"
        },
        controllerAs: 'vm',
        controller: CnafCctPensionsRetraitesRentesController
    });
})();

(function() {
    'use strict';

    CnafCctRevenusDeficitsFonciersController.$inject = ['$scope',
        'CnafComponentsTeleprocConstantes',
        'CnafCctRessourcesService'];

    function CnafCctRevenusDeficitsFonciersController($scope,
        CnafComponentsTeleprocConstantes,
        CnafCctRessourcesService) {
        var vm = this;

        // Retourne true si rubrique cochee et remplie
        vm.controleDecochage = function() {
            if (vm.data.controle.revenusdeficitsfonciersChckBx) {
                if( (vm.data.ressources.beneficesFonciers && vm.data.ressources.beneficesFonciers > 0) ||
                    (vm.data.ressources.deficitsFonciers && vm.data.ressources.deficitsFonciers > 0)) {
                    return true;
                }else {
                    return false;
                }
            }
            return false;
        };

        $scope.$on('controleRevenusDeficitsFonciersComponent', function(e) {
            vm.data.controle.controleRevenusDeficitsFonciers = vm.controleDecochage();
        });

        $scope.$on('clearRevenusDeficitsFonciersComponent', function(e) {
            vm.data.controle.revenusdeficitsfonciersChckBx = false;
            vm.data.controle.controleRevenusDeficitsFonciers = false;
        });

        $scope.$on('collectDataRevenusDeficitsFonciersComponent', function(e) {
            if(vm.data.ressources){
                if(vm.data.ressources.beneficesFonciers){
                    if(!CnafCctRessourcesService.ressourceDejaExistante(vm.data.ressources.references, CnafComponentsTeleprocConstantes.ref40)){
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref40, Number(vm.data.ressources.beneficesFonciers));
                    } else {
                        var valeurExistante = vm.data.ressources.references.get(CnafComponentsTeleprocConstantes.ref40);
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref40, (Number(valeurExistante) + Number(vm.data.ressources.beneficesFonciers)));
                    }
                }
                if(vm.data.ressources.deficitsFonciers){
                    if(!CnafCctRessourcesService.ressourceDejaExistante(vm.data.ressources.references, CnafComponentsTeleprocConstantes.ref63)){
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref63, Number(vm.data.ressources.deficitsFonciers));
                    } else {
                        var valeurExistante = vm.data.ressources.references.get(CnafComponentsTeleprocConstantes.ref63);
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref63, (Number(valeurExistante) + Number(vm.data.ressources.deficitsFonciers)));
                    }
                }
            }
        });

        vm.champsVideOuZero = function() {
            if(vm.data.controle.revenusdeficitsfonciersChckBx) {
                if(vm.data.ressources.beneficesFonciers > 0 || vm.data.ressources.deficitsFonciers > 0){
                    return true;
                }else {
                    return false;
                }
            }
            return false;
        };
    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctRevenusDeficitsFonciers
     *
     * @description
     * cnafCctRevenusDeficitsFonciers affiche les zones pour la saisie des revenus ou décifits foncier
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} revenusdeficitsfonciersform formulaire
     * @param {Object} errorrevenusdeficitsfonciers erreurs
     * @param {boolean} desactive permet de désactiver/activer la saisie des revenus ou décifits foncier
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */
    angular.module('cnafComponentsTeleprocApp').component('cnafCctRevenusDeficitsFonciers', {
        templateUrl: 'components/cnaf-cct-ressources/cnaf-cct-revenus-deficits-fonciers/cnaf-cct-revenus-deficits-fonciers.component.html',
        bindings: {
            data: '=',
            revenusdeficitsfonciersform: "=",
            errorrevenusdeficitsfonciers: "=",
            desactive: "<"
        },
        controllerAs: 'vm',
        controller: CnafCctRevenusDeficitsFonciersController
    });
})();

(function() {
    'use strict';

    CnafCctRevenusNonSalariesController.$inject = ['$scope',
        'CnafComponentsTeleprocConstantes',
        'CnafCctRessourcesService'];

    function CnafCctRevenusNonSalariesController($scope,
        CnafComponentsTeleprocConstantes,
        CnafCctRessourcesService) {
        var vm = this;

        // Retourne true si rubrique cochee et remplie
        vm.controleDecochage = function() {
            if (vm.data.controle.revenusnonsalariesChckBx) {
                if( (vm.data.ressources.benefEntrepreneur && vm.data.ressources.benefEntrepreneur > 0) ||
                    (vm.data.ressources.benefNonAdherents && vm.data.ressources.benefNonAdherents > 0) ||
                    (vm.data.ressources.deficitPro && vm.data.ressources.deficitPro > 0) ) {
                    return true;
                }else {
                    return false;
                }
            }
            return false;
        };

        $scope.$on('controleRevenusNonSalariesComponent', function(e) {
            vm.data.controle.controleRevenusNonSalaries = vm.controleDecochage();
        });

        $scope.$on('clearRevenusNonSalariesComponent', function(e) {
            vm.data.controle.controleRevenusNonSalaries = false;
            vm.data.controle.revenusnonsalariesChckBx = false;
        });

        $scope.$on('collectDataRevenusNonSalariesComponent', function(e) {
            // on check si une ressource n'est pas deja referencé si oui on ajoute la valeur en plus sinon on la créé
            if(vm.data.ressources){
                if(vm.data.ressources.benefEntrepreneur){
                    if(!CnafCctRessourcesService.ressourceDejaExistante(vm.data.ressources.references, CnafComponentsTeleprocConstantes.ref30)){
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref30, Number(vm.data.ressources.benefEntrepreneur));
                    } else {
                        var valeurExistante = vm.data.ressources.references.get(CnafComponentsTeleprocConstantes.ref30);
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref30, (Number(valeurExistante) + Number(vm.data.ressources.benefEntrepreneur)));
                    }
                }
                if(vm.data.ressources.benefNonAdherents){
                    if(!CnafCctRessourcesService.ressourceDejaExistante(vm.data.ressources.references, CnafComponentsTeleprocConstantes.ref34)){
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref34, Number(vm.data.ressources.benefNonAdherents));
                    } else {
                        var valeurExistante = vm.data.ressources.references.get(CnafComponentsTeleprocConstantes.ref34);
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref34, (Number(valeurExistante) + Number(vm.data.ressources.benefNonAdherents)));
                    }
                }
                if(vm.data.ressources.deficitPro){
                    if(!CnafCctRessourcesService.ressourceDejaExistante(vm.data.ressources.references, CnafComponentsTeleprocConstantes.ref62)){
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref62, Number(vm.data.ressources.deficitPro));
                    } else {
                        var valeurExistante = vm.data.ressources.references.get(CnafComponentsTeleprocConstantes.ref62);
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref62, (Number(valeurExistante) + Number(vm.data.ressources.deficitPro)));
                    }
                }
            }
        });

        vm.champsVideOuZero = function() {
            if(vm.data.controle.revenusnonsalariesChckBx) {
                if(vm.data.ressources.benefEntrepreneur > 0 || vm.data.ressources.benefNonAdherents > 0 || vm.data.ressources.deficitPro > 0){
                    return true;
                }else {
                    return false;
                }
            }
            return false;
        };
    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctRevenusNonSalaries
     *
     * @description
     * cnafCctRevenusNonSalaries affiche les zones pour la saisie des revenus non salariés
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} revenusnonsalariesform formulaire
     * @param {Object} errorrevenusnonsalaries erreurs
     * @param {boolean} desactive permet de désactiver/activer la saisie des revenus non salariés
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */
    angular.module('cnafComponentsTeleprocApp').component('cnafCctRevenusNonSalaries', {
        templateUrl: 'components/cnaf-cct-ressources/cnaf-cct-revenus-non-salaries/cnaf-cct-revenus-non-salaries.component.html',
        bindings: {
            data: '=',
            revenusnonsalariesform: "=",
            errorrevenusnonsalaries: "=",
            desactive: "<"
        },
        controllerAs: 'vm',
        controller: CnafCctRevenusNonSalariesController
    });
})();

(function() {
    'use strict';

    CnafCctSalairesController.$inject = ['$scope',
          'CnafComponentsTeleprocConstantes',
          'CnafCctRessourcesService'];

    function CnafCctSalairesController($scope,
        CnafComponentsTeleprocConstantes,
        CnafCctRessourcesService) {
        var vm = this;

        this.$onInit = function(){
            vm.actualiserVarImpotApprenti();
        };

        vm.actualiserVarImpotApprenti = function() {
          //--------------------------------------------------------------------------------------------------------------------------------------
          //VALORISATION Var_impot et Var_apprenti en fonction de l'année de Référence (Infos stockées dans CnafComponentsTeleprocConstantes...
          //--------------------------------------------------------------------------------------------------------------------------------------

          if(vm.data != undefined && !vm.data.varImpot && !vm.data.varApprenti)
          {
            //Boucle d'implémentaiton de varImpot et varApprenti en fonction de la valeur de anneeReference
            for(var i = 0;i < CnafComponentsTeleprocConstantes.varTabImpotApprenti.length; i++)
            {
              // si on trouve l'anneeReference, on récupère les données, sinon on garde les valeurs de l'année la = récente
              if( vm.data.anneeReference == CnafComponentsTeleprocConstantes.varTabImpotApprenti[i].anneeReference)
              {
                vm.data.varImpot = CnafComponentsTeleprocConstantes.varTabImpotApprenti[i].varImpot;
                vm.data.varApprenti = CnafComponentsTeleprocConstantes.varTabImpotApprenti[i].varApprenti;
              }
            }
            //Si Année non trouvée dans CnafComponentsTeleprocConstantes, prendre les varialbes de l'année la plus récente...
            if (!vm.data.varImpot && !vm.data.varApprenti)
            {
              vm.data.varImpot = CnafComponentsTeleprocConstantes.varTabImpotApprenti[0].varImpot;
              vm.data.varApprenti = CnafComponentsTeleprocConstantes.varTabImpotApprenti[0].varApprenti;
            }
            //console.log("CnafCctSalairesController controlerDonnees : anneeReference = " + vm.data.anneeReference +" varImpot = "+vm.data.varImpot+" varApprenti = "+vm.data.varApprenti);
          }
          //-----------------------------------------------------------------------------------------------------------------------------------------
        };

        // Retourne true si rubrique cochee et remplie
        vm.controleDecochage = function() {
            if (vm.data.controle.salairesChckBx) {
                if( (vm.data.ressources.salaire && vm.data.ressources.salaire > 0) || (vm.data.ressources.chomage && vm.data.ressources.chomage > 0) ||
                    (vm.data.ressources.fraisReels && vm.data.ressources.fraisReels > 0) ) {
                    return true;
                }else {
                    return false;
                }
            }
            return false;
        };

        $scope.$on('controleSalairesComponent', function(e) {
            vm.data.controle.controleSalaires = vm.controleDecochage();
        });

        $scope.$on('clearSalairesComponent', function(e) {
            vm.data.varImpot = "";
            vm.data.varApprenti = "";
            vm.actualiserVarImpotApprenti();
            vm.data.controle.controleSalaires = false;
            vm.data.controle.salairesChckBx = false;
        });

        $scope.$on('collectDataSalairesComponent', function(e) {
            if(vm.data.ressources){
                if(vm.data.ressources.salaire){
                    if(!CnafCctRessourcesService.ressourceDejaExistante(vm.data.ressources.references, CnafComponentsTeleprocConstantes.ref1)){
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref1, Number(vm.data.ressources.salaire));
                    } else {
                        var valeurExistante = vm.data.ressources.references.get(CnafComponentsTeleprocConstantes.ref1);
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref1, (Number(valeurExistante) + Number(vm.data.ressources.salaire)));
                    }
                }
                if(vm.data.ressources.chomage){
                    if(!CnafCctRessourcesService.ressourceDejaExistante(vm.data.ressources.references, CnafComponentsTeleprocConstantes.ref10)){
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref10, Number(vm.data.ressources.chomage));
                    } else {
                        var valeurExistante = vm.data.ressources.references.get(CnafComponentsTeleprocConstantes.ref10);
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref10, (Number(valeurExistante) + Number(vm.data.ressources.chomage)));
                    }
                }
                if(vm.data.ressources.fraisReels){
                    if(!CnafCctRessourcesService.ressourceDejaExistante(vm.data.ressources.references, CnafComponentsTeleprocConstantes.ref2)){
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref2, Number(vm.data.ressources.fraisReels));
                    } else {
                        var valeurExistante = vm.data.ressources.references.get(CnafComponentsTeleprocConstantes.ref2);
                        vm.data.ressources.references.set(CnafComponentsTeleprocConstantes.ref2, (Number(valeurExistante) + Number(vm.data.ressources.fraisReels)));
                    }
                }
            }
        });

        vm.champsVideOuZero = function() {
            if(vm.data.controle.salairesChckBx) {
                if( (vm.data.ressources.salaire && vm.data.ressources.salaire > 0) || (vm.data.ressources.chomage && vm.data.ressources.chomage > 0) ||
                    (vm.data.ressources.fraisReels && vm.data.ressources.fraisReels > 0) ) {
                    return true;
                }else {
                    return false;
                }
            }
            return false;
        };
    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctSalaires
     *
     * @description
     * cnafCctSalaires affiche les zones pour la saisie des revenus salariés
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} salairesform formulaire
     * @param {Object} errorsalaires erreurs
     * @param {boolean} desactive permet de désactiver/activer la saisie des revenus salariés
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */
    angular.module('cnafComponentsTeleprocApp').component('cnafCctSalaires', {
        templateUrl: 'components/cnaf-cct-ressources/cnaf-cct-salaires/cnaf-cct-salaires.component.html',
        bindings: {
            data: '=',
            salairesform: "=",
            errorsalaires: "=",
            desactive: "<"
        },
        controllerAs: 'vm',
        controller: CnafCctSalairesController
    });
})();

(function() {
    'use strict';

    CnafCctArriveEtrangerController.$inject = [];

    function CnafCctArriveEtrangerController(){


    }

    /**
     * @ngdoc directive
     * @name SitEnfAppli.component:cnafArriveEtrangerEnfant
     *
     * @description
     * cnafArriveEtrangerEnfant affiche les champs de saisie de la date d'arrivée
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} arriveetrangerform formulaire
     * @param {Object} controle controle
     *
    */

    angular.module('cnafComponentsTeleprocApp').component('cnafArriveEtrangerEnfant', {
        templateUrl: 'components/cnaf-cct-retour-enfant/cnaf-cct-arrive-etranger-enfant/cnaf-cct-arrive-etranger-enfant.html',
        bindings: {
            data: '=',
            arriveetrangerform: "=",
            controle: "="
        },
        controllerAs: 'vm',
        controller: CnafCctArriveEtrangerController
    });
})();

(function() {
    'use strict';

    CnafCctDateRetourController.$inject = [
        'CnafCctDateService',
        'CnafCctControleDateNaissanceService'];

    function CnafCctDateRetourController(
        CnafCctDateService,
        CnafCctControleDateNaissanceService){

        var vm = this;
        vm.controleDateRetour = CnafCctDateService.isDateStrictementSuperieure;
        vm.controleDateRetourDateDuJour = CnafCctControleDateNaissanceService.controleDateNaissance;

    }

    /**
     * @ngdoc directive
     * @name SitEnfAppli.component:cnafDateRetourEnfant
     *
     * @description
     * cnafDateRetourEnfant affiche les champs de saisie de la date d'arrivée
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} datearriveeform formulaire
     * @param {Object} controle controle
     *
    */

    angular.module('cnafComponentsTeleprocApp').component('cnafDateRetourEnfant', {
        templateUrl: 'components/cnaf-cct-retour-enfant/cnaf-cct-date-retour-enfant/cnaf-cct-date-retour-enfant.html',
        bindings: {
            data: '=',
            dateretourform: "=",
            controle: "="
        },
        controllerAs: 'vm',
        controller: CnafCctDateRetourController
    });
})();

(function() {
    'use strict';

    CnafCctAdresseEtablissementController.$inject = ['CnafCctAdresseSocleService','CnafCctGestionTypeService','CnafCctConstantMsgTypes'];

    function CnafCctAdresseEtablissementController(CnafCctAdresseSocleService,CnafCctGestionTypeService,CnafCctConstantMsgTypes) {
        var vm = this;
        vm.listePays = null;
        vm.isObligatoire = true;

        /* ------------------- */
        /*       SERVICE       */
        /* ------------------- */
        //AMABIS :
        vm.numEtAdresse = CnafCctAdresseSocleService.numEtAdresse;
        vm.codePostalVilles = CnafCctAdresseSocleService.codePostalVilles;
        vm.controleCodePostalFormat = CnafCctAdresseSocleService.controleCodePostalFormat;

        //Contrôle Téléphone
        vm.testType2 = function (donnee, form, nomDonnee) {
            if (!donnee) {
                form.$setValidity('type2', true);
            }
            else {
              // On remet le formulaire sans erreur
              form.$setValidity('invalide', true);
                var retourControles = CnafCctGestionTypeService.appelControleType2(donnee, form);
                if (retourControles !== null) {
                    vm.data[nomDonnee] = retourControles;
                }
            }
        };

        vm.testType7 = function(donnee,form,nomDonnee){
          if (donnee === undefined || donnee.length === 0){
              form.$setValidity('type7', true);
          }
          else {
            var retourControles = CnafCctGestionTypeService.appelControleType7(donnee, form);
            if (retourControles !== null)
            {
              vm.data[nomDonnee]=retourControles;
            }
          }
        };

        vm.testType8 = function(donnee,form,nomDonnee){
            if (donnee === undefined || donnee.length === 0){
                form.$setValidity('type8', true);
            }
            else {
              var retourControles = CnafCctGestionTypeService.appelControleType8(donnee, form);
              if (retourControles !== null)
              {
                  vm.data[nomDonnee]=retourControles;
              }
            }
          };

        vm.testType12 = function(donnee,form){
          if (donnee === undefined || donnee.length === 0){
              form.$setValidity('type12', true);
          }
          else {
            var retourControles = CnafCctGestionTypeService.appelControleType12(donnee, form);
            if (retourControles !== null)
            {
                vm.data.cpComEtab=retourControles;
            }
          }
        };


        //AUTO-COMPLETION
        vm.numEtAdresse = function(prefix) {
            //On ne fait la recherche que si on a une cleGeo ( que si une recherche a été effectué avec le cp et commune)
            if (vm.data.cpComEtab && vm.data.cpComEtab.cleGeo && vm.data.cpComEtab.cleGeoAgg) {
                return CnafCctAdresseSocleService.voies(vm.data.cpComEtab.cleGeo, vm.data.cpComEtab.cleGeoAgg, prefix).get()
                    .$promise.then(function(result) {
                        return result.listRechVoie;
                    });
            }
        };
        vm.codePostalVilles = function(prefix) {
            return CnafCctAdresseSocleService.localites(prefix, CnafCctAdresseSocleService.transformCodePays('FRA')).get()
                .$promise.then(function(result) {
                    return result.listRechLoc;
                });
        };

        /** Cette fonction reinitialise les erreurs sur la validation de l'adresse,
         * cela permet de relancer la validation de l'adresse en cas de modification d'un des champs de l'adresse
         */
        vm.reinitErreurAdresse = function(){
            vm.erroradresse = false;
        };

        /* ------------------------------------------------------------------------------------------------------------------------- */
    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctAdresseEtablissement
     *
     * @description
     * cnafCctAdresseEtablissement affiche les champs de saisie minimum pour une adresse
     *
     * @restrict E
     *
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     * @param {Object} data data
     * @param {Object} adresseform formulaire
     * @param {Object} erroradresse erreurs
     * @param {Object} listepays liste des Pays
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */
    angular.module('cnafComponentsTeleprocApp').component('cnafCctAdresseEtablissement', {
        templateUrl: 'components/cnaf-cct-sitenf-chgsit/cnaf-cct-adresse-etablissement/cnaf-cct-adresse-etablissement.html',
        bindings: {
            data: '=',
            adresseetablissementform: "=",
            erroradresse: "=",
            autocompletion: "=",
            controle: "="
        },
        controllerAs: 'vm',
        controller: CnafCctAdresseEtablissementController
    });
})();

(function() {
    'use strict';

    CnafCctSitenfChgsitAdo1Controller.$inject = [
        'CnafCctDateService',
    ];

    function CnafCctSitenfChgsitAdo1Controller(CnafCctDateService) {
        var vm = this;

        vm.listeSituationAdo1 = [{
            "code": "SCO",
            "libelle": "Scolarisé dans un établissement"
        }, {
            "code": "IAD",
            "libelle": "Instruction à domicile"
        }, {
            "code": "APP",
            "libelle": "Apprenti"
        }, {
            "code": "CPRO",
            "libelle": "En contrat de professionnalisation - En alternance"
        }, {
            "code": "INF",
            "libelle": "Non scolarisé pour raison de santé"
        }];

        /* ------------------------------------------------------------------------------------------------------------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {

        };

        vm.controleSupDateDeb = function(dateFin,dateDebut){
            var valueControle = true;
            if (dateDebut && dateDebut.length >= 10 && dateFin && dateFin.length >= 10 ){
                var dateDebATester = Date.parseExact(dateDebut, "d/M/yyyy");
                var dateFinATester = Date.parseExact(dateFin, "d/M/yyyy");
                if (dateFinATester && 'Invalid Date' !== dateFinATester && dateDebATester && 'Invalid Date' !== dateDebATester) {
                    if (dateFinATester < dateDebATester) {
                        valueControle = false;
                    }
                }
            }
            return valueControle;
        };

        vm.isDatePlusNMoisSupOuEgaleAXX = function (dateDemarche, dateNais, nbMois) {
            if (dateNais !== undefined) {
                dateNais.add({months:nbMois});
                return (dateDemarche >= dateNais);
            }
        };

        vm.contratProfessionalisation = function(dateDebutSit) {
            //La proposition « En contrat de professionnalisation – En alternance » est affichée si :
            //-	la personne a un mois de naissance supérieur ou égal à 09
            //ET -	l’âge de la personne à la date de début de situation est supérieur ou égal à 15 ans + 9 mois.
            //12*15 = 180 + 9 = 189
            var dateNaiss;
            if (vm.data.choix && vm.data.choix==='Changement')
            {
                dateNaiss = CnafCctDateService.getDateFormatCristalToFormatEcran(vm.data.choixPersonne.dateNaissance);
            }
            else {
                //Cas Arrivée - Format date différent
                dateNaiss = vm.data.choixPersonne.dateNaissance;
            }

            dateNaiss = Date.parseExact(dateNaiss, "d/M/yyyy");
            var mm = dateNaiss.getMonth()+1;
            var dateDebutSitu = Date.parseExact(dateDebutSit, "d/M/yyyy");

            if (vm.data.choix && vm.data.choix==='Changement')
            {
                if (mm >= 9 && vm.isDatePlusNMoisSupOuEgaleAXX(dateDebutSitu, dateNaiss, 189))
                {
                    //l’âge de la personne à la date de début de situation est supérieur ou égal à 15 ans + 9 mois
                    return (true);
                }
                else
                {   //Le bouton "En contrat" a été sélectionné auparavant avec une autre dateDebutSit
                    //ce bouton n'est plus affiché, on doit supprimer la sélection
                    if (vm.data.situationAdo1 === 'CPRO')
                    {
                        delete vm.data.situationAdo1;
                    }
                    return (false);
                }
            }
            else
            {
                if (mm >= 9)
                {
                    //l’âge de la personne à la date de début de situation
                    return (true);
                }
                else
                {   //Le bouton "En contrat" a été sélectionné auparavant avec une autre dateDebutSit
                    //ce bouton n'est plus affiché, on doit supprimer la sélection
                    if (vm.data.situationAdo1 === 'CPRO')
                    {
                        delete vm.data.situationAdo1;
                    }
                    return (false);
                }
            }
        };
    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctSitenfChgsitAdo1
     *
     * @description
     * cnafCctSitenfChgsitAdo1 affiche les champs de saisie pour choisir son activité de type "non salarié"
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} chgsitado1form formulaire
     * @param {Object} errorsitenfchgsitAdo1 erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */
    angular.module('cnafComponentsTeleprocApp').component('cnafCctSitenfChgsitAdo1', {
        templateUrl: 'components/cnaf-cct-sitenf-chgsit/cnaf-cct-sitenf-chgsit-ado1/cnaf-cct-sitenf-chgsit-ado1.html',
        bindings: {
            data: '=',
            chgsitado1form: "=",
            errorchgsitado1: "=",
            autocompletion: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafCctSitenfChgsitAdo1Controller
    });
})();

(function() {
    'use strict';

    CnafCctSitenfChgsitAdo2Controller.$inject = ['$scope'];

    function CnafCctSitenfChgsitAdo2Controller($scope){
        var vm = this;

        vm.init = function() {
            vm.refreshList();
            vm.controle.typeSituation = "situation";
        };

        //Pour rafraichir la liste lorsque le composant n'est pas reloader(on ne passe pas dans le init)
        //Dès que l'age est modifié on rafraichit la liste.
        $scope.$watch('vm.controle.age18a21', function() {
            vm.refreshList();
        });


        //on ajoute le champ ETI si la personne a entre 18 et 21 ans,
        // on le supprime sinon et s'il existe dans la liste
        vm.refreshList = function() {

            vm.listesituationsado2precisesaut = [
                {
                    code: "SAL",
                    libelle: "Activité salariée",
                    popover: "Salarié, engagé volontaire à l’armée et gérant salarié minoritaire ou égalitaire (affiliation au régime général de la Sécurité Sociale)"
                },
                {
                    code: "volontaire",
                    libelle: "Volontariat",
                    popover: "Volontariat international, Volontariat civil, Volontariat pour l’insertion EPIDE, Service civique et Sapeur-pompier volontaire"
                },
                {
                    code: "CHR",
                    libelle: "Chômage indemnisé"
                },
                {
                    code: "CNI",
                    libelle: "Chômage non indemnisé"
                },
                {
                    code: "SSA",
                    libelle: "Sans activité"
                }
            ];

            if (vm.controle.age18a21) {
                vm.listesituationsado2precisesaut.splice(1,0, { code: 'ETI', libelle: 'Activité non salariée'});
            }
        };




    }



    /**
     * @ngdoc directive
     * @name SitEnfAppli.component:cnafCctSitenfChgsitAdo2
     *
     * @description
     * cnafCctSitenfChgsitAdo2 affiche les champs de saisie de la sit enf des 16 21 ans
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} chgsitado2form formulaire
     * @param {Object} controle controle
     *
    */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSitenfChgsitAdo2', {
        templateUrl: 'components/cnaf-cct-sitenf-chgsit/cnaf-cct-sitenf-chgsit-ado2/cnaf-cct-sitenf-chgsit-ado2.html',
        bindings: {
            data: '=',
            chgsitado2form: "=",
            controle: "=",
            listesituationsado2: "=",
            listesituationsado2precises : "="
        },
        controllerAs: 'vm',
        controller: CnafCctSitenfChgsitAdo2Controller
    });
})();

(function() {
    'use strict';

    CnafCctSitenfChgsitAdulteController.$inject = [
        'CnafCctGestionTypeService',
        'CnafCctDateService'
    ];

    function CnafCctSitenfChgsitAdulteController(CnafCctGestionTypeService, CnafCctDateService) {
        var vm = this;

        vm.choixactivites = [{
            "code": "ETU",
            "libelle": "Etudiant"
        }, {
            "code": "ETS",
            "libelle": "Etudiant salarié ou scolarité rémunérée"
        }, {
            "code": "SFP",
            "libelle": "Stagiaire de la formation professionnelle"
        }, {
            "code": "APP",
            "libelle": "Apprenti"
        }, {
            "code": "CPRO",
            "libelle": "En contrat de professionnalisation - En alternance"
        }];

        vm.listeSituationAdulte = {
        };

        /* ------------------------------------------------------------------------------------------------------------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
            vm.listeSituationAdulte = vm.determinationInfosSituationAdulte(
                vm.data.choixPersonne.dateNaissance
            );
        };

        vm.determinationInfosSituationAdulte = function(dateNaiss) {

            var dateNaissance, dateCompar;

            // cas d'un arrivée
            if (dateNaiss && (dateNaiss.toString()).indexOf('/') >= 0) {
                dateNaissance = dateNaiss;
                dateCompar = CnafCctDateService.ddmmyyyy(vm.controle.today);
            }
            // cas d'un changement simple
            else{
                dateNaissance = CnafCctDateService.getDateFormatCristalToFormatEcran(dateNaiss);
                dateCompar = vm.data.dateActivite;
            }

            vm.listeSituationAdulte = [{
                "code": "SAL",
                "libelle": "Activité salariée"
            }, {
                "code": "ETI",
                "libelle": "Activité non salariée"
            }, {
                "code": "ETU-STA-APP-ALT",
                "libelle": "Etudiant - Stagiaire - Apprenti - En alternance"
            }, {
                "code": "HAN",
                "libelle": "Handicapé - Invalide - Inapte au travail"
            }, {
                "code": "CHR",
                "libelle": "Chômage indemnisé"
            }, {
                "code": "CNI",
                "libelle": "Chômage non indemnisé"
            }, {
                "code": "volontaire",
                "libelle": "Volontariat"
            }, {
                "code": "SSA",
                "libelle": "Sans activité"
            }];

            // si on doit afficher la situation retraite on l ajoute à la liste
            //La case "retraite" ne s'affiche que si la personne est âgée de + de 40 ans
            //à la date de début de situation ou date démarche
            if (vm.isAfficheRetraite(dateNaissance, dateCompar)) {
                vm.listeSituationAdulte.splice(6, 0, {
                    code: 'RET',
                    libelle: 'Retraite'
                });
            }
            return vm.listeSituationAdulte;
        };

        vm.isAfficheRetraite = function(dateNaissance, dateCompar) {
            return ((CnafCctDateService.getAgePartiel(dateNaissance, dateCompar)) >= 40);
        };
    }



    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctSitenfChgsitAdulte
     *
     * @description
     * cnafCctSitenfChgsitAdulte affiche les champs de saisie pour choisir son activité de type "non salarié"
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} chgsitadulteform formulaire
     * @param {Object} errorsitenfchgsitadulte erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */
    angular.module('cnafComponentsTeleprocApp').component('cnafCctSitenfChgsitAdulte', {
        templateUrl: 'components/cnaf-cct-sitenf-chgsit/cnaf-cct-sitenf-chgsit-adulte/cnaf-cct-sitenf-chgsit-adulte.html',
        bindings: {
            data: '=',
            chgsitadulteform: "=",
            errorchgsitadulte: "=",
            autocompletion: '=',
            controle: '=',
            index: '='

        },
        controllerAs: 'vm',
        controller: CnafCctSitenfChgsitAdulteController
    });
})();

(function() {
    'use strict';

    CnafCctSitenfChgsitEnfant2Controller.$inject = [];

    function CnafCctSitenfChgsitEnfant2Controller() {

        var vm = this;

        vm.listeSituationEnfant2 = [{
            "code": "SCO",
            "libelle": "Scolarisé dans un établissement"
        }, {
            "code": "IAD",
            "libelle": "Instruction à domicile"
        }, {
            "code": "INF",
            "libelle": "Non scolarisé pour raison de santé"
        }];

    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctSitenfChgsitEnfant2
     *
     * @description
     * cnafCctSitenfChgsitEnfant2 affiche les champs de saisie pour choisir son activité de type "non salarié"
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} chgsitenfant2form formulaire
     * @param {Object} errorsitenfchgsitEnfant2 erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */
    angular.module('cnafComponentsTeleprocApp').component('cnafCctSitenfChgsitEnfant2', {
        templateUrl: 'components/cnaf-cct-sitenf-chgsit/cnaf-cct-sitenf-chgsit-enfant2/cnaf-cct-sitenf-chgsit-enfant2.html',
        bindings: {
            data: '=',
            chgsitenfant2form: "=",
            errorchgsitenfant2: "=",
            autocompletion: '=',
            controle: '=',
            index: '='

        },
        controllerAs: 'vm',
        controller: CnafCctSitenfChgsitEnfant2Controller
    });
})();

(function() {
    'use strict';

    CnafCctSituationDateDebutController.$inject = ['$scope', 'CnafCctDateService', 'CnafCctSitEnfService'];

    function CnafCctSituationDateDebutController($scope, CnafCctDateService, CnafCctSitEnfService){

        var vm = this;

        vm.init = function() {
            vm.controleDateDuJour = CnafCctDateService.controleDateJour;
            // tableau des data à surveiller. Lorsque ces données évoluent
            // il faut relancer les tests sur la date de début activité.
            // ca tableau est utilisé dans le ui-watch-validate-collection dans le html de la date.
            vm.tableauControle = ['vm.data.situationAdo1',
                'vm.data.situationAdo2',
                'vm.data.situationAdo2StagAppAlt',
                'vm.data.situationAdo2AutreSituation',
                'vm.data.situationAdulte',
                'vm.data.situationAdulteEtuStagAppAlt'
            ];
        };


        vm.controleDateNaissance = function(dateDebSituation) {
            return CnafCctDateService.isDateStrictementSuperieure(dateDebSituation, vm.data.choixPersonne.dateNaissance);
        };

        vm.controleEntreAgeEtDateSit = function(sDebSituation) {
            var controleEntreAgeEtDateSit = true;
            var stringDateNaissance = vm.data.choixPersonne.dateNaissance;

            var dateMaxiAutorisee;
            if (vm.controle.ageEnfant1)
            {
                dateMaxiAutorisee = CnafCctSitEnfService.getDateMaxAutoriseeEnfant1(stringDateNaissance, vm.data.situationEnfant1);
            }
            else if (vm.controle.ageEnfant2)
            {
                dateMaxiAutorisee = CnafCctSitEnfService.getDateMaxAutoriseeEnfant2(stringDateNaissance, vm.data.situationEnfant2);
            }
            else if (vm.controle.ageAdo1)
            {
                dateMaxiAutorisee = CnafCctSitEnfService.getDateMaxAutoriseeAdo1(stringDateNaissance, vm.data.situationAdo1);
            }
            else if (vm.controle.ageAdo2)
            {
                dateMaxiAutorisee = CnafCctSitEnfService.getDateMaxAutoriseeAdo2(stringDateNaissance, vm.data.situationAdo2, vm.data.situationAdo2StagAppAlt,
                    vm.data.situationAdo2AutreSituation);
            }
            else if (vm.controle.agesupAdulte)
            {
                dateMaxiAutorisee = CnafCctSitEnfService.getDateMaxAutoriseeAdulte(stringDateNaissance, vm.data.situationAdulte, vm.data.situationAdulteEtuStagAppAlt);
            }

            if (dateMaxiAutorisee && sDebSituation)
            {
                vm.sDateDebutAutorisee = CnafCctDateService.ddmmyyyy(dateMaxiAutorisee);
                var dateDebutSituation = Date.parseExact(sDebSituation, "d/M/yyyy");
                if (dateDebutSituation && dateMaxiAutorisee > dateDebutSituation)
                {
                    controleEntreAgeEtDateSit = false;
                }
            }
            return controleEntreAgeEtDateSit;
        };

    }


    /**
     * @ngdoc directive
     * @name SitEnfAppli.component:cnafCctSituationDateDebut
     *
     * @description
     * cnafCctSituationDateDebut affiche les champs de saisie de la date de début situation enfant
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} datedebutsituationform formulaire
     * @param {Object} controle controle
     *
    */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationDateDebut', {
        templateUrl: 'components/cnaf-cct-sitenf-chgsit/cnaf-cct-situation-date-debut/cnaf-cct-situation-date-debut.html',
        bindings: {
            data: '=',
            datedebutsituationform: "=",
            controle: "="
        },
        controllerAs: 'vm',
        controller: CnafCctSituationDateDebutController
    });
})();

(function() {
    'use strict';

    CnafCctSituationDateFinController.$inject = ['CnafCctDateService'];

    function CnafCctSituationDateFinController(CnafCctDateService){

        var vm = this;

        vm.controleSupDateDeb = function(dateFin){
            return CnafCctDateService.isDateStrictementSuperieure(dateFin, vm.data.dateActivite);
        };

    }


    /**
     * @ngdoc directive
     * @name SitEnfAppli.component:cnafCctSituationDateFin
     *
     * @description
     * cnafCctSituationDateFin affiche les champs de saisie de la date de début situation enfant
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} datefinsituationform formulaire
     * @param {Object} controle controle
     *
    */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationDateFin', {
        templateUrl: 'components/cnaf-cct-sitenf-chgsit/cnaf-cct-situation-date-fin/cnaf-cct-situation-date-fin.html',
        bindings: {
            data: '=',
            datefinsituationform: "=",
            controle: "="
        },
        controllerAs: 'vm',
        controller: CnafCctSituationDateFinController
    });
})();

(function() {
    'use strict';

    CnafCctSituationEnfant1Controller.$inject = ['CnafCctDateService'];

    function CnafCctSituationEnfant1Controller(CnafCctDateService){

        var vm = this;
        vm.controleDateDuJour = CnafCctDateService.controleDateJour;

        vm.controleDateNaissance = function(dateDebSituation) {

            var stringDateNaissance = CnafCctDateService.getDateFormatCristalToFormatEcran(vm.data.choixPersonne.dateNaissance);
            return CnafCctDateService.isDateStrictementSuperieure(dateDebSituation, stringDateNaissance);

        };

        vm.controleEntreAgeEtDateSit = function(sDebSituation) {
            var stringDateNaissance = CnafCctDateService.getDateFormatCristalToFormatEcran(vm.data.choixPersonne.dateNaissance);
            var controleEntreAgeEtDateSit = true;
            if (stringDateNaissance) {
                var dateMaxiAutorisee = vm.getDateMaxAutorisee(stringDateNaissance);
                vm.sDateDebutAutorisee = CnafCctDateService.ddmmyyyy(dateMaxiAutorisee);
                vm.age = CnafCctDateService.getAgePartiel(stringDateNaissance, sDebSituation);
                var dateDebutSituation = Date.parseExact(sDebSituation, "d/M/yyyy");
                if (dateMaxiAutorisee &&  dateDebutSituation && dateMaxiAutorisee > dateDebutSituation)
                {
                    controleEntreAgeEtDateSit = false;
                }
            }
            return controleEntreAgeEtDateSit;
        };

        vm.getDateMaxAutorisee = function(stringDateNaissance) {
            var dateMaxiAutorisee = CnafCctDateService.getDatePlusNAnnees(stringDateNaissance, 5);
            return dateMaxiAutorisee.moveToFirstDayOfMonth();
        };

    }


    /**
     * @ngdoc directive
     * @name SitEnfAppli.component:cnafCctSituationEnfant1
     *
     * @description
     * cnafCctSituationEnfant1 affiche les champs de saisie de la date de début situation enfant
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} situationenfant1form formulaire
     * @param {Object} controle controle
     *
    */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationEnfant1', {
        templateUrl: 'components/cnaf-cct-sitenf-chgsit/cnaf-cct-situation-enfant1/cnaf-cct-situation-enfant1.html',
        bindings: {
            data: '=',
            situationenfant1form: "=",
            controle: "="
        },
        controllerAs: 'vm',
        controller: CnafCctSituationEnfant1Controller
    });
})();

(function() {
    'use strict';

    CnafCctSitproChoixActiviteController.$inject = ['CnafCctAdresseSocleService'];

    function CnafCctSitproChoixActiviteController(CnafCctAdresseSocleService) {
        var vm = this;

        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */

        vm.init = function() {
            CnafCctAdresseSocleService.getEtatAmabis().get()
                .$promise.then(
                function successCallback(result) {
                    vm.autocompletion = "on";
                },
                function errorCallback(error) {
                    vm.autocompletion = "off";
                });

            // Toutes les activités
            if (vm.controle.etudiant || vm.index > 0) {
                vm.choixactivites = [{
                    "code": "SAL",
                    "libelle": "En activité salariée"
                }, {
                    "code": "NSAL",
                    "libelle": "En activité non salariée"
                }, {
                    "code": "ETU",
                    "libelle": "Etudiant"
                }, {
                    "code": "APP",
                    "libelle": "Stagiaire - Apprenti - En alternance"
                }, {
                    "code": "CHO",
                    "libelle": "Chômage indemnisé ou non"
                }, {
                    "code": "RET",
                    "libelle": "Retraite - Préretraite"
                }, {
                    "code": "PENS",
                    "libelle": "Pension d'invalidité - Rente accident du travail"
                }, {
                    "code": "CONG",
                    "libelle": "Congés maternité, parental ou autre congé"
                }, {
                    "code": "AUT",
                    "libelle": "Autre situation"
                }];
            } else {
                // Toutes les activités Sauf Etudiant
                vm.choixactivites = [{
                    "code": "SAL",
                    "libelle": "En activité salariée"
                }, {
                    "code": "NSAL",
                    "libelle": "En activité non salariée"
                }, {
                    "code": "APP",
                    "libelle": "Stagiaire - Apprenti - En alternance"
                }, {
                    "code": "CHO",
                    "libelle": "Chômage indemnisé ou non"
                }, {
                    "code": "RET",
                    "libelle": "Retraite - Préretraite"
                }, {
                    "code": "PENS",
                    "libelle": "Pension d'invalidité - Rente accident du travail"
                }, {
                    "code": "CONG",
                    "libelle": "Congés maternité, parental ou autre congé"
                }, {
                    "code": "AUT",
                    "libelle": "Autre situation"
                }];
            }
            if(vm.index > 0){
                switch(vm.data.sitPros[vm.index-1].choixActivite){
                    case 'CHO':
                        vm.choixactivites = [{
                            "code": "SAL",
                            "libelle": "En activité salariée"
                        }, {
                            "code": "NSAL",
                            "libelle": "En activité non salariée"
                        }, {
                            "code": "ETU",
                            "libelle": "Etudiant"
                        }, {
                            "code": "APP",
                            "libelle": "Stagiaire - Apprenti - En alternance"
                        }, {
                            "code": "CHO",
                            "libelle": "Chômage indemnisé ou non"
                        },{
                            "code": "PENS",
                            "libelle": "Pension d'invalidité - Rente accident du travail"
                        }, {
                            "code": "CONG",
                            "libelle": "Congés maternité, parental ou autre congé"
                        }, {
                            "code": "AUT",
                            "libelle": "Autre situation"
                        }];
                        break;
                    case 'PENS':
                        vm.choixactivites = [{
                            "code": "SAL",
                            "libelle": "En activité salariée"
                        }, {
                            "code": "NSAL",
                            "libelle": "En activité non salariée"
                        }, {
                            "code": "ETU",
                            "libelle": "Etudiant"
                        }, {
                            "code": "APP",
                            "libelle": "Stagiaire - Apprenti - En alternance"
                        }, {
                            "code": "CHO",
                            "libelle": "Chômage indemnisé ou non"
                        }, {
                            "code": "PENS",
                            "libelle": "Pension d'invalidité - Rente accident du travail"
                        },{
                            "code": "CONG",
                            "libelle": "Congés maternité, parental ou autre congé"
                        }, {
                            "code": "AUT",
                            "libelle": "Autre situation"
                        }];
                        break;
                    case 'RET':
                        vm.choixactivites = [{
                            "code": "SAL",
                            "libelle": "En activité salariée"
                        }, {
                            "code": "NSAL",
                            "libelle": "En activité non salariée"
                        }, {
                            "code": "APP",
                            "libelle": "Stagiaire - Apprenti - En alternance"
                        }, {
                            "code": "CHO",
                            "libelle": "Chômage indemnisé ou non"
                        }, {
                            "code": "PENS",
                            "libelle": "Pension d'invalidité - Rente accident du travail"
                        }, {
                            "code": "CONG",
                            "libelle": "Congés maternité, parental ou autre congé"
                        }, {
                            "code": "AUT",
                            "libelle": "Autre situation"
                        }];
                        break;
                    case 'CONG':
                        vm.choixactivites = [{
                            "code": "SAL",
                            "libelle": "En activité salariée"
                        }, {
                            "code": "NSAL",
                            "libelle": "En activité non salariée"
                        }, {
                            "code": "ETU",
                            "libelle": "Etudiant"
                        }, {
                            "code": "APP",
                            "libelle": "Stagiaire - Apprenti - En alternance"
                        }, {
                            "code": "CHO",
                            "libelle": "Chômage indemnisé ou non"
                        }, {
                            "code": "PENS",
                            "libelle": "Pension d'invalidité - Rente accident du travail"
                        }, {
                            "code": "CONG",
                            "libelle": "Congés maternité, parental ou autre congé"
                        }, {
                            "code": "AUT",
                            "libelle": "Autre situation"
                        }];
                        break;
                    case 'ETU':
                        vm.choixactivites = [{
                            "code": "SAL",
                            "libelle": "En activité salariée"
                        }, {
                            "code": "NSAL",
                            "libelle": "En activité non salariée"
                        }, {
                            "code": "ETU",
                            "libelle": "Etudiant"
                        }, {
                            "code": "APP",
                            "libelle": "Stagiaire - Apprenti - En alternance"
                        }, {
                            "code": "CHO",
                            "libelle": "Chômage indemnisé ou non"
                        }, {
                            "code": "PENS",
                            "libelle": "Pension d'invalidité - Rente accident du travail"
                        }, {
                            "code": "CONG",
                            "libelle": "Congés maternité, parental ou autre congé"
                        }, {
                            "code": "AUT",
                            "libelle": "Autre situation"
                        }];
                        break;
                    case 'APP':
                        vm.choixactivites = [{
                            "code": "SAL",
                            "libelle": "En activité salariée"
                        }, {
                            "code": "NSAL",
                            "libelle": "En activité non salariée"
                        }, {
                            "code": "ETU",
                            "libelle": "Etudiant"
                        }, {
                            "code": "APP",
                            "libelle": "Stagiaire - Apprenti - En alternance"
                        }, {
                            "code": "CHO",
                            "libelle": "Chômage indemnisé ou non"
                        }, {
                            "code": "PENS",
                            "libelle": "Pension d'invalidité - Rente accident du travail"
                        }, {
                            "code": "CONG",
                            "libelle": "Congés maternité, parental ou autre congé"
                        }, {
                            "code": "AUT",
                            "libelle": "Autre situation"
                        }];
                        break;
                    case 'AUT':
                        var id = null;

                        if(vm.data.sitPros[vm.index-1].choixAutreSituation){
                            id = vm.data.sitPros[vm.index-1].choixAutreSituation.id;
                        }
                        if(id == 'activiteSansActivite' || id == 'activiteArretMaladie' || id == 'activiteVolontariat'){
                            vm.choixactivites = [{
                                "code": "SAL",
                                "libelle": "En activité salariée"
                            }, {
                                "code": "NSAL",
                                "libelle": "En activité non salariée"
                            }, {
                                "code": "ETU",
                                "libelle": "Etudiant"
                            },{
                                "code": "APP",
                                "libelle": "Stagiaire - Apprenti - En alternance"
                            }, {
                                "code": "CHO",
                                "libelle": "Chômage indemnisé ou non"
                            }, {
                                "code": "PENS",
                                "libelle": "Pension d'invalidité - Rente accident du travail"
                            }, {
                                "code": "CONG",
                                "libelle": "Congés maternité, parental ou autre congé"
                            }, {
                                "code": "AUT",
                                "libelle": "Autre situation"
                            } ];
                        }else{
                            vm.choixactivites = [{
                                "code": "SAL",
                                "libelle": "En activité salariée"
                            }, {
                                "code": "NSAL",
                                "libelle": "En activité non salariée"
                            }, {
                                "code": "ETU",
                                "libelle": "Etudiant"
                            },{
                                "code": "APP",
                                "libelle": "Stagiaire - Apprenti - En alternance"
                            }, {
                                "code": "CHO",
                                "libelle": "Chômage indemnisé ou non"
                            },{
                                "code": "RET",
                                "libelle": "Retraite - Préretraite"
                            }, {
                                "code": "PENS",
                                "libelle": "Pension d'invalidité - Rente accident du travail"
                            }, {
                                "code": "CONG",
                                "libelle": "Congés maternité, parental ou autre congé"
                            }, {
                                "code": "AUT",
                                "libelle": "Autre situation"
                            }];
                        }
                        break;
                }
            }

        };
    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctSitproChoixActivite
     *
     * @description
     * cnafCctSitproChoixActivite affiche les champs de saisie pour choisir son type d'activité
     *
     * @restrict E
     *
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     * @param {Object} data data
     * @param {Object} choixactiviteform formulaire
     * @param {Object} errorchoixactivite erreurs
     * @param {boolean} conjoint indique si on traite l'état civil du conjoint
     * @param {boolean} encouple indique si présence d'une sitfam couple
     * @param {string} codepostal code postal
     * @param {Date} datenaissance date de naissance
     * @param {Date} dernJourMoisSuivDemAL dernier jour du mois qui suit le mois de la démarche
     * @param {number} index l'index de la sitPro en cours de saisie
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSitproChoixActivite', {
        templateUrl: 'components/cnaf-cct-sitpro/cnaf-cct-sitpro-choix-activite/cnaf-cct-sitpro-choix-activite.html',
        bindings: {
            autocompletion: '=',
            data: '=',
            choixactiviteform: "=",
            errorchoixactivite: "=",
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafCctSitproChoixActiviteController
    });
})();

(function() {
    'use strict';

    CnafCctSitproChoixActiviteAutreSituationController.$inject = [    'CnafCctGestionTypeService',
        'CnafCctSitproControleDateService',
        'CnafCctDateService',
        'CnafCctSitproSuccessiviteService',
        'CnafCctAdresseSocleService',
        '$filter'];

    function CnafCctSitproChoixActiviteAutreSituationController(  CnafCctGestionTypeService,
                                                                CnafCctSitproControleDateService,
                                                                CnafCctDateService,
                                                                CnafCctSitproSuccessiviteService,
                                                                CnafCctAdresseSocleService,
                                                                $filter) {
        var vm = this;

        vm.listeChoixAutreSituation = [
            { code: 'SSA', libelle: 'Sans activité', id: 'activiteSansActivite'},
            { code: 'MAL', libelle: 'En arrêt maladie', id: 'activiteArretMaladie'},
            { code: 'MOA', libelle: 'Membre d’une organisation communautaire', id: 'activiteMOC'},
            { code: 'ABS', libelle: 'En détention', id: 'activiteDetention', ael: 'Concerne les personnes incarcérées'},
            { code: 'VOLONTARIAT', libelle: 'Volontariat', id: 'activiteVolontariat'}
        ];

        vm.listeChoixAutreSituationVolontariat = [
            { code: 'SNR-SERVICECIVIQUE', libelle: 'Service civique', id: 'volontaireServiceCivique'},
            { code: 'SAL-GE', libelle: 'Volontaire dans les armées', id: 'volontaireArmees'},
            { code: 'SNR-POMPIER', libelle: 'Sapeur-pompier volontaire', id: 'volontaireSapeurPompier'},
            { code: 'SNR-INTERNATIONAL', libelle: 'Volontaire international', id: 'volontaireInternational'},
            { code: 'SNR-INSERTION', libelle: 'Volontaire pour insertion', id: 'volontaireInsertion'}
        ];

        /* ------------------------------------------------------------------------------------------------------------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
            vm.controleInfDateNaissance = CnafCctSitproControleDateService.controleInfDateNaissance;
            vm.controleSupDernJourMoisSuivDemAL = CnafCctSitproControleDateService.controleSupDernJourMoisSuivDemAL;
            vm.controlerDateSitPro = CnafCctSitproSuccessiviteService.controlerDateSitPro;
            vm.dateActivitePrecMoins1jour = CnafCctSitproSuccessiviteService.dateActivitePrecMoins1jour;

            vm.datedemarche = vm.controle.datedemarche;

            vm.httpRechListePaysEmployeur();
            vm.initListeVolontariat();
        };

        vm.testType5 = function(donnee,form){
            if (donnee === undefined || donnee.length === 0){
                form.$setValidity('type5', true);
            }
            else {
                var retourControles = CnafCctGestionTypeService.appelControleType5(donnee, form);
                if (retourControles !== null)
                {
                    vm.data.sitPros[vm.index].villeOrgaComm=retourControles;
                    return true;
                }
            }
        };

        vm.initListeVolontariat = function(){
            if(vm.isAgeSupAXX(55)){
                vm.listeChoixAutreSituationVolontariat = [
                    { code: 'SNR', libelle: 'Volontaire international', id: 'volontaireInternational'}
                ];
            } else if(vm.isAgeSupAXX(31)){
                vm.listeChoixAutreSituationVolontariat = [
                    { code: 'SNR', libelle: 'Sapeur-pompier volontaire', id: 'volontaireSapeurPompier'},
                    { code: 'SNR', libelle: 'Volontaire international', id: 'volontaireInternational'}
                ];
            } else {
                vm.listeChoixAutreSituationVolontariat = [
                    { code: 'SNR', libelle: 'Service civique', id: 'volontaireServiceCivique'},
                    { code: 'SAL-GE', libelle: 'Volontaire dans les armées', id: 'volontaireArmees'},
                    { code: 'SNR', libelle: 'Sapeur-pompier volontaire', id: 'volontaireSapeurPompier'},
                    { code: 'SNR', libelle: 'Volontaire international', id: 'volontaireInternational'},
                    { code: 'SNR', libelle: 'Volontaire pour insertion', id: 'volontaireInsertion'}
                ];
            }
        };

        /**
         * @deprecated utiliser la méthode dans CnafCctDateService
         */
        vm.isAgeSupAXX = function (age) {
            if (vm.controle.datenaissance !== undefined) {
                var dateNaisPlusXX =  Date.parseExact(vm.controle.datenaissance, "d/M/yyyy");
                dateNaisPlusXX.add({years:age});
                if (vm.datedemarche > dateNaisPlusXX) {
                    return (true);
                } else {
                    return (false);
                }
            }
        };

        //Recherche liste pays
        vm.httpRechListePaysEmployeur = function() {
            CnafCctAdresseSocleService.rechListePays().get().$promise.then(
                function successCallback (response0) {
                    vm.listePaysEmployeur = response0.listePays;
                },
                function errorCallback(error) {
                    vm.etat = "error";
                });
        };

        //AUTO-COMPLETION
        //Pays :
        vm.getListePaysEmployeurProposes = function(prefix) {
            return vm.listePaysEmployeur;
        };

        vm.afficheCodePostalVille = function (index) {
            if (vm.data.sitPros[index] && vm.data.sitPros[index].paysActivite){
                if (vm.data.sitPros[index].paysActivite.libelleCaffr == 'FRANCE' || vm.data.sitPros[index].paysActivite.libelleCaffr == 'PRINCIPAUTE DE MONACO'){
                    return (true);
                } else
                {
                    return (false);
                }
            }
        };

        vm.codePostalVilles = function(prefix) {
            return CnafCctAdresseSocleService.localitesSansLD(prefix, CnafCctAdresseSocleService.transformCodePays(vm.data.codePostalZoneActivite)).get()
                .$promise.then(function(result){
                    return $filter('limitTo')(result.listRechLoc, 10);
                });
        };


        vm.controleDateSup = function(dateDebut, dateFin){
            if(dateDebut && dateFin){
                if(CnafCctDateService.parseDate(dateFin).getTime() <= CnafCctDateService.parseDate(dateDebut).getTime()){
                    return false;
                } else {
                    return true;
                }
            }
            return true;
        };

        vm.controleDateSupOuEgale = function(date1, date2){
            if(date1 && date2){
                if(CnafCctDateService.parseDate(date2).getTime() < CnafCctDateService.parseDate(date1).getTime()){
                    return false;
                } else {
                    return true;
                }
            }
            return true;
        };

        vm.generationDatePosterieure = function(index){
            if(index > 0) {
                vm.datePosterieure = CnafCctSitproSuccessiviteService.generationDatePosterieure(index, vm.data.sitPros);
            }
        };
    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctSitproChoixActiviteAutreSituation
     *
     * @description
     * cnafCctSitproChoixActiviteAutreSituation affiche les champs de saisie pour activité conges divers
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} choixactiviteautresituationform formulaire
     * @param {Object} errorchoixactiviteautresituation erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     * @param {boolean} conjoint indique si on traite l'état civil du conjoint
     * @param {boolean} encouple indique si présence d'une sitfam couple
     * @param {Date} datenaissance date de naissance
     * @param {Date} dernjourodal dernier jour du mois d'ouverture de droit à l'AL
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSitproChoixActiviteAutreSituation', {
        templateUrl: 'components/cnaf-cct-sitpro/cnaf-cct-sitpro-choix-activite-autre-situation/cnaf-cct-sitpro-choix-activite-autre-situation.html',
        bindings: {
            data: '=',
            choixactiviteautresituationform: "=",
            errorchoixactiviteautresituation: "=",
            autocompletion: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafCctSitproChoixActiviteAutreSituationController
    });
})();

(function() {
    'use strict';

    CnafCctSitproChoixActiviteChomageController.$inject = [ 'CnafCctGestionTypeService',
                                                            'CnafCctSitproControleDateService',
                                                            'CnafCctDateService',
                                                            'CnafCctSitproSuccessiviteService'];

    function CnafCctSitproChoixActiviteChomageController(   CnafCctGestionTypeService,
                                                            CnafCctSitproControleDateService,
                                                            CnafCctDateService,
                                                            CnafCctSitproSuccessiviteService) {
        var vm = this;

        vm.listeOrgInscription = [
            { code: 'GE-POLEEMPLOI', libelle: 'France Travail'},
            { code: 'GE-AUTREORGA', libelle: 'Autre organisme'}
        ];

        /* ------------------------------------------------------------------------------------------------------------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
          vm.controleInfDateNaissance = CnafCctSitproControleDateService.controleInfDateNaissance;
          vm.controleSupDernJourMoisSuivDemAL  = CnafCctSitproControleDateService.controleSupDernJourMoisSuivDemAL;
          vm.controlerDateSitPro = CnafCctSitproSuccessiviteService.controlerDateSitPro;
          vm.dateActivitePrecMoins1jour = CnafCctSitproSuccessiviteService.dateActivitePrecMoins1jour;
        };

        vm.generationDatePosterieure = function(index){
            if(index > 0) {
                vm.datePosterieure = CnafCctSitproSuccessiviteService.generationDatePosterieure(index, vm.data.sitPros);
            }
        };

        vm.testType8 = function(donnee,form,nomDonnee){
            if (donnee === undefined || donnee.length === 0){
              form.$setValidity('type8', true);
            }
            else {
                var retourControles = CnafCctGestionTypeService.appelControleType8(donnee, form);
                if (retourControles !== null)
                {
                  vm.data[nomDonnee]=retourControles;
                }
            }
        };

    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctSitproChoixActiviteChomage
     *
     * @description
     * cnafCctSitproChoixActiviteChomage affiche les champs de saisie pour activité chomage
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} choixactivitechomageform formulaire
     * @param {Object} errorchoixactivitechomage erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     * @param {boolean} conjoint indique si on traite l'état civil du conjoint
     * @param {boolean} encouple indique si présence d'une sitfam couple
     * @param {Date} datenaissance date de naissance
     * @param {Date} dernJourMoisSuivDemAL dernier jour du mois qui suit le mois de la démarche
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSitproChoixActiviteChomage', {
        templateUrl: 'components/cnaf-cct-sitpro/cnaf-cct-sitpro-choix-activite-chomage/cnaf-cct-sitpro-choix-activite-chomage.html',
        bindings: {
            data: '=',
            choixactivitechomageform: "=",
            errorchoixactivitechomage: "=",
            autocompletion: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafCctSitproChoixActiviteChomageController
    });
})();

(function() {
    'use strict';

    CnafCctSitproChoixActiviteCongesDiversController.$inject = [    'CnafCctGestionTypeService',
                                                                    'CnafCctSitproControleDateService',
                                                                    'CnafCctDateService',
                                                                    'CnafCctSitproSuccessiviteService'];

    function CnafCctSitproChoixActiviteCongesDiversController(  CnafCctGestionTypeService,
                                                                CnafCctSitproControleDateService,
                                                                CnafCctDateService,
                                                                CnafCctSitproSuccessiviteService) {
        var vm = this;

        vm.listeChoixCongesDivers = [
            { code: 'MAT', libelle: 'Congé maternité'},
            { code: 'CCV', libelle: 'Congé conventionnel'},
            { code: 'CSS-PARENT', libelle: 'Congé parental ou d’adoption'},
            { code: 'CSS', libelle: 'Congé sans solde'},
            { code: 'SAB', libelle: 'Congé sabbatique'}
        ];

        /* ------------------------------------------------------------------------------------------------------------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
          vm.controleInfDateNaissance = CnafCctSitproControleDateService.controleInfDateNaissance;
          vm.controleSupDernJourMoisSuivDemAL  = CnafCctSitproControleDateService.controleSupDernJourMoisSuivDemAL;
          vm.controlerDateSitPro = CnafCctSitproSuccessiviteService.controlerDateSitPro;
          vm.dateActivitePrecMoins1jour = CnafCctSitproSuccessiviteService.dateActivitePrecMoins1jour;
        };

        vm.controleSupDateDeb = function(dateFin,dateDebut){
            var valueControle = true;
            if (dateDebut && dateDebut.length >= 10 && dateFin && dateFin.length >= 10 ){
              var dateDebATester = Date.parseExact(dateDebut, "d/M/yyyy");
              var dateFinATester = Date.parseExact(dateFin, "d/M/yyyy");
              if (dateFinATester && 'Invalid Date' != dateFinATester && dateDebATester && 'Invalid Date' != dateDebATester) {
                  if (dateFinATester < dateDebATester) {
                    valueControle = false;
                }
              }
            }
            return valueControle;
        };

        vm.generationDatePosterieure = function(index){
            if(index > 0) {
                vm.datePosterieure = CnafCctSitproSuccessiviteService.generationDatePosterieure(index, vm.data.sitPros);
            }
        };

        vm.testType8 = function(donnee,form,nomDonnee){
            if (donnee === undefined || donnee.length === 0){
              form.$setValidity('type8', true);
            }
            else {
                var retourControles = CnafCctGestionTypeService.appelControleType8(donnee, form);
                if (retourControles !== null)
                {
                  vm.data[nomDonnee]=retourControles;
                }
            }
        };



    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctSitproChoixActiviteCongesdivers
     *
     * @description
     * cnafCctSitproChoixActiviteCongesdivers affiche les champs de saisie pour activité conges divers
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} choixactivitecongesdiversform formulaire
     * @param {Object} errorchoixactivitecongesdivers erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     * @param {boolean} conjoint indique si on traite l'état civil du conjoint
     * @param {boolean} encouple indique si présence d'une sitfam couple
     * @param {Date} datenaissance date de naissance
     * @param {Date} dernJourMoisSuivDemAL dernier jour du mois qui suit le mois de la démarche
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSitproChoixActiviteCongesDivers', {
        templateUrl: 'components/cnaf-cct-sitpro/cnaf-cct-sitpro-choix-activite-conges-divers/cnaf-cct-sitpro-choix-activite-conges-divers.html',
        bindings: {
            data: '=',
            choixactivitecongesdiversform: "=",
            errorchoixactivitecongesdivers: "=",
            autocompletion: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafCctSitproChoixActiviteCongesDiversController
    });
})();

(function() {
    'use strict';

    CnafCctSitproChoixActiviteInvaliditeController.$inject = [
        'CnafCctSitproControleDateService',
        'CnafCctSitproSuccessiviteService'];

    function CnafCctSitproChoixActiviteInvaliditeController(
                                                          CnafCctSitproControleDateService,
                                                          CnafCctSitproSuccessiviteService) {
        var vm = this;

          /* ------------------- */
          /* ------------------- */
          /*       Fonction      */
          /* ------------------- */
          vm.init = function() {

            vm.controleInfDateNaissance = CnafCctSitproControleDateService.controleInfDateNaissance;
            vm.controleSupDernJourMoisSuivDemAL  = CnafCctSitproControleDateService.controleSupDernJourMoisSuivDemAL;
            vm.controlerDateSitPro = CnafCctSitproSuccessiviteService.controlerDateSitPro;
            vm.dateActivitePrecMoins1jour = CnafCctSitproSuccessiviteService.dateActivitePrecMoins1jour;

            //Pour éviter une boucle, si on a déjà choixActivite == "PENS"
            if (vm.data.sitPros[vm.index].choixActivite == "PENS")
            {
              if (vm.data.sitPros[vm.index].choixActiviteComplementInvalidite == "PENS")
              {   vm.data.sitPros[vm.index].choixActiviteComplementInvalidite = "";
              }
              if (vm.data.sitPros[vm.index].choixActiviteComplementRetraite == "PENS")
              {   vm.data.sitPros[vm.index].choixActiviteComplementRetraite = "";
              }
            }

            vm.choixactivites3 = [{
                "code": "SAL",
                "libelle": "En activité salariée",
            }, {
                "code": "NSAL",
                "libelle": "En activité non salariée",
            }, {
                "code": "ETU",
                "libelle": "Etudiant",
            }, {
                "code": "APP",
                "libelle": "Stagiaire - Apprenti - En alternance",
            }, {
                "code": "CHO",
                "libelle": "Chômage indemnisé ou non",
            }, {
                "code": "CONG",
                "libelle": "Congés maternité, parental ou autre congé",
            }, {
                "code": "AUT",
                "libelle": "Autre situation",
            }];

          };

        vm.generationDatePosterieure = function(index){
            if(index > 0) {
                vm.datePosterieure = CnafCctSitproSuccessiviteService.generationDatePosterieure(index, vm.data.sitPros);
            }
        };
    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctSitproChoixActiviteInvalidite
     *
     * @description
     * cnafCctSitproChoixActiviteInvalidite affiche les champs de saisie pour choisir son activité de type "salarié"
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} choixactiviteinvaliditeform formulaire
     * @param {Object} errorchoixactiviteinvalidite erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     * @param {boolean} conjoint indique si on traite l'état civil du conjoint
     * @param {Date} date de naissance
     * @param {Date} dernier jour du mois d'ouverture de droit à l'AL
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSitproChoixActiviteInvalidite', {
        templateUrl: 'components/cnaf-cct-sitpro/cnaf-cct-sitpro-choix-activite-invalidite/cnaf-cct-sitpro-choix-activite-invalidite.html',
        bindings: {
            data: '=',
            choixactiviteinvaliditeform: "=",
            errorchoixactiviteinvalidite: "=",
            autocompletion: '=',
            controle: '=',
            index: '='

        },
        controllerAs: 'vm',
        controller: CnafCctSitproChoixActiviteInvaliditeController
    });
})();

(function() {
    'use strict';

    CnafCctSitproChoixActiviteNonSalarieeController.$inject = [
        'CnafCctGestionTypeService',
        'CnafCctSitproControleDateService',
        'CnafCctSitproSuccessiviteService'];

    function CnafCctSitproChoixActiviteNonSalarieeController(CnafCctGestionTypeService,
                                                             CnafCctSitproControleDateService,
                                                             CnafCctSitproSuccessiviteService) {

        var vm = this;
        vm.listeActivitenonsalariee = [
            { code: 'ETI', libelle: 'Travailleur indépendant'},
            { code: 'ETI-EAN', libelle: 'Auto-entrepreneur ou Micro-entrepreneur'},
            { code: 'GSA', libelle: 'Gérant non salarié'},
            { code: 'ETI-VDIAEN', libelle: 'Vendeur à domicile indépendant'},
            { code: 'VRP', libelle: 'VRP (Voyageur Représentant Placier)'},
            { code: 'MAR', libelle: 'Marin pêcheur'},
            { code: 'EXP', libelle: 'Exploitant agricole'},
            { code: 'ETI-AA', libelle: 'Artiste auteur'},
            { code: 'CJT', libelle: 'Conjoint collaborateur'},
            { code: 'AFA', libelle: 'Aide familiale agricole'}
        ];

        vm.listeRegimeImposition = [
            { code: 'R', libelle: 'Réel'},
            { code: 'F', libelle: 'Forfaitaire'},
        ];

        /* ------------------------------------------------------------------------------------------------------------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
            vm.controleInfDateNaissance = CnafCctSitproControleDateService.controleInfDateNaissance;
            vm.controleSupDernJourMoisSuivDemAL  = CnafCctSitproControleDateService.controleSupDernJourMoisSuivDemAL;
            vm.controlerDateSitPro = CnafCctSitproSuccessiviteService.controlerDateSitPro;
            vm.dateActivitePrecMoins1jour = CnafCctSitproSuccessiviteService.dateActivitePrecMoins1jour;
        };

        vm.generationDatePosterieure = function(index){
            if(index > 0) {
                vm.datePosterieure = CnafCctSitproSuccessiviteService.generationDatePosterieure(index, vm.data.sitPros);
            }
        };

        vm.afficheNomOrganisme = function (index) {
            //On affiche le champ 'Nom de l'organisme' si le régime de cotisation = "Autre régime"
            if (vm.data.sitPros[index] && vm.data.sitPros[index].cotisEmployeur){
                if (vm.data.sitPros[index].cotisEmployeur.libelle == 'Autre régime')
                {
                    return (true);
                }
                else {
                    return (false);
                }
            }
        };

        vm.afficheRegimeImposition = function (index) {
            // On affiche le régime d'imposition (Réel / Forfaitaire) pour les activités 'Vendeur à domicile indépendant' et 'Artiste auteur'
            if (vm.data.sitPros[index] && vm.data.sitPros[index].choixActiviteNonSalariee){
                if (vm.data.sitPros[index].choixActiviteNonSalariee.libelle === 'Vendeur à domicile indépendant' ||
                    vm.data.sitPros[index].choixActiviteNonSalariee.libelle === 'Artiste auteur')
                {
                    return (true);
                }
                else {
                    return (false);
                }
            }
        };

        vm.afficheMetropole = function () {
            // Dans le test d’accès de la DAL, on a la saisie du code postal.
            // Si le code postal saisi ne commence pas par 971, 972, 973, 974 ou 976
            // alors on applique les règles de la métropole décrites dans la US 3.5 (Activités non salariés Métropole)
            CnafCctSituationproService.isMetropole(vm.controle.codepostal);
        };



        vm.testType8 = function(donnee,form,nomDonnee){
            if (donnee === undefined || donnee.length === 0){
                form.$setValidity('type8', true);
            }
            else {
                var retourControles = CnafCctGestionTypeService.appelControleType8(donnee, form);
                if (retourControles !== null)
                {
                    vm.data[nomDonnee]=retourControles;
                }
            }
        };


    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctSitproChoixActiviteNonSalariee
     *
     * @description
     * cnafCctSitproChoixActiviteNonSalariee affiche les champs de saisie pour choisir son activité de type "non salarié"
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} choixactivitenonsalarieeform formulaire
     * @param {Object} errorchoixactivitenonsalariee erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     * @param {boolean} conjoint indique si on traite l'état civil du conjoint
     * @param {Date} date de naissance
     * @param {Date} dernier jour du mois d'ouverture de droit à l'AL
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSitproChoixActiviteNonSalariee', {
        templateUrl: 'components/cnaf-cct-sitpro/cnaf-cct-sitpro-choix-activite-non-salariee/cnaf-cct-sitpro-choix-activite-non-salariee.html',
        bindings: {
            data: '=',
            choixactivitenonsalarieeform: "=",
            errorchoixactivitenonsalariee: "=",
            autocompletion: '=',
            controle: '=',
            index: '='

        },
        controllerAs: 'vm',
        controller: CnafCctSitproChoixActiviteNonSalarieeController
    });
})();

(function() {
    'use strict';

    CnafCctSitproChoixActiviteRetraiteController.$inject = [
        'CnafCctSitproControleDateService',
        'CnafCctSitproSuccessiviteService'];

    function CnafCctSitproChoixActiviteRetraiteController(
                                                          CnafCctSitproControleDateService,
                                                          CnafCctSitproSuccessiviteService) {
        var vm = this;

        /* ------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {

            vm.controleInfDateNaissance = CnafCctSitproControleDateService.controleInfDateNaissance;
            vm.controleSupDernJourMoisSuivDemAL  = CnafCctSitproControleDateService.controleSupDernJourMoisSuivDemAL;
            vm.controlerDateSitPro = CnafCctSitproSuccessiviteService.controlerDateSitPro;
            vm.dateActivitePrecMoins1jour = CnafCctSitproSuccessiviteService.dateActivitePrecMoins1jour;

            //Pour éviter une boucle, si on a déjà choixActivite == "RET"
            if (vm.data.sitPros[vm.index].choixActivite == "RET")
            {
              if (vm.data.sitPros[vm.index].choixActiviteComplementInvalidite == "RET")
              {   vm.data.sitPros[vm.index].choixActiviteComplementInvalidite = "";
              }
              if (vm.data.sitPros[vm.index].choixActiviteComplementRetraite == "RET")
              {   vm.data.sitPros[vm.index].choixActiviteComplementRetraite = "";
              }
            }

            vm.choixactivites2 = [{
                "code": "SAL",
                "libelle": "En activité salariée",
            }, {
                "code": "NSAL",
                "libelle": "En activité non salariée",
            }, {
                "code": "ETU",
                "libelle": "Etudiant",
            }, {
                "code": "APP",
                "libelle": "Stagiaire - Apprenti - En alternance",
            }, {
                "code": "CHO",
                "libelle": "Chômage indemnisé ou non",
            }, {
                "code": "CONG",
                "libelle": "Congés maternité, parental ou autre congé",
            }, {
                "code": "AUT",
                "libelle": "Autre situation",
            }];

            
          };

        vm.generationDatePosterieure = function(index){
            if(index > 0) {
                vm.datePosterieure = CnafCctSitproSuccessiviteService.generationDatePosterieure(index, vm.data.sitPros);
            }
        };
    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctSitproChoixActiviteRetraite
     *
     * @description
     * cnafCctSitproChoixActiviteRetraite affiche les champs de saisie pour choisir son activité de type "salarié"
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} choixactiviteretraiteform formulaire
     * @param {Object} errorchoixactiviteretraite erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     * @param {boolean} conjoint indique si on traite l'état civil du conjoint
     * @param {Date} date de naissance
     * @param {Date} dernier jour du mois d'ouverture de droit à l'AL
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSitproChoixActiviteRetraite', {
        templateUrl: 'components/cnaf-cct-sitpro/cnaf-cct-sitpro-choix-activite-retraite/cnaf-cct-sitpro-choix-activite-retraite.html',
        bindings: {
            data: '=',
            choixactiviteretraiteform: "=",
            errorchoixactiviteretraite: "=",
            autocompletion: '=',
            controle: '=',
            index: '='

        },
        controllerAs: 'vm',
        controller: CnafCctSitproChoixActiviteRetraiteController
    });
})();

(function() {
    'use strict';

    CnafCctSitproChoixActiviteSalarieeController.$inject = ['CnafCctAdresseSocleService',
        '$filter',
        'CnafCctGestionTypeService',
        'CnafCctSitproControleDateService',
        'CnafCctSitproSuccessiviteService'];

    function CnafCctSitproChoixActiviteSalarieeController(CnafCctAdresseSocleService,
                                                          $filter,
                                                          CnafCctGestionTypeService,
                                                          CnafCctSitproControleDateService,
                                                          CnafCctSitproSuccessiviteService) {
        var vm = this;
        vm.listeActivitesalariee = [
            { code: 'SAL', libelle: 'Salarié'},
            { code: 'AMA', libelle: 'Assitant(e) maternel(le)'},
            { code: 'GSA', libelle: 'Gérant salarié'},
            { code: 'TSA', libelle: 'Travailleur saisonnier'},
            { code: 'INT', libelle: 'Intérimaire'},
            { code: 'SAL-INTERMITTENT', libelle: 'Intermittent du spectacle'},
            { code: 'SAL-VENDEURADOMICILE', libelle: 'Vendeur à domicile salarié'}

        ];

        /* ------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
            //AMABIS :
            CnafCctAdresseSocleService.getEtatAmabis().get()
                .$promise.then(
                function successCallback(result) {
                    vm.autocompletion = "on";
                },
                function errorCallback(error) {
                    vm.autocompletion = "off";
                });

            vm.controleInfDateNaissance = CnafCctSitproControleDateService.controleInfDateNaissance;
            vm.controleSupDernJourMoisSuivDemAL  = CnafCctSitproControleDateService.controleSupDernJourMoisSuivDemAL;
            vm.controlerDateSitPro = CnafCctSitproSuccessiviteService.controlerDateSitPro;
            vm.dateActivitePrecMoins1jour = CnafCctSitproSuccessiviteService.dateActivitePrecMoins1jour;

            vm.httpRechListePaysEmployeur();
        };

        vm.generationDatePosterieure = function(index){
            if(index > 0) {
                vm.datePosterieure = CnafCctSitproSuccessiviteService.generationDatePosterieure(index, vm.data.sitPros);
            }
        };

        //Recherche liste pays
        vm.httpRechListePaysEmployeur = function() {
            CnafCctAdresseSocleService.rechListePays().get().$promise.then(
                function successCallback (response0) {
                    vm.listePaysEmployeur = response0.listePays;
                },
                function errorCallback(error) {
                    vm.etat = "error";
                });
        };

        //AUTO-COMPLETION
        //Pays :
        vm.getListePaysEmployeurProposes = function(prefix) {
            return vm.listePaysEmployeur;
        };

        vm.afficheEmployeur = function (index) {
            if (vm.data.sitPros[index] && vm.data.sitPros[index].choixActiviteSalariee){
                if (vm.data.sitPros[index].choixActiviteSalariee.libelle == 'Salarié' ||
                 vm.data.sitPros[index].choixActiviteSalariee.libelle == 'Intérimaire' ||
                 vm.data.sitPros[index].choixActiviteSalariee.libelle == 'Vendeur à domicile salarié' ||
                 vm.data.sitPros[index].choixActiviteSalariee.libelle == 'Gérant salarié')
                {
                    return (true);
                }
                else {
                    return (false);
                }
            }
        };

        vm.afficheCodePostalVille = function (index) {
            if (vm.data.sitPros[index] && vm.data.sitPros[index].paysEmployeur){
                if (vm.data.sitPros[index].paysEmployeur.libelleCaffr == 'FRANCE' || vm.data.sitPros[index].paysEmployeur.libelleCaffr == 'PRINCIPAUTE DE MONACO'){
                    return (true);
                } else
                {
                    return (false);
                }
            }
        };

        vm.codePostalVilles = function(prefix) {
            return CnafCctAdresseSocleService.localitesSansLD(prefix, CnafCctAdresseSocleService.transformCodePays(vm.data.codePostalVille)).get()
                .$promise.then(function(result){
                    return $filter('limitTo')(result.listRechLoc, 10);
                });
        };

        vm.testType5 = function(donnee,form, index){
            if (donnee === undefined || donnee.length === 0){
                form.$setValidity('type5', true);
            }
            else {
                var retourControles = CnafCctGestionTypeService.appelControleType5(donnee, form);
                if (retourControles !== null)
                {
                    vm.data.sitPros[index].villeEmployeur=retourControles;
                    return true;
                }
            }
        };

        vm.testType8 = function(donnee,form,nomDonnee){
            if (donnee === undefined || donnee.length === 0){
                form.$setValidity('type8', true);
            }
            else {
                var retourControles = CnafCctGestionTypeService.appelControleType8(donnee, form);
                if (retourControles !== null)
                {
                    vm.data[nomDonnee]=retourControles;
                }
            }
        };

        vm.afficheRegimeCotisation = function (index) {
            if (vm.data.sitPros[index] && vm.data.sitPros[index].choixActiviteSalariee){
                if (vm.data.sitPros[index].choixActiviteSalariee.libelle !== 'Travailleur saisonnier')
                {
                    return (true);
                }
                else {
                    return (false);
                }
            }
        };

    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctSitproChoixActiviteSalariee
     *
     * @description
     * cnafCctSitproChoixActiviteSalariee affiche les champs de saisie pour choisir son activité de type "salarié"
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} choixactivitesalarieeform formulaire
     * @param {Object} errorchoixactivitesalariee erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     * @param {boolean} conjoint indique si on traite l'état civil du conjoint
     * @param {Date} date de naissance
     * @param {Date} dernier jour du mois d'ouverture de droit à l'AL
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSitproChoixActiviteSalariee', {
        templateUrl: 'components/cnaf-cct-sitpro/cnaf-cct-sitpro-choix-activite-salariee/cnaf-cct-sitpro-choix-activite-salariee.html',
        bindings: {
            data: '=',
            choixactivitesalarieeform: "=",
            errorchoixactivitesalariee: "=",
            autocompletion: '=',
            controle: '=',
            index: '='

        },
        controllerAs: 'vm',
        controller: CnafCctSitproChoixActiviteSalarieeController
    });
})();

(function() {
    'use strict';

    CnafCctSitproChoixActiviteStagiaireController.$inject = [    'CnafCctGestionTypeService',
                                                                    'CnafCctSitproControleDateService',
                                                                    'CnafCctDateService',
                                                                    'CnafCctSitproSuccessiviteService'];

    function CnafCctSitproChoixActiviteStagiaireController(  CnafCctGestionTypeService,
                                                                CnafCctSitproControleDateService,
                                                                CnafCctDateService,
                                                                CnafCctSitproSuccessiviteService) {
        var vm = this;

        vm.listeRegimeIndemnisation = [
            { code: 'CHO-POLEEMPLOI', libelle: 'France Travail'},
            { code: 'CHO-FONCTIONPUB', libelle: 'Fonction publique'},
            { code: 'SFP',   libelle: 'Employeur ou autre'},

        ];

        /* ------------------------------------------------------------------------------------------------------------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
          vm.controleInfDateNaissance = CnafCctSitproControleDateService.controleInfDateNaissance;
          vm.controleSupDernJourMoisSuivDemAL  = CnafCctSitproControleDateService.controleSupDernJourMoisSuivDemAL;
          vm.controlerDateSitPro = CnafCctSitproSuccessiviteService.controlerDateSitPro;
          vm.dateActivitePrecMoins1jour = CnafCctSitproSuccessiviteService.dateActivitePrecMoins1jour;
            console.log(vm.data.sitPros[0]);
          if(vm.data.sitPros[vm.index-1] && vm.data.sitPros[vm.index-1].choixActivite == 'RET' ){
              vm.listeChoixStagiaire = [
                 { code: 'SFP', libelle: 'Stagiaire'}
              ];
          }else{
                vm.listeChoixStagiaire = [
                    { code: 'SFP', libelle: 'Stagiaire'},
                    { code: 'APP', libelle: 'Apprenti'},
                    { code: 'ALTERNANCE', libelle: 'En contrat de professionnalisation - En alternance'}
                ];
          }
        };

        vm.afficheMetropole = function (index) {
            // Dans le test d’accès de la DAL, on a la saisie du code postal.
            // Si le code postal saisi ne commence pas par 971, 972, 973, 974 ou 976
            // alors on applique les règles de la métropole décrites dans la US 3.7 (Activité "Congés Divers" - Métropole)
            if (vm.controle.codepostal &&
                (vm.controle.codepostal.substring(0, 3) === "971" || vm.controle.codepostal.substring(0, 3) === "972" ||
                    vm.controle.codepostal.substring(0, 3) === "973" || vm.controle.codepostal.substring(0, 3) === "974" ||
                    vm.controle.codepostal.substring(0, 3) === "976"))
            {
                return (false);
            }
            else
            {
                return (true);
            }
        };

        vm.controleSupDateDeb = function(dateFin,dateDebut){
            var valueControle = true;
            if (dateDebut && dateDebut.length >= 10 && dateFin && dateFin.length >= 10 ){
              var dateDebATester = Date.parseExact(dateDebut, "d/M/yyyy");
              var dateFinATester = Date.parseExact(dateFin, "d/M/yyyy");
              if (dateFinATester && 'Invalid Date' != dateFinATester && dateDebATester && 'Invalid Date' != dateDebATester) {
                  if (dateFinATester < dateDebATester) {
                    valueControle = false;
                }
              }
            }
            return valueControle;
        };

        vm.generationDatePosterieure = function(index){
            if(index > 0) {
                vm.datePosterieure = CnafCctSitproSuccessiviteService.generationDatePosterieure(index, vm.data.sitPros);
            }
        };

        vm.testType8 = function(donnee,form,nomDonnee){
            if (donnee === undefined || donnee.length === 0){
              form.$setValidity('type8', true);
            }
            else {
                var retourControles = CnafCctGestionTypeService.appelControleType8(donnee, form);
                if (retourControles !== null)
                {
                  vm.data[nomDonnee]=retourControles;
                }
            }
        };



    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctSitproChoixActiviteStagiaire
     *
     * @description
     * cnafCctSitproChoixActiviteStagiaire affiche les champs de saisie
     * pour activité Stagiaire, apprenti, en contrat de professionalisation
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} choixactivitecongesdiversform formulaire
     * @param {Object} errorchoixactivitestagiaire erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     * @param {boolean} conjoint indique si on traite l'état civil du conjoint
     * @param {boolean} encouple indique si présence d'une sitfam couple
     * @param {Date} datenaissance date de naissance
     * @param {Date} dernJourMoisSuivDemAL dernier jour du mois qui suit le mois de la démarche
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSitproChoixActiviteStagiaire', {
        templateUrl: 'components/cnaf-cct-sitpro/cnaf-cct-sitpro-choix-activite-stagiaire/cnaf-cct-sitpro-choix-activite-stagiaire.html',
        bindings: {
            data: '=',
            choixactivitestagiaireform: "=",
            errorchoixactivitestagiaire: "=",
            autocompletion: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafCctSitproChoixActiviteStagiaireController
    });
})();

(function() {
    'use strict';

    CnafCctSitproCotisEmployeurController.$inject = ['CnafCctAdresseSocleService','$filter','CnafSaveSaisieService','CnafCctConstantMsgTypes'];

    function CnafCctSitproCotisEmployeurController(CnafCctAdresseSocleService,$filter,CnafSaveSaisieService,CnafCctConstantMsgTypes) {
        var vm = this;

        vm.listeContrat = [
            { code: 'CDI', libelle: 'CDI'},
            { code: 'CDD', libelle: 'CDD'},
            { code: 'CUI', libelle: "Contrat unique d'insertion"},
            { code: 'AUTRE', libelle: 'Autre'}
        ];


        vm.listeChoixAutRegSal = [
            { code: 'ORGAINTERNATIONALE', libelle: 'Membre d’une organisation internationale'},
            { code: 'FONCTIONNAIRE', libelle: 'Fonctionnaire'},
            { code: 'AL', libelle: 'Membre du Parlement (Assemblée nationale ou Sénat)'},
            { code: 'AUTRE', libelle: 'Autre'}
        ];

        /* ------------------------------------------------------------------------------------------------------------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
            CnafCctAdresseSocleService.getEtatAmabis().get()
                .$promise.then(
                function successCallback(result) {
                    vm.autocompletion = "on";
                },
                function errorCallback(error) {
                    vm.autocompletion = "off";
                });

            vm.httpRechListePaysCotisation();

            //Si activité SAL : Constitution de la liste de postes pour les fonctionnaires avec les bons codes associés selon Métro/Dom
            if (vm.index >= 0 && vm.activiteSAL(vm.index))
            {
                if (vm.controle.codepostal)
                {
                    if (vm.controle.codepostal.substring(0, 3) === "971" || vm.controle.codepostal.substring(0, 3) === "972" ||
                        vm.controle.codepostal.substring(0, 3) === "973" || vm.controle.codepostal.substring(0, 3) === "974" ||
                        vm.controle.codepostal.substring(0, 3) === "976")
                    {
                        vm.listeChoixPosteFonct = [
                            { code: 'FP', libelle: 'En France'},
                            { code: 'ETRANGER', libelle: "A l'étranger"}
                        ];
                    } else {
                        vm.listeChoixPosteFonct = [
                            { code: 'GE', libelle: 'En France'},
                            { code: 'ETRANGER', libelle: "A l'étranger"}
                        ];
                    }
                }
            }

            if (vm.index >= 0 &&
               (vm.activiteAPP(vm.index) ||
                vm.activiteCONG(vm.index) ||
                vm.cesseActProRETouPENS(vm.index)))
            {
                if (vm.controle.codepostal){
                    if (vm.controle.codepostal.substring(0, 3) === "971" || vm.controle.codepostal.substring(0, 3) === "972" ||
                        vm.controle.codepostal.substring(0, 3) === "973" || vm.controle.codepostal.substring(0, 3) === "974" ||
                        vm.controle.codepostal.substring(0, 3) === "976")
                    {

                        vm.listeRegimeCotisation = [
                            { code: 'GE-CGSS', libelle: 'CGSS'},
                            { code: 'AUTREREGIME', libelle: 'Autre régime'},
                        ];
                        if (vm.activiteCONG(vm.index))
                        {

                            vm.listeRegimeCotisation = [
                                { code: 'GE-CGSS', libelle: 'CGSS'},
                                { code: 'AUTREREGIME', libelle: 'Autre régime'},
                                { code: 'AUTRE', libelle: 'Autre'}
                            ];
                        }
                    } else {

                        vm.listeRegimeCotisation = [
                            { code: 'GE', libelle: 'Régime général'},
                            { code: 'AG', libelle: 'MSA'},
                            { code: 'AUTREREGIME', libelle: 'Autre régime'}
                        ];
                        if (vm.activiteCONG(vm.index))
                        {

                            vm.listeRegimeCotisation = [
                                { code: 'GE', libelle: 'Régime général'},
                                { code: 'AG', libelle: 'MSA'},
                                { code: 'AUTREREGIME', libelle: 'Autre régime'},
                                { code: 'GE-CPAM', libelle: 'CPAM'},
                                { code: 'AUTRE', libelle: 'Autre'}
                            ];
                        }
                    }
                }
            }
            else {
                if ((vm.index >= 0 && vm.activiteETU(vm.index)) ||
                    (vm.index === 0 && vm.controle.etudiant) ||
                    (vm.index >= 0 && vm.activiteSAL(vm.index)))
                {
                    if (vm.controle.codepostal)
                    {
                        if (vm.controle.codepostal.substring(0, 3) === "971" || vm.controle.codepostal.substring(0, 3) === "972" ||
                            vm.controle.codepostal.substring(0, 3) === "973" || vm.controle.codepostal.substring(0, 3) === "974" ||
                            vm.controle.codepostal.substring(0, 3) === "976")
                        {

                            vm.listeRegimeCotisation = [
                                { code: 'CGSS', libelle: 'CGSS'},
                                { code: 'Autre', libelle: 'Autre régime'},
                                { code: 'ETRANGER', libelle: 'Régime étranger'}
                            ];
                        } else {

                            vm.listeRegimeCotisation = [
                                { code: 'URSSAF', libelle: 'Urssaf'},
                                { code: 'MSA', libelle: 'MSA'},
                                { code: 'Autre', libelle: 'Autre régime'},
                                { code: 'ETRANGER', libelle: 'Régime étranger'}
                            ];
                        }
                    }
                }
                else {
                    if (vm.index >= 0 &&
                       vm.activiteNSAL(vm.index))
                    {
                        vm.listeRegimeCotisation = [
                            { code: 'GE', libelle: 'Urssaf / SSI'},
                            { code: 'AG', libelle: 'MSA'},
                            { code: 'AUTREREGIME', libelle: 'Autre régime'},
                            { code: 'AG-ARTISTES', libelle: 'Maison des artistes / AGESSA'},
                            { code: 'GE-CGSS', libelle: 'CGSS'}
                        ];
                    }
                }
            }

            if(CnafSaveSaisieService.getPageFromListHistoriqueByID('etatcivil_2')){
                vm.etatCivilCjt = CnafSaveSaisieService.getPageFromListHistoriqueByID('etatcivil_2').data;
            }
        };

        //Recherche liste pays
        vm.httpRechListePaysCotisation = function() {
            CnafCctAdresseSocleService.rechListePays().get().$promise.then(
                function successCallback (response0) {
                    vm.listePaysCotisation = response0.listePays;
                },
                function errorCallback(error) {
                    vm.etat = "error";
                });
        };

        //AUTO-COMPLETION
        //Pays :
        vm.getListePaysCotisationProposes = function(prefix) {
            return vm.listePaysCotisation;
        };

        vm.afficheNomOrganisme = function (index) {
            if (vm.data.sitPros[index] && vm.data.sitPros[index].cotisEmployeur){
                if (vm.data.sitPros[index].cotisEmployeur.libelle === 'Autre régime' ||
                    vm.data.sitPros[index].cotisEmployeur.libelle === 'Autre')
                {
                    return (true);
                }
                else {
                    return (false);
                }
            }
        };


        //le 6/11/2017 - US 3.22 : La question sur le type de contrat de travail est supprimée.
        //Vu avec Claire, cette question est également supprimée pour les autres sitpros
        /*vm.afficheContrat = function (index) {
            if (vm.data.sitPros[index] && vm.data.sitPros[index].cotisEmployeur && vm.data.sitPros[index].choixActiviteSalariee){
                if (vm.data.sitPros[index].cotisEmployeur.code == 'GE'||
                  vm.data.sitPros[index].cotisEmployeur.libelle == 'Cgss' ||
                  vm.data.sitPros[index].cotisEmployeur.libelle == 'Autre régime'||
                  (vm.data.sitPros[index].cotisEmployeur.libelle == 'MSA' && (vm.conjoint || index > 0)) ||
                  (vm.data.sitPros[index].cotisEmployeur.libelle == 'Régime étranger' && vm.data.sitPros[index].detacheFrance == 'Non'))
                {
                    if (vm.data.sitPros[index].choixActiviteSalariee.libelle == 'Salarié'){
                        return (true);
                    } else {
                        return (false);
                    }
                }
                else {
                    return (false);

                }
            }

        };*/

        vm.affichePaysCotisation = function (index) {
            if (vm.data.sitPros[index] && vm.data.sitPros[index].cotisEmployeur){
                if (vm.data.sitPros[index].cotisEmployeur.libelle == 'Régime étranger'){
                    return (true);
                }
                else {
                    return (false);
                }
            }
        };

        vm.afficheMetropole = function (index) {
            // Dans le test d’accès de la DAL, on a la saisie du code postal.
            // Si le code postal saisi ne commence pas par 971, 972, 973, 974 ou 976
            // alors on applique les règles de la métropole décrites dans la US 3.5 (Activités non salariés Métropole)
            if (vm.controle.codepostal &&
                (vm.controle.codepostal.substring(0, 3) === "971" || vm.controle.codepostal.substring(0, 3) === "972" ||
                    vm.controle.codepostal.substring(0, 3) === "973" || vm.controle.codepostal.substring(0, 3) === "974" ||
                    vm.controle.codepostal.substring(0, 3) === "976"))
            {
                return (false);
            }
            else
            {
                return (true);
            }
        };


        vm.gerantSalarie = function (index) {
            // SAL + 'Gérant Salarié'
            if (vm.data.sitPros[index].choixActiviteSalariee &&
                vm.data.sitPros[index].choixActiviteSalariee.libelle)
            {
                if ((vm.data.sitPros[index].choixActiviteSalariee.libelle == 'Gérant salarié' &&
                      vm.data.sitPros[index].choixActivite == 'SAL') ||
                   (vm.data.sitPros[index].cesseActProPens === false &&
                     vm.data.sitPros[index].choixActiviteSalariee.libelle == 'Gérant salarié' &&
                      vm.data.sitPros[index].choixActivite == 'PENS' &&
                      vm.data.sitPros[index].choixActiviteComplementInvalidite == 'SAL') ||
                   (vm.data.sitPros[index].cesseActProRet === false &&
                     vm.data.sitPros[index].choixActiviteSalariee.libelle == 'Gérant salarié' &&
                      vm.data.sitPros[index].choixActivite == 'RET' &&
                      vm.data.sitPros[index].choixActiviteComplementRetraite == 'SAL'))
                  {
                      return (true);
                  }else{
                      return (false);
                  }
              }
              else {
                return (false);
              }
        };

        vm.activiteCONG = function (index) {
            if (vm.data.sitPros[index].choixActivite == 'CONG' ||
               (vm.data.sitPros[index].cesseActProPens === false &&
                  vm.data.sitPros[index].choixActivite == 'PENS' &&
                  vm.data.sitPros[index].choixActiviteComplementInvalidite == 'CONG') ||
               (vm.data.sitPros[index].cesseActProRet === false &&
                  vm.data.sitPros[index].choixActivite == 'RET' &&
                  vm.data.sitPros[index].choixActiviteComplementRetraite == 'CONG'))
              {
                  return (true);
              }else{
                  return (false);
              }
        };

        vm.activiteNSAL = function (index) {
            if (vm.data.sitPros[index].choixActivite == 'NSAL' ||
               (vm.data.sitPros[index].cesseActProPens === false &&
                  vm.data.sitPros[index].choixActivite == 'PENS' &&
                  vm.data.sitPros[index].choixActiviteComplementInvalidite == 'NSAL') ||
               (vm.data.sitPros[index].cesseActProRet === false &&
                  vm.data.sitPros[index].choixActivite == 'RET' &&
                  vm.data.sitPros[index].choixActiviteComplementRetraite == 'NSAL'))
              {
                  return (true);
              }else{
                  return (false);
              }
        };

        vm.activiteAPP = function (index) {
            if (vm.data.sitPros[index].choixActivite == 'APP' ||
               (vm.data.sitPros[index].cesseActProPens === false &&
                  vm.data.sitPros[index].choixActivite == 'PENS' &&
                  vm.data.sitPros[index].choixActiviteComplementInvalidite == 'APP') ||
               (vm.data.sitPros[index].cesseActProRet === false &&
                  vm.data.sitPros[index].choixActivite == 'RET' &&
                  vm.data.sitPros[index].choixActiviteComplementRetraite == 'APP'))
              {
                  return (true);
              }else{
                  return (false);
              }
        };

        vm.activiteSAL = function (index) {
            if (vm.data.sitPros[index].choixActivite == 'SAL' ||
               (vm.data.sitPros[index].cesseActProPens === false &&
                  vm.data.sitPros[index].choixActivite == 'PENS' &&
                  vm.data.sitPros[index].choixActiviteComplementInvalidite == 'SAL') ||
               (vm.data.sitPros[index].cesseActProRet === false &&
                  vm.data.sitPros[index].choixActivite == 'RET' &&
                  vm.data.sitPros[index].choixActiviteComplementRetraite == 'SAL'))
              {
                  return (true);
              }else{
                  return (false);
              }
        };

        vm.activiteETU = function (index) {
            if (vm.data.sitPros[index].choixActivite == 'ETU' ||
               (vm.data.sitPros[index].cesseActProPens === false &&
                  vm.data.sitPros[index].choixActivite == 'PENS' &&
                  vm.data.sitPros[index].choixActiviteComplementInvalidite == 'ETU') ||
               (vm.data.sitPros[index].cesseActProRet === false &&
                  vm.data.sitPros[index].choixActivite == 'RET' &&
                  vm.data.sitPros[index].choixActiviteComplementRetraite == 'ETU'))
              {
                  return (true);
              }else{
                  return (false);
              }
        };

        vm.afficheDetache = function (index) {
            if (vm.data.sitPros[index] && vm.data.sitPros[index].cotisEmployeur && vm.data.sitPros[index].choixActiviteSalariee){
                if (vm.data.sitPros[index].choixActiviteSalariee.libelle !== 'Intérimaire' && vm.data.sitPros[index].cotisEmployeur.libelle == 'Régime étranger'){
                    if(vm.etatCivilCjt && vm.etatCivilCjt.resideEtranger == 'Non'){
                        return (true);
                    }else{
                        return (false);
                    }
                } else {
                    return (false);
                }
            }
        };

        vm.cesseActProRETouPENS = function (index) {
            if ((vm.data.sitPros[vm.index].choixActivite == 'RET' &&
                  vm.data.sitPros[vm.index].cesseActProRet) ||
               (vm.data.sitPros[vm.index].choixActivite == 'PENS' &&
                  vm.data.sitPros[vm.index].cesseActProPens))
              {
                  return (true);
              }else{
                  return (false);
              }
        };


    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctSitproCotisEmployeur
     *
     * @description
     * cnafCctSitproCotisEmployeur affiche les champs de saisie pour saisir le régime de cotisation
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} cotisemployeurform formulaire
     * @param {Object} errorcotisemployeur erreurs
     * @param {Object} activite activité salariée sélectionnée
     * @param {boolean} conjoint indique si on traite l'état civil du conjoint
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */


    angular.module('cnafComponentsTeleprocApp').component('cnafCctSitproCotisEmployeur', {
        templateUrl: 'components/cnaf-cct-sitpro/cnaf-cct-sitpro-cotis-employeur/cnaf-cct-sitpro-cotis-employeur.html',
        bindings: {
            data: '=',
            cotisemployeurform: "=",
            errorcotisemployeur: "=",
            controle: "=",
            index: "="
        },
        controllerAs: 'vm',
        controller: CnafCctSitproCotisEmployeurController
    });
})();

(function() {
    'use strict';

    CnafCctSitproEtudiantController.$inject = ['CnafCctAdresseSocleService','CnafCctDateService','CnafCctSitproControleDateService','CnafCctSitproSuccessiviteService'];

    function CnafCctSitproEtudiantController(CnafCctAdresseSocleService,CnafCctDateService,CnafCctSitproControleDateService,CnafCctSitproSuccessiviteService) {
        var vm = this;

        /* ------------------- */
        /*       SERVICE       */
        /* ------------------- */
        vm.parseDate = CnafCctDateService.parseDate;

        /* ------------------------------------------------------------------------------------------------------------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
            vm.isXs = true;
            vm.controleInfDateNaissance = CnafCctSitproControleDateService.controleInfDateNaissance;
            vm.controleSupDateOd = CnafCctSitproControleDateService.controleSupDateOd;
            vm.controlerDateSitPro = CnafCctSitproSuccessiviteService.controlerDateSitPro;
            vm.dateActivitePrecMoins1jour = CnafCctSitproSuccessiviteService.dateActivitePrecMoins1jour;


            vm.httpRechListePaysBourse();
        };

        vm.initClassXs = function(){
            vm.isXs = false;
        };

        vm.generationDatePosterieure = function(index){
            if(index > 0) {
                vm.datePosterieure = CnafCctSitproSuccessiviteService.generationDatePosterieure(index, vm.data.sitPros);
            }
        };

        vm.afficheBoursier = function (index) {
            if (vm.data.sitPros[index] && vm.data.sitPros[index].sitproetu){
                if (vm.data.sitPros[index].sitproetu === 'etu'){
                    return (true);
                }
                else  if (vm.data.sitPros[index].sitproetu === 'ets'){
                    if (vm.data.sitPros[index].dtDebContrat && (vm.parseDate(vm.data.sitPros[index].dtDebContrat) >= vm.controle.deuxSeptembreAnneeOD)){
                        return (true);
                    }
                    else if (vm.data.sitPros[index].couvreanneesco && vm.data.sitPros[index].couvreanneesco === 'Non'){
                        return (true);
                    }
                    else if ( (vm.data.sitPros[index].typeheurescontrat == 'hebdo' && (vm.data.sitPros[index].nbheures * 52) < 600) ||
                        (vm.data.sitPros[index].typeheurescontrat == 'mensuel' && (vm.data.sitPros[index].nbheures * 12) < 600) ||
                        (vm.data.sitPros[index].typeheurescontrat == 'trimestriel' && (vm.data.sitPros[index].nbheures < 150)) ){
                        return (true);
                    }
                    else{
                        return (false);
                    }
                }else if (vm.data.sitPros[index].sitproetu === 'etudiantActNonSal'){
                    if(vm.data.sitPros[index].dateActNonSal){
                        return (true);
                    }else{
                        return (false);
                    }
                }
            }
        };

        vm.controleNbreHeures = function (nbreHeures, typeheurescontrat) {
            var valueControle = true;
            if (nbreHeures !== undefined && nbreHeures !== "")
            {
                if ((typeheurescontrat == "hebdo" && nbreHeures > 39) ||
                    (typeheurescontrat == "mensuel" && nbreHeures > 169) ||
                    (typeheurescontrat == "trimestriel" && nbreHeures > 507))
                {
                    valueControle = false;
                }
            }
            return valueControle;
        };

        vm.afficheRegimeAffil = function (index) {
            if (vm.data.sitPros[index] && vm.data.sitPros[index].sitproetu){
                if (vm.data.sitPros[vm.index].boursier && vm.data.sitPros[vm.index].boursier === 'Non'){
                    if(vm.data.sitPros[index].sitproetu === 'etudiantActNonSal'){
                        return (false);
                    }else{
                        return (true);
                    }
                } else if (vm.data.sitPros[index].sitproetu === 'etu' && vm.controle.agesup29){
                    return (true);
                } else {
                    return (false);
                }
            }
        };

        vm.afficheRegimeCotisation = function (index) {
            if (vm.data.sitPros[index] && vm.data.sitPros[index].sitproetu === 'ets'){
                if ( (vm.data.sitPros[index].typeheurescontrat == 'hebdo' && (vm.data.sitPros[index].nbheures * 52) >= 600) ||
                    (vm.data.sitPros[index].typeheurescontrat == 'mensuel' && (vm.data.sitPros[index].nbheures * 12) >= 600) ||
                    (vm.data.sitPros[index].typeheurescontrat == 'trimestriel' && (vm.data.sitPros[index].nbheures >= 150)) ){
                    return (true);
                }
                else{
                    return (false);
                }
            } else {
                return (false);
            }
        };

        //Recherche liste pays pour établissement boursier
        vm.httpRechListePaysBourse = function() {
            CnafCctAdresseSocleService.rechListePays().get().$promise.then(
                function successCallback (response0) {
                    vm.listePaysBourse = response0.listePays;
                },
                function errorCallback(error) {
                    vm.etat = "error";
                });
        };

        //AUTO-COMPLETION
        //Pays :
        vm.getListePaysBourseProposes = function(prefix) {
            return vm.listePaysBourse;
        };

        vm.controleRessSuffisantesChckBx = function(value, form){
            //La case à cocher « Vous déclarez avoir des ressources suffisantes pour vivre » doit obligatoirement être cochée pour continuer
            //Au clic sur le bouton « Continuer », si la case n’est pas cochée,
            //on affiche sous le champ le message suivant : « La case à cocher doit être saisie pour continuer ».
            form.ressSuffisantesChckBx.$setValidity('obligatoire', true);

            if (vm.controle.nationalite==='C' && value === false) {
                form.ressSuffisantesChckBx.$setValidity('obligatoire', false);
            }

        };

        /**
         * @ngdoc method
         * @name openPopupSitPro
         * @methodOf cnafComponentsTeleprocApp.component:cnafCctSitproEtudiant
         * @description
         * Popup d'information spécifiant à l'utilisateur que
         * ses situations antérieures vont être supprimées
         */
        vm.openPopupSitPro = function () {
            $(':focus').blur();

            //Instanciation et ouverture de la modale
            var modalSitPro = $uibModal.open({
                component: 'cnafModalSitPro'
            });

            //Fonction appelée lors de la fermeture de la modal
            modalSitPro.result.then(function () {
                $(':focus').blur();
            });

        };

    }

    /**
     * @ngdoc directive
     * @name cnafComponentsTeleprocApp.component:cnafCctSitproEtudiant
     *
     * @description
     * cnafCctSitproEtudiant affiche les champs de saisie pour activité étudiant
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} sitproetudiantform formulaire
     * @param {Object} errorsitproetudiant erreurs
     * @param {boolean} agesup29 indique si la personne a plus de 29 ans
     * @param {boolean} encouple indique si présence d'une sitfam couple
     * @param {boolean} conjoint indique si on traite l'état civil du conjoint
     * @param {Object} anneeperiode année période du contrat de travail
     * @param {String} nationalite code nationalité
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSitproEtudiant', {
        templateUrl: 'components/cnaf-cct-sitpro/cnaf-cct-sitpro-etudiant/cnaf-cct-sitpro-etudiant.html',
        bindings: {
            data: '=',
            sitproetudiantform: "=",
            errorsitproetudiant: "=",
            controle: '=',
            index: "="
        },
        controllerAs: 'vm',
        controller: CnafCctSitproEtudiantController
    });
})();

(function() {
    'use strict';

    angular
        .module('cnafComponentsTeleprocApp')
        .service('CnafCctSitproControleDateService', CnafCctSitproControleDateService);

    CnafCctSitproControleDateService.$inject = [];

    function CnafCctSitproControleDateService() {

        //Fonction de contrôle
        //Contrôle si la date de début d'activité est postérieure à la date de naissance
        this.controleInfDateNaissance = function (date, dateNaissance) {
            var valueControle = true;
            if (date && date.length >= 10 ){
              //console.log("controleInfDateNaissance avec date = "+date+" dateNaissance = "+dateNaissance);
              var dateATester = Date.parseExact(date, "d/M/yyyy");
              var dateNaiss = Date.parseExact(dateNaissance, "d/M/yyyy");
              if (dateATester && 'Invalid Date' != dateATester) {
                  if (dateATester < dateNaiss) {
                    valueControle = false;
                }
              }
            }
            return valueControle;
        };

        //US3.24-Méthode controleSupDateOd conservée ici seulement pour 'Etudiant' (Révision prévue dans une future US)
        //===> Méthode à supprimer ensuite...
        //-------------------------------------------------------------------------------------------------------------
        //Contrôle si la date de début d'activité est postérieure au dernier jour du mois d'od
        this.controleSupDateOd = function (date, dernjourodal, index) {
            var valueControle = true;
            if (index === 0 && date && date.length >= 10 ){
              var dateATester = Date.parseExact(date, "d/M/yyyy");
              if (dateATester && 'Invalid Date' != dateATester) {
                  if (dateATester > dernjourodal) {
                    valueControle = false;
                }
              }
            }
            return valueControle;
        };
        //--------------------------------------------------------------------------------------------------------------

        //US3.24-Nouveau Contrôle sur la date de début d'activité // au dernier jour du mois qui suit le mois de la démarche
        this.controleSupDernJourMoisSuivDemAL = function (date, dernJourMoisSuivDemAL, index) {
            var valueControle = true;
            if (index === 0 && date && date.length >= 10 ){
              var dateATester = Date.parseExact(date, "d/M/yyyy");
              if (dateATester && 'Invalid Date' != dateATester) {
                  if (dateATester > dernJourMoisSuivDemAL) {
                    valueControle = false;
                }
              }
            }
            return valueControle;
        };




        this.controleDatePerActOK = function (dateactsaisie, datedebperiodeactal){
            var valueCtr = true;
            if (datedebperiodeactal && dateactsaisie && dateactsaisie.length >= 10 ){
              var dateATester = Date.parseExact(dateactsaisie, "d/M/yyyy");
              if (dateATester && 'Invalid Date' != dateATester) {
                  if (dateATester > datedebperiodeactal) {
                    valueCtr = false;
                }
              }
            }
            return valueCtr;
        };

      }
})();

(function() {
    'use strict';

    /**
     * @ngdoc service
     * @name cnafComponentsTeleprocApp.service:CnafCctSitproSuccessiviteService
     *
     * @description
     * Service de gestion des sitpros successives
     *
     */
    angular
        .module('cnafComponentsTeleprocApp')
        .service('CnafCctSitproSuccessiviteService', CnafCctSitproSuccessiviteService);

    CnafCctSitproSuccessiviteService.$inject = ['$uibModal', 'CnafCctSitproControleDateService', 'CnafCctDateService'];

    function CnafCctSitproSuccessiviteService($uibModal, CnafCctSitproControleDateService, CnafCctDateService) {

        var cnafCctSitproSuccessiviteService = this;

        /**
         * @ngdoc method
         * @name controlerDateSitPro
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctSitproSuccessiviteService
         * @param {date} dateactsaisie Date au format dd/jj/aaaa
         * @param {number} index index de la sitPro en cours de saisie
         * @description
         * Permet de vérifier si la date de debut activité saisie couvre la période
         * sinon on devra ajouter un bloc de saisie pour donner la possibilité
         * de saisir la sitPro antéieure.
         */
        this.controlerDateSitPro = function(dateactsaisie, index, sitPros, datePosterieure, datedebperiodeactal) {
            var retour = true;
            if(index > 0 ){
                if (dateactsaisie && dateactsaisie.length >= 10) {
                    var dateactsaisieFormatDate = Date.parseExact(dateactsaisie, "d/M/yyyy");
                    if (dateactsaisieFormatDate && 'Invalid Date' != dateactsaisieFormatDate) {
                        // controle si la date saisie est bien antérieure à la date saisie
                        // plus haut dans l'écran
                        var controleDateSitPrec = cnafCctSitproSuccessiviteService.controlerDateSitProEnCoursVsSitProPrec(dateactsaisieFormatDate, index, sitPros, datePosterieure);
                        if(controleDateSitPrec) {
                            // on recherche si la période est couverte par la sitPro en cours
                            var dateCouverte = CnafCctSitproControleDateService.controleDatePerActOK(dateactsaisie, datedebperiodeactal);
                            // si une date postérieure est modifiée
                            var datePosterieureModifiee = cnafCctSitproSuccessiviteService.controlerDateSitProEnCoursVsSitProSuiv(dateactsaisieFormatDate, index, sitPros);
                            if (!dateCouverte && datePosterieureModifiee && index < 15) {
                                cnafCctSitproSuccessiviteService.addNewSitPro(index, sitPros);
                            } else {
                                cnafCctSitproSuccessiviteService.verifieSiDateChangee(dateactsaisie, index, sitPros);
                                // cas où l'utilisateur modifie une situation postérieure
                                // celle-ci ne couvre pas la période souhaitée donc après avoir supprimé les
                                // sitPros antérieures on ajoute une sitPro antérieure vierge que
                                // l'utilisateur devra renseigner.
                                if (!dateCouverte) {
                                    cnafCctSitproSuccessiviteService.addNewSitPro(index, sitPros);
                                }else{
                                    cnafCctSitproSuccessiviteService.removeSitPro(index, sitPros);
                                }
                            }
                        } else {
                            retour = false;
                        }
                    }
                }
            }
            return retour;
        };

        this.verifieSiDateChangee = function(dateactsaisie, index, sitPros) {
            if(sitPros[index+1] && sitPros[index+1].dateFinActivite){
                if(!(sitPros[index+1].dateFinActivite === dateactsaisie)){
                    cnafCctSitproSuccessiviteService.removeSitPro(index, sitPros);
                }
            }
        };

        /**
         * @ngdoc method
         * @name openPopupSitPro
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctSitproSuccessiviteService
         * @description
         * Popup d'information spécifiant à l'utilisateur que
         * ses situations antérieures vont être supprimées
         */
        this.openPopupSitPro = function () {
            $(':focus').blur();

            //Instanciation et ouverture de la modale
            var modalSitPro = $uibModal.open({
                component: 'cnafModalSitPro'
            });

            //Fonction appelée lors de la fermeture de la modal
            modalSitPro.result.then(function () {
                $(':focus').blur();
            });
        };

        /**
         * @ngdoc method
         * @name addNewSitPro
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctSitproSuccessiviteService
         * @description
         * Ajout d'un élément dans le tableau de sitPro afin
         * d'afficher une nouvelle sit pro disponible à la saisie
         *
         */
        this.addNewSitPro = function(index, sitPros) {
            var isOkPourAjout = true;

            // on incrémente l'indice de la date saisie actuellement
            var newItemNo = index+1;

            // on recherche si l'indice de la sit pro suivante est
            // déjà présente.
            angular.forEach(sitPros, function(value, key) {
                if (value.id === newItemNo) {
                    isOkPourAjout = false;
                }
            });

            // Si elle est déjà présente on n'affiche pas
            // de sit pro supplémentaire.
            if (isOkPourAjout) {
                sitPros.push({'id': newItemNo});
            }
        };

        /**
         * @ngdoc method
         * @name removeSitPro
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctSitproSuccessiviteService
         * @param {number} index de la date saisie actuellement
         * @description
         * Permet de supprimer une sit Pro si elle est
         * contenu dans la liste (index+1)
         */
        this.removeSitPro = function(index, sitPros) {
            var isOkPourSuppression = false;

            // on incrémente l'indice de la date saisie actuellement
            var suppItemNo = index+1;

            // on recherche si l'indice de la sit pro suivante est
            // déjà présente.
            angular.forEach(sitPros, function(value, key) {
                // je verifie si la date activite est aussi presente
                if (value.id === suppItemNo) {
                    isOkPourSuppression = true;
                }
            });

            if (isOkPourSuppression) {
                cnafCctSitproSuccessiviteService.openPopupSitPro();
                sitPros.splice(suppItemNo);
                return sitPros;
            }
        };

        /**
         * @ngdoc method
         * @name controlerDateSitProEnCoursVsSitProPrec
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctSitproSuccessiviteService
         * @param {date} dateactsaisie Date au format dd/jj/aaaa
         * @param {number} index index de la sitPro en cours de saisie
         * @description
         * Permet de vérifier si la date de index est bien inférieure ou égale
         *  à la date de index -1
         */
        this.controlerDateSitProEnCoursVsSitProPrec = function(dateactsaisie, index, sitPros, datePosterieure) {
            var  controle = true;
            // si au moins deux dates de saisies
            if (dateactsaisie && index > 0) {
                datePosterieure = Date.parseExact(sitPros[index-1].dateActivite, "d/M/yyyy");
                // si la date de saisie n'est pas antéieure à la situation
                // saisie précédemment, on affiche un message
                if (datePosterieure && datePosterieure <= dateactsaisie) {
                    controle = false;
                }

            }
            return controle;
        };

        /**
         * @ngdoc method
         * @name controlerDateSitProEnCoursVsSitProSuiv
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctSitproSuccessiviteService
         * @param {date} dateactsaisie Date activite en cours de saisie
         * @param {number} index index de la sitPro en cours de saisie
         * @description
         * Permet de vérifier si la date de index est bien supérieure à la date de index +1
         */
        this.controlerDateSitProEnCoursVsSitProSuiv = function(dateactsaisie, index, sitPros) {
            var  controle = true;
            // si au moins deux dates de saisies
            if (dateactsaisie) {
                if (sitPros.length >= index+1) {
                    //On récupère la date de la situation anterieure à la date en cours de saisie.
                    //Ceci peut arriver lorsque l utilisateur revient sur une date
                    var sitProAnterieure = sitPros[index+1];
                    if (sitProAnterieure){
                        //vm.dateAnterieure = Date.parseExact(vm.sitProAnterieure.dateActivite, "d/M/yyyy");
                        // si date non définie (cas d'une erreur dessus)
                        // ou si dateDeb act antérieure sup ou égale à la date en cours de saisie
                        //if (!vm.dateAnterieure || vm.dateAnterieure >= dateactsaisie)
                        var dateAnterieure = Date.parseExact(sitProAnterieure.dateFinActivite, "d/M/yyyy");
                        //Si une date de fin antérieure existe et qu'elle n'est pas égale à la date saisie -1jour...
                        var dateAControler = new Date(dateactsaisie);
                        dateAControler.setDate(dateAControler.getDate()-1);
                        if (!dateAnterieure || dateAnterieure.getTime() !== dateAControler.getTime()){
                            controle = false;
                        }
                    }
                }
            }
            return controle;
        };

        this.dateActivitePrecMoins1jour = function(index, dateActivite, sitPros) {
           if (index > 0) {
               var dateFinMoinsUn = new Date(Date.parseExact(dateActivite, "d/M/yyyy"));
               dateFinMoinsUn.setDate(dateFinMoinsUn.getDate()-1);

               dateFinMoinsUn = CnafCctDateService.ddmmyyyy(dateFinMoinsUn);
               if (sitPros[index] && !sitPros[index].dateFinActivite) {
                   sitPros[index].dateFinActivite = dateFinMoinsUn;
               }
               return true;
           }
       };

        this.generationDatePosterieure = function(index, sitPros) {
            return Date.parseExact(sitPros[index-1].dateActivite, "d/M/yyyy");
        };

        /**
         * @ngdoc method
         * @name besoinSitproAnterieure
         * @methodOf cnafComponentsTeleprocApp.service:CnafCctSitproSuccessiviteService
         * @param {date} dateactsaisie Date au format dd/jj/aaaa
         * @param {number} index index de la sitPro en cours de saisie
         * @description
         * Permet de vérifier si la date de debut activité saisie couvre la période
         * sinon on devra ajouter un bloc de saisie pour donner la possibilité
         * de saisir la sitPro antéieure.
         */
        this.besoinSitproAnterieure = function(dateactsaisie, sitPros, datedebperiodeactal) {
            var dateactsaisieFormatDate = Date.parseExact(dateactsaisie, "d/M/yyyy");
            // controle si la date saisie est bien antérieure à la date saisie
            // plus haut dans l'écran
            var controleDateSitPrec = cnafCctSitproSuccessiviteService.controlerDateSitProEnCoursVsSitProPrec(dateactsaisieFormatDate, 0, sitPros, null);
            if(controleDateSitPrec) {
                // on recherche si la période est couverte par la sitPro en cours
                var dateCouverte = CnafCctSitproControleDateService.controleDatePerActOK(dateactsaisie, datedebperiodeactal);
                // si une date postérieure est modifiée
                var datePosterieureModifiee = cnafCctSitproSuccessiviteService.controlerDateSitProEnCoursVsSitProSuiv(dateactsaisieFormatDate, 0, sitPros);
                if (!dateCouverte && datePosterieureModifiee) {
                    return true;
                } else {
                    if (!dateCouverte) {
                        return true;
                    }else{
                        return false;
                    }
                }
            } else {
                return false;
            }
        };
    }
})();

(function() {
    'use strict';

    CnafSitproAssurancePretController.$inject = ['CnafCctGestionTypeService', 'CnafCctSituationproControleDateService'];

    function CnafSitproAssurancePretController(CnafCctGestionTypeService, CnafCctSituationproControleDateService) {
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafSitproAssurancePret
     *
     * @description
     * cnafSitproAssurancePret affiche les champs de saisie pour l'assurance des prêts
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} assurancepretform formulaire
     * @param {Object} errorassurancepret erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     * @param {boolean} conjoint indique si on traite l'état civil du conjoint
     * @param {boolean} encouple indique si présence d'une sitfam couple
     * @param {Date} datenaissance date de naissance
     * @param {Date} dernJourMoisSuivDemAL dernier jour du mois qui suit le mois de la démarche
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproAssurancePret', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-assurance-pret/cnaf-cct-situationpro-assurance-pret.html',
        bindings: {
            data: '=',
            assurancepretform: '=',
            errorassurancepret: '=',
            autocompletion: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafSitproAssurancePretController
    });
})();

(function() {
    'use strict';

    CnafSitproAutreSituationController.$inject = ['CnafCctAdresseSocleService', '$filter'];

    function CnafSitproAutreSituationController(CnafCctAdresseSocleService, $filter) {
        var vm = this;

        vm.listeChoixAutreSituation = [
            { code: 'SSA', libelle: 'Sans activité', id: 'SSA' },
            { code: 'MAL', libelle: 'En arrêt maladie', id: 'MAL' },
            { code: 'MOC', libelle: 'Membre d’une organisation communautaire', id: 'MOC' },
            { code: 'DETENU', libelle: 'En détention', id: 'DETENU', ael: 'Concerne les personnes incarcérées' },
            { code: 'AIDANT', libelle: 'Aidant familial percevant un dédommagement', id: 'AIDANT' },
            { code: 'VOL', libelle: 'Volontariat', id: 'VOL' },
            { code: 'JEUNE', libelle: 'Bénéficiaire de la garantie jeune', id: 'JEUNE' }
        ];

        /* ------------------------------------------------------------------------------------------------------------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
            vm.initListeVolontariat();
            if (vm.controle.encouple){
                vm.controle.libPersonneSansActi = vm.controle.libPersonneEnCours + " est inscrit(e) à France Travail";
                
            } else {
                vm.controle.libPersonneSansActi = "Vous êtes inscrit(e) à France Travail";
                
            }
        };

        vm.initListeVolontariat = function() {
            if (vm.isAgeSupAXX(55)) {
                vm.listechoixautresituationvolontariat = [
                    { code: 'VINTER', libelle: 'Volontaire international', id: 'VINTER' },
                    { code: 'VCIVIL', libelle: 'Volontaire civil', id: 'VCIVIL' }
                ];
            } else if (vm.isAgeSupAXX(31)) {
                vm.listechoixautresituationvolontariat = [
                    { code: 'SAPEUR', libelle: 'Sapeur-pompier volontaire', id: 'SAPEUR' },
                    { code: 'VINTER', libelle: 'Volontaire international', id: 'VINTER' },
                    { code: 'VCIVIL', libelle: 'Volontaire civil', id: 'VCIVIL' }
                ];
            } else {
                vm.listechoixautresituationvolontariat = [
                    { code: 'CIVIC', libelle: 'Service civique', id: 'CIVIC' },
                    { code: 'ARMEE', libelle: 'Volontaire dans les armées', id: 'ARMEE' },
                    { code: 'SAPEUR', libelle: 'Sapeur-pompier volontaire', id: 'SAPEUR' },
                    { code: 'VINTER', libelle: 'Volontaire international', id: 'VINTER' },
                    { code: 'VINSER', libelle: 'Volontaire pour insertion (EPIDE)', id: 'VINSER' },
                    { code: 'VCIVIL', libelle: 'Volontaire civil', id: 'VCIVIL' },
                    { code: 'SMADAP', libelle: 'Service Militaire Adapté', id: 'SMADAP' }
                ];
            }
        };

        /**
         * @deprecated utiliser la méthode dans CnafCctDateService
         */
        vm.isAgeSupAXX = function(age) {
            if (vm.controle.datenaissance != undefined) {
                var dateNaisPlusXX = new Date(vm.controle.datenaissance);
                dateNaisPlusXX.add({ years: age });
                return vm.controle.datedemarche > dateNaisPlusXX;
            }
        };

        /**
         * Supprime le choix de la cotisation
         */
        vm.deleteChoixAutreSituation = function() {
            delete vm.data.sitPros[vm.index].poleEmploi;
            delete vm.data.sitPros[vm.index].affectionLongueDuree;
            delete vm.data.sitPros[vm.index].choixAutreSituationVolontariat;
        };
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafSitproAutreSituation
     *
     * @description
     * cnafSitproAutreSituation affiche les champs de saisie pour activité conges divers
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} autresituationform formulaire
     * @param {Object} errorautresituation erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     * @param {boolean} conjoint indique si on traite l'état civil du conjoint
     * @param {boolean} encouple indique si présence d'une sitfam couple
     * @param {Date} datenaissance date de naissance
     * @param {Date} dernjourodal dernier jour du mois d'ouverture de droit à l'AL
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproAutreSituation', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-autre-situation/cnaf-cct-situationpro-autre-situation.html',
        bindings: {
            data: '=',
            autresituationform: '=',
            errorautresituation: '=',
            autocompletion: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafSitproAutreSituationController
    });
})();

(function() {
    'use strict';

    CnafSitproChoixActiviteController.$inject = ['CnafCctAdresseSocleService'];

    function CnafSitproChoixActiviteController(CnafCctAdresseSocleService) {
        var vm = this;
        var choixActivitesStandard = [
            {
                code: 'SAL',
                libelle: 'En activité salariée'
            },
            {
                code: 'NSAL',
                libelle: 'En activité non salariée'
            },
            {
                code: 'ETU',
                libelle: 'Etudiant(e) avec ou sans activité - Boursier(ère) ou non boursier(ère)'
            },
            {
                code: 'APP',
                libelle: 'Stagiaire - Apprenti(e) - En alternance'
            },
            {
                code: 'CHO',
                libelle: 'Chômage indemnisé ou non - Chômage partiel'
            },
            {
                code: 'RET',
                libelle: 'Retraite - Préretraite'
            },
            {
                code: 'PENS',
                libelle: "Pension d'invalidité - Rente accident du travail"
            },
            {
                code: 'CONG',
                libelle: 'Congés maternité, parental ou autre congé'
            },
            {
                code: 'AUT',
                libelle: 'Autre situation'
            }
        ];

        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */

        vm.init = function() {
            //console.log('init CnafSitproChoixActiviteController');
            CnafCctAdresseSocleService.getEtatAmabis()
                .get()
                .$promise.then(
                    function successCallback(result) {
                        console.log('amabis OK');
                        vm.autocompletion = 'on';
                    },
                    function errorCallback(error) {
                        console.log('amabis KO');
                        vm.autocompletion = 'off';
                    }
                );

            //console.log(' vm.controle.personneEnCoursCodeAct : ' + vm.controle.personneEnCoursCodeAct);

            // Si la valeur de cumul esrt différente de la sauvegarde faite dans la page "situation",
            // il faut effacer l'activité
            if (vm.data.cumul !== vm.data.sauveCumul) {
                vm.effaceActivite();
                vm.data.sauveCumul = vm.data.cumul;
            }
            // Si clique sur une autre activité suppl (cumulO)
            // alors traitement particulier
            /*  if (vm.data.cumul == 'cumulO')
            {
                  // activité simultanée -
                  // on ne propose pas l'activité en cours

                  switch(vm.controle.personneEnCoursCodeAct){

                      case 'CHO':
                              vm.choixactivites = [{
                                  "code": "SAL",
                                  "libelle": "En activité salariée"
                              }, {
                                  "code": "NSAL",
                                  "libelle": "En activité non salariée"
                              }, {
                                  "code": "ETU",
                                  "libelle": "Etudiant"
                              }, {
                                  "code": "APP",
                                  "libelle": "Stagiaire - Apprenti - En alternance"
                              }, {
                                  "code": "CHO",
                                  "libelle": "Chômage indemnisé ou non"
                              },{
                                  "code": "PENS",
                                  "libelle": "Pension d'invalidité - Rente accident du travail"
                              }, {
                                  "code": "CONG",
                                  "libelle": "Congés maternité, parental ou autre congé"
                              }, {
                                  "code": "AUT",
                                  "libelle": "Autre situation"
                              }];
                              break;

                      default:
                        vm.choixactivites = choixActivitesStandard;
                  }
            }
            // Sinon, pas de boutons (changement de situ ou autre activite suppl)
            // ou choix changement de situation
            // alors on affiche la propsoition standard.
            else {
              vm.choixactivites = choixActivitesStandard;
          }*/
            vm.choixactivites = choixActivitesStandard;
        };

        vm.effaceActivite = function() {
            // Si changement sur le bouton Cumul,
            // on efface l'activité saisie.
            if (vm.data.sitPros && vm.data.sitPros[0].choixActivite) {
                vm.data.sitPros[0].choixActivite = undefined;
            }
        };

        /**
         * Supprime le choix de l'activité salarié
         */
        vm.deleteChoixActiviteSalariee = function() {
            delete vm.data.sitPros[vm.index].choixActiviteSalariee;
            delete vm.data.sitPros[vm.index].choixActiviteNonSalariee;
            delete vm.data.sitPros[vm.index].sitproetu;
            delete vm.data.sitPros[vm.index].choixStagiaire;
            delete vm.data.sitPros[vm.index].orgInscription;
            delete vm.data.sitPros[vm.index].cesseActProRet;
            delete vm.data.sitPros[vm.index].cesseActProPens;
            delete vm.data.sitPros[vm.index].invalRente;
            delete vm.data.sitPros[vm.index].choixCongesDivers;
            delete vm.data.sitPros[vm.index].choixAutreSituation;
            delete vm.data.sitPros[vm.index].autreActivite;
        };
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafSitproChoixActivite
     *
     * @description
     * cnafSitproChoixActivite affiche les champs de saisie pour choisir son type d'activité
     *
     * @restrict E
     *
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     * @param {Object} data data
     * @param {Object} choixactiviteform formulaire
     * @param {Object} errorchoixactivite erreurs
     * @param {boolean} conjoint indique si on traite l'état civil du conjoint
     * @param {boolean} encouple indique si présence d'une sitfam couple
     * @param {string} codepostal code postal
     * @param {Date} datenaissance date de naissance
     * @param {Date} dernJourMoisSuivDemAL dernier jour du mois qui suit le mois de la démarche
     * @param {number} index l'index de la sitPro en cours de saisie
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproChoixActivite', {
        templateUrl: 'components/cnaf-cct-situationpro/cnaf-cct-situationpro-choix-activite/cnaf-cct-situationpro-choix-activite.html',
        bindings: {
            autocompletion: '=',
            data: '=',
            choixactiviteform: '=',
            errorchoixactivite: '=',
            controle: '=',
            index: '=',
            hidetitle: '='
        },
        controllerAs: 'vm',
        controller: CnafSitproChoixActiviteController
    });
})();

(function() {
    'use strict';

    CnafSitproChoixActiviteSalarieeController.$inject = [
        'CnafCctAdresseSocleService',
        '$filter',
        'CnafCctGestionTypeService',
        'CnafCctSituationproControleDateService'
    ];

    function CnafSitproChoixActiviteSalarieeController(
        CnafCctAdresseSocleService,
        $filter,
        CnafCctGestionTypeService,
        CnafCctSituationproControleDateService
    ) {
        var vm = this;
        vm.listeActivitesalariee = [
            { code: 'SAL', libelle: 'Salarié(e)' },
            { code: 'ASSMAT', libelle: 'Assistant(e) maternel(le)' },
            { code: 'GERSAL', libelle: 'Gérant(e) salarié(e)' },
            { code: 'TSA', libelle: 'Travailleur(se) saisonnier(e)' },
            { code: 'INT', libelle: 'Intérimaire' },
            { code: 'SPEC', libelle: 'Intermittent(e) du spectacle' },
            { code: 'VDS', libelle: 'Vendeur(se) à domicile salarié(e)' },
            { code: 'VRP', libelle: 'VRP' },
            { code: 'ESAT', libelle: 'Salarié(e) en ESAT' },
            { code: 'EMMAUS', libelle: 'Compagnon EMMAUS' },
            { code: 'INTER', libelle: "Salarié(e) d'une org. internationale" },
            { code: 'SAS', libelle: "Président(e) d'une SAS" },
            { code: 'ASSFAM', libelle: "Assistant(e) familial(e)"} 
        ];

        /* ------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
            // Ne sert pas car présent dans Choix Activité
            /*            //AMABIS
            CnafCctAdresseSocleService.getEtatAmabis().get()
                .$promise.then(
                function successCallback(result) {
                    vm.autocompletion = "on";
                },
                function errorCallback(error) {
                    vm.autocompletion = "off";
                });*/
          
            vm.controleInfDateNaissance = CnafCctSituationproControleDateService.controleInfDateNaissance;
            vm.controleSupDernJourMoisSuivDem = CnafCctSituationproControleDateService.controleSupDernJourMoisSuivDem;
            //INC0723285 : Contexte arrivée de conjoint - Ajout controle entre date début sitpro qui doit être < date Sitfam couple
            vm.controleDateSitProSitfamCouple = CnafCctSituationproControleDateService.controleDateSitProSitfamCouple;

            vm.httpRechListePaysEmployeur();
        };

        //Recherche liste pays
        vm.httpRechListePaysEmployeur = function() {
            CnafCctAdresseSocleService.rechListePays()
                .get()
                .$promise.then(
                    function successCallback(response0) {
                        vm.listePaysEmployeur = response0.listePays;
                    },
                    function errorCallback(error) {
                        vm.etat = 'error';
                    }
                );
        };

        //AUTO-COMPLETION
        //Pays :
        vm.getListePaysEmployeurProposes = function(prefix) {
            return vm.listePaysEmployeur;
        };

        vm.afficheEmployeur = function(index) {
            if (vm.data.sitPros[index] && vm.data.sitPros[index].choixActiviteSalariee) {
                if (
                    vm.data.sitPros[index].choixActiviteSalariee.code == 'SAL' ||
                    vm.data.sitPros[index].choixActiviteSalariee.code == 'INT' ||
                    vm.data.sitPros[index].choixActiviteSalariee.code == 'VDS' ||
                    vm.data.sitPros[index].choixActiviteSalariee.code == 'VRP' ||
                    vm.data.sitPros[index].choixActiviteSalariee.code == 'SAS' ||
                    vm.data.sitPros[index].choixActiviteSalariee.code == 'INTER' ||
                    vm.data.sitPros[index].choixActiviteSalariee.code == 'EMMAUS' ||
                    vm.data.sitPros[index].choixActiviteSalariee.code == 'GERSAL' ||
                    vm.data.sitPros[index].choixActiviteSalariee.code == 'ESAT'
                ) {
                    return true;
                } else {
                    return false;
                }
            }
        };

        vm.afficheCodePostalVille = function(index) {
            if (vm.data.sitPros[index] && vm.data.sitPros[index].paysEmployeur && vm.data.sitPros[index].choixActiviteSalariee.code !== 'ESAT') {
                if (vm.data.sitPros[index].paysEmployeur.code == 'FR') {
                    //  || vm.data.sitPros[index].paysEmployeur.libelleCaffr == 'PRINCIPAUTE DE MONACO'
                    return true;
                } else {
                    return false;
                }
            } else {
                if (vm.data.sitPros[index].choixActiviteSalariee.code == 'ESAT') {
                    return true;
                } else {
                    return false;
                }
            }
        };

        vm.codePostalVilles = function(prefix) {
            return CnafCctAdresseSocleService.localitesSansLD(prefix, CnafCctAdresseSocleService.transformCodePays(vm.data.codePostalVille))
                .get()
                .$promise.then(function(result) {
                    return $filter('limitTo')(result.listRechLoc, 10);
                });
        };

        vm.testType5 = function(donnee, form, index) {
            if (donnee === undefined || donnee.length === 0) {
                form.$setValidity('type5', true);
            } else {
                var retourControles = CnafCctGestionTypeService.appelControleType5(donnee, form);
                if (retourControles !== null) {
                    vm.data.sitPros[index].villeEmployeur = retourControles;
                    return true;
                }
            }
        };

        vm.testType8 = function(donnee, form, nomDonnee) {
            if (donnee === undefined || donnee.length === 0) {
                form.$setValidity('type8', true);
            } else {
                var retourControles = CnafCctGestionTypeService.appelControleType8(donnee, form);
                if (retourControles !== null) {
                    vm.data[nomDonnee] = retourControles;
                }
            }
        };

        vm.afficheRegimeCotisation = function(index) {
            return (vm.data.sitPros[index] && vm.data.sitPros[index].choixActiviteSalariee) 
                     && (
                        vm.data.sitPros[index].choixActiviteSalariee.code !== 'TSA' &&
                        vm.data.sitPros[index].choixActiviteSalariee.code !== 'ASSMAT' &&
                        vm.data.sitPros[index].choixActiviteSalariee.code !== 'SPEC' &&
                        vm.data.sitPros[index].choixActiviteSalariee.code !== 'INTER' &&
                        vm.data.sitPros[index].choixActiviteSalariee.code !== 'ESAT' &&
                        vm.data.sitPros[index].choixActiviteSalariee.code !== 'EMMAUS'
                    );
        };
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafSitproChoixActiviteSalariee
     *
     * @description
     * cnafSitproChoixActiviteSalariee affiche les champs de saisie pour choisir son activité de type "salarié"
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} situationprosalarieeform formulaire
     * @param {Object} errorchoixactivitesalariee erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     * @param {string} controle
     * @param {string} index positionné à 0 sera utilisé si plusieurs sitpro
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproChoixActiviteSalariee', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-choix-activite-salariee/cnaf-cct-situationpro-choix-activite-salariee.html',
        bindings: {
            data: '=',
            situationprosalarieeform: '=',
            errorchoixactivitesalariee: '=',
            autocompletion: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafSitproChoixActiviteSalarieeController
    });
})();

(function() {
    'use strict';

    CnafSitproChoixActiviteSimultaneeController.$inject = ['CnafCctSituationproService'];

    function CnafSitproChoixActiviteSimultaneeController(CnafSitproService) {
        var vm = this;

        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */

        vm.init = function() {
            console.log('init CnafSitproChoixActiviteSimultaneeController');
            console.log(' vm.controle.personneEnCoursCodeAct : ' + vm.controle.personneEnCoursCodeAct);
            console.log(' vm.data.cumul : ' + vm.data.cumul);
            if (CnafSitproService.activiteSalariee(vm.controle.personneEnCoursCodeAct)) {
                vm.choixactivitessimultanee = [
                    {
                        code: 'SAL',
                        libelle: 'Activité salariée'
                    },
                    {
                        code: 'NSAL',
                        libelle: 'Activité non salariée'
                    }
                ];
            } else if (CnafSitproService.professionNonSalariee(vm.controle.personneEnCoursCodeAct)) {
                vm.choixactivitessimultanee = [
                    {
                        code: 'NSAL',
                        libelle: 'Activité non salariée'
                    },
                    {
                        code: 'SAL',
                        libelle: 'Activité salariée'
                    }
                ];
            }
            if (vm.controle.encouple){
               
                vm.controle.libellePersonneSimultanee = "L'activité à laquelle " + vm.controle.libPersonneEnCours +" consacre le plus de temps";
            } else {
                
                vm.controle.libellePersonneSimultanee = "L'activité à laquelle vous consacrez le plus de temps";
            }
        };
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafSitproChoixActivite
     *
     * @description
     * cnafSitproChoixActivite affiche les champs de saisie pour choisir son type d'activité
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} choixactivitesimultaneeform formulaire
     * @param {Object} errorchoixactivitesimultanee erreurs
     * @param {number} index l'index de la sitPro en cours de saisie
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproChoixActiviteSimultanee', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-choix-activite-simultanee/cnaf-cct-situationpro-choix-activite-simultanee.html',
        bindings: {
            data: '=',
            choixactivitesimultaneeform: '=',
            errorchoixactivitesimultanee: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafSitproChoixActiviteSimultaneeController
    });
})();

(function() {
    'use strict';

    CnafSitproChoixActiviteStagiaireController.$inject = ['CnafCctGestionTypeService', '$uibModal', '$scope', 'CnafCctSituationproControleDateService'];

    function CnafSitproChoixActiviteStagiaireController(CnafCctGestionTypeService, $uibModal, $scope, CnafCctSituationproControleDateService) {
        var vm = this;

        vm.listeRegimeIndemnisation = [
            { code: 'PE', libelle: 'France Travail' },
            { code: 'FP', libelle: 'Fonction publique' },
            { code: 'AO', libelle: 'Employeur ou autre' }
        ];

        /* ------------------------------------------------------------------------------------------------------------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
            vm.controleInfDateNaissance = CnafCctSituationproControleDateService.controleInfDateNaissance;
            vm.controleSupDernJourMoisSuivDem = CnafCctSituationproControleDateService.controleSupDernJourMoisSuivDem;
            //INC0723285 : Contexte arrivée de conjoint - Ajout controle entre date début sitpro qui doit être < date Sitfam couple
            vm.controleDateSitProSitfamCouple = CnafCctSituationproControleDateService.controleDateSitProSitfamCouple;

            vm.listeChoixStagiaire = [
                { code: 'STAGE', libelle: 'Stagiaire' },
                { code: 'APP', libelle: 'Apprenti(e)' },
                { code: 'CONTRAT', libelle: 'En contrat de professionnalisation - En alternance' }
            ];
        };

        vm.controleSupDateDeb = function(dateFin, dateDebut) {
            var valueControle = true;
            if (dateDebut && dateDebut.length >= 10 && dateFin && dateFin.length >= 10) {
                var dateDebATester = Date.parseExact(dateDebut, 'd/M/yyyy');
                var dateFinATester = Date.parseExact(dateFin, 'd/M/yyyy');
                if (dateFinATester && 'Invalid Date' != dateFinATester && dateDebATester && 'Invalid Date' != dateDebATester) {
                    if (dateFinATester < dateDebATester) {
                        valueControle = false;
                    }
                }
            }
            return valueControle;
        };

        vm.testType8 = function(donnee, form, nomDonnee) {
            if (donnee === undefined || donnee.length === 0) {
                form.$setValidity('type8', true);
            } else {
                var retourControles = CnafCctGestionTypeService.appelControleType8(donnee, form);
                if (retourControles !== null) {
                    vm.data[nomDonnee] = retourControles;
                }
            }
        };

        /* ------------------------------ */
        /*   Boite de dialogue Abandon    */
        /* ------------------------------ */
        /**
         * Appel depuis controler parent
         */
        $scope.$on('callOpenStagiaireModal', function(e) {
            vm.openStagiaire();
        });

        vm.openStagiaire = function() {
            $(':focus').blur();

            //Instanciation et ouverture de la modale
            var modalStagiaire = $uibModal.open({
                component: 'cnafModalStagiaire',
                backdrop: 'static',
                keyboard: false

            });

            //Fonction appelée lors de la fermeture de la modal
            modalStagiaire.result.then(
                function() {
                    $(':focus').blur();
                },
                function() {
                    // Cancel
                }
            );
        };

    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafSitproChoixActiviteStagiaire
     *
     * @description
     * cnafSitproChoixActiviteStagiaire affiche les champs de saisie
     * pour activité Stagiaire, apprenti, en contrat de professionalisation
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} situationprostagiaireform formulaire
     * @param {Object} errorchoixactivitestagiaire erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     * @param {boolean} conjoint indique si on traite l'état civil du conjoint
     * @param {boolean} encouple indique si présence d'une sitfam couple
     * @param {Date} datenaissance date de naissance
     * @param {Date} dernJourMoisSuivDemAL dernier jour du mois qui suit le mois de la démarche
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproChoixActiviteStagiaire', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-choix-activite-stagiaire/cnaf-cct-situationpro-choix-activite-stagiaire.html',
        bindings: {
            data: '=',
            situationprostagiaireform: '=',
            errorchoixactivitestagiaire: '=',
            autocompletion: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafSitproChoixActiviteStagiaireController
    });
})();

(function() {
    'use strict';

    CnafSitproChomageController.$inject = ['CnafCctGestionTypeService',
                                            'CnafCctDateService',
                                            'CnafCctSituationproControleDateService'];

    function CnafSitproChomageController (CnafSitpronafCctGestionTypeService,
                                            CnafCctDateService,
                                            CnafCctSituationproControleDateService) {
        var vm = this;

        vm.listeOrgInscription = [{ code: 'PE', libelle: 'France Travail' }, { code: 'AO', libelle: 'Autre organisme' }];

        /* ------------------------------------------------------------------------------------------------------------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
            
            if (vm.controle.encouple){
                vm.controle.libellePersonneChomage = vm.controle.libPersonneEnCours + "  est inscrit(e) auprès de";
            } else {
                vm.controle.libellePersonneChomage = "Vous êtes inscrit(e) auprès de";
            }

            vm.controleInfDateNaissance = CnafCctSituationproControleDateService.controleInfDateNaissance;
            vm.controleSupDernJourMoisSuivDem = CnafCctSituationproControleDateService.controleSupDernJourMoisSuivDem;
            //INC0723285 : Contexte arrivée de conjoint - Ajout controle entre date début sitpro qui doit être < date Sitfam couple
            vm.controleDateSitProSitfamCouple = CnafCctSituationproControleDateService.controleDateSitProSitfamCouple;
            if(vm.data.sitPros[vm.index].heuresCPL) vm.heuresCPL = vm.data.sitPros[vm.index].heuresCPL.slice().reverse();

        };
        vm.initHeuresCPL = function(){
            var monthNames = [
                'janvier',
                'février',
                'mars',
                'avril',
                'mai',
                'juin',
                'juillet',
                'août',
                'septembre',
                'octobre',
                'novembre',
                'décembre'
            ];
            vm.heuresCPL = [];
            vm.data.sitPros[vm.index].heuresCPL = [];
            var datecho = vm.data.sitPros[vm.index].dateActiviteChomage;
            if( datecho && datecho !== 'jj/mm/aaaa' && vm.data.sitPros[vm.index].chomagePartiel){
                
                datecho = CnafCctDateService.parseDate(datecho);
                var dateenv = CnafCctDateService.getDateToday();

                //Calcul de M : différence des mois entre datecho et dateenv

                var year1=datecho.getFullYear();
                var year2=dateenv.getFullYear();
                var month1=datecho.getMonth();
                var month2=dateenv.getMonth();
                var M = (year2 - year1) * 12 + (month2 - month1);

                var result = [];
                if(M > 1){
                    for (var i = 0; i < M && i < 4; i++) {
                        var monthname = dateenv.getMonth()-1-i >= 0 ? (dateenv.getMonth()-1-i) : 12 + (dateenv.getMonth()-1-i);
                        result.push( { mois: monthNames[monthname], heures: '' } )
                    }
                    vm.heuresCPL = result.slice().reverse();
                    vm.data.sitPros[vm.index].heuresCPL = result;
                }

            }
        };

        vm.blurHeuresCPL = function(i){
            var M = vm.heuresCPL.length-1;

            var tmp = vm.heuresCPL[i].heures.trim();
            tmp = (tmp.length>1 && tmp[0]==='0') ? tmp.slice(1) : tmp; //  '0XY' -> 'XY'
            tmp = (tmp.length>1 && tmp[0]==='0') ? tmp.slice(1) : tmp; //  '0Y' -> 'Y'

            vm.data.sitPros[vm.index].heuresCPL[M-i].heures = tmp;
        };


        vm.askForMoisEnCoursCPL = function(){
            if(vm.data.sitPros[vm.index].heuresCPL.length==2){
                var heuresMmoins1 = vm.data.sitPros[vm.index].heuresCPL[0].heures;
                var heuresMmoins2 = vm.data.sitPros[vm.index].heuresCPL[1].heures;
                if(heuresMmoins1 && heuresMmoins2){
                    heuresMmoins1 = parseInt(heuresMmoins1);
                    heuresMmoins2 = parseInt(heuresMmoins2);
                    return (heuresMmoins1 > 0) && (heuresMmoins2 > 0) && (heuresMmoins1 + heuresMmoins2 >= 40);
                }
            }
            return (vm.data.sitPros[vm.index].heuresCPL.length>2);
        }

        vm.testType8 = function(donnee, form, nomDonnee) {
            //console.log("vm.testType8 avec form = "+form);
            //console.log("vm.testType8 avec donnee = "+donnee);
            if (donnee === undefined || donnee.length === 0) {
                form.$setValidity('type8', true);
            } else {
                var retourControles = CnafCctGestionTypeService.appelControleType8(donnee, form);
                //console.log("vm.testType8 avec retourControles = "+retourControles);
                if (retourControles !== null) {
                    vm.data[nomDonnee] = retourControles;
                }
            }
        };
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafSitpro * @description
     * cnafSitpro champs de saisie pour activité chomage
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} ire
     * @param {Object} error  * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     * @param {boolean} conjoint indique si on traite l'état civil du conjoint
     * @param {boolean} encouple indique si présence d'une sitfam couple
     * @param {Date} datenaissance date de naissance
     * @param {Date} dernJourMoisSuivDemAL dernier jour du mois qui suit le mois de la démarche
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproChomage',{
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-chomage/cnaf-cct-situationpro-chomage.html',
        bindings: {
            data: '=',
            chomageform: '=',
            errorchomage: '=',       
            autocompletion: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafSitproChomageController   });
})();

(function() {
    'use strict';

    CnafSitproCongesDiversController.$inject = ['CnafCctGestionTypeService', 
                                                             'CnafCctSituationproControleDateService'];

    function CnafSitproCongesDiversController(CnafCctGestionTypeService, 
                                                           CnafCctSituationproControleDateService) {
        var vm = this;
   
        /* ------------------------------------------------------------------------------------------------------------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
            vm.controleInfDateNaissance = CnafCctSituationproControleDateService.controleInfDateNaissance;
            vm.controleSupDernJourMoisSuivDem = CnafCctSituationproControleDateService.controleSupDernJourMoisSuivDem;
            //INC0723285 : Contexte arrivée de conjoint - Ajout controle entre date début sitpro qui doit être < date Sitfam couple
            vm.controleDateSitProSitfamCouple = CnafCctSituationproControleDateService.controleDateSitProSitfamCouple;

            var now = new Date();
            vm.datePickerEndYear = (new Date(now.setFullYear(now.getFullYear() + 2))).getFullYear();
            console.log("vm.controle.typePersonneEnCours : "+vm.controle.typePersonneEnCours);
            if (vm.controle.typePersonneEnCours === 'MME') {
                vm.listeChoixCongesDivers = [
                    { code: 'MAT', libelle: 'Congé maternité' },
                    { code: 'DIVERS', libelle: 'Congé conventionnel' },
                    { code: 'PARENT', libelle: 'Congé parental ou d’adoption' },
                    { code: 'SSOLDE', libelle: 'Congé sans solde' },
                    { code: 'SAB', libelle: 'Congé sabbatique' }
                ];
            } else {
                vm.listeChoixCongesDivers = [
                    { code: 'DIVERS', libelle: 'Congé conventionnel' },
                    { code: 'PARENT', libelle: 'Congé parental ou d’adoption' },
                    { code: 'SSOLDE', libelle: 'Congé sans solde' },
                    { code: 'SAB', libelle: 'Congé sabbatique' }
                ];
            }
       
       
        };

        vm.controleSupDateDeb = function(dateFin, dateDebut) {
            var valueControle = true;
            if (dateDebut && dateDebut.length >= 10 && dateFin && dateFin.length >= 10) {
                var dateDebATester = Date.parseExact(dateDebut, 'd/M/yyyy');
                var dateFinATester = Date.parseExact(dateFin, 'd/M/yyyy');
                if (dateFinATester && 'Invalid Date' != dateFinATester && dateDebATester && 'Invalid Date' != dateDebATester) {
                    if (dateFinATester < dateDebATester) {
                        valueControle = false;
                    }
                }
            }
            return valueControle;
        };

        vm.testType8 = function(donnee, form, nomDonnee) {
            if (donnee === undefined || donnee.length === 0) {
                form.$setValidity('type8', true);
            } else {
                var retourControles = CnafCctGestionTypeService.appelControleType8(donnee, form);
                if (retourControles !== null) {
                    vm.data[nomDonnee] = retourControles;
                }
            }
        };
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafSitproCongesdivers
     *
     * @description
     * cnafSitproCongesdivers affiche les champs de saisie pour activité conges divers
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} Congesdiversform formulaire
     * @param {Object} errorCongesdivers erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproCongesDivers', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-conges-divers/cnaf-cct-situationpro-conges-divers.html',
        bindings: {
            data: '=',
            congesdiversform: '=',
            errorcongesdivers: '=',
            autocompletion: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafSitproCongesDiversController
    });
})();

(function() {
    'use strict';

    CnafSitproCotisEmployeurController.$inject = ['CnafCctAdresseSocleService', '$filter', 'CnafSaveSaisieService', 'CnafCctConstantMsgTypes','CnafUserService','$scope','CnafCctSituationproService'];

    function CnafSitproCotisEmployeurController(CnafCctAdresseSocleService, $filter, CnafSaveSaisieService, CnafCctConstantMsgTypes, CnafUserService,$scope,CnafCctSituationproService) {
        var vm = this;

        vm.listeChoixAutRegSal = [
            { code: 'MO', libelle: 'Membre d’une organisation internationale' },
            { code: 'FO', libelle: 'Fonctionnaire' },
            { code: 'AL', libelle: 'Membre du Parlement (Assemblée nationale ou Sénat)' },
            { code: 'AU', libelle: 'Autre' }
        ];

        /* ------------------------------------------------------------------------------------------------------------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {

            if (vm.activiteSAL(vm.index)){
                $scope.$watch(function(scope){return vm.data.sitPros[vm.index].choixActiviteSalariee;},function(){vm.initAffichage();});
            } else if (vm.activiteNSAL(vm.index)){
                $scope.$watch(function(scope){return vm.data.sitPros[vm.index].choixActiviteNonSalariee;},function(){vm.initAffichage();});
            } else if (vm.activiteCONG(vm.index)){
                $scope.$watch(function(scope){return vm.data.sitPros[vm.index].choixCongesDivers;},function(){vm.initAffichage();});
            } else if (vm.activiteAPP(vm.index)){
                $scope.$watch(function(scope){return vm.data.sitPros[vm.index].choixStagiaire;},function(){vm.initAffichage();});
            } else {
                vm.initAffichage();
            }
    
           
        };

        vm.initAffichage = function() {
            var isAffichage = false;
            vm.controle.libCotisEmployeur = "";            
            //Constitution de la liste de régimes de cotisation avec les bons codes associés selon Métro/Dom
            //--------------------------------------------------------------------------------------------------------
            vm.listeRegimeCotisation = [];
            console.log("cotisEmployeur initAffichage - vm.controle.codepostal : "+vm.controle.codepostal);
            // Apprenti 
            // ou retraite/invalidité avec cessation activité ou anciennement sal ou non sal
            // ou Congés (ne concerne que la maternité)
            if ( (( vm.activiteAPP(vm.index) && vm.data.sitPros[vm.index].choixStagiaire 
                    && (vm.data.sitPros[vm.index].choixStagiaire.code == 'APP' || vm.data.sitPros[vm.index].choixStagiaire.code == 'CONTRAT'))
                 
                    || ((vm.data.sitPros[vm.index].choixActivite == 'RET' &&
                        (vm.data.sitPros[vm.index].cesseActProRet === 'Oui' || !vm.controle.isSalOuNonSal)) ||
                     (vm.data.sitPros[vm.index].choixActivite === 'PENS' &&
                        (vm.data.sitPros[vm.index].cesseActProPens === 'Oui' || !vm.controle.isSalOuNonSal)))
                        
                    || (vm.activiteCONG(vm.index) && vm.data.sitPros[vm.index].choixCongesDivers
                        && vm.data.sitPros[vm.index].choixCongesDivers.code === 'MAT') )
            ) {
                if (CnafCctSituationproService.isMetropole(vm.controle.codepostal)){
                    // Régime général
                    vm.listeRegimeCotisation.push({ code: 'GE', libelle: 'Régime général' });
                    // MSA
                    vm.listeRegimeCotisation.push({ code: 'AG', libelle: 'MSA' });  
               
                } else if (CnafCctSituationproService.isMayotte(vm.controle.codepostal)|| vm.controle.grpAllocatairesMayotte){
                     //RFC0018874 : Mayotte - sitpro régime cotisation CSSM
                     //CSSM
                    vm.listeRegimeCotisation.push({ code: 'CS', libelle: 'CSSM' });    
                } else {
                    //CGSS
                    vm.listeRegimeCotisation.push({ code: 'CG', libelle: 'CGSS' });
                }
                // Autre régime
                vm.listeRegimeCotisation.push({ code: 'AR', libelle: 'Autre régime' });  
                isAffichage = true;
                /*if ( vm.activiteAPP(vm.index) && vm.data.sitPros[vm.index].choixStagiaire 
                    && (vm.data.sitPros[vm.index].choixStagiaire.code == 'APP' || vm.data.sitPros[vm.index].choixStagiaire.code == 'CONTRAT'))
                {
                    console.log("initAffichage - isAffichage = true activité stagiaire : "+vm.data.sitPros[vm.index].choixStagiaire.code);
                } else if  ((vm.data.sitPros[vm.index].choixActivite == 'RET' &&
                                (vm.data.sitPros[vm.index].cesseActProRet === 'Oui' || !vm.controle.isSalOuNonSal)) ||
                            (vm.data.sitPros[vm.index].choixActivite === 'PENS' &&
                                (vm.data.sitPros[vm.index].cesseActProPens === 'Oui' || !vm.controle.isSalOuNonSal))){
                    console.log("initAffichage - isAffichage = true activité ret ou pens: "+vm.data.sitPros[vm.index].choixActivite);
                } else if (vm.activiteCONG(vm.index) && vm.data.sitPros[vm.index].choixCongesDivers
                            && vm.data.sitPros[vm.index].choixCongesDivers.code === 'MAT')  {
                    console.log("initAffichage - isAffichage = true activité congés : "+vm.data.sitPros[vm.index].choixCongesDivers.code);
                }  */         
            } else if (vm.activiteSAL(vm.index) && vm.data.sitPros[vm.index].choixActiviteSalariee 
                        && vm.data.sitPros[vm.index].choixActiviteSalariee.code !== 'TSA' 
                        && vm.data.sitPros[vm.index].choixActiviteSalariee.code !== 'ASSMAT' 
                        && vm.data.sitPros[vm.index].choixActiviteSalariee.code !== 'SPEC' 
                        && vm.data.sitPros[vm.index].choixActiviteSalariee.code !== 'INTER' 
                        && vm.data.sitPros[vm.index].choixActiviteSalariee.code !== 'ESAT' 
                        && vm.data.sitPros[vm.index].choixActiviteSalariee.code !== 'EMMAUS'
                        && vm.data.sitPros[vm.index].choixActiviteSalariee.code !== 'ASSFAM')
           {
                // concerne les salariés de type 
                // 'SAL' : 'Salarié'
                // 'GERSAL' : 'Gérant(e) salarié(e)'
                // 'INT' : 'Intérimaire',
                // 'VDS' : 'Vendeur(se) à domicile salarié'
                // 'VRP' : 'VRP',
                // 'SAS' : Président d'une SAS

                if (CnafCctSituationproService.isMetropole(vm.controle.codepostal)){
                    // URSSAF
                    vm.listeRegimeCotisation.push({ code: 'UR', libelle: 'Urssaf' });
                    // MSA
                    vm.listeRegimeCotisation.push({ code: 'AG', libelle: 'MSA' });  
                } else if (CnafCctSituationproService.isMayotte(vm.controle.codepostal)|| vm.controle.grpAllocatairesMayotte){
                    //RFC0018874 : Mayotte - sitpro régime cotisation CSSM
                    //CSSM
                   vm.listeRegimeCotisation.push({ code: 'CS', libelle: 'CSSM' });     
                } else {
                    //CGSS
                    vm.listeRegimeCotisation.push({ code: 'CG', libelle: 'CGSS' });
                }
               
                // Régime étranger
                vm.listeRegimeCotisation.push({ code: 'RE', libelle: 'Régime étranger' }); 
                // Autre régime
                vm.listeRegimeCotisation.push({ code: 'AR', libelle: 'Autre régime' });  
                isAffichage = true;
                //console.log("initAffichage - isAffichage = true activité salariée : "+vm.data.sitPros[vm.index].choixActiviteSalariee.code);
                    
            } else if (vm.activiteNSAL(vm.index) && vm.data.sitPros[vm.index].choixActiviteNonSalariee 
                        && vm.data.sitPros[vm.index].choixActiviteNonSalariee.code !== 'INDEP' 
                        && vm.data.sitPros[vm.index].choixActiviteNonSalariee.code !== 'COTIS')
            {
                // Non salariés de type
                // 'AUTOEN' : 'Micro-entrepreneur(se) (ex Auto-entrepreneur)'
                // 'VDINS' :  'VDI - Vendeur(se) à domicile'
                // 'MAR' :  'Marin pêcheur'
                // 'EXP' : 'Exploitant(e) agricole'
                // 'ARTIST' : 'Artiste auteur'
                // 'CONJOIN' : 'Conjoint(e) collaborateur'
                // 'AFA' : 'Aide familiale agricole'
                if (CnafCctSituationproService.isMetropole(vm.controle.codepostal)){
                    // métropole
                    if (vm.data.sitPros[vm.index].choixActiviteNonSalariee.code !== 'AFA' 
                            && vm.data.sitPros[vm.index].choixActiviteNonSalariee.code !== 'EXP'
                            && vm.data.sitPros[vm.index].choixActiviteNonSalariee.code !== 'MAR'){
                        // SSI
                        vm.listeRegimeCotisation.push({code: 'UI', libelle: 'SSI'});
                    } 
                    if (vm.data.sitPros[vm.index].choixActiviteNonSalariee.code !== 'ARTIST'
                            && vm.data.sitPros[vm.index].choixActiviteNonSalariee.code !== 'VDINS'
                            && vm.data.sitPros[vm.index].choixActiviteNonSalariee.code !== 'MAR'){
                        // MSA
                        vm.listeRegimeCotisation.push({ code: 'AG', libelle: 'MSA' });            
                    }
                } else if (CnafCctSituationproService.isMayotte(vm.controle.codepostal)|| vm.controle.grpAllocatairesMayotte){
                    //RFC0018874 : Mayotte - sitpro régime cotisation CSSM
                    //CSSM
                   vm.listeRegimeCotisation.push({ code: 'CS', libelle: 'CSSM' });        
                } else {
                    //CGSS
                    vm.listeRegimeCotisation.push({ code: 'CG', libelle: 'CGSS' });
                }   
                if (vm.data.sitPros[vm.index].choixActiviteNonSalariee.code === 'MAR'){
                    // ENIM
                    vm.listeRegimeCotisation.push({ code: 'TM', libelle: 'ENIM' });
                    // Régime étranger
                    vm.listeRegimeCotisation.push({ code: 'RE', libelle: 'Régime étranger' }); 
                }
                if (vm.data.sitPros[vm.index].choixActiviteNonSalariee.code === 'ARTIST'){
                    // Maison des artistes / AGESSA
                    vm.listeRegimeCotisation.push({ code: 'AA', libelle: 'Maison des artistes / AGESSA' }); 
                }
                if (vm.data.sitPros[vm.index].choixActiviteNonSalariee.code !== 'ARTIST'
                        && vm.data.sitPros[vm.index].choixActiviteNonSalariee.code !== 'CONJOIN'){
                    // Autre régime
                    vm.listeRegimeCotisation.push({ code: 'AR', libelle: 'Autre régime' });         
                }
                isAffichage = true;
                //console.log("initAffichage - isAffichage = true activité non salariée : "+vm.data.sitPros[vm.index].choixActiviteNonSalariee.code);
            } 
           
            if (isAffichage){
                //console.log("initAffichage - je détermine les libellés");
                // determination des libelles
                //--------------------------
                if (vm.gerantSalarie(vm.index)){
                    // gérant salarié
                    if (vm.controle.encouple){
                        vm.controle.libCotisEmployeur = vm.controle.libPersonneEnCours + " cotise à"; 
                    } else {
                        vm.controle.libCotisEmployeur ="Vous cotisez à"; 
                    }
                } else if ((vm.data.sitPros[vm.index].choixActivite === 'RET' &&
                            (vm.data.sitPros[vm.index].cesseActProRet === 'Oui' || !vm.controle.isSalOuNonSal)) ||
                            (vm.data.sitPros[vm.index].choixActivite === 'PENS' &&
                            (vm.data.sitPros[vm.index].cesseActProPens === 'Oui' || !vm.controle.isSalOuNonSal)))
                {
                    // retraite et invalidité avec cessation activité ou anciennement sal ou non sal
                    vm.controle.libCotisEmployeur ="L'organisme qui verse la pension/rente la plus élevée est"; 
                } else if (vm.activiteCONG(vm.index)){
                    // congés
                    if (vm.data.sitPros[vm.index].choixCongesDivers.code === 'MAT'){
                        vm.controle.libCotisEmployeur ="L'organisme qui verse les indemnités est"; 
                    } 
                } else if (vm.activiteNSAL(vm.index)){
                    // non salariés
                    vm.controle.libCotisEmployeur = "Vous êtes affilié(e) à"; 
                } else {
                    // autres cas
                    vm.controle.libCotisEmployeur ="L'employeur cotise à"; 
                }  
                
                // libellé autre régime et détaché france
                if (vm.controle.encouple){
                    vm.controle.libAutreRegime = vm.controle.libPersonneEnCours + " est"; 
                    vm.controle.libDetache = vm.controle.libPersonneEnCours + " est détaché(e) en France"; 
                } else {
                    vm.controle.libAutreRegime ="Vous êtes"; 
                    vm.controle.libDetache = "Vous êtes détaché(e) en France";
                }
                
                vm.httpRechListePaysCotisation();

                //Si activité SAL : 
                //Constitution de la liste de postes pour les fonctionnaires avec les bons codes associés selon Métro/Dom
                //--------------------------------------------------------------------------------------------------------
                if (vm.activiteSAL(vm.index)) {
                    if (CnafCctSituationproService.isMetropole(vm.controle.codepostal)){
                        vm.listeChoixPosteFonct = [
                            { code: 'GE', libelle: 'En France' }, 
                            { code: 'AE', libelle: "A l'étranger" }];
                    } else {
                        vm.listeChoixPosteFonct = [
                            { code: 'FP', libelle: 'En France' }, 
                            { code: 'AE', libelle: "A l'étranger" }];
                    }
                }

            }
            return isAffichage;
           
        };

        vm.affichePopupGe = function(index) {
            return ( 
                    vm.activiteAPP(index) 
                    || ((vm.data.sitPros[index].choixActivite == 'RET'
                        && (vm.data.sitPros[index].cesseActProRet === 'Oui' || !vm.controle.isSalOuNonSal)) 
                    || (vm.data.sitPros[index].choixActivite === 'PENS' 
                        && (vm.data.sitPros[index].cesseActProPens === 'Oui' || !vm.controle.isSalOuNonSal)))
                    ||  vm.activiteCONG(index)
            );
        };

        vm.affichePopupSsi = function(index) {
            return ( 
                    vm.activiteNSAL(index)
                        && CnafCctSituationproService.isMetropole(vm.controle.codepostal)
                        && vm.data.sitPros[index].choixActiviteNonSalariee.code !== 'AFA' 
                        && vm.data.sitPros[index].choixActiviteNonSalariee.code !== 'EXP'
                        && vm.data.sitPros[index].choixActiviteNonSalariee.code !== 'MAR' 
            );
        };

        vm.affichePopupMsa = function(index) {
            return ( 
                    vm.activiteAPP(index) || vm.activiteCONG(index)
                    || vm.activiteETU(index) || vm.controle.etudiant || vm.activiteSAL(index)
                    || ((vm.data.sitPros[vm.index].choixActivite == 'RET' &&
                   (vm.data.sitPros[index].cesseActProRet === 'Oui' || !vm.controle.isSalOuNonSal)) ||
                    (vm.data.sitPros[index].choixActivite === 'PENS' &&
                   (vm.data.sitPros[index].cesseActProPens === 'Oui' || !vm.controle.isSalOuNonSal)))
                    || ( vm.activiteNSAL(index)
                            && CnafCctSituationproService.isMetropole(vm.controle.codepostal) 
                            && vm.data.sitPros[index].choixActiviteNonSalariee.code !== 'ARTIST'
                            && vm.data.sitPros[index].choixActiviteNonSalariee.code !== 'VDINS'
                            && vm.data.sitPros[index].choixActiviteNonSalariee.code !== 'MAR' )
            );
        };

        // affiche l'information liée à l'activité exp avec régime MSA pour les dossiers ayant de la ppa
        vm.afficheInfoMSA = function(index) {
            return (vm.controle.droitPPAEnCours 
                        && CnafCctSituationproService.isMetropole(vm.controle.codepostal)
                        && vm.data.sitPros[index] 
                        && vm.data.sitPros[index].choixActiviteNonSalariee 
                        && vm.data.sitPros[index].choixActiviteNonSalariee.code === 'EXP' 
                        && vm.data.sitPros[index].cotisEmployeur 
                        && vm.data.sitPros[index].cotisEmployeur.code == 'AG' 
            );
        };

        //Recherche liste pays
        vm.httpRechListePaysCotisation = function() {
            CnafCctAdresseSocleService.rechListePays()
                .get()
                .$promise.then(
                    function successCallback(response0) {
                        vm.listePaysCotisation = response0.listePays;
                    },
                    function errorCallback(error) {
                        vm.etat = 'error';
                    }
                );
        };

        //AUTO-COMPLETION
        //Pays :
        vm.getListePaysCotisationProposes = function(prefix) {
            var listPaysCotisation = [];

            // On retire la France et Monaco de la liste
            // car il s'agit d'afficher un pays pour une cotisation à l'étranger :
            for (var i = 0; i < vm.listePaysCotisation.length; i++) {
                if (vm.listePaysCotisation[i].code !== 'FR' && vm.listePaysCotisation[i].code !== 'MC') {
                    listPaysCotisation[i] = vm.listePaysCotisation[i];
                }
            }

            return listPaysCotisation;
        };

        vm.afficheAutreRegime = function(index) {
            return (vm.data.sitPros[index] 
                        && vm.data.sitPros[index].cotisEmployeur 
                        && vm.data.sitPros[index].cotisEmployeur.code === 'AR' 
                        && vm.activiteSAL(index) == true
                        && vm.data.sitPros[index].choixActiviteSalariee.code === 'SAL'
            );            
        };

        vm.afficheNomOrganisme = function(index) {
            return ( vm.data.sitPros[index] 
                        && vm.data.sitPros[index].cotisEmployeur
                        && vm.data.sitPros[index].cotisEmployeur.code === 'AR'
                        && ( (vm.activiteSAL(index) == false || (vm.activiteSAL(index) == true
                         && vm.data.sitPros[index].choixActiviteSalariee.code !== 'SAL')) 
                            || (vm.data.sitPros[index].choixAutRegSal 
                            && vm.data.sitPros[index].choixAutRegSal.code === 'AU') ) 
            );     
        };

        vm.affichePaysCotisation = function(index) {
            return (
                    vm.data.sitPros[index] 
                        && vm.data.sitPros[index].cotisEmployeur
                        && vm.data.sitPros[index].cotisEmployeur.code === 'RE'
            ); 
        };

        vm.afficheDetache = function(index) {
            return (
                vm.data.sitPros[index] &&
                vm.data.sitPros[index].cotisEmployeur &&
                vm.data.sitPros[index].cotisEmployeur.code === 'RE' &&
                ( (vm.data.sitPros[index].choixActivite === 'SAL' &&
                    vm.data.sitPros[index].choixActiviteSalariee &&
                    vm.data.sitPros[index].choixActiviteSalariee.code !== 'INT') ||
                  (vm.data.sitPros[index].choixActivite === 'NSAL' &&
                    vm.data.sitPros[index].choixActiviteNonSalariee &&
                    vm.data.sitPros[index].choixActiviteNonSalariee.code === 'MAR') )
            );
        };

        vm.gerantSalarie = function(index) {
            // SAL + 'Gérant Salarié'
            return (
                vm.data.sitPros[index].choixActiviteSalariee 
                && vm.data.sitPros[index].choixActiviteSalariee.code 
                && vm.data.sitPros[index].choixActiviteSalariee.code === 'GERSAL'
            );
        };

        vm.activiteCONG = function(index) {
            return (vm.data.sitPros[index].choixActivite === 'CONG');
        };

        vm.activiteNSAL = function(index) {
            return (vm.data.sitPros[index].choixActivite === 'NSAL');
        };

        vm.activiteAPP = function(index) {
            return (vm.data.sitPros[index].choixActivite === 'APP');
        };

        vm.activiteSAL = function(index) {
            return (vm.data.sitPros[index].choixActivite == 'SAL');
        };

        vm.activiteETU = function(index) {
            return (vm.data.sitPros[index].choixActivite == 'ETU');
        };

        vm.cesseActProRETouPENS = function(index) {
            return (
                (vm.data.sitPros[index].choixActivite === 'RET' && vm.data.sitPros[index].cesseActProRet === 'Oui') ||
                (vm.data.sitPros[index].choixActivite === 'PENS' && vm.data.sitPros[index].cesseActProPens === 'Oui')
            );
        };

        /**
         * Supprime le choix de la cotisation
         */
        vm.deleteChoixCotisEmployeur = function() {
            delete vm.data.sitPros[vm.index].detacheFrance;
            delete vm.data.sitPros[vm.index].choixAutRegSal;
            delete vm.data.sitPros[vm.index].choixPosteFonct;
            delete vm.data.sitPros[vm.index].regImpos;
        };

        //COVID-19 : INC0570978 - RSL P5 CDS - Limitation nombre de mutation vers la MSA
        // affiche l'information liée à l'activité exp avec régime MSA pour les dossiers ayant de la ppa
        /* vm.afficheInfoMSA = function(index) {
            if (vm.controle.droitPPAEnCours &&
                this.isCafMetropole(CnafUserService.codeOrga()) &&
                vm.data.sitPros[index] &&
                vm.data.sitPros[index].choixActiviteNonSalariee &&
                vm.data.sitPros[index].choixActiviteNonSalariee.code === 'EXP' &&
                vm.data.sitPros[index].cotisEmployeur &&
                vm.data.sitPros[index].cotisEmployeur.code == 'AG' )
            {

                return true;
            } else {
                return false;

            }
        };*/
        // affiche l'information liée à l'activité exp avec régime MSA pour les dossiers ayant de la ppa et/ou du rsa
        vm.afficheInfoMSA = function(index) {
            return  ((vm.controle.droitPPAEnCours || vm.controle.droitRSAEnCours) &&
                CnafCctSituationproService.isMetropole(vm.controle.codepostal) &&
                vm.data.sitPros[index] &&
                vm.data.sitPros[index].choixActiviteNonSalariee &&
                vm.data.sitPros[index].choixActiviteNonSalariee.code === 'EXP' &&
                vm.data.sitPros[index].cotisEmployeur &&
                vm.data.sitPros[index].cotisEmployeur.code == 'AG' );
            
        };
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafSitproCotisEmployeur
     *
     * @description
     * cnafSitproCotisEmployeur affiche les champs de saisie pour saisir le régime de cotisation
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} cotisemployeurform formulaire
     * @param {Object} errorcotisemployeur erreurs
     * @param {Object} activite activité salariée sélectionnée
     * @param {boolean} conjoint indique si on traite l'état civil du conjoint
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproCotisEmployeur', {
        templateUrl: 'components/cnaf-cct-situationpro/cnaf-cct-situationpro-cotis-employeur/cnaf-cct-situationpro-cotis-employeur.html',
        bindings: {
            data: '=',
            cotisemployeurform: '=',
            errorcotisemployeur: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafSitproCotisEmployeurController
    });
})();

(function() {
    'use strict';

    CnafSitproEtudiantController.$inject = ['CnafCctAdresseSocleService', 'CnafCctSituationproControleDateService', 'CnafCctSituationproDateService'];

    function CnafSitproEtudiantController(CnafCctAdresseSocleService, CnafCctSituationproControleDateService, CnafCctSituationproDateService) {
        var vm = this;

        /* ------------------- */
        /*       SERVICE       */
        /* ------------------- */
        vm.parseDate = CnafCctSituationproDateService.parseDate;

        /* ------------------------------------------------------------------------------------------------------------------------- */
        /* ------------------- */ 
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
            vm.isXs = true;
            vm.controleInfDateNaissance = CnafCctSituationproControleDateService.controleInfDateNaissance;
            vm.controleSupDernJourMoisSuivDem = CnafCctSituationproControleDateService.controleSupDernJourMoisSuivDem;
            //INC0723285 : Contexte arrivée de conjoint - Ajout controle entre date début sitpro qui doit être < date Sitfam couple
            vm.controleDateSitProSitfamCouple = CnafCctSituationproControleDateService.controleDateSitProSitfamCouple;

            if (vm.controle.personneEnCoursIsEtu) {
                if (vm.controle.agesup29) {
                    vm.listeChoixEtudiant = [
                        { code: 'ETS', libelle: 'Etudiant(e) et activité salariée' },
                        { code: 'ETUNS', libelle: 'Etudiant(e) et activité non salariée' },
                        { code: 'HOSP', libelle: 'Etudiant(e) hospitalier(ère)' }
                    ];
                } else {
                    vm.listeChoixEtudiant = [
                        { code: 'ETS', libelle: 'Etudiant(e) et activité salariée' },
                        { code: 'ETUNS', libelle: 'Etudiant(e) et activité non salariée' },
                        { code: 'HOSP', libelle: 'Etudiant(e) hospitalier(ère)' },
                        { code: 'EBO', libelle: 'Etudiant(e) boursier(ère)' }
                    ];
                }
            } else {
                vm.listeChoixEtudiant = [
                    { code: 'ETU', libelle: 'Etudiant(e)' },
                    { code: 'ETS', libelle: 'Etudiant(e) et activité salariée' },
                    { code: 'ETUNS', libelle: 'Etudiant(e) et activité non salariée' },
                    { code: 'HOSP', libelle: 'Etudiant(e) hospitalier(ère)' }
                ];
            }

            if (vm.controle.encouple){
                vm.controle.libellePersonne = vm.controle.libPersonneEnCours + " est";
            } else {
                vm.controle.libellePersonne = "Vous êtes";
            }

        };



        vm.initClassXs = function() {
            vm.isXs = false;
        };

        vm.afficheDateActivite = function(index) {
            if (vm.data.sitPros[index] && vm.data.sitPros[index].sitproetu) {
                if (
                    vm.data.sitPros[index].sitproetu.code === 'ETU' ||
                    vm.data.sitPros[index].sitproetu.code === 'EBO' ||
                    vm.data.sitPros[index].sitproetu.code === 'HOSP'
                ) {
                    return "Depuis le";
                } else if (vm.data.sitPros[index].sitproetu.code === 'ETS'){
                    return "Date de début de contrat";
                } else if (vm.data.sitPros[index].sitproetu.code === 'ETUNS'){
                    return "Date de début de l'activité non salariée";
                }
            }
            return false;
        };

        //SLT le 18/09/2018 : Enlever module boursier pour Etudiant salarié et Etudiant hospitalier (US 238-P5-S3)
        //ABD le 11/12/2019 : Rajouter module boursier pour Etudiant Salarié (F1906017)
        //APN le 22/07/2022 : L2211 - RFC0014971 - Rajouter module boursier pour Etudiant hospitalier
        vm.afficheBoursier = function(index) {
            var bRetour = false;
            if (vm.data.sitPros[index] && vm.data.sitPros[index].sitproetu) {
                if (!vm.controle.agesup29) {
                    if (vm.data.sitPros[index].sitproetu.code === 'ETU' ||
                        vm.data.sitPros[index].sitproetu.code === 'ETS' ||
                        vm.data.sitPros[index].sitproetu.code === 'HOSP'||
                        vm.data.sitPros[index].sitproetu.code === 'ETUNS') {
                            
                        bRetour = true;
                    }
                }
            } 

            return bRetour;
        };

        /**
         * @ngdoc method
         * @name openPopupSitPro
         * @methodOf cnafComponentsTeleprocApp.component:cnafSitproEtudiant
         * @description
         * Popup d'information spécifiant à l'utilisateur que
         * ses situations antérieures vont être supprimées
         */
        vm.openPopupSitPro = function() {
            $(':focus').blur();

            //Instanciation et ouverture de la modale
            var modalSitPro = $uibModal.open({
                component: 'cnafModalSitPro'
            });

            //Fonction appelée lors de la fermeture de la modal
            modalSitPro.result.then(function() {
                $(':focus').blur();
            });
        };
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafSitproEtudiant
     *
     * @description
     * cnafSitproEtudiant affiche les champs de saisie pour activité étudiant
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} sitproetudiantform formulaire
     * @param {Object} errorsitproetudiant erreurs
     * @param {boolean} agesup29 indique si la personne a plus de 29 ans
     * @param {boolean} encouple indique si présence d'une sitfam couple
     * @param {boolean} conjoint indique si on traite l'état civil du conjoint
     * @param {Object} anneeperiode année période du contrat de travail
     * @param {String} nationalite code nationalité
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproEtudiant', {
        templateUrl: 'components/cnaf-cct-situationpro/cnaf-cct-situationpro-etudiant/cnaf-cct-situationpro-etudiant.html',
        bindings: {
            data: '=',
            sitproetudiantform: '=',
            errorsitproetudiant: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafSitproEtudiantController
    });
})();

(function() {
    'use strict';

    CnafSitproEtudiantBoursierController.$inject = ['CnafCctAdresseSocleService', 'CnafCctSituationproControleDateService', 'CnafCctSituationproDateService'];

    function CnafSitproEtudiantBoursierController(CnafCctAdresseSocleService, CnafCctSituationproControleDateService, CnafCctSituationproDateService) {
        var vm = this;

        /* ------------------- */
        /*       SERVICE       */
        /* ------------------- */
        vm.parseDate = CnafCctSituationproDateService.parseDate;

        /* ------------------------------------------------------------------------------------------------------------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
            vm.isXs = true;
            vm.controleInfDateNaissance = CnafCctSituationproControleDateService.controleInfDateNaissance;
            vm.controleSupDernJourMoisSuivDem = CnafCctSituationproControleDateService.controleSupDernJourMoisSuivDem;
            vm.controle.libelleEbo = "Vous êtes étudiant(e) boursier(ère)";
            if (vm.controle.encouple){
                vm.controle.libelleEbo = vm.controle.libPersonneEnCours + " est étudiant(e) boursier(ère)"; 
            }
                
        };

        vm.initClassXs = function() {
            vm.isXs = false;
        };

    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafSitproEtudiantBoursier
     *
     * @description
     * cnafSitproEtudiantBoursier affiche les champs de saisie pour activité étudiant boursier
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} sitproetudiantboursierform formulaire
     * @param {Object} errorsitproetudiantboursier erreurs
     * @param {boolean} agesup29 indique si la personne a plus de 29 ans
     * @param {boolean} encouple indique si présence d'une sitfam couple
     * @param {boolean} conjoint indique si on traite l'état civil du conjoint
     * @param {Object} anneeperiode année période du contrat de travail
     * @param {String} nationalite code nationalité
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproEtudiantBoursier', {
        templateUrl: 'components/cnaf-cct-situationpro/cnaf-cct-situationpro-etudiant-boursier/cnaf-cct-situationpro-etudiant-boursier.html',
        bindings: {
            data: '=',
            sitproetudiantboursierform: '=',
            errorsitproetudiantboursier: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafSitproEtudiantBoursierController
    });
})();

(function() {
    'use strict';

    CnafSitproEtudiantBoursierOrganismeController.$inject = ['CnafCctAdresseSocleService', 
                                                             'CnafCctSituationproControleDateService', 
                                                             'CnafCctSituationproDateService',
                                                             'CnafCctGestionTypeService'];

    function CnafSitproEtudiantBoursierOrganismeController(CnafCctAdresseSocleService, 
                                                           CnafCctSituationproControleDateService, 
                                                           CnafCctSituationproDateService,
                                                           CnafCctGestionTypeService) {
        var vm = this;

        /* ------------------- */
        /*       SERVICE       */
        /* ------------------- */
        vm.parseDate = CnafCctSituationproDateService.parseDate;
        
        /* ------------------------------------------------------------------------------------------------------------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */

        vm.isXs = true;

        //Recherche liste pays pour établissement boursier
        vm.httpRechListePaysBourse = function() {
            console.log("vm.httpRechListePaysBourse");
            CnafCctAdresseSocleService.rechListePays()
                .get()
                .$promise.then(
                    function successCallback(response0) {
                        vm.listePaysBourse = response0.listePays;
                        console.log(vm.listePaysBourse);
                    },
                    function errorCallback(error) {
                        vm.etat = 'error';
                    }
                );
        };

        //AUTO-COMPLETION
        //Pays :
        vm.getListePaysBourseProposes = function(prefix) {
            console.log(vm.listePaysBourse);
            return vm.listePaysBourse;
        };

        vm.httpRechListePaysBourse();


        vm.initClassXs = function() {
            vm.isXs = false;
        };

        vm.testType8 = function(donnee, form, nomDonnee) {
            console.log("vm.testType8 avec form = "+form);
            console.log("vm.testType8 avec donnee = "+donnee);
            if (donnee === undefined || donnee.length === 0) {
                form.$setValidity('type8', true);
            } else {
                var retourControles = CnafCctGestionTypeService.appelControleType8(donnee, form);
                console.log("vm.testType8 avec retourControles = "+retourControles);
                if (retourControles !== null) {
                    vm.data[nomDonnee] = retourControles;
                }
            }
        };

    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafSitproEtudiantBoursierOrganisme
     *
     * @description
     * cnafSitproEtudiantBoursierOrganisme affiche les champs de saisie pour l'organisme de l'étudiant boursier
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} sitproetudiantboursierorganismeform formulaire
     * @param {Object} errorsitproetudiantboursierorganisme erreurs
     * @param {boolean} agesup29 indique si la personne a plus de 29 ans
     * @param {boolean} encouple indique si présence d'une sitfam couple
     * @param {boolean} conjoint indique si on traite l'état civil du conjoint
     * @param {Object} anneeperiode année période du contrat de travail
     * @param {String} nationalite code nationalité
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproEtudiantBoursierOrganisme', {
        templateUrl: 'components/cnaf-cct-situationpro/cnaf-cct-situationpro-etudiant-boursier-organisme/cnaf-cct-situationpro-etudiant-boursier-organisme.html',
        bindings: {
            data: '=',
            sitproetudiantboursierorganismeform: '=',
            errorsitproetudiantboursierorganisme: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafSitproEtudiantBoursierOrganismeController
    });
})();

(function() {
    'use strict';

    CnafSitproEtudiantChoixController.$inject = [];

    function CnafSitproEtudiantChoixController() {

    }


    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafSitproEtudiantChoix
     *
     * @description
     * cnafSitproEtudiant affiche les champs de saisie pour activité étudiant
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} sitproetudiantchoixform formulaire
     * @param {Object} errorsitproetudiantchoix erreurs
     * @param {boolean} listechoixetudiant liste des choix à afficher
     * @param {boolean} controle data de contrôle
     * @param {boolean} index index
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproEtudiantChoix', {
        templateUrl: 'components/cnaf-cct-situationpro/cnaf-cct-situationpro-etudiant-choix/cnaf-cct-situationpro-etudiant-choix.html',
        bindings: {
            data: '=',
            sitproetudiantchoixform: '=',
            errorsitproetudiantchoix: '=',
            listechoixetudiant: '=',            
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafSitproEtudiantChoixController
    });
})();

(function() {
    'use strict';

    CnafSitproInvaliditeController.$inject = ['CnafCctSituationproControleDateService'];

    function CnafSitproInvaliditeController(CnafCctSituationproControleDateService) {
        var vm = this;

        /* ------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
            if (vm.controle.encouple){
                vm.controle.libellePersonneInva = vm.controle.libPersonneEnCours + " perçoit";
                vm.controle.libellePersonneCesseActProPens = vm.controle.libPersonneEnCours + " a totalement cessé son activité professionnelle";
            } else {
                vm.controle.libellePersonneInva = "Vous percevez";
                vm.controle.libellePersonneCesseActProPens = "Vous avez totalement cessé votre activité professionnelle";
            }
            vm.controleInfDateNaissance = CnafCctSituationproControleDateService.controleInfDateNaissance;
            vm.controleSupDernJourMoisSuivDem = CnafCctSituationproControleDateService.controleSupDernJourMoisSuivDem;
            //INC0723285 : Contexte arrivée de conjoint - Ajout controle entre date début sitpro qui doit être < date Sitfam couple
            vm.controleDateSitProSitfamCouple = CnafCctSituationproControleDateService.controleDateSitProSitfamCouple;
        };
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafSitproInvalidite
     *
     * @description
     * cnafSitproChoixActiviteInvalidite affiche les champs de saisie pour choisir son activité de type "salarié"
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} invaliditeform formulaire
     * @param {Object} errorinvalidite erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     * @param {boolean} conjoint indique si on traite l'état civil du conjoint
     * @param {Date} date de naissance
     * @param {Date} dernier jour du mois d'ouverture de droit à l'AL
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproInvalidite', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-invalidite/cnaf-cct-situationpro-invalidite.html',
        bindings: {
            data: '=',
            invaliditeform: '=',
            errorinvalidite: '=',
            autocompletion: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafSitproInvaliditeController
    });
})();

(function() {
    'use strict';

    CnafSitproNonSalarieeController.$inject = ['CnafCctGestionTypeService', 'CnafCctSituationproControleDateService','CnafCctSituationproService'];

    function CnafSitproNonSalarieeController(CnafCctGestionTypeService, CnafCctSituationproControleDateService,CnafCctSituationproService) {
        var vm = this;
       
        vm.listeRegimeImposition = [
            { code: 'T', libelle: 'Traitements et salaires' },
            { code: 'microBIC', libelle: 'Micro BIC Ventes/Micro BNC' },
            { code: 'bicbnc', libelle: 'BIC/BNC' },
            { code: 'microBNC', libelle: 'Micro BNC' },
            { code: 'bnc', libelle: 'BNC déclaration contrôlée' }
        ];
        /*INC0537508 
        vm.listeRegimeAffilMaladie = [
            { code: 'RG', libelle: 'Régime général' }, 
            { code: 'RA', libelle: 'Régime agricole' }
        ];*/

        vm.listeRegimeGerant = [
            { code: 'IR', libelle: "Gérant(e) ou chef d'entreprise individuelle soumise à l'IR" }, 
            { code: 'IS', libelle: "Gérant(e) d'une EIRL ou d'une société soumise à l'IS" }
        ];

        /* ------------------------------------------------------------------------------------------------------------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
            vm.controleInfDateNaissance = CnafCctSituationproControleDateService.controleInfDateNaissance;
            vm.controleSupDernJourMoisSuivDem = CnafCctSituationproControleDateService.controleSupDernJourMoisSuivDem;
            //INC0723285 : Contexte arrivée de conjoint - Ajout controle entre date début sitpro qui doit être < date Sitfam couple
            vm.controleDateSitProSitfamCouple = CnafCctSituationproControleDateService.controleDateSitProSitfamCouple;
            
            vm.listeActivitenonsalariee = [];
            vm.listeActivitenonsalariee.push({ code: 'INDEP', libelle: 'Travailleur(se) indépendant(e)' });
            vm.listeActivitenonsalariee.push({ code: 'AUTOEN', libelle: 'Micro-entrepreneur(se) (ex Auto-entrepreneur(se))' });
            vm.listeActivitenonsalariee.push({ code: 'VDINS', libelle: 'VDI - Vendeur(se) à domicile' });
            vm.listeActivitenonsalariee.push({ code: 'MAR', libelle: 'Marin pêcheur' });
            vm.listeActivitenonsalariee.push({ code: 'EXP', libelle: 'Exploitant(e) agricole'});
            vm.listeActivitenonsalariee.push({ code: 'ARTIST', libelle: 'Artiste auteur(e)'});
            if (vm.controle.encouple){
                vm.listeActivitenonsalariee.push({ code: 'CONJOIN', libelle: 'Conjoint(e) collaborateur(trice)'}); 
            }
            if (!CnafCctSituationproService.isMetropole(vm.controle.codepostal)){
                vm.listeActivitenonsalariee.push({ code: 'AFA', libelle: 'Aide familiale agricole' });
            }
            vm.listeActivitenonsalariee.push({ code: 'COTIS', libelle: 'Cotisant(e) solidaire' });
        };

        vm.afficheNomOrganisme = function(index) {
            //On affiche le champ 'Nom de l'organisme' si le régime de cotisation = "Autre régime"
            return (vm.data.sitPros[index] && vm.data.sitPros[index].cotisEmployeur) 
                    && (vm.data.sitPros[index].cotisEmployeur.code == 'AR');
        };

        vm.afficheRegimeCotisation = function(index) {
            // On affiche le régime de cotisation
            //pour les activités différente de 'Travailleur indépendant' et 'Cotisant solidaire'
            return (vm.data.sitPros[index] && vm.data.sitPros[index].choixActiviteNonSalariee 
                    && vm.data.sitPros[index].choixActiviteNonSalariee.code !== 'INDEP' 
                    && vm.data.sitPros[index].choixActiviteNonSalariee.code !== 'COTIS'
                ); 
        };

        vm.afficheRegimeImposition = function(index) {
            // On affiche le régime d'imposition (Réel / Forfaitaire / Traitement et salaire)
            //pour les activités 'Vendeur à domicile indépendant' et 'Artiste auteur'
            return (vm.data.sitPros[index] && vm.data.sitPros[index].choixActiviteNonSalariee) 
                && (
                    vm.data.sitPros[index].choixActiviteNonSalariee.code === 'VDINS' ||
                    vm.data.sitPros[index].choixActiviteNonSalariee.code === 'ARTIST'
                    );
        };

        vm.testType8 = function(donnee, form, nomDonnee) {
            if (donnee === undefined || donnee.length === 0) {
                form.$setValidity('type8', true);
            } else {
                var retourControles = CnafCctGestionTypeService.appelControleType8(donnee, form);
                if (retourControles !== null) {
                    vm.data[nomDonnee] = retourControles;
                }
            }
        };
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafSitproNonSalariee
     *
     * @description
     * cnafSitproNonSalariee affiche les champs de saisie pour choisir son activité de type "non salarié"
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} nonsalarieeform formulaire
     * @param {Object} errornonsalariee erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     * @param {boolean} conjoint indique si on traite l'état civil du conjoint
     * @param {Date} date de naissance
     * @param {Date} dernier jour du mois d'ouverture de droit à l'AL
     *
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproNonSalariee', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-non-salariee/cnaf-cct-situationpro-non-salariee.html',
        bindings: {
            data: '=',
            nonsalarieeform: '=',
            errornonsalariee: '=',
            autocompletion: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafSitproNonSalarieeController
    });
})();

(function() {
    'use strict';

    CnafRecapSitproController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafRecapSitproController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafRecapSitpro
     *
     * @description
     * cnafRecapSitpro affiche le bloc RECAP des champs de saisie pour la situation professionnelle
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproRecap', {
        templateUrl: 'components/cnaf-cct-situationpro/cnaf-cct-situationpro-recap/cnaf-cct-situationpro-recap.html',
        bindings: {
            data: '=',
            index: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafRecapSitproController
    });
})();

(function() {
    'use strict';

    CnafRecapAutresituationController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafRecapAutresituationController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {
        var vm = this;
        
       /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
            if (vm.data.exerceActPro)
            {
                vm.data.libelleexerceActPro = vm.libelleexerceActPro();
            }
        };
        
        vm.libelleexerceActPro = function() {
            var sLibelleRetour = '';
            if (vm.data.exerceActPro === 'Oui')
            {
                sLibelleRetour = ' exerce une activité professionnelle.';

            }
            else
            {
                sLibelleRetour = ' n’exerce pas une activité professionnelle.';
              
            }


            return sLibelleRetour;
        };         

    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafRecapAutresituation
     *
     * @description
     * cnafRecapAutresituation affiche le bloc RECAP des champs de saisie pour l'etat civil
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproRecapAutreSituation', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-recap-autre-situation/cnaf-cct-situationpro-recap-autre-situation.html',
        bindings: {
            data: '=',
            personneencours: '=',
            index: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafRecapAutresituationController
    });
})();

(function() {
    'use strict';

    CnafRecapChoixactivitesalarieeController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafRecapChoixactivitesalarieeController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {
        var vm = this;
        
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
            vm.data.libelleActPro = vm.libelleActPro(vm.data);
            
        };
        
        vm.libelleActPro = function(data) {
            var sLibelleRetour = '';
            switch (data.choixActiviteSalariee.code) {
                case ('SAL'):
                    sLibelleRetour = 'est salarié(e)';
                    break;
                case ('ASSMAT'):
                    sLibelleRetour = 'est assistant(e) maternel(le)';
                    break;
                case ('GERSAL'):
                    sLibelleRetour = 'est gérant(e) salarié(e)';
                    break;
                case ('TSA'):
                    sLibelleRetour = 'est travailleur(se) saisonnier(e)';
                    break;
                case ('INT'):
                    sLibelleRetour = 'est intérimaire';
                    break;
                case ('SPEC'):
                    sLibelleRetour = 'est intermittent(e) du spectacle';
                    break;
                case ('VDS'):
                    sLibelleRetour = 'est vendeur(se) à domicile salarié(e)';
                    break;
                case ('VRP'):
                    sLibelleRetour = 'est VRP (Voyageur Représentant Placier)';
                    break;
                case ('ESAT'):
                    sLibelleRetour = 'est salarié(e) en ESAT';
                    break;
                case ('EMMAUS'):
                    sLibelleRetour = 'est Compagnon EMMAÜS';
                    break;
                case ('INTER'):
                    sLibelleRetour = "est membre d'une organisation internationale";
                    break;
                case ('SAS'):
                    sLibelleRetour = "est président(e) d'une SAS";
                    break;
                case ('ASSFAM'):
                    sLibelleRetour = "est assistant(e) familial(e)";
                    break;
                   
                default:
                    //console.log("ERROR data.choixActiviteSalariee.code inconnue code :" + data.choixActiviteSalariee.code);
                    break;
            }

            if (data.profilAvecAAH){
                if (data.activitePartielAah){
                    sLibelleRetour = sLibelleRetour + ' à temps partiel.'; 
                } else {
                    sLibelleRetour = sLibelleRetour + ' à temps complet.'; 
                }
            } else {
                sLibelleRetour = sLibelleRetour + '.'; 
            }
           
            return sLibelleRetour;
        };         
    
       
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafRecapChoixactivitesalariee
     *
     * @description
     * cnafRecapChoixactivitesalariee affiche le bloc RECAP des champs de saisie pour l'etat civil
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproRecapChoixActiviteSalariee', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-recap-choix-activite-salariee/cnaf-cct-situationpro-recap-choix-activite-salariee.html',
        bindings: {
            data: '=',
            cumul: '=',
            issalounonsal: '=',
            personneencours: '=',
            index: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafRecapChoixactivitesalarieeController
    });
})();

(function() {
    'use strict';

    CnafRecapChoixactivitestagiaireController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafRecapChoixactivitestagiaireController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {
        var vm = this;
        
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
            vm.data.libelleActPro = vm.libelleActPro(vm.data);
            
        };
        
        vm.libelleActPro = function(data) {
            var sLibelleRetour = '';
            switch (data.choixStagiaire.code) {
                case ('STAGE'):
                    sLibelleRetour = 'est stagiaire';
                    break;
                case ('APP'):
                    sLibelleRetour = 'est apprenti(e)';
                    break;
                case ('CONTRAT'):
                    sLibelleRetour = 'est en contrat de professionnalisation ou en alternance';
                    break;
               
                default:
                    //console.log("ERROR data.choixStagiaire.code inconnue code :" + data.choixStagiaire.code);
                    break;
            }

            if (data.profilAvecAAH){
                if (data.activitePartielAah){
                    sLibelleRetour = sLibelleRetour + ' à temps partiel.'; 
                } else {
                    sLibelleRetour = sLibelleRetour + ' à temps complet.'; 
                }
            } else {
                sLibelleRetour = sLibelleRetour + '.'; 
            }
           
            return sLibelleRetour;
        };         
    
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafRecapChoixactivitestagiaire
     *
     * @description
     * cnafRecapChoixactivitestagiaire affiche le bloc RECAP des champs de saisie pour l'etat civil
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproRecapChoixActiviteStagiaire', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-recap-choix-activite-stagiaire/cnaf-cct-situationpro-recap-choix-activite-stagiaire.html',
        bindings: {
            data: '=',
            personneencours: '=',
            index: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafRecapChoixactivitestagiaireController
    });
})();

(function() {
    'use strict';

    CnafRecapChomageController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes', 'CnafCctDateService'];

    function CnafRecapChomageController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes, CnafCctDateService) {
        var vm = this;
        vm.init = function() {
            vm.moisEnCoursCPL = CnafCctDateService.getLitteralMonth(CnafCctDateService.getDateToday());
            if(vm.data.heuresCPL) vm.heuresCPL = vm.data.heuresCPL.slice().reverse();
        }
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafRecapChomage
     *
     * @description
     * cnafRecapChomage affiche le bloc RECAP des champs de saisie pour l'etat civil
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproRecapChomage', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-recap-chomage/cnaf-cct-situationpro-recap-chomage.html',
        bindings: {
            data: '=',
            personneencours: '=',
            index: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafRecapChomageController
    });
})();

(function() {
    'use strict';

    CnafRecapCongesDiversController.$inject = ['CnafCctGestionTypeService', 
                                                            '$state', 
                                                            'CnafCctConstantMsgTypes'];

    function CnafRecapCongesDiversController(CnafCctGestionTypeService, 
                                                          $state, 
                                                          CnafCctConstantMsgTypes) {
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafRecapCongesDivers
     *
     * @description
     * cnafRecapChoixactivitecongesdivers affiche le bloc RECAP des champs de saisie pour l'etat civil
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproRecapCongesDivers', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-recap-conges-divers/cnaf-cct-situationpro-recap-conges-divers.html',
        bindings: {
            data: '=',
            personneencours: '=',
            index: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafRecapCongesDiversController
    });
})();

(function() {
    'use strict';

    CnafRecapEtudiantController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafRecapEtudiantController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {
        var vm = this;


        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
            if (vm.data.boursier)
            {
                vm.data.libelleBoursier = vm.libelleBoursier();
            }
        };

        vm.libelleBoursier = function() {
            var sLibelleRetour = '';
            if (vm.data.sitproetu.code === 'ETU')
            {
                sLibelleRetour = ' est étudiant(e) et n’est pas boursier(ère).';

                if (vm.data.boursier === 'Oui')
                {
                    sLibelleRetour = ' est étudiant(e) boursier(ère).';   
                }
            }
            else if (vm.data.sitproetu.code === 'ETS' || 
                        vm.data.sitproetu.code === 'ETUNS' || 
                        vm.data.sitproetu.code === 'HOSP'
                        )
            {
                sLibelleRetour = ' n’est pas boursier(ère).';

                if (vm.data.boursier === 'Oui')
                {
                    sLibelleRetour = ' est boursier(ère).';   
                }               
            }


            return sLibelleRetour;
        };        
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafRecapEtudiant
     *
     * @description
     * cnafRecapEtudiant affiche le bloc RECAP des champs de saisie pour l'activité ETUDIANT
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproRecapEtudiant', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-recap-etudiant/cnaf-cct-situationpro-recap-etudiant.html',
        bindings: {
            data: '=',
            personneencours: '=',
            index: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafRecapEtudiantController
    });
})();

(function() {
    'use strict';

    CnafRecapInvaliditeController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafRecapInvaliditeController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafRecapInvalidite
     *
     * @description
     * cnafRecapInvalidite affiche le bloc RECAP des champs de saisie pour l'etat civil
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproRecapInvalidite', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-recap-invalidite/cnaf-cct-situationpro-recap-invalidite.html',
        bindings: {
            data: '=',
            personneencours: '=',
            index: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafRecapInvaliditeController
    });
})();

(function() {
    'use strict';

    CnafRecapNonSalarieeController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafRecapNonSalarieeController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {
       
        var vm = this;
        
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
            vm.data.libelleActPro = vm.libelleActPro(vm.data);
            
        };
        
        vm.libelleActPro = function(data) {
            var sLibelleRetour = '';
            switch (data.choixActiviteNonSalariee.code) {
                case ('INDEP'):
                    sLibelleRetour = 'est travailleur(se) indépendant(e)';
                    break;
                case ('AUTOEN'):
                    sLibelleRetour = 'est micro-entrepreneur(se) (ex auto-entrepreneur(se))';
                    break;
                case ('VDINS'):
                    sLibelleRetour = 'est vendeur(se) à domicile indépendant';
                    break;
                case ('MAR'):
                    sLibelleRetour = 'est marin pêcheur';
                    break;
                case ('EXP'):
                    sLibelleRetour = 'est exploitant(e) agricole';
                    break;
                case ('ARTIST'):
                    sLibelleRetour = 'est artiste auteur(e)';
                    break;
                case ('AFA'):
                    sLibelleRetour = 'est aide familiale agricole';
                    break;
                case ('CONJOIN'):
                    sLibelleRetour = 'est conjoint(e) collaborateur';
                    break;
                case ('COTIS'):
                    sLibelleRetour = 'est cotisant(e) solidaire';
                    break;
               
                default:
                    //console.log("ERROR data.choixActiviteNonSalariee.code inconnue code :" + data.choixActiviteNonSalariee.code);
                    break;
            }

            if (data.profilAvecAAH){
                if (data.activitePartielAah){
                    sLibelleRetour = sLibelleRetour + ' à temps partiel.'; 
                } else {
                    sLibelleRetour = sLibelleRetour + ' à temps complet.'; 
                }
            } else {
                sLibelleRetour = sLibelleRetour + '.'; 
            }
           
            return sLibelleRetour;
        };         
    
       
    
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafRecapnonsalariee
     *
     * @description
     * cnafRecapNonSalariee affiche le bloc RECAP des champs de saisie pour les activités non salariées
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproRecapNonSalariee', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-recap-non-salariee/cnaf-cct-situationpro-recap-non-salariee.html',
        bindings: {
            data: '=',
            cumul: '=',
            issalounonsal: '=',
            personneencours: '=',
            index: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafRecapNonSalarieeController
    });
})();

(function() {
    'use strict';

    CnafRecapRetraiteController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafRecapRetraiteController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafRecapRetraite
     *
     * @description
     * cnafRecapRetraite affiche le bloc RECAP des champs de saisie pour l'etat civil
     *
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproRecapRetraite', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-recap-retraite/cnaf-cct-situationpro-recap-retraite.html',
        bindings: {
            data: '=',
            personneencours: '=',
            index: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafRecapRetraiteController
    });
})();

(function() {
    'use strict';

    CnafRecapProlongSitproController.$inject = ['CnafCctGestionTypeService', '$state', 'CnafCctConstantMsgTypes'];

    function CnafRecapProlongSitproController(CnafCctGestionTypeService, $state, CnafCctConstantMsgTypes) {
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafRecapProlongSitpro
     *
     * @description
     * cnafRecapProlongSitpro affiche le bloc RECAP des champs de saisie pour la situation professionnelle
     * en cas de prolongation d'activité (on vient d'une alerte et concerne CSS, CAC et MAL)
     *
     * @restrict E
     *
     * @param {Object} data data
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproRecapprolong', {
        templateUrl: 'components/cnaf-cct-situationpro/cnaf-cct-situationpro-recapprolong/cnaf-cct-situationpro-recapprolong.html',
        bindings: {
            data: '=',
            index: '=',
            recapform: '='
        },
        controllerAs: 'vm',
        controller: CnafRecapProlongSitproController
    });
})();

(function() {
    'use strict';

    CnafSitproRetraiteController.$inject = ['CnafCctSituationproControleDateService','CnafCctSituationproService'];

    function CnafSitproRetraiteController(CnafCctSituationproControleDateService,CnafCctSituationproService) {
        var vm = this;

/* ------------------- */
        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */
        vm.init = function() {
            if (vm.controle.encouple){
                vm.controle.libellePersonneCesseActProRet = vm.controle.libPersonneEnCours + " a totalement cessé son activité professionnelle";
            } else {
                vm.controle.libellePersonneCesseActProRet = "Vous avez totalement cessé votre activité professionnelle";
            }
            vm.controleInfDateNaissance = CnafCctSituationproControleDateService.controleInfDateNaissance;
            vm.controleSupDernJourMoisSuivDem = CnafCctSituationproControleDateService.controleSupDernJourMoisSuivDem;
            //INC0723285 : Contexte arrivée de conjoint - Ajout controle entre date début sitpro qui doit être < date Sitfam couple
            vm.controleDateSitProSitfamCouple = CnafCctSituationproControleDateService.controleDateSitProSitfamCouple;
        };

        vm.afficheMayotte = function(index) {
            return ( 
                CnafCctSituationproService.isMayotte(vm.controle.codepostal)|| vm.controle.grpAllocatairesMayotte
            );
        };
    }



    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:cnafSitproRetraite
     *
     * @description
     * cnafSitproRetraite affiche les champs de saisie pour choisir son activité de type "salarié"
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} retraiteform formulaire
     * @param {Object} erroretraite erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     * @param {boolean} conjoint indique si on traite l'état civil du conjoint
     * @param {Date} date de naissance
     * @param {Date} dernier jour du mois d'ouverture de droit à l'AL
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproRetraite', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-retraite/cnaf-cct-situationpro-retraite.html',
        bindings: {
            data: '=',
            retraiteform: '=',
            errorretraite: '=',
            autocompletion: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafSitproRetraiteController
    });
})();

(function() {
    'use strict';

    CnafCctSitproTauxActiviteAahController.$inject = ['$scope'];

    function CnafCctSitproTauxActiviteAahController($scope) {
        var vm = this;
        //$scope.percentageRegex = /(^100(\.0{1,2})?$)|(^([1-9]([0-9])?|0)(\.[0-9]{1,2})?$)/;

        /* ------------------- */
        /*       Fonction      */
        /* ------------------- */

        vm.init = function() {
           console.log("vm.dataCCT",vm.data);
           console.log("vm.controleCCT",vm.controle);
                                   
           vm.isXs = true;
             
        };

        vm.initClassXs = function() {
            vm.isXs = false;
        };
       

    }

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproTauxActiviteAah', {
        templateUrl: 'components/cnaf-cct-situationpro/cnaf-cct-situationpro-taux-activite-aah/cnaf-cct-situationpro-taux-activite-aah.html',
        bindings: {
            data: '=',
            tauxactiviteaahform: "=",
            errorctauxactiviteaah: "=",
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafCctSitproTauxActiviteAahController
    });
})();
(function() {
    'use strict';

    CnafCctSituationproTexteEboController.$inject = [];

    function CnafCctSituationproTexteEboController() {
 

    }

    /**
     * @ngdoc directive
     * @name cnafCctSituationproTexteEboController.component:cnafCctSituationproTexteEboController
     *
     * @description
     * cnafCctSituationproTexteEboController affiche le texte particulier pour les étudiants boursiers
     *
     *
     * @restrict E
     *
     * @example
     * Voir showcase : http://localhost:9000/
    */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproTexteEbo', {
        templateUrl: 'components/cnaf-cct-situationpro/cnaf-cct-situationpro-texte-ebo/cnaf-cct-situationpro-texte-ebo.html',
        controllerAs: 'vm',
        controller: CnafCctSituationproTexteEboController
    });
})();

(function() {
    'use strict';

    angular.module('cnafComponentsTeleprocApp').service('CnafCctControleIbanService', CnafCctControleIbanService);

    CnafCctControleIbanService.$inject = [
        'CnafCctConstantMsgIban',
        '$state',
        '$rootScope',
        'CnafCctWsBicIbanService',
        'CnafSaveSaisieService',
        'CnafCctIbanService'
    ];

    function CnafCctControleIbanService(
        CnafCctConstantMsgIban,
        $state,
        $rootScope,
        CnafCctWsBicIbanService,
        CnafSaveSaisieService,
        CnafCctIbanService
    ) {
        /**
         * Contrôle de l'iban et bic
         *
         * @param {any} iban
         * @param {any} bic
         * @returns retour du contrôle
         */
        this.controlerIban = function(iban, bic) {
            var retourControles = this.controleCid6867RegleB(iban);
            var cetban, cguban, ncpban, ctregt;
            //Contrôles liés aux éléments de l'IBAN (Validité des codes etablissement/guichet/...)
            if (retourControles === 'OK') {
                if (CnafCctIbanService.isPaysZoneSepaFrDomTom(bic)) {
                    // Pays FR (DOM TOM inclus)
                    var ibanDecoupe = CnafCctIbanService.decouperIban(iban);
                    cetban = ibanDecoupe.cetban;
                    cguban = ibanDecoupe.cguban;
                    ncpban = ibanDecoupe.ncpban;
                    ctregt = this.genererCtregt(ibanDecoupe.cetban, ibanDecoupe.cguban, bic);
                    retourControles = this.controleCid6867R3(ctregt, ibanDecoupe.cetban);

                    //Tous les contrôles/IBAN suivants générant le même message (U961.CC6867=La saisie du code IBAN est incorrecte)...
                    //Pour éviter l'affichage multiple de ce message, les cid suivants ne seront appelés que si pas d'erreur déjà détectée
                    if (retourControles === 'OK') {
                        retourControles = this.controlerDonnees(ctregt, cetban, cguban, ncpban);
                    }
                }
            }
            return retourControles;
        };

        /*
         * Returns 1 si l'iban est valide
         * Returns FALSE si la longueur n'est pas ce qu'elle devrait être
         * Returns tout autre nombre si l'iban est invalide
         * cf http://stackoverflow.com/questions/21928083/iban-validation-check
         * cf http://stackoverflow.com/questions/23471591/regex-for-iban-allowing-for-white-spaces-and-checking-for-exact-length
         */
        this.isValidIBANNumber = function(input) {
            // TODO tjrs utile ?
            if (input) {
                input = input.split(' ').join('');
                //Ajouter le code et la longueur associé pour chaque pays à contrôler
                var CODE_LENGTHS = {
                    FR: 27,
                    MC: 27,
                    GP: 27,
                    GF: 27,
                    MQ: 27,
                    RE: 27,
                    YT: 27,
                    PM: 27,
                    TF: 27,
                    WF: 27,
                    MF: 27,
                    BL: 27
                };
                var iban = String(input)
                        .toUpperCase()
                        .replace(/[^A-Z0-9]/g, ''), // garde les char alphanumérique
                    code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/), // verifie les differents char
                    digits;
                // check syntax and length
                if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
                    return false;
                }
                // rearrange country code and check digits, and convert chars to ints
                digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function(letter) {
                    return letter.charCodeAt(0) - 55;
                });
                // final check
                return mod97(digits);
            }
            return '';
        };

        function mod97(string) {
            var checksum = string.slice(0, 2),
                fragment;
            for (var offset = 2; offset < string.length; offset += 7) {
                fragment = String(checksum) + string.substring(offset, offset + 7);
                checksum = parseInt(fragment, 10) % 97;
            }
            return checksum;
        }

        // création d'une fonction String.prototype endsWith
        // pour vérifier si une chaine se termine par une autre chaine
        // test préalable pour vérifier que une déclaration de endWith n'existe pas déjà ailleurs
        if (typeof String.prototype.endsWith !== 'function') {
            String.prototype.endsWith = function(suffix) {
                return this.indexOf(suffix, this.length - suffix.length) !== -1;
            };
        }

        this.validerWsBicIban = function(data, choixTituRibs, currentForm) {
            //Appel API REST
            //Validation du BIC / IBAN via l'appel au WebService GSFF
            return CnafCctWsBicIbanService.httpVerifierBicIbanApprofondi(data.bic, data.iban).then(
                function successCallback(response) {
                    //BIC / IBAN valide
                    // ATTENTION : on traite ici les reponse ayant un code retour http 200, 400 ou 404
                    // Cela devrait changer suite mail fait à l'équipe de Lyon

                    //Si au moins une erreur est retournée et que le code retour est différent de 0 (code HTTP = 200)
                    if (response.data.errors[0] && response.data.errors.length > 0 && response.data.errors[0].errorCode != '0') {
                        //Alors on affiche le message d'erreur adéquat retourné par le ws

                        if (currentForm && currentForm.iban) {
                            if (response.data.errors[0].errorCode == '3' || response.data.errors[0].errorCode == '8') {
                                // Iban et bic en erreur :
                                currentForm.iban.$setValidity('ibanvalid', false);
                                currentForm.bic.$setValidity('bicvalid', false);
                                currentForm.iban.invalidmsg = 'Codes BIC et IBAN invalides';
                                currentForm.bic.invalidmsg = '';
                                currentForm.iban.errorcode = response.data.errors[0].errorCode;
                                currentForm.bic.errorcode = response.data.errors[0].errorCode;
                            }

                            if (response.data.errors[0].errorCode == '4' || response.data.errors[0].errorCode == '6') {
                                // Seul le bic est en erreur :
                                currentForm.bic.$setValidity('bicvalid', false);
                                currentForm.bic.invalidmsg = 'Code BIC invalide';
                                currentForm.bic.errorcode = response.data.errors[0].errorCode;
                            }

                            if (response.data.errors[0].errorCode == '5') {
                                // Seul l'iban est en erreur :
                                currentForm.iban.$setValidity('ibanvalid', false);
                                currentForm.iban.invalidmsg = 'Code IBAN invalide';
                                currentForm.iban.errorcode = 5;
                            }
                        }

                        //Si le code erreur est 999 alors on remplace le BIC saisi par un BIC completé de XXX
                        if (response.data.errors[0].errorCode === '999') {
                            data.bic = data.bic.substring(0, 8) + 'XXX';
                        }
                    } else {
                        data.iban = CnafCctIbanService.getIbanWithoutSpace(data.iban);
                        var libelleSel = '';
                        var codeQualiteTitulaireCompteSel = '';
                        var libelleSaveBaseSel = '';
                        var i = 0;
                        while (i < choixTituRibs.length && libelleSel === '') {
                            if (choixTituRibs[i].cle === data.choixTituRib) {
                                libelleSel = choixTituRibs[i].libelle;
                                codeQualiteTitulaireCompteSel = choixTituRibs[i].codeQualiteTitulaireCompte;
                                libelleSaveBaseSel = choixTituRibs[i].libelleSaveBase;
                            }
                            i++;
                        }
                        //Récup du nom de la personne pour affichage dans la page récap (cas d'une personne seule)
                        if (libelleSel === '') {
                            libelleSel = choixTituRibs[0].libelle;
                        }
                        data.libelleTit = libelleSel;
                        data.codeQualiteTitulaireCompte = codeQualiteTitulaireCompteSel;
                        data.libelleSaveBase = libelleSaveBaseSel;
                        // Détermination si c'est un dossier couple (nous avons plus de 2 choix dans ce cas)
                        data.couple = choixTituRibs.length > 2;
                    }
                    return response.data.errors[0].errorCode;
                },
                function errorCallback(error) {
                    if (currentForm && currentForm.iban) {
                        currentForm.iban.$setValidity('ibanvalid', false);
                        currentForm.iban.invalidmsg = CnafCctConstantMsgIban.BIC_6867;
                    }
                }
            );
        };

        this.genererCtregt = function(cetban, cguban, bic) {
            var ctregt = 'VB'; // VB par défaut
            if (CnafCctIbanService.isPaysZoneSepaFrDomTom(bic))
            {
                if ((cetban !== null && cetban.trim() !== '') || (cguban !== null && cguban.trim() !== '')) {
                    var codeBanc = parseInt(cetban);

                    if (null !== cetban && cetban.endsWith('5') && codeBanc >= 10000) {
                        // si la 5ème position du code établissement = 5
                        // et le code établissement est superieur ou égal à "10000"
                        // alors le type de règlement = "Caisse d'éPargne écureuil" (CP)
                        ctregt = 'CP';
                    } else if (
                        codeBanc >= 10000 &&
                        codeBanc != 10011 &&
                        codeBanc != 20041 &&
                        codeBanc != 30041 &&
                        codeBanc != 14158 &&
                        codeBanc != 14168
                    ) {
                        // Si le code établissement est superieur ou égal à "10000"
                        // et différent de "10011 / 20041 / 30041 / 14158 / 14168"
                        // alors le type de réglement = "Virement Bancaire" (VB)
                        ctregt = 'VB';
                    } else if (codeBanc == 20041 || codeBanc == 30041 || codeBanc == 14158 || codeBanc == 14168) {
                        // Si le code établissement égal à
                        // "20041 / 30041 / 14158 / 14168"
                        // alors le type de réglement = "Virement Postal" (VP)
                        ctregt = 'VP';
                    } else if (codeBanc == 10011 && cguban === '00020') {
                        // Si le code établissement est égal à "10011"
                        // et le code guichet est égal à "00020"
                        // alors le type de réglement = "Caisse nationale d'Epargne"
                        // (CE)
                        ctregt = 'CE';
                    }
                }
            } 
            else {
                ctregt = 'VB';
            }

            return ctregt;
        };

        this.controlerDonnees = function(ctregt, cetban, cguban, ncpban) {
            //console.log("CnafCctControleIbanService controlerDonnees : entrée, avec ctregt = " + ctregt+" cetban = "+cetban+" cguban = "+cguban+" ncpban = "+ncpban);
            var retourControles = 'OK';

            //Tous les contrôles/IBAN suivants générant le même message (U961.CC6867=La saisie du code IBAN est incorrecte)...
            //Pour éviter l'affichage multiple de ce message, les cid suivants ne seront appelés que si pas d'erreur déjà détectée
            if (retourControles === 'OK') {
                retourControles = this.controleCid6867R4(ctregt, cetban);
            }
            if (retourControles === 'OK') {
                retourControles = this.controleCid6867R5(ctregt, cetban);
            }
            if (retourControles === 'OK') {
                retourControles = this.controleCid6867R6(ctregt, cetban, cguban);
            }
            if (retourControles === 'OK') {
                retourControles = this.controleCid6867R8(cetban, cguban);
            }
            if (retourControles === 'OK') {
                retourControles = this.controleCid6867R9(cetban, cguban);
            }
            if (retourControles === 'OK') {
                retourControles = this.controleCid6867R10(cetban, cguban);
            }
            if (retourControles === 'OK') {
                retourControles = this.controleCid6867R11(cetban, cguban);
            }
            if (retourControles === 'OK') {
                retourControles = this.controleCid6867R12Pos9(ctregt, ncpban);
            }
            if (retourControles === 'OK') {
                retourControles = this.controleCid6867R12Pos10et11(ctregt, ncpban);
            }
            if (retourControles === 'OK') {
                retourControles = this.controleCid6867R12Cle(ctregt, ncpban);
            }

            return retourControles;
        };

        this.controleCid6867R3 = function(ctregt, cetban) {
            // Règle 3
            // Si type de règlement VB ou CP, le Code établissemnet est >= 10000
            var ret = 'OK';
            if (ctregt == 'VB' || ctregt == 'CP') {
                if (cetban !== null && cetban.trim() !== '') {
                    var codEtab = parseInt(cetban);
                    if (codEtab < 10000) {
                        ret = CnafCctConstantMsgIban.CETBAN_6867;
                    }
                } else {
                    ret = CnafCctConstantMsgIban.CETBAN_6867;
                }
            }

            return ret;
        };

        this.controleCid3006R3 = function(ctregt, cetban) {
            // Règle 3
            // Si type de règlement VB ou CP, le Code établissemnet
            // est différent de 10011/20041/30041/14158/14168
            // ================================================================================
            var ret = 'OK';
            if (ctregt === 'VB' || ctregt === 'CP') {
                if (cetban !== null && cetban.trim() !== '') {
                    if (cetban === '10011' || cetban === '20041' || cetban === '30041' || cetban === '14158' || cetban === '14168') {
                        ret = CnafCctConstantMsgIban.CETBAN_3006;
                    }
                } else {
                    ret = CnafCctConstantMsgIban.CETBAN_3006;
                }
            }

            return ret;
        };

        this.controleCid6867R4 = function(ctregt, cetban) {
            // Règle 4
            // Si type de règlement CP : Code établissemnet = xxxx5
            // ================================================================================
            var ret = 'OK';
            if ('CP' === ctregt) {
                if (cetban !== null && '' !== cetban.trim()) {
                    if (cetban.trim().length < 5) {
                        ret = CnafCctConstantMsgIban.CETBAN_6867;
                    } else if (cetban.substring(4, 5) !== '5') {
                        ret = CnafCctConstantMsgIban.CETBAN_6867;
                    }
                } else {
                    ret = CnafCctConstantMsgIban.CETBAN_6867;
                }
            }

            return ret;
        };

        this.controleCid6867R5 = function(ctregt, cetban) {
            // Règle 5
            // // Si type règlement VP : Code établissemnet = 20041 ou 30041 ou
            // 14158 ou 14168
            // ================================================================================
            var ret = 'OK';
            if ('VP' === ctregt) {
                if (cetban !== null && '' !== cetban.trim()) {
                    if ('20041' !== cetban && '30041' !== cetban && '14158' !== cetban && '14168' !== cetban) {
                        ret = CnafCctConstantMsgIban.CETBAN_6867;
                    }
                } else {
                    ret = CnafCctConstantMsgIban.CETBAN_6867;
                }
            }

            return ret;
        };

        this.controleCid6867R6 = function(ctregt, cetban, cguban) {
            // Règle 6
            // Si type de règlement CE : Code établissemnet = 10011 Code guichet =
            // 00020
            // ================================================================================
            var ret = 'OK';
            if ('CE' === ctregt) {
                if (cetban !== null && '' !== cetban.trim()) {
                    if ('10011' !== cetban) {
                        ret = CnafCctConstantMsgIban.CETBAN_6867;
                    } else {
                        if (cguban !== null && '' !== cguban.trim()) {
                            if ('00020' !== cguban) {
                                ret = CnafCctConstantMsgIban.CGUBAN_6867;
                            }
                        } else {
                            ret = CnafCctConstantMsgIban.CGUBAN_6867;
                        }
                    }
                } else {
                    ret = CnafCctConstantMsgIban.CETBAN_6867;
                }
            }

            return ret;
        };

        this.controleCid6867R8 = function(cetban, cguban) {
            // Règle 8
            // Si Code établissement = 20041, le code guichet doit être égal à
            // 00001 ou "01000" <= code guichet <= "01021"
            // ================================================================================
            var ret = 'OK';
            if (cetban !== null && '' !== cetban.trim()) {
                if ('20041' === cetban) {
                    if ('00001' !== cguban) {
                        var codGuiche = parseInt(cguban);
                        if (codGuiche < 1000 || codGuiche > 1021) {
                            ret = CnafCctConstantMsgIban.CGUBAN_6867;
                        }
                    }
                }
            } else {
                ret = CnafCctConstantMsgIban.CETBAN_6867;
            }

            return ret;
        };

        this.controleCid6867R9 = function(cetban, cguban) {
            // Règle 9
            // Si Code établissement = 30041, si saisi, code guichet = "00001"
            // ================================================================================
            var ret = 'OK';
            if (cetban !== null && '' !== cetban.trim()) {
                if ('30041' === cetban) {
                    if ('00001' !== cguban) {
                        ret = CnafCctConstantMsgIban.CGUBAN_6867;
                    }
                }
            } else {
                ret = CnafCctConstantMsgIban.CETBAN_6867;
            }

            return ret;
        };

        this.controleCid6867R10 = function(cetban, cguban) {
            // Règle 10
            // Si Code établissement = 14158, si saisi, code guichet = "01022"
            // ================================================================================
            var ret = 'OK';
            if (cetban !== null && '' !== cetban.trim()) {
                if ('14158' === cetban) {
                    if ('01022' !== cguban) {
                        ret = CnafCctConstantMsgIban.CGUBAN_6867;
                    }
                }
            } else {
                ret = CnafCctConstantMsgIban.CETBAN_6867;
            }

            return ret;
        };

        this.controleCid6867R11 = function(cetban, cguban) {
            // Règle 11
            // Si Code établissement = 14168, si saisi, code guichet = "01023"
            // ================================================================================
            var ret = 'OK';
            if (cetban !== null && '' !== cetban.trim()) {
                if ('14168' === cetban) {
                    if ('01023' !== cguban) {
                        ret = CnafCctConstantMsgIban.CGUBAN_6867;
                    }
                }
            } else {
                ret = CnafCctConstantMsgIban.CETBAN_6867;
            }

            return ret;
        };

        this.controleCid6867R12Pos9 = function(ctregt, ncpban) {
            // Règle 12
            // Si type de règlement VP... la 13° position doit être égale à 0
            // ================================================================================
            var ret = 'OK';
            if ('VP' === ctregt) {
                if (ncpban !== null && '' !== ncpban.trim() && ncpban.length == 11) {
                    // la 9e position du compte doit être = 0
                    if ('0' !== ncpban.substring(8, 9)) {
                        ret = CnafCctConstantMsgIban.NCPBAN_6867;
                    }
                } else {
                    ret = CnafCctConstantMsgIban.NCPBAN_6867;
                }
            }

            return ret;
        };

        this.controleCid6867R12Pos10et11 = function(ctregt, ncpban) {
            // Règle 12
            // Si type de règlement VP... les 10° et 11° positions doivent être
            // numériques
            // et ce nombre doit être supérier à 14 et inférieur à 69
            // ================================================================================
            var ret = 'OK';
            if ('VP' === ctregt) {
                if (ncpban !== null && '' !== ncpban.trim() && ncpban.length == 11) {
                    // 10 et 11e positions du compte sont numériques et >14 et <69
                    var car10_11DuCompte = ncpban.substring(9, 11);
                    var pos10_11DuCompte = parseInt(car10_11DuCompte);
                    if (pos10_11DuCompte <= 14 || pos10_11DuCompte >= 69) {
                        ret = CnafCctConstantMsgIban.NCPBAN_6867;
                    }
                } else {
                    ret = CnafCctConstantMsgIban.NCPBAN_6867;
                }
            }

            return ret;
        };

        this.controleCid6867R12Cle = function(ctregt, ncpban) {
            // Règle 12
            // Si type de règlement VP..., la 8e position du compte = clé à
            // contrôler
            // ================================================================================
            var ret = 'OK';
            if ('VP' === ctregt) {
                if (ncpban !== null && '' !== ncpban.trim() && ncpban.length == 11) {
                    ret = this.verifierCleCpte(ncpban);
                } else {
                    ret = CnafCctConstantMsgIban.NCPBAN_6867;
                }
            }

            return ret;
        };

        this.controleCid6867RegleA = function(iban) {
            // Règle A
            // Contrôle du code pays : Les 2 premières positions de l'IBAN doit être
            // égales à liste des pays SEPA ( daf 3.1.5	Tableau des codes pays de la zone SEPA )
            var ret = 'OK';
            if (!CnafCctIbanService.isPaysZoneSepa(iban)) {
                ret = CnafCctConstantMsgIban.IBAN_6867_REGLE_A;
            }
            return ret;
        };

        this.controleCid6867RegleB = function(iban) {
            // Règle B
            // Les positions 3 à 4 sont obligatoirement numériques (contrôle de la
            // clé).
            var ret = 'OK';
            if (iban !== null) {
                var patronNumeriqueDeuxChiffres = new RegExp('^[0-9]+$');
                var deuxCaracteres = iban.substring(2, 4);
                var m = patronNumeriqueDeuxChiffres.test(deuxCaracteres);
                if (!m) {
                    ret = CnafCctConstantMsgIban.IBAN_6867;
                }
            } else {
                ret = CnafCctConstantMsgIban.IBAN_6867;
            }

            return ret;
        };

        // Vérification de la clé du compte bancaire (Si type règlement = VP)
        // ==================================================================
        this.verifierCleCpte = function(ncpban) {
            // Recherche de la clé spécifique
            var ret = 'OK';
            var egaliteOk = false;
            var pos1_7DuCompte = 0;
            var tabCle = [];

            // Init du tableau de clés
            tabCle[0] = '00A';
            tabCle[1] = '01B';
            tabCle[2] = '02C';
            tabCle[3] = '03D';
            tabCle[4] = '04E';
            tabCle[5] = '05F';
            tabCle[6] = '06G';
            tabCle[7] = '07H';
            tabCle[8] = '08J';
            tabCle[9] = '09K';
            tabCle[10] = '10L';
            tabCle[11] = '11M';
            tabCle[12] = '12N';
            tabCle[13] = '13P';
            tabCle[14] = '14R';
            tabCle[15] = '15S';
            tabCle[16] = '16T';
            tabCle[17] = '17U';
            tabCle[18] = '18V';
            tabCle[19] = '19W';
            tabCle[20] = '20X';
            tabCle[21] = '21Y';
            tabCle[22] = '22Z';

            pos1_7DuCompte = parseInt(ncpban.substring(0, 7));

            var indCle = 0;
            var var10_11DuCompte = parseInt(ncpban.substring(9, 11));
            var varCalcul = var10_11DuCompte * 1000000 + pos1_7DuCompte;
            var varCleCalculee = varCalcul % 23;

            for (var ind = 0; ind < 23 && !egaliteOk; ind++) {
                if (varCleCalculee == parseInt(tabCle[ind].substring(0, 2).trim())) {
                    egaliteOk = true;
                    indCle = ind;
                }
            }
            if (egaliteOk) {
                // Erreur inégalité sur la 7e position du n° de compte avec
                // correspondance tableau
                if (tabCle[indCle].substring(2) !== ncpban.substring(7, 8)) {
                    ret = CnafCctConstantMsgIban.NCPBAN_6867;
                }
            }
            return ret;
        };
    }
})();

(function() {
    'use strict';
    //Définition de constantes pour les msg d'erreur
    angular.module('cnafComponentsTeleprocApp').constant('CnafCctConstantMsgIban', {
        CETBAN_3006: 'La saisie du code IBAN est incorrecte.',
        BIC_5003: 'Code BIC obligatoire.',
        IBAN_5003: 'Code IBAN obligatoire.',
        CETBAN_6867: 'La saisie du code IBAN est incorrecte.',
        CGUBAN_6867: 'La saisie du code IBAN est incorrecte.',
        NCPBAN_6867: 'La saisie du code IBAN est incorrecte.',
        IBAN_6867: 'La saisie du code IBAN est incorrecte.',
        BIC_6867: 'La saisie du code BIC est incorrecte.',
        CODE_8: 'Code IBAN incohérent avec le code BIC.',
        BICIBAN_6867: 'Codes BIC et IBAN invalides.',
        BICIBAN_6894: 'Codes BIC / IBAN invalides (hors SEPA).',
        IBAN_6867_REGLE_A: 'Votre compte bancaire doit être domicilié dans un pays membre de l\'Union européenne',
        BICCODE_46: 'Après contrôle avec nos fichiers, nous avons remplacé les 3 derniers caractères du Bic par "XXX"'
    });
})();

(function() {
    'use strict';

    angular.module('cnafComponentsTeleprocApp').service('CnafCctIbanService', CnafCctIbanService);

    function CnafCctIbanService() {
        /**
         * Supprime les espaces (et mets en MAJUSCULE)
         */
        this.getIbanWithoutSpace = function(iban) {
            return iban
                .split(' ')
                .join('')
                .toUpperCase();
        };

        this.decouperIban = function(iban) {
            var ibanDecoupe = {};
            if (iban !== null) {
                ibanDecoupe.cetban = iban.substring(4, 9);
                ibanDecoupe.cguban = iban.substring(9, 14);
                ibanDecoupe.ncpban = iban.substring(14, 25);
                ibanDecoupe.cclrib = iban.substring(25);
            }
            return ibanDecoupe;
        };

        /**
         * Ajouter des espaces pour les iban
         */
        this.affichageIbanAvecBlanc = function(iban) {
            var ibanAvecBlanc = '';
            if (iban && iban != '') {
                ibanAvecBlanc = iban
                    .replace(/[^\dA-Z]/g, '')
                    .replace(/(.{4})/g, '$1 ')
                    .trim();
            }
            return ibanAvecBlanc;
        };

        this.setCursorPosition = function(curseurPos, value, oldValue, elem, backSpacePressed) {
            //On set une valeur iban avec les espaces
            var iban = value;
            //On enlève les espace de la value
            value = value.split(' ').join('');
            //Si la valeur est differente de l'ancienne valeur sans espace ou que la place du curseur ne soit pas à la fin,
            //C'est qu'on a pas ajouté d'espace, on peut alors redéfinir la position du curseur
            if (value !== oldValue.split(' ').join('') || elem.selectionStart !== iban.length) {
                //Ainsi la position du curseur se trouve tout simplement au niveau de là où il était lors de l'ajout d'un caractère
                curseurPos = elem.selectionStart;
                //Cependant si le backspace n'a pas été pressé
                //Et que le curseur se trouve après (ou avant) un espace ajouté automatiquement (retrouvé avec le modulo car sur 5 caractères)
                //Et que la longueur de la valeur (sans les espaces) ne soit pas un multiple de 4
                //Ce qui voudrait dire que l'on est dans la chaine de caractère, qu'on y a ajouté un nouveau caractère en fin de pavé de 4 caractères,
                //Qu'on doit déplacer du coup le curseur de l'autre coté de l'espace
                if (!backSpacePressed && (elem.selectionStart % 5 === 0 || elem.selectionStart % 5 === 4) && !(value.length % 4 === 0)) {
                    curseurPos++;
                }
            }
            //retourne la position du curseur
            return curseurPos;
        };

        /**
         * Objet recensant la liste des pays SEPA (cf DAF -RSL - P#5 - 2018 - Coordonnées bancaires v1.1 §3.1.5)
         */
        var mapCodePaysSepa = [
            { code: 'AT', length: 20, isFrDomTom: false },
            { code: 'BE', length: 16, isFrDomTom: false },
            { code: 'BG', length: 22, isFrDomTom: false },
            { code: 'CH', length: 21, isFrDomTom: false },
            { code: 'CY', length: 28, isFrDomTom: false },
            { code: 'CZ', length: 24, isFrDomTom: false },
            { code: 'DE', length: 22, isFrDomTom: false },
            { code: 'DK', length: 18, isFrDomTom: false },
            { code: 'EE', length: 20, isFrDomTom: false },
            { code: 'ES', length: 24, isFrDomTom: false },
            { code: 'FI', length: 18, isFrDomTom: false },
            { code: 'FR', length: 27, isFrDomTom: true },
            { code: 'GB', length: 22, isFrDomTom: false },
            { code: 'GF', length: 27, isFrDomTom: true },
            { code: 'GI', length: 23, isFrDomTom: false },
            { code: 'GP', length: 27, isFrDomTom: true },
            { code: 'GR', length: 27, isFrDomTom: false },
            { code: 'HR', length: 21, isFrDomTom: false },
            { code: 'HU', length: 28, isFrDomTom: false },
            { code: 'IE', length: 22, isFrDomTom: false },
            { code: 'IS', length: 26, isFrDomTom: false },
            { code: 'IT', length: 27, isFrDomTom: false },
            { code: 'LI', length: 21, isFrDomTom: false },
            { code: 'LT', length: 20, isFrDomTom: false },
            { code: 'LU', length: 20, isFrDomTom: false },
            { code: 'LV', length: 21, isFrDomTom: false },
            { code: 'MC', length: 27, isFrDomTom: false },
            { code: 'MQ', length: 27, isFrDomTom: true },
            { code: 'MT', length: 31, isFrDomTom: false },
            { code: 'NC', length: 27, isFrDomTom: false },
            { code: 'NL', length: 18, isFrDomTom: false },
            { code: 'NO', length: 15, isFrDomTom: false },
            { code: 'PF', length: 27, isFrDomTom: false },
            { code: 'PL', length: 28, isFrDomTom: false },
            { code: 'PT', length: 25, isFrDomTom: false },
            { code: 'RE', length: 27, isFrDomTom: true },
            { code: 'RO', length: 24, isFrDomTom: false },
            { code: 'SE', length: 24, isFrDomTom: false },
            { code: 'SI', length: 19, isFrDomTom: false },
            { code: 'SK', length: 24, isFrDomTom: false },
            { code: 'YT', length: 27, isFrDomTom: true }
        ];

        /**
         * Permet de repeter X fois un caractère
         */
        var repeatStringNumTimes = function(string, times) {
            var repeatedString = '';
            while (times > 0) {
                repeatedString += string;
                times--;
            }
            return repeatedString;
        };

        /**
         * Retourne l'objet correspondant au premiere lettre saisie pour l'iban ( ex pour 'FR' : {code:'FR', length:27})
         * afin de calculer le ui-mask dans la zone de saisie.
         * Retourne null si les 2 premières lettres ne correspondent pas à un pays SEPA
         */
        this.getIbanObj = function(ibanValue) {
            if (ibanValue.length > 1) {
                var begining = ibanValue.substr(0, 2).toUpperCase();
                var filtered = mapCodePaysSepa.filter(function(item) {
                    return item.code == begining;
                });

                if (filtered.length > 0) {
                    return filtered[0];
                } else {
                    return null;
                }
            } else {
                return null;
            }
        };

        /**
         * Retourne le bon 'ui-mask' en fonction du pays SEPA saisi. Ex pour FR : 'AA99 **** **** **** **** **** ***'
         * Retourne vide si le pays n'est pas en zone SEPA
         */
        this.getMaskType = function(ibanNewValue) {
            var ibanObj = this.getIbanObj(ibanNewValue);
            if (ibanObj) {
                //build mask
                var valueStr = '';
                // on retranche les 4 premiers caracteres ( correspondant à AA99 dans ui-mask)
                var countdown = ibanObj.length - 4;
                while (countdown > 0) {
                    if (countdown >= 4) {
                        valueStr += ' ****';
                        countdown = countdown - 4;
                    } else if (countdown < 4) {
                        valueStr += ' ';
                        // Pas possible d'utiliser .repeat à cause d'internet explorer sur les postes en libres services,
                        // A uncomment une fois que les postes en libre service utiliseront un browser moderne.
                        //valueStr += '*'.repeat(countdown);
                        valueStr += repeatStringNumTimes('*', countdown);
                        countdown = 0;
                    }
                }
                return 'AA99' + valueStr;
            } else {
                return 'AA99 **** **** **** **** **** **** ***';
            }
        };

        /**
         * Indique si l'iban passé en parametre à une longueur correcte. (ou pas.)
         */
        this.isValidLengthIban = function(ibanNewValue) {
            var ibanObj = this.getIbanObj(ibanNewValue);
            if (ibanObj) {
                return ibanObj.length === ibanNewValue.length;
            } else {
                return false;
            }
        };

        /**
         * Indique si bic est bien de type FR/DOM/TOM
         */
        this.isPaysZoneSepaFrDomTom = function(bic) {
            if (bic !== null && bic !== undefined && bic !== '') {
                var ret = mapCodePaysSepa.filter(function(item) {
                    return item.code == bic.substring(4, 6).toUpperCase() && item.isFrDomTom == true;
                });
                return ret.length == 1;
            } else {
                return false;
            }
        };

        /**
         * Indique si l'iban est un iban zone SEPA ou non. (cf daf 3.1.5 Tableau des codes pays de la zone SEPA)
         */
        this.isPaysZoneSepa = function(iban) {
            if (iban !== null && iban !== undefined && iban !== '') {
                var ret = mapCodePaysSepa.filter(function(item) {
                    return item.code == iban.substring(0, 2).toUpperCase();
                });
                return ret.length == 1;
            } else {
                return false;
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('cnafComponentsTeleprocApp')
        .service('CnafCctControleRnbService',
            CnafCctControleRnbService);

    CnafCctControleRnbService.$inject = [
        '$rootScope',
        'CnafCctDateService',
        'CnafCctWsrnbService',
        'CnafCctPrimoDateService'
    ];

    function CnafCctControleRnbService(
        $rootScope,
        CnafCctDateService,
        CnafCctWsrnbService,
        CnafCctPrimoDateService) {


        this.accederWsRnb = function(dataRNB,situationAcces,nir,codeOrga,dateDemarche) {
            //Appel API REST

            //Alimentation objet pour appeler le RNB
            var dataTOAPI = {};
            if (dataRNB.COMnaissance !== undefined)
            {  dataTOAPI.COMnaissance = dataRNB.COMnaissance;
            }
            dataTOAPI.lieunaissance = dataRNB.lieunaissance;
            //Si pas de Nir saisi, et génération d'un nir (ex cas COM) alors alim donneesGenerees
            if ((dataRNB.nir === undefined || dataRNB.nir.length === 0) && nir !== undefined && nir.length !== 0)
            {   dataTOAPI.nir = nir;
            }
            else
            {    dataTOAPI.nir = dataRNB.nir;
            }

            dataTOAPI.nom = dataRNB.nom;
            dataTOAPI.prenom = dataRNB.prenom;
            dataTOAPI.sexe = dataRNB.sexe;
            if ((dataRNB.codePostalVille) && (dataRNB.codePostalVille.lib)) {
                dataTOAPI.codePostalVille = dataRNB.codePostalVille.lib;
            }
            if ((dataRNB.paysNaissance) && (dataRNB.paysNaissance.libelleCaffr)) {
                dataTOAPI.paysNaissance = dataRNB.paysNaissance.libelleCaffr;
            }
            if (dataRNB.dateNaissance) {
                dataTOAPI.dateNaissance = new Date(Date.parseExact(dataRNB.dateNaissance, "d/M/yyyy"));
                dataTOAPI.dateNaissance = CnafCctDateService.yyyymmddsansslash(dataTOAPI.dateNaissance);
            }
            dataTOAPI.datedemarche = dateDemarche;
            dataTOAPI.situationAcces = situationAcces;
            dataTOAPI.codeOrga = codeOrga;

            //exemple base rnb :
            //née en France : CAROLE LEPELTIER née le 01/04/1969 dans le département = 14 - nir = 269041411800928
            //né à l'étranger : ZAKARIA BENABDERRAHMANE né le 29/05/1982 en Algérie
            //né en COM : 276129873501776 - PERCHAIS - EMMANUELLE - Polynésie Française - 1976/12/30 - 987 - 98
            //né en COM : 293109873502675 - MAHATIA AUROUSSEAU - NANCY - Polynésie Française - 06/10/1993
            //Appel du WebService RNB
            return CnafCctWsrnbService.httpRechercherRnbIdentPers(dataTOAPI);
        };
    }
})();

(function() {
    'use strict';

    CnafSitproDatedebController.$inject = ['CnafCctSituationproControleDateService'];

    function CnafSitproDatedebController(CnafCctSituationproControleDateService) {
        var vm = this;

        vm.controleInfDateNaissance = CnafCctSituationproControleDateService.controleInfDateNaissance;
        vm.controleSupDernJourMoisSuivDem = CnafCctSituationproControleDateService.controleSupDernJourMoisSuivDem;
        //INC0723285 : Contexte arrivée de conjoint - Ajout controle entre date début sitpro qui doit être < date Sitfam couple
        vm.controleDateSitProSitfamCouple = CnafCctSituationproControleDateService.controleDateSitProSitfamCouple;
    }

    



    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:CnafSitproDatedebController
     *
     * @description
     * cnafSitproDatedeb affiche les champs de saisie pour activité conges divers
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} datedebform formulaire
     * @param {Object} errordatedeb erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproDatedeb', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-autre-situation/datedeb-activite/cnaf-cct-situationpro-datedeb-activite.html',
        bindings: {
            data: '=',
            datedebform: '=',
            errordatedeb: '=',
            intitulelabel: '=',
            autocompletion: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafSitproDatedebController
    });
})();

(function() {
    'use strict';

    CnafSitproDatefinController.$inject = ['CnafCctSituationproControleDateService'];

    function CnafSitproDatefinController(CnafCctSituationproControleDateService) {
        var vm = this;

        vm.controleInfDateNaissance = CnafCctSituationproControleDateService.controleInfDateNaissance;
        vm.controleDateSup = CnafCctSituationproControleDateService.controleDateSup;

        // Le Calendrier propose jusqu'à 2 ans de plus que l'année en cours
        var now = new Date();
        vm.datePickerEndYear = (new Date(now.setFullYear(now.getFullYear() + 2))).getFullYear();
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:CnafSitproDatefinController
     *
     * @description
     * cnafSitproDatefin affiche les champs de saisie pour activité conges divers
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} datefinform formulaire
     * @param {Object} errordatefin erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproDatefin', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-autre-situation/datefin-activite/cnaf-cct-situationpro-datefin-activite.html',
        bindings: {
            data: '=',
            datefinform: '=',
            errordatefin: '=',
            intitulelabel: '=',
            obligatoire: '=',
            autocompletion: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafSitproDatefinController
    });
})();

(function() {
    'use strict';

    CnafSitproDetentionController.$inject = ['CnafCctAdresseSocleService', '$filter', 'CnafCctGestionTypeService'];

    function CnafSitproDetentionController(CnafCctAdresseSocleService, $filter, CnafCctGestionTypeService) {
        var vm = this;

        vm.controleCodePostalFormat = CnafCctAdresseSocleService.controleCodePostalFormat;

        vm.testType5 = function(donnee, form) {
            if (!donnee) {
                form.$setValidity('type5', true);
            } else {
                var retourControles = CnafCctGestionTypeService.appelControleType5(donnee, form);
                if (retourControles !== null) {
                    vm.data.sitPros[vm.index].villeEtrangerEtabPenitentiaire = retourControles;
                    return true;
                }
            }
        };

        vm.testType8 = function(donnee, form, nomDonnee) {
            if (!donnee) {
                form.$setValidity('type8', true);
            } else {
                var retourControles = CnafCctGestionTypeService.appelControleType8(donnee, form);
                if (retourControles !== null) {
                    vm.data[nomDonnee] = retourControles;
                }
            }
        };

        //Recherche liste pays
        vm.httpRechListePaysDetention = function() {
            CnafCctAdresseSocleService.rechListePays()
                .get()
                .$promise.then(
                    function successCallback(response0) {
                        vm.listePaysDetention = response0.listePays;
                    },
                    function errorCallback(error) {
                        vm.etat = 'error';
                    }
                );
        };

        //AUTO-COMPLETION
        //Pays :
        vm.getListePaysDetentionProposes = function(prefix) {
            return vm.listePaysDetention;
        };

        vm.afficheCodePostalVille = function(index) {
            if (vm.data.sitPros[index] && vm.data.sitPros[index].paysActivite) {
                return vm.data.sitPros[index].paysActivite.code == 'FR';
            }
        };

        vm.codePostalVilles = function(prefix) {
            return CnafCctAdresseSocleService.localitesSansLD(prefix, CnafCctAdresseSocleService.transformCodePays(vm.data.codePostalVille))
                .get()
                .$promise.then(function(result) {
                    return $filter('limitTo')(result.listRechLoc, 10);
                });
        };

        vm.httpRechListePaysDetention();
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:CnafSitproDetentionController
     *
     * @description
     * cnafSitproDetention affiche les champs de saisie pour activité conges divers
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} detentionform formulaire
     * @param {Object} errordetention erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproDetention', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-autre-situation/detention/cnaf-cct-situationpro-detention.html',
        bindings: {
            data: '=',
            detentionform: '=',
            errordetention: '=',
            autocompletion: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafSitproDetentionController
    });
})();

(function() {
    'use strict';

    CnafSitproMaladieController.$inject = ['CnafCctSituationproControleDateService'];

    function CnafSitproMaladieController(CnafCctSituationproControleDateService) {
        var vm = this;
        vm.controleDateSupOuEgale = CnafCctSituationproControleDateService.controleDateSupOuEgale;
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:CnafSitproMaladieController
     *
     * @description
     * cnafSitproMaladie affiche les champs de saisie pour activité conges divers
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} maladieform formulaire
     * @param {Object} errormaladie erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproMaladie', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-autre-situation/maladie/cnaf-cct-situationpro-maladie.html',
        bindings: {
            data: '=',
            maladieform: '=',
            errormaladie: '=',
            autocompletion: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafSitproMaladieController
    });
})();

(function() {
    'use strict';

    CnafSitproEtablissementController.$inject = ['CnafCctAdresseSocleService', 
                                                 '$filter', 
                                                 'CnafCctGestionTypeService'];

    function CnafSitproEtablissementController(CnafCctAdresseSocleService, 
                                               $filter, 
                                               CnafCctGestionTypeService) {
        var vm = this;

        vm.controleCodePostalFormat = CnafCctAdresseSocleService.controleCodePostalFormat;

        vm.testType5 = function(donnee, form) {
            if (!donnee) {
                form.$setValidity('type5', true);
            } else {
                var retourControles = CnafCctGestionTypeService.appelControleType5(donnee, form);
                if (retourControles !== null) {
                    vm.data.sitPros[vm.index].villeorgacomm = retourControles;
                    return true;
                }
            }
        };

        vm.testType8 = function(donnee, form, nomDonnee) {
            if (!donnee) {
                form.$setValidity('type8', true);
            } else {
                var retourControles = CnafCctGestionTypeService.appelControleType8(donnee, form);
                if (retourControles !== null) {
                    vm.data[nomDonnee] = retourControles;
                }
            }
        };

        //Recherche liste pays
        vm.httpRechListePaysEmployeur = function() {
            CnafCctAdresseSocleService.rechListePays()
                .get()
                .$promise.then(
                    function successCallback(response0) {
                        vm.listePaysEmployeur = response0.listePays;
                    },
                    function errorCallback(error) {
                        vm.etat = 'error';
                    }
                );
        };

        //AUTO-COMPLETION
        //Pays :
        vm.getListePaysEmployeurProposes = function(prefix) {
            return vm.listePaysEmployeur;
        };

        vm.afficheVilleEtranger = function(index){
            return (vm.data.sitPros[index] 
                        && vm.data.sitPros[index].paysActivite 
                        && vm.data.sitPros[index].paysActivite.code != 'FR' 
                        && vm.data.sitPros[index].paysActivite.code != 'MC') ;
            
        };

        vm.afficheCodePostalVille = function(index) {
            return (vm.data.sitPros[index] 
                    && vm.data.sitPros[index].paysActivite
                    && vm.data.sitPros[index].paysActivite.code == 'FR') ;
            
        };

        vm.codePostalVilles = function(prefix) {
            return CnafCctAdresseSocleService.localitesSansLD(prefix, CnafCctAdresseSocleService.transformCodePays(vm.data.codePostalZoneActivite))
                .get()
                .$promise.then(function(result) {
                    return $filter('limitTo')(result.listRechLoc, 10);
                });
        };

        vm.httpRechListePaysEmployeur();
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:CnafSitproEtablissementController
     *
     * @description
     * cnafSitproEtablissment affiche les champs de saisie pour les coordonnée d'un  établissement
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} etablissementform formulaire
     * @param {Object} erroretablissement erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproEtablissement', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-autre-situation/etablissement/cnaf-cct-situationpro-etablissement.html',
        bindings: {
            data: '=',
            etablissementform: '=',
            erroretablissement: '=',
            intituleetablissement: '=',
            autocompletion: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafSitproEtablissementController
    });
})();

(function() {
    'use strict';

    CnafSitproOrgacommController.$inject = ['CnafCctAdresseSocleService', '$filter', 'CnafCctGestionTypeService'];

    function CnafSitproOrgacommController(CnafCctAdresseSocleService, $filter, CnafCctGestionTypeService) {
        var vm = this;

        vm.controleCodePostalFormat = CnafCctAdresseSocleService.controleCodePostalFormat;

        vm.testType5 = function(donnee, form) {
            if (!donnee) {
                form.$setValidity('type5', true);
            } else {
                var retourControles = CnafCctGestionTypeService.appelControleType5(donnee, form);
                if (retourControles !== null) {
                    vm.data.sitPros[vm.index].villeOrgaComm = retourControles;
                    return true;
                }
            }
        };

        vm.testType8 = function(donnee, form, nomDonnee) {
            if (!donnee) {
                form.$setValidity('type8', true);
            } else {
                var retourControles = CnafCctGestionTypeService.appelControleType8(donnee, form);
                if (retourControles !== null) {
                    vm.data[nomDonnee] = retourControles;
                }
            }
        };

        //Recherche liste pays
        vm.httpRechListePaysEmployeur = function() {
            CnafCctAdresseSocleService.rechListePays()
                .get()
                .$promise.then(
                    function successCallback(response0) {
                        vm.listePaysEmployeur = response0.listePays;
                    },
                    function errorCallback(error) {
                        vm.etat = 'error';
                    }
                );
        };

        //AUTO-COMPLETION
        //Pays :
        vm.getListePaysEmployeurProposes = function(prefix) {
            return vm.listePaysEmployeur;
        };

        vm.afficheVilleEtranger = function(index){
            if (vm.data.sitPros[index] && vm.data.sitPros[index].paysactivite) {
                if (vm.data.sitPros[vm.index].paysactivite.code != 'FR' && 
                    vm.data.sitPros[vm.index].paysactivite.code != 'MC') {
                    return true;
                } else {
                    return false;
                }
            }
        }

        vm.afficheCodePostalVille = function(index) {
            if (vm.data.sitPros[index] && vm.data.sitPros[index].paysactivite) {
                if (vm.data.sitPros[index].paysactivite.code == 'FR') {
                    // || vm.data.sitPros[index].paysactivite.libelleCaffr == 'PRINCIPAUTE DE MONACO')
                    return true;
                } else {
                    return false;
                }
            }
        };

        vm.codePostalVilles = function(prefix) {
            return CnafCctAdresseSocleService.localitesSansLD(prefix, CnafCctAdresseSocleService.transformCodePays(vm.data.codePostalZoneActivite))
                .get()
                .$promise.then(function(result) {
                    return $filter('limitTo')(result.listRechLoc, 10);
                });
        };

        vm.httpRechListePaysEmployeur();
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:CnafSitproOrgacommController
     *
     * @description
     * cnafSitproOrgacomm affiche les champs de saisie pour activité conges divers
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} orgacommform formulaire
     * @param {Object} errororgacomm erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproOrgacomm', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-autre-situation/orgacomm/cnaf-cct-situationpro-orgacomm.html',
        bindings: {
            data: '=',
            orgacommform: '=',
            errororgacomm: '=',
            autocompletion: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafSitproOrgacommController
    });
})();

(function() {
    'use strict';

    CnafSitproSansActiviteController.$inject = [];

    function CnafSitproSansActiviteController() {}

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:CnafSitproSansActiviteController
     *
     * @description
     * cnafSitproSansActivite affiche les champs de saisie pour activité conges divers
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} sansactiviteform formulaire
     * @param {Object} errorsansactivite erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproSansactivite', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-autre-situation/sansactivite/cnaf-cct-situationpro-sansactivite.html',
        bindings: {
            data: '=',
            sansactiviteform: '=',
            errorsansactivite: '=',
            autocompletion: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafSitproSansActiviteController
    });
})();

(function() {
    'use strict';

    CnafSitproVolontariatController.$inject = ['CnafCctAdresseSocleService', 'CnafCctGestionTypeService'];

    function CnafSitproVolontariatController(CnafCctAdresseSocleService, CnafCctGestionTypeService) {
        var vm = this;

        vm.controleCodePostalFormat = CnafCctAdresseSocleService.controleCodePostalFormat;

        //Recherche liste pays
        vm.httpRechListePaysEmployeur = function() {
            CnafCctAdresseSocleService.rechListePays()
                .get()
                .$promise.then(
                    function successCallback(response0) {
                        vm.listePaysEmployeur = response0.listePays;
                    },
                    function errorCallback(error) {
                        vm.etat = 'error';
                    }
                );
        };

        //AUTO-COMPLETION
        //Pays :
        vm.getListePaysEmployeurProposes = function(prefix) {
            return vm.listePaysEmployeur;
        };

        vm.httpRechListePaysEmployeur();
    }

    /**
     * @ngdoc directive
     * @name cnafSitproApp.component:CnafSitproVolontariatController
     *
     * @description
     * cnafSitproVolontariat affiche les champs de saisie pour activité conges divers
     *
     * @restrict E
     *
     * @param {Object} data data
     * @param {Object} volontariatform formulaire
     * @param {Object} errorvolontariat erreurs
     * @param {boolean} autocompletion Autocomplétion Amabis sur codepostalVille et numAdresse
     *
     * @example
     * Voir showcase : http://localhost:9000/
     */

    angular.module('cnafComponentsTeleprocApp').component('cnafCctSituationproVolontariat', {
        templateUrl:
            'components/cnaf-cct-situationpro/cnaf-cct-situationpro-autre-situation/volontariat/cnaf-cct-situationpro-volontariat.html',
        bindings: {
            data: '=',
            volontariatform: '=',
            errorvolontariat: '=',
            listechoixautresituationvolontariat: '=',
            autocompletion: '=',
            controle: '=',
            index: '='
        },
        controllerAs: 'vm',
        controller: CnafSitproVolontariatController
    });
})();
